var Pp = Object.defineProperty;
var Ip = (t, e, n) => e in t ? Pp(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var _n = (t, e, n) => Ip(t, typeof e != "symbol" ? e + "" : e, n);
import { FontAwesomeIcon as Nn } from "@fortawesome/vue-fontawesome";
import { computed as I, toValue as Jt, getCurrentInstance as Bn, withCtx as P, hasInjectionContext as Mp, ref as N, watchEffect as ie, readonly as Un, markRaw as Fn, createRenderer as Tp, camelize as Uu, defineComponent as K, provide as cs, h as zp, watch as ht, onMounted as Fu, onUnmounted as Xr, warn as ju, toRef as jt, toRefs as Ae, createBlock as Z, openBlock as $, unref as c, createElementBlock as O, createCommentVNode as X, renderSlot as Nt, createElementVNode as x, normalizeStyle as Wt, createVNode as b, Fragment as re, inject as Bu, shallowRef as Ep, nextTick as bo, mergeModels as Ne, useModel as je, resolveComponent as xe, withModifiers as os, Transition as De, mergeProps as wo, createTextVNode as ce, toDisplayString as L, reactive as qu, renderList as $e, normalizeClass as Se, isRef as _t, createStaticVNode as Hu, withDirectives as ot, withKeys as Za, vModelText as pn, createSlots as Gl, useTemplateRef as xo, resolveDynamicComponent as Kr, vModelRadio as la, vModelCheckbox as Op, TransitionGroup as Rp, vShow as Lp, defineCustomElement as Dp } from "vue";
import { useIdle as Wu, useDevicePixelRatio as Np, useDebounceFn as Gu, useTimeoutFn as Zl, useConfirmDialog as Vp, toRef as Zu, useDropZone as Up, useFileDialog as Fp, useStorage as jp, useMousePressed as Qu, useMouseInElement as Xu, clamp as wr, toRefs as Bp, useFocus as Ku, useEyeDropper as qp, watchDebounced as Hp, useMediaQuery as Wp, useTimeout as Gp, useResizeObserver as Ql } from "@vueuse/core";
import { defineStore as tt, storeToRefs as D, createPinia as Zp } from "pinia";
import { useMutation as tn, useQueryClient as mt, useQuery as kt, useQueries as Xl, useInfiniteQuery as zs, VueQueryPlugin as Qp } from "@tanstack/vue-query";
import * as Xp from "pixi.js";
import { Ticker as Kp, Container as Ju, Rectangle as Qa, Point as bt, ExtensionType as Yu, LoaderParserPriority as Jp, Text as ed, TilingSprite as Yp, Sprite as td, RenderLayer as ef, RenderContainer as tf, PerspectiveMesh as nf, ParticleContainer as sf, NineSliceSprite as af, NineSlicePlane as of, MeshSimple as rf, MeshRope as lf, MeshPlane as cf, Mesh as uf, HTMLText as df, Graphics as mf, BitmapText as hf, AnimatedSprite as pf, extensions as ff, Application as vf, AbstractText as gf, Texture as nd, WorkerManager as Kl, loadImageBitmap as _f, ImageSource as kf, getResolutionOfUrl as yf, createTexture as bf, GraphicsContext as to, Assets as Jl, WebGPURenderer as wf, WebGLRenderer as xf } from "pixi.js";
import { useI18n as wt, I18nT as Yl, createI18n as $f, I18nInjectionKey as Sf } from "vue-i18n";
import { setTag as sd, startSpan as Af, setUser as Cf } from "@sentry/vue";
import { ToastRoot as Pf, DialogTitle as Tt, DialogRoot as zt, DialogTrigger as ad, DialogPortal as Et, DialogOverlay as Ot, DialogContent as Rt, DialogClose as Bt, SelectItem as od, SelectItemText as id, SelectRoot as rd, SelectTrigger as ld, SelectValue as cd, SelectIcon as If, SelectPortal as ud, SelectContent as dd, SelectViewport as md, TabsTrigger as hd, TooltipProvider as Mf, TooltipRoot as Tf, TooltipTrigger as zf, TooltipPortal as Ef, TooltipContent as Of, TooltipArrow as Rf, TabsRoot as Jr, TabsList as Yr, TabsContent as ca, SelectScrollDownButton as Lf, PopoverRoot as pd, PopoverTrigger as fd, PopoverPortal as vd, PopoverContent as gd, PopoverClose as _d, PopoverArrow as Df, VisuallyHidden as Nf, AccordionRoot as Vf, AccordionItem as Uf, AccordionHeader as Ff, AccordionTrigger as jf, AccordionContent as Bf, DialogDescription as qf, CollapsibleRoot as Hf, CollapsibleContent as Wf, CollapsibleTrigger as Gf, RadioGroupItem as Zf, RadioGroupIndicator as Qf, RadioGroupRoot as Xf, TabsIndicator as Kf, SliderRoot as Jf, SliderTrack as Yf, SliderThumb as ev, ToastProvider as tv, ToastViewport as nv } from "radix-vue";
import { klona as Es } from "klona";
import { extendTailwindMerge as sv } from "tailwind-merge";
import { vInfiniteScroll as ya } from "@vueuse/components";
import { findIconDefinition as av, config as ov, library as iv } from "@fortawesome/fontawesome-svg-core";
class jn extends Error {
  constructor(n, s, a) {
    const o = n.status || n.status === 0 ? n.status : "", i = n.statusText || "", r = `${o} ${i}`.trim(), l = r ? `status code ${r}` : "an unknown error";
    super(`Request failed with ${l}: ${s.method} ${s.url}`);
    _n(this, "response");
    _n(this, "request");
    _n(this, "options");
    this.name = "HTTPError", this.response = n, this.request = s, this.options = a;
  }
}
class kd extends Error {
  constructor(n) {
    super(`Request timed out: ${n.method} ${n.url}`);
    _n(this, "request");
    this.name = "TimeoutError", this.request = n;
  }
}
const ec = (() => {
  let t = !1, e = !1;
  const n = typeof globalThis.ReadableStream == "function", s = typeof globalThis.Request == "function";
  if (n && s)
    try {
      e = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex() {
          return t = !0, "half";
        }
      }).headers.has("Content-Type");
    } catch (a) {
      if (a instanceof Error && a.message === "unsupported BodyInit type")
        return !1;
      throw a;
    }
  return t && !e;
})(), rv = typeof globalThis.AbortController == "function", lv = typeof globalThis.ReadableStream == "function", cv = typeof globalThis.FormData == "function", yd = ["get", "post", "put", "patch", "head", "delete"], uv = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, ci = 2147483647, dv = new TextEncoder().encode("------WebKitFormBoundaryaxpyiPgbbPti10Rw").length, bd = Symbol("stop"), mv = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  onUploadProgress: !0,
  fetch: !0
}, hv = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, pv = (t) => {
  if (!t)
    return 0;
  if (t instanceof FormData) {
    let e = 0;
    for (const [n, s] of t)
      e += dv, e += new TextEncoder().encode(`Content-Disposition: form-data; name="${n}"`).length, e += typeof s == "string" ? new TextEncoder().encode(s).length : s.size;
    return e;
  }
  if (t instanceof Blob)
    return t.size;
  if (t instanceof ArrayBuffer)
    return t.byteLength;
  if (typeof t == "string")
    return new TextEncoder().encode(t).length;
  if (t instanceof URLSearchParams)
    return new TextEncoder().encode(t.toString()).length;
  if ("byteLength" in t)
    return t.byteLength;
  if (typeof t == "object" && t !== null)
    try {
      const e = JSON.stringify(t);
      return new TextEncoder().encode(e).length;
    } catch {
      return 0;
    }
  return 0;
}, fv = (t, e) => {
  const n = Number(t.headers.get("content-length")) || 0;
  let s = 0;
  return t.status === 204 ? (e && e({ percent: 1, totalBytes: n, transferredBytes: s }, new Uint8Array()), new Response(null, {
    status: t.status,
    statusText: t.statusText,
    headers: t.headers
  })) : new Response(new ReadableStream({
    async start(a) {
      const o = t.body.getReader();
      e && e({ percent: 0, transferredBytes: 0, totalBytes: n }, new Uint8Array());
      async function i() {
        const { done: r, value: l } = await o.read();
        if (r) {
          a.close();
          return;
        }
        if (e) {
          s += l.byteLength;
          const u = n === 0 ? 0 : s / n;
          e({ percent: u, transferredBytes: s, totalBytes: n }, l);
        }
        a.enqueue(l), await i();
      }
      await i();
    }
  }), {
    status: t.status,
    statusText: t.statusText,
    headers: t.headers
  });
}, vv = (t, e) => {
  const n = pv(t.body);
  let s = 0;
  return new Request(t, {
    // @ts-expect-error - Types are outdated.
    duplex: "half",
    body: new ReadableStream({
      async start(a) {
        const o = t.body instanceof ReadableStream ? t.body.getReader() : new Response("").body.getReader();
        async function i() {
          const { done: r, value: l } = await o.read();
          if (r) {
            e && e({ percent: 1, transferredBytes: s, totalBytes: Math.max(n, s) }, new Uint8Array()), a.close();
            return;
          }
          s += l.byteLength;
          let u = n === 0 ? 0 : s / n;
          (n < s || u === 1) && (u = 0.99), e && e({ percent: Number(u.toFixed(2)), transferredBytes: s, totalBytes: n }, l), a.enqueue(l), await i();
        }
        await i();
      }
    })
  });
}, aa = (t) => t !== null && typeof t == "object", Ba = (...t) => {
  for (const e of t)
    if ((!aa(e) || Array.isArray(e)) && e !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return el({}, ...t);
}, wd = (t = {}, e = {}) => {
  const n = new globalThis.Headers(t), s = e instanceof globalThis.Headers, a = new globalThis.Headers(e);
  for (const [o, i] of a.entries())
    s && i === "undefined" || i === void 0 ? n.delete(o) : n.set(o, i);
  return n;
};
function qa(t, e, n) {
  return Object.hasOwn(e, n) && e[n] === void 0 ? [] : el(t[n] ?? [], e[n] ?? []);
}
const xd = (t = {}, e = {}) => ({
  beforeRequest: qa(t, e, "beforeRequest"),
  beforeRetry: qa(t, e, "beforeRetry"),
  afterResponse: qa(t, e, "afterResponse"),
  beforeError: qa(t, e, "beforeError")
}), el = (...t) => {
  let e = {}, n = {}, s = {};
  for (const a of t)
    if (Array.isArray(a))
      Array.isArray(e) || (e = []), e = [...e, ...a];
    else if (aa(a)) {
      for (let [o, i] of Object.entries(a))
        aa(i) && o in e && (i = el(e[o], i)), e = { ...e, [o]: i };
      aa(a.hooks) && (s = xd(s, a.hooks), e.hooks = s), aa(a.headers) && (n = wd(n, a.headers), e.headers = n);
    }
  return e;
}, gv = (t) => yd.includes(t) ? t.toUpperCase() : t, _v = ["get", "put", "head", "delete", "options", "trace"], kv = [408, 413, 429, 500, 502, 503, 504], yv = [413, 429, 503], tc = {
  limit: 2,
  methods: _v,
  statusCodes: kv,
  afterStatusCodes: yv,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (t) => 0.3 * 2 ** (t - 1) * 1e3
}, bv = (t = {}) => {
  if (typeof t == "number")
    return {
      ...tc,
      limit: t
    };
  if (t.methods && !Array.isArray(t.methods))
    throw new Error("retry.methods must be an array");
  if (t.statusCodes && !Array.isArray(t.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...tc,
    ...t
  };
};
async function wv(t, e, n, s) {
  return new Promise((a, o) => {
    const i = setTimeout(() => {
      n && n.abort(), o(new kd(t));
    }, s.timeout);
    s.fetch(t, e).then(a).catch(o).then(() => {
      clearTimeout(i);
    });
  });
}
async function xv(t, { signal: e }) {
  return new Promise((n, s) => {
    e && (e.throwIfAborted(), e.addEventListener("abort", a, { once: !0 }));
    function a() {
      clearTimeout(o), s(e.reason);
    }
    const o = setTimeout(() => {
      e == null || e.removeEventListener("abort", a), n();
    }, t);
  });
}
const $v = (t, e) => {
  const n = {};
  for (const s in e)
    !(s in hv) && !(s in mv) && !(s in t) && (n[s] = e[s]);
  return n;
};
class no {
  // eslint-disable-next-line complexity
  constructor(e, n = {}) {
    _n(this, "request");
    _n(this, "abortController");
    _n(this, "_retryCount", 0);
    _n(this, "_input");
    _n(this, "_options");
    var s, a;
    if (this._input = e, this._options = {
      ...n,
      headers: wd(this._input.headers, n.headers),
      hooks: xd({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: gv(n.method ?? this._input.method ?? "GET"),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: bv(n.retry),
      throwHttpErrors: n.throwHttpErrors !== !1,
      timeout: n.timeout ?? 1e4,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (rv) {
      const o = this._options.signal ?? this._input.signal;
      this.abortController = new globalThis.AbortController(), this._options.signal = o ? AbortSignal.any([o, this.abortController.signal]) : this.abortController.signal;
    }
    if (ec && (this._options.duplex = "half"), this._options.json !== void 0 && (this._options.body = ((a = (s = this._options).stringifyJson) == null ? void 0 : a.call(s, this._options.json)) ?? JSON.stringify(this._options.json), this._options.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json")), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const i = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), r = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, i);
      (cv && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(r, { ...this.request }), this._options);
    }
    if (this._options.onUploadProgress) {
      if (typeof this._options.onUploadProgress != "function")
        throw new TypeError("The `onUploadProgress` option must be a function");
      if (!ec)
        throw new Error("Request streams are not supported in your environment. The `duplex` option for `Request` is not available.");
      this.request.body && (this.request = vv(this.request, this._options.onUploadProgress));
    }
  }
  static create(e, n) {
    const s = new no(e, n), a = async () => {
      if (typeof s._options.timeout == "number" && s._options.timeout > ci)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${ci}`);
      await Promise.resolve();
      let r = await s._fetch();
      for (const l of s._options.hooks.afterResponse) {
        const u = await l(s.request, s._options, s._decorateResponse(r.clone()));
        u instanceof globalThis.Response && (r = u);
      }
      if (s._decorateResponse(r), !r.ok && s._options.throwHttpErrors) {
        let l = new jn(r, s.request, s._options);
        for (const u of s._options.hooks.beforeError)
          l = await u(l);
        throw l;
      }
      if (s._options.onDownloadProgress) {
        if (typeof s._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!lv)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return fv(r.clone(), s._options.onDownloadProgress);
      }
      return r;
    }, i = (s._options.retry.methods.includes(s.request.method.toLowerCase()) ? s._retry(a) : a()).finally(async () => {
      var r;
      s.request.bodyUsed || await ((r = s.request.body) == null ? void 0 : r.cancel());
    });
    for (const [r, l] of Object.entries(uv))
      i[r] = async () => {
        s.request.headers.set("accept", s.request.headers.get("accept") || l);
        const u = await i;
        if (r === "json") {
          if (u.status === 204 || (await u.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (n.parseJson)
            return n.parseJson(await u.text());
        }
        return u[r]();
      };
    return i;
  }
  _calculateRetryDelay(e) {
    if (this._retryCount++, this._retryCount > this._options.retry.limit || e instanceof kd)
      throw e;
    if (e instanceof jn) {
      if (!this._options.retry.statusCodes.includes(e.response.status))
        throw e;
      const s = e.response.headers.get("Retry-After") ?? e.response.headers.get("RateLimit-Reset") ?? e.response.headers.get("X-RateLimit-Reset") ?? e.response.headers.get("X-Rate-Limit-Reset");
      if (s && this._options.retry.afterStatusCodes.includes(e.response.status)) {
        let a = Number(s) * 1e3;
        Number.isNaN(a) ? a = Date.parse(s) - Date.now() : a >= Date.parse("2024-01-01") && (a -= Date.now());
        const o = this._options.retry.maxRetryAfter ?? a;
        return a < o ? a : o;
      }
      if (e.response.status === 413)
        throw e;
    }
    const n = this._options.retry.delay(this._retryCount);
    return Math.min(this._options.retry.backoffLimit, n);
  }
  _decorateResponse(e) {
    return this._options.parseJson && (e.json = async () => this._options.parseJson(await e.text())), e;
  }
  async _retry(e) {
    try {
      return await e();
    } catch (n) {
      const s = Math.min(this._calculateRetryDelay(n), ci);
      if (this._retryCount < 1)
        throw n;
      await xv(s, { signal: this._options.signal });
      for (const a of this._options.hooks.beforeRetry)
        if (await a({
          request: this.request,
          options: this._options,
          error: n,
          retryCount: this._retryCount
        }) === bd)
          return;
      return this._retry(e);
    }
  }
  async _fetch() {
    for (const s of this._options.hooks.beforeRequest) {
      const a = await s(this.request, this._options);
      if (a instanceof Request) {
        this.request = a;
        break;
      }
      if (a instanceof Response)
        return a;
    }
    const e = $v(this.request, this._options), n = this.request;
    return this.request = n.clone(), this._options.timeout === !1 ? this._options.fetch(n, e) : wv(n, e, this.abortController, this._options);
  }
}
/*! MIT License © Sindre Sorhus */
const xr = (t) => {
  const e = (n, s) => no.create(n, Ba(t, s));
  for (const n of yd)
    e[n] = (s, a) => no.create(s, Ba(t, a, { method: n }));
  return e.create = (n) => xr(Ba(n)), e.extend = (n) => (typeof n == "function" && (n = n(t ?? {})), xr(Ba(t, n))), e.stop = bd, e;
}, $d = xr();
var nc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Sd(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Sv(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(s) {
    var a = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(n, s, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[s];
      }
    });
  }), n;
}
var ui, sc;
function Os() {
  return sc || (sc = 1, ui = TypeError), ui;
}
const Av = {}, Cv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Av
}, Symbol.toStringTag, { value: "Module" })), Pv = /* @__PURE__ */ Sv(Cv);
var di, ac;
function $o() {
  if (ac) return di;
  ac = 1;
  var t = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && t ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, n = t && e && typeof e.get == "function" ? e.get : null, s = t && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, o = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, i = a && o && typeof o.get == "function" ? o.get : null, r = a && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, u = l ? WeakMap.prototype.has : null, m = typeof WeakSet == "function" && WeakSet.prototype, h = m ? WeakSet.prototype.has : null, v = typeof WeakRef == "function" && WeakRef.prototype, _ = v ? WeakRef.prototype.deref : null, y = Boolean.prototype.valueOf, S = Object.prototype.toString, f = Function.prototype.toString, k = String.prototype.match, w = String.prototype.slice, C = String.prototype.replace, M = String.prototype.toUpperCase, T = String.prototype.toLowerCase, E = RegExp.prototype.test, U = Array.prototype.concat, F = Array.prototype.join, ee = Array.prototype.slice, Q = Math.floor, se = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, W = Object.getOwnPropertySymbols, Y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, me = typeof Symbol == "function" && typeof Symbol.iterator == "object", he = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === me || !0) ? Symbol.toStringTag : null, _e = Object.prototype.propertyIsEnumerable, te = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(j) {
    return j.__proto__;
  } : null);
  function J(j, q) {
    if (j === 1 / 0 || j === -1 / 0 || j !== j || j && j > -1e3 && j < 1e3 || E.call(/e/, q))
      return q;
    var qe = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof j == "number") {
      var Xe = j < 0 ? -Q(-j) : Q(j);
      if (Xe !== j) {
        var Fe = String(Xe), Re = w.call(q, Fe.length + 1);
        return C.call(Fe, qe, "$&_") + "." + C.call(C.call(Re, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return C.call(q, qe, "$&_");
  }
  var de = Pv, ke = de.custom, Te = lt(ke) ? ke : null, Ve = {
    __proto__: null,
    double: '"',
    single: "'"
  }, nt = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  di = function j(q, qe, Xe, Fe) {
    var Re = qe || {};
    if (Ct(Re, "quoteStyle") && !Ct(Ve, Re.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Ct(Re, "maxStringLength") && (typeof Re.maxStringLength == "number" ? Re.maxStringLength < 0 && Re.maxStringLength !== 1 / 0 : Re.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Dt = Ct(Re, "customInspect") ? Re.customInspect : !0;
    if (typeof Dt != "boolean" && Dt !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Ct(Re, "indent") && Re.indent !== null && Re.indent !== "	" && !(parseInt(Re.indent, 10) === Re.indent && Re.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Ct(Re, "numericSeparator") && typeof Re.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var $n = Re.numericSeparator;
    if (typeof q > "u")
      return "undefined";
    if (q === null)
      return "null";
    if (typeof q == "boolean")
      return q ? "true" : "false";
    if (typeof q == "string")
      return za(q, Re);
    if (typeof q == "number") {
      if (q === 0)
        return 1 / 0 / q > 0 ? "0" : "-0";
      var Pt = String(q);
      return $n ? J(q, Pt) : Pt;
    }
    if (typeof q == "bigint") {
      var mn = String(q) + "n";
      return $n ? J(q, mn) : mn;
    }
    var ys = typeof Re.depth > "u" ? 5 : Re.depth;
    if (typeof Xe > "u" && (Xe = 0), Xe >= ys && ys > 0 && typeof q == "object")
      return rt(q) ? "[Array]" : "[Object]";
    var Sn = Ws(Re, Xe);
    if (typeof Fe > "u")
      Fe = [];
    else if (vn(Fe, q) >= 0)
      return "[Circular]";
    function Kt(gn, En, ei) {
      if (En && (Fe = ee.call(Fe), Fe.push(En)), ei) {
        var Va = {
          depth: Re.depth
        };
        return Ct(Re, "quoteStyle") && (Va.quoteStyle = Re.quoteStyle), j(gn, Va, Xe + 1, Fe);
      }
      return j(gn, Re, Xe + 1, Fe);
    }
    if (typeof q == "function" && !we(q)) {
      var Oa = Mn(q), Ra = ks(q, Kt);
      return "[Function" + (Oa ? ": " + Oa : " (anonymous)") + "]" + (Ra.length > 0 ? " { " + F.call(Ra, ", ") + " }" : "");
    }
    if (lt(q)) {
      var Xn = me ? C.call(String(q), /^(Symbol\(.*\))_[^)]*$/, "$1") : Y.call(q);
      return typeof q == "object" && !me ? Zn(Xn) : Xn;
    }
    if (Xo(q)) {
      for (var Kn = "<" + T.call(String(q.nodeName)), bs = q.attributes || [], ws = 0; ws < bs.length; ws++)
        Kn += " " + bs[ws].name + "=" + Pe(ae(bs[ws].value), "double", Re);
      return Kn += ">", q.childNodes && q.childNodes.length && (Kn += "..."), Kn += "</" + T.call(String(q.nodeName)) + ">", Kn;
    }
    if (rt(q)) {
      if (q.length === 0)
        return "[]";
      var Gs = ks(q, Kt);
      return Sn && !Jo(Gs) ? "[" + Qn(Gs, Sn) + "]" : "[ " + F.call(Gs, ", ") + " ]";
    }
    if (Ce(q)) {
      var Zs = ks(q, Kt);
      return !("cause" in Error.prototype) && "cause" in q && !_e.call(q, "cause") ? "{ [" + String(q) + "] " + F.call(U.call("[cause]: " + Kt(q.cause), Zs), ", ") + " }" : Zs.length === 0 ? "[" + String(q) + "]" : "{ [" + String(q) + "] " + F.call(Zs, ", ") + " }";
    }
    if (typeof q == "object" && Dt) {
      if (Te && typeof q[Te] == "function" && de)
        return de(q, { depth: ys - Xe });
      if (Dt !== "symbol" && typeof q.inspect == "function")
        return q.inspect();
    }
    if (Xt(q)) {
      var La = [];
      return s && s.call(q, function(gn, En) {
        La.push(Kt(En, q, !0) + " => " + Kt(gn, q));
      }), Ea("Map", n.call(q), La, Sn);
    }
    if (zn(q)) {
      var Da = [];
      return r && r.call(q, function(gn) {
        Da.push(Kt(gn, q));
      }), Ea("Set", i.call(q), Da, Sn);
    }
    if (Tn(q))
      return Hs("WeakMap");
    if (et(q))
      return Hs("WeakSet");
    if (dn(q))
      return Hs("WeakRef");
    if (Ue(q))
      return Zn(Kt(Number(q)));
    if (gt(q))
      return Zn(Kt(se.call(q)));
    if (Ye(q))
      return Zn(y.call(q));
    if (Je(q))
      return Zn(Kt(String(q)));
    if (typeof window < "u" && q === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && q === globalThis || typeof nc < "u" && q === nc)
      return "{ [object globalThis] }";
    if (!st(q) && !we(q)) {
      var Qs = ks(q, Kt), Xs = te ? te(q) === Object.prototype : q instanceof Object || q.constructor === Object, hn = q instanceof Object ? "" : "null prototype", Na = !Xs && he && Object(q) === q && he in q ? w.call(Lt(q), 8, -1) : hn ? "Object" : "", Yo = Xs || typeof q.constructor != "function" ? "" : q.constructor.name ? q.constructor.name + " " : "", Ks = Yo + (Na || hn ? "[" + F.call(U.call([], Na || [], hn || []), ": ") + "] " : "");
      return Qs.length === 0 ? Ks + "{}" : Sn ? Ks + "{" + Qn(Qs, Sn) + "}" : Ks + "{ " + F.call(Qs, ", ") + " }";
    }
    return String(q);
  };
  function Pe(j, q, qe) {
    var Xe = qe.quoteStyle || q, Fe = Ve[Xe];
    return Fe + j + Fe;
  }
  function ae(j) {
    return C.call(String(j), /"/g, "&quot;");
  }
  function pe(j) {
    return !he || !(typeof j == "object" && (he in j || typeof j[he] < "u"));
  }
  function rt(j) {
    return Lt(j) === "[object Array]" && pe(j);
  }
  function st(j) {
    return Lt(j) === "[object Date]" && pe(j);
  }
  function we(j) {
    return Lt(j) === "[object RegExp]" && pe(j);
  }
  function Ce(j) {
    return Lt(j) === "[object Error]" && pe(j);
  }
  function Je(j) {
    return Lt(j) === "[object String]" && pe(j);
  }
  function Ue(j) {
    return Lt(j) === "[object Number]" && pe(j);
  }
  function Ye(j) {
    return Lt(j) === "[object Boolean]" && pe(j);
  }
  function lt(j) {
    if (me)
      return j && typeof j == "object" && j instanceof Symbol;
    if (typeof j == "symbol")
      return !0;
    if (!j || typeof j != "object" || !Y)
      return !1;
    try {
      return Y.call(j), !0;
    } catch {
    }
    return !1;
  }
  function gt(j) {
    if (!j || typeof j != "object" || !se)
      return !1;
    try {
      return se.call(j), !0;
    } catch {
    }
    return !1;
  }
  var ct = Object.prototype.hasOwnProperty || function(j) {
    return j in this;
  };
  function Ct(j, q) {
    return ct.call(j, q);
  }
  function Lt(j) {
    return S.call(j);
  }
  function Mn(j) {
    if (j.name)
      return j.name;
    var q = k.call(f.call(j), /^function\s*([\w$]+)/);
    return q ? q[1] : null;
  }
  function vn(j, q) {
    if (j.indexOf)
      return j.indexOf(q);
    for (var qe = 0, Xe = j.length; qe < Xe; qe++)
      if (j[qe] === q)
        return qe;
    return -1;
  }
  function Xt(j) {
    if (!n || !j || typeof j != "object")
      return !1;
    try {
      n.call(j);
      try {
        i.call(j);
      } catch {
        return !0;
      }
      return j instanceof Map;
    } catch {
    }
    return !1;
  }
  function Tn(j) {
    if (!u || !j || typeof j != "object")
      return !1;
    try {
      u.call(j, u);
      try {
        h.call(j, h);
      } catch {
        return !0;
      }
      return j instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function dn(j) {
    if (!_ || !j || typeof j != "object")
      return !1;
    try {
      return _.call(j), !0;
    } catch {
    }
    return !1;
  }
  function zn(j) {
    if (!i || !j || typeof j != "object")
      return !1;
    try {
      i.call(j);
      try {
        n.call(j);
      } catch {
        return !0;
      }
      return j instanceof Set;
    } catch {
    }
    return !1;
  }
  function et(j) {
    if (!h || !j || typeof j != "object")
      return !1;
    try {
      h.call(j, h);
      try {
        u.call(j, u);
      } catch {
        return !0;
      }
      return j instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Xo(j) {
    return !j || typeof j != "object" ? !1 : typeof HTMLElement < "u" && j instanceof HTMLElement ? !0 : typeof j.nodeName == "string" && typeof j.getAttribute == "function";
  }
  function za(j, q) {
    if (j.length > q.maxStringLength) {
      var qe = j.length - q.maxStringLength, Xe = "... " + qe + " more character" + (qe > 1 ? "s" : "");
      return za(w.call(j, 0, q.maxStringLength), q) + Xe;
    }
    var Fe = nt[q.quoteStyle || "single"];
    Fe.lastIndex = 0;
    var Re = C.call(C.call(j, Fe, "\\$1"), /[\x00-\x1f]/g, Ko);
    return Pe(Re, "single", q);
  }
  function Ko(j) {
    var q = j.charCodeAt(0), qe = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[q];
    return qe ? "\\" + qe : "\\x" + (q < 16 ? "0" : "") + M.call(q.toString(16));
  }
  function Zn(j) {
    return "Object(" + j + ")";
  }
  function Hs(j) {
    return j + " { ? }";
  }
  function Ea(j, q, qe, Xe) {
    var Fe = Xe ? Qn(qe, Xe) : F.call(qe, ", ");
    return j + " (" + q + ") {" + Fe + "}";
  }
  function Jo(j) {
    for (var q = 0; q < j.length; q++)
      if (vn(j[q], `
`) >= 0)
        return !1;
    return !0;
  }
  function Ws(j, q) {
    var qe;
    if (j.indent === "	")
      qe = "	";
    else if (typeof j.indent == "number" && j.indent > 0)
      qe = F.call(Array(j.indent + 1), " ");
    else
      return null;
    return {
      base: qe,
      prev: F.call(Array(q + 1), qe)
    };
  }
  function Qn(j, q) {
    if (j.length === 0)
      return "";
    var qe = `
` + q.prev + q.base;
    return qe + F.call(j, "," + qe) + `
` + q.prev;
  }
  function ks(j, q) {
    var qe = rt(j), Xe = [];
    if (qe) {
      Xe.length = j.length;
      for (var Fe = 0; Fe < j.length; Fe++)
        Xe[Fe] = Ct(j, Fe) ? q(j[Fe], j) : "";
    }
    var Re = typeof W == "function" ? W(j) : [], Dt;
    if (me) {
      Dt = {};
      for (var $n = 0; $n < Re.length; $n++)
        Dt["$" + Re[$n]] = Re[$n];
    }
    for (var Pt in j)
      Ct(j, Pt) && (qe && String(Number(Pt)) === Pt && Pt < j.length || me && Dt["$" + Pt] instanceof Symbol || (E.call(/[^\w$]/, Pt) ? Xe.push(q(Pt, j) + ": " + q(j[Pt], j)) : Xe.push(Pt + ": " + q(j[Pt], j))));
    if (typeof W == "function")
      for (var mn = 0; mn < Re.length; mn++)
        _e.call(j, Re[mn]) && Xe.push("[" + q(Re[mn]) + "]: " + q(j[Re[mn]], j));
    return Xe;
  }
  return di;
}
var mi, oc;
function Iv() {
  if (oc) return mi;
  oc = 1;
  var t = /* @__PURE__ */ $o(), e = /* @__PURE__ */ Os(), n = function(r, l, u) {
    for (var m = r, h; (h = m.next) != null; m = h)
      if (h.key === l)
        return m.next = h.next, u || (h.next = /** @type {NonNullable<typeof list.next>} */
        r.next, r.next = h), h;
  }, s = function(r, l) {
    if (r) {
      var u = n(r, l);
      return u && u.value;
    }
  }, a = function(r, l, u) {
    var m = n(r, l);
    m ? m.value = u : r.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: l,
      next: r.next,
      value: u
    };
  }, o = function(r, l) {
    return r ? !!n(r, l) : !1;
  }, i = function(r, l) {
    if (r)
      return n(r, l, !0);
  };
  return mi = function() {
    var l, u = {
      assert: function(m) {
        if (!u.has(m))
          throw new e("Side channel does not contain " + t(m));
      },
      delete: function(m) {
        var h = l && l.next, v = i(l, m);
        return v && h && h === v && (l = void 0), !!v;
      },
      get: function(m) {
        return s(l, m);
      },
      has: function(m) {
        return o(l, m);
      },
      set: function(m, h) {
        l || (l = {
          next: void 0
        }), a(
          /** @type {NonNullable<typeof $o>} */
          l,
          m,
          h
        );
      }
    };
    return u;
  }, mi;
}
var hi, ic;
function Ad() {
  return ic || (ic = 1, hi = Object), hi;
}
var pi, rc;
function Mv() {
  return rc || (rc = 1, pi = Error), pi;
}
var fi, lc;
function Tv() {
  return lc || (lc = 1, fi = EvalError), fi;
}
var vi, cc;
function zv() {
  return cc || (cc = 1, vi = RangeError), vi;
}
var gi, uc;
function Ev() {
  return uc || (uc = 1, gi = ReferenceError), gi;
}
var _i, dc;
function Ov() {
  return dc || (dc = 1, _i = SyntaxError), _i;
}
var ki, mc;
function Rv() {
  return mc || (mc = 1, ki = URIError), ki;
}
var yi, hc;
function Lv() {
  return hc || (hc = 1, yi = Math.abs), yi;
}
var bi, pc;
function Dv() {
  return pc || (pc = 1, bi = Math.floor), bi;
}
var wi, fc;
function Nv() {
  return fc || (fc = 1, wi = Math.max), wi;
}
var xi, vc;
function Vv() {
  return vc || (vc = 1, xi = Math.min), xi;
}
var $i, gc;
function Uv() {
  return gc || (gc = 1, $i = Math.pow), $i;
}
var Si, _c;
function Fv() {
  return _c || (_c = 1, Si = Math.round), Si;
}
var Ai, kc;
function jv() {
  return kc || (kc = 1, Ai = Number.isNaN || function(e) {
    return e !== e;
  }), Ai;
}
var Ci, yc;
function Bv() {
  if (yc) return Ci;
  yc = 1;
  var t = /* @__PURE__ */ jv();
  return Ci = function(n) {
    return t(n) || n === 0 ? n : n < 0 ? -1 : 1;
  }, Ci;
}
var Pi, bc;
function qv() {
  return bc || (bc = 1, Pi = Object.getOwnPropertyDescriptor), Pi;
}
var Ii, wc;
function Cd() {
  if (wc) return Ii;
  wc = 1;
  var t = /* @__PURE__ */ qv();
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return Ii = t, Ii;
}
var Mi, xc;
function Hv() {
  if (xc) return Mi;
  xc = 1;
  var t = Object.defineProperty || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return Mi = t, Mi;
}
var Ti, $c;
function Wv() {
  return $c || ($c = 1, Ti = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, n = Symbol("test"), s = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(s) !== "[object Symbol]")
      return !1;
    var a = 42;
    e[n] = a;
    for (var o in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var i = Object.getOwnPropertySymbols(e);
    if (i.length !== 1 || i[0] !== n || !Object.prototype.propertyIsEnumerable.call(e, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var r = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, n)
      );
      if (r.value !== a || r.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Ti;
}
var zi, Sc;
function Gv() {
  if (Sc) return zi;
  Sc = 1;
  var t = typeof Symbol < "u" && Symbol, e = Wv();
  return zi = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, zi;
}
var Ei, Ac;
function Pd() {
  return Ac || (Ac = 1, Ei = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Ei;
}
var Oi, Cc;
function Id() {
  if (Cc) return Oi;
  Cc = 1;
  var t = /* @__PURE__ */ Ad();
  return Oi = t.getPrototypeOf || null, Oi;
}
var Ri, Pc;
function Zv() {
  if (Pc) return Ri;
  Pc = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, n = Math.max, s = "[object Function]", a = function(l, u) {
    for (var m = [], h = 0; h < l.length; h += 1)
      m[h] = l[h];
    for (var v = 0; v < u.length; v += 1)
      m[v + l.length] = u[v];
    return m;
  }, o = function(l, u) {
    for (var m = [], h = u, v = 0; h < l.length; h += 1, v += 1)
      m[v] = l[h];
    return m;
  }, i = function(r, l) {
    for (var u = "", m = 0; m < r.length; m += 1)
      u += r[m], m + 1 < r.length && (u += l);
    return u;
  };
  return Ri = function(l) {
    var u = this;
    if (typeof u != "function" || e.apply(u) !== s)
      throw new TypeError(t + u);
    for (var m = o(arguments, 1), h, v = function() {
      if (this instanceof h) {
        var k = u.apply(
          this,
          a(m, arguments)
        );
        return Object(k) === k ? k : this;
      }
      return u.apply(
        l,
        a(m, arguments)
      );
    }, _ = n(0, u.length - m.length), y = [], S = 0; S < _; S++)
      y[S] = "$" + S;
    if (h = Function("binder", "return function (" + i(y, ",") + "){ return binder.apply(this,arguments); }")(v), u.prototype) {
      var f = function() {
      };
      f.prototype = u.prototype, h.prototype = new f(), f.prototype = null;
    }
    return h;
  }, Ri;
}
var Li, Ic;
function So() {
  if (Ic) return Li;
  Ic = 1;
  var t = Zv();
  return Li = Function.prototype.bind || t, Li;
}
var Di, Mc;
function tl() {
  return Mc || (Mc = 1, Di = Function.prototype.call), Di;
}
var Ni, Tc;
function Md() {
  return Tc || (Tc = 1, Ni = Function.prototype.apply), Ni;
}
var Vi, zc;
function Qv() {
  return zc || (zc = 1, Vi = typeof Reflect < "u" && Reflect && Reflect.apply), Vi;
}
var Ui, Ec;
function Xv() {
  if (Ec) return Ui;
  Ec = 1;
  var t = So(), e = Md(), n = tl(), s = Qv();
  return Ui = s || t.call(n, e), Ui;
}
var Fi, Oc;
function Td() {
  if (Oc) return Fi;
  Oc = 1;
  var t = So(), e = /* @__PURE__ */ Os(), n = tl(), s = Xv();
  return Fi = function(o) {
    if (o.length < 1 || typeof o[0] != "function")
      throw new e("a function is required");
    return s(t, n, o);
  }, Fi;
}
var ji, Rc;
function Kv() {
  if (Rc) return ji;
  Rc = 1;
  var t = Td(), e = /* @__PURE__ */ Cd(), n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (i) {
    if (!i || typeof i != "object" || !("code" in i) || i.code !== "ERR_PROTO_ACCESS")
      throw i;
  }
  var s = !!n && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, o = a.getPrototypeOf;
  return ji = s && typeof s.get == "function" ? t([s.get]) : typeof o == "function" ? (
    /** @type {import('./get')} */
    function(r) {
      return o(r == null ? r : a(r));
    }
  ) : !1, ji;
}
var Bi, Lc;
function Jv() {
  if (Lc) return Bi;
  Lc = 1;
  var t = Pd(), e = Id(), n = /* @__PURE__ */ Kv();
  return Bi = t ? function(a) {
    return t(a);
  } : e ? function(a) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new TypeError("getProto: not an object");
    return e(a);
  } : n ? function(a) {
    return n(a);
  } : null, Bi;
}
var qi, Dc;
function Yv() {
  if (Dc) return qi;
  Dc = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, n = So();
  return qi = n.call(t, e), qi;
}
var Hi, Nc;
function nl() {
  if (Nc) return Hi;
  Nc = 1;
  var t, e = /* @__PURE__ */ Ad(), n = /* @__PURE__ */ Mv(), s = /* @__PURE__ */ Tv(), a = /* @__PURE__ */ zv(), o = /* @__PURE__ */ Ev(), i = /* @__PURE__ */ Ov(), r = /* @__PURE__ */ Os(), l = /* @__PURE__ */ Rv(), u = /* @__PURE__ */ Lv(), m = /* @__PURE__ */ Dv(), h = /* @__PURE__ */ Nv(), v = /* @__PURE__ */ Vv(), _ = /* @__PURE__ */ Uv(), y = /* @__PURE__ */ Fv(), S = /* @__PURE__ */ Bv(), f = Function, k = function(we) {
    try {
      return f('"use strict"; return (' + we + ").constructor;")();
    } catch {
    }
  }, w = /* @__PURE__ */ Cd(), C = /* @__PURE__ */ Hv(), M = function() {
    throw new r();
  }, T = w ? function() {
    try {
      return arguments.callee, M;
    } catch {
      try {
        return w(arguments, "callee").get;
      } catch {
        return M;
      }
    }
  }() : M, E = Gv()(), U = Jv(), F = Id(), ee = Pd(), Q = Md(), se = tl(), W = {}, Y = typeof Uint8Array > "u" || !U ? t : U(Uint8Array), me = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": E && U ? U([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": W,
    "%AsyncGenerator%": W,
    "%AsyncGeneratorFunction%": W,
    "%AsyncIteratorPrototype%": W,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": n,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": s,
    "%Float16Array%": typeof Float16Array > "u" ? t : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": f,
    "%GeneratorFunction%": W,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": E && U ? U(U([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !E || !U ? t : U((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": w,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": a,
    "%ReferenceError%": o,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !E || !U ? t : U((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": E && U ? U(""[Symbol.iterator]()) : t,
    "%Symbol%": E ? Symbol : t,
    "%SyntaxError%": i,
    "%ThrowTypeError%": T,
    "%TypedArray%": Y,
    "%TypeError%": r,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet,
    "%Function.prototype.call%": se,
    "%Function.prototype.apply%": Q,
    "%Object.defineProperty%": C,
    "%Object.getPrototypeOf%": F,
    "%Math.abs%": u,
    "%Math.floor%": m,
    "%Math.max%": h,
    "%Math.min%": v,
    "%Math.pow%": _,
    "%Math.round%": y,
    "%Math.sign%": S,
    "%Reflect.getPrototypeOf%": ee
  };
  if (U)
    try {
      null.error;
    } catch (we) {
      var he = U(U(we));
      me["%Error.prototype%"] = he;
    }
  var _e = function we(Ce) {
    var Je;
    if (Ce === "%AsyncFunction%")
      Je = k("async function () {}");
    else if (Ce === "%GeneratorFunction%")
      Je = k("function* () {}");
    else if (Ce === "%AsyncGeneratorFunction%")
      Je = k("async function* () {}");
    else if (Ce === "%AsyncGenerator%") {
      var Ue = we("%AsyncGeneratorFunction%");
      Ue && (Je = Ue.prototype);
    } else if (Ce === "%AsyncIteratorPrototype%") {
      var Ye = we("%AsyncGenerator%");
      Ye && U && (Je = U(Ye.prototype));
    }
    return me[Ce] = Je, Je;
  }, te = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, J = So(), de = /* @__PURE__ */ Yv(), ke = J.call(se, Array.prototype.concat), Te = J.call(Q, Array.prototype.splice), Ve = J.call(se, String.prototype.replace), nt = J.call(se, String.prototype.slice), Pe = J.call(se, RegExp.prototype.exec), ae = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, pe = /\\(\\)?/g, rt = function(Ce) {
    var Je = nt(Ce, 0, 1), Ue = nt(Ce, -1);
    if (Je === "%" && Ue !== "%")
      throw new i("invalid intrinsic syntax, expected closing `%`");
    if (Ue === "%" && Je !== "%")
      throw new i("invalid intrinsic syntax, expected opening `%`");
    var Ye = [];
    return Ve(Ce, ae, function(lt, gt, ct, Ct) {
      Ye[Ye.length] = ct ? Ve(Ct, pe, "$1") : gt || lt;
    }), Ye;
  }, st = function(Ce, Je) {
    var Ue = Ce, Ye;
    if (de(te, Ue) && (Ye = te[Ue], Ue = "%" + Ye[0] + "%"), de(me, Ue)) {
      var lt = me[Ue];
      if (lt === W && (lt = _e(Ue)), typeof lt > "u" && !Je)
        throw new r("intrinsic " + Ce + " exists, but is not available. Please file an issue!");
      return {
        alias: Ye,
        name: Ue,
        value: lt
      };
    }
    throw new i("intrinsic " + Ce + " does not exist!");
  };
  return Hi = function(Ce, Je) {
    if (typeof Ce != "string" || Ce.length === 0)
      throw new r("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Je != "boolean")
      throw new r('"allowMissing" argument must be a boolean');
    if (Pe(/^%?[^%]*%?$/, Ce) === null)
      throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var Ue = rt(Ce), Ye = Ue.length > 0 ? Ue[0] : "", lt = st("%" + Ye + "%", Je), gt = lt.name, ct = lt.value, Ct = !1, Lt = lt.alias;
    Lt && (Ye = Lt[0], Te(Ue, ke([0, 1], Lt)));
    for (var Mn = 1, vn = !0; Mn < Ue.length; Mn += 1) {
      var Xt = Ue[Mn], Tn = nt(Xt, 0, 1), dn = nt(Xt, -1);
      if ((Tn === '"' || Tn === "'" || Tn === "`" || dn === '"' || dn === "'" || dn === "`") && Tn !== dn)
        throw new i("property names with quotes must have matching quotes");
      if ((Xt === "constructor" || !vn) && (Ct = !0), Ye += "." + Xt, gt = "%" + Ye + "%", de(me, gt))
        ct = me[gt];
      else if (ct != null) {
        if (!(Xt in ct)) {
          if (!Je)
            throw new r("base intrinsic for " + Ce + " exists, but the property is not available.");
          return;
        }
        if (w && Mn + 1 >= Ue.length) {
          var zn = w(ct, Xt);
          vn = !!zn, vn && "get" in zn && !("originalValue" in zn.get) ? ct = zn.get : ct = ct[Xt];
        } else
          vn = de(ct, Xt), ct = ct[Xt];
        vn && !Ct && (me[gt] = ct);
      }
    }
    return ct;
  }, Hi;
}
var Wi, Vc;
function zd() {
  if (Vc) return Wi;
  Vc = 1;
  var t = /* @__PURE__ */ nl(), e = Td(), n = e([t("%String.prototype.indexOf%")]);
  return Wi = function(a, o) {
    var i = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      t(a, !!o)
    );
    return typeof i == "function" && n(a, ".prototype.") > -1 ? e(
      /** @type {const} */
      [i]
    ) : i;
  }, Wi;
}
var Gi, Uc;
function Ed() {
  if (Uc) return Gi;
  Uc = 1;
  var t = /* @__PURE__ */ nl(), e = /* @__PURE__ */ zd(), n = /* @__PURE__ */ $o(), s = /* @__PURE__ */ Os(), a = t("%Map%", !0), o = e("Map.prototype.get", !0), i = e("Map.prototype.set", !0), r = e("Map.prototype.has", !0), l = e("Map.prototype.delete", !0), u = e("Map.prototype.size", !0);
  return Gi = !!a && /** @type {Exclude<import('.'), false>} */
  function() {
    var h, v = {
      assert: function(_) {
        if (!v.has(_))
          throw new s("Side channel does not contain " + n(_));
      },
      delete: function(_) {
        if (h) {
          var y = l(h, _);
          return u(h) === 0 && (h = void 0), y;
        }
        return !1;
      },
      get: function(_) {
        if (h)
          return o(h, _);
      },
      has: function(_) {
        return h ? r(h, _) : !1;
      },
      set: function(_, y) {
        h || (h = new a()), i(h, _, y);
      }
    };
    return v;
  }, Gi;
}
var Zi, Fc;
function e1() {
  if (Fc) return Zi;
  Fc = 1;
  var t = /* @__PURE__ */ nl(), e = /* @__PURE__ */ zd(), n = /* @__PURE__ */ $o(), s = Ed(), a = /* @__PURE__ */ Os(), o = t("%WeakMap%", !0), i = e("WeakMap.prototype.get", !0), r = e("WeakMap.prototype.set", !0), l = e("WeakMap.prototype.has", !0), u = e("WeakMap.prototype.delete", !0);
  return Zi = o ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var h, v, _ = {
        assert: function(y) {
          if (!_.has(y))
            throw new a("Side channel does not contain " + n(y));
        },
        delete: function(y) {
          if (o && y && (typeof y == "object" || typeof y == "function")) {
            if (h)
              return u(h, y);
          } else if (s && v)
            return v.delete(y);
          return !1;
        },
        get: function(y) {
          return o && y && (typeof y == "object" || typeof y == "function") && h ? i(h, y) : v && v.get(y);
        },
        has: function(y) {
          return o && y && (typeof y == "object" || typeof y == "function") && h ? l(h, y) : !!v && v.has(y);
        },
        set: function(y, S) {
          o && y && (typeof y == "object" || typeof y == "function") ? (h || (h = new o()), r(h, y, S)) : s && (v || (v = s()), v.set(y, S));
        }
      };
      return _;
    }
  ) : s, Zi;
}
var Qi, jc;
function t1() {
  if (jc) return Qi;
  jc = 1;
  var t = /* @__PURE__ */ Os(), e = /* @__PURE__ */ $o(), n = Iv(), s = Ed(), a = e1(), o = a || s || n;
  return Qi = function() {
    var r, l = {
      assert: function(u) {
        if (!l.has(u))
          throw new t("Side channel does not contain " + e(u));
      },
      delete: function(u) {
        return !!r && r.delete(u);
      },
      get: function(u) {
        return r && r.get(u);
      },
      has: function(u) {
        return !!r && r.has(u);
      },
      set: function(u, m) {
        r || (r = o()), r.set(u, m);
      }
    };
    return l;
  }, Qi;
}
var Xi, Bc;
function sl() {
  if (Bc) return Xi;
  Bc = 1;
  var t = String.prototype.replace, e = /%20/g, n = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Xi = {
    default: n.RFC3986,
    formatters: {
      RFC1738: function(s) {
        return t.call(s, e, "+");
      },
      RFC3986: function(s) {
        return String(s);
      }
    },
    RFC1738: n.RFC1738,
    RFC3986: n.RFC3986
  }, Xi;
}
var Ki, qc;
function Od() {
  if (qc) return Ki;
  qc = 1;
  var t = /* @__PURE__ */ sl(), e = Object.prototype.hasOwnProperty, n = Array.isArray, s = function() {
    for (var f = [], k = 0; k < 256; ++k)
      f.push("%" + ((k < 16 ? "0" : "") + k.toString(16)).toUpperCase());
    return f;
  }(), a = function(k) {
    for (; k.length > 1; ) {
      var w = k.pop(), C = w.obj[w.prop];
      if (n(C)) {
        for (var M = [], T = 0; T < C.length; ++T)
          typeof C[T] < "u" && M.push(C[T]);
        w.obj[w.prop] = M;
      }
    }
  }, o = function(k, w) {
    for (var C = w && w.plainObjects ? { __proto__: null } : {}, M = 0; M < k.length; ++M)
      typeof k[M] < "u" && (C[M] = k[M]);
    return C;
  }, i = function f(k, w, C) {
    if (!w)
      return k;
    if (typeof w != "object" && typeof w != "function") {
      if (n(k))
        k.push(w);
      else if (k && typeof k == "object")
        (C && (C.plainObjects || C.allowPrototypes) || !e.call(Object.prototype, w)) && (k[w] = !0);
      else
        return [k, w];
      return k;
    }
    if (!k || typeof k != "object")
      return [k].concat(w);
    var M = k;
    return n(k) && !n(w) && (M = o(k, C)), n(k) && n(w) ? (w.forEach(function(T, E) {
      if (e.call(k, E)) {
        var U = k[E];
        U && typeof U == "object" && T && typeof T == "object" ? k[E] = f(U, T, C) : k.push(T);
      } else
        k[E] = T;
    }), k) : Object.keys(w).reduce(function(T, E) {
      var U = w[E];
      return e.call(T, E) ? T[E] = f(T[E], U, C) : T[E] = U, T;
    }, M);
  }, r = function(k, w) {
    return Object.keys(w).reduce(function(C, M) {
      return C[M] = w[M], C;
    }, k);
  }, l = function(f, k, w) {
    var C = f.replace(/\+/g, " ");
    if (w === "iso-8859-1")
      return C.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(C);
    } catch {
      return C;
    }
  }, u = 1024, m = function(k, w, C, M, T) {
    if (k.length === 0)
      return k;
    var E = k;
    if (typeof k == "symbol" ? E = Symbol.prototype.toString.call(k) : typeof k != "string" && (E = String(k)), C === "iso-8859-1")
      return escape(E).replace(/%u[0-9a-f]{4}/gi, function(Y) {
        return "%26%23" + parseInt(Y.slice(2), 16) + "%3B";
      });
    for (var U = "", F = 0; F < E.length; F += u) {
      for (var ee = E.length >= u ? E.slice(F, F + u) : E, Q = [], se = 0; se < ee.length; ++se) {
        var W = ee.charCodeAt(se);
        if (W === 45 || W === 46 || W === 95 || W === 126 || W >= 48 && W <= 57 || W >= 65 && W <= 90 || W >= 97 && W <= 122 || T === t.RFC1738 && (W === 40 || W === 41)) {
          Q[Q.length] = ee.charAt(se);
          continue;
        }
        if (W < 128) {
          Q[Q.length] = s[W];
          continue;
        }
        if (W < 2048) {
          Q[Q.length] = s[192 | W >> 6] + s[128 | W & 63];
          continue;
        }
        if (W < 55296 || W >= 57344) {
          Q[Q.length] = s[224 | W >> 12] + s[128 | W >> 6 & 63] + s[128 | W & 63];
          continue;
        }
        se += 1, W = 65536 + ((W & 1023) << 10 | ee.charCodeAt(se) & 1023), Q[Q.length] = s[240 | W >> 18] + s[128 | W >> 12 & 63] + s[128 | W >> 6 & 63] + s[128 | W & 63];
      }
      U += Q.join("");
    }
    return U;
  }, h = function(k) {
    for (var w = [{ obj: { o: k }, prop: "o" }], C = [], M = 0; M < w.length; ++M)
      for (var T = w[M], E = T.obj[T.prop], U = Object.keys(E), F = 0; F < U.length; ++F) {
        var ee = U[F], Q = E[ee];
        typeof Q == "object" && Q !== null && C.indexOf(Q) === -1 && (w.push({ obj: E, prop: ee }), C.push(Q));
      }
    return a(w), k;
  }, v = function(k) {
    return Object.prototype.toString.call(k) === "[object RegExp]";
  }, _ = function(k) {
    return !k || typeof k != "object" ? !1 : !!(k.constructor && k.constructor.isBuffer && k.constructor.isBuffer(k));
  }, y = function(k, w) {
    return [].concat(k, w);
  }, S = function(k, w) {
    if (n(k)) {
      for (var C = [], M = 0; M < k.length; M += 1)
        C.push(w(k[M]));
      return C;
    }
    return w(k);
  };
  return Ki = {
    arrayToObject: o,
    assign: r,
    combine: y,
    compact: h,
    decode: l,
    encode: m,
    isBuffer: _,
    isRegExp: v,
    maybeMap: S,
    merge: i
  }, Ki;
}
var Ji, Hc;
function n1() {
  if (Hc) return Ji;
  Hc = 1;
  var t = t1(), e = /* @__PURE__ */ Od(), n = /* @__PURE__ */ sl(), s = Object.prototype.hasOwnProperty, a = {
    brackets: function(f) {
      return f + "[]";
    },
    comma: "comma",
    indices: function(f, k) {
      return f + "[" + k + "]";
    },
    repeat: function(f) {
      return f;
    }
  }, o = Array.isArray, i = Array.prototype.push, r = function(S, f) {
    i.apply(S, o(f) ? f : [f]);
  }, l = Date.prototype.toISOString, u = n.default, m = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: e.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: u,
    formatter: n.formatters[u],
    // deprecated
    indices: !1,
    serializeDate: function(f) {
      return l.call(f);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, h = function(f) {
    return typeof f == "string" || typeof f == "number" || typeof f == "boolean" || typeof f == "symbol" || typeof f == "bigint";
  }, v = {}, _ = function S(f, k, w, C, M, T, E, U, F, ee, Q, se, W, Y, me, he, _e, te) {
    for (var J = f, de = te, ke = 0, Te = !1; (de = de.get(v)) !== void 0 && !Te; ) {
      var Ve = de.get(f);
      if (ke += 1, typeof Ve < "u") {
        if (Ve === ke)
          throw new RangeError("Cyclic object value");
        Te = !0;
      }
      typeof de.get(v) > "u" && (ke = 0);
    }
    if (typeof ee == "function" ? J = ee(k, J) : J instanceof Date ? J = W(J) : w === "comma" && o(J) && (J = e.maybeMap(J, function(gt) {
      return gt instanceof Date ? W(gt) : gt;
    })), J === null) {
      if (T)
        return F && !he ? F(k, m.encoder, _e, "key", Y) : k;
      J = "";
    }
    if (h(J) || e.isBuffer(J)) {
      if (F) {
        var nt = he ? k : F(k, m.encoder, _e, "key", Y);
        return [me(nt) + "=" + me(F(J, m.encoder, _e, "value", Y))];
      }
      return [me(k) + "=" + me(String(J))];
    }
    var Pe = [];
    if (typeof J > "u")
      return Pe;
    var ae;
    if (w === "comma" && o(J))
      he && F && (J = e.maybeMap(J, F)), ae = [{ value: J.length > 0 ? J.join(",") || null : void 0 }];
    else if (o(ee))
      ae = ee;
    else {
      var pe = Object.keys(J);
      ae = Q ? pe.sort(Q) : pe;
    }
    var rt = U ? String(k).replace(/\./g, "%2E") : String(k), st = C && o(J) && J.length === 1 ? rt + "[]" : rt;
    if (M && o(J) && J.length === 0)
      return st + "[]";
    for (var we = 0; we < ae.length; ++we) {
      var Ce = ae[we], Je = typeof Ce == "object" && Ce && typeof Ce.value < "u" ? Ce.value : J[Ce];
      if (!(E && Je === null)) {
        var Ue = se && U ? String(Ce).replace(/\./g, "%2E") : String(Ce), Ye = o(J) ? typeof w == "function" ? w(st, Ue) : st : st + (se ? "." + Ue : "[" + Ue + "]");
        te.set(f, ke);
        var lt = t();
        lt.set(v, te), r(Pe, S(
          Je,
          Ye,
          w,
          C,
          M,
          T,
          E,
          U,
          w === "comma" && he && o(J) ? null : F,
          ee,
          Q,
          se,
          W,
          Y,
          me,
          he,
          _e,
          lt
        ));
      }
    }
    return Pe;
  }, y = function(f) {
    if (!f)
      return m;
    if (typeof f.allowEmptyArrays < "u" && typeof f.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof f.encodeDotInKeys < "u" && typeof f.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (f.encoder !== null && typeof f.encoder < "u" && typeof f.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var k = f.charset || m.charset;
    if (typeof f.charset < "u" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var w = n.default;
    if (typeof f.format < "u") {
      if (!s.call(n.formatters, f.format))
        throw new TypeError("Unknown format option provided.");
      w = f.format;
    }
    var C = n.formatters[w], M = m.filter;
    (typeof f.filter == "function" || o(f.filter)) && (M = f.filter);
    var T;
    if (f.arrayFormat in a ? T = f.arrayFormat : "indices" in f ? T = f.indices ? "indices" : "repeat" : T = m.arrayFormat, "commaRoundTrip" in f && typeof f.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var E = typeof f.allowDots > "u" ? f.encodeDotInKeys === !0 ? !0 : m.allowDots : !!f.allowDots;
    return {
      addQueryPrefix: typeof f.addQueryPrefix == "boolean" ? f.addQueryPrefix : m.addQueryPrefix,
      allowDots: E,
      allowEmptyArrays: typeof f.allowEmptyArrays == "boolean" ? !!f.allowEmptyArrays : m.allowEmptyArrays,
      arrayFormat: T,
      charset: k,
      charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : m.charsetSentinel,
      commaRoundTrip: !!f.commaRoundTrip,
      delimiter: typeof f.delimiter > "u" ? m.delimiter : f.delimiter,
      encode: typeof f.encode == "boolean" ? f.encode : m.encode,
      encodeDotInKeys: typeof f.encodeDotInKeys == "boolean" ? f.encodeDotInKeys : m.encodeDotInKeys,
      encoder: typeof f.encoder == "function" ? f.encoder : m.encoder,
      encodeValuesOnly: typeof f.encodeValuesOnly == "boolean" ? f.encodeValuesOnly : m.encodeValuesOnly,
      filter: M,
      format: w,
      formatter: C,
      serializeDate: typeof f.serializeDate == "function" ? f.serializeDate : m.serializeDate,
      skipNulls: typeof f.skipNulls == "boolean" ? f.skipNulls : m.skipNulls,
      sort: typeof f.sort == "function" ? f.sort : null,
      strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : m.strictNullHandling
    };
  };
  return Ji = function(S, f) {
    var k = S, w = y(f), C, M;
    typeof w.filter == "function" ? (M = w.filter, k = M("", k)) : o(w.filter) && (M = w.filter, C = M);
    var T = [];
    if (typeof k != "object" || k === null)
      return "";
    var E = a[w.arrayFormat], U = E === "comma" && w.commaRoundTrip;
    C || (C = Object.keys(k)), w.sort && C.sort(w.sort);
    for (var F = t(), ee = 0; ee < C.length; ++ee) {
      var Q = C[ee], se = k[Q];
      w.skipNulls && se === null || r(T, _(
        se,
        Q,
        E,
        U,
        w.allowEmptyArrays,
        w.strictNullHandling,
        w.skipNulls,
        w.encodeDotInKeys,
        w.encode ? w.encoder : null,
        w.filter,
        w.sort,
        w.allowDots,
        w.serializeDate,
        w.format,
        w.formatter,
        w.encodeValuesOnly,
        w.charset,
        F
      ));
    }
    var W = T.join(w.delimiter), Y = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? Y += "utf8=%26%2310003%3B&" : Y += "utf8=%E2%9C%93&"), W.length > 0 ? Y + W : "";
  }, Ji;
}
var Yi, Wc;
function s1() {
  if (Wc) return Yi;
  Wc = 1;
  var t = /* @__PURE__ */ Od(), e = Object.prototype.hasOwnProperty, n = Array.isArray, s = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: t.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, a = function(v) {
    return v.replace(/&#(\d+);/g, function(_, y) {
      return String.fromCharCode(parseInt(y, 10));
    });
  }, o = function(v, _, y) {
    if (v && typeof v == "string" && _.comma && v.indexOf(",") > -1)
      return v.split(",");
    if (_.throwOnLimitExceeded && y >= _.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + _.arrayLimit + " element" + (_.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return v;
  }, i = "utf8=%26%2310003%3B", r = "utf8=%E2%9C%93", l = function(_, y) {
    var S = { __proto__: null }, f = y.ignoreQueryPrefix ? _.replace(/^\?/, "") : _;
    f = f.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var k = y.parameterLimit === 1 / 0 ? void 0 : y.parameterLimit, w = f.split(
      y.delimiter,
      y.throwOnLimitExceeded ? k + 1 : k
    );
    if (y.throwOnLimitExceeded && w.length > k)
      throw new RangeError("Parameter limit exceeded. Only " + k + " parameter" + (k === 1 ? "" : "s") + " allowed.");
    var C = -1, M, T = y.charset;
    if (y.charsetSentinel)
      for (M = 0; M < w.length; ++M)
        w[M].indexOf("utf8=") === 0 && (w[M] === r ? T = "utf-8" : w[M] === i && (T = "iso-8859-1"), C = M, M = w.length);
    for (M = 0; M < w.length; ++M)
      if (M !== C) {
        var E = w[M], U = E.indexOf("]="), F = U === -1 ? E.indexOf("=") : U + 1, ee, Q;
        F === -1 ? (ee = y.decoder(E, s.decoder, T, "key"), Q = y.strictNullHandling ? null : "") : (ee = y.decoder(E.slice(0, F), s.decoder, T, "key"), Q = t.maybeMap(
          o(
            E.slice(F + 1),
            y,
            n(S[ee]) ? S[ee].length : 0
          ),
          function(W) {
            return y.decoder(W, s.decoder, T, "value");
          }
        )), Q && y.interpretNumericEntities && T === "iso-8859-1" && (Q = a(String(Q))), E.indexOf("[]=") > -1 && (Q = n(Q) ? [Q] : Q);
        var se = e.call(S, ee);
        se && y.duplicates === "combine" ? S[ee] = t.combine(S[ee], Q) : (!se || y.duplicates === "last") && (S[ee] = Q);
      }
    return S;
  }, u = function(v, _, y, S) {
    var f = 0;
    if (v.length > 0 && v[v.length - 1] === "[]") {
      var k = v.slice(0, -1).join("");
      f = Array.isArray(_) && _[k] ? _[k].length : 0;
    }
    for (var w = S ? _ : o(_, y, f), C = v.length - 1; C >= 0; --C) {
      var M, T = v[C];
      if (T === "[]" && y.parseArrays)
        M = y.allowEmptyArrays && (w === "" || y.strictNullHandling && w === null) ? [] : t.combine([], w);
      else {
        M = y.plainObjects ? { __proto__: null } : {};
        var E = T.charAt(0) === "[" && T.charAt(T.length - 1) === "]" ? T.slice(1, -1) : T, U = y.decodeDotInKeys ? E.replace(/%2E/g, ".") : E, F = parseInt(U, 10);
        !y.parseArrays && U === "" ? M = { 0: w } : !isNaN(F) && T !== U && String(F) === U && F >= 0 && y.parseArrays && F <= y.arrayLimit ? (M = [], M[F] = w) : U !== "__proto__" && (M[U] = w);
      }
      w = M;
    }
    return w;
  }, m = function(_, y, S, f) {
    if (_) {
      var k = S.allowDots ? _.replace(/\.([^.[]+)/g, "[$1]") : _, w = /(\[[^[\]]*])/, C = /(\[[^[\]]*])/g, M = S.depth > 0 && w.exec(k), T = M ? k.slice(0, M.index) : k, E = [];
      if (T) {
        if (!S.plainObjects && e.call(Object.prototype, T) && !S.allowPrototypes)
          return;
        E.push(T);
      }
      for (var U = 0; S.depth > 0 && (M = C.exec(k)) !== null && U < S.depth; ) {
        if (U += 1, !S.plainObjects && e.call(Object.prototype, M[1].slice(1, -1)) && !S.allowPrototypes)
          return;
        E.push(M[1]);
      }
      if (M) {
        if (S.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + S.depth + " and strictDepth is true");
        E.push("[" + k.slice(M.index) + "]");
      }
      return u(E, y, S, f);
    }
  }, h = function(_) {
    if (!_)
      return s;
    if (typeof _.allowEmptyArrays < "u" && typeof _.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof _.decodeDotInKeys < "u" && typeof _.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (_.decoder !== null && typeof _.decoder < "u" && typeof _.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof _.charset < "u" && _.charset !== "utf-8" && _.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof _.throwOnLimitExceeded < "u" && typeof _.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var y = typeof _.charset > "u" ? s.charset : _.charset, S = typeof _.duplicates > "u" ? s.duplicates : _.duplicates;
    if (S !== "combine" && S !== "first" && S !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var f = typeof _.allowDots > "u" ? _.decodeDotInKeys === !0 ? !0 : s.allowDots : !!_.allowDots;
    return {
      allowDots: f,
      allowEmptyArrays: typeof _.allowEmptyArrays == "boolean" ? !!_.allowEmptyArrays : s.allowEmptyArrays,
      allowPrototypes: typeof _.allowPrototypes == "boolean" ? _.allowPrototypes : s.allowPrototypes,
      allowSparse: typeof _.allowSparse == "boolean" ? _.allowSparse : s.allowSparse,
      arrayLimit: typeof _.arrayLimit == "number" ? _.arrayLimit : s.arrayLimit,
      charset: y,
      charsetSentinel: typeof _.charsetSentinel == "boolean" ? _.charsetSentinel : s.charsetSentinel,
      comma: typeof _.comma == "boolean" ? _.comma : s.comma,
      decodeDotInKeys: typeof _.decodeDotInKeys == "boolean" ? _.decodeDotInKeys : s.decodeDotInKeys,
      decoder: typeof _.decoder == "function" ? _.decoder : s.decoder,
      delimiter: typeof _.delimiter == "string" || t.isRegExp(_.delimiter) ? _.delimiter : s.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof _.depth == "number" || _.depth === !1 ? +_.depth : s.depth,
      duplicates: S,
      ignoreQueryPrefix: _.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof _.interpretNumericEntities == "boolean" ? _.interpretNumericEntities : s.interpretNumericEntities,
      parameterLimit: typeof _.parameterLimit == "number" ? _.parameterLimit : s.parameterLimit,
      parseArrays: _.parseArrays !== !1,
      plainObjects: typeof _.plainObjects == "boolean" ? _.plainObjects : s.plainObjects,
      strictDepth: typeof _.strictDepth == "boolean" ? !!_.strictDepth : s.strictDepth,
      strictNullHandling: typeof _.strictNullHandling == "boolean" ? _.strictNullHandling : s.strictNullHandling,
      throwOnLimitExceeded: typeof _.throwOnLimitExceeded == "boolean" ? _.throwOnLimitExceeded : !1
    };
  };
  return Yi = function(v, _) {
    var y = h(_);
    if (v === "" || v === null || typeof v > "u")
      return y.plainObjects ? { __proto__: null } : {};
    for (var S = typeof v == "string" ? l(v, y) : v, f = y.plainObjects ? { __proto__: null } : {}, k = Object.keys(S), w = 0; w < k.length; ++w) {
      var C = k[w], M = m(C, S[C], y, typeof v == "string");
      f = t.merge(f, M, y);
    }
    return y.allowSparse === !0 ? f : t.compact(f);
  }, Yi;
}
var er, Gc;
function a1() {
  if (Gc) return er;
  Gc = 1;
  var t = /* @__PURE__ */ n1(), e = /* @__PURE__ */ s1(), n = /* @__PURE__ */ sl();
  return er = {
    formats: n,
    parse: e,
    stringify: t
  }, er;
}
var o1 = /* @__PURE__ */ a1();
const i1 = /* @__PURE__ */ Sd(o1);
var r1 = Object.defineProperty, l1 = (t, e, n) => e in t ? r1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, so = (t, e, n) => l1(t, typeof e != "symbol" ? e + "" : e, n), $r = /* @__PURE__ */ ((t) => (t[t.INPUT = 0] = "INPUT", t[t.OUTPUT = 1] = "OUTPUT", t))($r || {});
let c1 = class extends Error {
  constructor(e, n, s) {
    let a = `Endpoint validation error in ${e === 0 ? "input" : "output"} of "${s.key ?? ""}"
${Rd(n.issues)}`;
    a.length > 5e5 && (a = a.slice(0, 499997) + "..."), super(a), so(this, "name", "EndpointValidationError");
  }
};
function Zc(t, e, n, s, a) {
  if (t) {
    const o = t.safeParse(e);
    if (o.success)
      return o.data;
    {
      const i = new c1(
        n,
        o.error,
        s
      );
      if (a)
        a(i);
      else
        throw i;
    }
  }
  return e;
}
function Rd(t, e = 0) {
  const n = /* @__PURE__ */ new Set();
  for (const s of t) {
    const { path: a, ...o } = s;
    let i = `${a.map((r) => typeof r == "number" ? "[]" : r).join(".")}: `;
    if (o.code === "invalid_union") {
      const { unionErrors: r, ...l } = o;
      i += `${JSON.stringify(l)}
`;
      const u = [];
      for (const m of r)
        u.push(
          Rd(m.issues, e + 1)
        );
      i += u.join(
        `
${"  ".repeat(e + 1)}---
`
      );
    } else
      i += JSON.stringify(o);
    n.add(i);
  }
  return `${"  ".repeat(e)}${[...n].join(`
${"  ".repeat(e)}`)}`;
}
class Ao {
  constructor(e, n, s, a, o, i, r = (m) => m.json(), l, u) {
    so(this, "inputType"), so(this, "outputType"), this.kyInstance = e, this.middlewares = n, this.resolver = s, this.onValidationError = a, this.inputSchema = o, this.outputSchema = i, this.responseTransformer = r, this.onSuccess = l, this.key = u;
  }
  async fetch(e, n, s, a, ...o) {
    if (!s.value)
      throw new Error(`Not enabled. Key: ${JSON.stringify(a.key)}`);
    const i = Zc(
      this.inputSchema,
      e,
      $r.INPUT,
      this,
      this.onValidationError
    );
    let r = this.resolver(i, ...o);
    for (const v of n)
      r = v(r, a);
    const { url: l, ...u } = r, m = await this.responseTransformer(
      this.kyInstance(l, {
        ...u,
        searchParams: u.searchParams ? i1.stringify(u.searchParams, {
          arrayFormat: "comma",
          skipNulls: !0
        }) : void 0
      })
    ), h = Zc(
      this.outputSchema,
      m,
      $r.OUTPUT,
      this,
      this.onValidationError
    );
    try {
      P(
        () => {
          var v;
          return (v = this.onSuccess) == null ? void 0 : v.call(this, {
            input: i,
            output: h
          });
        },
        a.context
      )();
    } catch {
    }
    return h;
  }
  runMiddlewares() {
    if (!Mp())
      throw new Error(
        "Middlewares outside of injection context not supported"
      );
    const e = this.middlewares.map(
      (n) => n()
    );
    return {
      beforeRequest: e.map(({ beforeRequest: n }) => n).filter((n) => n !== void 0),
      enabled: e.map(({ enabled: n }) => n).filter((n) => n !== void 0),
      key: e.map(({ key: n }) => n).filter((n) => n !== void 0)
    };
  }
}
let u1 = class Ld extends Ao {
  constructor(e, n, s, ...a) {
    super(...a), so(this, "pageParamType"), this.initialPageParam = e, this.getNextPageParam = n, this.getPreviousPageParam = s;
  }
  static create(e, n, s) {
    return (a, o) => new Ld(
      o.initialPageParam,
      o.getNextPageParam,
      o.getPreviousPageParam,
      e,
      n,
      a,
      s,
      o.input,
      o.output,
      o.responseTransformer,
      o.onSuccess
    );
  }
  getQueryKey(e) {
    const { key: n } = this.runMiddlewares();
    return e === void 0 ? [this.key, n] : [this.key, n, e];
  }
  use(...[e]) {
    const {
      beforeRequest: n,
      enabled: s,
      key: a
    } = this.runMiddlewares(), o = I(
      () => s.every((r) => Jt(r))
    ), i = Bn();
    return {
      enabled: o,
      getNextPageParam: this.getNextPageParam,
      getPreviousPageParam: this.getPreviousPageParam,
      initialPageParam: this.initialPageParam,
      queryFn: async ({
        pageParam: r,
        queryKey: l
      }) => this.fetch(
        l[2],
        n,
        o,
        { context: i, key: l },
        r
      ),
      queryKey: [this.key, a, e]
    };
  }
  useWithManualPageParam(...[e, n]) {
    const {
      beforeRequest: s,
      enabled: a,
      key: o
    } = this.runMiddlewares(), i = I(
      () => a.every((l) => Jt(l))
    ), r = Bn();
    return {
      enabled: i,
      queryFn: async ({
        queryKey: l
      }) => this.fetch(
        l[2],
        s,
        i,
        { context: r, key: l },
        l[3]
      ),
      queryKey: [
        this.key,
        o,
        e,
        n
      ]
    };
  }
};
class al extends Ao {
  static create(e, n, s) {
    return (a, o) => new al(
      e,
      n,
      a,
      s,
      o == null ? void 0 : o.input,
      o == null ? void 0 : o.output,
      o == null ? void 0 : o.responseTransformer,
      o == null ? void 0 : o.onSuccess
    );
  }
  use() {
    const {
      beforeRequest: e,
      enabled: n,
      key: s
    } = this.runMiddlewares(), a = I(
      () => n.every((i) => Jt(i))
    ), o = Bn();
    return {
      mutationFn: async (...[i]) => this.fetch(i, e, a, { context: o }),
      mutationKey: [this.key, s]
    };
  }
}
let d1 = class Dd extends Ao {
  static create(e, n, s) {
    return (a, o) => new Dd(
      e,
      n,
      a,
      s,
      o == null ? void 0 : o.input,
      o == null ? void 0 : o.output,
      o == null ? void 0 : o.responseTransformer,
      o == null ? void 0 : o.onSuccess
    );
  }
  getQueryKey(e) {
    const { key: n } = this.runMiddlewares();
    return e === void 0 ? [this.key, n] : [this.key, n, e];
  }
  use(...[e]) {
    const {
      beforeRequest: n,
      enabled: s,
      key: a
    } = this.runMiddlewares(), o = I(
      () => s.every((r) => Jt(r))
    ), i = Bn();
    return {
      enabled: o,
      queryFn: async ({
        queryKey: r
      }) => this.fetch(r[2], n, o, {
        context: i,
        key: r
      }),
      queryKey: [this.key, a, e]
    };
  }
};
function Nd(t, e = []) {
  const { onValidationError: n, ...s } = t, a = $d.extend({ retry: 0, ...s });
  return {
    infiniteQuery: u1.create(
      a,
      e,
      n
    ),
    mutation: al.create(
      a,
      e,
      n
    ),
    query: d1.create(a, e, n),
    use: (o) => Nd(t, [
      ...e,
      o
    ])
  };
}
function pt(t, e) {
  for (const [n, s] of Object.entries(t)) {
    const a = e ? `${e}.${n}` : n;
    s instanceof Ao ? s.key = a : pt(s, a);
  }
  return t;
}
const St = [];
for (let t = 0; t < 256; ++t)
  St.push((t + 256).toString(16).slice(1));
function m1(t, e = 0) {
  return (St[t[e + 0]] + St[t[e + 1]] + St[t[e + 2]] + St[t[e + 3]] + "-" + St[t[e + 4]] + St[t[e + 5]] + "-" + St[t[e + 6]] + St[t[e + 7]] + "-" + St[t[e + 8]] + St[t[e + 9]] + "-" + St[t[e + 10]] + St[t[e + 11]] + St[t[e + 12]] + St[t[e + 13]] + St[t[e + 14]] + St[t[e + 15]]).toLowerCase();
}
let tr;
const h1 = new Uint8Array(16);
function p1() {
  if (!tr) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    tr = crypto.getRandomValues.bind(crypto);
  }
  return tr(h1);
}
const f1 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Qc = { randomUUID: f1 };
function Vd(t, e, n) {
  var a;
  if (Qc.randomUUID && !t)
    return Qc.randomUUID();
  t = t || {};
  const s = t.random ?? ((a = t.rng) == null ? void 0 : a.call(t)) ?? p1();
  if (s.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, m1(s);
}
var We;
(function(t) {
  t.assertEqual = (a) => {
  };
  function e(a) {
  }
  t.assertIs = e;
  function n(a) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (a) => {
    const o = {};
    for (const i of a)
      o[i] = i;
    return o;
  }, t.getValidEnumValues = (a) => {
    const o = t.objectKeys(a).filter((r) => typeof a[a[r]] != "number"), i = {};
    for (const r of o)
      i[r] = a[r];
    return t.objectValues(i);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(o) {
    return a[o];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const o = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && o.push(i);
    return o;
  }, t.find = (a, o) => {
    for (const i of a)
      if (o(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function s(a, o = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(o);
  }
  t.joinValues = s, t.jsonStringifyReplacer = (a, o) => typeof o == "bigint" ? o.toString() : o;
})(We || (We = {}));
var Xc;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(Xc || (Xc = {}));
const fe = We.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Dn = (t) => {
  switch (typeof t) {
    case "undefined":
      return fe.undefined;
    case "string":
      return fe.string;
    case "number":
      return Number.isNaN(t) ? fe.nan : fe.number;
    case "boolean":
      return fe.boolean;
    case "function":
      return fe.function;
    case "bigint":
      return fe.bigint;
    case "symbol":
      return fe.symbol;
    case "object":
      return Array.isArray(t) ? fe.array : t === null ? fe.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? fe.promise : typeof Map < "u" && t instanceof Map ? fe.map : typeof Set < "u" && t instanceof Set ? fe.set : typeof Date < "u" && t instanceof Date ? fe.date : fe.object;
    default:
      return fe.unknown;
  }
}, ne = We.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class In extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(o) {
      return o.message;
    }, s = { _errors: [] }, a = (o) => {
      for (const i of o.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          s._errors.push(n(i));
        else {
          let r = s, l = 0;
          for (; l < i.path.length; ) {
            const u = i.path[l];
            l === i.path.length - 1 ? (r[u] = r[u] || { _errors: [] }, r[u]._errors.push(n(i))) : r[u] = r[u] || { _errors: [] }, r = r[u], l++;
          }
        }
    };
    return a(this), s;
  }
  static assert(e) {
    if (!(e instanceof In))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, We.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, s = [];
    for (const a of this.issues)
      a.path.length > 0 ? (n[a.path[0]] = n[a.path[0]] || [], n[a.path[0]].push(e(a))) : s.push(e(a));
    return { formErrors: s, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
In.create = (t) => new In(t);
const Sr = (t, e) => {
  let n;
  switch (t.code) {
    case ne.invalid_type:
      t.received === fe.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case ne.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, We.jsonStringifyReplacer)}`;
      break;
    case ne.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${We.joinValues(t.keys, ", ")}`;
      break;
    case ne.invalid_union:
      n = "Invalid input";
      break;
    case ne.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${We.joinValues(t.options)}`;
      break;
    case ne.invalid_enum_value:
      n = `Invalid enum value. Expected ${We.joinValues(t.options)}, received '${t.received}'`;
      break;
    case ne.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case ne.invalid_return_type:
      n = "Invalid function return type";
      break;
    case ne.invalid_date:
      n = "Invalid date";
      break;
    case ne.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : We.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case ne.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case ne.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case ne.custom:
      n = "Invalid input";
      break;
    case ne.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case ne.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case ne.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, We.assertNever(t);
  }
  return { message: n };
};
let v1 = Sr;
function g1() {
  return v1;
}
const _1 = (t) => {
  const { data: e, path: n, errorMaps: s, issueData: a } = t, o = [...n, ...a.path || []], i = {
    ...a,
    path: o
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: o,
      message: a.message
    };
  let r = "";
  const l = s.filter((u) => !!u).slice().reverse();
  for (const u of l)
    r = u(i, { data: e, defaultError: r }).message;
  return {
    ...a,
    path: o,
    message: r
  };
};
function ue(t, e) {
  const n = g1(), s = _1({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === Sr ? void 0 : Sr
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(s);
}
class nn {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const s = [];
    for (const a of n) {
      if (a.status === "aborted")
        return Ie;
      a.status === "dirty" && e.dirty(), s.push(a.value);
    }
    return { status: e.value, value: s };
  }
  static async mergeObjectAsync(e, n) {
    const s = [];
    for (const a of n) {
      const o = await a.key, i = await a.value;
      s.push({
        key: o,
        value: i
      });
    }
    return nn.mergeObjectSync(e, s);
  }
  static mergeObjectSync(e, n) {
    const s = {};
    for (const a of n) {
      const { key: o, value: i } = a;
      if (o.status === "aborted" || i.status === "aborted")
        return Ie;
      o.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), o.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (s[o.value] = i.value);
    }
    return { status: e.value, value: s };
  }
}
const Ie = Object.freeze({
  status: "aborted"
}), oa = (t) => ({ status: "dirty", value: t }), cn = (t) => ({ status: "valid", value: t }), Kc = (t) => t.status === "aborted", Jc = (t) => t.status === "dirty", Cs = (t) => t.status === "valid", ao = (t) => typeof Promise < "u" && t instanceof Promise;
var ge;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(ge || (ge = {}));
class qn {
  constructor(e, n, s, a) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = s, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Yc = (t, e) => {
  if (Cs(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new In(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Le(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: s, description: a } = t;
  if (e && (n || s))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (i, r) => {
    const { message: l } = t;
    return i.code === "invalid_enum_value" ? { message: l ?? r.defaultError } : typeof r.data > "u" ? { message: l ?? s ?? r.defaultError } : i.code !== "invalid_type" ? { message: r.defaultError } : { message: l ?? n ?? r.defaultError };
  }, description: a };
}
class Be {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Dn(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: Dn(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new nn(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Dn(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (ao(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const s = this.safeParse(e, n);
    if (s.success)
      return s.data;
    throw s.error;
  }
  safeParse(e, n) {
    const s = {
      common: {
        issues: [],
        async: (n == null ? void 0 : n.async) ?? !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Dn(e)
    }, a = this._parseSync({ data: e, path: s.path, parent: s });
    return Yc(s, a);
  }
  "~validate"(e) {
    var s, a;
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Dn(e)
    };
    if (!this["~standard"].async)
      try {
        const o = this._parseSync({ data: e, path: [], parent: n });
        return Cs(o) ? {
          value: o.value
        } : {
          issues: n.common.issues
        };
      } catch (o) {
        (a = (s = o == null ? void 0 : o.message) == null ? void 0 : s.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: n }).then((o) => Cs(o) ? {
      value: o.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(e, n) {
    const s = await this.safeParseAsync(e, n);
    if (s.success)
      return s.data;
    throw s.error;
  }
  async safeParseAsync(e, n) {
    const s = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Dn(e)
    }, a = this._parse({ data: e, path: s.path, parent: s }), o = await (ao(a) ? a : Promise.resolve(a));
    return Yc(s, o);
  }
  refine(e, n) {
    const s = (a) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(a) : n;
    return this._refinement((a, o) => {
      const i = e(a), r = () => o.addIssue({
        code: ne.custom,
        ...s(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((l) => l ? !0 : (r(), !1)) : i ? !0 : (r(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((s, a) => e(s) ? !0 : (a.addIssue(typeof n == "function" ? n(s, a) : n), !1));
  }
  _refinement(e) {
    return new ms({
      schema: this,
      typeName: Me.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return Pn.create(this, this._def);
  }
  nullable() {
    return hs.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return bn.create(this);
  }
  promise() {
    return mo.create(this, this._def);
  }
  or(e) {
    return io.create([this, e], this._def);
  }
  and(e) {
    return ro.create(this, e, this._def);
  }
  transform(e) {
    return new ms({
      ...Le(this._def),
      schema: this,
      typeName: Me.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new ho({
      ...Le(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Me.ZodDefault
    });
  }
  brand() {
    return new Bd({
      typeName: Me.ZodBranded,
      type: this,
      ...Le(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new po({
      ...Le(this._def),
      innerType: this,
      catchValue: n,
      typeName: Me.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return il.create(this, e);
  }
  readonly() {
    return fo.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const k1 = /^c[^\s-]{8,}$/i, y1 = /^[0-9a-z]+$/, b1 = /^[0-9A-HJKMNP-TV-Z]{26}$/i, w1 = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, x1 = /^[a-z0-9_-]{21}$/i, $1 = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, S1 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, A1 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, C1 = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let nr;
const P1 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, I1 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, M1 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, T1 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, z1 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, E1 = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ud = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", O1 = new RegExp(`^${Ud}$`);
function Fd(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const n = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${n}`;
}
function R1(t) {
  return new RegExp(`^${Fd(t)}$`);
}
function L1(t) {
  let e = `${Ud}T${Fd(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function D1(t, e) {
  return !!((e === "v4" || !e) && P1.test(t) || (e === "v6" || !e) && M1.test(t));
}
function N1(t, e) {
  if (!$1.test(t))
    return !1;
  try {
    const [n] = t.split("."), s = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), a = JSON.parse(atob(s));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function V1(t, e) {
  return !!((e === "v4" || !e) && I1.test(t) || (e === "v6" || !e) && T1.test(t));
}
class Vn extends Be {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== fe.string) {
      const o = this._getOrReturnCtx(e);
      return ue(o, {
        code: ne.invalid_type,
        expected: fe.string,
        received: o.parsedType
      }), Ie;
    }
    const s = new nn();
    let a;
    for (const o of this._def.checks)
      if (o.kind === "min")
        e.data.length < o.value && (a = this._getOrReturnCtx(e, a), ue(a, {
          code: ne.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), s.dirty());
      else if (o.kind === "max")
        e.data.length > o.value && (a = this._getOrReturnCtx(e, a), ue(a, {
          code: ne.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), s.dirty());
      else if (o.kind === "length") {
        const i = e.data.length > o.value, r = e.data.length < o.value;
        (i || r) && (a = this._getOrReturnCtx(e, a), i ? ue(a, {
          code: ne.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : r && ue(a, {
          code: ne.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), s.dirty());
      } else if (o.kind === "email")
        A1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
          validation: "email",
          code: ne.invalid_string,
          message: o.message
        }), s.dirty());
      else if (o.kind === "emoji")
        nr || (nr = new RegExp(C1, "u")), nr.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
          validation: "emoji",
          code: ne.invalid_string,
          message: o.message
        }), s.dirty());
      else if (o.kind === "uuid")
        w1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
          validation: "uuid",
          code: ne.invalid_string,
          message: o.message
        }), s.dirty());
      else if (o.kind === "nanoid")
        x1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
          validation: "nanoid",
          code: ne.invalid_string,
          message: o.message
        }), s.dirty());
      else if (o.kind === "cuid")
        k1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
          validation: "cuid",
          code: ne.invalid_string,
          message: o.message
        }), s.dirty());
      else if (o.kind === "cuid2")
        y1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
          validation: "cuid2",
          code: ne.invalid_string,
          message: o.message
        }), s.dirty());
      else if (o.kind === "ulid")
        b1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
          validation: "ulid",
          code: ne.invalid_string,
          message: o.message
        }), s.dirty());
      else if (o.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), ue(a, {
            validation: "url",
            code: ne.invalid_string,
            message: o.message
          }), s.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
        validation: "regex",
        code: ne.invalid_string,
        message: o.message
      }), s.dirty())) : o.kind === "trim" ? e.data = e.data.trim() : o.kind === "includes" ? e.data.includes(o.value, o.position) || (a = this._getOrReturnCtx(e, a), ue(a, {
        code: ne.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), s.dirty()) : o.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : o.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : o.kind === "startsWith" ? e.data.startsWith(o.value) || (a = this._getOrReturnCtx(e, a), ue(a, {
        code: ne.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), s.dirty()) : o.kind === "endsWith" ? e.data.endsWith(o.value) || (a = this._getOrReturnCtx(e, a), ue(a, {
        code: ne.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), s.dirty()) : o.kind === "datetime" ? L1(o).test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
        code: ne.invalid_string,
        validation: "datetime",
        message: o.message
      }), s.dirty()) : o.kind === "date" ? O1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
        code: ne.invalid_string,
        validation: "date",
        message: o.message
      }), s.dirty()) : o.kind === "time" ? R1(o).test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
        code: ne.invalid_string,
        validation: "time",
        message: o.message
      }), s.dirty()) : o.kind === "duration" ? S1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
        validation: "duration",
        code: ne.invalid_string,
        message: o.message
      }), s.dirty()) : o.kind === "ip" ? D1(e.data, o.version) || (a = this._getOrReturnCtx(e, a), ue(a, {
        validation: "ip",
        code: ne.invalid_string,
        message: o.message
      }), s.dirty()) : o.kind === "jwt" ? N1(e.data, o.alg) || (a = this._getOrReturnCtx(e, a), ue(a, {
        validation: "jwt",
        code: ne.invalid_string,
        message: o.message
      }), s.dirty()) : o.kind === "cidr" ? V1(e.data, o.version) || (a = this._getOrReturnCtx(e, a), ue(a, {
        validation: "cidr",
        code: ne.invalid_string,
        message: o.message
      }), s.dirty()) : o.kind === "base64" ? z1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
        validation: "base64",
        code: ne.invalid_string,
        message: o.message
      }), s.dirty()) : o.kind === "base64url" ? E1.test(e.data) || (a = this._getOrReturnCtx(e, a), ue(a, {
        validation: "base64url",
        code: ne.invalid_string,
        message: o.message
      }), s.dirty()) : We.assertNever(o);
    return { status: s.value, value: e.data };
  }
  _regex(e, n, s) {
    return this.refinement((a) => e.test(a), {
      validation: n,
      code: ne.invalid_string,
      ...ge.errToObj(s)
    });
  }
  _addCheck(e) {
    return new Vn({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...ge.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...ge.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...ge.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...ge.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...ge.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...ge.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...ge.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...ge.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...ge.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...ge.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...ge.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...ge.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...ge.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...ge.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...ge.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...ge.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...ge.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position,
      ...ge.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...ge.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...ge.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...ge.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...ge.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...ge.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, ge.errToObj(e));
  }
  trim() {
    return new Vn({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Vn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Vn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
Vn.create = (t) => new Vn({
  checks: [],
  typeName: Me.ZodString,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...Le(t)
});
function U1(t, e) {
  const n = (t.toString().split(".")[1] || "").length, s = (e.toString().split(".")[1] || "").length, a = n > s ? n : s, o = Number.parseInt(t.toFixed(a).replace(".", "")), i = Number.parseInt(e.toFixed(a).replace(".", ""));
  return o % i / 10 ** a;
}
class Ps extends Be {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== fe.number) {
      const o = this._getOrReturnCtx(e);
      return ue(o, {
        code: ne.invalid_type,
        expected: fe.number,
        received: o.parsedType
      }), Ie;
    }
    let s;
    const a = new nn();
    for (const o of this._def.checks)
      o.kind === "int" ? We.isInteger(e.data) || (s = this._getOrReturnCtx(e, s), ue(s, {
        code: ne.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), a.dirty()) : o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (s = this._getOrReturnCtx(e, s), ue(s, {
        code: ne.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), a.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (s = this._getOrReturnCtx(e, s), ue(s, {
        code: ne.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), a.dirty()) : o.kind === "multipleOf" ? U1(e.data, o.value) !== 0 && (s = this._getOrReturnCtx(e, s), ue(s, {
        code: ne.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), a.dirty()) : o.kind === "finite" ? Number.isFinite(e.data) || (s = this._getOrReturnCtx(e, s), ue(s, {
        code: ne.not_finite,
        message: o.message
      }), a.dirty()) : We.assertNever(o);
    return { status: a.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, ge.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, ge.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, ge.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, ge.toString(n));
  }
  setLimit(e, n, s, a) {
    return new Ps({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: s,
          message: ge.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Ps({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: ge.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: ge.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: ge.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: ge.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: ge.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: ge.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: ge.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: ge.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: ge.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && We.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf")
        return !0;
      s.kind === "min" ? (n === null || s.value > n) && (n = s.value) : s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
Ps.create = (t) => new Ps({
  checks: [],
  typeName: Me.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...Le(t)
});
class ma extends Be {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== fe.bigint)
      return this._getInvalidInput(e);
    let s;
    const a = new nn();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (s = this._getOrReturnCtx(e, s), ue(s, {
        code: ne.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), a.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (s = this._getOrReturnCtx(e, s), ue(s, {
        code: ne.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), a.dirty()) : o.kind === "multipleOf" ? e.data % o.value !== BigInt(0) && (s = this._getOrReturnCtx(e, s), ue(s, {
        code: ne.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), a.dirty()) : We.assertNever(o);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return ue(n, {
      code: ne.invalid_type,
      expected: fe.bigint,
      received: n.parsedType
    }), Ie;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, ge.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, ge.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, ge.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, ge.toString(n));
  }
  setLimit(e, n, s, a) {
    return new ma({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: s,
          message: ge.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new ma({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: ge.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: ge.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: ge.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: ge.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: ge.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
ma.create = (t) => new ma({
  checks: [],
  typeName: Me.ZodBigInt,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...Le(t)
});
class Ar extends Be {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== fe.boolean) {
      const s = this._getOrReturnCtx(e);
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.boolean,
        received: s.parsedType
      }), Ie;
    }
    return cn(e.data);
  }
}
Ar.create = (t) => new Ar({
  typeName: Me.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...Le(t)
});
class ha extends Be {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== fe.date) {
      const o = this._getOrReturnCtx(e);
      return ue(o, {
        code: ne.invalid_type,
        expected: fe.date,
        received: o.parsedType
      }), Ie;
    }
    if (Number.isNaN(e.data.getTime())) {
      const o = this._getOrReturnCtx(e);
      return ue(o, {
        code: ne.invalid_date
      }), Ie;
    }
    const s = new nn();
    let a;
    for (const o of this._def.checks)
      o.kind === "min" ? e.data.getTime() < o.value && (a = this._getOrReturnCtx(e, a), ue(a, {
        code: ne.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), s.dirty()) : o.kind === "max" ? e.data.getTime() > o.value && (a = this._getOrReturnCtx(e, a), ue(a, {
        code: ne.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), s.dirty()) : We.assertNever(o);
    return {
      status: s.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new ha({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: ge.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: ge.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
ha.create = (t) => new ha({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: Me.ZodDate,
  ...Le(t)
});
class eu extends Be {
  _parse(e) {
    if (this._getType(e) !== fe.symbol) {
      const s = this._getOrReturnCtx(e);
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.symbol,
        received: s.parsedType
      }), Ie;
    }
    return cn(e.data);
  }
}
eu.create = (t) => new eu({
  typeName: Me.ZodSymbol,
  ...Le(t)
});
class Cr extends Be {
  _parse(e) {
    if (this._getType(e) !== fe.undefined) {
      const s = this._getOrReturnCtx(e);
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.undefined,
        received: s.parsedType
      }), Ie;
    }
    return cn(e.data);
  }
}
Cr.create = (t) => new Cr({
  typeName: Me.ZodUndefined,
  ...Le(t)
});
class oo extends Be {
  _parse(e) {
    if (this._getType(e) !== fe.null) {
      const s = this._getOrReturnCtx(e);
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.null,
        received: s.parsedType
      }), Ie;
    }
    return cn(e.data);
  }
}
oo.create = (t) => new oo({
  typeName: Me.ZodNull,
  ...Le(t)
});
class pa extends Be {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return cn(e.data);
  }
}
pa.create = (t) => new pa({
  typeName: Me.ZodAny,
  ...Le(t)
});
class Pr extends Be {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return cn(e.data);
  }
}
Pr.create = (t) => new Pr({
  typeName: Me.ZodUnknown,
  ...Le(t)
});
class Hn extends Be {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return ue(n, {
      code: ne.invalid_type,
      expected: fe.never,
      received: n.parsedType
    }), Ie;
  }
}
Hn.create = (t) => new Hn({
  typeName: Me.ZodNever,
  ...Le(t)
});
class tu extends Be {
  _parse(e) {
    if (this._getType(e) !== fe.undefined) {
      const s = this._getOrReturnCtx(e);
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.void,
        received: s.parsedType
      }), Ie;
    }
    return cn(e.data);
  }
}
tu.create = (t) => new tu({
  typeName: Me.ZodVoid,
  ...Le(t)
});
class bn extends Be {
  _parse(e) {
    const { ctx: n, status: s } = this._processInputParams(e), a = this._def;
    if (n.parsedType !== fe.array)
      return ue(n, {
        code: ne.invalid_type,
        expected: fe.array,
        received: n.parsedType
      }), Ie;
    if (a.exactLength !== null) {
      const i = n.data.length > a.exactLength.value, r = n.data.length < a.exactLength.value;
      (i || r) && (ue(n, {
        code: i ? ne.too_big : ne.too_small,
        minimum: r ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), s.dirty());
    }
    if (a.minLength !== null && n.data.length < a.minLength.value && (ue(n, {
      code: ne.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), s.dirty()), a.maxLength !== null && n.data.length > a.maxLength.value && (ue(n, {
      code: ne.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), s.dirty()), n.common.async)
      return Promise.all([...n.data].map((i, r) => a.type._parseAsync(new qn(n, i, n.path, r)))).then((i) => nn.mergeArray(s, i));
    const o = [...n.data].map((i, r) => a.type._parseSync(new qn(n, i, n.path, r)));
    return nn.mergeArray(s, o);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new bn({
      ...this._def,
      minLength: { value: e, message: ge.toString(n) }
    });
  }
  max(e, n) {
    return new bn({
      ...this._def,
      maxLength: { value: e, message: ge.toString(n) }
    });
  }
  length(e, n) {
    return new bn({
      ...this._def,
      exactLength: { value: e, message: ge.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
bn.create = (t, e) => new bn({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Me.ZodArray,
  ...Le(e)
});
function xs(t) {
  if (t instanceof vt) {
    const e = {};
    for (const n in t.shape) {
      const s = t.shape[n];
      e[n] = Pn.create(xs(s));
    }
    return new vt({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof bn ? new bn({
    ...t._def,
    type: xs(t.element)
  }) : t instanceof Pn ? Pn.create(xs(t.unwrap())) : t instanceof hs ? hs.create(xs(t.unwrap())) : t instanceof us ? us.create(t.items.map((e) => xs(e))) : t;
}
class vt extends Be {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = We.objectKeys(e);
    return this._cached = { shape: e, keys: n }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== fe.object) {
      const u = this._getOrReturnCtx(e);
      return ue(u, {
        code: ne.invalid_type,
        expected: fe.object,
        received: u.parsedType
      }), Ie;
    }
    const { status: s, ctx: a } = this._processInputParams(e), { shape: o, keys: i } = this._getCached(), r = [];
    if (!(this._def.catchall instanceof Hn && this._def.unknownKeys === "strip"))
      for (const u in a.data)
        i.includes(u) || r.push(u);
    const l = [];
    for (const u of i) {
      const m = o[u], h = a.data[u];
      l.push({
        key: { status: "valid", value: u },
        value: m._parse(new qn(a, h, a.path, u)),
        alwaysSet: u in a.data
      });
    }
    if (this._def.catchall instanceof Hn) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const m of r)
          l.push({
            key: { status: "valid", value: m },
            value: { status: "valid", value: a.data[m] }
          });
      else if (u === "strict")
        r.length > 0 && (ue(a, {
          code: ne.unrecognized_keys,
          keys: r
        }), s.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const m of r) {
        const h = a.data[m];
        l.push({
          key: { status: "valid", value: m },
          value: u._parse(
            new qn(a, h, a.path, m)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: m in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const m of l) {
        const h = await m.key, v = await m.value;
        u.push({
          key: h,
          value: v,
          alwaysSet: m.alwaysSet
        });
      }
      return u;
    }).then((u) => nn.mergeObjectSync(s, u)) : nn.mergeObjectSync(s, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return ge.errToObj, new vt({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, s) => {
          var o, i;
          const a = ((i = (o = this._def).errorMap) == null ? void 0 : i.call(o, n, s).message) ?? s.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: ge.errToObj(e).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new vt({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new vt({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new vt({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new vt({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Me.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new vt({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    for (const s of We.objectKeys(e))
      e[s] && this.shape[s] && (n[s] = this.shape[s]);
    return new vt({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    for (const s of We.objectKeys(this.shape))
      e[s] || (n[s] = this.shape[s]);
    return new vt({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return xs(this);
  }
  partial(e) {
    const n = {};
    for (const s of We.objectKeys(this.shape)) {
      const a = this.shape[s];
      e && !e[s] ? n[s] = a : n[s] = a.optional();
    }
    return new vt({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    for (const s of We.objectKeys(this.shape))
      if (e && !e[s])
        n[s] = this.shape[s];
      else {
        let o = this.shape[s];
        for (; o instanceof Pn; )
          o = o._def.innerType;
        n[s] = o;
      }
    return new vt({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return jd(We.objectKeys(this.shape));
  }
}
vt.create = (t, e) => new vt({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Hn.create(),
  typeName: Me.ZodObject,
  ...Le(e)
});
vt.strictCreate = (t, e) => new vt({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Hn.create(),
  typeName: Me.ZodObject,
  ...Le(e)
});
vt.lazycreate = (t, e) => new vt({
  shape: t,
  unknownKeys: "strip",
  catchall: Hn.create(),
  typeName: Me.ZodObject,
  ...Le(e)
});
class io extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = this._def.options;
    function a(o) {
      for (const r of o)
        if (r.result.status === "valid")
          return r.result;
      for (const r of o)
        if (r.result.status === "dirty")
          return n.common.issues.push(...r.ctx.common.issues), r.result;
      const i = o.map((r) => new In(r.ctx.common.issues));
      return ue(n, {
        code: ne.invalid_union,
        unionErrors: i
      }), Ie;
    }
    if (n.common.async)
      return Promise.all(s.map(async (o) => {
        const i = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: n.data,
            path: n.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let o;
      const i = [];
      for (const l of s) {
        const u = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, m = l._parseSync({
          data: n.data,
          path: n.path,
          parent: u
        });
        if (m.status === "valid")
          return m;
        m.status === "dirty" && !o && (o = { result: m, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (o)
        return n.common.issues.push(...o.ctx.common.issues), o.result;
      const r = i.map((l) => new In(l));
      return ue(n, {
        code: ne.invalid_union,
        unionErrors: r
      }), Ie;
    }
  }
  get options() {
    return this._def.options;
  }
}
io.create = (t, e) => new io({
  options: t,
  typeName: Me.ZodUnion,
  ...Le(e)
});
const Cn = (t) => t instanceof lo ? Cn(t.schema) : t instanceof ms ? Cn(t.innerType()) : t instanceof co ? [t.value] : t instanceof ds ? t.options : t instanceof uo ? We.objectValues(t.enum) : t instanceof ho ? Cn(t._def.innerType) : t instanceof Cr ? [void 0] : t instanceof oo ? [null] : t instanceof Pn ? [void 0, ...Cn(t.unwrap())] : t instanceof hs ? [null, ...Cn(t.unwrap())] : t instanceof Bd || t instanceof fo ? Cn(t.unwrap()) : t instanceof po ? Cn(t._def.innerType) : [];
class ol extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== fe.object)
      return ue(n, {
        code: ne.invalid_type,
        expected: fe.object,
        received: n.parsedType
      }), Ie;
    const s = this.discriminator, a = n.data[s], o = this.optionsMap.get(a);
    return o ? n.common.async ? o._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : o._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (ue(n, {
      code: ne.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [s]
    }), Ie);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, s) {
    const a = /* @__PURE__ */ new Map();
    for (const o of n) {
      const i = Cn(o.shape[e]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const r of i) {
        if (a.has(r))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(r)}`);
        a.set(r, o);
      }
    }
    return new ol({
      typeName: Me.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: a,
      ...Le(s)
    });
  }
}
function Ir(t, e) {
  const n = Dn(t), s = Dn(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === fe.object && s === fe.object) {
    const a = We.objectKeys(e), o = We.objectKeys(t).filter((r) => a.indexOf(r) !== -1), i = { ...t, ...e };
    for (const r of o) {
      const l = Ir(t[r], e[r]);
      if (!l.valid)
        return { valid: !1 };
      i[r] = l.data;
    }
    return { valid: !0, data: i };
  } else if (n === fe.array && s === fe.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let o = 0; o < t.length; o++) {
      const i = t[o], r = e[o], l = Ir(i, r);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return n === fe.date && s === fe.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class ro extends Be {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e), a = (o, i) => {
      if (Kc(o) || Kc(i))
        return Ie;
      const r = Ir(o.value, i.value);
      return r.valid ? ((Jc(o) || Jc(i)) && n.dirty(), { status: n.value, value: r.data }) : (ue(s, {
        code: ne.invalid_intersection_types
      }), Ie);
    };
    return s.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      }),
      this._def.right._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      })
    ]).then(([o, i]) => a(o, i)) : a(this._def.left._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }), this._def.right._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }));
  }
}
ro.create = (t, e, n) => new ro({
  left: t,
  right: e,
  typeName: Me.ZodIntersection,
  ...Le(n)
});
class us extends Be {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== fe.array)
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.array,
        received: s.parsedType
      }), Ie;
    if (s.data.length < this._def.items.length)
      return ue(s, {
        code: ne.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ie;
    !this._def.rest && s.data.length > this._def.items.length && (ue(s, {
      code: ne.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const o = [...s.data].map((i, r) => {
      const l = this._def.items[r] || this._def.rest;
      return l ? l._parse(new qn(s, i, s.path, r)) : null;
    }).filter((i) => !!i);
    return s.common.async ? Promise.all(o).then((i) => nn.mergeArray(n, i)) : nn.mergeArray(n, o);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new us({
      ...this._def,
      rest: e
    });
  }
}
us.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new us({
    items: t,
    typeName: Me.ZodTuple,
    rest: null,
    ...Le(e)
  });
};
class nu extends Be {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== fe.map)
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.map,
        received: s.parsedType
      }), Ie;
    const a = this._def.keyType, o = this._def.valueType, i = [...s.data.entries()].map(([r, l], u) => ({
      key: a._parse(new qn(s, r, s.path, [u, "key"])),
      value: o._parse(new qn(s, l, s.path, [u, "value"]))
    }));
    if (s.common.async) {
      const r = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of i) {
          const u = await l.key, m = await l.value;
          if (u.status === "aborted" || m.status === "aborted")
            return Ie;
          (u.status === "dirty" || m.status === "dirty") && n.dirty(), r.set(u.value, m.value);
        }
        return { status: n.value, value: r };
      });
    } else {
      const r = /* @__PURE__ */ new Map();
      for (const l of i) {
        const u = l.key, m = l.value;
        if (u.status === "aborted" || m.status === "aborted")
          return Ie;
        (u.status === "dirty" || m.status === "dirty") && n.dirty(), r.set(u.value, m.value);
      }
      return { status: n.value, value: r };
    }
  }
}
nu.create = (t, e, n) => new nu({
  valueType: e,
  keyType: t,
  typeName: Me.ZodMap,
  ...Le(n)
});
class fa extends Be {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== fe.set)
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.set,
        received: s.parsedType
      }), Ie;
    const a = this._def;
    a.minSize !== null && s.data.size < a.minSize.value && (ue(s, {
      code: ne.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), n.dirty()), a.maxSize !== null && s.data.size > a.maxSize.value && (ue(s, {
      code: ne.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), n.dirty());
    const o = this._def.valueType;
    function i(l) {
      const u = /* @__PURE__ */ new Set();
      for (const m of l) {
        if (m.status === "aborted")
          return Ie;
        m.status === "dirty" && n.dirty(), u.add(m.value);
      }
      return { status: n.value, value: u };
    }
    const r = [...s.data.values()].map((l, u) => o._parse(new qn(s, l, s.path, u)));
    return s.common.async ? Promise.all(r).then((l) => i(l)) : i(r);
  }
  min(e, n) {
    return new fa({
      ...this._def,
      minSize: { value: e, message: ge.toString(n) }
    });
  }
  max(e, n) {
    return new fa({
      ...this._def,
      maxSize: { value: e, message: ge.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
fa.create = (t, e) => new fa({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: Me.ZodSet,
  ...Le(e)
});
class lo extends Be {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
lo.create = (t, e) => new lo({
  getter: t,
  typeName: Me.ZodLazy,
  ...Le(e)
});
class co extends Be {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return ue(n, {
        received: n.data,
        code: ne.invalid_literal,
        expected: this._def.value
      }), Ie;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
co.create = (t, e) => new co({
  value: t,
  typeName: Me.ZodLiteral,
  ...Le(e)
});
function jd(t, e) {
  return new ds({
    values: t,
    typeName: Me.ZodEnum,
    ...Le(e)
  });
}
class ds extends Be {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), s = this._def.values;
      return ue(n, {
        expected: We.joinValues(s),
        received: n.parsedType,
        code: ne.invalid_type
      }), Ie;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const n = this._getOrReturnCtx(e), s = this._def.values;
      return ue(n, {
        received: n.data,
        code: ne.invalid_enum_value,
        options: s
      }), Ie;
    }
    return cn(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return ds.create(e, {
      ...this._def,
      ...n
    });
  }
  exclude(e, n = this._def) {
    return ds.create(this.options.filter((s) => !e.includes(s)), {
      ...this._def,
      ...n
    });
  }
}
ds.create = jd;
class uo extends Be {
  _parse(e) {
    const n = We.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(e);
    if (s.parsedType !== fe.string && s.parsedType !== fe.number) {
      const a = We.objectValues(n);
      return ue(s, {
        expected: We.joinValues(a),
        received: s.parsedType,
        code: ne.invalid_type
      }), Ie;
    }
    if (this._cache || (this._cache = new Set(We.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const a = We.objectValues(n);
      return ue(s, {
        received: s.data,
        code: ne.invalid_enum_value,
        options: a
      }), Ie;
    }
    return cn(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
uo.create = (t, e) => new uo({
  values: t,
  typeName: Me.ZodNativeEnum,
  ...Le(e)
});
class mo extends Be {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== fe.promise && n.common.async === !1)
      return ue(n, {
        code: ne.invalid_type,
        expected: fe.promise,
        received: n.parsedType
      }), Ie;
    const s = n.parsedType === fe.promise ? n.data : Promise.resolve(n.data);
    return cn(s.then((a) => this._def.type.parseAsync(a, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
mo.create = (t, e) => new mo({
  type: t,
  typeName: Me.ZodPromise,
  ...Le(e)
});
class ms extends Be {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Me.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e), a = this._def.effect || null, o = {
      addIssue: (i) => {
        ue(s, i), i.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return s.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), a.type === "preprocess") {
      const i = a.transform(s.data, o);
      if (s.common.async)
        return Promise.resolve(i).then(async (r) => {
          if (n.value === "aborted")
            return Ie;
          const l = await this._def.schema._parseAsync({
            data: r,
            path: s.path,
            parent: s
          });
          return l.status === "aborted" ? Ie : l.status === "dirty" || n.value === "dirty" ? oa(l.value) : l;
        });
      {
        if (n.value === "aborted")
          return Ie;
        const r = this._def.schema._parseSync({
          data: i,
          path: s.path,
          parent: s
        });
        return r.status === "aborted" ? Ie : r.status === "dirty" || n.value === "dirty" ? oa(r.value) : r;
      }
    }
    if (a.type === "refinement") {
      const i = (r) => {
        const l = a.refinement(r, o);
        if (s.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return r;
      };
      if (s.common.async === !1) {
        const r = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return r.status === "aborted" ? Ie : (r.status === "dirty" && n.dirty(), i(r.value), { status: n.value, value: r.value });
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((r) => r.status === "aborted" ? Ie : (r.status === "dirty" && n.dirty(), i(r.value).then(() => ({ status: n.value, value: r.value }))));
    }
    if (a.type === "transform")
      if (s.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        if (!Cs(i))
          return Ie;
        const r = a.transform(i.value, o);
        if (r instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: r };
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((i) => Cs(i) ? Promise.resolve(a.transform(i.value, o)).then((r) => ({
          status: n.value,
          value: r
        })) : Ie);
    We.assertNever(a);
  }
}
ms.create = (t, e, n) => new ms({
  schema: t,
  typeName: Me.ZodEffects,
  effect: e,
  ...Le(n)
});
ms.createWithPreprocess = (t, e, n) => new ms({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: Me.ZodEffects,
  ...Le(n)
});
class Pn extends Be {
  _parse(e) {
    return this._getType(e) === fe.undefined ? cn(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Pn.create = (t, e) => new Pn({
  innerType: t,
  typeName: Me.ZodOptional,
  ...Le(e)
});
class hs extends Be {
  _parse(e) {
    return this._getType(e) === fe.null ? cn(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
hs.create = (t, e) => new hs({
  innerType: t,
  typeName: Me.ZodNullable,
  ...Le(e)
});
class ho extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let s = n.data;
    return n.parsedType === fe.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({
      data: s,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ho.create = (t, e) => new ho({
  innerType: t,
  typeName: Me.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...Le(e)
});
class po extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: s.data,
      path: s.path,
      parent: {
        ...s
      }
    });
    return ao(a) ? a.then((o) => ({
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new In(s.common.issues);
        },
        input: s.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new In(s.common.issues);
        },
        input: s.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
po.create = (t, e) => new po({
  innerType: t,
  typeName: Me.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...Le(e)
});
class su extends Be {
  _parse(e) {
    if (this._getType(e) !== fe.nan) {
      const s = this._getOrReturnCtx(e);
      return ue(s, {
        code: ne.invalid_type,
        expected: fe.nan,
        received: s.parsedType
      }), Ie;
    }
    return { status: "valid", value: e.data };
  }
}
su.create = (t) => new su({
  typeName: Me.ZodNaN,
  ...Le(t)
});
class Bd extends Be {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), s = n.data;
    return this._def.type._parse({
      data: s,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class il extends Be {
  _parse(e) {
    const { status: n, ctx: s } = this._processInputParams(e);
    if (s.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return o.status === "aborted" ? Ie : o.status === "dirty" ? (n.dirty(), oa(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: s.path,
          parent: s
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: s.data,
        path: s.path,
        parent: s
      });
      return a.status === "aborted" ? Ie : a.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: s.path,
        parent: s
      });
    }
  }
  static create(e, n) {
    return new il({
      in: e,
      out: n,
      typeName: Me.ZodPipeline
    });
  }
}
class fo extends Be {
  _parse(e) {
    const n = this._def.innerType._parse(e), s = (a) => (Cs(a) && (a.value = Object.freeze(a.value)), a);
    return ao(n) ? n.then((a) => s(a)) : s(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
fo.create = (t, e) => new fo({
  innerType: t,
  typeName: Me.ZodReadonly,
  ...Le(e)
});
function au(t, e) {
  const n = typeof t == "function" ? t(e) : typeof t == "string" ? { message: t } : t;
  return typeof n == "string" ? { message: n } : n;
}
function qd(t, e = {}, n) {
  return t ? pa.create().superRefine((s, a) => {
    const o = t(s);
    if (o instanceof Promise)
      return o.then((i) => {
        if (!i) {
          const r = au(e, s), l = r.fatal ?? n ?? !0;
          a.addIssue({ code: "custom", ...r, fatal: l });
        }
      });
    if (!o) {
      const i = au(e, s), r = i.fatal ?? n ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: r });
    }
  }) : pa.create();
}
var Me;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(Me || (Me = {}));
const F1 = (t, e = {
  message: `Input not instance of ${t.name}`
}) => qd((n) => n instanceof t, e), V = Vn.create, R = Ps.create, Yt = Ar.create, ts = ha.create, va = oo.create;
pa.create;
const j1 = Pr.create;
Hn.create;
const ut = bn.create, B = vt.create, Wn = io.create, rl = ol.create;
ro.create;
const Gn = us.create, ll = lo.create, at = co.create;
ds.create;
const un = uo.create;
mo.create;
Pn.create;
hs.create;
var sr = { exports: {} };
/*!
 * Pusher JavaScript Library v8.4.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */
var ou;
function B1() {
  return ou || (ou = 1, function(t, e) {
    (function(s, a) {
      t.exports = a();
    })(window, function() {
      return (
        /******/
        function(n) {
          var s = {};
          function a(o) {
            if (s[o])
              return s[o].exports;
            var i = s[o] = {
              /******/
              i: o,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return n[o].call(i.exports, i, i.exports, a), i.l = !0, i.exports;
          }
          return a.m = n, a.c = s, a.d = function(o, i, r) {
            a.o(o, i) || Object.defineProperty(o, i, { enumerable: !0, get: r });
          }, a.r = function(o) {
            typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
          }, a.t = function(o, i) {
            if (i & 1 && (o = a(o)), i & 8 || i & 4 && typeof o == "object" && o && o.__esModule) return o;
            var r = /* @__PURE__ */ Object.create(null);
            if (a.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: o }), i & 2 && typeof o != "string") for (var l in o) a.d(r, l, (function(u) {
              return o[u];
            }).bind(null, l));
            return r;
          }, a.n = function(o) {
            var i = o && o.__esModule ? (
              /******/
              function() {
                return o.default;
              }
            ) : (
              /******/
              function() {
                return o;
              }
            );
            return a.d(i, "a", i), i;
          }, a.o = function(o, i) {
            return Object.prototype.hasOwnProperty.call(o, i);
          }, a.p = "", a(a.s = 2);
        }([
          /* 0 */
          /***/
          function(n, s, a) {
            var o = this && this.__extends || /* @__PURE__ */ function() {
              var S = function(f, k) {
                return S = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, C) {
                  w.__proto__ = C;
                } || function(w, C) {
                  for (var M in C) C.hasOwnProperty(M) && (w[M] = C[M]);
                }, S(f, k);
              };
              return function(f, k) {
                S(f, k);
                function w() {
                  this.constructor = f;
                }
                f.prototype = k === null ? Object.create(k) : (w.prototype = k.prototype, new w());
              };
            }();
            Object.defineProperty(s, "__esModule", { value: !0 });
            var i = 256, r = (
              /** @class */
              function() {
                function S(f) {
                  f === void 0 && (f = "="), this._paddingCharacter = f;
                }
                return S.prototype.encodedLength = function(f) {
                  return this._paddingCharacter ? (f + 2) / 3 * 4 | 0 : (f * 8 + 5) / 6 | 0;
                }, S.prototype.encode = function(f) {
                  for (var k = "", w = 0; w < f.length - 2; w += 3) {
                    var C = f[w] << 16 | f[w + 1] << 8 | f[w + 2];
                    k += this._encodeByte(C >>> 3 * 6 & 63), k += this._encodeByte(C >>> 2 * 6 & 63), k += this._encodeByte(C >>> 1 * 6 & 63), k += this._encodeByte(C >>> 0 * 6 & 63);
                  }
                  var M = f.length - w;
                  if (M > 0) {
                    var C = f[w] << 16 | (M === 2 ? f[w + 1] << 8 : 0);
                    k += this._encodeByte(C >>> 3 * 6 & 63), k += this._encodeByte(C >>> 2 * 6 & 63), M === 2 ? k += this._encodeByte(C >>> 1 * 6 & 63) : k += this._paddingCharacter || "", k += this._paddingCharacter || "";
                  }
                  return k;
                }, S.prototype.maxDecodedLength = function(f) {
                  return this._paddingCharacter ? f / 4 * 3 | 0 : (f * 6 + 7) / 8 | 0;
                }, S.prototype.decodedLength = function(f) {
                  return this.maxDecodedLength(f.length - this._getPaddingLength(f));
                }, S.prototype.decode = function(f) {
                  if (f.length === 0)
                    return new Uint8Array(0);
                  for (var k = this._getPaddingLength(f), w = f.length - k, C = new Uint8Array(this.maxDecodedLength(w)), M = 0, T = 0, E = 0, U = 0, F = 0, ee = 0, Q = 0; T < w - 4; T += 4)
                    U = this._decodeChar(f.charCodeAt(T + 0)), F = this._decodeChar(f.charCodeAt(T + 1)), ee = this._decodeChar(f.charCodeAt(T + 2)), Q = this._decodeChar(f.charCodeAt(T + 3)), C[M++] = U << 2 | F >>> 4, C[M++] = F << 4 | ee >>> 2, C[M++] = ee << 6 | Q, E |= U & i, E |= F & i, E |= ee & i, E |= Q & i;
                  if (T < w - 1 && (U = this._decodeChar(f.charCodeAt(T)), F = this._decodeChar(f.charCodeAt(T + 1)), C[M++] = U << 2 | F >>> 4, E |= U & i, E |= F & i), T < w - 2 && (ee = this._decodeChar(f.charCodeAt(T + 2)), C[M++] = F << 4 | ee >>> 2, E |= ee & i), T < w - 3 && (Q = this._decodeChar(f.charCodeAt(T + 3)), C[M++] = ee << 6 | Q, E |= Q & i), E !== 0)
                    throw new Error("Base64Coder: incorrect characters for decoding");
                  return C;
                }, S.prototype._encodeByte = function(f) {
                  var k = f;
                  return k += 65, k += 25 - f >>> 8 & 6, k += 51 - f >>> 8 & -75, k += 61 - f >>> 8 & -15, k += 62 - f >>> 8 & 3, String.fromCharCode(k);
                }, S.prototype._decodeChar = function(f) {
                  var k = i;
                  return k += (42 - f & f - 44) >>> 8 & -256 + f - 43 + 62, k += (46 - f & f - 48) >>> 8 & -256 + f - 47 + 63, k += (47 - f & f - 58) >>> 8 & -256 + f - 48 + 52, k += (64 - f & f - 91) >>> 8 & -256 + f - 65 + 0, k += (96 - f & f - 123) >>> 8 & -256 + f - 97 + 26, k;
                }, S.prototype._getPaddingLength = function(f) {
                  var k = 0;
                  if (this._paddingCharacter) {
                    for (var w = f.length - 1; w >= 0 && f[w] === this._paddingCharacter; w--)
                      k++;
                    if (f.length < 4 || k > 2)
                      throw new Error("Base64Coder: incorrect padding");
                  }
                  return k;
                }, S;
              }()
            );
            s.Coder = r;
            var l = new r();
            function u(S) {
              return l.encode(S);
            }
            s.encode = u;
            function m(S) {
              return l.decode(S);
            }
            s.decode = m;
            var h = (
              /** @class */
              function(S) {
                o(f, S);
                function f() {
                  return S !== null && S.apply(this, arguments) || this;
                }
                return f.prototype._encodeByte = function(k) {
                  var w = k;
                  return w += 65, w += 25 - k >>> 8 & 6, w += 51 - k >>> 8 & -75, w += 61 - k >>> 8 & -13, w += 62 - k >>> 8 & 49, String.fromCharCode(w);
                }, f.prototype._decodeChar = function(k) {
                  var w = i;
                  return w += (44 - k & k - 46) >>> 8 & -256 + k - 45 + 62, w += (94 - k & k - 96) >>> 8 & -256 + k - 95 + 63, w += (47 - k & k - 58) >>> 8 & -256 + k - 48 + 52, w += (64 - k & k - 91) >>> 8 & -256 + k - 65 + 0, w += (96 - k & k - 123) >>> 8 & -256 + k - 97 + 26, w;
                }, f;
              }(r)
            );
            s.URLSafeCoder = h;
            var v = new h();
            function _(S) {
              return v.encode(S);
            }
            s.encodeURLSafe = _;
            function y(S) {
              return v.decode(S);
            }
            s.decodeURLSafe = y, s.encodedLength = function(S) {
              return l.encodedLength(S);
            }, s.maxDecodedLength = function(S) {
              return l.maxDecodedLength(S);
            }, s.decodedLength = function(S) {
              return l.decodedLength(S);
            };
          },
          /* 1 */
          /***/
          function(n, s, a) {
            Object.defineProperty(s, "__esModule", { value: !0 });
            var o = "utf8: invalid string", i = "utf8: invalid source encoding";
            function r(m) {
              for (var h = new Uint8Array(l(m)), v = 0, _ = 0; _ < m.length; _++) {
                var y = m.charCodeAt(_);
                y < 128 ? h[v++] = y : y < 2048 ? (h[v++] = 192 | y >> 6, h[v++] = 128 | y & 63) : y < 55296 ? (h[v++] = 224 | y >> 12, h[v++] = 128 | y >> 6 & 63, h[v++] = 128 | y & 63) : (_++, y = (y & 1023) << 10, y |= m.charCodeAt(_) & 1023, y += 65536, h[v++] = 240 | y >> 18, h[v++] = 128 | y >> 12 & 63, h[v++] = 128 | y >> 6 & 63, h[v++] = 128 | y & 63);
              }
              return h;
            }
            s.encode = r;
            function l(m) {
              for (var h = 0, v = 0; v < m.length; v++) {
                var _ = m.charCodeAt(v);
                if (_ < 128)
                  h += 1;
                else if (_ < 2048)
                  h += 2;
                else if (_ < 55296)
                  h += 3;
                else if (_ <= 57343) {
                  if (v >= m.length - 1)
                    throw new Error(o);
                  v++, h += 4;
                } else
                  throw new Error(o);
              }
              return h;
            }
            s.encodedLength = l;
            function u(m) {
              for (var h = [], v = 0; v < m.length; v++) {
                var _ = m[v];
                if (_ & 128) {
                  var y = void 0;
                  if (_ < 224) {
                    if (v >= m.length)
                      throw new Error(i);
                    var S = m[++v];
                    if ((S & 192) !== 128)
                      throw new Error(i);
                    _ = (_ & 31) << 6 | S & 63, y = 128;
                  } else if (_ < 240) {
                    if (v >= m.length - 1)
                      throw new Error(i);
                    var S = m[++v], f = m[++v];
                    if ((S & 192) !== 128 || (f & 192) !== 128)
                      throw new Error(i);
                    _ = (_ & 15) << 12 | (S & 63) << 6 | f & 63, y = 2048;
                  } else if (_ < 248) {
                    if (v >= m.length - 2)
                      throw new Error(i);
                    var S = m[++v], f = m[++v], k = m[++v];
                    if ((S & 192) !== 128 || (f & 192) !== 128 || (k & 192) !== 128)
                      throw new Error(i);
                    _ = (_ & 15) << 18 | (S & 63) << 12 | (f & 63) << 6 | k & 63, y = 65536;
                  } else
                    throw new Error(i);
                  if (_ < y || _ >= 55296 && _ <= 57343)
                    throw new Error(i);
                  if (_ >= 65536) {
                    if (_ > 1114111)
                      throw new Error(i);
                    _ -= 65536, h.push(String.fromCharCode(55296 | _ >> 10)), _ = 56320 | _ & 1023;
                  }
                }
                h.push(String.fromCharCode(_));
              }
              return h.join("");
            }
            s.decode = u;
          },
          /* 2 */
          /***/
          function(n, s, a) {
            n.exports = a(3).default;
          },
          /* 3 */
          /***/
          function(n, s, a) {
            a.r(s);
            class o {
              constructor(d, p) {
                this.lastId = 0, this.prefix = d, this.name = p;
              }
              create(d) {
                this.lastId++;
                var p = this.lastId, A = this.prefix + p, z = this.name + "[" + p + "]", G = !1, oe = function() {
                  G || (d.apply(null, arguments), G = !0);
                };
                return this[p] = oe, { number: p, id: A, name: z, callback: oe };
              }
              remove(d) {
                delete this[d.number];
              }
            }
            var i = new o("_pusher_script_", "Pusher.ScriptReceivers"), r = {
              VERSION: "8.4.0",
              PROTOCOL: 7,
              wsPort: 80,
              wssPort: 443,
              wsPath: "",
              httpHost: "sockjs.pusher.com",
              httpPort: 80,
              httpsPort: 443,
              httpPath: "/pusher",
              stats_host: "stats.pusher.com",
              authEndpoint: "/pusher/auth",
              authTransport: "ajax",
              activityTimeout: 12e4,
              pongTimeout: 3e4,
              unavailableTimeout: 1e4,
              userAuthentication: {
                endpoint: "/pusher/user-auth",
                transport: "ajax"
              },
              channelAuthorization: {
                endpoint: "/pusher/auth",
                transport: "ajax"
              },
              cdn_http: "http://js.pusher.com",
              cdn_https: "https://js.pusher.com",
              dependency_suffix: ""
            }, l = r;
            class u {
              constructor(d) {
                this.options = d, this.receivers = d.receivers || i, this.loading = {};
              }
              load(d, p, A) {
                var z = this;
                if (z.loading[d] && z.loading[d].length > 0)
                  z.loading[d].push(A);
                else {
                  z.loading[d] = [A];
                  var G = Ee.createScriptRequest(z.getPath(d, p)), oe = z.receivers.create(function(ve) {
                    if (z.receivers.remove(oe), z.loading[d]) {
                      var ze = z.loading[d];
                      delete z.loading[d];
                      for (var Qe = function(ft) {
                        ft || G.cleanup();
                      }, Ke = 0; Ke < ze.length; Ke++)
                        ze[Ke](ve, Qe);
                    }
                  });
                  G.send(oe);
                }
              }
              getRoot(d) {
                var p, A = Ee.getDocument().location.protocol;
                return d && d.useTLS || A === "https:" ? p = this.options.cdn_https : p = this.options.cdn_http, p.replace(/\/*$/, "") + "/" + this.options.version;
              }
              getPath(d, p) {
                return this.getRoot(p) + "/" + d + this.options.suffix + ".js";
              }
            }
            var m = new o("_pusher_dependencies", "Pusher.DependenciesReceivers"), h = new u({
              cdn_http: l.cdn_http,
              cdn_https: l.cdn_https,
              version: l.VERSION,
              suffix: l.dependency_suffix,
              receivers: m
            });
            const v = {
              baseUrl: "https://pusher.com",
              urls: {
                authenticationEndpoint: {
                  path: "/docs/channels/server_api/authenticating_users"
                },
                authorizationEndpoint: {
                  path: "/docs/channels/server_api/authorizing-users/"
                },
                javascriptQuickStart: {
                  path: "/docs/javascript_quick_start"
                },
                triggeringClientEvents: {
                  path: "/docs/client_api_guide/client_events#trigger-events"
                },
                encryptedChannelSupport: {
                  fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
                }
              }
            };
            var y = { buildLogSuffix: function(g) {
              const d = "See:", p = v.urls[g];
              if (!p)
                return "";
              let A;
              return p.fullUrl ? A = p.fullUrl : p.path && (A = v.baseUrl + p.path), A ? `${d} ${A}` : "";
            } }, S;
            (function(g) {
              g.UserAuthentication = "user-authentication", g.ChannelAuthorization = "channel-authorization";
            })(S || (S = {}));
            class f extends Error {
              constructor(d) {
                super(d), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class k extends Error {
              constructor(d) {
                super(d), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class w extends Error {
              constructor(d) {
                super(d), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class C extends Error {
              constructor(d) {
                super(d), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class M extends Error {
              constructor(d) {
                super(d), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class T extends Error {
              constructor(d) {
                super(d), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class E extends Error {
              constructor(d) {
                super(d), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class U extends Error {
              constructor(d) {
                super(d), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class F extends Error {
              constructor(d, p) {
                super(p), this.status = d, Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            var Q = function(g, d, p, A, z) {
              const G = Ee.createXHR();
              G.open("POST", p.endpoint, !0), G.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
              for (var oe in p.headers)
                G.setRequestHeader(oe, p.headers[oe]);
              if (p.headersProvider != null) {
                let ve = p.headersProvider();
                for (var oe in ve)
                  G.setRequestHeader(oe, ve[oe]);
              }
              return G.onreadystatechange = function() {
                if (G.readyState === 4)
                  if (G.status === 200) {
                    let ve, ze = !1;
                    try {
                      ve = JSON.parse(G.responseText), ze = !0;
                    } catch {
                      z(new F(200, `JSON returned from ${A.toString()} endpoint was invalid, yet status code was 200. Data was: ${G.responseText}`), null);
                    }
                    ze && z(null, ve);
                  } else {
                    let ve = "";
                    switch (A) {
                      case S.UserAuthentication:
                        ve = y.buildLogSuffix("authenticationEndpoint");
                        break;
                      case S.ChannelAuthorization:
                        ve = `Clients must be authorized to join private or presence channels. ${y.buildLogSuffix("authorizationEndpoint")}`;
                        break;
                    }
                    z(new F(G.status, `Unable to retrieve auth string from ${A.toString()} endpoint - received status: ${G.status} from ${p.endpoint}. ${ve}`), null);
                  }
              }, G.send(d), G;
            };
            function se(g) {
              return te(he(g));
            }
            var W = String.fromCharCode, Y = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", me = function(g) {
              var d = g.charCodeAt(0);
              return d < 128 ? g : d < 2048 ? W(192 | d >>> 6) + W(128 | d & 63) : W(224 | d >>> 12 & 15) + W(128 | d >>> 6 & 63) + W(128 | d & 63);
            }, he = function(g) {
              return g.replace(/[^\x00-\x7F]/g, me);
            }, _e = function(g) {
              var d = [0, 2, 1][g.length % 3], p = g.charCodeAt(0) << 16 | (g.length > 1 ? g.charCodeAt(1) : 0) << 8 | (g.length > 2 ? g.charCodeAt(2) : 0), A = [
                Y.charAt(p >>> 18),
                Y.charAt(p >>> 12 & 63),
                d >= 2 ? "=" : Y.charAt(p >>> 6 & 63),
                d >= 1 ? "=" : Y.charAt(p & 63)
              ];
              return A.join("");
            }, te = window.btoa || function(g) {
              return g.replace(/[\s\S]{1,3}/g, _e);
            };
            class J {
              constructor(d, p, A, z) {
                this.clear = p, this.timer = d(() => {
                  this.timer && (this.timer = z(this.timer));
                }, A);
              }
              isRunning() {
                return this.timer !== null;
              }
              ensureAborted() {
                this.timer && (this.clear(this.timer), this.timer = null);
              }
            }
            var de = J;
            function ke(g) {
              window.clearTimeout(g);
            }
            function Te(g) {
              window.clearInterval(g);
            }
            class Ve extends de {
              constructor(d, p) {
                super(setTimeout, ke, d, function(A) {
                  return p(), null;
                });
              }
            }
            class nt extends de {
              constructor(d, p) {
                super(setInterval, Te, d, function(A) {
                  return p(), A;
                });
              }
            }
            var Pe = {
              now() {
                return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).valueOf();
              },
              defer(g) {
                return new Ve(0, g);
              },
              method(g, ...d) {
                var p = Array.prototype.slice.call(arguments, 1);
                return function(A) {
                  return A[g].apply(A, p.concat(arguments));
                };
              }
            }, ae = Pe;
            function pe(g, ...d) {
              for (var p = 0; p < d.length; p++) {
                var A = d[p];
                for (var z in A)
                  A[z] && A[z].constructor && A[z].constructor === Object ? g[z] = pe(g[z] || {}, A[z]) : g[z] = A[z];
              }
              return g;
            }
            function rt() {
              for (var g = ["Pusher"], d = 0; d < arguments.length; d++)
                typeof arguments[d] == "string" ? g.push(arguments[d]) : g.push(dn(arguments[d]));
              return g.join(" : ");
            }
            function st(g, d) {
              var p = Array.prototype.indexOf;
              if (g === null)
                return -1;
              if (p && g.indexOf === p)
                return g.indexOf(d);
              for (var A = 0, z = g.length; A < z; A++)
                if (g[A] === d)
                  return A;
              return -1;
            }
            function we(g, d) {
              for (var p in g)
                Object.prototype.hasOwnProperty.call(g, p) && d(g[p], p, g);
            }
            function Ce(g) {
              var d = [];
              return we(g, function(p, A) {
                d.push(A);
              }), d;
            }
            function Je(g) {
              var d = [];
              return we(g, function(p) {
                d.push(p);
              }), d;
            }
            function Ue(g, d, p) {
              for (var A = 0; A < g.length; A++)
                d.call(p || window, g[A], A, g);
            }
            function Ye(g, d) {
              for (var p = [], A = 0; A < g.length; A++)
                p.push(d(g[A], A, g, p));
              return p;
            }
            function lt(g, d) {
              var p = {};
              return we(g, function(A, z) {
                p[z] = d(A);
              }), p;
            }
            function gt(g, d) {
              d = d || function(z) {
                return !!z;
              };
              for (var p = [], A = 0; A < g.length; A++)
                d(g[A], A, g, p) && p.push(g[A]);
              return p;
            }
            function ct(g, d) {
              var p = {};
              return we(g, function(A, z) {
                (d && d(A, z, g, p) || A) && (p[z] = A);
              }), p;
            }
            function Ct(g) {
              var d = [];
              return we(g, function(p, A) {
                d.push([A, p]);
              }), d;
            }
            function Lt(g, d) {
              for (var p = 0; p < g.length; p++)
                if (d(g[p], p, g))
                  return !0;
              return !1;
            }
            function Mn(g, d) {
              for (var p = 0; p < g.length; p++)
                if (!d(g[p], p, g))
                  return !1;
              return !0;
            }
            function vn(g) {
              return lt(g, function(d) {
                return typeof d == "object" && (d = dn(d)), encodeURIComponent(se(d.toString()));
              });
            }
            function Xt(g) {
              var d = ct(g, function(A) {
                return A !== void 0;
              }), p = Ye(Ct(vn(d)), ae.method("join", "=")).join("&");
              return p;
            }
            function Tn(g) {
              var d = [], p = [];
              return function A(z, G) {
                var oe, ve, ze;
                switch (typeof z) {
                  case "object":
                    if (!z)
                      return null;
                    for (oe = 0; oe < d.length; oe += 1)
                      if (d[oe] === z)
                        return { $ref: p[oe] };
                    if (d.push(z), p.push(G), Object.prototype.toString.apply(z) === "[object Array]")
                      for (ze = [], oe = 0; oe < z.length; oe += 1)
                        ze[oe] = A(z[oe], G + "[" + oe + "]");
                    else {
                      ze = {};
                      for (ve in z)
                        Object.prototype.hasOwnProperty.call(z, ve) && (ze[ve] = A(z[ve], G + "[" + JSON.stringify(ve) + "]"));
                    }
                    return ze;
                  case "number":
                  case "string":
                  case "boolean":
                    return z;
                }
              }(g, "$");
            }
            function dn(g) {
              try {
                return JSON.stringify(g);
              } catch {
                return JSON.stringify(Tn(g));
              }
            }
            class zn {
              constructor() {
                this.globalLog = (d) => {
                  window.console && window.console.log && window.console.log(d);
                };
              }
              debug(...d) {
                this.log(this.globalLog, d);
              }
              warn(...d) {
                this.log(this.globalLogWarn, d);
              }
              error(...d) {
                this.log(this.globalLogError, d);
              }
              globalLogWarn(d) {
                window.console && window.console.warn ? window.console.warn(d) : this.globalLog(d);
              }
              globalLogError(d) {
                window.console && window.console.error ? window.console.error(d) : this.globalLogWarn(d);
              }
              log(d, ...p) {
                var A = rt.apply(this, arguments);
                ii.log ? ii.log(A) : ii.logToConsole && d.bind(this)(A);
              }
            }
            var et = new zn(), Xo = function(g, d, p, A, z) {
              (p.headers !== void 0 || p.headersProvider != null) && et.warn(`To send headers with the ${A.toString()} request, you must use AJAX, rather than JSONP.`);
              var G = g.nextAuthCallbackID.toString();
              g.nextAuthCallbackID++;
              var oe = g.getDocument(), ve = oe.createElement("script");
              g.auth_callbacks[G] = function(Ke) {
                z(null, Ke);
              };
              var ze = "Pusher.auth_callbacks['" + G + "']";
              ve.src = p.endpoint + "?callback=" + encodeURIComponent(ze) + "&" + d;
              var Qe = oe.getElementsByTagName("head")[0] || oe.documentElement;
              Qe.insertBefore(ve, Qe.firstChild);
            }, za = Xo;
            class Ko {
              constructor(d) {
                this.src = d;
              }
              send(d) {
                var p = this, A = "Error loading " + p.src;
                p.script = document.createElement("script"), p.script.id = d.id, p.script.src = p.src, p.script.type = "text/javascript", p.script.charset = "UTF-8", p.script.addEventListener ? (p.script.onerror = function() {
                  d.callback(A);
                }, p.script.onload = function() {
                  d.callback(null);
                }) : p.script.onreadystatechange = function() {
                  (p.script.readyState === "loaded" || p.script.readyState === "complete") && d.callback(null);
                }, p.script.async === void 0 && document.attachEvent && /opera/i.test(navigator.userAgent) ? (p.errorScript = document.createElement("script"), p.errorScript.id = d.id + "_error", p.errorScript.text = d.name + "('" + A + "');", p.script.async = p.errorScript.async = !1) : p.script.async = !0;
                var z = document.getElementsByTagName("head")[0];
                z.insertBefore(p.script, z.firstChild), p.errorScript && z.insertBefore(p.errorScript, p.script.nextSibling);
              }
              cleanup() {
                this.script && (this.script.onload = this.script.onerror = null, this.script.onreadystatechange = null), this.script && this.script.parentNode && this.script.parentNode.removeChild(this.script), this.errorScript && this.errorScript.parentNode && this.errorScript.parentNode.removeChild(this.errorScript), this.script = null, this.errorScript = null;
              }
            }
            class Zn {
              constructor(d, p) {
                this.url = d, this.data = p;
              }
              send(d) {
                if (!this.request) {
                  var p = Xt(this.data), A = this.url + "/" + d.number + "?" + p;
                  this.request = Ee.createScriptRequest(A), this.request.send(d);
                }
              }
              cleanup() {
                this.request && this.request.cleanup();
              }
            }
            var Hs = function(g, d) {
              return function(p, A) {
                var z = "http" + (d ? "s" : "") + "://", G = z + (g.host || g.options.host) + g.options.path, oe = Ee.createJSONPRequest(G, p), ve = Ee.ScriptReceivers.create(function(ze, Qe) {
                  i.remove(ve), oe.cleanup(), Qe && Qe.host && (g.host = Qe.host), A && A(ze, Qe);
                });
                oe.send(ve);
              };
            }, Ea = {
              name: "jsonp",
              getAgent: Hs
            }, Jo = Ea;
            function Ws(g, d, p) {
              var A = g + (d.useTLS ? "s" : ""), z = d.useTLS ? d.hostTLS : d.hostNonTLS;
              return A + "://" + z + p;
            }
            function Qn(g, d) {
              var p = "/app/" + g, A = "?protocol=" + l.PROTOCOL + "&client=js&version=" + l.VERSION + (d ? "&" + d : "");
              return p + A;
            }
            var ks = {
              getInitial: function(g, d) {
                var p = (d.httpPath || "") + Qn(g, "flash=false");
                return Ws("ws", d, p);
              }
            }, j = {
              getInitial: function(g, d) {
                var p = (d.httpPath || "/pusher") + Qn(g);
                return Ws("http", d, p);
              }
            }, q = {
              getInitial: function(g, d) {
                return Ws("http", d, d.httpPath || "/pusher");
              },
              getPath: function(g, d) {
                return Qn(g);
              }
            };
            class qe {
              constructor() {
                this._callbacks = {};
              }
              get(d) {
                return this._callbacks[Xe(d)];
              }
              add(d, p, A) {
                var z = Xe(d);
                this._callbacks[z] = this._callbacks[z] || [], this._callbacks[z].push({
                  fn: p,
                  context: A
                });
              }
              remove(d, p, A) {
                if (!d && !p && !A) {
                  this._callbacks = {};
                  return;
                }
                var z = d ? [Xe(d)] : Ce(this._callbacks);
                p || A ? this.removeCallback(z, p, A) : this.removeAllCallbacks(z);
              }
              removeCallback(d, p, A) {
                Ue(d, function(z) {
                  this._callbacks[z] = gt(this._callbacks[z] || [], function(G) {
                    return p && p !== G.fn || A && A !== G.context;
                  }), this._callbacks[z].length === 0 && delete this._callbacks[z];
                }, this);
              }
              removeAllCallbacks(d) {
                Ue(d, function(p) {
                  delete this._callbacks[p];
                }, this);
              }
            }
            function Xe(g) {
              return "_" + g;
            }
            class Fe {
              constructor(d) {
                this.callbacks = new qe(), this.global_callbacks = [], this.failThrough = d;
              }
              bind(d, p, A) {
                return this.callbacks.add(d, p, A), this;
              }
              bind_global(d) {
                return this.global_callbacks.push(d), this;
              }
              unbind(d, p, A) {
                return this.callbacks.remove(d, p, A), this;
              }
              unbind_global(d) {
                return d ? (this.global_callbacks = gt(this.global_callbacks || [], (p) => p !== d), this) : (this.global_callbacks = [], this);
              }
              unbind_all() {
                return this.unbind(), this.unbind_global(), this;
              }
              emit(d, p, A) {
                for (var z = 0; z < this.global_callbacks.length; z++)
                  this.global_callbacks[z](d, p);
                var G = this.callbacks.get(d), oe = [];
                if (A ? oe.push(p, A) : p && oe.push(p), G && G.length > 0)
                  for (var z = 0; z < G.length; z++)
                    G[z].fn.apply(G[z].context || window, oe);
                else this.failThrough && this.failThrough(d, p);
                return this;
              }
            }
            class Re extends Fe {
              constructor(d, p, A, z, G) {
                super(), this.initialize = Ee.transportConnectionInitializer, this.hooks = d, this.name = p, this.priority = A, this.key = z, this.options = G, this.state = "new", this.timeline = G.timeline, this.activityTimeout = G.activityTimeout, this.id = this.timeline.generateUniqueID();
              }
              handlesActivityChecks() {
                return !!this.hooks.handlesActivityChecks;
              }
              supportsPing() {
                return !!this.hooks.supportsPing;
              }
              connect() {
                if (this.socket || this.state !== "initialized")
                  return !1;
                var d = this.hooks.urls.getInitial(this.key, this.options);
                try {
                  this.socket = this.hooks.getSocket(d, this.options);
                } catch (p) {
                  return ae.defer(() => {
                    this.onError(p), this.changeState("closed");
                  }), !1;
                }
                return this.bindListeners(), et.debug("Connecting", { transport: this.name, url: d }), this.changeState("connecting"), !0;
              }
              close() {
                return this.socket ? (this.socket.close(), !0) : !1;
              }
              send(d) {
                return this.state === "open" ? (ae.defer(() => {
                  this.socket && this.socket.send(d);
                }), !0) : !1;
              }
              ping() {
                this.state === "open" && this.supportsPing() && this.socket.ping();
              }
              onOpen() {
                this.hooks.beforeOpen && this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options)), this.changeState("open"), this.socket.onopen = void 0;
              }
              onError(d) {
                this.emit("error", { type: "WebSocketError", error: d }), this.timeline.error(this.buildTimelineMessage({ error: d.toString() }));
              }
              onClose(d) {
                d ? this.changeState("closed", {
                  code: d.code,
                  reason: d.reason,
                  wasClean: d.wasClean
                }) : this.changeState("closed"), this.unbindListeners(), this.socket = void 0;
              }
              onMessage(d) {
                this.emit("message", d);
              }
              onActivity() {
                this.emit("activity");
              }
              bindListeners() {
                this.socket.onopen = () => {
                  this.onOpen();
                }, this.socket.onerror = (d) => {
                  this.onError(d);
                }, this.socket.onclose = (d) => {
                  this.onClose(d);
                }, this.socket.onmessage = (d) => {
                  this.onMessage(d);
                }, this.supportsPing() && (this.socket.onactivity = () => {
                  this.onActivity();
                });
              }
              unbindListeners() {
                this.socket && (this.socket.onopen = void 0, this.socket.onerror = void 0, this.socket.onclose = void 0, this.socket.onmessage = void 0, this.supportsPing() && (this.socket.onactivity = void 0));
              }
              changeState(d, p) {
                this.state = d, this.timeline.info(this.buildTimelineMessage({
                  state: d,
                  params: p
                })), this.emit(d, p);
              }
              buildTimelineMessage(d) {
                return pe({ cid: this.id }, d);
              }
            }
            class Dt {
              constructor(d) {
                this.hooks = d;
              }
              isSupported(d) {
                return this.hooks.isSupported(d);
              }
              createConnection(d, p, A, z) {
                return new Re(this.hooks, d, p, A, z);
              }
            }
            var $n = new Dt({
              urls: ks,
              handlesActivityChecks: !1,
              supportsPing: !1,
              isInitialized: function() {
                return !!Ee.getWebSocketAPI();
              },
              isSupported: function() {
                return !!Ee.getWebSocketAPI();
              },
              getSocket: function(g) {
                return Ee.createWebSocket(g);
              }
            }), Pt = {
              urls: j,
              handlesActivityChecks: !1,
              supportsPing: !0,
              isInitialized: function() {
                return !0;
              }
            }, mn = pe({
              getSocket: function(g) {
                return Ee.HTTPFactory.createStreamingSocket(g);
              }
            }, Pt), ys = pe({
              getSocket: function(g) {
                return Ee.HTTPFactory.createPollingSocket(g);
              }
            }, Pt), Sn = {
              isSupported: function() {
                return Ee.isXHRSupported();
              }
            }, Kt = new Dt(pe({}, mn, Sn)), Oa = new Dt(pe({}, ys, Sn)), Ra = {
              ws: $n,
              xhr_streaming: Kt,
              xhr_polling: Oa
            }, Xn = Ra, Kn = new Dt({
              file: "sockjs",
              urls: q,
              handlesActivityChecks: !0,
              supportsPing: !1,
              isSupported: function() {
                return !0;
              },
              isInitialized: function() {
                return window.SockJS !== void 0;
              },
              getSocket: function(g, d) {
                return new window.SockJS(g, null, {
                  js_path: h.getPath("sockjs", {
                    useTLS: d.useTLS
                  }),
                  ignore_null_origin: d.ignoreNullOrigin
                });
              },
              beforeOpen: function(g, d) {
                g.send(JSON.stringify({
                  path: d
                }));
              }
            }), bs = {
              isSupported: function(g) {
                var d = Ee.isXDRSupported(g.useTLS);
                return d;
              }
            }, ws = new Dt(pe({}, mn, bs)), Gs = new Dt(pe({}, ys, bs));
            Xn.xdr_streaming = ws, Xn.xdr_polling = Gs, Xn.sockjs = Kn;
            var Zs = Xn;
            class La extends Fe {
              constructor() {
                super();
                var d = this;
                window.addEventListener !== void 0 && (window.addEventListener("online", function() {
                  d.emit("online");
                }, !1), window.addEventListener("offline", function() {
                  d.emit("offline");
                }, !1));
              }
              isOnline() {
                return window.navigator.onLine === void 0 ? !0 : window.navigator.onLine;
              }
            }
            var Da = new La();
            class Qs {
              constructor(d, p, A) {
                this.manager = d, this.transport = p, this.minPingDelay = A.minPingDelay, this.maxPingDelay = A.maxPingDelay, this.pingDelay = void 0;
              }
              createConnection(d, p, A, z) {
                z = pe({}, z, {
                  activityTimeout: this.pingDelay
                });
                var G = this.transport.createConnection(d, p, A, z), oe = null, ve = function() {
                  G.unbind("open", ve), G.bind("closed", ze), oe = ae.now();
                }, ze = (Qe) => {
                  if (G.unbind("closed", ze), Qe.code === 1002 || Qe.code === 1003)
                    this.manager.reportDeath();
                  else if (!Qe.wasClean && oe) {
                    var Ke = ae.now() - oe;
                    Ke < 2 * this.maxPingDelay && (this.manager.reportDeath(), this.pingDelay = Math.max(Ke / 2, this.minPingDelay));
                  }
                };
                return G.bind("open", ve), G;
              }
              isSupported(d) {
                return this.manager.isAlive() && this.transport.isSupported(d);
              }
            }
            const Xs = {
              decodeMessage: function(g) {
                try {
                  var d = JSON.parse(g.data), p = d.data;
                  if (typeof p == "string")
                    try {
                      p = JSON.parse(d.data);
                    } catch {
                    }
                  var A = {
                    event: d.event,
                    channel: d.channel,
                    data: p
                  };
                  return d.user_id && (A.user_id = d.user_id), A;
                } catch (z) {
                  throw { type: "MessageParseError", error: z, data: g.data };
                }
              },
              encodeMessage: function(g) {
                return JSON.stringify(g);
              },
              processHandshake: function(g) {
                var d = Xs.decodeMessage(g);
                if (d.event === "pusher:connection_established") {
                  if (!d.data.activity_timeout)
                    throw "No activity timeout specified in handshake";
                  return {
                    action: "connected",
                    id: d.data.socket_id,
                    activityTimeout: d.data.activity_timeout * 1e3
                  };
                } else {
                  if (d.event === "pusher:error")
                    return {
                      action: this.getCloseAction(d.data),
                      error: this.getCloseError(d.data)
                    };
                  throw "Invalid handshake";
                }
              },
              getCloseAction: function(g) {
                return g.code < 4e3 ? g.code >= 1002 && g.code <= 1004 ? "backoff" : null : g.code === 4e3 ? "tls_only" : g.code < 4100 ? "refused" : g.code < 4200 ? "backoff" : g.code < 4300 ? "retry" : "refused";
              },
              getCloseError: function(g) {
                return g.code !== 1e3 && g.code !== 1001 ? {
                  type: "PusherError",
                  data: {
                    code: g.code,
                    message: g.reason || g.message
                  }
                } : null;
              }
            };
            var hn = Xs;
            class Na extends Fe {
              constructor(d, p) {
                super(), this.id = d, this.transport = p, this.activityTimeout = p.activityTimeout, this.bindListeners();
              }
              handlesActivityChecks() {
                return this.transport.handlesActivityChecks();
              }
              send(d) {
                return this.transport.send(d);
              }
              send_event(d, p, A) {
                var z = { event: d, data: p };
                return A && (z.channel = A), et.debug("Event sent", z), this.send(hn.encodeMessage(z));
              }
              ping() {
                this.transport.supportsPing() ? this.transport.ping() : this.send_event("pusher:ping", {});
              }
              close() {
                this.transport.close();
              }
              bindListeners() {
                var d = {
                  message: (A) => {
                    var z;
                    try {
                      z = hn.decodeMessage(A);
                    } catch (G) {
                      this.emit("error", {
                        type: "MessageParseError",
                        error: G,
                        data: A.data
                      });
                    }
                    if (z !== void 0) {
                      switch (et.debug("Event recd", z), z.event) {
                        case "pusher:error":
                          this.emit("error", {
                            type: "PusherError",
                            data: z.data
                          });
                          break;
                        case "pusher:ping":
                          this.emit("ping");
                          break;
                        case "pusher:pong":
                          this.emit("pong");
                          break;
                      }
                      this.emit("message", z);
                    }
                  },
                  activity: () => {
                    this.emit("activity");
                  },
                  error: (A) => {
                    this.emit("error", A);
                  },
                  closed: (A) => {
                    p(), A && A.code && this.handleCloseEvent(A), this.transport = null, this.emit("closed");
                  }
                }, p = () => {
                  we(d, (A, z) => {
                    this.transport.unbind(z, A);
                  });
                };
                we(d, (A, z) => {
                  this.transport.bind(z, A);
                });
              }
              handleCloseEvent(d) {
                var p = hn.getCloseAction(d), A = hn.getCloseError(d);
                A && this.emit("error", A), p && this.emit(p, { action: p, error: A });
              }
            }
            class Yo {
              constructor(d, p) {
                this.transport = d, this.callback = p, this.bindListeners();
              }
              close() {
                this.unbindListeners(), this.transport.close();
              }
              bindListeners() {
                this.onMessage = (d) => {
                  this.unbindListeners();
                  var p;
                  try {
                    p = hn.processHandshake(d);
                  } catch (A) {
                    this.finish("error", { error: A }), this.transport.close();
                    return;
                  }
                  p.action === "connected" ? this.finish("connected", {
                    connection: new Na(p.id, this.transport),
                    activityTimeout: p.activityTimeout
                  }) : (this.finish(p.action, { error: p.error }), this.transport.close());
                }, this.onClosed = (d) => {
                  this.unbindListeners();
                  var p = hn.getCloseAction(d) || "backoff", A = hn.getCloseError(d);
                  this.finish(p, { error: A });
                }, this.transport.bind("message", this.onMessage), this.transport.bind("closed", this.onClosed);
              }
              unbindListeners() {
                this.transport.unbind("message", this.onMessage), this.transport.unbind("closed", this.onClosed);
              }
              finish(d, p) {
                this.callback(pe({ transport: this.transport, action: d }, p));
              }
            }
            class Ks {
              constructor(d, p) {
                this.timeline = d, this.options = p || {};
              }
              send(d, p) {
                this.timeline.isEmpty() || this.timeline.send(Ee.TimelineTransport.getAgent(this, d), p);
              }
            }
            class gn extends Fe {
              constructor(d, p) {
                super(function(A, z) {
                  et.debug("No callbacks on " + d + " for " + A);
                }), this.name = d, this.pusher = p, this.subscribed = !1, this.subscriptionPending = !1, this.subscriptionCancelled = !1;
              }
              authorize(d, p) {
                return p(null, { auth: "" });
              }
              trigger(d, p) {
                if (d.indexOf("client-") !== 0)
                  throw new f("Event '" + d + "' does not start with 'client-'");
                if (!this.subscribed) {
                  var A = y.buildLogSuffix("triggeringClientEvents");
                  et.warn(`Client event triggered before channel 'subscription_succeeded' event . ${A}`);
                }
                return this.pusher.send_event(d, p, this.name);
              }
              disconnect() {
                this.subscribed = !1, this.subscriptionPending = !1;
              }
              handleEvent(d) {
                var p = d.event, A = d.data;
                if (p === "pusher_internal:subscription_succeeded")
                  this.handleSubscriptionSucceededEvent(d);
                else if (p === "pusher_internal:subscription_count")
                  this.handleSubscriptionCountEvent(d);
                else if (p.indexOf("pusher_internal:") !== 0) {
                  var z = {};
                  this.emit(p, A, z);
                }
              }
              handleSubscriptionSucceededEvent(d) {
                this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : this.emit("pusher:subscription_succeeded", d.data);
              }
              handleSubscriptionCountEvent(d) {
                d.data.subscription_count && (this.subscriptionCount = d.data.subscription_count), this.emit("pusher:subscription_count", d.data);
              }
              subscribe() {
                this.subscribed || (this.subscriptionPending = !0, this.subscriptionCancelled = !1, this.authorize(this.pusher.connection.socket_id, (d, p) => {
                  d ? (this.subscriptionPending = !1, et.error(d.toString()), this.emit("pusher:subscription_error", Object.assign({}, {
                    type: "AuthError",
                    error: d.message
                  }, d instanceof F ? { status: d.status } : {}))) : this.pusher.send_event("pusher:subscribe", {
                    auth: p.auth,
                    channel_data: p.channel_data,
                    channel: this.name
                  });
                }));
              }
              unsubscribe() {
                this.subscribed = !1, this.pusher.send_event("pusher:unsubscribe", {
                  channel: this.name
                });
              }
              cancelSubscription() {
                this.subscriptionCancelled = !0;
              }
              reinstateSubscription() {
                this.subscriptionCancelled = !1;
              }
            }
            class En extends gn {
              authorize(d, p) {
                return this.pusher.config.channelAuthorizer({
                  channelName: this.name,
                  socketId: d
                }, p);
              }
            }
            class ei {
              constructor() {
                this.reset();
              }
              get(d) {
                return Object.prototype.hasOwnProperty.call(this.members, d) ? {
                  id: d,
                  info: this.members[d]
                } : null;
              }
              each(d) {
                we(this.members, (p, A) => {
                  d(this.get(A));
                });
              }
              setMyID(d) {
                this.myID = d;
              }
              onSubscription(d) {
                this.members = d.presence.hash, this.count = d.presence.count, this.me = this.get(this.myID);
              }
              addMember(d) {
                return this.get(d.user_id) === null && this.count++, this.members[d.user_id] = d.user_info, this.get(d.user_id);
              }
              removeMember(d) {
                var p = this.get(d.user_id);
                return p && (delete this.members[d.user_id], this.count--), p;
              }
              reset() {
                this.members = {}, this.count = 0, this.myID = null, this.me = null;
              }
            }
            var Va = function(g, d, p, A) {
              function z(G) {
                return G instanceof p ? G : new p(function(oe) {
                  oe(G);
                });
              }
              return new (p || (p = Promise))(function(G, oe) {
                function ve(Ke) {
                  try {
                    Qe(A.next(Ke));
                  } catch (ft) {
                    oe(ft);
                  }
                }
                function ze(Ke) {
                  try {
                    Qe(A.throw(Ke));
                  } catch (ft) {
                    oe(ft);
                  }
                }
                function Qe(Ke) {
                  Ke.done ? G(Ke.value) : z(Ke.value).then(ve, ze);
                }
                Qe((A = A.apply(g, d || [])).next());
              });
            };
            class dh extends En {
              constructor(d, p) {
                super(d, p), this.members = new ei();
              }
              authorize(d, p) {
                super.authorize(d, (A, z) => Va(this, void 0, void 0, function* () {
                  if (!A)
                    if (z = z, z.channel_data != null) {
                      var G = JSON.parse(z.channel_data);
                      this.members.setMyID(G.user_id);
                    } else if (yield this.pusher.user.signinDonePromise, this.pusher.user.user_data != null)
                      this.members.setMyID(this.pusher.user.user_data.id);
                    else {
                      let oe = y.buildLogSuffix("authorizationEndpoint");
                      et.error(`Invalid auth response for channel '${this.name}', expected 'channel_data' field. ${oe}, or the user should be signed in.`), p("Invalid auth response");
                      return;
                    }
                  p(A, z);
                }));
              }
              handleEvent(d) {
                var p = d.event;
                if (p.indexOf("pusher_internal:") === 0)
                  this.handleInternalEvent(d);
                else {
                  var A = d.data, z = {};
                  d.user_id && (z.user_id = d.user_id), this.emit(p, A, z);
                }
              }
              handleInternalEvent(d) {
                var p = d.event, A = d.data;
                switch (p) {
                  case "pusher_internal:subscription_succeeded":
                    this.handleSubscriptionSucceededEvent(d);
                    break;
                  case "pusher_internal:subscription_count":
                    this.handleSubscriptionCountEvent(d);
                    break;
                  case "pusher_internal:member_added":
                    var z = this.members.addMember(A);
                    this.emit("pusher:member_added", z);
                    break;
                  case "pusher_internal:member_removed":
                    var G = this.members.removeMember(A);
                    G && this.emit("pusher:member_removed", G);
                    break;
                }
              }
              handleSubscriptionSucceededEvent(d) {
                this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : (this.members.onSubscription(d.data), this.emit("pusher:subscription_succeeded", this.members));
              }
              disconnect() {
                this.members.reset(), super.disconnect();
              }
            }
            var mh = a(1), ti = a(0);
            class hh extends En {
              constructor(d, p, A) {
                super(d, p), this.key = null, this.nacl = A;
              }
              authorize(d, p) {
                super.authorize(d, (A, z) => {
                  if (A) {
                    p(A, z);
                    return;
                  }
                  let G = z.shared_secret;
                  if (!G) {
                    p(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                    return;
                  }
                  this.key = Object(ti.decode)(G), delete z.shared_secret, p(null, z);
                });
              }
              trigger(d, p) {
                throw new T("Client events are not currently supported for encrypted channels");
              }
              handleEvent(d) {
                var p = d.event, A = d.data;
                if (p.indexOf("pusher_internal:") === 0 || p.indexOf("pusher:") === 0) {
                  super.handleEvent(d);
                  return;
                }
                this.handleEncryptedEvent(p, A);
              }
              handleEncryptedEvent(d, p) {
                if (!this.key) {
                  et.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                  return;
                }
                if (!p.ciphertext || !p.nonce) {
                  et.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + p);
                  return;
                }
                let A = Object(ti.decode)(p.ciphertext);
                if (A.length < this.nacl.secretbox.overheadLength) {
                  et.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${A.length}`);
                  return;
                }
                let z = Object(ti.decode)(p.nonce);
                if (z.length < this.nacl.secretbox.nonceLength) {
                  et.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${z.length}`);
                  return;
                }
                let G = this.nacl.secretbox.open(A, z, this.key);
                if (G === null) {
                  et.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint..."), this.authorize(this.pusher.connection.socket_id, (oe, ve) => {
                    if (oe) {
                      et.error(`Failed to make a request to the authEndpoint: ${ve}. Unable to fetch new key, so dropping encrypted event`);
                      return;
                    }
                    if (G = this.nacl.secretbox.open(A, z, this.key), G === null) {
                      et.error("Failed to decrypt event with new key. Dropping encrypted event");
                      return;
                    }
                    this.emit(d, this.getDataToEmit(G));
                  });
                  return;
                }
                this.emit(d, this.getDataToEmit(G));
              }
              getDataToEmit(d) {
                let p = Object(mh.decode)(d);
                try {
                  return JSON.parse(p);
                } catch {
                  return p;
                }
              }
            }
            class ph extends Fe {
              constructor(d, p) {
                super(), this.state = "initialized", this.connection = null, this.key = d, this.options = p, this.timeline = this.options.timeline, this.usingTLS = this.options.useTLS, this.errorCallbacks = this.buildErrorCallbacks(), this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks), this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
                var A = Ee.getNetwork();
                A.bind("online", () => {
                  this.timeline.info({ netinfo: "online" }), (this.state === "connecting" || this.state === "unavailable") && this.retryIn(0);
                }), A.bind("offline", () => {
                  this.timeline.info({ netinfo: "offline" }), this.connection && this.sendActivityCheck();
                }), this.updateStrategy();
              }
              connect() {
                if (!(this.connection || this.runner)) {
                  if (!this.strategy.isSupported()) {
                    this.updateState("failed");
                    return;
                  }
                  this.updateState("connecting"), this.startConnecting(), this.setUnavailableTimer();
                }
              }
              send(d) {
                return this.connection ? this.connection.send(d) : !1;
              }
              send_event(d, p, A) {
                return this.connection ? this.connection.send_event(d, p, A) : !1;
              }
              disconnect() {
                this.disconnectInternally(), this.updateState("disconnected");
              }
              isUsingTLS() {
                return this.usingTLS;
              }
              startConnecting() {
                var d = (p, A) => {
                  p ? this.runner = this.strategy.connect(0, d) : A.action === "error" ? (this.emit("error", {
                    type: "HandshakeError",
                    error: A.error
                  }), this.timeline.error({ handshakeError: A.error })) : (this.abortConnecting(), this.handshakeCallbacks[A.action](A));
                };
                this.runner = this.strategy.connect(0, d);
              }
              abortConnecting() {
                this.runner && (this.runner.abort(), this.runner = null);
              }
              disconnectInternally() {
                if (this.abortConnecting(), this.clearRetryTimer(), this.clearUnavailableTimer(), this.connection) {
                  var d = this.abandonConnection();
                  d.close();
                }
              }
              updateStrategy() {
                this.strategy = this.options.getStrategy({
                  key: this.key,
                  timeline: this.timeline,
                  useTLS: this.usingTLS
                });
              }
              retryIn(d) {
                this.timeline.info({ action: "retry", delay: d }), d > 0 && this.emit("connecting_in", Math.round(d / 1e3)), this.retryTimer = new Ve(d || 0, () => {
                  this.disconnectInternally(), this.connect();
                });
              }
              clearRetryTimer() {
                this.retryTimer && (this.retryTimer.ensureAborted(), this.retryTimer = null);
              }
              setUnavailableTimer() {
                this.unavailableTimer = new Ve(this.options.unavailableTimeout, () => {
                  this.updateState("unavailable");
                });
              }
              clearUnavailableTimer() {
                this.unavailableTimer && this.unavailableTimer.ensureAborted();
              }
              sendActivityCheck() {
                this.stopActivityCheck(), this.connection.ping(), this.activityTimer = new Ve(this.options.pongTimeout, () => {
                  this.timeline.error({ pong_timed_out: this.options.pongTimeout }), this.retryIn(0);
                });
              }
              resetActivityCheck() {
                this.stopActivityCheck(), this.connection && !this.connection.handlesActivityChecks() && (this.activityTimer = new Ve(this.activityTimeout, () => {
                  this.sendActivityCheck();
                }));
              }
              stopActivityCheck() {
                this.activityTimer && this.activityTimer.ensureAborted();
              }
              buildConnectionCallbacks(d) {
                return pe({}, d, {
                  message: (p) => {
                    this.resetActivityCheck(), this.emit("message", p);
                  },
                  ping: () => {
                    this.send_event("pusher:pong", {});
                  },
                  activity: () => {
                    this.resetActivityCheck();
                  },
                  error: (p) => {
                    this.emit("error", p);
                  },
                  closed: () => {
                    this.abandonConnection(), this.shouldRetry() && this.retryIn(1e3);
                  }
                });
              }
              buildHandshakeCallbacks(d) {
                return pe({}, d, {
                  connected: (p) => {
                    this.activityTimeout = Math.min(this.options.activityTimeout, p.activityTimeout, p.connection.activityTimeout || 1 / 0), this.clearUnavailableTimer(), this.setConnection(p.connection), this.socket_id = this.connection.id, this.updateState("connected", { socket_id: this.socket_id });
                  }
                });
              }
              buildErrorCallbacks() {
                let d = (p) => (A) => {
                  A.error && this.emit("error", { type: "WebSocketError", error: A.error }), p(A);
                };
                return {
                  tls_only: d(() => {
                    this.usingTLS = !0, this.updateStrategy(), this.retryIn(0);
                  }),
                  refused: d(() => {
                    this.disconnect();
                  }),
                  backoff: d(() => {
                    this.retryIn(1e3);
                  }),
                  retry: d(() => {
                    this.retryIn(0);
                  })
                };
              }
              setConnection(d) {
                this.connection = d;
                for (var p in this.connectionCallbacks)
                  this.connection.bind(p, this.connectionCallbacks[p]);
                this.resetActivityCheck();
              }
              abandonConnection() {
                if (this.connection) {
                  this.stopActivityCheck();
                  for (var d in this.connectionCallbacks)
                    this.connection.unbind(d, this.connectionCallbacks[d]);
                  var p = this.connection;
                  return this.connection = null, p;
                }
              }
              updateState(d, p) {
                var A = this.state;
                if (this.state = d, A !== d) {
                  var z = d;
                  z === "connected" && (z += " with new socket ID " + p.socket_id), et.debug("State changed", A + " -> " + z), this.timeline.info({ state: d, params: p }), this.emit("state_change", { previous: A, current: d }), this.emit(d, p);
                }
              }
              shouldRetry() {
                return this.state === "connecting" || this.state === "connected";
              }
            }
            class fh {
              constructor() {
                this.channels = {};
              }
              add(d, p) {
                return this.channels[d] || (this.channels[d] = vh(d, p)), this.channels[d];
              }
              all() {
                return Je(this.channels);
              }
              find(d) {
                return this.channels[d];
              }
              remove(d) {
                var p = this.channels[d];
                return delete this.channels[d], p;
              }
              disconnect() {
                we(this.channels, function(d) {
                  d.disconnect();
                });
              }
            }
            function vh(g, d) {
              if (g.indexOf("private-encrypted-") === 0) {
                if (d.config.nacl)
                  return An.createEncryptedChannel(g, d, d.config.nacl);
                let p = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available", A = y.buildLogSuffix("encryptedChannelSupport");
                throw new T(`${p}. ${A}`);
              } else {
                if (g.indexOf("private-") === 0)
                  return An.createPrivateChannel(g, d);
                if (g.indexOf("presence-") === 0)
                  return An.createPresenceChannel(g, d);
                if (g.indexOf("#") === 0)
                  throw new k('Cannot create a channel with name "' + g + '".');
                return An.createChannel(g, d);
              }
            }
            var gh = {
              createChannels() {
                return new fh();
              },
              createConnectionManager(g, d) {
                return new ph(g, d);
              },
              createChannel(g, d) {
                return new gn(g, d);
              },
              createPrivateChannel(g, d) {
                return new En(g, d);
              },
              createPresenceChannel(g, d) {
                return new dh(g, d);
              },
              createEncryptedChannel(g, d, p) {
                return new hh(g, d, p);
              },
              createTimelineSender(g, d) {
                return new Ks(g, d);
              },
              createHandshake(g, d) {
                return new Yo(g, d);
              },
              createAssistantToTheTransportManager(g, d, p) {
                return new Qs(g, d, p);
              }
            }, An = gh;
            class El {
              constructor(d) {
                this.options = d || {}, this.livesLeft = this.options.lives || 1 / 0;
              }
              getAssistant(d) {
                return An.createAssistantToTheTransportManager(this, d, {
                  minPingDelay: this.options.minPingDelay,
                  maxPingDelay: this.options.maxPingDelay
                });
              }
              isAlive() {
                return this.livesLeft > 0;
              }
              reportDeath() {
                this.livesLeft -= 1;
              }
            }
            class Jn {
              constructor(d, p) {
                this.strategies = d, this.loop = !!p.loop, this.failFast = !!p.failFast, this.timeout = p.timeout, this.timeoutLimit = p.timeoutLimit;
              }
              isSupported() {
                return Lt(this.strategies, ae.method("isSupported"));
              }
              connect(d, p) {
                var A = this.strategies, z = 0, G = this.timeout, oe = null, ve = (ze, Qe) => {
                  Qe ? p(null, Qe) : (z = z + 1, this.loop && (z = z % A.length), z < A.length ? (G && (G = G * 2, this.timeoutLimit && (G = Math.min(G, this.timeoutLimit))), oe = this.tryStrategy(A[z], d, { timeout: G, failFast: this.failFast }, ve)) : p(!0));
                };
                return oe = this.tryStrategy(A[z], d, { timeout: G, failFast: this.failFast }, ve), {
                  abort: function() {
                    oe.abort();
                  },
                  forceMinPriority: function(ze) {
                    d = ze, oe && oe.forceMinPriority(ze);
                  }
                };
              }
              tryStrategy(d, p, A, z) {
                var G = null, oe = null;
                return A.timeout > 0 && (G = new Ve(A.timeout, function() {
                  oe.abort(), z(!0);
                })), oe = d.connect(p, function(ve, ze) {
                  ve && G && G.isRunning() && !A.failFast || (G && G.ensureAborted(), z(ve, ze));
                }), {
                  abort: function() {
                    G && G.ensureAborted(), oe.abort();
                  },
                  forceMinPriority: function(ve) {
                    oe.forceMinPriority(ve);
                  }
                };
              }
            }
            class ni {
              constructor(d) {
                this.strategies = d;
              }
              isSupported() {
                return Lt(this.strategies, ae.method("isSupported"));
              }
              connect(d, p) {
                return _h(this.strategies, d, function(A, z) {
                  return function(G, oe) {
                    if (z[A].error = G, G) {
                      kh(z) && p(!0);
                      return;
                    }
                    Ue(z, function(ve) {
                      ve.forceMinPriority(oe.transport.priority);
                    }), p(null, oe);
                  };
                });
              }
            }
            function _h(g, d, p) {
              var A = Ye(g, function(z, G, oe, ve) {
                return z.connect(d, p(G, ve));
              });
              return {
                abort: function() {
                  Ue(A, yh);
                },
                forceMinPriority: function(z) {
                  Ue(A, function(G) {
                    G.forceMinPriority(z);
                  });
                }
              };
            }
            function kh(g) {
              return Mn(g, function(d) {
                return !!d.error;
              });
            }
            function yh(g) {
              !g.error && !g.aborted && (g.abort(), g.aborted = !0);
            }
            class bh {
              constructor(d, p, A) {
                this.strategy = d, this.transports = p, this.ttl = A.ttl || 1800 * 1e3, this.usingTLS = A.useTLS, this.timeline = A.timeline;
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(d, p) {
                var A = this.usingTLS, z = wh(A), G = z && z.cacheSkipCount ? z.cacheSkipCount : 0, oe = [this.strategy];
                if (z && z.timestamp + this.ttl >= ae.now()) {
                  var ve = this.transports[z.transport];
                  ve && (["ws", "wss"].includes(z.transport) || G > 3 ? (this.timeline.info({
                    cached: !0,
                    transport: z.transport,
                    latency: z.latency
                  }), oe.push(new Jn([ve], {
                    timeout: z.latency * 2 + 1e3,
                    failFast: !0
                  }))) : G++);
                }
                var ze = ae.now(), Qe = oe.pop().connect(d, function Ke(ft, ja) {
                  ft ? (Ol(A), oe.length > 0 ? (ze = ae.now(), Qe = oe.pop().connect(d, Ke)) : p(ft)) : (xh(A, ja.transport.name, ae.now() - ze, G), p(null, ja));
                });
                return {
                  abort: function() {
                    Qe.abort();
                  },
                  forceMinPriority: function(Ke) {
                    d = Ke, Qe && Qe.forceMinPriority(Ke);
                  }
                };
              }
            }
            function si(g) {
              return "pusherTransport" + (g ? "TLS" : "NonTLS");
            }
            function wh(g) {
              var d = Ee.getLocalStorage();
              if (d)
                try {
                  var p = d[si(g)];
                  if (p)
                    return JSON.parse(p);
                } catch {
                  Ol(g);
                }
              return null;
            }
            function xh(g, d, p, A) {
              var z = Ee.getLocalStorage();
              if (z)
                try {
                  z[si(g)] = dn({
                    timestamp: ae.now(),
                    transport: d,
                    latency: p,
                    cacheSkipCount: A
                  });
                } catch {
                }
            }
            function Ol(g) {
              var d = Ee.getLocalStorage();
              if (d)
                try {
                  delete d[si(g)];
                } catch {
                }
            }
            class Ua {
              constructor(d, { delay: p }) {
                this.strategy = d, this.options = { delay: p };
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(d, p) {
                var A = this.strategy, z, G = new Ve(this.options.delay, function() {
                  z = A.connect(d, p);
                });
                return {
                  abort: function() {
                    G.ensureAborted(), z && z.abort();
                  },
                  forceMinPriority: function(oe) {
                    d = oe, z && z.forceMinPriority(oe);
                  }
                };
              }
            }
            class Js {
              constructor(d, p, A) {
                this.test = d, this.trueBranch = p, this.falseBranch = A;
              }
              isSupported() {
                var d = this.test() ? this.trueBranch : this.falseBranch;
                return d.isSupported();
              }
              connect(d, p) {
                var A = this.test() ? this.trueBranch : this.falseBranch;
                return A.connect(d, p);
              }
            }
            class $h {
              constructor(d) {
                this.strategy = d;
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(d, p) {
                var A = this.strategy.connect(d, function(z, G) {
                  G && A.abort(), p(z, G);
                });
                return A;
              }
            }
            function Ys(g) {
              return function() {
                return g.isSupported();
              };
            }
            var Sh = function(g, d, p) {
              var A = {};
              function z(Hl, $p, Sp, Ap, Cp) {
                var Wl = p(g, Hl, $p, Sp, Ap, Cp);
                return A[Hl] = Wl, Wl;
              }
              var G = Object.assign({}, d, {
                hostNonTLS: g.wsHost + ":" + g.wsPort,
                hostTLS: g.wsHost + ":" + g.wssPort,
                httpPath: g.wsPath
              }), oe = Object.assign({}, G, {
                useTLS: !0
              }), ve = Object.assign({}, d, {
                hostNonTLS: g.httpHost + ":" + g.httpPort,
                hostTLS: g.httpHost + ":" + g.httpsPort,
                httpPath: g.httpPath
              }), ze = {
                loop: !0,
                timeout: 15e3,
                timeoutLimit: 6e4
              }, Qe = new El({
                minPingDelay: 1e4,
                maxPingDelay: g.activityTimeout
              }), Ke = new El({
                lives: 2,
                minPingDelay: 1e4,
                maxPingDelay: g.activityTimeout
              }), ft = z("ws", "ws", 3, G, Qe), ja = z("wss", "ws", 3, oe, Qe), kp = z("sockjs", "sockjs", 1, ve), Vl = z("xhr_streaming", "xhr_streaming", 1, ve, Ke), yp = z("xdr_streaming", "xdr_streaming", 1, ve, Ke), Ul = z("xhr_polling", "xhr_polling", 1, ve), bp = z("xdr_polling", "xdr_polling", 1, ve), Fl = new Jn([ft], ze), wp = new Jn([ja], ze), xp = new Jn([kp], ze), jl = new Jn([
                new Js(Ys(Vl), Vl, yp)
              ], ze), Bl = new Jn([
                new Js(Ys(Ul), Ul, bp)
              ], ze), ql = new Jn([
                new Js(Ys(jl), new ni([
                  jl,
                  new Ua(Bl, { delay: 4e3 })
                ]), Bl)
              ], ze), ri = new Js(Ys(ql), ql, xp), li;
              return d.useTLS ? li = new ni([
                Fl,
                new Ua(ri, { delay: 2e3 })
              ]) : li = new ni([
                Fl,
                new Ua(wp, { delay: 2e3 }),
                new Ua(ri, { delay: 5e3 })
              ]), new bh(new $h(new Js(Ys(ft), li, ri)), A, {
                ttl: 18e5,
                timeline: d.timeline,
                useTLS: d.useTLS
              });
            }, Ah = Sh, Ch = function() {
              var g = this;
              g.timeline.info(g.buildTimelineMessage({
                transport: g.name + (g.options.useTLS ? "s" : "")
              })), g.hooks.isInitialized() ? g.changeState("initialized") : g.hooks.file ? (g.changeState("initializing"), h.load(g.hooks.file, { useTLS: g.options.useTLS }, function(d, p) {
                g.hooks.isInitialized() ? (g.changeState("initialized"), p(!0)) : (d && g.onError(d), g.onClose(), p(!1));
              })) : g.onClose();
            }, Ph = {
              getRequest: function(g) {
                var d = new window.XDomainRequest();
                return d.ontimeout = function() {
                  g.emit("error", new w()), g.close();
                }, d.onerror = function(p) {
                  g.emit("error", p), g.close();
                }, d.onprogress = function() {
                  d.responseText && d.responseText.length > 0 && g.onChunk(200, d.responseText);
                }, d.onload = function() {
                  d.responseText && d.responseText.length > 0 && g.onChunk(200, d.responseText), g.emit("finished", 200), g.close();
                }, d;
              },
              abortRequest: function(g) {
                g.ontimeout = g.onerror = g.onprogress = g.onload = null, g.abort();
              }
            }, Ih = Ph;
            const Mh = 256 * 1024;
            class Th extends Fe {
              constructor(d, p, A) {
                super(), this.hooks = d, this.method = p, this.url = A;
              }
              start(d) {
                this.position = 0, this.xhr = this.hooks.getRequest(this), this.unloader = () => {
                  this.close();
                }, Ee.addUnloadListener(this.unloader), this.xhr.open(this.method, this.url, !0), this.xhr.setRequestHeader && this.xhr.setRequestHeader("Content-Type", "application/json"), this.xhr.send(d);
              }
              close() {
                this.unloader && (Ee.removeUnloadListener(this.unloader), this.unloader = null), this.xhr && (this.hooks.abortRequest(this.xhr), this.xhr = null);
              }
              onChunk(d, p) {
                for (; ; ) {
                  var A = this.advanceBuffer(p);
                  if (A)
                    this.emit("chunk", { status: d, data: A });
                  else
                    break;
                }
                this.isBufferTooLong(p) && this.emit("buffer_too_long");
              }
              advanceBuffer(d) {
                var p = d.slice(this.position), A = p.indexOf(`
`);
                return A !== -1 ? (this.position += A + 1, p.slice(0, A)) : null;
              }
              isBufferTooLong(d) {
                return this.position === d.length && d.length > Mh;
              }
            }
            var ai;
            (function(g) {
              g[g.CONNECTING = 0] = "CONNECTING", g[g.OPEN = 1] = "OPEN", g[g.CLOSED = 3] = "CLOSED";
            })(ai || (ai = {}));
            var Yn = ai, zh = 1;
            class Eh {
              constructor(d, p) {
                this.hooks = d, this.session = Ll(1e3) + "/" + Dh(8), this.location = Oh(p), this.readyState = Yn.CONNECTING, this.openStream();
              }
              send(d) {
                return this.sendRaw(JSON.stringify([d]));
              }
              ping() {
                this.hooks.sendHeartbeat(this);
              }
              close(d, p) {
                this.onClose(d, p, !0);
              }
              sendRaw(d) {
                if (this.readyState === Yn.OPEN)
                  try {
                    return Ee.createSocketRequest("POST", Rl(Rh(this.location, this.session))).start(d), !0;
                  } catch {
                    return !1;
                  }
                else
                  return !1;
              }
              reconnect() {
                this.closeStream(), this.openStream();
              }
              onClose(d, p, A) {
                this.closeStream(), this.readyState = Yn.CLOSED, this.onclose && this.onclose({
                  code: d,
                  reason: p,
                  wasClean: A
                });
              }
              onChunk(d) {
                if (d.status === 200) {
                  this.readyState === Yn.OPEN && this.onActivity();
                  var p, A = d.data.slice(0, 1);
                  switch (A) {
                    case "o":
                      p = JSON.parse(d.data.slice(1) || "{}"), this.onOpen(p);
                      break;
                    case "a":
                      p = JSON.parse(d.data.slice(1) || "[]");
                      for (var z = 0; z < p.length; z++)
                        this.onEvent(p[z]);
                      break;
                    case "m":
                      p = JSON.parse(d.data.slice(1) || "null"), this.onEvent(p);
                      break;
                    case "h":
                      this.hooks.onHeartbeat(this);
                      break;
                    case "c":
                      p = JSON.parse(d.data.slice(1) || "[]"), this.onClose(p[0], p[1], !0);
                      break;
                  }
                }
              }
              onOpen(d) {
                this.readyState === Yn.CONNECTING ? (d && d.hostname && (this.location.base = Lh(this.location.base, d.hostname)), this.readyState = Yn.OPEN, this.onopen && this.onopen()) : this.onClose(1006, "Server lost session", !0);
              }
              onEvent(d) {
                this.readyState === Yn.OPEN && this.onmessage && this.onmessage({ data: d });
              }
              onActivity() {
                this.onactivity && this.onactivity();
              }
              onError(d) {
                this.onerror && this.onerror(d);
              }
              openStream() {
                this.stream = Ee.createSocketRequest("POST", Rl(this.hooks.getReceiveURL(this.location, this.session))), this.stream.bind("chunk", (d) => {
                  this.onChunk(d);
                }), this.stream.bind("finished", (d) => {
                  this.hooks.onFinished(this, d);
                }), this.stream.bind("buffer_too_long", () => {
                  this.reconnect();
                });
                try {
                  this.stream.start();
                } catch (d) {
                  ae.defer(() => {
                    this.onError(d), this.onClose(1006, "Could not start streaming", !1);
                  });
                }
              }
              closeStream() {
                this.stream && (this.stream.unbind_all(), this.stream.close(), this.stream = null);
              }
            }
            function Oh(g) {
              var d = /([^\?]*)\/*(\??.*)/.exec(g);
              return {
                base: d[1],
                queryString: d[2]
              };
            }
            function Rh(g, d) {
              return g.base + "/" + d + "/xhr_send";
            }
            function Rl(g) {
              var d = g.indexOf("?") === -1 ? "?" : "&";
              return g + d + "t=" + +/* @__PURE__ */ new Date() + "&n=" + zh++;
            }
            function Lh(g, d) {
              var p = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(g);
              return p[1] + d + p[3];
            }
            function Ll(g) {
              return Ee.randomInt(g);
            }
            function Dh(g) {
              for (var d = [], p = 0; p < g; p++)
                d.push(Ll(32).toString(32));
              return d.join("");
            }
            var Nh = Eh, Vh = {
              getReceiveURL: function(g, d) {
                return g.base + "/" + d + "/xhr_streaming" + g.queryString;
              },
              onHeartbeat: function(g) {
                g.sendRaw("[]");
              },
              sendHeartbeat: function(g) {
                g.sendRaw("[]");
              },
              onFinished: function(g, d) {
                g.onClose(1006, "Connection interrupted (" + d + ")", !1);
              }
            }, Uh = Vh, Fh = {
              getReceiveURL: function(g, d) {
                return g.base + "/" + d + "/xhr" + g.queryString;
              },
              onHeartbeat: function() {
              },
              sendHeartbeat: function(g) {
                g.sendRaw("[]");
              },
              onFinished: function(g, d) {
                d === 200 ? g.reconnect() : g.onClose(1006, "Connection interrupted (" + d + ")", !1);
              }
            }, jh = Fh, Bh = {
              getRequest: function(g) {
                var d = Ee.getXHRAPI(), p = new d();
                return p.onreadystatechange = p.onprogress = function() {
                  switch (p.readyState) {
                    case 3:
                      p.responseText && p.responseText.length > 0 && g.onChunk(p.status, p.responseText);
                      break;
                    case 4:
                      p.responseText && p.responseText.length > 0 && g.onChunk(p.status, p.responseText), g.emit("finished", p.status), g.close();
                      break;
                  }
                }, p;
              },
              abortRequest: function(g) {
                g.onreadystatechange = null, g.abort();
              }
            }, qh = Bh, Hh = {
              createStreamingSocket(g) {
                return this.createSocket(Uh, g);
              },
              createPollingSocket(g) {
                return this.createSocket(jh, g);
              },
              createSocket(g, d) {
                return new Nh(g, d);
              },
              createXHR(g, d) {
                return this.createRequest(qh, g, d);
              },
              createRequest(g, d, p) {
                return new Th(g, d, p);
              }
            }, Dl = Hh;
            Dl.createXDR = function(g, d) {
              return this.createRequest(Ih, g, d);
            };
            var Wh = Dl, Gh = {
              nextAuthCallbackID: 1,
              auth_callbacks: {},
              ScriptReceivers: i,
              DependenciesReceivers: m,
              getDefaultStrategy: Ah,
              Transports: Zs,
              transportConnectionInitializer: Ch,
              HTTPFactory: Wh,
              TimelineTransport: Jo,
              getXHRAPI() {
                return window.XMLHttpRequest;
              },
              getWebSocketAPI() {
                return window.WebSocket || window.MozWebSocket;
              },
              setup(g) {
                window.Pusher = g;
                var d = () => {
                  this.onDocumentBody(g.ready);
                };
                window.JSON ? d() : h.load("json2", {}, d);
              },
              getDocument() {
                return document;
              },
              getProtocol() {
                return this.getDocument().location.protocol;
              },
              getAuthorizers() {
                return { ajax: Q, jsonp: za };
              },
              onDocumentBody(g) {
                document.body ? g() : setTimeout(() => {
                  this.onDocumentBody(g);
                }, 0);
              },
              createJSONPRequest(g, d) {
                return new Zn(g, d);
              },
              createScriptRequest(g) {
                return new Ko(g);
              },
              getLocalStorage() {
                try {
                  return window.localStorage;
                } catch {
                  return;
                }
              },
              createXHR() {
                return this.getXHRAPI() ? this.createXMLHttpRequest() : this.createMicrosoftXHR();
              },
              createXMLHttpRequest() {
                var g = this.getXHRAPI();
                return new g();
              },
              createMicrosoftXHR() {
                return new ActiveXObject("Microsoft.XMLHTTP");
              },
              getNetwork() {
                return Da;
              },
              createWebSocket(g) {
                var d = this.getWebSocketAPI();
                return new d(g);
              },
              createSocketRequest(g, d) {
                if (this.isXHRSupported())
                  return this.HTTPFactory.createXHR(g, d);
                if (this.isXDRSupported(d.indexOf("https:") === 0))
                  return this.HTTPFactory.createXDR(g, d);
                throw "Cross-origin HTTP requests are not supported";
              },
              isXHRSupported() {
                var g = this.getXHRAPI();
                return !!g && new g().withCredentials !== void 0;
              },
              isXDRSupported(g) {
                var d = g ? "https:" : "http:", p = this.getProtocol();
                return !!window.XDomainRequest && p === d;
              },
              addUnloadListener(g) {
                window.addEventListener !== void 0 ? window.addEventListener("unload", g, !1) : window.attachEvent !== void 0 && window.attachEvent("onunload", g);
              },
              removeUnloadListener(g) {
                window.addEventListener !== void 0 ? window.removeEventListener("unload", g, !1) : window.detachEvent !== void 0 && window.detachEvent("onunload", g);
              },
              randomInt(g) {
                return Math.floor(function() {
                  return (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32);
                }() * g);
              }
            }, Ee = Gh, oi;
            (function(g) {
              g[g.ERROR = 3] = "ERROR", g[g.INFO = 6] = "INFO", g[g.DEBUG = 7] = "DEBUG";
            })(oi || (oi = {}));
            var Fa = oi;
            class Zh {
              constructor(d, p, A) {
                this.key = d, this.session = p, this.events = [], this.options = A || {}, this.sent = 0, this.uniqueID = 0;
              }
              log(d, p) {
                d <= this.options.level && (this.events.push(pe({}, p, { timestamp: ae.now() })), this.options.limit && this.events.length > this.options.limit && this.events.shift());
              }
              error(d) {
                this.log(Fa.ERROR, d);
              }
              info(d) {
                this.log(Fa.INFO, d);
              }
              debug(d) {
                this.log(Fa.DEBUG, d);
              }
              isEmpty() {
                return this.events.length === 0;
              }
              send(d, p) {
                var A = pe({
                  session: this.session,
                  bundle: this.sent + 1,
                  key: this.key,
                  lib: "js",
                  version: this.options.version,
                  cluster: this.options.cluster,
                  features: this.options.features,
                  timeline: this.events
                }, this.options.params);
                return this.events = [], d(A, (z, G) => {
                  z || this.sent++, p && p(z, G);
                }), !0;
              }
              generateUniqueID() {
                return this.uniqueID++, this.uniqueID;
              }
            }
            class Qh {
              constructor(d, p, A, z) {
                this.name = d, this.priority = p, this.transport = A, this.options = z || {};
              }
              isSupported() {
                return this.transport.isSupported({
                  useTLS: this.options.useTLS
                });
              }
              connect(d, p) {
                if (this.isSupported()) {
                  if (this.priority < d)
                    return Nl(new C(), p);
                } else return Nl(new U(), p);
                var A = !1, z = this.transport.createConnection(this.name, this.priority, this.options.key, this.options), G = null, oe = function() {
                  z.unbind("initialized", oe), z.connect();
                }, ve = function() {
                  G = An.createHandshake(z, function(ft) {
                    A = !0, Ke(), p(null, ft);
                  });
                }, ze = function(ft) {
                  Ke(), p(ft);
                }, Qe = function() {
                  Ke();
                  var ft;
                  ft = dn(z), p(new M(ft));
                }, Ke = function() {
                  z.unbind("initialized", oe), z.unbind("open", ve), z.unbind("error", ze), z.unbind("closed", Qe);
                };
                return z.bind("initialized", oe), z.bind("open", ve), z.bind("error", ze), z.bind("closed", Qe), z.initialize(), {
                  abort: () => {
                    A || (Ke(), G ? G.close() : z.close());
                  },
                  forceMinPriority: (ft) => {
                    A || this.priority < ft && (G ? G.close() : z.close());
                  }
                };
              }
            }
            function Nl(g, d) {
              return ae.defer(function() {
                d(g);
              }), {
                abort: function() {
                },
                forceMinPriority: function() {
                }
              };
            }
            const { Transports: Xh } = Ee;
            var Kh = function(g, d, p, A, z, G) {
              var oe = Xh[p];
              if (!oe)
                throw new E(p);
              var ve = (!g.enabledTransports || st(g.enabledTransports, d) !== -1) && (!g.disabledTransports || st(g.disabledTransports, d) === -1), ze;
              return ve ? (z = Object.assign({ ignoreNullOrigin: g.ignoreNullOrigin }, z), ze = new Qh(d, A, G ? G.getAssistant(oe) : oe, z)) : ze = Jh, ze;
            }, Jh = {
              isSupported: function() {
                return !1;
              },
              connect: function(g, d) {
                var p = ae.defer(function() {
                  d(new U());
                });
                return {
                  abort: function() {
                    p.ensureAborted();
                  },
                  forceMinPriority: function() {
                  }
                };
              }
            };
            function Yh(g) {
              if (g == null)
                throw "You must pass an options object";
              if (g.cluster == null)
                throw "Options object must provide a cluster";
              "disableStats" in g && et.warn("The disableStats option is deprecated in favor of enableStats");
            }
            const ep = (g, d) => {
              var p = "socket_id=" + encodeURIComponent(g.socketId);
              for (var A in d.params)
                p += "&" + encodeURIComponent(A) + "=" + encodeURIComponent(d.params[A]);
              if (d.paramsProvider != null) {
                let z = d.paramsProvider();
                for (var A in z)
                  p += "&" + encodeURIComponent(A) + "=" + encodeURIComponent(z[A]);
              }
              return p;
            };
            var tp = (g) => {
              if (typeof Ee.getAuthorizers()[g.transport] > "u")
                throw `'${g.transport}' is not a recognized auth transport`;
              return (d, p) => {
                const A = ep(d, g);
                Ee.getAuthorizers()[g.transport](Ee, A, g, S.UserAuthentication, p);
              };
            };
            const np = (g, d) => {
              var p = "socket_id=" + encodeURIComponent(g.socketId);
              p += "&channel_name=" + encodeURIComponent(g.channelName);
              for (var A in d.params)
                p += "&" + encodeURIComponent(A) + "=" + encodeURIComponent(d.params[A]);
              if (d.paramsProvider != null) {
                let z = d.paramsProvider();
                for (var A in z)
                  p += "&" + encodeURIComponent(A) + "=" + encodeURIComponent(z[A]);
              }
              return p;
            };
            var sp = (g) => {
              if (typeof Ee.getAuthorizers()[g.transport] > "u")
                throw `'${g.transport}' is not a recognized auth transport`;
              return (d, p) => {
                const A = np(d, g);
                Ee.getAuthorizers()[g.transport](Ee, A, g, S.ChannelAuthorization, p);
              };
            };
            const ap = (g, d, p) => {
              const A = {
                authTransport: d.transport,
                authEndpoint: d.endpoint,
                auth: {
                  params: d.params,
                  headers: d.headers
                }
              };
              return (z, G) => {
                const oe = g.channel(z.channelName);
                p(oe, A).authorize(z.socketId, G);
              };
            };
            function op(g, d) {
              let p = {
                activityTimeout: g.activityTimeout || l.activityTimeout,
                cluster: g.cluster,
                httpPath: g.httpPath || l.httpPath,
                httpPort: g.httpPort || l.httpPort,
                httpsPort: g.httpsPort || l.httpsPort,
                pongTimeout: g.pongTimeout || l.pongTimeout,
                statsHost: g.statsHost || l.stats_host,
                unavailableTimeout: g.unavailableTimeout || l.unavailableTimeout,
                wsPath: g.wsPath || l.wsPath,
                wsPort: g.wsPort || l.wsPort,
                wssPort: g.wssPort || l.wssPort,
                enableStats: up(g),
                httpHost: ip(g),
                useTLS: cp(g),
                wsHost: rp(g),
                userAuthenticator: dp(g),
                channelAuthorizer: hp(g, d)
              };
              return "disabledTransports" in g && (p.disabledTransports = g.disabledTransports), "enabledTransports" in g && (p.enabledTransports = g.enabledTransports), "ignoreNullOrigin" in g && (p.ignoreNullOrigin = g.ignoreNullOrigin), "timelineParams" in g && (p.timelineParams = g.timelineParams), "nacl" in g && (p.nacl = g.nacl), p;
            }
            function ip(g) {
              return g.httpHost ? g.httpHost : g.cluster ? `sockjs-${g.cluster}.pusher.com` : l.httpHost;
            }
            function rp(g) {
              return g.wsHost ? g.wsHost : lp(g.cluster);
            }
            function lp(g) {
              return `ws-${g}.pusher.com`;
            }
            function cp(g) {
              return Ee.getProtocol() === "https:" ? !0 : g.forceTLS !== !1;
            }
            function up(g) {
              return "enableStats" in g ? g.enableStats : "disableStats" in g ? !g.disableStats : !1;
            }
            function dp(g) {
              const d = Object.assign(Object.assign({}, l.userAuthentication), g.userAuthentication);
              return "customHandler" in d && d.customHandler != null ? d.customHandler : tp(d);
            }
            function mp(g, d) {
              let p;
              return "channelAuthorization" in g ? p = Object.assign(Object.assign({}, l.channelAuthorization), g.channelAuthorization) : (p = {
                transport: g.authTransport || l.authTransport,
                endpoint: g.authEndpoint || l.authEndpoint
              }, "auth" in g && ("params" in g.auth && (p.params = g.auth.params), "headers" in g.auth && (p.headers = g.auth.headers)), "authorizer" in g && (p.customHandler = ap(d, p, g.authorizer))), p;
            }
            function hp(g, d) {
              const p = mp(g, d);
              return "customHandler" in p && p.customHandler != null ? p.customHandler : sp(p);
            }
            class pp extends Fe {
              constructor(d) {
                super(function(p, A) {
                  et.debug(`No callbacks on watchlist events for ${p}`);
                }), this.pusher = d, this.bindWatchlistInternalEvent();
              }
              handleEvent(d) {
                d.data.events.forEach((p) => {
                  this.emit(p.name, p);
                });
              }
              bindWatchlistInternalEvent() {
                this.pusher.connection.bind("message", (d) => {
                  var p = d.event;
                  p === "pusher_internal:watchlist_events" && this.handleEvent(d);
                });
              }
            }
            function fp() {
              let g, d;
              return { promise: new Promise((A, z) => {
                g = A, d = z;
              }), resolve: g, reject: d };
            }
            var vp = fp;
            class gp extends Fe {
              constructor(d) {
                super(function(p, A) {
                  et.debug("No callbacks on user for " + p);
                }), this.signin_requested = !1, this.user_data = null, this.serverToUserChannel = null, this.signinDonePromise = null, this._signinDoneResolve = null, this._onAuthorize = (p, A) => {
                  if (p) {
                    et.warn(`Error during signin: ${p}`), this._cleanup();
                    return;
                  }
                  this.pusher.send_event("pusher:signin", {
                    auth: A.auth,
                    user_data: A.user_data
                  });
                }, this.pusher = d, this.pusher.connection.bind("state_change", ({ previous: p, current: A }) => {
                  p !== "connected" && A === "connected" && this._signin(), p === "connected" && A !== "connected" && (this._cleanup(), this._newSigninPromiseIfNeeded());
                }), this.watchlist = new pp(d), this.pusher.connection.bind("message", (p) => {
                  var A = p.event;
                  A === "pusher:signin_success" && this._onSigninSuccess(p.data), this.serverToUserChannel && this.serverToUserChannel.name === p.channel && this.serverToUserChannel.handleEvent(p);
                });
              }
              signin() {
                this.signin_requested || (this.signin_requested = !0, this._signin());
              }
              _signin() {
                this.signin_requested && (this._newSigninPromiseIfNeeded(), this.pusher.connection.state === "connected" && this.pusher.config.userAuthenticator({
                  socketId: this.pusher.connection.socket_id
                }, this._onAuthorize));
              }
              _onSigninSuccess(d) {
                try {
                  this.user_data = JSON.parse(d.user_data);
                } catch {
                  et.error(`Failed parsing user data after signin: ${d.user_data}`), this._cleanup();
                  return;
                }
                if (typeof this.user_data.id != "string" || this.user_data.id === "") {
                  et.error(`user_data doesn't contain an id. user_data: ${this.user_data}`), this._cleanup();
                  return;
                }
                this._signinDoneResolve(), this._subscribeChannels();
              }
              _subscribeChannels() {
                const d = (p) => {
                  p.subscriptionPending && p.subscriptionCancelled ? p.reinstateSubscription() : !p.subscriptionPending && this.pusher.connection.state === "connected" && p.subscribe();
                };
                this.serverToUserChannel = new gn(`#server-to-user-${this.user_data.id}`, this.pusher), this.serverToUserChannel.bind_global((p, A) => {
                  p.indexOf("pusher_internal:") === 0 || p.indexOf("pusher:") === 0 || this.emit(p, A);
                }), d(this.serverToUserChannel);
              }
              _cleanup() {
                this.user_data = null, this.serverToUserChannel && (this.serverToUserChannel.unbind_all(), this.serverToUserChannel.disconnect(), this.serverToUserChannel = null), this.signin_requested && this._signinDoneResolve();
              }
              _newSigninPromiseIfNeeded() {
                if (!this.signin_requested || this.signinDonePromise && !this.signinDonePromise.done)
                  return;
                const { promise: d, resolve: p } = vp();
                d.done = !1;
                const A = () => {
                  d.done = !0;
                };
                d.then(A).catch(A), this.signinDonePromise = d, this._signinDoneResolve = p;
              }
            }
            class $t {
              static ready() {
                $t.isReady = !0;
                for (var d = 0, p = $t.instances.length; d < p; d++)
                  $t.instances[d].connect();
              }
              static getClientFeatures() {
                return Ce(ct({ ws: Ee.Transports.ws }, function(d) {
                  return d.isSupported({});
                }));
              }
              constructor(d, p) {
                _p(d), Yh(p), this.key = d, this.config = op(p, this), this.channels = An.createChannels(), this.global_emitter = new Fe(), this.sessionID = Ee.randomInt(1e9), this.timeline = new Zh(this.key, this.sessionID, {
                  cluster: this.config.cluster,
                  features: $t.getClientFeatures(),
                  params: this.config.timelineParams || {},
                  limit: 50,
                  level: Fa.INFO,
                  version: l.VERSION
                }), this.config.enableStats && (this.timelineSender = An.createTimelineSender(this.timeline, {
                  host: this.config.statsHost,
                  path: "/timeline/v2/" + Ee.TimelineTransport.name
                }));
                var A = (z) => Ee.getDefaultStrategy(this.config, z, Kh);
                this.connection = An.createConnectionManager(this.key, {
                  getStrategy: A,
                  timeline: this.timeline,
                  activityTimeout: this.config.activityTimeout,
                  pongTimeout: this.config.pongTimeout,
                  unavailableTimeout: this.config.unavailableTimeout,
                  useTLS: !!this.config.useTLS
                }), this.connection.bind("connected", () => {
                  this.subscribeAll(), this.timelineSender && this.timelineSender.send(this.connection.isUsingTLS());
                }), this.connection.bind("message", (z) => {
                  var G = z.event, oe = G.indexOf("pusher_internal:") === 0;
                  if (z.channel) {
                    var ve = this.channel(z.channel);
                    ve && ve.handleEvent(z);
                  }
                  oe || this.global_emitter.emit(z.event, z.data);
                }), this.connection.bind("connecting", () => {
                  this.channels.disconnect();
                }), this.connection.bind("disconnected", () => {
                  this.channels.disconnect();
                }), this.connection.bind("error", (z) => {
                  et.warn(z);
                }), $t.instances.push(this), this.timeline.info({ instances: $t.instances.length }), this.user = new gp(this), $t.isReady && this.connect();
              }
              channel(d) {
                return this.channels.find(d);
              }
              allChannels() {
                return this.channels.all();
              }
              connect() {
                if (this.connection.connect(), this.timelineSender && !this.timelineSenderTimer) {
                  var d = this.connection.isUsingTLS(), p = this.timelineSender;
                  this.timelineSenderTimer = new nt(6e4, function() {
                    p.send(d);
                  });
                }
              }
              disconnect() {
                this.connection.disconnect(), this.timelineSenderTimer && (this.timelineSenderTimer.ensureAborted(), this.timelineSenderTimer = null);
              }
              bind(d, p, A) {
                return this.global_emitter.bind(d, p, A), this;
              }
              unbind(d, p, A) {
                return this.global_emitter.unbind(d, p, A), this;
              }
              bind_global(d) {
                return this.global_emitter.bind_global(d), this;
              }
              unbind_global(d) {
                return this.global_emitter.unbind_global(d), this;
              }
              unbind_all(d) {
                return this.global_emitter.unbind_all(), this;
              }
              subscribeAll() {
                var d;
                for (d in this.channels.channels)
                  this.channels.channels.hasOwnProperty(d) && this.subscribe(d);
              }
              subscribe(d) {
                var p = this.channels.add(d, this);
                return p.subscriptionPending && p.subscriptionCancelled ? p.reinstateSubscription() : !p.subscriptionPending && this.connection.state === "connected" && p.subscribe(), p;
              }
              unsubscribe(d) {
                var p = this.channels.find(d);
                p && p.subscriptionPending ? p.cancelSubscription() : (p = this.channels.remove(d), p && p.subscribed && p.unsubscribe());
              }
              send_event(d, p, A) {
                return this.connection.send_event(d, p, A);
              }
              shouldUseTLS() {
                return this.config.useTLS;
              }
              signin() {
                this.user.signin();
              }
            }
            $t.instances = [], $t.isReady = !1, $t.logToConsole = !1, $t.Runtime = Ee, $t.ScriptReceivers = Ee.ScriptReceivers, $t.DependenciesReceivers = Ee.DependenciesReceivers, $t.auth_callbacks = Ee.auth_callbacks;
            var ii = s.default = $t;
            function _p(g) {
              if (g == null)
                throw "You must pass your app key when you instantiate Pusher.";
            }
            Ee.setup($t);
          }
          /******/
        ])
      );
    });
  }(sr)), sr.exports;
}
var q1 = B1();
const H1 = /* @__PURE__ */ Sd(q1);
/**
* @vue/shared v3.5.16
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const Hd = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  return (n) => e[n] || (e[n] = t(n));
}, W1 = /-(\w)/g, G1 = Hd(
  (t) => t.replace(W1, (e, n) => n ? n.toUpperCase() : "")
), Z1 = Hd((t) => t.charAt(0).toUpperCase() + t.slice(1)), Q1 = [
  "AnimatedSprite",
  "BitmapText",
  "Container",
  "Graphics",
  "HtmlText",
  "Mesh",
  "MeshPlane",
  "MeshRope",
  "MeshSimple",
  "NineSlicePlane",
  "NineSliceSprite",
  "ParticleContainer",
  "PerspectiveMesh",
  "RenderContainer",
  "RenderLayer",
  "Sprite",
  "Text",
  "TilingSprite"
];
function X1(t) {
  return Q1.includes(t);
}
function K1(t) {
  return t = Z1(G1(t)), t.startsWith("Pixi") && (t = t.slice(4)), t;
}
class Vt {
  /** @param {Viewport} parent */
  constructor(e) {
    this.parent = e, this.paused = !1;
  }
  /** Called when plugin is removed */
  destroy() {
  }
  /** Handler for pointerdown PIXI event */
  down(e) {
    return !1;
  }
  /** Handler for pointermove PIXI event */
  move(e) {
    return !1;
  }
  /** Handler for pointerup PIXI event */
  up(e) {
    return !1;
  }
  /** Handler for wheel event on div */
  wheel(e) {
    return !1;
  }
  /**
   * Called on each tick
   * @param {number} elapsed time in millisecond since last update
   */
  update(e) {
  }
  /** Called when the viewport is resized */
  resize() {
  }
  /** Called when the viewport is manually moved */
  reset() {
  }
  /** Pause the plugin */
  pause() {
    this.paused = !0;
  }
  /** Un-pause the plugin */
  resume() {
    this.paused = !1;
  }
}
var J1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Y1(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Wd = { exports: {} };
(function(t, e) {
  (function() {
    var n, s;
    s = function(a) {
      return t.exports = a;
    }, n = {
      linear: function(a, o, i, r) {
        return i * a / r + o;
      },
      easeInQuad: function(a, o, i, r) {
        return i * (a /= r) * a + o;
      },
      easeOutQuad: function(a, o, i, r) {
        return -i * (a /= r) * (a - 2) + o;
      },
      easeInOutQuad: function(a, o, i, r) {
        return (a /= r / 2) < 1 ? i / 2 * a * a + o : -i / 2 * (--a * (a - 2) - 1) + o;
      },
      easeInCubic: function(a, o, i, r) {
        return i * (a /= r) * a * a + o;
      },
      easeOutCubic: function(a, o, i, r) {
        return i * ((a = a / r - 1) * a * a + 1) + o;
      },
      easeInOutCubic: function(a, o, i, r) {
        return (a /= r / 2) < 1 ? i / 2 * a * a * a + o : i / 2 * ((a -= 2) * a * a + 2) + o;
      },
      easeInQuart: function(a, o, i, r) {
        return i * (a /= r) * a * a * a + o;
      },
      easeOutQuart: function(a, o, i, r) {
        return -i * ((a = a / r - 1) * a * a * a - 1) + o;
      },
      easeInOutQuart: function(a, o, i, r) {
        return (a /= r / 2) < 1 ? i / 2 * a * a * a * a + o : -i / 2 * ((a -= 2) * a * a * a - 2) + o;
      },
      easeInQuint: function(a, o, i, r) {
        return i * (a /= r) * a * a * a * a + o;
      },
      easeOutQuint: function(a, o, i, r) {
        return i * ((a = a / r - 1) * a * a * a * a + 1) + o;
      },
      easeInOutQuint: function(a, o, i, r) {
        return (a /= r / 2) < 1 ? i / 2 * a * a * a * a * a + o : i / 2 * ((a -= 2) * a * a * a * a + 2) + o;
      },
      easeInSine: function(a, o, i, r) {
        return -i * Math.cos(a / r * (Math.PI / 2)) + i + o;
      },
      easeOutSine: function(a, o, i, r) {
        return i * Math.sin(a / r * (Math.PI / 2)) + o;
      },
      easeInOutSine: function(a, o, i, r) {
        return -i / 2 * (Math.cos(Math.PI * a / r) - 1) + o;
      },
      easeInExpo: function(a, o, i, r) {
        return a === 0 ? o : i * Math.pow(2, 10 * (a / r - 1)) + o;
      },
      easeOutExpo: function(a, o, i, r) {
        return a === r ? o + i : i * (-Math.pow(2, -10 * a / r) + 1) + o;
      },
      easeInOutExpo: function(a, o, i, r) {
        return (a /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (a - 1)) + o : i / 2 * (-Math.pow(2, -10 * --a) + 2) + o;
      },
      easeInCirc: function(a, o, i, r) {
        return -i * (Math.sqrt(1 - (a /= r) * a) - 1) + o;
      },
      easeOutCirc: function(a, o, i, r) {
        return i * Math.sqrt(1 - (a = a / r - 1) * a) + o;
      },
      easeInOutCirc: function(a, o, i, r) {
        return (a /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - a * a) - 1) + o : i / 2 * (Math.sqrt(1 - (a -= 2) * a) + 1) + o;
      },
      easeInElastic: function(a, o, i, r) {
        var l, u, m;
        return m = 1.70158, u = 0, l = i, a === 0 || (a /= r), u || (u = r * 0.3), l < Math.abs(i) ? (l = i, m = u / 4) : m = u / (2 * Math.PI) * Math.asin(i / l), -(l * Math.pow(2, 10 * (a -= 1)) * Math.sin((a * r - m) * (2 * Math.PI) / u)) + o;
      },
      easeOutElastic: function(a, o, i, r) {
        var l, u, m;
        return m = 1.70158, u = 0, l = i, a === 0 || (a /= r), u || (u = r * 0.3), l < Math.abs(i) ? (l = i, m = u / 4) : m = u / (2 * Math.PI) * Math.asin(i / l), l * Math.pow(2, -10 * a) * Math.sin((a * r - m) * (2 * Math.PI) / u) + i + o;
      },
      easeInOutElastic: function(a, o, i, r) {
        var l, u, m;
        return m = 1.70158, u = 0, l = i, a === 0 || (a /= r / 2), u || (u = r * (0.3 * 1.5)), l < Math.abs(i) ? (l = i, m = u / 4) : m = u / (2 * Math.PI) * Math.asin(i / l), a < 1 ? -0.5 * (l * Math.pow(2, 10 * (a -= 1)) * Math.sin((a * r - m) * (2 * Math.PI) / u)) + o : l * Math.pow(2, -10 * (a -= 1)) * Math.sin((a * r - m) * (2 * Math.PI) / u) * 0.5 + i + o;
      },
      easeInBack: function(a, o, i, r, l) {
        return l === void 0 && (l = 1.70158), i * (a /= r) * a * ((l + 1) * a - l) + o;
      },
      easeOutBack: function(a, o, i, r, l) {
        return l === void 0 && (l = 1.70158), i * ((a = a / r - 1) * a * ((l + 1) * a + l) + 1) + o;
      },
      easeInOutBack: function(a, o, i, r, l) {
        return l === void 0 && (l = 1.70158), (a /= r / 2) < 1 ? i / 2 * (a * a * (((l *= 1.525) + 1) * a - l)) + o : i / 2 * ((a -= 2) * a * (((l *= 1.525) + 1) * a + l) + 2) + o;
      },
      easeInBounce: function(a, o, i, r) {
        var l;
        return l = n.easeOutBounce(r - a, 0, i, r), i - l + o;
      },
      easeOutBounce: function(a, o, i, r) {
        return (a /= r) < 1 / 2.75 ? i * (7.5625 * a * a) + o : a < 2 / 2.75 ? i * (7.5625 * (a -= 1.5 / 2.75) * a + 0.75) + o : a < 2.5 / 2.75 ? i * (7.5625 * (a -= 2.25 / 2.75) * a + 0.9375) + o : i * (7.5625 * (a -= 2.625 / 2.75) * a + 0.984375) + o;
      },
      easeInOutBounce: function(a, o, i, r) {
        var l;
        return a < r / 2 ? (l = n.easeInBounce(a * 2, 0, i, r), l * 0.5 + o) : (l = n.easeOutBounce(a * 2 - r, 0, i, r), l * 0.5 + i * 0.5 + o);
      }
    }, s(n);
  }).call(J1);
})(Wd);
var eg = Wd.exports;
const iu = /* @__PURE__ */ Y1(eg);
function Co(t, e) {
  if (t) {
    if (typeof t == "function")
      return t;
    if (typeof t == "string")
      return iu[t];
  } else
    return iu[e];
}
const tg = {
  removeOnInterrupt: !1,
  ease: "linear",
  time: 1e3
};
let ng = class extends Vt {
  /**
   * This is called by {@link Viewport.animate}.
   *
   * @param parent
   * @param options
   */
  constructor(e, n = {}) {
    super(e), this.startWidth = null, this.startHeight = null, this.deltaWidth = null, this.deltaHeight = null, this.width = null, this.height = null, this.time = 0, this.options = Object.assign({}, tg, n), this.options.ease = Co(this.options.ease), this.setupPosition(), this.setupZoom(), this.time = 0;
  }
  /**
   * Setup `startX`, `startY`, `deltaX`, `deltaY`, `keepCenter`.
   *
   * This is called during construction.
   */
  setupPosition() {
    typeof this.options.position < "u" ? (this.startX = this.parent.center.x, this.startY = this.parent.center.y, this.deltaX = this.options.position.x - this.parent.center.x, this.deltaY = this.options.position.y - this.parent.center.y, this.keepCenter = !1) : this.keepCenter = !0;
  }
  /**
   * Setup `startWidth, `startHeight`, `deltaWidth, `deltaHeight, `width`, `height`.
   *
   * This is called during construction.
   */
  setupZoom() {
    this.width = null, this.height = null, typeof this.options.scale < "u" ? this.width = this.parent.screenWidth / this.options.scale : typeof this.options.scaleX < "u" || typeof this.options.scaleY < "u" ? (typeof this.options.scaleX < "u" && (this.width = this.parent.screenWidth / this.options.scaleX), typeof this.options.scaleY < "u" && (this.height = this.parent.screenHeight / this.options.scaleY)) : (typeof this.options.width < "u" && (this.width = this.options.width), typeof this.options.height < "u" && (this.height = this.options.height)), this.width !== null && (this.startWidth = this.parent.screenWidthInWorldPixels, this.deltaWidth = this.width - this.startWidth), this.height !== null && (this.startHeight = this.parent.screenHeightInWorldPixels, this.deltaHeight = this.height - this.startHeight);
  }
  down() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("animate"), !1;
  }
  complete() {
    this.parent.plugins.remove("animate"), this.width !== null && this.parent.fitWidth(this.width, this.keepCenter, this.height === null), this.height !== null && this.parent.fitHeight(this.height, this.keepCenter, this.width === null), !this.keepCenter && this.options.position && this.parent.moveCenter(this.options.position), this.parent.emit("animate-end", this.parent), this.options.callbackOnComplete && this.options.callbackOnComplete(this.parent);
  }
  update(e) {
    if (this.paused)
      return;
    this.time += e;
    const n = new bt(this.parent.scale.x, this.parent.scale.y);
    if (this.time >= this.options.time) {
      const s = this.parent.width, a = this.parent.height;
      this.complete(), (s !== this.parent.width || a !== this.parent.height) && this.parent.emit("zoomed", { viewport: this.parent, original: n, type: "animate" });
    } else {
      const s = this.options.ease(this.time, 0, 1, this.options.time);
      if (this.width !== null) {
        const a = this.startWidth, o = this.deltaWidth;
        this.parent.fitWidth(
          a + o * s,
          this.keepCenter,
          this.height === null
        );
      }
      if (this.height !== null) {
        const a = this.startHeight, o = this.deltaHeight;
        this.parent.fitHeight(
          a + o * s,
          this.keepCenter,
          this.width === null
        );
      }
      if (this.width === null ? this.parent.scale.x = this.parent.scale.y : this.height === null && (this.parent.scale.y = this.parent.scale.x), !this.keepCenter) {
        const a = this.startX, o = this.startY, i = this.deltaX, r = this.deltaY, l = new bt(this.parent.x, this.parent.y);
        this.parent.moveCenter(a + i * s, o + r * s), this.parent.emit("moved", { viewport: this.parent, original: l, type: "animate" });
      }
      (this.width || this.height) && this.parent.emit("zoomed", { viewport: this.parent, original: n, type: "animate" });
    }
  }
};
const sg = {
  sides: "all",
  friction: 0.5,
  time: 150,
  ease: "easeInOutSine",
  underflow: "center",
  bounceBox: null
};
class ag extends Vt {
  /**
   * This is called by {@link Viewport.bounce}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, sg, n), this.ease = Co(this.options.ease, "easeInOutSine"), this.options.sides ? this.options.sides === "all" ? this.top = this.bottom = this.left = this.right = !0 : this.options.sides === "horizontal" ? (this.right = this.left = !0, this.top = this.bottom = !1) : this.options.sides === "vertical" ? (this.left = this.right = !1, this.top = this.bottom = !0) : (this.top = this.options.sides.indexOf("top") !== -1, this.bottom = this.options.sides.indexOf("bottom") !== -1, this.left = this.options.sides.indexOf("left") !== -1, this.right = this.options.sides.indexOf("right") !== -1) : this.left = this.top = this.right = this.bottom = !1;
    const s = this.options.underflow.toLowerCase();
    s === "center" ? (this.underflowX = 0, this.underflowY = 0) : (this.underflowX = s.indexOf("left") !== -1 ? -1 : s.indexOf("right") !== -1 ? 1 : 0, this.underflowY = s.indexOf("top") !== -1 ? -1 : s.indexOf("bottom") !== -1 ? 1 : 0), this.reset();
  }
  isActive() {
    return this.toX !== null || this.toY !== null;
  }
  down() {
    return this.toX = this.toY = null, !1;
  }
  up() {
    return this.bounce(), !1;
  }
  update(e) {
    if (!this.paused) {
      if (this.bounce(), this.toX) {
        const n = this.toX;
        n.time += e, this.parent.emit("moved", { viewport: this.parent, type: "bounce-x" }), n.time >= this.options.time ? (this.parent.x = n.end, this.toX = null, this.parent.emit("bounce-x-end", this.parent)) : this.parent.x = this.ease(n.time, n.start, n.delta, this.options.time);
      }
      if (this.toY) {
        const n = this.toY;
        n.time += e, this.parent.emit("moved", { viewport: this.parent, type: "bounce-y" }), n.time >= this.options.time ? (this.parent.y = n.end, this.toY = null, this.parent.emit("bounce-y-end", this.parent)) : this.parent.y = this.ease(n.time, n.start, n.delta, this.options.time);
      }
    }
  }
  /** @internal */
  calcUnderflowX() {
    let e;
    switch (this.underflowX) {
      case -1:
        e = 0;
        break;
      case 1:
        e = this.parent.screenWidth - this.parent.screenWorldWidth;
        break;
      default:
        e = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
    }
    return e;
  }
  /** @internal */
  calcUnderflowY() {
    let e;
    switch (this.underflowY) {
      case -1:
        e = 0;
        break;
      case 1:
        e = this.parent.screenHeight - this.parent.screenWorldHeight;
        break;
      default:
        e = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
    }
    return e;
  }
  oob() {
    const e = this.options.bounceBox;
    if (e) {
      const n = typeof e.x > "u" ? 0 : e.x, s = typeof e.y > "u" ? 0 : e.y, a = typeof e.width > "u" ? this.parent.worldWidth : e.width, o = typeof e.height > "u" ? this.parent.worldHeight : e.height;
      return {
        left: this.parent.left < n,
        right: this.parent.right > a,
        top: this.parent.top < s,
        bottom: this.parent.bottom > o,
        topLeft: new bt(
          n * this.parent.scale.x,
          s * this.parent.scale.y
        ),
        bottomRight: new bt(
          a * this.parent.scale.x - this.parent.screenWidth,
          o * this.parent.scale.y - this.parent.screenHeight
        )
      };
    }
    return {
      left: this.parent.left < 0,
      right: this.parent.right > this.parent.worldWidth,
      top: this.parent.top < 0,
      bottom: this.parent.bottom > this.parent.worldHeight,
      topLeft: new bt(0, 0),
      bottomRight: new bt(
        this.parent.worldWidth * this.parent.scale.x - this.parent.screenWidth,
        this.parent.worldHeight * this.parent.scale.y - this.parent.screenHeight
      )
    };
  }
  bounce() {
    var e, n;
    if (this.paused)
      return;
    let s, a = this.parent.plugins.get("decelerate", !0);
    a && (a.x || a.y) && (a.x && a.percentChangeX === ((e = a.options) == null ? void 0 : e.friction) || a.y && a.percentChangeY === ((n = a.options) == null ? void 0 : n.friction)) && (s = this.oob(), (s.left && this.left || s.right && this.right) && (a.percentChangeX = this.options.friction), (s.top && this.top || s.bottom && this.bottom) && (a.percentChangeY = this.options.friction));
    const o = this.parent.plugins.get("drag", !0) || {}, i = this.parent.plugins.get("pinch", !0) || {};
    if (a = a || {}, !(o != null && o.active) && !(i != null && i.active) && (!this.toX || !this.toY) && (!a.x || !a.y)) {
      s = s || this.oob();
      const r = s.topLeft, l = s.bottomRight;
      if (!this.toX && !a.x) {
        let u = null;
        s.left && this.left ? u = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -r.x : s.right && this.right && (u = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -l.x), u !== null && this.parent.x !== u && (this.toX = { time: 0, start: this.parent.x, delta: u - this.parent.x, end: u }, this.parent.emit("bounce-x-start", this.parent));
      }
      if (!this.toY && !a.y) {
        let u = null;
        s.top && this.top ? u = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -r.y : s.bottom && this.bottom && (u = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -l.y), u !== null && this.parent.y !== u && (this.toY = { time: 0, start: this.parent.y, delta: u - this.parent.y, end: u }, this.parent.emit("bounce-y-start", this.parent));
      }
    }
  }
  reset() {
    this.toX = this.toY = null, this.bounce();
  }
}
const og = {
  left: !1,
  right: !1,
  top: !1,
  bottom: !1,
  direction: null,
  underflow: "center"
};
let ig = class extends Vt {
  /**
   * This is called by {@link Viewport.clamp}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, og, n), this.options.direction && (this.options.left = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.right = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.top = this.options.direction === "y" || this.options.direction === "all" ? !0 : null, this.options.bottom = this.options.direction === "y" || this.options.direction === "all" ? !0 : null), this.parseUnderflow(), this.last = { x: null, y: null, scaleX: null, scaleY: null }, this.update();
  }
  parseUnderflow() {
    const e = this.options.underflow.toLowerCase();
    e === "none" ? this.noUnderflow = !0 : e === "center" ? (this.underflowX = this.underflowY = 0, this.noUnderflow = !1) : (this.underflowX = e.indexOf("left") !== -1 ? -1 : e.indexOf("right") !== -1 ? 1 : 0, this.underflowY = e.indexOf("top") !== -1 ? -1 : e.indexOf("bottom") !== -1 ? 1 : 0, this.noUnderflow = !1);
  }
  move() {
    return this.update(), !1;
  }
  update() {
    if (this.paused || this.parent.x === this.last.x && this.parent.y === this.last.y && this.parent.scale.x === this.last.scaleX && this.parent.scale.y === this.last.scaleY)
      return;
    const e = new bt(this.parent.x, this.parent.y), n = this.parent.plugins.decelerate || {};
    if (this.options.left !== null || this.options.right !== null) {
      let s = !1;
      if (!this.noUnderflow && this.parent.screenWorldWidth < this.parent.screenWidth)
        switch (this.underflowX) {
          case -1:
            this.parent.x !== 0 && (this.parent.x = 0, s = !0);
            break;
          case 1:
            this.parent.x !== this.parent.screenWidth - this.parent.screenWorldWidth && (this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth, s = !0);
            break;
          default:
            this.parent.x !== (this.parent.screenWidth - this.parent.screenWorldWidth) / 2 && (this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2, s = !0);
        }
      else
        this.options.left !== null && this.parent.left < (this.options.left === !0 ? 0 : this.options.left) && (this.parent.x = -(this.options.left === !0 ? 0 : this.options.left) * this.parent.scale.x, n.x = 0, s = !0), this.options.right !== null && this.parent.right > (this.options.right === !0 ? this.parent.worldWidth : this.options.right) && (this.parent.x = -(this.options.right === !0 ? this.parent.worldWidth : this.options.right) * this.parent.scale.x + this.parent.screenWidth, n.x = 0, s = !0);
      s && this.parent.emit("moved", { viewport: this.parent, original: e, type: "clamp-x" });
    }
    if (this.options.top !== null || this.options.bottom !== null) {
      let s = !1;
      if (!this.noUnderflow && this.parent.screenWorldHeight < this.parent.screenHeight)
        switch (this.underflowY) {
          case -1:
            this.parent.y !== 0 && (this.parent.y = 0, s = !0);
            break;
          case 1:
            this.parent.y !== this.parent.screenHeight - this.parent.screenWorldHeight && (this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight, s = !0);
            break;
          default:
            this.parent.y !== (this.parent.screenHeight - this.parent.screenWorldHeight) / 2 && (this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2, s = !0);
        }
      else
        this.options.top !== null && this.parent.top < (this.options.top === !0 ? 0 : this.options.top) && (this.parent.y = -(this.options.top === !0 ? 0 : this.options.top) * this.parent.scale.y, n.y = 0, s = !0), this.options.bottom !== null && this.parent.bottom > (this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) && (this.parent.y = -(this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) * this.parent.scale.y + this.parent.screenHeight, n.y = 0, s = !0);
      s && this.parent.emit("moved", { viewport: this.parent, original: e, type: "clamp-y" });
    }
    this.last.x = this.parent.x, this.last.y = this.parent.y, this.last.scaleX = this.parent.scale.x, this.last.scaleY = this.parent.scale.y;
  }
  reset() {
    this.update();
  }
};
const rg = {
  minWidth: null,
  minHeight: null,
  maxWidth: null,
  maxHeight: null,
  minScale: null,
  maxScale: null
};
class lg extends Vt {
  /**
   * This is called by {@link Viewport.clampZoom}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, rg, n), this.clamp();
  }
  resize() {
    this.clamp();
  }
  /** Clamp the viewport scale zoom) */
  clamp() {
    if (!this.paused) {
      if (this.options.minWidth || this.options.minHeight || this.options.maxWidth || this.options.maxHeight) {
        let e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight;
        if (this.options.minWidth !== null && e < this.options.minWidth) {
          const s = this.parent.scale.x;
          this.parent.fitWidth(this.options.minWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / s, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.maxWidth !== null && e > this.options.maxWidth) {
          const s = this.parent.scale.x;
          this.parent.fitWidth(this.options.maxWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / s, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.minHeight !== null && n < this.options.minHeight) {
          const s = this.parent.scale.y;
          this.parent.fitHeight(this.options.minHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / s, e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
        if (this.options.maxHeight !== null && n > this.options.maxHeight) {
          const s = this.parent.scale.y;
          this.parent.fitHeight(this.options.maxHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / s, this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" });
        }
      } else if (this.options.minScale || this.options.maxScale) {
        const e = { x: null, y: null }, n = { x: null, y: null };
        if (typeof this.options.minScale == "number")
          e.x = this.options.minScale, e.y = this.options.minScale;
        else if (this.options.minScale !== null) {
          const o = this.options.minScale;
          e.x = typeof o.x > "u" ? null : o.x, e.y = typeof o.y > "u" ? null : o.y;
        }
        if (typeof this.options.maxScale == "number")
          n.x = this.options.maxScale, n.y = this.options.maxScale;
        else if (this.options.maxScale !== null) {
          const o = this.options.maxScale;
          n.x = typeof o.x > "u" ? null : o.x, n.y = typeof o.y > "u" ? null : o.y;
        }
        let s = this.parent.scale.x, a = this.parent.scale.y;
        e.x !== null && s < e.x && (s = e.x), n.x !== null && s > n.x && (s = n.x), e.y !== null && a < e.y && (a = e.y), n.y !== null && a > n.y && (a = n.y), (s !== this.parent.scale.x || a !== this.parent.scale.y) && (this.parent.scale.set(s, a), this.parent.emit("zoomed", { viewport: this.parent, type: "clamp-zoom" }));
      }
    }
  }
  reset() {
    this.clamp();
  }
}
const cg = {
  friction: 0.98,
  bounce: 0.8,
  minSpeed: 0.01
}, On = 16;
class ug extends Vt {
  /**
   * This is called by {@link Viewport.decelerate}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, cg, n), this.saved = [], this.timeSinceRelease = 0, this.reset(), this.parent.on("moved", (s) => this.handleMoved(s));
  }
  down() {
    return this.saved = [], this.x = this.y = null, !1;
  }
  isActive() {
    return !!(this.x || this.y);
  }
  move() {
    if (this.paused)
      return !1;
    const e = this.parent.input.count();
    return (e === 1 || e > 1 && !this.parent.plugins.get("pinch", !0)) && (this.saved.push({ x: this.parent.x, y: this.parent.y, time: performance.now() }), this.saved.length > 60 && this.saved.splice(0, 30)), !1;
  }
  /** Listener to viewport's "moved" event. */
  handleMoved(e) {
    if (this.saved.length) {
      const n = this.saved[this.saved.length - 1];
      e.type === "clamp-x" && e.original ? n.x === e.original.x && (n.x = this.parent.x) : e.type === "clamp-y" && e.original && n.y === e.original.y && (n.y = this.parent.y);
    }
  }
  up() {
    if (this.parent.input.count() === 0 && this.saved.length) {
      const e = performance.now();
      for (const n of this.saved)
        if (n.time >= e - 100) {
          const s = e - n.time;
          this.x = (this.parent.x - n.x) / s, this.y = (this.parent.y - n.y) / s, this.percentChangeX = this.percentChangeY = this.options.friction, this.timeSinceRelease = 0;
          break;
        }
    }
    return !1;
  }
  /**
   * Manually activate deceleration, starting from the (x, y) velocity components passed in the options.
   *
   * @param {object} options
   * @param {number} [options.x] - Specify x-component of initial velocity.
   * @param {number} [options.y] - Specify y-component of initial velocity.
   */
  activate(e) {
    e = e || {}, typeof e.x < "u" && (this.x = e.x, this.percentChangeX = this.options.friction), typeof e.y < "u" && (this.y = e.y, this.percentChangeY = this.options.friction);
  }
  update(e) {
    if (this.paused)
      return;
    const n = this.x || this.y, s = this.timeSinceRelease, a = this.timeSinceRelease + e;
    if (this.x) {
      const o = this.percentChangeX, i = Math.log(o);
      this.parent.x += this.x * On / i * (Math.pow(o, a / On) - Math.pow(o, s / On)), this.x *= Math.pow(this.percentChangeX, e / On);
    }
    if (this.y) {
      const o = this.percentChangeY, i = Math.log(o);
      this.parent.y += this.y * On / i * (Math.pow(o, a / On) - Math.pow(o, s / On)), this.y *= Math.pow(this.percentChangeY, e / On);
    }
    this.timeSinceRelease += e, this.x && this.y ? Math.abs(this.x) < this.options.minSpeed && Math.abs(this.y) < this.options.minSpeed && (this.x = 0, this.y = 0) : (Math.abs(this.x || 0) < this.options.minSpeed && (this.x = 0), Math.abs(this.y || 0) < this.options.minSpeed && (this.y = 0)), n && this.parent.emit("moved", { viewport: this.parent, type: "decelerate" });
  }
  reset() {
    this.x = this.y = null;
  }
}
const dg = {
  direction: "all",
  pressDrag: !0,
  wheel: !0,
  wheelScroll: 1,
  reverse: !1,
  clampWheel: !1,
  underflow: "center",
  factor: 1,
  mouseButtons: "all",
  keyToPress: null,
  ignoreKeyToPressOnTouch: !1,
  lineHeight: 20,
  wheelSwapAxes: !1
};
let mg = class extends Vt {
  /**
   * This is called by {@link Viewport.drag}.
   */
  constructor(e, n = {}) {
    super(e), this.windowEventHandlers = [], this.options = Object.assign({}, dg, n), this.moved = !1, this.reverse = this.options.reverse ? 1 : -1, this.xDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "x", this.yDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "y", this.keyIsPressed = !1, this.parseUnderflow(), this.mouseButtons(this.options.mouseButtons), this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger drag event
   */
  handleKeyPresses(e) {
    const n = (a) => {
      e.includes(a.code) && (this.keyIsPressed = !0);
    }, s = (a) => {
      e.includes(a.code) && (this.keyIsPressed = !1);
    };
    this.addWindowEventHandler("keyup", s), this.addWindowEventHandler("keydown", n);
  }
  addWindowEventHandler(e, n) {
    typeof window > "u" || (window.addEventListener(e, n), this.windowEventHandlers.push({ event: e, handler: n }));
  }
  destroy() {
    typeof window > "u" || this.windowEventHandlers.forEach(({ event: e, handler: n }) => {
      window.removeEventListener(e, n);
    });
  }
  /**
   * initialize mousebuttons array
   * @param {string} buttons
   */
  mouseButtons(e) {
    !e || e === "all" ? this.mouse = [!0, !0, !0] : this.mouse = [
      e.indexOf("left") !== -1,
      e.indexOf("middle") !== -1,
      e.indexOf("right") !== -1
    ];
  }
  parseUnderflow() {
    const e = this.options.underflow.toLowerCase();
    e === "center" ? (this.underflowX = 0, this.underflowY = 0) : (e.includes("left") ? this.underflowX = -1 : e.includes("right") ? this.underflowX = 1 : this.underflowX = 0, e.includes("top") ? this.underflowY = -1 : e.includes("bottom") ? this.underflowY = 1 : this.underflowY = 0);
  }
  /**
   * @param {PIXI.FederatedPointerEvent} event
   * @returns {boolean}
   */
  checkButtons(e) {
    const n = e.pointerType === "mouse", s = this.parent.input.count();
    return !!((s === 1 || s > 1 && !this.parent.plugins.get("pinch", !0)) && (!n || this.mouse[e.button]));
  }
  /**
   * @param {PIXI.FederatedPointerEvent} event
   * @returns {boolean}
   */
  checkKeyPress(e) {
    return !this.options.keyToPress || this.keyIsPressed || this.options.ignoreKeyToPressOnTouch && e.data.pointerType === "touch";
  }
  down(e) {
    return this.paused || !this.options.pressDrag ? !1 : this.checkButtons(e) && this.checkKeyPress(e) ? (this.last = { x: e.global.x, y: e.global.y }, this.current = e.pointerId, !0) : (this.last = null, !1);
  }
  get active() {
    return this.moved;
  }
  move(e) {
    if (this.paused || !this.options.pressDrag)
      return !1;
    if (this.last && this.current === e.data.pointerId) {
      const n = e.global.x, s = e.global.y, a = this.parent.input.count();
      if (a === 1 || a > 1 && !this.parent.plugins.get("pinch", !0)) {
        const o = n - this.last.x, i = s - this.last.y;
        if (this.moved || this.xDirection && this.parent.input.checkThreshold(o) || this.yDirection && this.parent.input.checkThreshold(i)) {
          const r = { x: n, y: s };
          return this.xDirection && (this.parent.x += (r.x - this.last.x) * this.options.factor), this.yDirection && (this.parent.y += (r.y - this.last.y) * this.options.factor), this.last = r, this.moved || this.parent.emit("drag-start", {
            event: e,
            screen: new bt(this.last.x, this.last.y),
            world: this.parent.toWorld(new bt(this.last.x, this.last.y)),
            viewport: this.parent
          }), this.moved = !0, this.parent.emit("moved", { viewport: this.parent, type: "drag" }), !0;
        }
      } else
        this.moved = !1;
    }
    return !1;
  }
  up(e) {
    if (this.paused)
      return !1;
    const n = this.parent.input.touches;
    if (n.length === 1) {
      const s = n[0];
      return s.last && (this.last = { x: s.last.x, y: s.last.y }, this.current = s.id), this.moved = !1, !0;
    } else if (this.last && this.moved) {
      const s = new bt(this.last.x, this.last.y);
      return this.parent.emit("drag-end", {
        event: e,
        screen: s,
        world: this.parent.toWorld(s),
        viewport: this.parent
      }), this.last = null, this.moved = !1, !0;
    }
    return !1;
  }
  wheel(e) {
    if (this.paused)
      return !1;
    if (this.options.wheel) {
      const n = this.parent.plugins.get("wheel", !0);
      if (!n || !n.options.wheelZoom && !e.ctrlKey) {
        const s = e.deltaMode ? this.options.lineHeight : 1, a = [e.deltaX, e.deltaY], [o, i] = this.options.wheelSwapAxes ? a.reverse() : a;
        return this.xDirection && (this.parent.x += o * s * this.options.wheelScroll * this.reverse), this.yDirection && (this.parent.y += i * s * this.options.wheelScroll * this.reverse), this.options.clampWheel && this.clamp(), this.parent.emit("wheel-scroll", this.parent), this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.options.passiveWheel || e.preventDefault(), this.parent.options.stopPropagation && e.stopPropagation(), !0;
      }
    }
    return !1;
  }
  resume() {
    this.last = null, this.paused = !1;
  }
  clamp() {
    const e = this.parent.plugins.get("decelerate", !0) || {};
    if (this.options.clampWheel !== "y")
      if (this.parent.screenWorldWidth < this.parent.screenWidth)
        switch (this.underflowX) {
          case -1:
            this.parent.x = 0;
            break;
          case 1:
            this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
            break;
          default:
            this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
        }
      else
        this.parent.left < 0 ? (this.parent.x = 0, e.x = 0) : this.parent.right > this.parent.worldWidth && (this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth, e.x = 0);
    if (this.options.clampWheel !== "x")
      if (this.parent.screenWorldHeight < this.parent.screenHeight)
        switch (this.underflowY) {
          case -1:
            this.parent.y = 0;
            break;
          case 1:
            this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
            break;
          default:
            this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
        }
      else
        this.parent.top < 0 && (this.parent.y = 0, e.y = 0), this.parent.bottom > this.parent.worldHeight && (this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight, e.y = 0);
  }
};
const hg = {
  speed: 0,
  acceleration: null,
  radius: null
};
let pg = class extends Vt {
  /**
   * This is called by {@link Viewport.follow}.
   *
   * @param parent
   * @param target - target to follow
   * @param options
   */
  constructor(e, n, s = {}) {
    super(e), this.target = n, this.options = Object.assign({}, hg, s), this.velocity = { x: 0, y: 0 };
  }
  update(e) {
    if (this.paused)
      return;
    const n = this.parent.center;
    let s = this.target.x, a = this.target.y;
    if (this.options.radius)
      if (Math.sqrt(Math.pow(this.target.y - n.y, 2) + Math.pow(this.target.x - n.x, 2)) > this.options.radius) {
        const r = Math.atan2(this.target.y - n.y, this.target.x - n.x);
        s = this.target.x - Math.cos(r) * this.options.radius, a = this.target.y - Math.sin(r) * this.options.radius;
      } else
        return;
    const o = s - n.x, i = a - n.y;
    if (o || i)
      if (this.options.speed)
        if (this.options.acceleration) {
          const r = Math.atan2(a - n.y, s - n.x), l = Math.sqrt(Math.pow(o, 2) + Math.pow(i, 2));
          if (l) {
            const u = (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2)) / (2 * this.options.acceleration);
            l > u ? this.velocity = {
              x: Math.min(this.velocity.x + (this.options.acceleration * e, this.options.speed)),
              y: Math.min(this.velocity.y + (this.options.acceleration * e, this.options.speed))
            } : this.velocity = {
              x: Math.max(this.velocity.x - this.options.acceleration * this.options.speed, 0),
              y: Math.max(this.velocity.y - this.options.acceleration * this.options.speed, 0)
            };
            const m = Math.cos(r) * this.velocity.x, h = Math.sin(r) * this.velocity.y, v = Math.abs(m) > Math.abs(o) ? s : n.x + m, _ = Math.abs(h) > Math.abs(i) ? a : n.y + h;
            this.parent.moveCenter(v, _), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
          }
        } else {
          const r = Math.atan2(a - n.y, s - n.x), l = Math.cos(r) * this.options.speed, u = Math.sin(r) * this.options.speed, m = Math.abs(l) > Math.abs(o) ? s : n.x + l, h = Math.abs(u) > Math.abs(i) ? a : n.y + u;
          this.parent.moveCenter(m, h), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
        }
      else
        this.parent.moveCenter(s, a), this.parent.emit("moved", { viewport: this.parent, type: "follow" });
  }
};
const fg = {
  radius: null,
  distance: null,
  top: null,
  bottom: null,
  left: null,
  right: null,
  speed: 8,
  reverse: !1,
  noDecelerate: !1,
  linear: !1,
  allowButtons: !1
};
let vg = class extends Vt {
  /**
   * This is called by {@link Viewport.mouseEdges}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, fg, n), this.reverse = this.options.reverse ? 1 : -1, this.radiusSquared = typeof this.options.radius == "number" ? Math.pow(this.options.radius, 2) : null, this.resize();
  }
  resize() {
    const e = this.options.distance;
    e !== null ? (this.left = e, this.top = e, this.right = this.parent.screenWidth - e, this.bottom = this.parent.screenHeight - e) : this.options.radius || (this.left = this.options.left, this.top = this.options.top, this.right = this.options.right === null ? null : this.parent.screenWidth - this.options.right, this.bottom = this.options.bottom === null ? null : this.parent.screenHeight - this.options.bottom);
  }
  down() {
    return this.paused || this.options.allowButtons || (this.horizontal = this.vertical = null), !1;
  }
  move(e) {
    if (this.paused || e.pointerType !== "mouse" && e.pointerId !== 1 || !this.options.allowButtons && e.buttons !== 0)
      return !1;
    const n = e.global.x, s = e.global.y;
    if (this.radiusSquared) {
      const a = this.parent.toScreen(this.parent.center);
      if (Math.pow(a.x - n, 2) + Math.pow(a.y - s, 2) >= this.radiusSquared) {
        const o = Math.atan2(a.y - s, a.x - n);
        this.options.linear ? (this.horizontal = Math.round(Math.cos(o)) * this.options.speed * this.reverse * (60 / 1e3), this.vertical = Math.round(Math.sin(o)) * this.options.speed * this.reverse * (60 / 1e3)) : (this.horizontal = Math.cos(o) * this.options.speed * this.reverse * (60 / 1e3), this.vertical = Math.sin(o) * this.options.speed * this.reverse * (60 / 1e3));
      } else
        this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = 0;
    } else
      this.left !== null && n < this.left ? this.horizontal = Number(this.reverse) * this.options.speed * (60 / 1e3) : this.right !== null && n > this.right ? this.horizontal = -1 * this.reverse * this.options.speed * (60 / 1e3) : (this.decelerateHorizontal(), this.horizontal = 0), this.top !== null && s < this.top ? this.vertical = Number(this.reverse) * this.options.speed * (60 / 1e3) : this.bottom !== null && s > this.bottom ? this.vertical = -1 * this.reverse * this.options.speed * (60 / 1e3) : (this.decelerateVertical(), this.vertical = 0);
    return !1;
  }
  decelerateHorizontal() {
    const e = this.parent.plugins.get("decelerate", !0);
    this.horizontal && e && !this.options.noDecelerate && e.activate({ x: this.horizontal * this.options.speed * this.reverse / (1e3 / 60) });
  }
  decelerateVertical() {
    const e = this.parent.plugins.get("decelerate", !0);
    this.vertical && e && !this.options.noDecelerate && e.activate({ y: this.vertical * this.options.speed * this.reverse / (1e3 / 60) });
  }
  up() {
    return this.paused || (this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = null), !1;
  }
  update() {
    if (!this.paused && (this.horizontal || this.vertical)) {
      const e = this.parent.center;
      this.horizontal && (e.x += this.horizontal * this.options.speed), this.vertical && (e.y += this.vertical * this.options.speed), this.parent.moveCenter(e), this.parent.emit("moved", { viewport: this.parent, type: "mouse-edges" });
    }
  }
};
const gg = {
  noDrag: !1,
  percent: 1,
  center: null,
  factor: 1,
  axis: "all"
};
class _g extends Vt {
  /**
   * This is called by {@link Viewport.pinch}.
   */
  constructor(e, n = {}) {
    super(e), this.active = !1, this.pinching = !1, this.moved = !1, this.options = Object.assign({}, gg, n);
  }
  down() {
    return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  move(e) {
    if (this.paused || !this.active)
      return !1;
    const n = e.global.x, s = e.global.y, a = this.parent.input.touches;
    if (a.length >= 2) {
      const o = a[0], i = a[1], r = o.last && i.last ? Math.sqrt(Math.pow(i.last.x - o.last.x, 2) + Math.pow(i.last.y - o.last.y, 2)) : null;
      if (o.id === e.pointerId ? o.last = { x: n, y: s, data: e } : i.id === e.pointerId && (i.last = { x: n, y: s, data: e }), r) {
        let l;
        const u = new bt(
          o.last.x + (i.last.x - o.last.x) / 2,
          o.last.y + (i.last.y - o.last.y) / 2
        );
        this.options.center || (l = this.parent.toLocal(u));
        let m = Math.sqrt(Math.pow(
          i.last.x - o.last.x,
          2
        ) + Math.pow(i.last.y - o.last.y, 2));
        m = m === 0 ? m = 1e-10 : m;
        const h = (1 - r / m) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
        this.isAxisX() && (this.parent.scale.x += h), this.isAxisY() && (this.parent.scale.y += h), this.parent.emit("zoomed", { viewport: this.parent, type: "pinch", center: u });
        const v = this.parent.plugins.get("clamp-zoom", !0);
        if (v && v.clamp(), this.options.center)
          this.parent.moveCenter(this.options.center);
        else {
          const _ = this.parent.toGlobal(l);
          this.parent.x += (u.x - _.x) * this.options.factor, this.parent.y += (u.y - _.y) * this.options.factor, this.parent.emit("moved", { viewport: this.parent, type: "pinch" });
        }
        !this.options.noDrag && this.lastCenter && (this.parent.x += (u.x - this.lastCenter.x) * this.options.factor, this.parent.y += (u.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", { viewport: this.parent, type: "pinch" })), this.lastCenter = u, this.moved = !0;
      } else
        this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
      return !0;
    }
    return !1;
  }
  up() {
    return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = null, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
  }
}
const kg = {
  topLeft: !1,
  friction: 0.8,
  time: 1e3,
  ease: "easeInOutSine",
  interrupt: !0,
  removeOnComplete: !1,
  removeOnInterrupt: !1,
  forceStart: !1
};
let yg = class extends Vt {
  /**
   * This is called by {@link Viewport.snap}.
   */
  constructor(e, n, s, a = {}) {
    super(e), this.options = Object.assign({}, kg, a), this.ease = Co(a.ease, "easeInOutSine"), this.x = n, this.y = s, this.options.forceStart && this.snapStart();
  }
  snapStart() {
    this.percent = 0, this.snapping = { time: 0 };
    const e = this.options.topLeft ? this.parent.corner : this.parent.center;
    this.deltaX = this.x - e.x, this.deltaY = this.y - e.y, this.startX = e.x, this.startY = e.y, this.parent.emit("snap-start", this.parent);
  }
  wheel() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("snap"), !1;
  }
  down() {
    return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap") : this.options.interrupt && (this.snapping = null), !1;
  }
  up() {
    if (this.parent.input.count() === 0) {
      const e = this.parent.plugins.get("decelerate", !0);
      e && (e.x || e.y) && (e.percentChangeX = e.percentChangeY = this.options.friction);
    }
    return !1;
  }
  update(e) {
    if (!this.paused && !(this.options.interrupt && this.parent.input.count() !== 0))
      if (this.snapping) {
        const n = this.snapping;
        n.time += e;
        let s, a, o;
        const i = this.startX, r = this.startY, l = this.deltaX, u = this.deltaY;
        if (n.time > this.options.time)
          s = !0, a = i + l, o = r + u;
        else {
          const m = this.ease(n.time, 0, 1, this.options.time);
          a = i + l * m, o = r + u * m;
        }
        this.options.topLeft ? this.parent.moveCorner(a, o) : this.parent.moveCenter(a, o), this.parent.emit("moved", { viewport: this.parent, type: "snap" }), s && (this.options.removeOnComplete && this.parent.plugins.remove("snap"), this.parent.emit("snap-end", this.parent), this.snapping = null);
      } else {
        const n = this.options.topLeft ? this.parent.corner : this.parent.center;
        (n.x !== this.x || n.y !== this.y) && this.snapStart();
      }
  }
};
const bg = {
  width: 0,
  height: 0,
  time: 1e3,
  ease: "easeInOutSine",
  center: null,
  interrupt: !0,
  removeOnComplete: !1,
  removeOnInterrupt: !1,
  forceStart: !1,
  noMove: !1
};
let wg = class extends Vt {
  /**
   * This is called by {@link Viewport.snapZoom}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, bg, n), this.ease = Co(this.options.ease), this.xIndependent = !1, this.yIndependent = !1, this.xScale = 0, this.yScale = 0, this.options.width > 0 && (this.xScale = e.screenWidth / this.options.width, this.xIndependent = !0), this.options.height > 0 && (this.yScale = e.screenHeight / this.options.height, this.yIndependent = !0), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale, this.options.time === 0 ? (e.container.scale.x = this.xScale, e.container.scale.y = this.yScale, this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom")) : n.forceStart && this.createSnapping();
  }
  createSnapping() {
    const e = this.parent.worldScreenWidth, n = this.parent.worldScreenHeight, s = this.parent.screenWidth / this.xScale, a = this.parent.screenHeight / this.yScale;
    this.snapping = {
      time: 0,
      startX: e,
      startY: n,
      deltaX: s - e,
      deltaY: a - n
    }, this.parent.emit("snap-zoom-start", this.parent);
  }
  resize() {
    this.snapping = null, this.options.width > 0 && (this.xScale = this.parent.screenWidth / this.options.width), this.options.height > 0 && (this.yScale = this.parent.screenHeight / this.options.height), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale;
  }
  wheel() {
    return this.options.removeOnInterrupt && this.parent.plugins.remove("snap-zoom"), !1;
  }
  down() {
    return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap-zoom") : this.options.interrupt && (this.snapping = null), !1;
  }
  update(e) {
    if (this.paused || this.options.interrupt && this.parent.input.count() !== 0)
      return;
    let n;
    if (!this.options.center && !this.options.noMove && (n = this.parent.center), !this.snapping)
      (this.parent.scale.x !== this.xScale || this.parent.scale.y !== this.yScale) && this.createSnapping();
    else if (this.snapping) {
      const s = this.snapping;
      if (s.time += e, s.time >= this.options.time)
        this.parent.scale.set(this.xScale, this.yScale), this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom"), this.parent.emit("snap-zoom-end", this.parent), this.snapping = null;
      else {
        const o = this.snapping, i = this.ease(o.time, o.startX, o.deltaX, this.options.time), r = this.ease(o.time, o.startY, o.deltaY, this.options.time);
        this.parent.scale.x = this.parent.screenWidth / i, this.parent.scale.y = this.parent.screenHeight / r;
      }
      const a = this.parent.plugins.get("clamp-zoom", !0);
      a && a.clamp(), this.options.noMove || (this.options.center ? this.parent.moveCenter(this.options.center) : this.parent.moveCenter(n));
    }
  }
  resume() {
    this.snapping = null, super.resume();
  }
};
const xg = {
  percent: 0.1,
  smooth: !1,
  interrupt: !0,
  reverse: !1,
  center: null,
  lineHeight: 20,
  axis: "all",
  keyToPress: null,
  trackpadPinch: !1,
  wheelZoom: !0
};
let $g = class extends Vt {
  /**
   * This is called by {@link Viewport.wheel}.
   */
  constructor(e, n = {}) {
    super(e), this.options = Object.assign({}, xg, n), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger zoom event
   */
  handleKeyPresses(e) {
    typeof window > "u" || (window.addEventListener("keydown", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !0);
    }), window.addEventListener("keyup", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !1);
    }));
  }
  checkKeyPress() {
    return !this.options.keyToPress || this.keyIsPressed;
  }
  down() {
    return this.options.interrupt && (this.smoothing = null), !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  update() {
    if (this.smoothing) {
      const e = this.smoothingCenter, n = this.smoothing;
      let s;
      this.options.center || (s = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x += n.x), this.isAxisY() && (this.parent.scale.y += n.y), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
      const a = this.parent.plugins.get("clamp-zoom", !0);
      if (a && a.clamp(), this.options.center)
        this.parent.moveCenter(this.options.center);
      else {
        const o = this.parent.toGlobal(s);
        this.parent.x += e.x - o.x, this.parent.y += e.y - o.y;
      }
      this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.smoothingCount++, this.smoothingCount >= this.options.smooth && (this.smoothing = null);
    }
  }
  pinch(e) {
    if (this.paused)
      return;
    const n = this.parent.input.getPointerPosition(e), s = -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 200, a = Math.pow(2, (1 + this.options.percent) * s);
    let o;
    this.options.center || (o = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= a), this.isAxisY() && (this.parent.scale.y *= a), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
    const i = this.parent.plugins.get("clamp-zoom", !0);
    if (i && i.clamp(), this.options.center)
      this.parent.moveCenter(this.options.center);
    else {
      const r = this.parent.toGlobal(o);
      this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
    }
    this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.emit(
      "wheel-start",
      { event: e, viewport: this.parent }
    );
  }
  wheel(e) {
    if (this.paused || !this.checkKeyPress())
      return !1;
    if (e.ctrlKey && this.options.trackpadPinch)
      this.pinch(e);
    else if (this.options.wheelZoom) {
      const n = this.parent.input.getPointerPosition(e), s = (this.options.reverse ? -1 : 1) * -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 500, a = Math.pow(2, (1 + this.options.percent) * s);
      if (this.options.smooth) {
        const o = {
          x: this.smoothing ? this.smoothing.x * (this.options.smooth - this.smoothingCount) : 0,
          y: this.smoothing ? this.smoothing.y * (this.options.smooth - this.smoothingCount) : 0
        };
        this.smoothing = {
          x: ((this.parent.scale.x + o.x) * a - this.parent.scale.x) / this.options.smooth,
          y: ((this.parent.scale.y + o.y) * a - this.parent.scale.y) / this.options.smooth
        }, this.smoothingCount = 0, this.smoothingCenter = n;
      } else {
        let o;
        this.options.center || (o = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= a), this.isAxisY() && (this.parent.scale.y *= a), this.parent.emit("zoomed", { viewport: this.parent, type: "wheel" });
        const i = this.parent.plugins.get("clamp-zoom", !0);
        if (i && i.clamp(), this.options.center)
          this.parent.moveCenter(this.options.center);
        else {
          const r = this.parent.toGlobal(o);
          this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
        }
      }
      this.parent.emit("moved", { viewport: this.parent, type: "wheel" }), this.parent.emit(
        "wheel-start",
        { event: e, viewport: this.parent }
      );
    }
    return !this.parent.options.passiveWheel;
  }
}, Sg = class {
  constructor(e) {
    this.viewport = e, this.touches = [], this.addListeners();
  }
  /** Add input listeners */
  addListeners() {
    this.viewport.eventMode = "static", this.viewport.forceHitArea || (this.viewport.hitArea = new Qa(0, 0, this.viewport.worldWidth, this.viewport.worldHeight)), this.viewport.on("pointerdown", this.down, this), this.viewport.options.allowPreserveDragOutside ? this.viewport.on("globalpointermove", this.move, this) : this.viewport.on("pointermove", this.move, this), this.viewport.on("pointerup", this.up, this), this.viewport.on("pointerupoutside", this.up, this), this.viewport.on("pointercancel", this.up, this), this.viewport.options.allowPreserveDragOutside || this.viewport.on("pointerleave", this.up, this), this.wheelFunction = (e) => this.handleWheel(e), this.viewport.options.events.domElement.addEventListener(
      "wheel",
      this.wheelFunction,
      { passive: this.viewport.options.passiveWheel }
    ), this.isMouseDown = !1;
  }
  /**
   * Removes all event listeners from viewport
   * (useful for cleanup of wheel when removing viewport)
   */
  destroy() {
    var e;
    (e = this.viewport.options.events.domElement) == null || e.removeEventListener("wheel", this.wheelFunction);
  }
  /**
   * handle down events for viewport
   *
   * @param {PIXI.FederatedPointerEvent} event
   */
  down(e) {
    if (!(this.viewport.pause || !this.viewport.visible)) {
      if (e.pointerType === "mouse" ? this.isMouseDown = !0 : this.get(e.pointerId) || this.touches.push({ id: e.pointerId, last: null }), this.count() === 1) {
        this.last = e.global.clone();
        const n = this.viewport.plugins.get("decelerate", !0), s = this.viewport.plugins.get("bounce", !0);
        (!n || !n.isActive()) && (!s || !s.isActive()) ? this.clickedAvailable = !0 : this.clickedAvailable = !1;
      } else
        this.clickedAvailable = !1;
      this.viewport.plugins.down(e) && this.viewport.options.stopPropagation && e.stopPropagation();
    }
  }
  /** Clears all pointer events */
  clear() {
    this.isMouseDown = !1, this.touches = [], this.last = null;
  }
  /**
   * @param {number} change
   * @returns whether change exceeds threshold
   */
  checkThreshold(e) {
    return Math.abs(e) >= this.viewport.threshold;
  }
  /** Handle move events for viewport */
  move(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    const n = this.viewport.plugins.move(e);
    if (this.clickedAvailable && this.last) {
      const s = e.global.x - this.last.x, a = e.global.y - this.last.y;
      (this.checkThreshold(s) || this.checkThreshold(a)) && (this.clickedAvailable = !1);
    }
    n && this.viewport.options.stopPropagation && e.stopPropagation();
  }
  /** Handle up events for viewport */
  up(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    e.pointerType === "mouse" && (this.isMouseDown = !1), e.pointerType !== "mouse" && this.remove(e.pointerId);
    const n = this.viewport.plugins.up(e);
    this.clickedAvailable && this.count() === 0 && this.last && (this.viewport.emit("clicked", {
      event: e,
      screen: this.last,
      world: this.viewport.toWorld(this.last),
      viewport: this.viewport
    }), this.clickedAvailable = !1), n && this.viewport.options.stopPropagation && e.stopPropagation();
  }
  /** Gets pointer position if this.interaction is set */
  getPointerPosition(e) {
    const n = new bt();
    return this.viewport.options.events.mapPositionToPoint(n, e.clientX, e.clientY), n;
  }
  /** Handle wheel events */
  handleWheel(e) {
    if (this.viewport.pause || !this.viewport.visible)
      return;
    const n = this.viewport.toLocal(this.getPointerPosition(e));
    this.viewport.left <= n.x && n.x <= this.viewport.right && this.viewport.top <= n.y && n.y <= this.viewport.bottom && this.viewport.plugins.wheel(e) && !this.viewport.options.passiveWheel && e.preventDefault();
  }
  pause() {
    this.touches = [], this.isMouseDown = !1;
  }
  /** Get touch by id */
  get(e) {
    for (const n of this.touches)
      if (n.id === e)
        return n;
    return null;
  }
  /** Remove touch by number */
  remove(e) {
    for (let n = 0; n < this.touches.length; n++)
      if (this.touches[n].id === e) {
        this.touches.splice(n, 1);
        return;
      }
  }
  /**
   * @returns {number} count of mouse/touch pointers that are down on the viewport
   */
  count() {
    return (this.isMouseDown ? 1 : 0) + this.touches.length;
  }
};
const ea = [
  "drag",
  "pinch",
  "wheel",
  "follow",
  "mouse-edges",
  "decelerate",
  "animate",
  "bounce",
  "snap-zoom",
  "clamp-zoom",
  "snap",
  "clamp"
];
class Ag {
  /** This is called by {@link Viewport} to initialize the {@link Viewport.plugins plugins}. */
  constructor(e) {
    this.viewport = e, this.list = [], this.plugins = {};
  }
  /**
   * Inserts a named plugin or a user plugin into the viewport
   * default plugin order: 'drag', 'pinch', 'wheel', 'follow', 'mouse-edges', 'decelerate', 'bounce',
   * 'snap-zoom', 'clamp-zoom', 'snap', 'clamp'
   *
   * @param {string} name of plugin
   * @param {Plugin} plugin - instantiated Plugin class
   * @param {number} index to insert userPlugin (otherwise inserts it at the end)
   */
  add(e, n, s = ea.length) {
    const a = this.plugins[e];
    a && a.destroy(), this.plugins[e] = n;
    const o = ea.indexOf(e);
    o !== -1 && ea.splice(o, 1), ea.splice(s, 0, e), this.sort();
  }
  /**
   * Get plugin
   *
   * @param {string} name of plugin
   * @param {boolean} [ignorePaused] return null if plugin is paused
   */
  get(e, n) {
    var s;
    return n && (s = this.plugins[e]) != null && s.paused ? null : this.plugins[e];
  }
  /**
   * Update all active plugins
   *
   * @internal
   * @ignore
   * @param {number} elapsed type in milliseconds since last update
   */
  update(e) {
    for (const n of this.list)
      n.update(e);
  }
  /**
   * Resize all active plugins
   *
   * @internal
   * @ignore
   */
  resize() {
    for (const e of this.list)
      e.resize();
  }
  /** Clamps and resets bounce and decelerate (as needed) after manually moving viewport */
  reset() {
    for (const e of this.list)
      e.reset();
  }
  /** removes all installed plugins */
  removeAll() {
    this.list.forEach((e) => {
      e.destroy();
    }), this.plugins = {}, this.sort();
  }
  /**
   * Removes installed plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  remove(e) {
    var n;
    this.plugins[e] && ((n = this.plugins[e]) == null || n.destroy(), delete this.plugins[e], this.viewport.emit("plugin-remove", e), this.sort());
  }
  /**
   * Pause plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  pause(e) {
    var n;
    (n = this.plugins[e]) == null || n.pause();
  }
  /**
   * Resume plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */
  resume(e) {
    var n;
    (n = this.plugins[e]) == null || n.resume();
  }
  /**
   * Sort plugins according to PLUGIN_ORDER
   *
   * @internal
   * @ignore
   */
  sort() {
    this.list = [];
    for (const e of ea)
      this.plugins[e] && this.list.push(this.plugins[e]);
  }
  /**
   * Handle down for all plugins
   *
   * @internal
   * @ignore
   */
  down(e) {
    let n = !1;
    for (const s of this.list)
      s.down(e) && (n = !0);
    return n;
  }
  /**
   * Handle move for all plugins
   *
   * @internal
   * @ignore
   */
  move(e) {
    let n = !1;
    for (const s of this.viewport.plugins.list)
      s.move(e) && (n = !0);
    return n;
  }
  /**
   * Handle up for all plugins
   *
   * @internal
   * @ignore
   */
  up(e) {
    let n = !1;
    for (const s of this.list)
      s.up(e) && (n = !0);
    return n;
  }
  /**
   * Handle wheel event for all plugins
   *
   * @internal
   * @ignore
   */
  wheel(e) {
    let n = !1;
    for (const s of this.list)
      s.wheel(e) && (n = !0);
    return n;
  }
}
const Cg = {
  screenWidth: typeof window > "u" ? 0 : window.innerWidth,
  screenHeight: typeof window > "u" ? 0 : window.innerHeight,
  worldWidth: null,
  worldHeight: null,
  threshold: 5,
  passiveWheel: !0,
  stopPropagation: !1,
  forceHitArea: null,
  noTicker: !1,
  disableOnContextMenu: !1,
  ticker: Kp.shared,
  allowPreserveDragOutside: !1
};
let Pg = class extends Ju {
  /**
   * @param {IViewportOptions} ViewportOptions
   * @param {number} [options.screenWidth=window.innerWidth]
   * @param {number} [options.screenHeight=window.innerHeight]
   * @param {number} [options.worldWidth=this.width]
   * @param {number} [options.worldHeight=this.height]
   * @param {number} [options.threshold=5] number of pixels to move to trigger an input event (e.g., drag, pinch)
   * or disable a clicked event
   * @param {boolean} [options.passiveWheel=true] whether the 'wheel' event is set to passive (note: if false,
   * e.preventDefault() will be called when wheel is used over the viewport)
   * @param {boolean} [options.stopPropagation=false] whether to stopPropagation of events that impact the viewport
   * (except wheel events, see options.passiveWheel)
   * @param {HitArea} [options.forceHitArea] change the default hitArea from world size to a new value
   * @param {boolean} [options.noTicker] set this if you want to manually call update() function on each frame
   * @param {PIXI.Ticker} [options.ticker=PIXI.Ticker.shared] use this PIXI.ticker for updates
   * @param {PIXI.EventSystem} [options.events] EventSystem available from app.events or added manually and passed here
   * location on screen
   * @param {boolean} [options.disableOnContextMenu] remove oncontextmenu=() => {} from the pixi's events.domElement
   */
  constructor(e) {
    super(), this._disableOnContextMenu = (n) => n.preventDefault(), this.options = {
      ...Cg,
      ...e
    }, this.screenWidth = this.options.screenWidth, this.screenHeight = this.options.screenHeight, this._worldWidth = this.options.worldWidth, this._worldHeight = this.options.worldHeight, this.forceHitArea = this.options.forceHitArea, this.threshold = this.options.threshold, this.options.disableOnContextMenu && this.options.events.domElement.addEventListener("contextmenu", this._disableOnContextMenu), this.options.noTicker || (this.tickerFunction = () => this.update(this.options.ticker.elapsedMS), this.options.ticker.add(this.tickerFunction)), this.input = new Sg(this), this.plugins = new Ag(this);
  }
  /** Overrides PIXI.Container's destroy to also remove the 'wheel' and PIXI.Ticker listeners */
  destroy(e) {
    var n;
    !this.options.noTicker && this.tickerFunction && this.options.ticker.remove(this.tickerFunction), this.options.disableOnContextMenu && ((n = this.options.events.domElement) == null || n.removeEventListener("contextmenu", this._disableOnContextMenu)), this.input.destroy(), super.destroy(e);
  }
  /**
   * Update viewport on each frame.
   *
   * By default, you do not need to call this unless you set `options.noTicker=true`.
   *
   * @param {number} elapsed time in milliseconds since last update
   */
  update(e) {
    this.pause || (this.plugins.update(e), this.lastViewport && (this.lastViewport.x !== this.x || this.lastViewport.y !== this.y ? this.moving = !0 : this.moving && (this.emit("moved-end", this), this.moving = !1), this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y ? this.zooming = !0 : this.zooming && (this.emit("zoomed-end", this), this.zooming = !1)), this.forceHitArea || (this._hitAreaDefault = new Qa(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight), this.hitArea = this._hitAreaDefault), this._dirty = this._dirty || !this.lastViewport || this.lastViewport.x !== this.x || this.lastViewport.y !== this.y || this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y, this.lastViewport = {
      x: this.x,
      y: this.y,
      scaleX: this.scale.x,
      scaleY: this.scale.y
    }, this.emit("frame-end", this));
  }
  /**
   * Use this to set screen and world sizes, needed for pinch/wheel/clamp/bounce.
   * @param {number} screenWidth=window.innerWidth
   * @param {number} screenHeight=window.innerHeight
   * @param {number} [worldWidth]
   * @param {number} [worldHeight]
   */
  resize(e = typeof window > "u" ? 0 : window.innerWidth, n = typeof window > "u" ? 0 : window.innerHeight, s, a) {
    this.screenWidth = e, this.screenHeight = n, typeof s < "u" && (this._worldWidth = s), typeof a < "u" && (this._worldHeight = a), this.plugins.resize(), this.dirty = !0;
  }
  /** World width, in pixels */
  get worldWidth() {
    return this._worldWidth ? this._worldWidth : this.width / this.scale.x;
  }
  set worldWidth(e) {
    this._worldWidth = e, this.plugins.resize();
  }
  /** World height, in pixels */
  get worldHeight() {
    return this._worldHeight ? this._worldHeight : this.height / this.scale.y;
  }
  set worldHeight(e) {
    this._worldHeight = e, this.plugins.resize();
  }
  /** Get visible world bounds of viewport */
  getVisibleBounds() {
    return new Qa(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight);
  }
  /**
   * Changes coordinate from screen to world
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */
  toWorld(e, n) {
    return arguments.length === 2 ? this.toLocal(new bt(e, n)) : this.toLocal(e);
  }
  /**
   * Changes coordinate from world to screen
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */
  toScreen(e, n) {
    return arguments.length === 2 ? this.toGlobal(new bt(e, n)) : this.toGlobal(e);
  }
  /** Screen width in world coordinates */
  get worldScreenWidth() {
    return this.screenWidth / this.scale.x;
  }
  /** Screen height in world coordinates */
  get worldScreenHeight() {
    return this.screenHeight / this.scale.y;
  }
  /** World width in screen coordinates */
  get screenWorldWidth() {
    return this.worldWidth * this.scale.x;
  }
  /** World height in screen coordinates */
  get screenWorldHeight() {
    return this.worldHeight * this.scale.y;
  }
  /** Center of screen in world coordinates */
  get center() {
    return new bt(
      this.worldScreenWidth / 2 - this.x / this.scale.x,
      this.worldScreenHeight / 2 - this.y / this.scale.y
    );
  }
  set center(e) {
    this.moveCenter(e);
  }
  /**
   * Move center of viewport to (x, y)
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @return {Viewport}
   */
  moveCenter(...e) {
    let n, s;
    typeof e[0] == "number" ? (n = e[0], s = e[1]) : (n = e[0].x, s = e[0].y);
    const a = (this.worldScreenWidth / 2 - n) * this.scale.x, o = (this.worldScreenHeight / 2 - s) * this.scale.y;
    return (this.x !== a || this.y !== o) && (this.position.set(a, o), this.plugins.reset(), this.dirty = !0), this;
  }
  /** Top-left corner of Viewport */
  get corner() {
    return new bt(-this.x / this.scale.x, -this.y / this.scale.y);
  }
  set corner(e) {
    this.moveCorner(e);
  }
  /**
   * MoveCorner
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @returns {Viewport}
   */
  moveCorner(...e) {
    let n, s;
    return e.length === 1 ? (n = -e[0].x * this.scale.x, s = -e[0].y * this.scale.y) : (n = -e[0] * this.scale.x, s = -e[1] * this.scale.y), (n !== this.x || s !== this.y) && (this.position.set(n, s), this.plugins.reset(), this.dirty = !0), this;
  }
  /** Get how many world pixels fit in screen's width */
  get screenWidthInWorldPixels() {
    return this.screenWidth / this.scale.x;
  }
  /** Get how many world pixels fit on screen's height */
  get screenHeightInWorldPixels() {
    return this.screenHeight / this.scale.y;
  }
  /**
   * Find the scale value that fits a world width on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param width - Width in world pixels
   * @return - scale
   */
  findFitWidth(e) {
    return this.screenWidth / e;
  }
  /**
   * Finds the scale value that fits a world height on the screens
   * does not change the viewport (use fit... to change)
   *
   * @param height - Height in world pixels
   * @return - scale
   */
  findFitHeight(e) {
    return this.screenHeight / e;
  }
  /**
   * Finds the scale value that fits the smaller of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */
  findFit(e, n) {
    const s = this.screenWidth / e, a = this.screenHeight / n;
    return Math.min(s, a);
  }
  /**
   * Finds the scale value that fits the larger of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */
  findCover(e, n) {
    const s = this.screenWidth / e, a = this.screenHeight / n;
    return Math.max(s, a);
  }
  /**
   * Change zoom so the width fits in the viewport
   *
   * @param width - width in world coordinates
   * @param center - maintain the same center
   * @param scaleY - whether to set scaleY=scaleX
   * @param noClamp - whether to disable clamp-zoom
   * @returns {Viewport} this
   */
  fitWidth(e = this.worldWidth, n, s = !0, a) {
    let o;
    n && (o = this.center), this.scale.x = this.screenWidth / e, s && (this.scale.y = this.scale.x);
    const i = this.plugins.get("clamp-zoom", !0);
    return !a && i && i.clamp(), n && o && this.moveCenter(o), this;
  }
  /**
   * Change zoom so the height fits in the viewport
   *
   * @param {number} [height=this.worldHeight] in world coordinates
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {boolean} [scaleX=true] whether to set scaleX = scaleY
   * @param {boolean} [noClamp] whether to disable clamp-zoom
   * @returns {Viewport} this
   */
  fitHeight(e = this.worldHeight, n, s = !0, a) {
    let o;
    n && (o = this.center), this.scale.y = this.screenHeight / e, s && (this.scale.x = this.scale.y);
    const i = this.plugins.get("clamp-zoom", !0);
    return !a && i && i.clamp(), n && o && this.moveCenter(o), this;
  }
  /**
   * Change zoom so it fits the entire world in the viewport
   *
   * @param {boolean} center maintain the same center of the screen after zoom
   * @returns {Viewport} this
   */
  fitWorld(e) {
    let n;
    e && (n = this.center), this.scale.x = this.screenWidth / this.worldWidth, this.scale.y = this.screenHeight / this.worldHeight, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
    const s = this.plugins.get("clamp-zoom", !0);
    return s && s.clamp(), e && n && this.moveCenter(n), this;
  }
  /**
   * Change zoom so it fits the size or the entire world in the viewport
   *
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {number} [width=this.worldWidth] desired width
   * @param {number} [height=this.worldHeight] desired height
   * @returns {Viewport} this
   */
  fit(e, n = this.worldWidth, s = this.worldHeight) {
    let a;
    e && (a = this.center), this.scale.x = this.screenWidth / n, this.scale.y = this.screenHeight / s, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
    const o = this.plugins.get("clamp-zoom", !0);
    return o && o.clamp(), e && a && this.moveCenter(a), this;
  }
  /**
   * Zoom viewport to specific value.
   *
   * @param {number} scale value (e.g., 1 would be 100%, 0.25 would be 25%)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  setZoom(e, n) {
    let s;
    n && (s = this.center), this.scale.set(e);
    const a = this.plugins.get("clamp-zoom", !0);
    return a && a.clamp(), n && s && this.moveCenter(s), this;
  }
  /**
   * Zoom viewport by a certain percent (in both x and y direction).
   *
   * @param {number} percent change (e.g., 0.25 would increase a starting scale of 1.0 to 1.25)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  zoomPercent(e, n) {
    return this.setZoom(this.scale.x + this.scale.x * e, n);
  }
  /**
   * Zoom viewport by increasing/decreasing width by a certain number of pixels.
   *
   * @param {number} change in pixels
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */
  zoom(e, n) {
    return this.fitWidth(e + this.worldScreenWidth, n), this;
  }
  /** Changes scale of viewport and maintains center of viewport */
  get scaled() {
    return this.scale.x;
  }
  set scaled(e) {
    this.setZoom(e, !0);
  }
  /**
   * Returns zoom to the desired scale
   *
   * @param {ISnapZoomOptions} options
   * @param {number} [options.width=0] - the desired width to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.height=0] - the desired height to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.time=1000] - time for snapping in ms
   * @param {(string|function)} [options.ease=easeInOutSine] ease function or name (see http://easings.net/
   *   for supported names)
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of the viewport
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at the
   *   desired zoom
   * @param {boolean} [options.noMove] - zoom but do not move
   */
  snapZoom(e) {
    return this.plugins.add("snap-zoom", new wg(this, e)), this;
  }
  /** Is container out of world bounds */
  OOB() {
    return {
      left: this.left < 0,
      right: this.right > this.worldWidth,
      top: this.top < 0,
      bottom: this.bottom > this.worldHeight,
      cornerPoint: new bt(
        this.worldWidth * this.scale.x - this.screenWidth,
        this.worldHeight * this.scale.y - this.screenHeight
      )
    };
  }
  /** World coordinates of the right edge of the screen */
  get right() {
    return -this.x / this.scale.x + this.worldScreenWidth;
  }
  set right(e) {
    this.x = -e * this.scale.x + this.screenWidth, this.plugins.reset();
  }
  /** World coordinates of the left edge of the screen */
  get left() {
    return -this.x / this.scale.x;
  }
  set left(e) {
    this.x = -e * this.scale.x, this.plugins.reset();
  }
  /** World coordinates of the top edge of the screen */
  get top() {
    return -this.y / this.scale.y;
  }
  set top(e) {
    this.y = -e * this.scale.y, this.plugins.reset();
  }
  /** World coordinates of the bottom edge of the screen */
  get bottom() {
    return -this.y / this.scale.y + this.worldScreenHeight;
  }
  set bottom(e) {
    this.y = -e * this.scale.y + this.screenHeight, this.plugins.reset();
  }
  /**
   * Determines whether the viewport is dirty (i.e., needs to be rendered to the screen because of a change)
   */
  get dirty() {
    return !!this._dirty;
  }
  set dirty(e) {
    this._dirty = e;
  }
  /**
   * Permanently changes the Viewport's hitArea
   *
   * NOTE: if not set then hitArea = PIXI.Rectangle(Viewport.left, Viewport.top, Viewport.worldScreenWidth,
   * Viewport.worldScreenHeight)
   */
  get forceHitArea() {
    return this._forceHitArea;
  }
  set forceHitArea(e) {
    e ? (this._forceHitArea = e, this.hitArea = e) : (this._forceHitArea = null, this.hitArea = new Qa(0, 0, this.worldWidth, this.worldHeight));
  }
  /**
   * Enable one-finger touch to drag
   *
   * NOTE: if you expect users to use right-click dragging, you should enable `viewport.options.disableOnContextMenu`
   * to avoid the context menu popping up on each right-click drag.
   *
   * @param {IDragOptions} [options]
   * @param {string} [options.direction=all] direction to drag
   * @param {boolean} [options.pressDrag=true] whether click to drag is active
   * @param {boolean} [options.wheel=true] use wheel to scroll in direction (unless wheel plugin is active)
   * @param {number} [options.wheelScroll=1] number of pixels to scroll with each wheel spin
   * @param {boolean} [options.reverse] reverse the direction of the wheel scroll
   * @param {(boolean|string)} [options.clampWheel=false] clamp wheel(to avoid weird bounce with mouse wheel)
   * @param {string} [options.underflow=center] where to place world if too small for screen
   * @param {number} [options.factor=1] factor to multiply drag to increase the speed of movement
   * @param {string} [options.mouseButtons=all] changes which mouse buttons trigger drag, use: 'all', 'left',
   *  'right' 'middle', or some combination, like, 'middle-right'; you may want to set
   *   viewport.options.disableOnContextMenu if you want to use right-click dragging
   * @param {string[]} [options.keyToPress=null] - array containing
   *  {@link key|https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code} codes of keys that can be
   *  pressed for the drag to be triggered, e.g.: ['ShiftLeft', 'ShiftRight'}.
   * @param {boolean} [options.ignoreKeyToPressOnTouch=false] - ignore keyToPress for touch events
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @returns {Viewport} this
   */
  drag(e) {
    return this.plugins.add("drag", new mg(this, e)), this;
  }
  /**
   * Clamp to world boundaries or other provided boundaries
   * There are three ways to clamp:
   * 1. direction: 'all' = the world is clamped to its world boundaries, ie, you cannot drag any part of offscreen
   *    direction: 'x' | 'y' = only the x or y direction is clamped to its world boundary
   * 2. left, right, top, bottom = true | number = the world is clamped to the world's pixel location for each side;
   *    if any of these are set to true, then the location is set to the boundary
   *    [0, viewport.worldWidth/viewport.worldHeight], eg: to allow the world to be completely dragged offscreen,
   *    set [-viewport.worldWidth, -viewport.worldHeight, viewport.worldWidth * 2, viewport.worldHeight * 2]
   *
   * Underflow determines what happens when the world is smaller than the viewport
   * 1. none = the world is clamped but there is no special behavior
   * 2. center = the world is centered on the viewport
   * 3. combination of top/bottom/center and left/right/center (case insensitive) = the world is stuck to the
   *     appropriate boundaries
   *
   * NOTES:
   *   clamp is disabled if called with no options; use { direction: 'all' } for all edge clamping
   *   screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *
   * @param {object} [options]
   * @param {(number|boolean)} [options.left=false] - clamp left; true = 0
   * @param {(number|boolean)} [options.right=false] - clamp right; true = viewport.worldWidth
   * @param {(number|boolean)} [options.top=false] - clamp top; true = 0
   * @param {(number|boolean)} [options.bottom=false] - clamp bottom; true = viewport.worldHeight
   * @param {string} [direction] - (all, x, or y) using clamps of [0, viewport.worldWidth/viewport.worldHeight];
   *  replaces left/right/top/bottom if set
   * @param {string} [underflow=center] - where to place world if too small for screen (e.g., top-right, center,
   *  none, bottomLeft)     * @returns {Viewport} this
   */
  clamp(e) {
    return this.plugins.add("clamp", new ig(this, e)), this;
  }
  /**
   * Decelerate after a move
   *
   * NOTE: this fires 'moved' event during deceleration
   *
   * @param {IDecelerateOptions} [options]
   * @param {number} [options.friction=0.95] - percent to decelerate after movement
   * @param {number} [options.bounce=0.8] - percent to decelerate when past boundaries (only applicable when
   *   viewport.bounce() is active)
   * @param {number} [options.minSpeed=0.01] - minimum velocity before stopping/reversing acceleration
   * @return {Viewport} this
   */
  decelerate(e) {
    return this.plugins.add("decelerate", new ug(this, e)), this;
  }
  /**
   * Bounce on borders
   * NOTES:
   *    screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *    fires 'moved', 'bounce-x-start', 'bounce-y-start', 'bounce-x-end', and 'bounce-y-end' events
   * @param {object} [options]
   * @param {string} [options.sides=all] - all, horizontal, vertical, or combination of top, bottom, right, left
   *  (e.g., 'top-bottom-right')
   * @param {number} [options.friction=0.5] - friction to apply to decelerate if active
   * @param {number} [options.time=150] - time in ms to finish bounce
   * @param {object} [options.bounceBox] - use this bounceBox instead of (0, 0, viewport.worldWidth, viewport.worldHeight)
   * @param {number} [options.bounceBox.x=0]
   * @param {number} [options.bounceBox.y=0]
   * @param {number} [options.bounceBox.width=viewport.worldWidth]
   * @param {number} [options.bounceBox.height=viewport.worldHeight]
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name
   *  (see http://easings.net/ for supported names)
   * @param {string} [options.underflow=center] - (top/bottom/center and left/right/center, or center)
   *  where to place world if too small for screen
   * @return {Viewport} this
   */
  bounce(e) {
    return this.plugins.add("bounce", new ag(this, e)), this;
  }
  /**
   * Enable pinch to zoom and two-finger touch to drag
   *
   * @param {PinchOptions} [options]
   * @param {boolean} [options.noDrag] - disable two-finger dragging
   * @param {number} [options.percent=1] - percent to modify pinch speed
   * @param {number} [options.factor=1] - factor to multiply two-finger drag to increase the speed of movement
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of two fingers
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */
  pinch(e) {
    return this.plugins.add("pinch", new _g(this, e)), this;
  }
  /**
   * Snap to a point
   *
   * @param {number} x
   * @param {number} y
   * @param {ISnapOptions} [options]
   * @param {boolean} [options.topLeft] - snap to the top-left of viewport instead of center
   * @param {number} [options.friction=0.8] - friction/frame to apply if decelerate is active
   * @param {number} [options.time=1000] - time in ms to snap
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name (see http://easings.net/
   *   for supported names)
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at
   *   the desired location
   * @return {Viewport} this
   */
  snap(e, n, s) {
    return this.plugins.add("snap", new yg(this, e, n, s)), this;
  }
  /**
   * Follow a target
   *
   * NOTES:
   *    uses the (x, y) as the center to follow; for PIXI.Sprite to work properly, use sprite.anchor.set(0.5)
   *    options.acceleration is not perfect as it doesn't know the velocity of the target. It adds acceleration
   *    to the start of movement and deceleration to the end of movement when the target is stopped.
   *    To cancel the follow, use: `viewport.plugins.remove('follow')`
   *
   * @fires 'moved' event
   *
   * @param {PIXI.DisplayObject} target to follow
   * @param {IFollowOptions} [options]
   * @param {number} [options.speed=0] - to follow in pixels/frame (0=teleport to location)
   * @param {number} [options.acceleration] - set acceleration to accelerate and decelerate at this rate; speed
   *   cannot be 0 to use acceleration
   * @param {number} [options.radius] - radius (in world coordinates) of center circle where movement is allowed
   *   without moving the viewport     * @returns {Viewport} this
   * @returns {Viewport} this
   */
  follow(e, n) {
    return this.plugins.add("follow", new pg(this, e, n)), this;
  }
  /**
   * Zoom using mouse wheel
   *
   * NOTE: the default event listener for 'wheel' event is the options.events.domElement.
   *
   * @param {IWheelOptions} [options]
   * @param {number} [options.percent=0.1] - percent to scroll with each spin
   * @param {number} [options.smooth] - smooth the zooming by providing the number of frames to zoom between wheel spins
   * @param {boolean} [options.interrupt=true] - stop smoothing with any user input on the viewport
   * @param {boolean} [options.reverse] - reverse the direction of the scroll
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of current mouse position
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */
  wheel(e) {
    return this.plugins.add("wheel", new $g(this, e)), this;
  }
  /**
   * Animate the position and/or scale of the viewport
   * To set the zoom level, use: (1) scale, (2) scaleX and scaleY, or (3) width and/or height
   * @param {object} options
   * @param {number} [options.time=1000] - time to animate
   * @param {PIXI.Point} [options.position=viewport.center] - position to move viewport
   * @param {number} [options.width] - desired viewport width in world pixels (use instead of scale;
   *  aspect ratio is maintained if height is not provided)
   * @param {number} [options.height] - desired viewport height in world pixels (use instead of scale;
   *  aspect ratio is maintained if width is not provided)
   * @param {number} [options.scale] - scale to change zoom (scale.x = scale.y)
   * @param {number} [options.scaleX] - independently change zoom in x-direction
   * @param {number} [options.scaleY] - independently change zoom in y-direction
   * @param {(function|string)} [options.ease=linear] - easing function to use
   * @param {function} [options.callbackOnComplete]
   * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
   * @returns {Viewport} this
   */
  animate(e) {
    return this.plugins.add("animate", new ng(this, e)), this;
  }
  /**
   * Enable clamping of zoom to constraints
   *
   * The minWidth/Height settings are how small the world can get (as it would appear on the screen)
   * before clamping. The maxWidth/maxHeight is how larger the world can scale (as it would appear on
   * the screen) before clamping.
   *
   * For example, if you have a world size of 1000 x 1000 and a screen size of 100 x 100, if you set
   * minWidth/Height = 100 then the world will not be able to zoom smaller than the screen size (ie,
   * zooming out so it appears smaller than the screen). Similarly, if you set maxWidth/Height = 100
   * the world will not be able to zoom larger than the screen size (ie, zooming in so it appears
   * larger than the screen).
   *
   * @param {object} [options]
   * @param {number} [options.minWidth] - minimum width
   * @param {number} [options.minHeight] - minimum height
   * @param {number} [options.maxWidth] - maximum width
   * @param {number} [options.maxHeight] - maximum height
   * @param {number} [options.minScale] - minimum scale
   * @param {number} [options.maxScale] - minimum scale
   * @return {Viewport} this
   */
  clampZoom(e) {
    return this.plugins.add("clamp-zoom", new lg(this, e)), this;
  }
  /**
   * Scroll viewport when mouse hovers near one of the edges or radius-distance from center of screen.
   *
   * NOTES: fires 'moved' event; there's a known bug where the mouseEdges does not work properly with "windowed" viewports
   *
   * @param {IMouseEdgesOptions} [options]
   * @param {number} [options.radius] - distance from center of screen in screen pixels
   * @param {number} [options.distance] - distance from all sides in screen pixels
   * @param {number} [options.top] - alternatively, set top distance (leave unset for no top scroll)
   * @param {number} [options.bottom] - alternatively, set bottom distance (leave unset for no top scroll)
   * @param {number} [options.left] - alternatively, set left distance (leave unset for no top scroll)
   * @param {number} [options.right] - alternatively, set right distance (leave unset for no top scroll)
   * @param {number} [options.speed=8] - speed in pixels/frame to scroll viewport
   * @param {boolean} [options.reverse] - reverse direction of scroll
   * @param {boolean} [options.noDecelerate] - don't use decelerate plugin even if it's installed
   * @param {boolean} [options.linear] - if using radius, use linear movement (+/- 1, +/- 1) instead of angled
   *   movement (Math.cos(angle from center), Math.sin(angle from center))
   * @param {boolean} [options.allowButtons] allows plugin to continue working even when there's a mousedown event
   */
  mouseEdges(e) {
    return this.plugins.add("mouse-edges", new vg(this, e)), this;
  }
  /** Pause viewport (including animation updates such as decelerate) */
  get pause() {
    return !!this._pause;
  }
  set pause(e) {
    this._pause = e, this.lastViewport = null, this.moving = !1, this.zooming = !1, e && this.input.pause();
  }
  /**
   * Move the viewport so the bounding box is visible
   *
   * @param x - left
   * @param y - top
   * @param width
   * @param height
   * @param resizeToFit - Resize the viewport so the box fits within the viewport
   */
  ensureVisible(e, n, s, a, o) {
    o && (s > this.worldScreenWidth || a > this.worldScreenHeight) && (this.fit(!0, s, a), this.emit("zoomed", { viewport: this, type: "ensureVisible" }));
    let i = !1;
    e < this.left ? (this.left = e, i = !0) : e + s > this.right && (this.right = e + s, i = !0), n < this.top ? (this.top = n, i = !0) : n + a > this.bottom && (this.bottom = n + a, i = !0), i && this.emit("moved", { viewport: this, type: "ensureVisible" });
  }
};
/*! Fast Average Color | © 2025 Denis Seleznev | MIT License | https://github.com/fast-average-color/fast-average-color */
function Ig(t) {
  var e = t.toString(16);
  return e.length === 1 ? "0" + e : e;
}
function ru(t) {
  return "#" + t.map(Ig).join("");
}
function Mg(t) {
  var e = (t[0] * 299 + t[1] * 587 + t[2] * 114) / 1e3;
  return e < 128;
}
function Tg(t) {
  return t ? zg(t) ? t : [t] : [];
}
function zg(t) {
  return Array.isArray(t[0]);
}
function cl(t, e, n) {
  for (var s = 0; s < n.length; s++)
    if (Eg(t, e, n[s]))
      return !0;
  return !1;
}
function Eg(t, e, n) {
  switch (n.length) {
    case 3:
      if (Og(t, e, n))
        return !0;
      break;
    case 4:
      if (Rg(t, e, n))
        return !0;
      break;
    case 5:
      if (Lg(t, e, n))
        return !0;
      break;
    default:
      return !1;
  }
}
function Og(t, e, n) {
  return t[e + 3] !== 255 || t[e] === n[0] && t[e + 1] === n[1] && t[e + 2] === n[2];
}
function Rg(t, e, n) {
  return t[e + 3] && n[3] ? t[e] === n[0] && t[e + 1] === n[1] && t[e + 2] === n[2] && t[e + 3] === n[3] : t[e + 3] === n[3];
}
function Ha(t, e, n) {
  return t >= e - n && t <= e + n;
}
function Lg(t, e, n) {
  var s = n[0], a = n[1], o = n[2], i = n[3], r = n[4], l = t[e + 3], u = Ha(l, i, r);
  return i ? !!(!l && u || Ha(t[e], s, r) && Ha(t[e + 1], a, r) && Ha(t[e + 2], o, r) && u) : u;
}
var Dg = 24;
function Ng(t, e, n) {
  for (var s = {}, a = n.dominantDivider || Dg, o = n.ignoredColor, i = n.step, r = [0, 0, 0, 0, 0], l = 0; l < e; l += i) {
    var u = t[l], m = t[l + 1], h = t[l + 2], v = t[l + 3];
    if (!(o && cl(t, l, o))) {
      var _ = Math.round(u / a) + "," + Math.round(m / a) + "," + Math.round(h / a);
      s[_] ? s[_] = [
        s[_][0] + u * v,
        s[_][1] + m * v,
        s[_][2] + h * v,
        s[_][3] + v,
        s[_][4] + 1
      ] : s[_] = [u * v, m * v, h * v, v, 1], r[4] < s[_][4] && (r = s[_]);
    }
  }
  var y = r[0], S = r[1], f = r[2], k = r[3], w = r[4];
  return k ? [
    Math.round(y / k),
    Math.round(S / k),
    Math.round(f / k),
    Math.round(k / w)
  ] : n.defaultColor;
}
function Vg(t, e, n) {
  for (var s = 0, a = 0, o = 0, i = 0, r = 0, l = n.ignoredColor, u = n.step, m = 0; m < e; m += u) {
    var h = t[m + 3], v = t[m] * h, _ = t[m + 1] * h, y = t[m + 2] * h;
    l && cl(t, m, l) || (s += v, a += _, o += y, i += h, r++);
  }
  return i ? [
    Math.round(s / i),
    Math.round(a / i),
    Math.round(o / i),
    Math.round(i / r)
  ] : n.defaultColor;
}
function Ug(t, e, n) {
  for (var s = 0, a = 0, o = 0, i = 0, r = 0, l = n.ignoredColor, u = n.step, m = 0; m < e; m += u) {
    var h = t[m], v = t[m + 1], _ = t[m + 2], y = t[m + 3];
    l && cl(t, m, l) || (s += h * h * y, a += v * v * y, o += _ * _ * y, i += y, r++);
  }
  return i ? [
    Math.round(Math.sqrt(s / i)),
    Math.round(Math.sqrt(a / i)),
    Math.round(Math.sqrt(o / i)),
    Math.round(i / r)
  ] : n.defaultColor;
}
function lu(t) {
  return ia(t, "defaultColor", [0, 0, 0, 0]);
}
function ia(t, e, n) {
  return t[e] === void 0 ? n : t[e];
}
var cu = 10, Mr = 100;
function Fg(t) {
  return t.search(/\.svg(\?|$)/i) !== -1;
}
function jg(t) {
  if (Gd(t)) {
    var e = t.naturalWidth, n = t.naturalHeight;
    return !t.naturalWidth && Fg(t.src) && (e = n = Mr), {
      width: e,
      height: n
    };
  }
  return qg(t) ? {
    width: t.videoWidth,
    height: t.videoHeight
  } : Qd(t) ? {
    width: t.codedWidth,
    height: t.codedHeight
  } : {
    width: t.width,
    height: t.height
  };
}
function uu(t) {
  return Hg(t) ? "canvas" : Bg(t) ? "offscreencanvas" : Qd(t) ? "videoframe" : Wg(t) ? "imagebitmap" : t.src;
}
function Gd(t) {
  return typeof HTMLImageElement < "u" && t instanceof HTMLImageElement;
}
var Zd = typeof OffscreenCanvas < "u";
function Bg(t) {
  return Zd && t instanceof OffscreenCanvas;
}
function qg(t) {
  return typeof HTMLVideoElement < "u" && t instanceof HTMLVideoElement;
}
function Qd(t) {
  return typeof VideoFrame < "u" && t instanceof VideoFrame;
}
function Hg(t) {
  return typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement;
}
function Wg(t) {
  return typeof ImageBitmap < "u" && t instanceof ImageBitmap;
}
function Gg(t, e) {
  var n = ia(e, "left", 0), s = ia(e, "top", 0), a = ia(e, "width", t.width), o = ia(e, "height", t.height), i = a, r = o;
  if (e.mode === "precision")
    return {
      srcLeft: n,
      srcTop: s,
      srcWidth: a,
      srcHeight: o,
      destWidth: i,
      destHeight: r
    };
  var l;
  return a > o ? (l = a / o, i = Mr, r = Math.round(i / l)) : (l = o / a, r = Mr, i = Math.round(r / l)), (i > a || r > o || i < cu || r < cu) && (i = a, r = o), {
    srcLeft: n,
    srcTop: s,
    srcWidth: a,
    srcHeight: o,
    destWidth: i,
    destHeight: r
  };
}
var Zg = typeof window > "u";
function Qg() {
  return Zg ? Zd ? new OffscreenCanvas(1, 1) : null : document.createElement("canvas");
}
var Xg = "FastAverageColor: ";
function kn(t) {
  return Error(Xg + t);
}
function ta(t, e) {
  e || console.error(t);
}
var Kg = (
  /** @class */
  function() {
    function t() {
      this.canvas = null, this.ctx = null;
    }
    return t.prototype.getColorAsync = function(e, n) {
      if (!e)
        return Promise.reject(kn("call .getColorAsync() without resource"));
      if (typeof e == "string") {
        if (typeof Image > "u")
          return Promise.reject(kn("resource as string is not supported in this environment"));
        var s = new Image();
        return s.crossOrigin = n && n.crossOrigin || "", s.src = e, this.bindImageEvents(s, n);
      } else {
        if (Gd(e) && !e.complete)
          return this.bindImageEvents(e, n);
        var a = this.getColor(e, n);
        return a.error ? Promise.reject(a.error) : Promise.resolve(a);
      }
    }, t.prototype.getColor = function(e, n) {
      n = n || {};
      var s = lu(n);
      if (!e) {
        var a = kn("call .getColor() without resource");
        return ta(a, n.silent), this.prepareResult(s, a);
      }
      var o = jg(e), i = Gg(o, n);
      if (!i.srcWidth || !i.srcHeight || !i.destWidth || !i.destHeight) {
        var a = kn('incorrect sizes for resource "'.concat(uu(e), '"'));
        return ta(a, n.silent), this.prepareResult(s, a);
      }
      if (!this.canvas && (this.canvas = Qg(), !this.canvas)) {
        var a = kn("OffscreenCanvas is not supported in this browser");
        return ta(a, n.silent), this.prepareResult(s, a);
      }
      if (!this.ctx) {
        if (this.ctx = this.canvas.getContext("2d", { willReadFrequently: !0 }), !this.ctx) {
          var a = kn("Canvas Context 2D is not supported in this browser");
          return ta(a, n.silent), this.prepareResult(s);
        }
        this.ctx.imageSmoothingEnabled = !1;
      }
      this.canvas.width = i.destWidth, this.canvas.height = i.destHeight;
      try {
        this.ctx.clearRect(0, 0, i.destWidth, i.destHeight), this.ctx.drawImage(e, i.srcLeft, i.srcTop, i.srcWidth, i.srcHeight, 0, 0, i.destWidth, i.destHeight);
        var r = this.ctx.getImageData(0, 0, i.destWidth, i.destHeight).data;
        return this.prepareResult(this.getColorFromArray4(r, n));
      } catch (l) {
        var a = kn("security error (CORS) for resource ".concat(uu(e), `.
Details: https://developer.mozilla.org/en/docs/Web/HTML/CORS_enabled_image`));
        return ta(a, n.silent), n.silent || console.error(l), this.prepareResult(s, a);
      }
    }, t.prototype.getColorFromArray4 = function(e, n) {
      n = n || {};
      var s = 4, a = e.length, o = lu(n);
      if (a < s)
        return o;
      var i = a - a % s, r = (n.step || 1) * s, l;
      switch (n.algorithm || "sqrt") {
        case "simple":
          l = Vg;
          break;
        case "sqrt":
          l = Ug;
          break;
        case "dominant":
          l = Ng;
          break;
        default:
          throw kn("".concat(n.algorithm, " is unknown algorithm"));
      }
      return l(e, i, {
        defaultColor: o,
        ignoredColor: Tg(n.ignoredColor),
        step: r,
        dominantDivider: n.dominantDivider
      });
    }, t.prototype.prepareResult = function(e, n) {
      var s = e.slice(0, 3), a = [e[0], e[1], e[2], e[3] / 255], o = Mg(e);
      return {
        value: [e[0], e[1], e[2], e[3]],
        rgb: "rgb(" + s.join(",") + ")",
        rgba: "rgba(" + a.join(",") + ")",
        hex: ru(s),
        hexa: ru(e),
        isDark: o,
        isLight: !o,
        error: n
      };
    }, t.prototype.destroy = function() {
      this.canvas && (this.canvas.width = 1, this.canvas.height = 1, this.canvas = null), this.ctx = null;
    }, t.prototype.bindImageEvents = function(e, n) {
      var s = this;
      return new Promise(function(a, o) {
        var i = function() {
          u();
          var m = s.getColor(e, n);
          m.error ? o(m.error) : a(m);
        }, r = function() {
          u(), o(kn('Error loading image "'.concat(e.src, '"')));
        }, l = function() {
          u(), o(kn('Image "'.concat(e.src, '" loading aborted')));
        }, u = function() {
          e.removeEventListener("load", i), e.removeEventListener("error", r), e.removeEventListener("abort", l);
        };
        e.addEventListener("load", i), e.addEventListener("error", r), e.addEventListener("abort", l);
      });
    }, t;
  }()
), Jg = Object.defineProperty, Yg = (t, e, n) => e in t ? Jg(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, on = (t, e, n) => Yg(t, typeof e != "symbol" ? e + "" : e, n);
const ul = tt("designer-core.apiClient", () => {
  const t = N(), e = N("2024-07-15"), n = N(), s = N(Vd());
  return { acceptLanguage: n, apiVersion: e, baseUrl: t, sessionId: s };
});
function e0() {
  const { acceptLanguage: t, apiVersion: e, baseUrl: n, sessionId: s } = D(ul());
  return {
    beforeRequest: (a) => ({
      ...a,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...a.headers,
        "Accept-Language": t.value,
        "X-Api-Version": e.value,
        "X-Tab-Session-Id": s.value
      },
      prefixUrl: n.value,
      timeout: 3e4
    }),
    enabled: I(() => !!(n.value && t.value)),
    key: [n, e, t]
  };
}
let Tr;
function t0(t) {
  Tr = t;
}
const dl = Nd(
  {
    headers: { "Content-Type": "application/json" },
    onValidationError: (t) => Tr == null ? void 0 : Tr(t)
  },
  [e0]
), n0 = dl.mutation(
  ({ token: t, userExternalIdentifier: e }) => ({
    headers: { "X-Designer-Token": t },
    json: {
      designer_token: t,
      external_identifier: e
    },
    method: "post",
    url: "auth/login"
  }),
  {
    input: B({
      token: V(),
      userExternalIdentifier: V()
    }),
    output: B({
      expire_date: R(),
      token_string: V(),
      user_id: R()
    })
  }
), s0 = dl.mutation(
  (t) => ({
    headers: { Authorization: `Bearer ${t}` },
    method: "post",
    url: "auth/token/refresh"
  }),
  {
    input: V(),
    output: B({
      expire_date: R(),
      token_string: V(),
      user_id: R()
    })
  }
), a0 = pt({ refresh: s0 }), o0 = pt({ login: n0, token: a0 }), ba = tt("designer-core.token", () => {
  const t = N(), e = N(), n = N(), s = N(!1), {
    data: a,
    error: o,
    mutate: i,
    reset: r
  } = tn(le.auth.login.use()), l = N();
  ie(() => {
    a.value && (l.value = a.value);
  });
  const {
    data: u,
    error: m,
    mutate: h,
    reset: v
  } = tn(le.auth.token.refresh.use()), _ = N();
  ie(() => {
    u.value && (_.value = u.value);
  });
  const y = I(
    () => t.value ?? _.value ?? l.value
  );
  function S() {
    e.value = void 0, l.value = void 0, _.value = void 0, r(), v();
  }
  ie(() => {
    !e.value || t.value || (n.value ? i({
      token: e.value,
      userExternalIdentifier: n.value
    }) : h(e.value));
  }), ie(() => {
    !o.value || !e.value || t.value || h(e.value);
  });
  const { idle: f } = Wu(24 * 60 * 60 * 1e3);
  return ie(() => {
    !m.value && !f.value || t.value || (s.value = !0, S());
  }), ie((k) => {
    if (!y.value || t.value) return;
    s.value = !1;
    const w = setTimeout(
      () => {
        if (!y.value) throw new Error("tokenData not set");
        h(y.value.token_string);
      },
      y.value.expire_date * 1e3 - 60 * 1e3 - Date.now()
    );
    k(() => {
      clearTimeout(w);
    });
  }), {
    initialToken: e,
    isSessionExpired: Un(s),
    logout: S,
    manualTokenData: t,
    tokenData: y,
    userExternalIdentifier: n
  };
}), Xd = dl.use(() => {
  const { tokenData: t, userExternalIdentifier: e } = D(ba());
  return {
    beforeRequest: (n) => ({
      ...n,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...n.headers,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        Authorization: `Bearer ${t.value.token_string}`,
        "X-App-User": e.value
      }
    }),
    enabled: I(() => {
      var n;
      return !!((n = t.value) != null && n.token_string);
    }),
    key: I(() => {
      var n;
      return (n = t.value) == null ? void 0 : n.user_id;
    })
  };
}), Ge = Xd;
var $s = /* @__PURE__ */ ((t) => (t.Black = "Black", t.BlackItalic = "Black Italic", t.Bold = "Bold", t.BoldItalic = "Bold Italic", t.DemiBold = "Demi Bold", t.DemiBoldItalic = "Demi Bold Italic", t.Italic = "Italic", t.Light = "Light", t.Medium = "Medium", t.Normal = "Normal", t.Regular = "Regular", t))($s || {});
const i0 = B({
  id: R(),
  description: V(),
  display_name: V(),
  handle: V(),
  is_using_color_picker: Yt(),
  preview_url: V(),
  production_type: B({
    id: R(),
    handle: V()
  })
}), r0 = B({
  id: R(),
  code: V(),
  custom_attributes: V().array().nullable()
}), l0 = B({
  id: R(),
  name: V(),
  code: V(),
  thickness: V().nullable()
}), ar = B({
  id: R(),
  blue: R(),
  display_name: V(),
  external_identifier: V().nullable(),
  green: R(),
  is_customer_logo_color: Yt(),
  is_standard: Yt(),
  production_methods: B({ id: R() }).array(),
  red: R()
}), Kd = rl("color_details_type", [
  B({
    color_details: r0,
    color_details_type: at("manual-color-details")
  }).merge(ar),
  B({
    color_details: l0,
    color_details_type: at("embroidery-color-details")
  }).merge(ar),
  B({ color_details: va(), color_details_type: va() }).merge(ar)
]), c0 = B({
  id: R(),
  name: V(),
  display_name: V(),
  family_name: V(),
  font_url: V().nullable(),
  group_handle: V(),
  letter_case_set: Wn([
    at("upper-and-lowercase"),
    at("only-uppercase")
  ]),
  max: R(),
  min: R(),
  preview_url: V().nullable(),
  production_methods: B({ id: R() }).array(),
  style: un($s)
}), u0 = Ge.query(() => ({ url: "configurations/app" }), {
  output: B({
    colors: Kd.array(),
    fonts: c0.array(),
    productionMethods: i0.array()
  })
}), d0 = pt({ get: u0 }), m0 = B({
  id: R(),
  customer_upload: B({
    allowed_logo_file_types: ut(V()),
    dpi: R(),
    max_file_size_mb: R(),
    min_dimension: R()
  }).nullable(),
  description: V(),
  display_name: V(),
  handle: V(),
  is_digitizable: Yt(),
  is_using_color_picker: Yt(),
  preview_url: V(),
  production_type: B({
    id: R(),
    handle: V()
  })
}), h0 = Ge.query(
  () => ({ url: "configurations/designer" }),
  {
    output: B({
      settings: B({
        attributes: B({
          company_name: V().nullable(),
          phone: V().nullable()
        }),
        is_internal: Yt(),
        production_methods: m0.array().optional(),
        // for now optional as not online available
        settings: B({
          customization_positioning_mode: V(),
          include_tax: Yt(),
          locale: V(),
          units: B({
            currency: V(),
            length: V()
          })
        })
      })
    })
  }
), p0 = pt({ get: h0 }), f0 = pt({ app: d0, designer: p0 }), v0 = Ge.query(
  (t) => ({ searchParams: { filter: t }, url: "customer-logos/count" }),
  {
    input: B({ production_method: ut(R()) }).partial().optional(),
    output: R(),
    responseTransformer: async (t) => (await t.json()).count
  }
);
function wa(t) {
  return B({
    data: t.array(),
    links: B({
      first: V().nullable(),
      last: V().nullable(),
      next: V().nullable(),
      prev: V().nullable()
    }),
    meta: B({
      next_cursor: V().nullable(),
      path: V(),
      per_page: R(),
      prev_cursor: V().nullable()
    })
  });
}
var Rs = /* @__PURE__ */ ((t) => (t.INNER = "inner", t.OUTER = "outer", t))(Rs || {}), vs = /* @__PURE__ */ ((t) => (t.BOTTOM_CENTER = "bc", t.BOTTOM_LEFT = "bl", t.BOTTOM_RIGHT = "br", t.LEFT_BOTTOM = "lb", t.LEFT_CENTER = "lc", t.LEFT_TOP = "lt", t.RIGHT_BOTTOM = "rb", t.RIGHT_CENTER = "rc", t.RIGHT_TOP = "rt", t.TOP_CENTER = "tc", t.TOP_LEFT = "tl", t.TOP_RIGHT = "tr", t))(vs || {});
const ml = B({
  id: R(),
  name: V(),
  base_logo_id: R().nullable(),
  color_assignments: B({
    id: R(),
    apply_to: at("fill"),
    blue: R(),
    color: Kd.nullable(),
    created_at: V().datetime({ offset: !0 }),
    green: R(),
    is_color_picker: Yt().nullable(),
    red: R(),
    updated_at: V().datetime({ offset: !0 })
  }).array(),
  created_at: V().datetime({ offset: !0 }),
  design_settings: B({
    next_element_alignment: B({
      anchor_type: at(Rs.OUTER),
      anchor_value: un(vs),
      offset: B({ x: R(), y: R() }),
      rotation: R()
    })
  }),
  external_identifier: V().nullable(),
  height: R().nullable(),
  is_customer_logo: Yt(),
  is_editable: Yt(),
  is_scaleable: Yt(),
  max_height: R().nullable(),
  max_width: R().nullable(),
  min_height: R().nullable(),
  min_width: R().nullable(),
  preview_url: V().nullable(),
  production_method: B({ id: R() }),
  production_type: B({ id: R() }),
  texts: j1().array(),
  updated_at: V().datetime({ offset: !0 }),
  width: R().nullable()
}), g0 = Ge.query(
  (t) => ({ url: `logos/${t.toString()}` }),
  {
    input: R(),
    output: ml
  }
), hl = B({
  id: R(),
  name: V().nullable(),
  created_at: V().datetime({ offset: !0 }),
  logo: ml,
  updated_at: V().datetime({ offset: !0 })
}), _0 = Ge.infiniteQuery(
  (t, e) => ({
    searchParams: { cursor: e, filter: t },
    url: "customer-logos"
  }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({ production_method: ut(R()) }).partial().optional(),
    onSuccess: ({ output: t }) => {
      const e = mt();
      for (const n of t.data) {
        e.setQueryData(
          le.customerLogos.get.getQueryKey(n.id),
          n
        );
        const s = n.logo;
        e.setQueryData(
          le.logos.get.getQueryKey(s.id),
          s
        );
      }
    },
    output: wa(hl)
  }
), k0 = Ge.query(
  (t) => ({
    url: `customer-logos/${t.toString()}`
  }),
  {
    input: R(),
    onSuccess: ({ output: t }) => {
      const e = mt(), n = t.logo;
      e.setQueryData(
        le.logos.get.getQueryKey(n.id),
        n
      );
    },
    output: hl
  }
);
function y0(t, e) {
  if (e && e.pages[0])
    return {
      ...e,
      pages: [
        {
          ...e.pages[0],
          data: [t, ...e.pages[0].data]
        },
        ...e.pages.slice(1)
      ]
    };
}
function Jd({ id: t, name: e }, n) {
  if (n)
    return {
      ...n,
      pages: n.pages.map((s) => ({
        ...s,
        data: s.data.map(
          (a) => a.id === t ? {
            ...a,
            name: e
          } : a
        )
      }))
    };
}
const b0 = Ge.mutation(
  (t) => ({
    json: { ...t, id: void 0 },
    method: "patch",
    url: `customer-logos/${t.id.toString()}`
  }),
  {
    input: B({ id: R(), name: V() }),
    onSuccess: ({ output: t }) => {
      mt().setQueriesData(
        { queryKey: le.customerLogos.list.getQueryKey() },
        (e) => Jd(t, e)
      );
    },
    output: hl
  }
), w0 = Ge.mutation(
  ({ path: t, production_method_id: e }) => ({
    json: {
      path: t,
      production_method: {
        id: e
      }
    },
    method: "post",
    url: "customer-logos"
  }),
  {
    input: B({ path: V(), production_method_id: R() }),
    output: R(),
    responseTransformer: async (t) => {
      const e = await t;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), x0 = Ge.mutation(
  (t) => ({
    json: t,
    method: "post",
    url: "customer-logos/temporary-upload-url"
  }),
  {
    input: B({ content_type: V(), file_name: V() }),
    output: B({
      path: V(),
      url: V()
    })
  }
), $0 = pt({
  count: v0,
  get: k0,
  list: _0,
  patch: b0,
  post: w0,
  temporaryUploadUrl: x0
}), S0 = Ge.query(
  (t) => ({ searchParams: { filter: t }, url: "designs/favored/count" }),
  {
    input: B({ production_method: ut(R()) }).partial().optional(),
    output: R(),
    responseTransformer: async (t) => (await t.json()).count
  }
);
function Yd(t, e) {
  if (e) {
    if (e.pages.some(
      (n) => n.data.some((s) => s.id === t.id)
    )) {
      pl(t, e);
      return;
    }
    if (e.pages[0])
      return {
        ...e,
        pages: [
          {
            ...e.pages[0],
            data: [t, ...e.pages[0].data]
          },
          ...e.pages.slice(1)
        ]
      };
  }
}
function em(t, e) {
  if (e)
    return {
      ...e,
      pages: e.pages.map((n) => ({
        ...n,
        data: n.data.filter((s) => s.id !== t)
      }))
    };
}
function pl({ id: t, name: e }, n) {
  if (n)
    return {
      ...n,
      pages: n.pages.map((s) => ({
        ...s,
        data: s.data.map(
          (a) => a.id === t ? {
            ...a,
            name: e
          } : a
        )
      }))
    };
}
const A0 = Ge.mutation(
  (t) => ({ method: "delete", url: `designs/favored/${t.toString()}` }),
  {
    input: R(),
    onSuccess: ({ input: t }) => {
      const e = mt();
      e.setQueriesData(
        { queryKey: le.designs.favored.list.getQueryKey() },
        (n) => em(t, n)
      ), e.invalidateQueries({
        queryKey: le.designs.favored.count.getQueryKey()
      });
    },
    output: B({ message: V() })
  }
);
var is = /* @__PURE__ */ ((t) => (t.CENTER = "center", t.LEFT = "left", t.RIGHT = "right", t))(is || {});
const tm = Wn([
  B({
    id: R(),
    color: B({
      id: R()
    })
  }),
  B({
    id: R(),
    blue: R(),
    color: va().optional(),
    green: R(),
    red: R()
  })
]), C0 = B({
  dimension: B({ height: R(), width: R() }).optional(),
  resource: B({
    id: R(),
    name: V(),
    color_assignments: tm.array(),
    created_at: V().datetime({ offset: !0 }),
    design_settings: B({
      next_element_alignment: B({
        anchor_type: at(Rs.OUTER),
        anchor_value: un(vs),
        offset: B({ x: R(), y: R() }),
        rotation: R()
      })
    }),
    external_identifier: V().nullable(),
    height: R(),
    is_customer_logo: Yt(),
    max_height: R(),
    max_width: R(),
    min_height: R(),
    min_width: R(),
    origin: Wn([
      at("merchant-upload"),
      at("customer-upload"),
      at("customer-logo")
    ]),
    preview_url: V().nullable(),
    production_method: B({ id: R() }),
    production_type: B({ id: R(), handle: V() }),
    updated_at: V().datetime({ offset: !0 }),
    width: R()
  }),
  resource_type: at("logo")
}), P0 = B({
  resource: B({
    lines: ut(
      B({
        bending_radius: R(),
        color_assignments: Gn([tm]),
        font: B({ id: R() }),
        font_size: R(),
        horizontal_alignment: un(is),
        offset: R(),
        order_column: R(),
        padding_bottom: R(),
        value: V()
      })
    ),
    preview_url: V().nullable(),
    production_method: B({ id: R() })
  }),
  resource_type: at("text")
}), I0 = B({ elements: ut(ll(() => M0)) }), nm = rl("resource_type", [
  C0,
  P0
]).and(I0), M0 = nm.and(
  B({
    alignment: B({
      anchor_type: at(Rs.OUTER),
      anchor_value: un(vs),
      offset: B({ x: R(), y: R() })
    })
  })
), xa = B({
  id: R(),
  name: V().nullable(),
  created_at: V().datetime({ offset: !0 }),
  elements: Gn([nm]),
  height: R(),
  preview_url: V(),
  production_method: B({ id: R() }),
  updated_at: V().datetime({ offset: !0 }),
  width: R()
}), T0 = Ge.query(
  (t) => ({ url: `designs/favored/${t.toString()}` }),
  {
    input: R(),
    output: xa
  }
), z0 = Ge.infiniteQuery(
  (t, e) => ({
    searchParams: { cursor: e, filter: t },
    url: "designs/favored"
  }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({ production_method: ut(R()) }).partial().optional(),
    onSuccess: ({ output: t }) => {
      const e = mt();
      for (const n of t.data)
        e.setQueryData(
          le.designs.favored.get.getQueryKey(n.id),
          n
        );
    },
    output: wa(xa)
  }
), E0 = Ge.mutation(
  ({ id: t, name: e }) => ({
    json: { name: e },
    method: "patch",
    url: `designs/favored/${t.toString()}`
  }),
  {
    input: B({ id: R(), name: V() }),
    onSuccess: ({ output: t }) => {
      mt().setQueriesData(
        { queryKey: le.designs.favored.list.getQueryKey() },
        (e) => pl(t, e)
      );
    },
    output: xa
  }
), O0 = B({
  dimension: B({ height: R(), width: R() }).optional(),
  resource: B({
    id: R(),
    color_assignments: Wn([
      B({
        id: R(),
        color: B({
          id: R()
        })
      }),
      B({
        id: R(),
        blue: R(),
        color: va().optional(),
        green: R(),
        red: R()
      })
    ]).array(),
    production_method: B({ id: R() })
  }),
  resource_type: at("logo")
}), R0 = B({
  resource: B({
    lines: ut(
      B({
        bending_radius: R(),
        color_assignments: Gn([
          Wn([
            B({
              color: B({
                id: R()
              })
            }),
            B({
              blue: R(),
              color: va().optional(),
              green: R(),
              red: R()
            })
          ])
        ]),
        font: B({ id: R() }),
        font_size: R(),
        horizontal_alignment: un(is),
        offset: R(),
        order_column: R(),
        padding_bottom: R(),
        value: V()
      })
    ),
    production_method: B({ id: R() })
  }),
  resource_type: at("text")
}), L0 = B({ elements: ut(ll(() => D0)) }), Ls = rl("resource_type", [
  O0,
  R0
]).and(L0), D0 = Ls.and(
  B({
    alignment: B({
      anchor_type: at(Rs.OUTER),
      anchor_value: un(vs),
      offset: B({ x: R(), y: R() }),
      rotation: R()
    })
  })
), N0 = Xd.query(
  (t) => ({ json: t, method: "post", url: "designs/preview" }),
  {
    input: B({
      elements: Gn([Ls]),
      production_method: B({ id: R() })
    }),
    output: B({
      content: V(),
      height: R(),
      width: R()
    })
  }
), V0 = Ge.mutation(
  (t) => ({ json: t, method: "post", url: "designs/favored" }),
  {
    input: B({
      elements: Gn([Ls]),
      production_method: B({ id: R() })
    }),
    onSuccess: ({ input: t, output: e }) => {
      const n = mt();
      n.setQueriesData(
        {
          queryKey: le.designs.favored.list.getQueryKey({
            production_method: [e.production_method.id]
          })
        },
        (s) => Yd(e, s)
      ), n.invalidateQueries({
        queryKey: le.designs.favored.count.getQueryKey({
          production_method: [t.production_method.id]
        })
      });
    },
    output: xa
  }
), U0 = pt({
  count: S0,
  delete: A0,
  get: T0,
  list: z0,
  patch: E0,
  post: V0
}), F0 = pt({ favored: U0, preview: N0 });
function sm() {
  const t = mt(), e = le.favorites.variants.list.getQueryKey(), n = le.designs.favored.list.getQueryKey();
  function s(a) {
    t.setQueriesData(
      {
        queryKey: e
      },
      (o) => {
        if (o)
          return {
            ...o,
            pages: o.pages.map((i) => ({
              ...i,
              data: i.data.filter(
                (r) => r.id !== a
              )
            }))
          };
      }
    ), t.setQueriesData(
      {
        queryKey: n
      },
      (o) => {
        if (o)
          return {
            ...o,
            pages: o.pages.map((i) => ({
              ...i,
              data: i.data.filter(
                (r) => r.id !== a
              )
            }))
          };
      }
    );
  }
  return {
    deleteFavorite: s
  };
}
const j0 = Ge.mutation(
  (t) => ({ method: "delete", url: `favorites/${t.toString()}` }),
  {
    input: R(),
    onSuccess: ({ input: t }) => {
      const { deleteFavorite: e } = sm();
      e(t);
    }
  }
), am = Wn([
  at("merchant-sketch"),
  at("customer-sketch"),
  at("ordered")
]);
var Ds = /* @__PURE__ */ ((t) => (t.BOTTOM_CENTER = "bc", t.BOTTOM_LEFT = "bl", t.BOTTOM_RIGHT = "br", t.CENTER_CENTER = "cc", t.CENTER_LEFT = "cl", t.CENTER_RIGHT = "cr", t.TOP_CENTER = "tc", t.TOP_LEFT = "tl", t.TOP_RIGHT = "tr", t))(Ds || {});
function B0(t) {
  switch (t) {
    case 0:
      return "tc";
    case 45:
      return "tr";
    case 90:
      return "cr";
    case 135:
      return "br";
    case 180:
      return "bc";
    case 225:
      return "bl";
    case 270:
      return "cl";
    case 315:
      return "tl";
    default:
      return;
  }
}
function Is(t) {
  switch (t) {
    case "b":
    case "r":
      return 1;
    case "c":
      return 0.5;
    default:
      return 0;
  }
}
function q0(t) {
  switch (t) {
    case "bc":
      return 180;
    case "bl":
      return 225;
    case "br":
      return 135;
    case "cl":
      return 270;
    case "cr":
      return 90;
    case "tc":
      return 0;
    case "tl":
      return 315;
    case "tr":
      return 45;
    default:
      return;
  }
}
const om = B({
  id: R(),
  description: V(),
  display_name: V(),
  handle: V(),
  preview_url: V(),
  production_type: B({ id: R(), handle: V() })
}), H0 = B({
  id: R(),
  name: V(),
  handle: V()
}), du = B({
  id: R(),
  annotations: B({
    id: R(),
    created_at: V(),
    description: V(),
    handle: V(),
    updated_at: V()
  }).array(),
  blacklisted_variants: R().array(),
  direction: R(),
  localized_height: R(),
  localized_width: R(),
  order_column: R(),
  position: un(Ds),
  positioning_area_identifier: H0.nullable(),
  positioning_area_identifier_handle: V().nullable(),
  production_method: om,
  rotation: R(),
  view_type_handle: V(),
  x: R(),
  y: R()
}), W0 = B({
  customizations: B({
    id: R(),
    background_color: V(),
    calculation_type: V(),
    calculation_value: R(),
    created_at: V().datetime({ offset: !0 }),
    design: xa,
    hash: V(),
    height: R(),
    order: R(),
    position: un(Ds),
    positioningArea: du,
    price: V(),
    rotation: R(),
    updated_at: V().datetime({ offset: !0 }),
    width: R(),
    x: R(),
    y: R()
  }).array(),
  display_name: V(),
  handle: V(),
  image_urls: B({
    md: V(),
    sm: V(),
    xl: V()
  }),
  long_display_name: V(),
  mockup_urls: B({
    md: V().nullable(),
    sm: V().nullable(),
    xl: V().nullable()
  }),
  positioning_areas: du.array(),
  production_areas: B({
    id: R(),
    points: B({ x: R(), y: R() }).array(),
    production_method: om,
    view_type_handle: V()
  }).array(),
  scalefactor: R(),
  short_display_name: V()
}), Po = B({
  id: R(),
  name: V(),
  attributes: B({
    name: Wn([at("color"), at("size")]),
    handle: V(),
    value: V()
  }).array(),
  base: B({
    id: R(),
    external_identifier: V().nullable()
  }),
  collection_name: Wn([at("custom"), at("catalogue")]),
  created_at: V().datetime({ offset: !0 }),
  external_identifier: V().nullable(),
  id_hash: V(),
  origin: B({
    code: V(),
    external_identifier: V().nullable()
  }),
  product_id: R(),
  state: V(),
  updated_at: V().datetime({ offset: !0 }),
  views: W0.array()
}), G0 = Ge.query(
  (t) => ({ url: `variants/cached/variant-id/${t.toString()}` }),
  {
    input: R(),
    onSuccess: ({ output: t }) => {
      const e = mt();
      for (const n of t.views)
        for (const { design: s } of n.customizations)
          e.setQueryData(
            le.designs.favored.get.getQueryKey(s.id),
            s
          );
    },
    output: Po
  }
), im = B({
  id: R(),
  collection_name: am,
  created_at: V(),
  filter_date: V(),
  id_hash: V(),
  is_active: Yt(),
  resource: Po,
  resource_type: at("variant"),
  updated_at: V()
}), Z0 = Ge.query(
  (t) => ({ url: `favorites/variants/${t.toString()}` }),
  {
    input: R(),
    onSuccess: ({ output: t }) => {
      const e = mt();
      e.setQueryData(
        le.variants.get.getQueryKey(t.resource.id),
        t.resource
      ), t.resource.external_identifier && e.setQueryData(
        le.variants.getByExternalIdentifier.getQueryKey(
          t.resource.external_identifier
        ),
        t.resource
      );
      for (const n of t.resource.views)
        for (const { design: s } of n.customizations)
          e.setQueryData(
            le.designs.favored.get.getQueryKey(s.id),
            s
          );
    },
    output: im
  }
), Q0 = Ge.infiniteQuery(
  (t, e) => ({
    searchParams: {
      ...t,
      cursor: e
    },
    url: "favorites/variants"
  }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      filter: B({
        collection_name: am,
        filter_date_equals: ts(),
        filter_date_max: ts(),
        filter_date_min: ts()
      }).partial().optional()
    }).optional(),
    onSuccess: ({ output: t }) => {
      const e = mt();
      for (const n of t.data) {
        e.setQueryData(
          le.favorites.variants.get.getQueryKey(
            n.id
          ),
          n
        ), e.setQueryData(
          le.variants.get.getQueryKey(
            n.resource.id
          ),
          n.resource
        ), n.resource.external_identifier && e.setQueryData(
          le.variants.getByExternalIdentifier.getQueryKey(
            n.resource.external_identifier
          ),
          n.resource
        );
        for (const s of n.resource.views)
          for (const { design: a } of s.customizations)
            e.setQueryData(
              le.designs.favored.get.getQueryKey(
                a.id
              ),
              a
            );
      }
    },
    output: wa(im)
  }
), X0 = Ge.mutation(
  (t) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: t,
    method: "post",
    url: "favorites/variants"
  }),
  {
    input: B({
      resource: B({
        id: R(),
        views: ut(
          B({
            customizations: ut(
              B({
                design: B({
                  elements: Gn([Ls]),
                  production_method: B({
                    id: R()
                  })
                }),
                order: R(),
                position: un(Ds),
                positioning_area: B({
                  id: R()
                }),
                rotation: R(),
                x: R(),
                y: R()
              })
            ),
            handle: V()
          })
        )
      })
    }),
    output: R(),
    responseTransformer: async (t) => {
      const e = await t;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), K0 = pt({ get: Z0, list: Q0, post: X0 }), J0 = pt({ delete: j0, variants: K0 }), Y0 = Ge.query(
  (t) => ({ searchParams: { filter: t }, url: "logos/categories" }),
  {
    input: B({ production_method: ut(R()) }).partial().optional(),
    output: B({
      id: R(),
      name: V(),
      left: R(),
      logos: R().array(),
      parent_id: R().nullable(),
      right: R()
    }).array()
  }
), e_ = pt({ list: Y0 }), t_ = B({
  node: B({
    id: R(),
    name: V(),
    entries_count: R()
  })
}), rm = t_.extend({
  children: ll(() => rm).array()
}), n_ = Ge.query(
  () => ({ method: "get", url: "logos/category-tree" }),
  { output: rm.array() }
), s_ = pt({ get: n_ }), a_ = Ge.query(
  (t) => ({ searchParams: { filter: t }, url: "logos/count" }),
  {
    input: B({
      name: V(),
      name_or_tags: V(),
      production_method: ut(R()),
      tags: V()
    }).partial().optional(),
    output: R(),
    responseTransformer: async (t) => (await t.json()).count
  }
), o_ = Ge.infiniteQuery(
  (t, e) => ({
    searchParams: {
      cursor: e,
      filter: t
    },
    url: "logos"
  }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      id: R(),
      name: V(),
      "categories.id": ut(R()),
      created_at_max: ts(),
      created_at_min: ts(),
      name_or_tags: V(),
      production_method: ut(R()),
      tags: V(),
      updated_at_max: ts(),
      updated_at_min: ts()
    }).partial().optional(),
    onSuccess: ({ output: t }) => {
      const e = mt();
      for (const n of t.data)
        e.setQueryData(
          le.logos.get.getQueryKey(n.id),
          n
        );
    },
    output: wa(ml)
  }
), i_ = pt({ categories: e_, categoryTree: s_, count: a_, get: g0, list: o_ }), r_ = Ge.query(
  (t) => ({
    json: { items: t },
    method: "post",
    url: "prices"
  }),
  {
    input: ut(
      B({
        quantity: R(),
        variant: B({ id: R() })
      })
    ),
    output: B({
      items: B({
        prices: B({
          calculation_quantity: R(),
          model_id: R(),
          model_type: V(),
          price: R(),
          pricing: B({
            calculate_from: R(),
            calculation_type: V(),
            scaled_prices: B({
              from_a_number_of: R(),
              price: R()
            }).array()
          }),
          single_unit_price: R()
        }).array(),
        quantity: R(),
        variant: B({
          id: R()
        })
      }).array()
    })
  }
), l_ = pt({ getByItems: r_ }), c_ = Ge.query(
  (t) => ({ url: `products/${t.toString()}/color-variants` }),
  {
    input: R(),
    output: B({
      color_handle: V(),
      color_name: V(),
      color_preview_url: V(),
      image_url: V(),
      size_variants: B({
        id: R(),
        external_identifier: V(),
        product_size_label_id: R().nullable(),
        product_size_label_name: V().nullable(),
        product_sizes: ut(
          B({
            id: R(),
            oder_column: R(),
            product_size_scale_id: R(),
            product_size_scale_name: V(),
            value: V()
          })
        ),
        size_handle: V(),
        size_name: V(),
        size_order_column: R()
      }).array()
    }).array()
  }
), u_ = pt({ list: c_ }), d_ = Ge.infiniteQuery(
  (t, e) => ({
    searchParams: { ...t, page: e },
    url: "products"
  }),
  {
    getNextPageParam: (t) => {
      if (!(t.meta.current_page >= t.meta.to))
        return t.meta.current_page + 1;
    },
    initialPageParam: 1,
    input: B({ per_page: R() }).partial().optional(),
    output: B({
      data: B({
        id: R(),
        created_at: V(),
        description: V(),
        is_test: R(),
        title: V(),
        updated_at: V(),
        variants: R().array()
      }).array(),
      links: B({
        first: V().nullable(),
        last: V().nullable(),
        next: V().nullable(),
        prev: V().nullable()
      }),
      meta: B({
        current_page: R(),
        current_page_url: V(),
        from: R(),
        path: V(),
        per_page: R(),
        to: R()
      })
    })
  }
), m_ = pt({ colorVariants: u_, list: d_ }), h_ = Ge.query(
  (t) => ({
    url: `variants/cached/external-identifier/${encodeURIComponent(t)}`
  }),
  {
    input: V(),
    onSuccess: ({ output: t }) => {
      const e = mt();
      for (const n of t.views)
        for (const { design: s } of n.customizations)
          e.setQueryData(
            le.designs.favored.get.getQueryKey(s.id),
            s
          );
    },
    output: Po
  }
), p_ = Ge.infiniteQuery(
  (t) => ({ searchParams: { filter: t }, url: "variants" }),
  {
    getNextPageParam: (t) => t.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: B({
      id: R().or(ut(R())),
      collection_name: V(),
      external_identifier: V()
    }).partial().optional(),
    onSuccess: ({ output: t }) => {
      const e = mt();
      for (const n of t.data) {
        e.setQueryData(
          le.variants.get.getQueryKey(n.id),
          n
        ), n.external_identifier && e.setQueryData(
          le.variants.getByExternalIdentifier.getQueryKey(
            n.external_identifier
          ),
          n
        );
        for (const s of n.views)
          for (const { design: a } of s.customizations)
            e.setQueryData(
              le.designs.favored.get.getQueryKey(
                a.id
              ),
              a
            );
      }
    },
    output: wa(Po)
  }
), f_ = Ge.query(
  (t) => ({ url: `variants/${t.toString()}/pdf-download` }),
  {
    input: R(),
    output: F1(Blob).and(
      qd((t) => t.type === "application/pdf")
    ),
    responseTransformer: (t) => t.blob()
  }
), v_ = Ge.mutation(
  /**
   * Creates a pdf preview of a custom variant.
   *
   * @param baseId id of the variant that the new one is based on
   * @param views array of views defining the variants content
   *
   * @returns id of the created variant which is used for the pdf.
   *   The created variant needs to be rendered first before it can be retrieved.
   *   A pusher event is emitted when the rendering is done.
   */
  ({ baseId: t, views: e }) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: { views: e },
    method: "post",
    timeout: !1,
    url: `variants/${t.toString()}/design-for-pdf-download`
  }),
  {
    input: B({
      baseId: R(),
      views: ut(
        B({
          customizations: ut(
            B({
              design: B({
                elements: Gn([Ls]),
                production_method: B({
                  id: R()
                })
              }),
              order: R(),
              position: un(Ds),
              positioning_area: B({
                id: R()
              }),
              rotation: R(),
              x: R(),
              y: R()
            })
          ),
          handle: V()
        })
      )
    }),
    output: R(),
    responseTransformer: async (t) => {
      const e = await t;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), g_ = pt({ getByVariantId: f_, postForDownload: v_ }), __ = Ge.mutation(
  /**
   * Creates a new custom variant
   *
   * @param baseId id of the variant that the new one is based on
   * @param views array of views defining the variants content
   *
   * @returns id of the created variant.
   *   The created variant needs to be rendered first before it can be retrieved.
   *   A pusher event is emitted when the rendering is done
   */
  ({ baseId: t, views: e }) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: { views: e },
    method: "post",
    url: `variants/${t.toString()}/design`
  }),
  {
    input: B({
      baseId: R(),
      views: ut(
        B({
          customizations: ut(
            B({
              design: B({
                elements: Gn([Ls]),
                production_method: B({
                  id: R()
                })
              }),
              order: R(),
              position: un(Ds),
              positioning_area: B({
                id: R()
              }),
              rotation: R(),
              x: R(),
              y: R()
            })
          ),
          handle: V()
        })
      )
    }),
    output: R(),
    responseTransformer: async (t) => {
      const e = await t;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), k_ = Ge.query(
  (t) => ({ url: `variants/${t.toString()}/preview-html` }),
  { input: R(), output: V() }
), y_ = pt({ getByVariantId: k_ }), b_ = pt({
  get: G0,
  getByExternalIdentifier: h_,
  list: p_,
  pdf: g_,
  post: __,
  previewHtml: y_
}), le = pt(
  {
    auth: o0,
    configurations: f0,
    customerLogos: $0,
    designs: F0,
    favorites: J0,
    logos: i_,
    prices: l_,
    products: m_,
    variants: b_
  },
  "designer-api"
), fl = tt("designer-core.pusher", () => {
  const t = N(), e = N(), n = N(), { sessionId: s } = D(ul()), { tokenData: a } = D(ba()), o = N();
  ie((m) => {
    const h = e.value, v = n.value;
    !h || !v || (o.value = Fn(
      new H1(h, {
        cluster: v
      })
    ), m(() => {
      var _;
      (_ = o.value) == null || _.disconnect(), o.value = void 0;
    }));
  });
  const i = I(() => {
    var m;
    if (t.value && (m = a.value) != null && m.user_id)
      return [
        t.value,
        "smake-designer-api",
        a.value.user_id
      ].join("-");
  }), r = I(() => {
    if (i.value)
      return [i.value, s.value].join("-");
  }), l = N(), u = N();
  return ie((m) => {
    if (!o.value)
      return;
    const h = i.value;
    h && (l.value = Fn(o.value.subscribe(h)), m(() => {
      var v;
      (v = o.value) == null || v.unsubscribe(h), l.value = void 0;
    }));
  }), ie((m) => {
    if (!o.value)
      return;
    const h = r.value;
    h && (u.value = Fn(
      o.value.subscribe(h)
    ), m(() => {
      var v;
      (v = o.value) == null || v.unsubscribe(h), u.value = void 0;
    }));
  }), {
    appKey: e,
    channelPrefix: t,
    channelSession: u,
    channelUser: l,
    cluster: n,
    pusher: o
  };
});
function Ft(t, e) {
  const { channelUser: n } = D(fl()), s = jt(t);
  ie((a) => {
    const o = n.value;
    if (!o) return;
    const i = s.value;
    o.bind(i, e), a(() => {
      o.unbind(i, e);
    });
  });
}
function en(t) {
  const e = Bn();
  return P(t, e);
}
function w_() {
  const t = mt(), e = le.customerLogos.list.getQueryKey(), n = en(
    (o) => t.fetchQuery({
      ...le.customerLogos.get.use(o),
      retry: !1,
      staleTime: 1 / 0
    })
  ), s = en(
    (o) => le.customerLogos.list.getQueryKey({
      production_method: [o]
    })
  );
  Ft("customerLogo.updated", (o) => {
    t.setQueriesData(
      {
        queryKey: e
      },
      (i) => Jd(o, i)
    );
  }), Ft("customerLogo.completed", async ({ id: o }) => {
    const i = await n(o);
    t.setQueriesData(
      {
        queryKey: s(
          i.logo.production_method.id
        )
      },
      (r) => y0(i, r)
    ), await t.invalidateQueries({
      queryKey: a(
        i.logo.production_method.id
      )
    });
  });
  const a = en(
    (o) => le.customerLogos.count.getQueryKey({
      production_method: [o]
    })
  );
}
function x_(t) {
  const e = mt();
  Ft(
    "customVariant.deleteFromArchive.completed",
    ({ id: s }) => {
      const a = le.favorites.variants.list.getQueryKey({
        filter: {
          collection_name: "customer-sketch"
        }
      });
      e.setQueryData(
        a,
        (o) => o && {
          ...o,
          pages: o.pages.map((i) => ({
            ...i,
            data: i.data.filter(
              (r) => r.id !== s
            )
          }))
        }
      );
    }
  ), Ft(
    "customVariant.customizationsCompletedAfterAssignedToArchive",
    async ({ id: s }) => {
      try {
        const a = await n(s), o = le.favorites.variants.list.getQueryKey({
          filter: {
            collection_name: "customer-sketch"
          }
        }), i = e.getQueryData(
          o
        );
        if (!i) return;
        if (i.pages.some(
          (r) => r.data.some((l) => l.id === s)
        )) {
          e.setQueryData(
            o,
            (r) => {
              if (r)
                return {
                  ...r,
                  pages: r.pages.map((l) => ({
                    ...l,
                    data: l.data.map(
                      (u) => u.id === s ? a : u
                    )
                  }))
                };
            }
          );
          return;
        }
        e.setQueryData(
          o,
          (r) => {
            if (r != null && r.pages[0])
              return {
                ...r,
                pages: [
                  {
                    ...r.pages[0],
                    data: [
                      a,
                      ...r.pages[0].data
                    ]
                  },
                  ...r.pages.slice(1)
                ]
              };
          }
        );
      } catch (a) {
        t && t(a);
      }
    }
  );
  const n = en(
    (s) => e.fetchQuery(le.favorites.variants.get.use(s))
  );
}
function $_(t) {
  const e = mt();
  Ft(
    "favorite.deleted",
    async ({ resource_id: o, resource_type: i }) => {
      if (i === "design") {
        e.setQueriesData(
          { queryKey: s() },
          (r) => em(o, r)
        );
        try {
          await e.invalidateQueries({
            queryKey: a()
          });
        } catch (r) {
          t && t(r);
        }
      }
    }
  ), Ft("favoredDesign.updated", (o) => {
    e.setQueriesData(
      { queryKey: s() },
      (i) => pl(o, i)
    );
  }), Ft(
    "favorite.created",
    async ({ resource_id: o, resource_type: i }) => {
      if (i === "design")
        try {
          const r = await n(o);
          e.setQueriesData(
            {
              queryKey: s([
                r.production_method.id
              ])
            },
            (l) => Yd(r, l)
          ), await e.invalidateQueries({
            queryKey: a()
          });
        } catch (r) {
          t && t(r);
        }
    }
  );
  const n = en((o) => {
    const i = le.designs.favored.get.use(o);
    return e.fetchQuery(i);
  }), s = en(
    (o) => o === void 0 ? le.designs.favored.list.getQueryKey() : le.designs.favored.list.getQueryKey({
      production_method: o
    })
  ), a = en(() => le.designs.favored.count.getQueryKey());
}
function S_(t) {
  const e = mt(), n = le.favorites.variants.list.getQueryKey({
    filter: { collection_name: "customer-sketch" }
  });
  Ft("favorite.rendered", async ({ id: o }) => {
    try {
      const i = await a(o), r = e.getQueryData(
        n
      );
      if (!r) return;
      if (r.pages.some(
        (l) => l.data.some((u) => u.id === o)
      )) {
        e.setQueryData(
          n,
          (l) => {
            if (l)
              return {
                ...l,
                pages: l.pages.map((u) => ({
                  ...u,
                  data: u.data.map(
                    (m) => m.id === o ? i : m
                  )
                }))
              };
          }
        );
        return;
      }
      e.setQueryData(
        n,
        (l) => {
          if (l != null && l.pages[0])
            return {
              ...l,
              pages: [
                {
                  ...l.pages[0],
                  data: [i, ...l.pages[0].data]
                },
                ...l.pages.slice(1)
              ]
            };
        }
      );
    } catch (i) {
      t && t(i);
    }
  });
  const { deleteFavorite: s } = sm();
  Ft("favorite.deleted", ({ id: o, resource_type: i }) => {
    i === "variant" && s(o);
  }), Ft("favorite.updated", async ({ id: o }) => {
    try {
      const i = await a(o), r = e.getQueryData(
        n
      );
      if (!r) return;
      if (r.pages.some(
        (l) => l.data.some((u) => u.id === o)
      )) {
        e.setQueryData(
          n,
          (l) => {
            if (l)
              return {
                ...l,
                pages: l.pages.map((u) => ({
                  ...u,
                  data: u.data.map(
                    (m) => m.id === o ? i : m
                  )
                }))
              };
          }
        );
        return;
      }
      e.setQueryData(
        n,
        (l) => {
          if (l != null && l.pages[0])
            return {
              ...l,
              pages: [
                {
                  ...l.pages[0],
                  data: [i, ...l.pages[0].data]
                },
                ...l.pages.slice(1)
              ]
            };
        }
      );
    } catch (i) {
      t && t(i);
    }
  }), Ft("favorite.created", async ({ id: o, resource_type: i }) => {
    if (i === "variant")
      try {
        const r = await a(o), l = e.getQueryData(
          n
        );
        if (!l) return;
        if (l.pages.some(
          (u) => u.data.some((m) => m.id === r.id)
        )) {
          e.setQueryData(
            n,
            (u) => {
              if (u)
                return {
                  ...u,
                  pages: u.pages.map((m) => ({
                    ...m,
                    data: m.data.map(
                      (h) => h.id === o ? r : h
                    )
                  }))
                };
            }
          );
          return;
        }
        e.setQueryData(
          n,
          (u) => {
            if (u != null && u.pages[0])
              return {
                ...u,
                pages: [
                  {
                    ...u.pages[0],
                    data: [r, ...u.pages[0].data]
                  },
                  ...u.pages.slice(1)
                ]
              };
          }
        );
      } catch (r) {
        t && t(r);
      }
  });
  const a = en((o) => {
    const i = le.favorites.variants.get.use(o);
    return e.fetchQuery(i);
  });
}
function A_(t) {
  w_(), S_(t), $_(t), x_(t);
}
let zr = class extends Error {
};
function Mt(t, e) {
  const n = Bu(t);
  if (!n)
    throw new Error(`injection "${String(t)}" not found`);
  return n;
}
const mu = 4095, or = {};
function vl(t, e) {
  const n = I(
    () => !!Jt(t) && !Jt(e == null ? void 0 : e.disabled)
  ), s = I(() => {
    const o = Jt(e == null ? void 0 : e.placeholder);
    if (o)
      return Fn(C_(o));
  }), a = kt({
    enabled: n,
    placeholderData: s,
    queryFn: async () => (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Fn(await Jl.load(Jt(t)))
    ),
    queryKey: ["pixi.js-asset", t],
    staleTime: 1 / 0
  });
  return ie(() => {
    const o = Jt(t);
    n.value || !o || Jl.backgroundLoad(o);
  }), a;
}
function C_({ height: t, radius: e, width: n }) {
  const s = Math.min(mu / n, mu / t, 1);
  n = Math.round(n * s), t = Math.round(t * s), e = Math.round(e * s);
  const a = `${n.toString()}x${t.toString()}|${e.toString()}}`;
  if (!(a in or)) {
    const o = document.createElement("canvas");
    o.width = n, o.height = t;
    const i = o.getContext("2d");
    if (!i) throw new Error("Canvas context couldn't be created");
    i.fillStyle = "#ffffff", i.roundRect(0, 0, n, t, e), i.fill(), or[a] = nd.from(o);
  }
  return or[a];
}
function Ms(t, e, n) {
  const s = lm(n, [
    { x: -e.x, y: -e.y },
    { x: t.width - e.x, y: -e.y },
    { x: -e.x, y: t.height - e.y },
    { x: t.width - e.x, y: t.height - e.y }
  ]), a = s.map(({ x: i }) => i), o = s.map(({ y: i }) => i);
  return {
    bottom: Math.max(...o),
    left: Math.min(...a),
    right: Math.max(...a),
    top: Math.min(...o)
  };
}
function vo({ x: t, y: e }, { x: n, y: s }) {
  return Math.hypot(t - n, e - s);
}
function rn(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function ir(t, e, n, s) {
  return (e - t) * (1 - Math.exp(-0.1 * n));
}
function Io(t) {
  return (t % 360 + 360) % 360;
}
function P_(t) {
  return t * (180 / Math.PI);
}
function lm(t, e) {
  const n = I_(t), s = Math.cos(n), a = Math.sin(n);
  return e.map(({ x: o, y: i }) => ({
    x: o * s - i * a,
    y: o * a + i * s
  }));
}
function hu(t, e, n, s) {
  const { x: a, y: o } = t;
  if (typeof e == "number") {
    const r = a + ir(a, e, n);
    return t.set(r), Math.abs(r - e);
  }
  const i = {
    x: a + ir(a, e.x, n),
    y: o + ir(o, e.y, n)
  };
  return t.copyFrom(i), vo(i, e);
}
function I_(t) {
  return t * Math.PI / 180;
}
var be = /* @__PURE__ */ ((t) => (t.ANCHOR = "ANCHOR", t.LOGO = "LOGO", t.TEXT = "TEXT", t))(be || {});
function Er(t, e) {
  var n, s, a, o, i, r, l, u, m, h, v, _;
  let y = { max: 1 / 0, min: -1 / 0 };
  switch (t.type) {
    case be.ANCHOR: {
      const S = Er(
        t.parent,
        e
      );
      y = {
        max: Math.min(y.max, S.max),
        min: Math.max(y.min, S.min)
      };
      for (const f of t.children) {
        const k = Er(
          f.value,
          e
        );
        y = {
          max: Math.min(y.max, k.max),
          min: Math.max(y.min, k.min)
        };
      }
      break;
    }
    case be.LOGO:
      t.size && (y = {
        max: Math.min(
          y.max,
          (((s = (n = e.logo) == null ? void 0 : n.size) == null ? void 0 : s.max) ?? 1 / 0) / t.size.width,
          (((o = (a = e.logo) == null ? void 0 : a.size) == null ? void 0 : o.max) ?? 1 / 0) / t.size.height
        ),
        min: Math.max(
          y.min,
          (((r = (i = e.logo) == null ? void 0 : i.size) == null ? void 0 : r.min) ?? -1 / 0) / t.size.width,
          (((u = (l = e.logo) == null ? void 0 : l.size) == null ? void 0 : u.min) ?? -1 / 0) / t.size.height
        )
      });
      break;
    case be.TEXT:
      for (const S of t.lines)
        y = {
          max: (((h = (m = e.text) == null ? void 0 : m.size) == null ? void 0 : h.max) ?? 1 / 0) / S.size,
          min: (((_ = (v = e.text) == null ? void 0 : v.size) == null ? void 0 : _.min) ?? -1 / 0) / S.size
        };
      break;
  }
  return y;
}
function Or(t) {
  switch (t.type) {
    case be.ANCHOR:
      return Or(t.parent) && t.children.every(({ value: e }) => Or(e));
    case be.LOGO:
      return !!t.size;
    case be.TEXT:
      return !0;
  }
}
function ga(t) {
  switch (t.type) {
    case be.ANCHOR: {
      const e = ga(t.parent);
      if (!e)
        throw new Error(
          "Normalized parent of anchor design is undefined"
        );
      const n = t.children.map((s) => {
        const a = ga(s.value);
        return a ? { ...s, value: a } : void 0;
      }).filter((s) => s !== void 0);
      return n.length === 0 ? e : {
        children: n,
        parent: e,
        type: be.ANCHOR
      };
    }
    case be.LOGO:
      return t;
    case be.TEXT: {
      const e = {
        lines: t.lines.map((n) => ({ ...n, text: n.text.trim() })).filter((n) => n.text),
        type: be.TEXT
      };
      return e.lines.length === 0 ? void 0 : e;
    }
  }
}
function Rr(t, e, n) {
  var s, a, o, i, r, l, u, m, h, v, _, y, S, f, k, w, C, M, T, E;
  switch (t.type) {
    case be.ANCHOR:
      Rr(t.parent, e, n);
      for (const U of t.children)
        Rr(U.value, e, n);
      break;
    case be.LOGO:
      t.size && (t.size.width = rn(
        t.size.width * e,
        ((a = (s = n == null ? void 0 : n.logo) == null ? void 0 : s.size) == null ? void 0 : a.min) ?? 0,
        ((i = (o = n == null ? void 0 : n.logo) == null ? void 0 : o.size) == null ? void 0 : i.max) ?? 1 / 0
      ), t.size.height = rn(
        t.size.height * e,
        ((l = (r = n == null ? void 0 : n.logo) == null ? void 0 : r.size) == null ? void 0 : l.min) ?? 0,
        ((m = (u = n == null ? void 0 : n.logo) == null ? void 0 : u.size) == null ? void 0 : m.max) ?? 1 / 0
      ));
      break;
    case be.TEXT:
      for (const U of t.lines)
        U.offsetLeft && (U.offsetLeft = rn(
          U.offsetLeft * e,
          ((v = (h = n == null ? void 0 : n.text) == null ? void 0 : h.offsetLeft) == null ? void 0 : v.min) ?? -1 / 0,
          ((y = (_ = n == null ? void 0 : n.text) == null ? void 0 : _.offsetLeft) == null ? void 0 : y.max) ?? 1 / 0
        )), U.paddingBottom = rn(
          U.paddingBottom * e,
          ((f = (S = n == null ? void 0 : n.text) == null ? void 0 : S.paddingBottom) == null ? void 0 : f.min) ?? -1 / 0,
          ((w = (k = n == null ? void 0 : n.text) == null ? void 0 : k.paddingBottom) == null ? void 0 : w.max) ?? 1 / 0
        ), U.size = rn(
          U.size * e,
          ((M = (C = n == null ? void 0 : n.text) == null ? void 0 : C.size) == null ? void 0 : M.min) ?? 0,
          ((E = (T = n == null ? void 0 : n.text) == null ? void 0 : T.size) == null ? void 0 : E.max) ?? 1 / 0
        );
      break;
  }
}
const Ns = Symbol("designer_core"), gl = Symbol("view"), Vs = Symbol("positioning_area"), cm = Symbol("positioning_area_design"), _l = Symbol("design"), M_ = {
  name: "loadCdnTextures",
  config: {
    crossOrigin: "anonymous",
    preferCreateImageBitmap: !0,
    preferWorkers: !0
  },
  extension: {
    name: "loadCdnTextures",
    priority: Jp.High,
    type: Yu.LoadParser
  },
  // @ts-expect-error: It's like that in the source
  async load(t, e, n) {
    var s, a;
    let o;
    globalThis.createImageBitmap && (s = this.config) != null && s.preferCreateImageBitmap ? o = this.config.preferWorkers && await Kl.isImageBitmapSupported() ? await Kl.loadImageBitmap(t, e) : await _f(t, e) : o = await new Promise((r) => {
      o = new Image(), o.crossOrigin = this.config.crossOrigin, o.src = t, o.complete ? r(o) : o.addEventListener("load", () => {
        r(o);
      });
    });
    const i = new kf({
      alphaMode: "premultiply-alpha-on-upload",
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      resolution: ((a = e.data) == null ? void 0 : a.resolution) || yf(t),
      resource: o,
      ...e.data
    });
    return bf(i, n, t);
  },
  test(t) {
    return /^https:\/\/cdn\.(.+\.)?smake\./.test(t);
  },
  unload(t) {
    t.destroy(!0);
  }
}, T_ = {
  AnimatedSprite: { createElement: (t) => new pf(t) },
  BitmapText: { createElement: (t) => new hf(t) },
  Container: { createElement: (t) => new Ju(t) },
  Graphics: { createElement: (t) => new mf(t) },
  HtmlText: { createElement: (t) => new df(t) },
  Mesh: { createElement: (t) => new uf(t) },
  MeshPlane: { createElement: (t) => new cf(t) },
  MeshRope: { createElement: (t) => new lf(t) },
  MeshSimple: { createElement: (t) => new rf(t) },
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  NineSlicePlane: { createElement: (t) => new of(t) },
  NineSliceSprite: { createElement: (t) => new af(t) },
  ParticleContainer: {
    createElement: (t) => new sf(t)
  },
  PerspectiveMesh: { createElement: (t) => new nf(t) },
  RenderContainer: { createElement: (t) => new tf(t) },
  RenderLayer: { createElement: (t) => new ef(t) },
  Sprite: { createElement: (t) => new td(t) },
  Text: { createElement: (t) => new ed(t) },
  TilingSprite: { createElement: (t) => new Yp(t) }
};
function z_() {
  const t = new td(nd.EMPTY);
  return t.visible = !1, t.renderable = !1, t;
}
function E_(t) {
  const e = {};
  for (const [n, s] of Object.entries(t))
    e[Uu(n)] = s;
  return e;
}
function pu(t, e) {
  if (!(t instanceof gf)) {
    ju("Text is only supported with Text or BitmapText elements");
    return;
  }
  t.text = e;
}
function O_(t) {
  return t.charAt(0).toLowerCase() + t.slice(1);
}
const um = {};
function R_(t, e) {
  um[t] = e;
}
const { createApp: L_, render: lV } = Tp({
  createComment: z_,
  // @ts-expect-error: No way found to fix this
  createElement(t, e, n, s) {
    const a = K1(t), o = X1(a) ? T_[a] : um[a];
    if (!o) throw new Error(`Unknown element ${t}`);
    return Fn(
      o.createElement(
        // @ts-expect-error: We just have to assume the types are correct
        E_(s ?? {})
      )
    );
  },
  createText(t) {
    return new ed({ text: t });
  },
  insert(t, e, n) {
    if (n) {
      e.addChildAt(t, e.getChildIndex(n));
      return;
    }
    e.addChild(t);
  },
  nextSibling(t) {
    const e = t.parent.getChildIndex(t);
    return t.parent.children.length <= e + 1 ? (
      // eslint-disable-next-line unicorn/no-null
      null
    ) : t.parent.getChildAt(e + 1);
  },
  parentNode(t) {
    return t.parent;
  },
  patchProp(t, e, n, s) {
    if (e = Uu(e), e.startsWith("on")) {
      const a = O_(e.slice(2));
      if (n !== null)
        if (Array.isArray(n))
          for (const o of n)
            t.off(a, o);
        else
          t.off(a, n);
      if (Array.isArray(s))
        for (const o of s)
          t.on(a, o);
      else
        t.on(a, s);
      return;
    }
    if (!t[`_vp_skip_first_set_${e}`]) {
      t[`_vp_skip_first_set_${e}`] = !0;
      return;
    }
    t[e] = s;
  },
  remove(t) {
    t.destroy();
  },
  setElementText: pu,
  setText: pu
});
ff.add({ ref: M_, type: Yu.LoadParser });
const dm = Symbol(
  "vue_pixi_application"
);
function D_(t) {
  let e = !1, n;
  return (...s) => {
    n = s, !e && (e = !0, requestAnimationFrame(() => {
      e = !1, t(...n), n = void 0;
    }));
  };
}
const N_ = K({
  props: [
    "preference",
    "webgpu",
    "webgl",
    "skipExtensionImports",
    "manageImports",
    "backgroundColor",
    "background",
    "backgroundAlpha",
    "clearBeforeRender",
    "width",
    "height",
    "canvas",
    "view",
    "autoDensity",
    "resolution",
    "antialias",
    "depth",
    "multiView",
    "hello",
    "textureGCActive",
    "textureGCAMaxIdle",
    "textureGCCheckCountMax",
    "eventMode",
    "eventFeatures",
    "failIfMajorPerformanceCaveat",
    "roundPixels",
    "bezierSmoothness",
    "useBackBuffer",
    "context",
    "powerPreference",
    "premultipliedAlpha",
    "preserveDrawingBuffer",
    "preferWebGLVersion",
    "forceFallbackAdapter",
    "resizeTo",
    "autoStart",
    "sharedTicker"
  ],
  setup(t, { expose: e, slots: n }) {
    const s = N(), a = new vf(), o = N(!1), i = I(() => {
      const y = {};
      for (const [S, f] of Object.entries(t))
        f !== void 0 && (y[S] = f);
      return y;
    });
    globalThis.__PIXI_DEVTOOLS__ = {
      app: a,
      pixi: Xp
    };
    const r = L_(
      K(() => () => {
        var y;
        return (y = n.default) == null ? void 0 : y.call(n);
      })
    ), l = { app: a, canvas: s, isInitialized: o };
    cs(dm, l), e(l);
    const u = Bn(), m = u.appContext.app;
    r.config.globalProperties = m.config.globalProperties, Object.assign(r._context, m._context), r._context.provides = u.provides, r.mount(a.stage);
    function h(y, S, f) {
      const k = a.renderer, w = y * f, C = S * f;
      if (k instanceof wf) {
        const M = k.gpu.device.limits.maxTextureDimension2D;
        k.resolution = Math.min(
          f,
          f * Math.min(
            Math.min(w, M) / w,
            Math.min(C, M) / C
          )
        ), k.resize(y, S);
      } else k instanceof xf && (k.resolution = f, k.resize(y, S), k.resolution = Math.min(
        f,
        f * Math.min(
          k.gl.drawingBufferWidth / w,
          k.gl.drawingBufferHeight / C
        )
      ));
      a.render();
    }
    const v = D_(h);
    function _(y, S) {
      const f = Object.keys(t).filter((k) => y[k] !== S[k]);
      (f.includes("width") || f.includes("height") || f.includes("resolution")) && v(
        S.width ?? 1,
        S.height ?? 1,
        S.resolution ?? 1
      );
      for (const k of f)
        if (!["height", "resolution", "width"].includes(k)) {
          if (k in a.renderer) {
            a.renderer[k] = S[k];
            continue;
          }
          if (k in a) {
            a[k] = S[k];
            continue;
          }
          ju(`Couldn't update app according to prop ${k}`);
        }
    }
    return ht(i, (y, S) => {
      o.value && _(S, y);
    }), Fu(async () => {
      const y = {
        ...i.value,
        height: 1,
        resolution: 1,
        width: 1
      };
      await a.init({
        ...y,
        canvas: s.value
      }), _(y, i.value), o.value = !0;
    }), Xr(() => {
      r.unmount(), a.destroy();
    }), () => zp("canvas", { ref: s });
  }
});
function Ss(t, e) {
  const n = (e == null ? void 0 : e.ticker) ?? V_();
  ie((s) => {
    const a = n.value;
    !a || !Jt((e == null ? void 0 : e.enabled) ?? !0) || (a.add(t, e == null ? void 0 : e.context, e == null ? void 0 : e.priority), s(() => {
      a.remove(t, e == null ? void 0 : e.context);
    }));
  });
}
function V_() {
  const { app: t, isInitialized: e } = Mt(dm);
  return I(() => e.value ? t.ticker : void 0);
}
const U_ = ["texture", "width", "height", "alpha", "tint"], mm = /* @__PURE__ */ K({
  __name: "DesignPreview",
  setup(t) {
    const {
      error: e,
      fetchStatus: n,
      isPlaceholderData: s,
      placeholderColor: a,
      size: o,
      texture: i
    } = Mt(_l), r = I(() => n.value === "fetching"), l = N(1);
    return Ss(
      (u) => {
        l.value = Math.sin(u.lastTime / 1e3 * Math.PI) * 0.25 + 0.5;
      },
      { enabled: r }
    ), (u, m) => c(i) && c(o) ? ($(), O("PixiSprite", {
      key: 0,
      label: "DesignPreview",
      texture: c(i),
      width: c(o).width,
      height: c(o).height,
      alpha: c(e) ? 0.5 : r.value ? l.value : 1,
      tint: c(e) ? 16711680 : c(s) ? c(a) : void 0
    }, null, 8, U_)) : X("", !0);
  }
}), F_ = ["angle", "scale", "position", "pivot"], j_ = ["context"], B_ = ["context", "x", "y", "cursor"], q_ = ["context", "x", "y"], H_ = ["context", "x", "y"], W_ = /* @__PURE__ */ K({
  __name: "DesignControls",
  props: {
    deleteable: { type: Boolean },
    deleteIcon: {},
    designBounds: { default: void 0 },
    hidden: { type: Boolean },
    padding: { default: 3 },
    resizeable: { type: Boolean },
    resizeIcon: {},
    rotateable: { type: Boolean },
    rotateIcon: {},
    rotateStep: { default: void 0 },
    rotationControlLength: { default: 15 }
  },
  setup(t) {
    const e = t, {
      deleteable: n,
      deleteIcon: s,
      designBounds: a,
      hidden: o,
      padding: i,
      resizeable: r,
      resizeIcon: l,
      rotateable: u,
      rotateIcon: m,
      rotateStep: h,
      rotationControlLength: v
    } = Ae(e), { data: _ } = Mt(cm), { size: y, texture: S } = Mt(_l), { data: f } = Mt(Vs), { worldScale: k } = Mt(Ns), w = N(), C = N(0), M = N(1), T = N(1), E = I(() => M.value * T.value), U = I(() => k.value * E.value), F = I(
      () => y.value ? { x: y.value.width / 2, y: y.value.height / 2 } : void 0
    ), ee = new to();
    ie(() => {
      if (ee.clear(), o.value || !y.value) return;
      const ae = i.value;
      ee.rect(
        -ae,
        -ae,
        y.value.width + ae * 2,
        y.value.height + ae * 2
      ), u.value && ee.moveTo(y.value.width / 2, -ae).lineTo(
        y.value.width / 2,
        -ae - v.value
      ), ee.stroke({
        alignment: 0,
        color: 11717887,
        width: 1 / U.value
      });
    });
    function Q(ae) {
      const pe = I(() => {
        const Ce = Math.min(20 / ae.value.width, 20 / ae.value.height);
        return {
          height: ae.value.height * Ce,
          width: ae.value.width * Ce
        };
      }), rt = I(
        () => `data:image/svg+xml;base64,${btoa(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${ae.value.width.toString()} ${ae.value.height.toString()}" width="${(pe.value.width * 2).toString()}px" height="${(pe.value.height * 2).toString()}px"><path d="${ae.value.path}"/></svg>`)}`
      ), { data: st } = vl(rt), we = new to();
      return ie(() => {
        if (we.clear(), o.value || !st.value) return;
        const Ce = {
          height: pe.value.height / U.value * 10,
          width: pe.value.width / U.value * 10
        };
        we.circle(0, 0, 15 / U.value * 10).fill({ color: 16777215 }).stroke({
          alignment: 0,
          color: 0,
          width: 1 / U.value * 10
        }).texture(
          st.value,
          16777215,
          -Ce.width / 2,
          -Ce.height / 2,
          Ce.width,
          Ce.height
        );
      }), we;
    }
    const se = Q(m), W = Q(s), Y = Q(l), me = N();
    function he(ae) {
      ae.stopPropagation(), f.value.designs = f.value.designs.filter(
        (pe) => pe !== _.value
      );
    }
    function _e(ae) {
      if (!me.value) return;
      ae.stopPropagation(), me.value = void 0;
      let pe = C.value;
      h.value && (pe = Math.round(pe / h.value) * h.value), _.value.rotation = Io(
        _.value.rotation + pe
      ), C.value = 0;
    }
    function te(ae) {
      if (!w.value || !F.value || !me.value) return;
      const { x: pe, y: rt } = F.value, { x: st, y: we } = me.value, { x: Ce, y: Je } = w.value.parent.worldTransform.applyInverse(
        ae.global
      );
      if (st === Ce && we === Je) {
        C.value = 0;
        return;
      }
      const Ue = st - pe, Ye = we - rt, lt = Ce - pe, gt = Je - rt, ct = Math.acos(
        (Ue * lt + Ye * gt) / (Math.hypot(Ue, Ye) * Math.hypot(lt, gt))
      );
      C.value = P_(
        Ue * gt - Ye * lt < 0 ? 2 * Math.PI - ct : ct
      );
    }
    function J(ae) {
      w.value && (ae.stopPropagation(), me.value = w.value.parent.worldTransform.applyInverse(
        ae.global
      ), te(ae));
    }
    const de = I(
      () => !o.value && r.value && Or(_.value.design)
    ), ke = I(() => a.value ? Er(
      _.value.design,
      a.value
    ) : { max: 1 / 0, min: -1 / 0 }), Te = N();
    function Ve(ae) {
      Te.value && (ae.stopPropagation(), Te.value = void 0, M.value !== 1 && (Rr(
        _.value.design,
        M.value,
        a.value
      ), T.value = M.value, M.value = 1));
    }
    function nt(ae) {
      if (!w.value || !F.value || !Te.value) return;
      const { x: pe, y: rt } = w.value.parent.worldTransform.applyInverse(
        ae.global
      );
      M.value = rn(
        Math.sqrt(
          (Math.pow(F.value.x - pe, 2) + Math.pow(F.value.y - rt, 2)) / Te.value
        ),
        ke.value.min,
        ke.value.max
      );
    }
    function Pe(ae) {
      if (!w.value || !F.value) return;
      ae.stopPropagation();
      const { x: pe, y: rt } = w.value.parent.worldTransform.applyInverse(
        ae.global
      );
      Te.value = Math.pow(F.value.x - pe, 2) + Math.pow(F.value.y - rt, 2), nt(ae);
    }
    return ht(S, () => {
      T.value = 1;
    }), (ae, pe) => ($(), O("PixiContainer", {
      ref_key: "container",
      ref: w,
      label: "DesignControls",
      angle: C.value,
      scale: E.value,
      position: F.value,
      pivot: F.value
    }, [
      Nt(ae.$slots, "default", {}, () => [
        b(mm)
      ]),
      c(o) ? X("", !0) : ($(), O("PixiGraphics", {
        key: 0,
        label: "DesignControls_Border",
        context: c(ee)
      }, null, 8, j_)),
      !c(o) && c(y) && c(u) ? ($(), O("PixiGraphics", {
        key: 1,
        label: "DesignControls_Rotate",
        context: c(se),
        x: c(y).width / 2,
        y: -c(i) - c(v),
        scale: 0.1,
        "event-mode": "static",
        cursor: me.value ? "grabbing" : "grab",
        onPointerdown: J,
        onGlobalpointermove: te,
        onPointerup: _e,
        onPointerupoutside: _e,
        onPointercancel: _e
      }, null, 40, B_)) : X("", !0),
      !c(o) && c(y) && c(n) ? ($(), O("PixiGraphics", {
        key: 2,
        label: "DesignControls_Delete",
        context: c(W),
        x: -c(i),
        y: c(y).height + c(i),
        scale: 0.1,
        "event-mode": "static",
        cursor: "pointer",
        onPointerdown: he
      }, null, 40, q_)) : X("", !0),
      de.value && c(y) ? ($(), O("PixiGraphics", {
        key: 3,
        label: "DesignControls_Resize",
        context: c(Y),
        x: c(y).width + c(i),
        y: c(y).height + c(i),
        scale: 0.1,
        "event-mode": "static",
        cursor: "nwse-resize",
        onPointerdown: Pe,
        onGlobalpointermove: nt,
        onPointerup: Ve,
        onPointerupoutside: Ve,
        onPointercancel: Ve
      }, null, 40, H_)) : X("", !0)
    ], 8, F_));
  }
});
function G_(t) {
  let e;
  function n(a) {
    e = a.global.clone();
  }
  function s(a) {
    !e || vo(a.global, e) > 10 || t(a);
  }
  return { onPointerdown: n, onPointerup: s };
}
const kl = tt(
  "designer-core.designerCore",
  () => {
    const { pixelRatio: t } = Np();
    return { devicePixelRatio: t };
  }
);
function rr({ x: t, y: e }, n, s) {
  return {
    x: (s.x + s.width / 2 - t) / n,
    y: (s.y + s.height / 2 - e) / n
  };
}
function ra({ x: t, y: e }, n, s) {
  return {
    x: s.x + s.width / 2 - t * n,
    y: s.y + s.height / 2 - e * n
  };
}
const Z_ = {
  axis: "all",
  factor: 1,
  noDrag: !1,
  percent: 1,
  position: void 0
};
class Q_ extends Vt {
  /**
   * This is called by {@link Viewport.pinch}.
   */
  constructor(e, n = {}) {
    super(e), on(this, "active", !1), on(this, "options"), on(this, "pinching", !1), on(this, "lastCenter"), on(this, "moved", !1), this.options = Object.assign({}, Z_, n);
  }
  down() {
    return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  move(e) {
    if (this.paused || !this.active)
      return !1;
    const n = e.global.x, s = e.global.y, a = this.parent.input.touches;
    if (a.length >= 2) {
      const o = a[0], i = a[1], r = o.last && i.last ? Math.sqrt(
        Math.pow(i.last.x - o.last.x, 2) + Math.pow(i.last.y - o.last.y, 2)
      ) : void 0;
      if (o.id === e.pointerId ? o.last = { data: e, x: n, y: s } : i.id === e.pointerId && (i.last = { data: e, x: n, y: s }), r) {
        let l;
        const u = new bt(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          o.last.x + (i.last.x - o.last.x) / 2,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          o.last.y + (i.last.y - o.last.y) / 2
        );
        this.options.position || (l = this.parent.toLocal(u));
        let m = Math.sqrt(
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Math.pow(i.last.x - o.last.x, 2) + // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Math.pow(i.last.y - o.last.y, 2)
        );
        m = m === 0 ? m = 1e-10 : m;
        const h = (1 - r / m) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
        this.isAxisX() && (this.parent.scale.x += h), this.isAxisY() && (this.parent.scale.y += h), this.parent.emit("zoomed", {
          center: u,
          type: "pinch",
          viewport: this.parent
        });
        const v = this.parent.plugins.get("clamp-zoom", !0);
        if (v && v.clamp(), this.options.position)
          this.options.position();
        else {
          const _ = this.parent.toGlobal(l);
          this.parent.x += (u.x - _.x) * this.options.factor, this.parent.y += (u.y - _.y) * this.options.factor, this.parent.emit("moved", {
            type: "pinch",
            viewport: this.parent
          });
        }
        !this.options.noDrag && this.lastCenter && (this.parent.x += (u.x - this.lastCenter.x) * this.options.factor, this.parent.y += (u.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", {
          type: "pinch",
          viewport: this.parent
        })), this.lastCenter = u, this.moved = !0;
      } else this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
      return !0;
    }
    return !1;
  }
  up() {
    return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = void 0, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
  }
}
const X_ = {
  axis: "all",
  interrupt: !0,
  keyToPress: void 0,
  lineHeight: 20,
  percent: 0.1,
  position: void 0,
  reverse: !1,
  smooth: !1,
  trackpadPinch: !1,
  wheelZoom: !0
};
class K_ extends Vt {
  /**
   * This is called by {@link Viewport.wheel}.
   */
  constructor(e, n = {}) {
    super(e), on(this, "options"), on(this, "keyIsPressed"), on(this, "smoothing"), on(this, "smoothingCenter"), on(this, "smoothingCount"), this.options = Object.assign({}, X_, n), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
  }
  down() {
    return this.options.interrupt && (this.smoothing = void 0), !1;
  }
  update() {
    if (this.smoothing) {
      const e = this.smoothingCenter, n = this.smoothing;
      let s;
      this.options.position || (s = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x += n.x), this.isAxisY() && (this.parent.scale.y += n.y), this.parent.emit("zoomed", {
        type: "wheel",
        viewport: this.parent
      });
      const a = this.parent.plugins.get("clamp-zoom", !0);
      if (a && a.clamp(), this.options.position)
        this.options.position();
      else {
        const o = this.parent.toGlobal(s);
        this.parent.x += e.x - o.x, this.parent.y += e.y - o.y;
      }
      this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.smoothingCount++, this.options.smooth && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.smoothingCount >= this.options.smooth && (this.smoothing = void 0);
    }
  }
  wheel(e) {
    if (this.paused || !this.checkKeyPress())
      return !1;
    if (e.ctrlKey && this.options.trackpadPinch)
      this.pinch(e);
    else if (this.options.wheelZoom) {
      const n = this.parent.input.getPointerPosition(e), s = (this.options.reverse ? -1 : 1) * -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 500, a = Math.pow(2, (1 + this.options.percent) * s);
      if (this.options.smooth) {
        const o = {
          x: this.smoothing ? this.smoothing.x * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (this.options.smooth - this.smoothingCount) : 0,
          y: this.smoothing ? this.smoothing.y * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          (this.options.smooth - this.smoothingCount) : 0
        };
        this.smoothing = {
          x: ((this.parent.scale.x + o.x) * a - this.parent.scale.x) / this.options.smooth,
          y: ((this.parent.scale.y + o.y) * a - this.parent.scale.y) / this.options.smooth
        }, this.smoothingCount = 0, this.smoothingCenter = n;
      } else {
        let o;
        this.options.position || (o = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= a), this.isAxisY() && (this.parent.scale.y *= a), this.parent.emit("zoomed", {
          type: "wheel",
          viewport: this.parent
        });
        const i = this.parent.plugins.get("clamp-zoom", !0);
        if (i && i.clamp(), this.options.position)
          this.options.position();
        else {
          const r = this.parent.toGlobal(o);
          this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
        }
      }
      this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.parent.emit("wheel-start", {
        event: e,
        viewport: this.parent
      });
    }
    return !this.parent.options.passiveWheel;
  }
  checkKeyPress() {
    return !this.options.keyToPress || this.keyIsPressed;
  }
  /**
   * Handles keypress events and set the keyIsPressed boolean accordingly
   *
   * @param {array} codes - key codes that can be used to trigger zoom event
   */
  handleKeyPresses(e) {
    globalThis.addEventListener("keydown", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !0);
    }), globalThis.addEventListener("keyup", (n) => {
      e.includes(n.code) && (this.keyIsPressed = !1);
    });
  }
  isAxisX() {
    return ["all", "x"].includes(this.options.axis);
  }
  isAxisY() {
    return ["all", "y"].includes(this.options.axis);
  }
  pinch(e) {
    if (this.paused)
      return;
    const n = this.parent.input.getPointerPosition(e), s = -e.deltaY * (e.deltaMode ? this.options.lineHeight : 1) / 200, a = Math.pow(2, (1 + this.options.percent) * s);
    let o;
    this.options.position || (o = this.parent.toLocal(n)), this.isAxisX() && (this.parent.scale.x *= a), this.isAxisY() && (this.parent.scale.y *= a), this.parent.emit("zoomed", { type: "wheel", viewport: this.parent });
    const i = this.parent.plugins.get("clamp-zoom", !0);
    if (i && i.clamp(), this.options.position)
      this.options.position();
    else {
      const r = this.parent.toGlobal(o);
      this.parent.x += n.x - r.x, this.parent.y += n.y - r.y;
    }
    this.parent.emit("moved", { type: "wheel", viewport: this.parent }), this.parent.emit("wheel-start", {
      event: e,
      viewport: this.parent
    });
  }
}
const J_ = {
  stage: void 0
};
class Y_ extends Vt {
  constructor(e, n = {}) {
    super(e), on(this, "options"), on(this, "last"), this.options = Object.assign({}, J_, n), this.update();
  }
  move() {
    return this.update(), !1;
  }
  reset() {
    this.update();
  }
  update() {
    if (this.paused) return;
    let e, n;
    const s = this.options.stage;
    s ? (e = rn(
      this.parent.x,
      -this.parent.screenWorldWidth + s.x,
      s.x + s.width
    ), n = rn(
      this.parent.y,
      -this.parent.screenWorldHeight + s.y,
      s.y + s.height
    )) : (e = rn(
      this.parent.x,
      -this.parent.screenWorldWidth,
      this.parent.screenWidth
    ), n = rn(
      this.parent.y,
      -this.parent.screenWorldHeight,
      this.parent.screenHeight
    )), this.parent.position.set(e, n);
  }
}
const ek = ["text"], tk = ["context"], nk = /* @__PURE__ */ K({
  __name: "DebugInfo",
  props: {
    stage: {}
  },
  setup(t) {
    const e = t, { stage: n } = Ae(e), s = N(0);
    let a = 0, o = Date.now();
    Ss(() => {
      if (a === 0) {
        const r = Date.now(), l = r - o;
        o = r, s.value = 3e4 / l;
      }
      a = (a + 1) % 30;
    });
    const i = new to();
    return ie(() => {
      i.clear(), n.value && i.rect(
        n.value.x,
        n.value.y,
        n.value.width,
        n.value.height
      ).stroke({ alignment: 0, color: 16711935, width: 5 });
    }), (r, l) => ($(), O(re, null, [
      x("PixiText", {
        text: `FPS: ${Math.round(s.value * 100) / 100}`,
        style: { fontSize: 20 }
      }, null, 8, ek),
      x("PixiGraphics", { context: c(i) }, null, 8, tk)
    ], 64));
  }
}), sk = ["events", "screen-width", "screen-height", "world-width", "world-height"], Mo = /* @__PURE__ */ K({
  __name: "DesignerCore",
  props: {
    clampZoom: {},
    debug: { type: Boolean },
    draggable: { type: Boolean },
    stage: {}
  },
  emits: ["click", "update:zoom"],
  setup(t, { expose: e, emit: n }) {
    const s = t, { clampZoom: a, debug: o, draggable: i, stage: r } = Ae(s), l = n, u = N(), m = N(), h = N(), v = I(() => {
      var te;
      return (te = u.value) == null ? void 0 : te.canvas;
    }), _ = N(), y = N([]), S = N([]), {
      onPointerdown: f,
      onPointerup: k
    } = G_((te) => {
      l("click", te);
    }), { devicePixelRatio: w } = D(kl()), C = N({ height: 5, width: 5 });
    ie((te) => {
      if (!v.value) return;
      const J = new ResizeObserver(([de]) => {
        var ke;
        de && (C.value = (ke = de.devicePixelContentBoxSize) != null && ke[0] ? {
          height: Math.max(
            de.devicePixelContentBoxSize[0].blockSize / w.value,
            5
          ),
          width: Math.max(
            de.devicePixelContentBoxSize[0].inlineSize / w.value,
            5
          )
        } : {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          height: Math.max(de.contentBoxSize[0].blockSize, 5),
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          width: Math.max(de.contentBoxSize[0].inlineSize, 5)
        });
      });
      try {
        J.observe(v.value, {
          box: "device-pixel-content-box"
        });
      } catch {
        J.observe(v.value, { box: "content-box" });
      }
      te(() => {
        J.disconnect();
      });
    });
    const M = I(() => {
      var te, J;
      const de = r.value ?? C.value;
      return {
        height: Math.max(de.height, 5),
        width: Math.max(de.width, 5),
        x: ((te = r.value) == null ? void 0 : te.x) ?? 0,
        y: ((J = r.value) == null ? void 0 : J.y) ?? 0
      };
    });
    ht(M, (te, J) => {
      const de = m.value;
      if (!de) return;
      const ke = Math.min(te.height, te.width) / Math.min(J.height, J.width) * de.scale.x;
      Y(
        ra(
          rr(de.position, de.scale.x, J),
          ke,
          te
        ),
        ke,
        !1
      );
    });
    const T = I(
      () => _.value ? Math.min(
        M.value.width / _.value.width,
        M.value.height / _.value.height
      ) : 1
    ), E = I(
      () => a.value ? {
        max: a.value.max * T.value,
        min: a.value.min * T.value
      } : void 0
    ), U = I(
      () => {
        var te;
        return (te = u.value) != null && te.isInitialized ? u.value.app.ticker : void 0;
      }
    ), F = N(1);
    Ss(
      () => {
        var te;
        F.value = ((te = m.value) == null ? void 0 : te.scale.x) ?? 1;
      },
      { ticker: U }
    );
    const ee = N();
    Ss(
      ({ deltaTime: te }) => {
        const J = ee.value;
        if (!J) return;
        const de = m.value;
        if (!de) return;
        const { scale: ke } = de;
        hu(
          ke,
          J,
          te
        ) < 1e-3 && (ke.set(J), ee.value = void 0);
      },
      { enabled: () => !!(ee.value && m.value), ticker: U }
    );
    const Q = N();
    Ss(
      ({ deltaTime: te }) => {
        const J = Q.value;
        if (!J) return;
        const de = m.value;
        if (!de) return;
        const { position: ke } = de;
        hu(
          ke,
          J,
          te
        ) < 0.5 && (ke.set(J.x, J.y), Q.value = void 0);
      },
      {
        enabled: () => !!(Q.value && m.value),
        ticker: U
      }
    );
    const se = I(
      () => ee.value !== void 0 || Q.value !== void 0
    );
    function W({ height: te, width: J, x: de, y: ke }, Te = !0) {
      const Ve = M.value, nt = E.value, Pe = rn(
        Math.min(Ve.width / J, Ve.height / te),
        (nt == null ? void 0 : nt.min) ?? 0,
        (nt == null ? void 0 : nt.max) ?? 1 / 0
      );
      Y(
        ra({ x: J / 2 + de, y: te / 2 + ke }, Pe, Ve),
        Pe,
        Te
      );
    }
    function Y(te, J, de = !0) {
      if (de)
        ee.value = J, Q.value = te;
      else {
        const ke = m.value;
        if (!ke) throw new Error("Viewport not initialized yet");
        ke.scale.set(J), ke.position.set(te.x, te.y);
      }
    }
    function me(te, J = !0) {
      const de = m.value;
      if (!de) return;
      const ke = M.value, Te = E.value, Ve = rn(
        te * T.value,
        (Te == null ? void 0 : Te.min) ?? 0,
        (Te == null ? void 0 : Te.max) ?? 1 / 0
      );
      Y(
        ra(
          rr(de.position, de.scale.x, ke),
          Ve,
          ke
        ),
        Ve,
        J
      );
    }
    ie(() => {
      l(
        "update:zoom",
        (ee.value ?? F.value) / T.value
      );
    }), ie(() => {
      const te = m.value;
      if (!te) return;
      te.drag({ wheel: !1 }).decelerate({ friction: 0.9 }).clampZoom({});
      const J = te.plugins;
      J.add(
        "wheel",
        new K_(te, { smooth: 10 })
      ), J.add("pinch", new Q_(te)), J.add("clamp", new Y_(te));
    }), ie(() => {
      const te = m.value;
      if (!te) return;
      const J = te.plugins.get("clamp");
      J && (J.options.stage = { ...M.value });
    }), ie(() => {
      const te = m.value;
      if (!te) return;
      const J = te.plugins, de = J.get("wheel"), ke = J.get("pinch"), Te = J.get("clamp-zoom");
      E.value ? (de == null || de.resume(), ke == null || ke.resume(), Te && (Te.options.minScale = E.value.min, Te.options.maxScale = E.value.max, Te.resume())) : (de == null || de.pause(), ke == null || ke.pause(), Te && (Te.pause(), Te.options.minScale = null, Te.options.maxScale = null));
    }), ie(() => {
      const te = m.value;
      if (!te) return;
      const J = te.plugins, de = J.get("wheel"), ke = J.get("pinch"), Te = J.get("drag");
      if (i.value)
        Te == null || Te.resume(), de && (de.options.position = void 0), ke && (ke.options.position = void 0, ke.options.noDrag = !1);
      else {
        let Ve = function() {
          const Pe = m.value;
          if (!Pe) return;
          const { x: ae, y: pe } = ra(
            nt,
            Pe.scale.x,
            M.value
          );
          Pe.position.set(ae, pe);
        };
        Te == null || Te.pause();
        const nt = rr(
          te.position,
          te.scale.x,
          M.value
        );
        de && (de.options.position = Ve), ke && (ke.options.position = Ve, ke.options.noDrag = !0);
      }
    });
    function he(te) {
      f(te), Q.value = void 0, ee.value = void 0;
    }
    function _e() {
      Q.value = void 0, ee.value = void 0;
    }
    return cs(Ns, {
      clampScale: E,
      fetching: S,
      rendering: y,
      scaleMultiplier: T,
      setPosition: W,
      topLayer: h,
      worldScale: F,
      worldSize: _
    }), e({ canvas: v, setPosition: W, setZoom: me }), (te, J) => ($(), Z(c(N_), {
      ref_key: "appData",
      ref: u,
      "background-color": 16777215,
      width: C.value.width,
      height: C.value.height,
      resolution: c(w),
      "data-animating": se.value,
      "data-rendering": y.value.length > 0,
      "data-fetching": S.value.length > 0,
      preference: "webgl",
      "power-preference": "low-power",
      "preserve-drawing-buffer": !0,
      legacy: !0,
      "auto-density": !1,
      antialias: !0
    }, {
      default: P(() => {
        var de, ke, Te;
        return [
          (de = u.value) != null && de.isInitialized && C.value ? ($(), O("PixiViewport", {
            key: 0,
            ref_key: "viewport",
            ref: m,
            events: u.value.app.renderer.events,
            "allow-preserve-drag-outside": !0,
            "passive-wheel": !1,
            "stop-propagation": !0,
            "screen-width": C.value.width,
            "screen-height": C.value.height,
            "world-width": (ke = _.value) == null ? void 0 : ke.width,
            "world-height": (Te = _.value) == null ? void 0 : Te.height,
            onPointerdown: he,
            onPointerup: J[0] || (J[0] = //@ts-ignore
            (...Ve) => c(k) && c(k)(...Ve)),
            onWheel: _e
          }, [
            Nt(te.$slots, "default"),
            x("PixiRenderLayer", {
              ref_key: "topLayer",
              ref: h
            }, null, 512)
          ], 40, sk)) : X("", !0),
          c(o) ? ($(), Z(nk, {
            key: 1,
            stage: M.value
          }, null, 8, ["stage"])) : X("", !0)
        ];
      }),
      _: 3
    }, 8, ["width", "height", "resolution", "data-animating", "data-rendering", "data-fetching"]));
  }
}), ak = ["position", "event-mode", "cursor"], ok = /* @__PURE__ */ K({
  __name: "Draggable",
  props: {
    disabled: { type: Boolean }
  },
  emits: ["update:point"],
  setup(t, { emit: e }) {
    const n = t, { disabled: s } = Ae(n), a = e, o = N(), i = N(), r = N(), l = I(() => {
      if (!r.value || !i.value || !o.value)
        return { x: 0, y: 0 };
      const v = o.value.parent.worldTransform.applyInverse(
        r.value
      );
      return {
        x: v.x - i.value.x,
        y: v.y - i.value.y
      };
    });
    ie(() => {
      a("update:point", r.value);
    });
    function u(v) {
      i.value && (v == null || v.stopPropagation(), i.value = void 0, r.value = void 0);
    }
    function m(v) {
      s.value || !r.value || r.value.copyFrom(v.global);
    }
    function h(v) {
      s.value || !o.value || (v.stopPropagation(), i.value = o.value.worldTransform.applyInverse(v.global), r.value = v.global.clone(), m(v));
    }
    return ht(s, () => {
      s.value && u();
    }), (v, _) => ($(), O("PixiContainer", {
      ref_key: "container",
      ref: o,
      label: "Draggable",
      position: l.value,
      "event-mode": c(s) ? "passive" : "static",
      cursor: r.value ? "grabbing" : "grab",
      onPointerdown: h,
      onGlobalpointermove: m,
      onPointerup: u,
      onPointerupoutside: u,
      onPointercancel: u
    }, [
      Nt(v.$slots, "default")
    ], 40, ak));
  }
});
function ik(t, e, n, s) {
  let a = 0, o = 0;
  for (let i = 0; i < e.length; i++) {
    const r = e[i], l = e[(i + 1) % e.length], u = l.x - r.x, m = l.y - r.y, h = Math.hypot(u, m), v = { x: u / h, y: m / h };
    let _ = 0;
    for (t.moveTo(
      r.x + o * v.x,
      r.y + o * v.y
    ); _ <= h; )
      _ += o + (a > 0 ? a : n), _ > h ? (a = _ - h, _ = h) : a = 0, t.lineTo(
        r.x + _ * v.x,
        r.y + _ * v.y
      ), _ += s, _ > h && a === 0 ? o = _ - h : (o = 0, t.moveTo(
        r.x + _ * v.x,
        r.y + _ * v.y
      ));
  }
}
const rk = ["x", "y", "pivot", "angle"], lk = ["context"], ck = ["resolution", "text", "position"], To = /* @__PURE__ */ K({
  __name: "PositioningArea",
  props: {
    data: {},
    fillColor: { default: () => new Uint8Array([0, 0, 0, 0]) },
    hidden: { type: Boolean },
    strokeColor: { default: 4605510 }
  },
  setup(t) {
    const e = t, { data: n, fillColor: s, hidden: a, strokeColor: o } = Ae(e), { devicePixelRatio: i } = D(kl()), { clampScale: r, scaleMultiplier: l, worldScale: u } = Mt(Ns), m = I(
      () => r.value ? 7 / l.value : 14 / u.value
    ), h = I(
      () => r.value ? 5 / l.value : 10 / u.value
    ), v = I(
      () => r.value ? Math.max(2 / l.value, 1 / u.value) : 4 / u.value
    ), _ = new to();
    ie(() => {
      _.clear(), !a.value && (ik(
        _,
        [
          { x: 0, y: 0 },
          { x: n.value.width, y: 0 },
          { x: n.value.width, y: n.value.height },
          { x: 0, y: n.value.height }
        ],
        m.value,
        h.value
      ), _.stroke({
        alignment: 1,
        color: o.value,
        width: v.value
      }), _.rect(0, 0, n.value.width, n.value.height).fill({ color: s.value }));
    });
    const y = I(() => ({
      x: n.value.width * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Is(n.value.position[1]),
      y: n.value.height * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Is(n.value.position[0])
    })), S = I(
      () => Math.max(16 / l.value, 12 / u.value)
    ), f = I(
      () => {
        var w;
        return Math.min(
          i.value * Math.max(((w = r.value) == null ? void 0 : w.max) ?? u.value, 1),
          // fontSize * textResolution should be capped at 3500 because otherwise
          // the designer starts to lag, trying to render very large texts
          3500 / S.value
        );
      }
    ), k = I(() => ({
      x: n.value.width / 2,
      y: n.value.height / 2
    }));
    return cs(Vs, { data: n }), (w, C) => ($(), O("PixiContainer", {
      label: "PositioningArea",
      x: c(n).x,
      y: c(n).y,
      pivot: y.value,
      angle: c(n).rotation
    }, [
      x("PixiGraphics", {
        label: "PositioningArea_Graphics",
        context: c(_)
      }, null, 8, lk),
      c(n).handle && c(n).designs.length === 0 && !c(a) ? ($(), O("PixiText", {
        key: 0,
        resolution: f.value,
        text: c(n).handle,
        style: Wt({
          fill: c(o),
          fontSize: S.value,
          fontWeight: "600",
          trim: !0
        }),
        position: k.value,
        anchor: {
          x: 0.5,
          y: 0.5
        }
      }, null, 12, ck)) : X("", !0),
      Nt(w.$slots, "default")
    ], 8, rk));
  }
}), fu = { height: 580, width: 520 };
function yl(t) {
  return t.elements.length > 0 ? {
    children: t.elements.map((e) => ({
      anchor: e.alignment.anchor_value,
      offset: {
        x: e.alignment.offset.x,
        y: e.alignment.offset.y
      },
      value: yl(e)
    })),
    parent: vu(t),
    type: be.ANCHOR
  } : vu(t);
}
function bl(t) {
  let e;
  return t.width !== null && t.height !== null && t.min_width !== null && t.min_height !== null && t.max_width !== null && t.max_height !== null && t.min_width < t.max_width && t.min_height < t.max_height && (e = { height: t.height, width: t.width }), {
    colorAssignments: t.color_assignments.map((n) => ({
      id: n.id,
      color: n.color ? { id: n.color.id } : {
        blue: n.blue,
        green: n.green,
        red: n.red
      }
    })),
    logoId: t.id,
    size: e,
    type: be.LOGO
  };
}
function uk(t, e) {
  return {
    id: t.id,
    designs: e.customizations.filter(
      (n) => n.positioningArea.id === t.id
    ).map((n) => ({
      design: yl(
        n.design.elements[0]
      ),
      rotation: n.rotation - t.rotation
    })),
    handle: t.positioning_area_identifier_handle ?? void 0,
    height: t.localized_height,
    position: t.position,
    productionMethodId: t.production_method.id,
    rotation: t.rotation,
    width: t.localized_width,
    x: t.x / e.scalefactor,
    y: t.y / e.scalefactor
  };
}
function wl(t) {
  return {
    handle: t.handle,
    height: fu.height / t.scalefactor,
    imageUrl: t.image_urls.xl,
    positioningAreas: [...t.positioning_areas].sort((e, n) => e.order_column - n.order_column).map(
      (e) => uk(e, t)
    ),
    width: fu.width / t.scalefactor
  };
}
function Ts({
  design: t,
  productionMethodId: e
}) {
  switch (t.type) {
    case be.ANCHOR:
      return {
        ...Ts({
          design: t.parent,
          productionMethodId: e
        }),
        elements: t.children.map((n) => ({
          ...Ts({
            design: n.value,
            productionMethodId: e
          }),
          alignment: {
            anchor_type: Rs.OUTER,
            anchor_value: n.anchor,
            offset: { x: n.offset.x, y: n.offset.y },
            rotation: 0
          }
        }))
      };
    case be.LOGO:
      return {
        dimension: t.size,
        elements: [],
        resource: {
          id: t.logoId,
          color_assignments: t.colorAssignments.map(
            ({ id: n, color: s }) => "id" in s ? { id: n, color: { id: s.id } } : {
              id: n,
              blue: s.blue,
              green: s.green,
              red: s.red
            }
          ),
          production_method: { id: e }
        },
        resource_type: "logo"
      };
    case be.TEXT:
      return {
        elements: [],
        resource: {
          lines: t.lines.map((n) => ({
            bending_radius: n.bendingRadius,
            color_assignments: [
              "id" in n.color ? { color: { id: n.color.id } } : {
                blue: n.color.blue,
                green: n.color.green,
                red: n.color.red
              }
            ],
            font: { id: n.fontId },
            font_size: n.size,
            horizontal_alignment: n.horizontalAlignment,
            offset: n.offsetLeft,
            order_column: 1,
            padding_bottom: n.paddingBottom,
            value: n.text
          })),
          production_method: { id: e }
        },
        resource_type: "text"
      };
  }
}
function dk(t, e) {
  return {
    customizations: t.positioningAreas.filter((n) => !!n.id).flatMap(
      (n) => n.designs.flatMap((s) => ({
        design: {
          elements: [
            Ts({
              design: s.design,
              productionMethodId: n.productionMethodId
            })
          ],
          production_method: {
            id: n.productionMethodId
          }
        },
        order: 0,
        position: mk(
          n,
          s
        ),
        positioning_area: {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          id: n.id
        },
        rotation: s.rotation + n.rotation,
        x: Math.round(n.x * e),
        y: Math.round(n.y * e)
      }))
    ),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    handle: t.handle
  };
}
function vu(t) {
  return t.resource_type === "text" ? {
    lines: t.resource.lines.map((e) => {
      const n = e.color_assignments[0];
      return {
        bendingRadius: e.bending_radius,
        color: n.color ? { id: n.color.id } : {
          blue: n.blue,
          green: n.green,
          red: n.red
        },
        fontId: e.font.id,
        horizontalAlignment: e.horizontal_alignment,
        offsetLeft: e.offset,
        paddingBottom: e.padding_bottom,
        size: e.font_size,
        text: e.value
      };
    }),
    type: be.TEXT
  } : {
    colorAssignments: t.resource.color_assignments.map(
      (e) => ({
        id: e.id,
        color: e.color ? { id: e.color.id } : {
          blue: e.blue,
          green: e.green,
          red: e.red
        }
      })
    ),
    logoId: t.resource.id,
    size: t.dimension ? {
      height: t.dimension.height,
      width: t.dimension.width
    } : void 0,
    type: be.LOGO
  };
}
function mk(t, e) {
  const n = q0(
    t.position
  );
  return n === void 0 ? t.position : B0(
    Io(
      n - e.rotation
    )
  ) ?? t.position;
}
function xl(t, e) {
  const n = Bu(Ns), s = I(
    () => t.value ? ga(t.value.design) : void 0
  ), a = I(() => {
    if (!t.value || !s.value) return;
    const M = t.value.productionMethodId;
    return {
      elements: [
        Ts({
          design: s.value,
          productionMethodId: M
        })
      ],
      production_method: { id: M }
    };
  }), o = le.designs.preview.use(
    a
  ), {
    data: i,
    error: r,
    fetchStatus: l,
    status: u
  } = kt({
    ...o,
    enabled: I(() => !!a.value),
    queryFn: Gu(o.queryFn, 1e3, {
      rejectOnCancel: !0
    }),
    retry: !1,
    staleTime: 1 / 0
  }), m = N(i.value);
  ie(() => {
    i.value && (m.value = i.value);
  });
  const h = I(() => {
    if (m.value)
      return {
        height: m.value.height,
        width: m.value.width
      };
    if (!s.value) return;
    const M = Jt(e);
    if (M)
      return {
        height: M.height,
        width: M.width
      };
  }), v = I(() => {
    var M;
    const T = (M = m.value) == null ? void 0 : M.content;
    return T != null && T.startsWith("https://") ? T : T ? `data:image/jpeg;base64,${T}` : void 0;
  }), {
    data: _,
    error: y,
    fetchStatus: S,
    isPlaceholderData: f,
    status: k
  } = vl(v, {
    placeholder: I(() => {
      var M;
      const T = Jt(e);
      if (!T || !h.value) return;
      const E = Math.max(
        ((M = n == null ? void 0 : n.clampScale.value) == null ? void 0 : M.max) ?? (n == null ? void 0 : n.worldScale.value) ?? 1,
        1
      );
      return {
        height: h.value.height * E,
        radius: T.radius * E,
        width: h.value.width * E
      };
    })
  }), w = I(
    () => u.value === "success" ? k.value : u.value
  ), C = I(
    () => l.value === "idle" ? S.value : l.value
  );
  return {
    error: I(
      () => r.value ?? y.value ?? void 0
    ),
    fetchStatus: C,
    isPlaceholderData: f,
    normalizedDesign: s,
    size: h,
    status: w,
    texture: _
  };
}
const hk = ["angle", "pivot", "position"], zo = /* @__PURE__ */ K({
  __name: "PositioningAreaDesign",
  props: {
    data: {},
    placeholder: {}
  },
  emits: ["update:boundingBox", "update:error", "update:fetchStatus", "update:size", "update:status"],
  setup(t, { emit: e }) {
    const n = t, { data: s, placeholder: a } = Ae(n), o = e, { data: i } = Mt(Vs), { error: r, fetchStatus: l, isPlaceholderData: u, size: m, status: h, texture: v } = xl(
      I(() => ({
        design: s.value.design,
        productionMethodId: i.value.productionMethodId
      })),
      a
    );
    ie(() => {
      o("update:error", r.value);
    }), ie(() => {
      o("update:fetchStatus", l.value);
    }), ie(() => {
      o("update:size", m.value);
    }), ie(() => {
      o("update:status", h.value);
    });
    const _ = I(
      () => m.value ? {
        x: m.value.width / 2,
        y: m.value.height / 2
      } : void 0
    ), y = I(
      () => m.value && _.value ? Ms(m.value, _.value, s.value.rotation) : void 0
    );
    ie(() => {
      o("update:boundingBox", y.value);
    });
    const S = I(() => {
      if (!y.value) return;
      const f = i.value.position[1], k = i.value.position[0], w = i.value.width * Is(f), C = i.value.height * Is(k);
      let M = 0;
      f === "l" ? M = y.value.left : f === "r" && (M = y.value.right);
      let T = 0;
      return k === "t" ? T = y.value.top : k === "b" && (T = y.value.bottom), {
        x: w - M,
        y: C - T
      };
    });
    return cs(_l, {
      error: r,
      fetchStatus: l,
      isPlaceholderData: u,
      placeholderColor: I(() => {
        var f;
        return (f = a.value) == null ? void 0 : f.color;
      }),
      size: m,
      status: h,
      texture: v
    }), cs(cm, { data: s }), (f, k) => _.value && S.value ? ($(), O("PixiContainer", {
      key: 0,
      label: "PositioningAreaDesign",
      angle: c(s).rotation,
      pivot: _.value,
      position: S.value
    }, [
      Nt(f.$slots, "default", {}, () => [
        b(mm)
      ])
    ], 8, hk)) : X("", !0);
  }
}), pk = /* @__PURE__ */ K({
  __name: "TopLayerTeleport",
  props: {
    disabled: { type: Boolean }
  },
  setup(t) {
    const e = t, { disabled: n } = Ae(e), { topLayer: s } = Mt(Ns), a = N();
    return ie((o) => {
      const i = s.value, r = a.value;
      n.value || !i || !r || (i.attach(r), o(() => {
        i.detach(r);
      }));
    }), (o, i) => ($(), O("PixiContainer", {
      ref_key: "container",
      ref: a,
      label: "TopLayerTeleport"
    }, [
      Nt(o.$slots, "default")
    ], 512));
  }
}), fk = ["texture", "width", "height", "alpha", "tint"], Eo = /* @__PURE__ */ K({
  __name: "View",
  props: {
    data: {},
    hidden: { type: Boolean },
    initialPosition: {},
    placeholder: {}
  },
  setup(t) {
    const e = t, { data: n, hidden: s, initialPosition: a, placeholder: o } = Ae(e), { clampScale: i, setPosition: r, worldScale: l, worldSize: u } = Mt(Ns);
    ie(() => {
      s.value || (u.value = {
        height: n.value.height,
        width: n.value.width
      });
    });
    function m() {
      s.value || r(
        a.value ?? {
          height: n.value.height,
          width: n.value.width,
          x: 0,
          y: 0
        },
        !1
      );
    }
    Fu(m), ht(s, m);
    const {
      data: h,
      isFetching: v,
      isPlaceholderData: _
    } = vl(
      I(() => n.value.imageUrl),
      {
        disabled: s,
        placeholder: I(() => {
          var f;
          if (!o.value) return;
          const k = Math.max(
            ((f = i.value) == null ? void 0 : f.max) ?? l.value,
            1
          );
          return {
            height: n.value.height * k,
            radius: o.value.radius * k,
            width: n.value.width * k
          };
        })
      }
    ), y = N(1);
    Ss(
      (f) => {
        y.value = Math.sin(f.lastTime / 1e3 * Math.PI) * 0.25 + 0.5;
      },
      { enabled: v }
    );
    const S = N();
    return cs(gl, { container: S, data: n, texture: h }), (f, k) => {
      var w;
      return c(s) ? X("", !0) : ($(), O("PixiContainer", {
        key: 0,
        ref_key: "container",
        ref: S,
        label: "View"
      }, [
        x("PixiSprite", {
          label: "View_Sprite",
          texture: c(h),
          width: c(n).width,
          height: c(n).height,
          alpha: c(v) ? y.value : 1,
          tint: c(_) ? (w = c(o)) == null ? void 0 : w.color : void 0
        }, null, 8, fk),
        Nt(f.$slots, "default")
      ], 512));
    };
  }
});
function hm(t) {
  const e = jt(t);
  return kt({
    enabled: I(() => !!e.value),
    queryFn: () => new Promise((n, s) => {
      const a = new Image();
      a.addEventListener("load", () => {
        n(a);
      }), a.addEventListener("error", s), a.crossOrigin = "Anonymous", a.src = e.value;
    }),
    queryKey: ["image", e],
    retry: !1,
    staleTime: 1 / 0
  });
}
const vk = ["width", "height"], gk = /* @__PURE__ */ K({
  __name: "ViewLight",
  props: {
    position: {},
    view: {}
  },
  setup(t) {
    const e = t, { position: n, view: s } = Ae(e), a = N(), o = I(() => {
      var f;
      return (f = a.value) == null ? void 0 : f.getContext("2d");
    }), { devicePixelRatio: i } = D(kl()), r = N({ height: 5, width: 5 });
    ie((f) => {
      if (!a.value) return;
      const k = new ResizeObserver(([w]) => {
        var C;
        w && (r.value = (C = w.devicePixelContentBoxSize) != null && C[0] ? {
          height: w.devicePixelContentBoxSize[0].blockSize / i.value,
          width: w.devicePixelContentBoxSize[0].inlineSize / i.value
        } : {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          height: w.contentBoxSize[0].blockSize,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          width: w.contentBoxSize[0].inlineSize
        });
      });
      try {
        k.observe(a.value, {
          box: "device-pixel-content-box"
        });
      } catch {
        k.observe(a.value, { box: "content-box" });
      }
      f(() => {
        k.disconnect();
      });
    }), ie(() => {
      S();
    }), ht([r], async () => {
      await bo(), S();
    });
    function l([
      f,
      k,
      w,
      C,
      M,
      T
    ]) {
      const E = f * C - k * w;
      if (E === 0)
        throw new Error("Matrix is not invertible (determinant is 0)");
      const U = C / E, F = -k / E, ee = -w / E, Q = f / E, se = (w * T - C * M) / E, W = (k * M - f * T) / E;
      return [
        U,
        F,
        ee,
        Q,
        se,
        W
      ];
    }
    const { data: u } = hm(I(() => s.value.imageUrl)), m = I(
      () => s.value.positioningAreas.flatMap(
        (f) => f.designs.map((k) => ({
          design: k.design,
          productionMethodId: f.productionMethodId
        }))
      )
    ), h = I(
      () => m.value.map((f) => {
        const k = ga(f.design);
        if (!k) return;
        const w = f.productionMethodId;
        return {
          elements: [
            Ts({
              design: k,
              productionMethodId: w
            })
          ],
          production_method: { id: w }
        };
      })
    ), v = en(
      (f) => {
        const k = le.designs.preview.use(f);
        return {
          ...k,
          enabled: k.enabled.value && !f,
          queryFn: Gu(k.queryFn, 1e3, {
            rejectOnCancel: !0
          }),
          retry: !1,
          staleTime: 1 / 0
        };
      }
    ), _ = Xl({
      queries: I(
        () => h.value.map(
          (f) => v(f)
        )
      )
    }), y = Xl({
      queries: I(
        () => _.value.map((f) => {
          const k = f.data ? f.data.content.startsWith("https://") ? f.data.content : `data:image/jpeg;base64,${f.data.content}` : void 0;
          return {
            enabled: !!k,
            queryFn: () => new Promise((w, C) => {
              const M = new Image();
              M.addEventListener("load", () => {
                w(M);
              }), M.addEventListener("error", C), M.crossOrigin = "Anonymous", M.src = k;
            }),
            queryKey: ["image", k],
            retry: !1,
            staleTime: 1 / 0
          };
        })
      )
    });
    function S() {
      if (!o.value) return;
      o.value.reset();
      const f = n.value ?? {
        height: s.value.height,
        width: s.value.width,
        x: 0,
        y: 0
      }, k = Math.min(
        r.value.width / f.width,
        r.value.height / f.height
      ), w = ra(
        {
          x: f.width / 2 + f.x,
          y: f.height / 2 + f.y
        },
        k,
        { ...r.value, x: 0, y: 0 }
      ), C = [
        k,
        0,
        0,
        k,
        w.x,
        w.y
      ];
      o.value.transform(...C), u.value && o.value.drawImage(
        u.value,
        0,
        0,
        s.value.width,
        s.value.height
      );
      for (const M of s.value.positioningAreas) {
        const T = M.rotation * Math.PI / 180, E = [
          Math.cos(T),
          Math.sin(T),
          -Math.sin(T),
          Math.cos(T),
          M.x,
          M.y
        ];
        o.value.transform(...E);
        for (const U of M.designs) {
          const F = m.value.findIndex(
            (ke) => ke.design === U.design
          ), ee = _.value[F], Q = y.value[F];
          if (!(ee != null && ee.data) || !(Q != null && Q.data)) continue;
          const se = {
            height: ee.data.height,
            width: ee.data.width
          }, W = {
            x: se.width / 2,
            y: se.height / 2
          }, Y = Ms(
            se,
            W,
            U.rotation
          ), me = M.position[1], he = M.position[0];
          let _e = 0;
          me === "l" ? _e = Y.left : me === "r" && (_e = Y.right);
          let te = 0;
          he === "t" ? te = Y.top : he === "b" && (te = Y.bottom);
          const J = U.rotation * Math.PI / 180, de = [
            Math.cos(J),
            Math.sin(J),
            -Math.sin(J),
            Math.cos(J),
            -_e,
            -te
          ];
          o.value.transform(...de), o.value.drawImage(
            Q.data,
            -W.x,
            -W.y,
            se.width,
            se.height
          ), o.value.transform(...l(de));
        }
        o.value.transform(...l(E));
      }
      o.value.transform(...l(C));
    }
    return (f, k) => ($(), O("canvas", {
      ref_key: "canvas",
      ref: a,
      width: r.value.width,
      height: r.value.height
    }, null, 8, vk));
  }
});
function _k(t) {
  const e = jt(t), n = mt(), s = en(
    (u) => n.fetchQuery({
      ...le.customerLogos.get.use(u),
      retry: !1,
      staleTime: 1 / 0
    })
  ), { mutateAsync: a } = tn(
    le.customerLogos.temporaryUploadUrl.use()
  ), { mutateAsync: o } = tn(
    le.customerLogos.post.use()
  );
  let i;
  const r = {};
  Ft("customerLogo.completed", ({ id: u }) => {
    r[u] = "completed", (i == null ? void 0 : i.pendingCustomerLogoId) === u && (i.resolve(), i = void 0);
  }), Ft("customerLogo.failed", ({ id: u, message: m }) => {
    if (r[u] = "failed", (i == null ? void 0 : i.pendingCustomerLogoId) === u) {
      switch (m) {
        case "SVG logo contains images.":
          i.reject(
            e.value.ERROR_SVG_CONTAINS_IMAGE
          );
          break;
        case "SVG logo contains texts.":
          i.reject(
            e.value.ERROR_SVG_CONTAINS_TEXT
          );
          break;
        default:
          i.reject(e.value.ERROR_UNEXPECTED);
      }
      i = void 0;
    }
  });
  async function l({
    file: u,
    productionMethodId: m
  }) {
    const { path: h, url: v } = await a({
      content_type: u.type,
      file_name: u.name
    });
    await kk(v, u);
    try {
      const _ = await o({
        path: h,
        production_method_id: m
      });
      if (_ in r) {
        if (r[_] === "failed")
          throw new Error("Failed to render customer logo");
      } else {
        const { promise: y, reject: S, resolve: f } = Promise.withResolvers();
        i = {
          pendingCustomerLogoId: _,
          reject: S,
          resolve: f
        }, await y;
      }
      return await s(_);
    } catch (_) {
      throw _ instanceof jn ? _ : typeof _ == "string" ? new zr(_) : new zr(
        e.value.ERROR_UNEXPECTED
      );
    }
  }
  return { mutationFn: l };
}
function kk(t, e) {
  return $d.put(t, {
    body: e,
    timeout: !1
  });
}
function pm(t, e) {
  const n = I(
    () => {
      var o;
      return ((o = t.value) == null ? void 0 : o.type) === be.LOGO ? t.value.logoId : void 0;
    }
  ), s = le.logos.get.use(n), { data: a } = kt({
    ...s,
    enabled: I(
      () => s.enabled.value && !!n.value
    ),
    retry: !1,
    staleTime: 1 / 0
  });
  return I(() => {
    var o;
    switch ((o = t.value) == null ? void 0 : o.type) {
      case be.LOGO: {
        const i = t.value.size ?? a.value;
        if (i != null && i.width && i.height)
          return { height: i.height, width: i.width };
        break;
      }
      case be.TEXT:
        return {
          height: 10 / e.value,
          width: 30 / e.value
        };
    }
    return {
      height: 30 / e.value,
      width: 30 / e.value
    };
  });
}
function Oo(t, e) {
  const n = e ?? Mt(Vs).data;
  return I(() => {
    if (!t.value || !n.value) return !1;
    const { height: s, width: a } = n.value, { bottom: o, left: i, right: r, top: l } = t.value;
    return r - i > a || o - l > s;
  });
}
const fm = Symbol("nearest_positioning_areas");
function yk(t, e, n) {
  const {
    filter: s = (y, S) => y.productionMethodId === S.productionMethodId && (S.designs.length === 0 || y === S),
    minDistance: a = 10,
    onMove: o
  } = n ?? {}, { container: i, data: r } = Mt(gl), { data: l } = Mt(Vs), u = Mt(fm), m = N();
  ht(e, (y) => {
    m.value = y ? { ...y } : void 0;
  });
  const h = I(
    () => e.value && m.value && vo(e.value, m.value) < a
  ), v = I(() => {
    if (!e.value || !i.value) return;
    if (h.value)
      return l.value;
    const y = l.value, S = i.value.worldTransform;
    let f, k = 1 / 0;
    for (const w of r.value.positioningAreas) {
      if (!s(y, w)) continue;
      const C = vo(
        e.value,
        S.apply(w)
      );
      C < k && (f = w, k = C);
    }
    return f;
  }), _ = Ep();
  ht(v, (y, S) => {
    _.value = S;
  }), ie(() => {
    const y = _.value, S = l.value;
    if (v.value || !y || S === y)
      return;
    o == null || o(S, y);
    const f = t.value;
    S.designs = S.designs.filter(
      (k) => k !== f
    ), y.designs.push(f);
  }), ie((y) => {
    const S = v.value;
    if (!S) return;
    const f = t.value;
    u.value.push({
      positioningArea: S,
      positioningAreaDesign: f
    }), y(() => {
      u.value = u.value.filter(
        ({ positioningAreaDesign: k }) => k !== f
      );
    });
  });
}
function bk() {
  const t = N([]);
  return cs(fm, t), t;
}
function wk() {
  const { data: t } = Mt(Vs);
  return t;
}
function vm([t, e, n]) {
  return t /= 255, e /= 255, n /= 255, t = t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4), e = e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4), n = n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4), t * 0.2126 + e * 0.7152 + n * 0.0722;
}
const xk = 0.179129;
function $l(t) {
  return vm(t) >= xk;
}
function Ro(t, e = 0) {
  const n = Ms(
    t,
    {
      x: t.width * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Is(t.position[1]),
      y: t.height * // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      Is(t.position[0])
    },
    t.rotation
  );
  return n.left -= e, n.top -= e, n.right += e, n.bottom += e, {
    height: n.bottom - n.top,
    width: n.right - n.left,
    x: t.x + n.left,
    y: t.y + n.top
  };
}
const $k = new Kg();
function $a(t, e) {
  const { image: n, view: s } = Sk(e), a = I(
    () => t.value ? Ro(t.value) : void 0
  ), o = I(() => {
    if (!s.value || !a.value || !n.value || !("width" in n.value) || !("height" in n.value)) return;
    const i = {
      x: n.value.width / s.value.width,
      y: n.value.height / s.value.height
    };
    return $k.getColor(n.value, {
      algorithm: "dominant",
      height: a.value.height * i.y,
      ignoredColor: [0, 0, 0, 0],
      left: a.value.x * i.x,
      top: a.value.y * i.y,
      width: a.value.width * i.x
    }).value;
  });
  return {
    averageColor: o,
    isLight: I(
      () => $l(
        o.value ?? [255, 255, 255]
      )
    )
  };
}
function Sk(t) {
  if (t)
    return {
      image: hm(I(() => {
        var s;
        return (s = t.value) == null ? void 0 : s.imageUrl;
      })).data,
      view: t
    };
  const { data: e, texture: n } = Mt(gl);
  return {
    image: I(
      () => {
        var s;
        return (s = n.value) == null ? void 0 : s.source.resource;
      }
    ),
    view: e
  };
}
function Ak(t, e, n = 0) {
  const { size: s } = xl(
    I(() => {
      if (!(!t.value || !e.value))
        return {
          design: e.value.design,
          productionMethodId: t.value.productionMethodId
        };
    })
  );
  return I(() => {
    if (!t.value || !e.value || !s.value)
      return;
    const a = Ms(
      s.value,
      { x: s.value.width / 2, y: s.value.height / 2 },
      e.value.rotation
    ), o = t.value.position[1], i = t.value.position[0], r = { x: 0, y: 0 };
    o === "l" ? r.x = a.left : o === "r" && (r.x = a.right), i === "t" ? r.y = a.top : i === "b" && (r.y = a.bottom);
    const [l] = lm(t.value.rotation, [
      r
    ]);
    if (!l) throw new Error("rotatedOffset is undefined");
    const u = Ms(
      s.value,
      { x: s.value.width / 2, y: s.value.height / 2 },
      t.value.rotation + e.value.rotation
    ), m = Jt(n);
    return u.left -= m, u.top -= m, u.right += m, u.bottom += m, {
      height: u.bottom - u.top,
      width: u.right - u.left,
      x: t.value.x + u.left - l.x,
      y: t.value.y + u.top - l.y
    };
  });
}
function gm(t, e) {
  const { channelSession: n } = D(fl()), s = jt(t);
  ie((a) => {
    const o = n.value;
    if (!o) return;
    const i = s.value;
    o.bind(i, e), a(() => {
      o.unbind(i, e);
    });
  });
}
const Ck = {
  install() {
    R_("Viewport", {
      createElement: (t) => new Pg(t)
    });
  }
};
function Pk(...t) {
  return t.flatMap((e) => e.resource_type === "text" ? e.resource.lines.flatMap(
    (n) => n.color_assignments
  ) : e.resource.color_assignments);
}
function Sl(t) {
  const e = [t];
  return e.push(
    ...t.elements.flatMap((n) => Sl(n))
  ), e;
}
const lr = /* @__PURE__ */ new WeakMap();
let Ik = 0;
function He(t) {
  return lr.has(t) || lr.set(t, ++Ik), lr.get(t);
}
function _m(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Mk } = Object.prototype, { getPrototypeOf: Al } = Object, { iterator: Lo, toStringTag: km } = Symbol, Do = /* @__PURE__ */ ((t) => (e) => {
  const n = Mk.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), fn = (t) => (t = t.toLowerCase(), (e) => Do(e) === t), No = (t) => (e) => typeof e === t, { isArray: Us } = Array, _a = No("undefined");
function Tk(t) {
  return t !== null && !_a(t) && t.constructor !== null && !_a(t.constructor) && qt(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const ym = fn("ArrayBuffer");
function zk(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && ym(t.buffer), e;
}
const Ek = No("string"), qt = No("function"), bm = No("number"), Vo = (t) => t !== null && typeof t == "object", Ok = (t) => t === !0 || t === !1, Xa = (t) => {
  if (Do(t) !== "object")
    return !1;
  const e = Al(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(km in t) && !(Lo in t);
}, Rk = fn("Date"), Lk = fn("File"), Dk = fn("Blob"), Nk = fn("FileList"), Vk = (t) => Vo(t) && qt(t.pipe), Uk = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || qt(t.append) && ((e = Do(t)) === "formdata" || // detect form-data instance
  e === "object" && qt(t.toString) && t.toString() === "[object FormData]"));
}, Fk = fn("URLSearchParams"), [jk, Bk, qk, Hk] = ["ReadableStream", "Request", "Response", "Headers"].map(fn), Wk = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Sa(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let s, a;
  if (typeof t != "object" && (t = [t]), Us(t))
    for (s = 0, a = t.length; s < a; s++)
      e.call(null, t[s], s, t);
  else {
    const o = n ? Object.getOwnPropertyNames(t) : Object.keys(t), i = o.length;
    let r;
    for (s = 0; s < i; s++)
      r = o[s], e.call(null, t[r], r, t);
  }
}
function wm(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let s = n.length, a;
  for (; s-- > 0; )
    if (a = n[s], e === a.toLowerCase())
      return a;
  return null;
}
const ns = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, xm = (t) => !_a(t) && t !== ns;
function Lr() {
  const { caseless: t } = xm(this) && this || {}, e = {}, n = (s, a) => {
    const o = t && wm(e, a) || a;
    Xa(e[o]) && Xa(s) ? e[o] = Lr(e[o], s) : Xa(s) ? e[o] = Lr({}, s) : Us(s) ? e[o] = s.slice() : e[o] = s;
  };
  for (let s = 0, a = arguments.length; s < a; s++)
    arguments[s] && Sa(arguments[s], n);
  return e;
}
const Gk = (t, e, n, { allOwnKeys: s } = {}) => (Sa(e, (a, o) => {
  n && qt(a) ? t[o] = _m(a, n) : t[o] = a;
}, { allOwnKeys: s }), t), Zk = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Qk = (t, e, n, s) => {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, Xk = (t, e, n, s) => {
  let a, o, i;
  const r = {};
  if (e = e || {}, t == null) return e;
  do {
    for (a = Object.getOwnPropertyNames(t), o = a.length; o-- > 0; )
      i = a[o], (!s || s(i, t, e)) && !r[i] && (e[i] = t[i], r[i] = !0);
    t = n !== !1 && Al(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, Kk = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const s = t.indexOf(e, n);
  return s !== -1 && s === n;
}, Jk = (t) => {
  if (!t) return null;
  if (Us(t)) return t;
  let e = t.length;
  if (!bm(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, Yk = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Al(Uint8Array)), e2 = (t, e) => {
  const s = (t && t[Lo]).call(t);
  let a;
  for (; (a = s.next()) && !a.done; ) {
    const o = a.value;
    e.call(t, o[0], o[1]);
  }
}, t2 = (t, e) => {
  let n;
  const s = [];
  for (; (n = t.exec(e)) !== null; )
    s.push(n);
  return s;
}, n2 = fn("HTMLFormElement"), s2 = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, a) {
    return s.toUpperCase() + a;
  }
), gu = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), a2 = fn("RegExp"), $m = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), s = {};
  Sa(n, (a, o) => {
    let i;
    (i = e(a, o, t)) !== !1 && (s[o] = i || a);
  }), Object.defineProperties(t, s);
}, o2 = (t) => {
  $m(t, (e, n) => {
    if (qt(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = t[n];
    if (qt(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, i2 = (t, e) => {
  const n = {}, s = (a) => {
    a.forEach((o) => {
      n[o] = !0;
    });
  };
  return Us(t) ? s(t) : s(String(t).split(e)), n;
}, r2 = () => {
}, l2 = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function c2(t) {
  return !!(t && qt(t.append) && t[km] === "FormData" && t[Lo]);
}
const u2 = (t) => {
  const e = new Array(10), n = (s, a) => {
    if (Vo(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        e[a] = s;
        const o = Us(s) ? [] : {};
        return Sa(s, (i, r) => {
          const l = n(i, a + 1);
          !_a(l) && (o[r] = l);
        }), e[a] = void 0, o;
      }
    }
    return s;
  };
  return n(t, 0);
}, d2 = fn("AsyncFunction"), m2 = (t) => t && (Vo(t) || qt(t)) && qt(t.then) && qt(t.catch), Sm = ((t, e) => t ? setImmediate : e ? ((n, s) => (ns.addEventListener("message", ({ source: a, data: o }) => {
  a === ns && o === n && s.length && s.shift()();
}, !1), (a) => {
  s.push(a), ns.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  qt(ns.postMessage)
), h2 = typeof queueMicrotask < "u" ? queueMicrotask.bind(ns) : typeof process < "u" && process.nextTick || Sm, p2 = (t) => t != null && qt(t[Lo]), H = {
  isArray: Us,
  isArrayBuffer: ym,
  isBuffer: Tk,
  isFormData: Uk,
  isArrayBufferView: zk,
  isString: Ek,
  isNumber: bm,
  isBoolean: Ok,
  isObject: Vo,
  isPlainObject: Xa,
  isReadableStream: jk,
  isRequest: Bk,
  isResponse: qk,
  isHeaders: Hk,
  isUndefined: _a,
  isDate: Rk,
  isFile: Lk,
  isBlob: Dk,
  isRegExp: a2,
  isFunction: qt,
  isStream: Vk,
  isURLSearchParams: Fk,
  isTypedArray: Yk,
  isFileList: Nk,
  forEach: Sa,
  merge: Lr,
  extend: Gk,
  trim: Wk,
  stripBOM: Zk,
  inherits: Qk,
  toFlatObject: Xk,
  kindOf: Do,
  kindOfTest: fn,
  endsWith: Kk,
  toArray: Jk,
  forEachEntry: e2,
  matchAll: t2,
  isHTMLForm: n2,
  hasOwnProperty: gu,
  hasOwnProp: gu,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: $m,
  freezeMethods: o2,
  toObjectSet: i2,
  toCamelCase: s2,
  noop: r2,
  toFiniteNumber: l2,
  findKey: wm,
  global: ns,
  isContextDefined: xm,
  isSpecCompliantForm: c2,
  toJSONObject: u2,
  isAsyncFn: d2,
  isThenable: m2,
  setImmediate: Sm,
  asap: h2,
  isIterable: p2
};
function Oe(t, e, n, s, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), s && (this.request = s), a && (this.response = a, this.status = a.status ? a.status : null);
}
H.inherits(Oe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: H.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Am = Oe.prototype, Cm = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Cm[t] = { value: t };
});
Object.defineProperties(Oe, Cm);
Object.defineProperty(Am, "isAxiosError", { value: !0 });
Oe.from = (t, e, n, s, a, o) => {
  const i = Object.create(Am);
  return H.toFlatObject(t, i, function(l) {
    return l !== Error.prototype;
  }, (r) => r !== "isAxiosError"), Oe.call(i, t.message, e, n, s, a), i.cause = t, i.name = t.name, o && Object.assign(i, o), i;
};
const f2 = null;
function Dr(t) {
  return H.isPlainObject(t) || H.isArray(t);
}
function Pm(t) {
  return H.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function _u(t, e, n) {
  return t ? t.concat(e).map(function(a, o) {
    return a = Pm(a), !n && o ? "[" + a + "]" : a;
  }).join(n ? "." : "") : e;
}
function v2(t) {
  return H.isArray(t) && !t.some(Dr);
}
const g2 = H.toFlatObject(H, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Uo(t, e, n) {
  if (!H.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = H.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(S, f) {
    return !H.isUndefined(f[S]);
  });
  const s = n.metaTokens, a = n.visitor || m, o = n.dots, i = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && H.isSpecCompliantForm(e);
  if (!H.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(y) {
    if (y === null) return "";
    if (H.isDate(y))
      return y.toISOString();
    if (H.isBoolean(y))
      return y.toString();
    if (!l && H.isBlob(y))
      throw new Oe("Blob is not supported. Use a Buffer instead.");
    return H.isArrayBuffer(y) || H.isTypedArray(y) ? l && typeof Blob == "function" ? new Blob([y]) : Buffer.from(y) : y;
  }
  function m(y, S, f) {
    let k = y;
    if (y && !f && typeof y == "object") {
      if (H.endsWith(S, "{}"))
        S = s ? S : S.slice(0, -2), y = JSON.stringify(y);
      else if (H.isArray(y) && v2(y) || (H.isFileList(y) || H.endsWith(S, "[]")) && (k = H.toArray(y)))
        return S = Pm(S), k.forEach(function(C, M) {
          !(H.isUndefined(C) || C === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? _u([S], M, o) : i === null ? S : S + "[]",
            u(C)
          );
        }), !1;
    }
    return Dr(y) ? !0 : (e.append(_u(f, S, o), u(y)), !1);
  }
  const h = [], v = Object.assign(g2, {
    defaultVisitor: m,
    convertValue: u,
    isVisitable: Dr
  });
  function _(y, S) {
    if (!H.isUndefined(y)) {
      if (h.indexOf(y) !== -1)
        throw Error("Circular reference detected in " + S.join("."));
      h.push(y), H.forEach(y, function(k, w) {
        (!(H.isUndefined(k) || k === null) && a.call(
          e,
          k,
          H.isString(w) ? w.trim() : w,
          S,
          v
        )) === !0 && _(k, S ? S.concat(w) : [w]);
      }), h.pop();
    }
  }
  if (!H.isObject(t))
    throw new TypeError("data must be an object");
  return _(t), e;
}
function ku(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function Cl(t, e) {
  this._pairs = [], t && Uo(t, this, e);
}
const Im = Cl.prototype;
Im.append = function(e, n) {
  this._pairs.push([e, n]);
};
Im.toString = function(e) {
  const n = e ? function(s) {
    return e.call(this, s, ku);
  } : ku;
  return this._pairs.map(function(a) {
    return n(a[0]) + "=" + n(a[1]);
  }, "").join("&");
};
function _2(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Mm(t, e, n) {
  if (!e)
    return t;
  const s = n && n.encode || _2;
  H.isFunction(n) && (n = {
    serialize: n
  });
  const a = n && n.serialize;
  let o;
  if (a ? o = a(e, n) : o = H.isURLSearchParams(e) ? e.toString() : new Cl(e, n).toString(s), o) {
    const i = t.indexOf("#");
    i !== -1 && (t = t.slice(0, i)), t += (t.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return t;
}
class yu {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    H.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const Tm = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, k2 = typeof URLSearchParams < "u" ? URLSearchParams : Cl, y2 = typeof FormData < "u" ? FormData : null, b2 = typeof Blob < "u" ? Blob : null, w2 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: k2,
    FormData: y2,
    Blob: b2
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Pl = typeof window < "u" && typeof document < "u", Nr = typeof navigator == "object" && navigator || void 0, x2 = Pl && (!Nr || ["ReactNative", "NativeScript", "NS"].indexOf(Nr.product) < 0), $2 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", S2 = Pl && window.location.href || "http://localhost", A2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Pl,
  hasStandardBrowserEnv: x2,
  hasStandardBrowserWebWorkerEnv: $2,
  navigator: Nr,
  origin: S2
}, Symbol.toStringTag, { value: "Module" })), It = {
  ...A2,
  ...w2
};
function C2(t, e) {
  return Uo(t, new It.classes.URLSearchParams(), Object.assign({
    visitor: function(n, s, a, o) {
      return It.isNode && H.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function P2(t) {
  return H.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function I2(t) {
  const e = {}, n = Object.keys(t);
  let s;
  const a = n.length;
  let o;
  for (s = 0; s < a; s++)
    o = n[s], e[o] = t[o];
  return e;
}
function zm(t) {
  function e(n, s, a, o) {
    let i = n[o++];
    if (i === "__proto__") return !0;
    const r = Number.isFinite(+i), l = o >= n.length;
    return i = !i && H.isArray(a) ? a.length : i, l ? (H.hasOwnProp(a, i) ? a[i] = [a[i], s] : a[i] = s, !r) : ((!a[i] || !H.isObject(a[i])) && (a[i] = []), e(n, s, a[i], o) && H.isArray(a[i]) && (a[i] = I2(a[i])), !r);
  }
  if (H.isFormData(t) && H.isFunction(t.entries)) {
    const n = {};
    return H.forEachEntry(t, (s, a) => {
      e(P2(s), a, n, 0);
    }), n;
  }
  return null;
}
function M2(t, e, n) {
  if (H.isString(t))
    try {
      return (e || JSON.parse)(t), H.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (n || JSON.stringify)(t);
}
const Aa = {
  transitional: Tm,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const s = n.getContentType() || "", a = s.indexOf("application/json") > -1, o = H.isObject(e);
    if (o && H.isHTMLForm(e) && (e = new FormData(e)), H.isFormData(e))
      return a ? JSON.stringify(zm(e)) : e;
    if (H.isArrayBuffer(e) || H.isBuffer(e) || H.isStream(e) || H.isFile(e) || H.isBlob(e) || H.isReadableStream(e))
      return e;
    if (H.isArrayBufferView(e))
      return e.buffer;
    if (H.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let r;
    if (o) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return C2(e, this.formSerializer).toString();
      if ((r = H.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Uo(
          r ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return o || a ? (n.setContentType("application/json", !1), M2(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || Aa.transitional, s = n && n.forcedJSONParsing, a = this.responseType === "json";
    if (H.isResponse(e) || H.isReadableStream(e))
      return e;
    if (e && H.isString(e) && (s && !this.responseType || a)) {
      const i = !(n && n.silentJSONParsing) && a;
      try {
        return JSON.parse(e);
      } catch (r) {
        if (i)
          throw r.name === "SyntaxError" ? Oe.from(r, Oe.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: It.classes.FormData,
    Blob: It.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
H.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Aa.headers[t] = {};
});
const T2 = H.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), z2 = (t) => {
  const e = {};
  let n, s, a;
  return t && t.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), n = i.substring(0, a).trim().toLowerCase(), s = i.substring(a + 1).trim(), !(!n || e[n] && T2[n]) && (n === "set-cookie" ? e[n] ? e[n].push(s) : e[n] = [s] : e[n] = e[n] ? e[n] + ", " + s : s);
  }), e;
}, bu = Symbol("internals");
function na(t) {
  return t && String(t).trim().toLowerCase();
}
function Ka(t) {
  return t === !1 || t == null ? t : H.isArray(t) ? t.map(Ka) : String(t);
}
function E2(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(t); )
    e[s[1]] = s[2];
  return e;
}
const O2 = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function cr(t, e, n, s, a) {
  if (H.isFunction(s))
    return s.call(this, e, n);
  if (a && (e = n), !!H.isString(e)) {
    if (H.isString(s))
      return e.indexOf(s) !== -1;
    if (H.isRegExp(s))
      return s.test(e);
  }
}
function R2(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, s) => n.toUpperCase() + s);
}
function L2(t, e) {
  const n = H.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(t, s + n, {
      value: function(a, o, i) {
        return this[s].call(this, e, a, o, i);
      },
      configurable: !0
    });
  });
}
let Ht = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, s) {
    const a = this;
    function o(r, l, u) {
      const m = na(l);
      if (!m)
        throw new Error("header name must be a non-empty string");
      const h = H.findKey(a, m);
      (!h || a[h] === void 0 || u === !0 || u === void 0 && a[h] !== !1) && (a[h || l] = Ka(r));
    }
    const i = (r, l) => H.forEach(r, (u, m) => o(u, m, l));
    if (H.isPlainObject(e) || e instanceof this.constructor)
      i(e, n);
    else if (H.isString(e) && (e = e.trim()) && !O2(e))
      i(z2(e), n);
    else if (H.isObject(e) && H.isIterable(e)) {
      let r = {}, l, u;
      for (const m of e) {
        if (!H.isArray(m))
          throw TypeError("Object iterator must return a key-value pair");
        r[u = m[0]] = (l = r[u]) ? H.isArray(l) ? [...l, m[1]] : [l, m[1]] : m[1];
      }
      i(r, n);
    } else
      e != null && o(n, e, s);
    return this;
  }
  get(e, n) {
    if (e = na(e), e) {
      const s = H.findKey(this, e);
      if (s) {
        const a = this[s];
        if (!n)
          return a;
        if (n === !0)
          return E2(a);
        if (H.isFunction(n))
          return n.call(this, a, s);
        if (H.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = na(e), e) {
      const s = H.findKey(this, e);
      return !!(s && this[s] !== void 0 && (!n || cr(this, this[s], s, n)));
    }
    return !1;
  }
  delete(e, n) {
    const s = this;
    let a = !1;
    function o(i) {
      if (i = na(i), i) {
        const r = H.findKey(s, i);
        r && (!n || cr(s, s[r], r, n)) && (delete s[r], a = !0);
      }
    }
    return H.isArray(e) ? e.forEach(o) : o(e), a;
  }
  clear(e) {
    const n = Object.keys(this);
    let s = n.length, a = !1;
    for (; s--; ) {
      const o = n[s];
      (!e || cr(this, this[o], o, e, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(e) {
    const n = this, s = {};
    return H.forEach(this, (a, o) => {
      const i = H.findKey(s, o);
      if (i) {
        n[i] = Ka(a), delete n[o];
        return;
      }
      const r = e ? R2(o) : String(o).trim();
      r !== o && delete n[o], n[r] = Ka(a), s[r] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return H.forEach(this, (s, a) => {
      s != null && s !== !1 && (n[a] = e && H.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const s = new this(e);
    return n.forEach((a) => s.set(a)), s;
  }
  static accessor(e) {
    const s = (this[bu] = this[bu] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(i) {
      const r = na(i);
      s[r] || (L2(a, i), s[r] = !0);
    }
    return H.isArray(e) ? e.forEach(o) : o(e), this;
  }
};
Ht.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
H.reduceDescriptors(Ht.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(s) {
      this[n] = s;
    }
  };
});
H.freezeMethods(Ht);
function ur(t, e) {
  const n = this || Aa, s = e || n, a = Ht.from(s.headers);
  let o = s.data;
  return H.forEach(t, function(r) {
    o = r.call(n, o, a.normalize(), e ? e.status : void 0);
  }), a.normalize(), o;
}
function Em(t) {
  return !!(t && t.__CANCEL__);
}
function Fs(t, e, n) {
  Oe.call(this, t ?? "canceled", Oe.ERR_CANCELED, e, n), this.name = "CanceledError";
}
H.inherits(Fs, Oe, {
  __CANCEL__: !0
});
function Om(t, e, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? t(n) : e(new Oe(
    "Request failed with status code " + n.status,
    [Oe.ERR_BAD_REQUEST, Oe.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function D2(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function N2(t, e) {
  t = t || 10;
  const n = new Array(t), s = new Array(t);
  let a = 0, o = 0, i;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const u = Date.now(), m = s[o];
    i || (i = u), n[a] = l, s[a] = u;
    let h = o, v = 0;
    for (; h !== a; )
      v += n[h++], h = h % t;
    if (a = (a + 1) % t, a === o && (o = (o + 1) % t), u - i < e)
      return;
    const _ = m && u - m;
    return _ ? Math.round(v * 1e3 / _) : void 0;
  };
}
function V2(t, e) {
  let n = 0, s = 1e3 / e, a, o;
  const i = (u, m = Date.now()) => {
    n = m, a = null, o && (clearTimeout(o), o = null), t.apply(null, u);
  };
  return [(...u) => {
    const m = Date.now(), h = m - n;
    h >= s ? i(u, m) : (a = u, o || (o = setTimeout(() => {
      o = null, i(a);
    }, s - h)));
  }, () => a && i(a)];
}
const go = (t, e, n = 3) => {
  let s = 0;
  const a = N2(50, 250);
  return V2((o) => {
    const i = o.loaded, r = o.lengthComputable ? o.total : void 0, l = i - s, u = a(l), m = i <= r;
    s = i;
    const h = {
      loaded: i,
      total: r,
      progress: r ? i / r : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && r && m ? (r - i) / u : void 0,
      event: o,
      lengthComputable: r != null,
      [e ? "download" : "upload"]: !0
    };
    t(h);
  }, n);
}, wu = (t, e) => {
  const n = t != null;
  return [(s) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: s
  }), e[1]];
}, xu = (t) => (...e) => H.asap(() => t(...e)), U2 = It.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, It.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(
  new URL(It.origin),
  It.navigator && /(msie|trident)/i.test(It.navigator.userAgent)
) : () => !0, F2 = It.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, s, a, o) {
      const i = [t + "=" + encodeURIComponent(e)];
      H.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), H.isString(s) && i.push("path=" + s), H.isString(a) && i.push("domain=" + a), o === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function j2(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function B2(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Rm(t, e, n) {
  let s = !j2(e);
  return t && (s || n == !1) ? B2(t, e) : e;
}
const $u = (t) => t instanceof Ht ? { ...t } : t;
function ps(t, e) {
  e = e || {};
  const n = {};
  function s(u, m, h, v) {
    return H.isPlainObject(u) && H.isPlainObject(m) ? H.merge.call({ caseless: v }, u, m) : H.isPlainObject(m) ? H.merge({}, m) : H.isArray(m) ? m.slice() : m;
  }
  function a(u, m, h, v) {
    if (H.isUndefined(m)) {
      if (!H.isUndefined(u))
        return s(void 0, u, h, v);
    } else return s(u, m, h, v);
  }
  function o(u, m) {
    if (!H.isUndefined(m))
      return s(void 0, m);
  }
  function i(u, m) {
    if (H.isUndefined(m)) {
      if (!H.isUndefined(u))
        return s(void 0, u);
    } else return s(void 0, m);
  }
  function r(u, m, h) {
    if (h in e)
      return s(u, m);
    if (h in t)
      return s(void 0, u);
  }
  const l = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: r,
    headers: (u, m, h) => a($u(u), $u(m), h, !0)
  };
  return H.forEach(Object.keys(Object.assign({}, t, e)), function(m) {
    const h = l[m] || a, v = h(t[m], e[m], m);
    H.isUndefined(v) && h !== r || (n[m] = v);
  }), n;
}
const Lm = (t) => {
  const e = ps({}, t);
  let { data: n, withXSRFToken: s, xsrfHeaderName: a, xsrfCookieName: o, headers: i, auth: r } = e;
  e.headers = i = Ht.from(i), e.url = Mm(Rm(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), r && i.set(
    "Authorization",
    "Basic " + btoa((r.username || "") + ":" + (r.password ? unescape(encodeURIComponent(r.password)) : ""))
  );
  let l;
  if (H.isFormData(n)) {
    if (It.hasStandardBrowserEnv || It.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [u, ...m] = l ? l.split(";").map((h) => h.trim()).filter(Boolean) : [];
      i.setContentType([u || "multipart/form-data", ...m].join("; "));
    }
  }
  if (It.hasStandardBrowserEnv && (s && H.isFunction(s) && (s = s(e)), s || s !== !1 && U2(e.url))) {
    const u = a && o && F2.read(o);
    u && i.set(a, u);
  }
  return e;
}, q2 = typeof XMLHttpRequest < "u", H2 = q2 && function(t) {
  return new Promise(function(n, s) {
    const a = Lm(t);
    let o = a.data;
    const i = Ht.from(a.headers).normalize();
    let { responseType: r, onUploadProgress: l, onDownloadProgress: u } = a, m, h, v, _, y;
    function S() {
      _ && _(), y && y(), a.cancelToken && a.cancelToken.unsubscribe(m), a.signal && a.signal.removeEventListener("abort", m);
    }
    let f = new XMLHttpRequest();
    f.open(a.method.toUpperCase(), a.url, !0), f.timeout = a.timeout;
    function k() {
      if (!f)
        return;
      const C = Ht.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), T = {
        data: !r || r === "text" || r === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: C,
        config: t,
        request: f
      };
      Om(function(U) {
        n(U), S();
      }, function(U) {
        s(U), S();
      }, T), f = null;
    }
    "onloadend" in f ? f.onloadend = k : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(k);
    }, f.onabort = function() {
      f && (s(new Oe("Request aborted", Oe.ECONNABORTED, t, f)), f = null);
    }, f.onerror = function() {
      s(new Oe("Network Error", Oe.ERR_NETWORK, t, f)), f = null;
    }, f.ontimeout = function() {
      let M = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const T = a.transitional || Tm;
      a.timeoutErrorMessage && (M = a.timeoutErrorMessage), s(new Oe(
        M,
        T.clarifyTimeoutError ? Oe.ETIMEDOUT : Oe.ECONNABORTED,
        t,
        f
      )), f = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in f && H.forEach(i.toJSON(), function(M, T) {
      f.setRequestHeader(T, M);
    }), H.isUndefined(a.withCredentials) || (f.withCredentials = !!a.withCredentials), r && r !== "json" && (f.responseType = a.responseType), u && ([v, y] = go(u, !0), f.addEventListener("progress", v)), l && f.upload && ([h, _] = go(l), f.upload.addEventListener("progress", h), f.upload.addEventListener("loadend", _)), (a.cancelToken || a.signal) && (m = (C) => {
      f && (s(!C || C.type ? new Fs(null, t, f) : C), f.abort(), f = null);
    }, a.cancelToken && a.cancelToken.subscribe(m), a.signal && (a.signal.aborted ? m() : a.signal.addEventListener("abort", m)));
    const w = D2(a.url);
    if (w && It.protocols.indexOf(w) === -1) {
      s(new Oe("Unsupported protocol " + w + ":", Oe.ERR_BAD_REQUEST, t));
      return;
    }
    f.send(o || null);
  });
}, W2 = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let s = new AbortController(), a;
    const o = function(u) {
      if (!a) {
        a = !0, r();
        const m = u instanceof Error ? u : this.reason;
        s.abort(m instanceof Oe ? m : new Fs(m instanceof Error ? m.message : m));
      }
    };
    let i = e && setTimeout(() => {
      i = null, o(new Oe(`timeout ${e} of ms exceeded`, Oe.ETIMEDOUT));
    }, e);
    const r = () => {
      t && (i && clearTimeout(i), i = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(o) : u.removeEventListener("abort", o);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", o));
    const { signal: l } = s;
    return l.unsubscribe = () => H.asap(r), l;
  }
}, G2 = function* (t, e) {
  let n = t.byteLength;
  if (n < e) {
    yield t;
    return;
  }
  let s = 0, a;
  for (; s < n; )
    a = s + e, yield t.slice(s, a), s = a;
}, Z2 = async function* (t, e) {
  for await (const n of Q2(t))
    yield* G2(n, e);
}, Q2 = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: n, value: s } = await e.read();
      if (n)
        break;
      yield s;
    }
  } finally {
    await e.cancel();
  }
}, Su = (t, e, n, s) => {
  const a = Z2(t, e);
  let o = 0, i, r = (l) => {
    i || (i = !0, s && s(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: m } = await a.next();
        if (u) {
          r(), l.close();
          return;
        }
        let h = m.byteLength;
        if (n) {
          let v = o += h;
          n(v);
        }
        l.enqueue(new Uint8Array(m));
      } catch (u) {
        throw r(u), u;
      }
    },
    cancel(l) {
      return r(l), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Fo = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Dm = Fo && typeof ReadableStream == "function", X2 = Fo && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), Nm = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, K2 = Dm && Nm(() => {
  let t = !1;
  const e = new Request(It.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), Au = 64 * 1024, Vr = Dm && Nm(() => H.isReadableStream(new Response("").body)), _o = {
  stream: Vr && ((t) => t.body)
};
Fo && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !_o[e] && (_o[e] = H.isFunction(t[e]) ? (n) => n[e]() : (n, s) => {
      throw new Oe(`Response type '${e}' is not supported`, Oe.ERR_NOT_SUPPORT, s);
    });
  });
})(new Response());
const J2 = async (t) => {
  if (t == null)
    return 0;
  if (H.isBlob(t))
    return t.size;
  if (H.isSpecCompliantForm(t))
    return (await new Request(It.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (H.isArrayBufferView(t) || H.isArrayBuffer(t))
    return t.byteLength;
  if (H.isURLSearchParams(t) && (t = t + ""), H.isString(t))
    return (await X2(t)).byteLength;
}, Y2 = async (t, e) => {
  const n = H.toFiniteNumber(t.getContentLength());
  return n ?? J2(e);
}, ey = Fo && (async (t) => {
  let {
    url: e,
    method: n,
    data: s,
    signal: a,
    cancelToken: o,
    timeout: i,
    onDownloadProgress: r,
    onUploadProgress: l,
    responseType: u,
    headers: m,
    withCredentials: h = "same-origin",
    fetchOptions: v
  } = Lm(t);
  u = u ? (u + "").toLowerCase() : "text";
  let _ = W2([a, o && o.toAbortSignal()], i), y;
  const S = _ && _.unsubscribe && (() => {
    _.unsubscribe();
  });
  let f;
  try {
    if (l && K2 && n !== "get" && n !== "head" && (f = await Y2(m, s)) !== 0) {
      let T = new Request(e, {
        method: "POST",
        body: s,
        duplex: "half"
      }), E;
      if (H.isFormData(s) && (E = T.headers.get("content-type")) && m.setContentType(E), T.body) {
        const [U, F] = wu(
          f,
          go(xu(l))
        );
        s = Su(T.body, Au, U, F);
      }
    }
    H.isString(h) || (h = h ? "include" : "omit");
    const k = "credentials" in Request.prototype;
    y = new Request(e, {
      ...v,
      signal: _,
      method: n.toUpperCase(),
      headers: m.normalize().toJSON(),
      body: s,
      duplex: "half",
      credentials: k ? h : void 0
    });
    let w = await fetch(y, v);
    const C = Vr && (u === "stream" || u === "response");
    if (Vr && (r || C && S)) {
      const T = {};
      ["status", "statusText", "headers"].forEach((ee) => {
        T[ee] = w[ee];
      });
      const E = H.toFiniteNumber(w.headers.get("content-length")), [U, F] = r && wu(
        E,
        go(xu(r), !0)
      ) || [];
      w = new Response(
        Su(w.body, Au, U, () => {
          F && F(), S && S();
        }),
        T
      );
    }
    u = u || "text";
    let M = await _o[H.findKey(_o, u) || "text"](w, t);
    return !C && S && S(), await new Promise((T, E) => {
      Om(T, E, {
        data: M,
        headers: Ht.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: t,
        request: y
      });
    });
  } catch (k) {
    throw S && S(), k && k.name === "TypeError" && /Load failed|fetch/i.test(k.message) ? Object.assign(
      new Oe("Network Error", Oe.ERR_NETWORK, t, y),
      {
        cause: k.cause || k
      }
    ) : Oe.from(k, k && k.code, t, y);
  }
}), Ur = {
  http: f2,
  xhr: H2,
  fetch: ey
};
H.forEach(Ur, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Cu = (t) => `- ${t}`, ty = (t) => H.isFunction(t) || t === null || t === !1, Vm = {
  getAdapter: (t) => {
    t = H.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, s;
    const a = {};
    for (let o = 0; o < e; o++) {
      n = t[o];
      let i;
      if (s = n, !ty(n) && (s = Ur[(i = String(n)).toLowerCase()], s === void 0))
        throw new Oe(`Unknown adapter '${i}'`);
      if (s)
        break;
      a[i || "#" + o] = s;
    }
    if (!s) {
      const o = Object.entries(a).map(
        ([r, l]) => `adapter ${r} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = e ? o.length > 1 ? `since :
` + o.map(Cu).join(`
`) : " " + Cu(o[0]) : "as no adapter specified";
      throw new Oe(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: Ur
};
function dr(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Fs(null, t);
}
function Pu(t) {
  return dr(t), t.headers = Ht.from(t.headers), t.data = ur.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Vm.getAdapter(t.adapter || Aa.adapter)(t).then(function(s) {
    return dr(t), s.data = ur.call(
      t,
      t.transformResponse,
      s
    ), s.headers = Ht.from(s.headers), s;
  }, function(s) {
    return Em(s) || (dr(t), s && s.response && (s.response.data = ur.call(
      t,
      t.transformResponse,
      s.response
    ), s.response.headers = Ht.from(s.response.headers))), Promise.reject(s);
  });
}
const Um = "1.10.0", jo = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  jo[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Iu = {};
jo.transitional = function(e, n, s) {
  function a(o, i) {
    return "[Axios v" + Um + "] Transitional option '" + o + "'" + i + (s ? ". " + s : "");
  }
  return (o, i, r) => {
    if (e === !1)
      throw new Oe(
        a(i, " has been removed" + (n ? " in " + n : "")),
        Oe.ERR_DEPRECATED
      );
    return n && !Iu[i] && (Iu[i] = !0, console.warn(
      a(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(o, i, r) : !0;
  };
};
jo.spelling = function(e) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${e}`), !0);
};
function ny(t, e, n) {
  if (typeof t != "object")
    throw new Oe("options must be an object", Oe.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(t);
  let a = s.length;
  for (; a-- > 0; ) {
    const o = s[a], i = e[o];
    if (i) {
      const r = t[o], l = r === void 0 || i(r, o, t);
      if (l !== !0)
        throw new Oe("option " + o + " must be " + l, Oe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new Oe("Unknown option " + o, Oe.ERR_BAD_OPTION);
  }
}
const Ja = {
  assertOptions: ny,
  validators: jo
}, yn = Ja.validators;
let rs = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new yu(),
      response: new yu()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (s) {
      if (s instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? o && !String(s.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + o) : s.stack = o;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = ps(this.defaults, n);
    const { transitional: s, paramsSerializer: a, headers: o } = n;
    s !== void 0 && Ja.assertOptions(s, {
      silentJSONParsing: yn.transitional(yn.boolean),
      forcedJSONParsing: yn.transitional(yn.boolean),
      clarifyTimeoutError: yn.transitional(yn.boolean)
    }, !1), a != null && (H.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : Ja.assertOptions(a, {
      encode: yn.function,
      serialize: yn.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Ja.assertOptions(n, {
      baseUrl: yn.spelling("baseURL"),
      withXsrfToken: yn.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = o && H.merge(
      o.common,
      o[n.method]
    );
    o && H.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (y) => {
        delete o[y];
      }
    ), n.headers = Ht.concat(i, o);
    const r = [];
    let l = !0;
    this.interceptors.request.forEach(function(S) {
      typeof S.runWhen == "function" && S.runWhen(n) === !1 || (l = l && S.synchronous, r.unshift(S.fulfilled, S.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(S) {
      u.push(S.fulfilled, S.rejected);
    });
    let m, h = 0, v;
    if (!l) {
      const y = [Pu.bind(this), void 0];
      for (y.unshift.apply(y, r), y.push.apply(y, u), v = y.length, m = Promise.resolve(n); h < v; )
        m = m.then(y[h++], y[h++]);
      return m;
    }
    v = r.length;
    let _ = n;
    for (h = 0; h < v; ) {
      const y = r[h++], S = r[h++];
      try {
        _ = y(_);
      } catch (f) {
        S.call(this, f);
        break;
      }
    }
    try {
      m = Pu.call(this, _);
    } catch (y) {
      return Promise.reject(y);
    }
    for (h = 0, v = u.length; h < v; )
      m = m.then(u[h++], u[h++]);
    return m;
  }
  getUri(e) {
    e = ps(this.defaults, e);
    const n = Rm(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Mm(n, e.params, e.paramsSerializer);
  }
};
H.forEach(["delete", "get", "head", "options"], function(e) {
  rs.prototype[e] = function(n, s) {
    return this.request(ps(s || {}, {
      method: e,
      url: n,
      data: (s || {}).data
    }));
  };
});
H.forEach(["post", "put", "patch"], function(e) {
  function n(s) {
    return function(o, i, r) {
      return this.request(ps(r || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: i
      }));
    };
  }
  rs.prototype[e] = n(), rs.prototype[e + "Form"] = n(!0);
});
let sy = class Fm {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const s = this;
    this.promise.then((a) => {
      if (!s._listeners) return;
      let o = s._listeners.length;
      for (; o-- > 0; )
        s._listeners[o](a);
      s._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const i = new Promise((r) => {
        s.subscribe(r), o = r;
      }).then(a);
      return i.cancel = function() {
        s.unsubscribe(o);
      }, i;
    }, e(function(o, i, r) {
      s.reason || (s.reason = new Fs(o, i, r), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (s) => {
      e.abort(s);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Fm(function(a) {
        e = a;
      }),
      cancel: e
    };
  }
};
function ay(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function oy(t) {
  return H.isObject(t) && t.isAxiosError === !0;
}
const Fr = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Fr).forEach(([t, e]) => {
  Fr[e] = t;
});
function jm(t) {
  const e = new rs(t), n = _m(rs.prototype.request, e);
  return H.extend(n, rs.prototype, e, { allOwnKeys: !0 }), H.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(a) {
    return jm(ps(t, a));
  }, n;
}
const dt = jm(Aa);
dt.Axios = rs;
dt.CanceledError = Fs;
dt.CancelToken = sy;
dt.isCancel = Em;
dt.VERSION = Um;
dt.toFormData = Uo;
dt.AxiosError = Oe;
dt.Cancel = dt.CanceledError;
dt.all = function(e) {
  return Promise.all(e);
};
dt.spread = ay;
dt.isAxiosError = oy;
dt.mergeConfig = ps;
dt.AxiosHeaders = Ht;
dt.formToJSON = (t) => zm(H.isHTMLForm(t) ? new FormData(t) : t);
dt.getAdapter = Vm.getAdapter;
dt.HttpStatusCode = Fr;
dt.default = dt;
const {
  Axios: dV,
  AxiosError: mV,
  CanceledError: hV,
  isCancel: pV,
  CancelToken: fV,
  VERSION: vV,
  all: gV,
  Cancel: _V,
  isAxiosError: kV,
  spread: yV,
  toFormData: bV,
  AxiosHeaders: wV,
  HttpStatusCode: xV,
  formToJSON: $V,
  getAdapter: SV,
  mergeConfig: AV
} = dt;
var iy = Object.defineProperty, ry = (t, e, n) => e in t ? iy(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, ly = (t, e, n) => ry(t, e + "", n);
const Ya = /* @__PURE__ */ K({
  __name: "SmuFeature",
  props: {
    name: {}
  },
  setup(t) {
    const { hasAccess: e } = Pa();
    return (n, s) => c(e)(n.name) ? Nt(n.$slots, "default", { key: 0 }) : X("", !0);
  }
});
function cy(t) {
  return Ca(Bm(t));
}
function Bm(t) {
  const { cyan: e, key: n, magenta: s, yellow: a } = t;
  return {
    blue: Math.round(255 * (1 - a / 100) * (1 - n / 100)),
    green: Math.round(255 * (1 - s / 100) * (1 - n / 100)),
    red: Math.round(255 * (1 - e / 100) * (1 - n / 100))
  };
}
function Bo(t) {
  if (!Wm(t)) return;
  t.length === 4 && (t = `#${t[1] ?? ""}${t[1] ?? ""}${t[2] ?? ""}${t[2] ?? ""}${t[3] ?? ""}${t[3] ?? ""}`);
  const e = qm(t);
  if (e)
    return Ca(e);
}
function qm(t) {
  if (Wm(t))
    return t.length === 4 && (t = `#${t[1] ?? ""}${t[1] ?? ""}${t[2] ?? ""}${t[2] ?? ""}${t[3] ?? ""}${t[3] ?? ""}`), {
      blue: Number.parseInt(t.slice(5, 7), 16),
      green: Number.parseInt(t.slice(3, 5), 16),
      red: Number.parseInt(t.slice(1, 3), 16)
    };
}
function uy(t) {
  const e = ls(t);
  return dy(e);
}
function Hm(t) {
  return my(ls(t));
}
function ls(t) {
  const { hue: e, saturation: n, value: s } = t, a = e / 360, o = n / 100, i = s / 100;
  let r = 0, l = 0, u = 0;
  const m = Math.floor(a * 6), h = a * 6 - m, v = i * (1 - o), _ = i * (1 - h * o), y = i * (1 - (1 - h) * o);
  switch (m % 6) {
    case 0:
      r = i, l = y, u = v;
      break;
    case 1:
      r = _, l = i, u = v;
      break;
    case 2:
      r = v, l = i, u = y;
      break;
    case 3:
      r = v, l = _, u = i;
      break;
    case 4:
      r = y, l = v, u = i;
      break;
    case 5:
      r = i, l = v, u = _;
      break;
  }
  return {
    blue: Math.round(u * 255),
    green: Math.round(l * 255),
    red: Math.round(r * 255)
  };
}
function jr(t, e) {
  return t.red === e.red && t.green === e.green && t.blue === e.blue;
}
function Wm(t) {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(t);
}
function dy(t) {
  const { blue: e, green: n, red: s } = t, a = s / 255, o = e / 255, i = n / 255, r = 1 - Math.max(a, i, o);
  return r === 1 ? {
    cyan: 0,
    key: 100,
    magenta: 0,
    yellow: 0
  } : {
    cyan: (1 - a - r) / (1 - r) * 100,
    key: r * 100,
    magenta: (1 - i - r) / (1 - r) * 100,
    yellow: (1 - o - r) / (1 - r) * 100
  };
}
function my({ blue: t, green: e, red: n }) {
  return `#${(1 << 24 | n << 16 | e << 8 | t).toString(16).slice(1).toUpperCase()}`;
}
function Ca(t) {
  const { blue: e, green: n, red: s } = t, a = s / 255, o = n / 255, i = e / 255, r = Math.max(a, o, i), l = Math.min(a, o, i), u = r - l;
  let m = 0;
  if (u !== 0) {
    switch (r) {
      case i:
        m = (a - o) / u + 4;
        break;
      case o:
        m = (i - a) / u + 2;
        break;
      case a:
        m = (o - i) / u + (o < i ? 6 : 0);
        break;
    }
    m *= 60;
  }
  const h = r === 0 ? 0 : u / r;
  return {
    hue: m,
    saturation: h * 100,
    value: r * 100
  };
}
function hy(t) {
  const e = N({ hue: 0, saturation: 0, value: 0 });
  return {
    colorHSV: I({
      get() {
        return py(t.value, ls(e.value)) ? e.value : Ca({ ...t.value });
      },
      set(n) {
        e.value = { ...n }, t.value = ls({ ...n });
      }
    })
  };
}
function py(t, e) {
  return t.red === e.red && t.green === e.green && t.blue === e.blue;
}
function qo(t) {
  const e = I({
    get() {
      return ls(t.value);
    },
    set(o) {
      t.value = Ca(o);
    }
  }), n = N("#000"), s = I({
    get() {
      const o = qm(n.value);
      if (!o)
        throw new Error("unexpected error in hex to rgb conversion");
      return jr(ls(t.value), o) ? n.value : Hm(t.value);
    },
    set(o) {
      const i = Bo(o);
      i && (n.value = o, t.value = i);
    }
  }), a = N({ cyan: 0, key: 0, magenta: 0, yellow: 0 });
  return {
    colorCMYK: I({
      get() {
        return jr(ls(t.value), Bm(a.value)) ? a.value : uy({ ...t.value });
      },
      set(o) {
        a.value = { ...o }, t.value = cy({ ...o });
      }
    }),
    colorHex: s,
    colorRGB: e
  };
}
const Gm = (t, e = 250) => {
  async function n(s) {
    if (!t.value) return;
    const a = getComputedStyle(t.value).height;
    s(), await bo();
    const o = getComputedStyle(t.value).height, i = Number.parseInt(a) > Number.parseInt(o);
    i && s();
    const r = t.value.animate(
      [
        { height: a, overflow: "hidden" },
        { height: o, overflow: "hidden" }
      ],
      { duration: e, easing: "cubic-bezier(0.4, 0, 0.2, 1)" }
    );
    i && (await r.finished, s());
  }
  return {
    animateHeight: n
  };
};
var Br = /* @__PURE__ */ ((t) => (t[t.ACCEPTED = 202] = "ACCEPTED", t[t.CREATED = 201] = "CREATED", t[t.NO_CONTENT = 204] = "NO_CONTENT", t[t.NOT_MODIFIED = 304] = "NOT_MODIFIED", t[t.OK = 200] = "OK", t))(Br || {});
const fy = 7 * 24 * 60 * 60 * 1e3, vy = (t, e, n) => {
  const s = N(3), a = N(
    Object.assign({}, t.defaults.headers)
  );
  o();
  function o() {
    a.value.common = Object.fromEntries(
      Object.entries(a.value.common).filter((k) => {
        const w = k[0];
        return n ? !n.excludedHeadersForCacheKey.includes(w) : !0;
      })
    );
  }
  async function i(k, w) {
    const C = await t.get(
      k,
      S(k, w)
    );
    if (C.status === Br.NOT_MODIFIED) {
      const M = y(
        k,
        w == null ? void 0 : w.headers
      );
      if (M !== null)
        return M;
      if (s.value === 0)
        throw new Error("Unexpected local storage state occurred.");
      return await i(k, w);
    }
    return h(C, k, w == null ? void 0 : w.headers), s.value = 3, C;
  }
  function r(k) {
    return k ? (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix next time
      k.expire_timestamp !== void 0 && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix next time
      k.entries !== void 0
    ) : !1;
  }
  function l() {
    const k = localStorage.getItem(e);
    if (!k)
      return u();
    try {
      const w = JSON.parse(k);
      return r(w) ? w.expire_timestamp < Date.now() ? (localStorage.removeItem(e), u()) : w : u();
    } catch {
      return u();
    }
  }
  function u() {
    return {
      entries: [],
      expire_timestamp: new Date(
        Date.now() + fy
      ).getTime()
    };
  }
  function m(k, w) {
    return JSON.stringify({
      defaultHeaders: a.value,
      requestSpecificHeaders: w,
      url: k
    });
  }
  function h(k, w, C) {
    const M = k.headers.etag;
    if (!M)
      return;
    const T = l(), E = m(
      w,
      C
    );
    T.entries = T.entries.filter(
      (U) => U.request_identifier !== E
    ), T.entries.push({
      etag: M,
      request_identifier: E,
      response: k
    }), localStorage.setItem(
      e,
      JSON.stringify(T)
    );
  }
  function v(k, w) {
    return l().entries.find(
      (C) => C.request_identifier === m(k, w)
    ) ?? null;
  }
  function _(k, w) {
    var C;
    return ((C = v(
      k,
      w
    )) == null ? void 0 : C.etag) ?? null;
  }
  function y(k, w) {
    var C;
    const M = m(
      k,
      w
    );
    return ((C = l().entries.find(
      (T) => T.request_identifier === M
      // eslint-disable-next-line unicorn/no-null -- fix next time
    )) == null ? void 0 : C.response) ?? null;
  }
  function S(k, w) {
    return w ? (w.data ?? (w.data = {}), w.headers = {
      // eslint-disable-next-line @typescript-eslint/no-misused-spread -- fix next time
      ...w.headers,
      "If-None-Match": _(k, w.headers) ?? void 0
    }, w.validateStatus = f, w) : {
      data: {},
      headers: {
        "If-None-Match": _(k) ?? void 0
      },
      validateStatus: f
    };
  }
  function f(k) {
    return k <= 300 || k === Br.NOT_MODIFIED;
  }
  return {
    get: i
  };
}, gy = tt("smake-use-feature-flag-store", () => ({
  featureFlags: N(/* @__PURE__ */ new Map())
}));
function Pa() {
  const { featureFlags: t } = D(gy());
  function e(a) {
    return t.value.get(a) ?? !1;
  }
  function n(a) {
    t.value.set(a, !0);
  }
  function s(a) {
    t.value.set(a, !1);
  }
  return {
    featureFlags: t,
    giveAccessToFeature: n,
    hasAccess: e,
    removeAccessFromFeature: s
  };
}
const Ho = () => {
  function t(s, a, o) {
    return new Intl.NumberFormat(a, {
      currency: o,
      style: "currency"
    }).format(s);
  }
  function e(s, a, o) {
    return new Intl.NumberFormat(a, {
      maximumFractionDigits: 2,
      minimumFractionDigits: o,
      style: "decimal"
    }).format(s);
  }
  function n(s, a, o, i) {
    const r = a ?? 1;
    return t(
      s + s / 100 * r,
      o,
      i
    );
  }
  return {
    currencyFormat: t,
    decimalFormat: e,
    priceWithTax: n
  };
}, Rn = dt.create(), _y = 24, { idle: ky } = Wu(_y * 60 * 60 * 1e3), Ln = N(!1), Wa = N(""), mr = N(0), hr = N(), yt = () => {
  async function t(l) {
    Ln.value = !1, Rn.defaults.baseURL = l.baseUrl, Wa.value = Vd(), localStorage.getItem("designer-locale") !== l.acceptLanguage && (localStorage.removeItem("designer-api-client-cache"), localStorage.setItem(
      "designer-locale",
      l.acceptLanguage
    )), Rn.defaults.headers.common = {
      Accept: "application/json",
      "Accept-Language": l.acceptLanguage,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "X-Api-Version": l.apiVersion ?? "2024-07-15",
      "X-App-User": l.user_external_identifier,
      "X-Tab-Session-Id": Wa.value
    };
    try {
      if (await n(l))
        return;
      await s(l.token);
    } catch (u) {
      throw Ln.value = !0, new Mu(u);
    }
  }
  async function e(l) {
    try {
      await s(l);
    } catch (u) {
      throw Ln.value = !0, new Mu(u);
    }
    Ln.value = !1;
  }
  async function n(l) {
    if (!l.user_external_identifier)
      return !1;
    Rn.defaults.headers.common["X-Designer-Token"] = l.token;
    try {
      const u = await fr().endpoints.auth.login({
        designer_token: l.token,
        external_identifier: l.user_external_identifier
      });
      i(u);
    } catch {
      return !1;
    }
    return delete Rn.defaults.headers.common["X-Designer-Token"], !0;
  }
  async function s(l) {
    Rn.defaults.headers.common.Authorization = `Bearer ${l}`, delete Rn.defaults.headers.common["X-Designer-Token"], i(await fr().endpoints.auth.token.refresh());
  }
  function a(l) {
    const u = l * 1e3, m = 60 * 1e3, h = u - m - Date.now();
    setTimeout(o, h);
  }
  async function o() {
    if (ky.value) {
      Ln.value = !0;
      return;
    }
    try {
      i(await fr().endpoints.auth.token.refresh());
    } catch {
      Ln.value = !0;
    }
  }
  function i(l) {
    hr.value = l, Rn.defaults.headers.common.Authorization = `Bearer ${l.token_string}`, a(l.expire_date), mr.value = l.user_id;
  }
  function r() {
    hr.value = void 0, mr.value = 0, Wa.value = "", Ln.value = !1;
  }
  return {
    axiosInstance: Rn,
    init: t,
    isDesignerSessionExpired: Ln,
    renewToken: e,
    resetGlobals: r,
    tokenData: Un(hr),
    userId: Un(mr),
    xTabSessionId: Un(Wa)
  };
}, yy = () => {
  const { axiosInstance: t } = yt();
  async function e(n) {
    return (await t.post("auth/login", n)).data;
  }
  return {
    login: e
  };
}, by = 3, pr = N(0), wy = () => {
  const { axiosInstance: t } = yt();
  async function e() {
    try {
      const n = (
        // eslint-disable-next-line unicorn/no-await-expression-member -- fix next time
        (await t.post("auth/token/refresh", {})).data
      );
      return pr.value = 0, n;
    } catch (n) {
      if (pr.value < by)
        return pr.value += 1, e();
      throw n;
    }
  }
  return {
    refresh: e
  };
}, xy = () => ({
  token: {
    ...wy()
  },
  ...yy()
}), wn = () => vy(
  yt().axiosInstance,
  "designer-api-client-cache",
  {
    excludedHeadersForCacheKey: ["X-Tab-Session-Id", "Authorization"]
  }
), $y = () => {
  const { get: t } = wn();
  async function e() {
    return (await t("colors?per_page=100")).data;
  }
  return { list: e };
}, Sy = () => ({
  ...$y()
}), Ay = () => {
  const { get: t } = wn();
  async function e(n) {
    return (
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, unicorn/no-await-expression-member -- fix next time, fix next time
      (await t(`products/${n}/color-variants`)).data
    );
  }
  return { listByProductId: e };
}, Cy = () => ({
  ...Ay()
}), Py = () => {
  const { get: t } = wn();
  async function e() {
    return (await t("configurations")).data;
  }
  async function n() {
    return (await t("configurations/app")).data;
  }
  async function s() {
    return (await t("configurations/designer")).data;
  }
  return {
    get: e,
    getForApp: n,
    getForDesigner: s
  };
}, Iy = () => ({
  ...Py()
}), My = () => {
  const { axiosInstance: t } = yt();
  async function e(s) {
    return (await t.get("customer-logos", {
      params: s
    })).data;
  }
  async function n() {
    return (await t.get(
      "customer-logos/count"
    )).data;
  }
  return {
    count: n,
    list: e
  };
}, Ty = () => {
  const { axiosInstance: t } = yt();
  async function e(n) {
    return (await t.patch(
      `customer-logos/${n.id.toString()}`,
      {
        ...n,
        id: void 0
      }
    )).data;
  }
  return {
    update: e
  };
}, zy = () => ({
  ...My(),
  ...Ty()
}), Ey = () => {
  const { axiosInstance: t } = yt();
  async function e(n) {
    return (await t.post(
      "designs/preview",
      n
    )).data;
  }
  return {
    fetchPreview: e
  };
}, Oy = () => {
  const { axiosInstance: t } = yt();
  async function e(r) {
    return (await t.post(
      "designs/favored",
      r
    )).data;
  }
  async function n(r) {
    return (await t.get(
      `designs/favored/${r.toString()}`
    )).data;
  }
  async function s(r) {
    return (await t.get("designs/favored", {
      params: r
    })).data;
  }
  async function a() {
    return (await t.get(
      "designs/favored/count"
    )).data;
  }
  async function o(r) {
    return (await t.patch(
      `designs/favored/${r.id.toString()}`,
      {
        ...r,
        id: void 0
      }
    )).data;
  }
  async function i(r) {
    await t.delete(
      `designs/favored/${r.toString()}`
    );
  }
  return {
    count: a,
    create: e,
    delete: i,
    getById: n,
    list: s,
    update: o
  };
}, Ry = () => ({
  ...Ey(),
  favored: Oy()
}), Ly = () => {
  const { get: t } = wn();
  async function e() {
    return (await t("fonts?per_page=100")).data;
  }
  return { list: e };
}, Dy = () => ({
  ...Ly()
}), Ny = () => {
  const { axiosInstance: t } = yt();
  async function e(a) {
    return (await t.get(`logos/${a}`)).data;
  }
  async function n(a) {
    return (await t.get("logos", {
      params: a
    })).data;
  }
  async function s() {
    return (await t.get(
      "logos/count"
    )).data.count;
  }
  return {
    count: s,
    get: e,
    list: n
  };
}, Vy = () => ({
  ...Ny()
}), Uy = () => {
  const { axiosInstance: t } = yt();
  async function e(n) {
    return (await t.post(
      "prices",
      n
    )).data;
  }
  return { getByItems: e };
}, Fy = () => ({
  ...Uy()
}), jy = () => {
  const { get: t } = wn();
  async function e() {
    return (await t("production-methods")).data;
  }
  return { list: e };
}, By = () => ({
  ...jy()
}), qy = () => {
  const { get: t } = wn();
  async function e(n, s) {
    return (await t("products", {
      params: {
        page: n,
        per_page: s
      }
    })).data;
  }
  return { list: e };
}, Hy = () => ({
  ...qy()
}), Wy = () => {
  const t = wn();
  async function e() {
    return (await t.get("settings")).data;
  }
  return { get: e };
}, Gy = () => ({
  ...Wy()
}), Zy = () => {
  const { axiosInstance: t } = yt();
  async function e(n) {
    return (await t.post(
      "texts/preview",
      n
    )).data;
  }
  return {
    fetchPreview: e
  };
}, Qy = () => {
  const { get: t } = wn();
  async function e(n) {
    return (await t(`texts/${n}`)).data;
  }
  return { getById: e };
}, Xy = () => {
  const { axiosInstance: t } = yt();
  async function e(n) {
    const s = await t.post("texts", n);
    return Number.parseInt(s.headers["x-identifier"]);
  }
  return {
    storeText: e
  };
}, Ky = () => {
  const { axiosInstance: t } = yt();
  async function e(n, s) {
    return await t.put(
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands -- fix next time
      "texts/" + s,
      n
    );
  }
  return { updateText: e };
}, Jy = () => ({
  ...Xy(),
  ...Ky(),
  ...Qy(),
  ...Zy()
}), Yy = () => {
  const { axiosInstance: t } = yt(), { get: e } = wn();
  async function n() {
    try {
      return (await e("users/current")).data;
    } catch {
      return (await t.post("/users", {
        external_identifier: t.defaults.headers.common["X-App-User"]
      })).data;
    }
  }
  return { current: n };
}, eb = () => ({
  ...Yy()
}), tb = () => {
  const { axiosInstance: t } = yt();
  async function e(a, o) {
    const i = await t.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${a}/design-for-pdf-download`,
      o
    );
    return Number.parseInt(i.headers["x-identifier"]);
  }
  async function n(a) {
    const o = await t.get(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${a}/pdf-download`,
      {
        responseType: "arraybuffer"
      }
    );
    return new Blob([o.data], { type: "application/pdf" });
  }
  async function s(a) {
    return (await t.get(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${a}/preview-html`,
      {
        data: {}
      }
    )).data;
  }
  return {
    getHTMLPreviewByVariantId: s,
    getPdfByVariantId: n,
    storeVariantForPdfDownload: e
  };
}, nb = () => {
  const { axiosInstance: t } = yt();
  async function e(n) {
    return await t.delete(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/archived/${n}`,
      { data: {} }
    );
  }
  return {
    deleteVariantByIdFromArchive: e
  };
}, sb = () => {
  const { axiosInstance: t } = yt();
  async function e(s) {
    return (await t.get("favorites/variants", { params: s })).data;
  }
  async function n(s) {
    return (await t.get(
      `favorites/variants/${s.toString()}`
    )).data;
  }
  return {
    getById: n,
    list: e
  };
}, ab = () => {
  const { get: t } = wn();
  async function e(i) {
    return (await t(
      `variants/cached/variant-id/${i.toString()}`
    )).data;
  }
  async function n(i) {
    return i = encodeURIComponent(
      i
    ), (await t(
      `variants/cached/external-identifier/${i}`
    )).data;
  }
  async function s(i) {
    return (await t("variants", {
      params: i
    })).data;
  }
  async function a(i, r) {
    return (await t("variants/archived", {
      params: {
        page: i,
        per_page: r
      }
    })).data;
  }
  async function o(i) {
    return (await t(
      `variants/archived/${i.toString()}`
    )).data;
  }
  return {
    getArchivedById: o,
    getByExternalIdentifier: n,
    getById: e,
    list: s,
    listArchived: a
  };
}, ob = () => {
  const { axiosInstance: t } = yt();
  async function e(s, a) {
    const o = await t.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${s}/archive`,
      a
    );
    return Number.parseInt(o.headers["x-identifier"]);
  }
  async function n(s, a) {
    const o = await t.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${s}/design`,
      a
    );
    return Number.parseInt(o.headers["x-identifier"]);
  }
  return {
    storeVariant: n,
    storeVariantToArchive: e
  };
}, ib = () => ({
  ...ab(),
  ...ob(),
  ...tb(),
  ...nb(),
  favorite: sb()
}), rb = () => {
  const { axiosInstance: t } = yt();
  async function e() {
    return (await t.get(
      "logos/category-tree"
    )).data;
  }
  async function n() {
    return (await t.get("logos/categories")).data;
  }
  return {
    getTree: e,
    list: n
  };
}, lb = () => ({
  ...rb()
}), {
  init: cb,
  isDesignerSessionExpired: ub,
  renewToken: db,
  resetGlobals: mb,
  tokenData: hb,
  userId: pb,
  xTabSessionId: fb
} = yt(), fr = () => ({
  endpoints: {
    auth: xy(),
    colors: Sy(),
    colorVariants: Cy(),
    configurations: Iy(),
    customerLogos: zy(),
    designs: Ry(),
    fonts: Dy(),
    logoCategories: lb(),
    logos: Vy(),
    prices: Fy(),
    productionMethods: By(),
    products: Hy(),
    settings: Gy(),
    texts: Jy(),
    users: eb(),
    variants: ib()
  },
  init: cb,
  isDesignerSessionExpired: ub,
  renewToken: db,
  resetGlobals: mb,
  tokenData: hb,
  userId: pb,
  xTabSessionId: fb
});
class vb extends Error {
  constructor(e) {
    super(), ly(this, "previous"), this.message = this.constructor.name, this.previous = e ?? null;
  }
}
class Mu extends vb {
}
const Ga = dt.create(), vr = N(!1), gb = () => {
  function t(n) {
    vr.value = !1, Ga.defaults.baseURL = n.baseUrl, Ga.defaults.headers.common = {
      Accept: "application/json",
      "Accept-Language": n.acceptLanguage,
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${n.token}`,
      "Content-Type": "application/json"
    }, vr.value = !0;
  }
  function e(n) {
    Ga.defaults.headers.common.Authorization = `Bearer ${n}`;
  }
  return {
    axiosInstance: Ga,
    init: t,
    isInitialized: Un(vr),
    renewToken: e
  };
};
gb();
N(0);
N(null);
const Ut = tt("layout", () => {
  const t = N(), e = N(!0);
  return { rootElement: t, showLayout: e };
}), it = tt("configuration", () => {
  const { data: t, status: e } = kt({
    ...le.configurations.app.get.use(),
    retry: !1,
    staleTime: 1 / 0
  }), { data: n } = kt({
    ...le.configurations.designer.get.use(),
    retry: !1,
    staleTime: 1 / 0
  });
  return { appConfiguration: t, designerConfiguration: n, status: e };
}), Zt = tt("variant", () => {
  const t = N();
  ie(() => {
    sd("variant-id", t.value);
  });
  const e = le.variants.get.use(t), n = le.variants.getByExternalIdentifier.use(
    t
  ), { data: s, fetchStatus: a, status: o, suspense: i } = kt(
    I(
      () => typeof t.value == "number" ? {
        ...e,
        retry: !1,
        staleTime: 1 / 0
      } : {
        ...n,
        enabled: I(
          () => n.enabled.value && typeof t.value == "string"
        ),
        retry: !1,
        staleTime: 1 / 0
      }
    )
  );
  return {
    data: s,
    fetchStatus: a,
    status: o,
    suspense: i,
    variantId: t
  };
}), Qt = tt("view", () => {
  const { data: t } = D(Zt()), e = N([]), n = N(0);
  return ie(() => {
    t.value && (e.value = t.value.views.map((s) => wl(s)), n.value = 0);
  }), {
    data: e,
    selectedViewIndex: n
  };
});
function _b(t, e) {
  const n = /* @__PURE__ */ new Set();
  for (const s of t)
    e.has(s) && n.add(s);
  return n;
}
const Ze = tt("productionMethod", () => {
  const t = N(), { data: e } = D(Qt()), { data: n } = D(Zt()), s = I(() => {
    if (n.value)
      return new Set(
        e.value.flatMap(
          (l) => l.positioningAreas.filter(
            (u) => u.designs.length > 0
          ).map((u) => u.productionMethodId)
        )
      );
  }), a = I(() => {
    if (n.value)
      return new Set(
        e.value.flatMap(
          (l) => l.positioningAreas.map(
            (u) => u.productionMethodId
          )
        )
      );
  }), { appConfiguration: o } = D(it()), i = I(() => {
    if (o.value !== void 0)
      return new Set(
        o.value.productionMethods.map((l) => l.id).sort(
          (l, u) => l - u
        )
      );
  }), r = I(() => {
    if (i.value !== void 0 && a.value !== void 0)
      return _b(
        a.value,
        i.value
      );
  });
  return ie(() => {
    r.value !== void 0 && (t.value !== void 0 && r.value.has(
      t.value
    ) || s.value !== void 0 && (t.value = s.value.values().next().value, t.value !== void 0) || (t.value = r.value.values().next().value));
  }), {
    activatedProductionMethodIds: i,
    availableProductionMethodIds: r,
    designsProductionMethodIds: s,
    selectedProductionMethodId: t
  };
}), kb = {
  key: 0,
  class: "smake:pointer-events-auto smake:flex smake:min-h-14 smake:w-full smake:max-w-md smake:flex-col smake:overflow-hidden smake:rounded-lg smake:border smake:border-secondary-2 smake:bg-secondary-3 smake:data-[swipe=cancel]:translate-y-0 smake:data-[swipe=cancel]:duration-200 smake:data-[swipe=end]:hidden smake:data-[swipe=move]:translate-y-(--radix-toast-swipe-move-y)"
}, yb = { class: "smake:flex smake:grow smake:items-center smake:justify-between smake:gap-2 smake:p-2" }, bb = { class: "smake:flex smake:grow smake:justify-center" }, wb = { key: 0 }, Zm = /* @__PURE__ */ K({
  __name: "Toast",
  props: /* @__PURE__ */ Ne({
    type: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = t, { type: s } = Ae(n), a = e, o = je(t, "open");
    o.value || a("closed");
    const i = {
      error: {
        class: "smake:text-danger",
        icon: ["fak", "icon-ciconfig-alert-warning"]
      },
      info: {
        class: "smake:text-info",
        icon: ["fak", "icon-ciconfig-alert-warning"]
      },
      success: {
        class: "smake:text-success",
        icon: ["fak", "icon-ciconfig-alert-check"]
      }
    }, r = I(() => i[s.value]), l = I(() => s.value === "success" ? 3e3 : -1);
    function u(m) {
      s.value === "error" && m.stopImmediatePropagation();
    }
    return (m, h) => {
      const v = xe("FontAwesomeIcon");
      return $(), Z(c(Pf), {
        open: o.value,
        "onUpdate:open": h[2] || (h[2] = (_) => o.value = _),
        duration: l.value,
        "as-child": "",
        onPointerdown: os(u, ["left"])
      }, {
        default: P(({ remaining: _ }) => [
          b(De, {
            "enter-active-class": "smake:motion-preset-rebound-down smake:motion-duration-75",
            "leave-active-class": "smake:duration-300",
            "leave-to-class": "smake:opacity-0",
            appear: "",
            onAfterLeave: h[1] || (h[1] = (y) => a("closed"))
          }, {
            default: P(() => [
              o.value ? ($(), O("li", kb, [
                x("div", yb, [
                  b(v, wo({ class: "smake:h-5" }, r.value, { "fixed-width": "" }), null, 16),
                  x("div", bb, [
                    Nt(m.$slots, "default")
                  ]),
                  c(s) === "info" ? ($(), O("button", {
                    key: 0,
                    type: "button",
                    onClick: h[0] || (h[0] = (y) => o.value = !1)
                  }, [
                    b(v, {
                      icon: ["fak", "icon-x"],
                      "fixed-width": "",
                      class: "smake:h-3.5 smake:text-secondary-1"
                    })
                  ])) : X("", !0)
                ]),
                c(s) === "success" ? ($(), O("div", wb, [
                  x("div", {
                    class: "smake:h-0.5 smake:bg-success",
                    style: Wt(`width: ${_ / l.value * 100}%;`)
                  }, null, 4)
                ])) : X("", !0)
              ])) : X("", !0)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 3
      }, 8, ["open", "duration"]);
    };
  }
}), fs = /* @__PURE__ */ K({
  __name: "TextToast",
  props: /* @__PURE__ */ Ne({
    text: {},
    type: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open");
    return (a, o) => ($(), Z(Zm, {
      open: s.value,
      "onUpdate:open": o[0] || (o[0] = (i) => s.value = i),
      type: a.type,
      onClosed: o[1] || (o[1] = (i) => n("closed"))
    }, {
      default: P(() => [
        ce(L(a.text), 1)
      ]),
      _: 1
    }, 8, ["open", "type"]));
  }
}), Qm = tt("toast", () => ({
  toasts: N([])
}));
function Ia() {
  const { toasts: t } = D(Qm()), e = N([]);
  function n(a, ...[o]) {
    const { id: i, input: r = {}, removeOnUnmount: l = !0 } = o ?? {};
    let u = i ? t.value.find((m) => m.id === i) : void 0;
    return u ? () => {
      u.open = !1;
    } : (u = qu({
      id: i,
      component: Fn(a),
      input: r,
      open: !0
    }), t.value.push(u), l && e.value.push(u), () => {
      u.open = !1;
    });
  }
  function s(a) {
    const o = t.value.find((i) => i.id === a);
    o && (o.open = !1);
  }
  return Bn() && Xr(() => {
    for (const a of e.value)
      a.open = !1;
  }), {
    close: s,
    open: n
  };
}
function xb(t) {
  const { data: e } = D(Zt());
  return I(
    () => {
      var s;
      return (s = e.value) == null ? void 0 : s.views.flatMap((a) => a.positioning_areas).find(
        (a) => a.id === t.value
      );
    }
  );
}
function $b(t) {
  const e = xb(t), n = I(() => {
    var l;
    return (l = e.value) == null ? void 0 : l.annotations;
  }), { close: s, open: a } = Ia(), o = N([]);
  ht(n, () => {
    r(), i();
  });
  function i() {
    if (n.value)
      for (const l of n.value) {
        const u = Symbol(
          `annotation-${l.id.toString()}`
        );
        o.value.push(u), a(fs, {
          id: u,
          input: {
            text: l.description,
            type: "info"
          },
          removeOnUnmount: !0
        });
      }
  }
  function r() {
    for (const l of o.value)
      s(l);
    o.value = [];
  }
}
const xn = tt("designer", () => {
  const t = N(), e = N(), n = N(1), s = I({
    get: () => n.value,
    set: (r) => {
      var l;
      (l = t.value) == null || l.setZoom(r);
    }
  }), a = N(!1), o = N(), i = N(!1);
  return {
    designerCore: t,
    hidePositioningAreas: a,
    highlightEmptyPositioningAreas: i,
    readOnlyZoom: n,
    selectedPositioningAreaDesign: o,
    stage: e,
    zoom: s
  };
}), an = tt("designEditDialog", () => {
  const { designerCore: t } = D(xn()), { data: e, selectedViewIndex: n } = D(Qt()), { showLayout: s } = D(Ut()), a = N(!1), o = N(), i = N(), r = N();
  $b(I(() => {
    var _;
    return (_ = o.value) == null ? void 0 : _.id;
  }));
  const l = I({
    get: () => !!o.value && !a.value,
    set: (_) => {
      if (_)
        throw new Error(
          "To open the DesignEditDialog the positioningArea needs to be set"
        );
      o.value = void 0, i.value = void 0;
    }
  });
  ie(() => {
    !o.value || !i.value || o.value.designs.includes(i.value) || (i.value = void 0);
  }), ht(
    [o, i],
    ([_, y], [S, f]) => {
      S !== void 0 && (y === f || _ === S) || (r.value = Es(y));
    }
  ), ht(
    i,
    (_, y) => {
      _ || !y || (l.value = !1);
    }
  ), ht([l, o], ([_, y]) => {
    if (s.value = !_, m(), v(), _) {
      u(y);
      return;
    }
    const S = e.value[n.value];
    h(S);
  });
  const { start: u, stop: m } = Zl(
    (_) => {
      var y;
      _ && ((y = t.value) == null || y.setPosition(
        Ro(_)
      ));
    },
    10
  ), { start: h, stop: v } = Zl(async (_) => {
    var y;
    await bo(), _ && ((y = t.value) == null || y.setPosition({
      height: _.height,
      width: _.width,
      x: 0,
      y: 0
    }));
  }, 50);
  return {
    forceClose: a,
    open: l,
    positioningArea: o,
    positioningAreaDesign: i,
    positioningAreaDesignBackup: r
  };
}), sn = tt("dialog", () => {
  const t = N([]), e = N(!1), n = N();
  function s(a) {
    a.resolve(), t.value = t.value.filter((o) => o !== a);
  }
  return {
    dialogs: t,
    dialogsRoot: n,
    hideAllDialogs: e,
    removeDialog: s
  };
}), gr = Symbol("chooseAPositioningAreaToast"), _r = Symbol(
  "noEmptyPositioningAreaOnCurrentView"
), Gt = tt(
  "selectPositioningArea",
  () => {
    const { close: t, open: e } = Ia(), { t: n } = wt(), { highlightEmptyPositioningAreas: s } = D(xn()), { hideAllDialogs: a } = D(sn()), { forceClose: o } = D(an()), { data: i, selectedViewIndex: r } = D(Qt()), { selectedProductionMethodId: l } = D(
      Ze()
    ), u = I(() => {
      const k = i.value[r.value];
      return k === void 0 ? !1 : k.positioningAreas.some((w) => w.productionMethodId !== l.value ? !1 : w.designs.length === 0);
    }), m = N(!1), {
      cancel: h,
      confirm: v,
      onCancel: _,
      onConfirm: y,
      onReveal: S,
      reveal: f
    } = Vp(m);
    return ie(() => {
      a.value = m.value, o.value = m.value;
    }), S(() => {
      s.value = !0;
    }), ie(() => {
      if (s.value) {
        if (u.value) {
          t(_r), e(fs, {
            id: gr,
            input: {
              text: n("choose_a_positioning_area"),
              type: "info"
            }
          });
          return;
        }
        t(gr), e(fs, {
          id: _r,
          input: {
            text: n("all_positioning_areas_are_occupied"),
            type: "info"
          }
        });
        return;
      }
      t(gr), t(_r);
    }), _(() => {
      s.value = !1;
    }), y(() => {
      s.value = !1;
    }), {
      cancelSelectingPositioningArea: h,
      isSelectingPositioningArea: Un(m),
      selectPositioningArea: v,
      waitForSelectingPositioningArea: f
    };
  }
), js = tt(
  "variantChangeEvent",
  () => {
    const { dialogs: t } = D(sn()), { open: e } = D(
      an()
    ), n = N(!1), s = N(!1), a = N(!1);
    return {
      isADialogOpen: I(
        () => t.value.length > 0 || e.value || n.value || s.value || a.value
      ),
      isFileUploadDialogOpen: a,
      isProductColorChangeDialogOpen: n,
      isVariantsDialogOpen: s
    };
  }
), Ma = tt("props", () => {
  const t = N(), e = N(), n = N(), s = N();
  return {
    availableVariants: t,
    customerLogoUploadInfo: e,
    termsOfServiceLink: n,
    uploadHelpLink: s
  };
});
function Xm(t) {
  return new Promise((e, n) => {
    const s = new Image();
    s.addEventListener("load", () => {
      e(s);
    }), s.addEventListener("error", n), s.crossOrigin = "Anonymous", s.src = t;
  });
}
async function Sb(t) {
  return Promise.all(t.map((e) => Xm(e)));
}
function Ab(t) {
  const e = jt(t);
  return kt({
    enabled: I(() => !!e.value),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => Xm(e.value),
    queryKey: ["image", e],
    retry: !1,
    staleTime: 1 / 0
  });
}
const Cb = ["src", "data-state"], Pb = ["data-state"], ln = /* @__PURE__ */ K({
  __name: "Image",
  props: {
    src: {}
  },
  setup(t) {
    const e = t, { src: n } = Ae(e), { status: s } = Ab(n);
    return (a, o) => ($(), Z(De, {
      "enter-active-class": "smake:duration-300 smake:ease-out",
      "enter-from-class": "smake:opacity-0",
      "leave-active-class": "smake:hidden"
    }, {
      default: P(() => [
        c(s) === "success" ? ($(), O("img", {
          key: 0,
          src: c(n),
          "data-state": c(s)
        }, null, 8, Cb)) : ($(), O("div", {
          key: 1,
          "data-state": c(s)
        }, null, 8, Pb))
      ]),
      _: 1
    }));
  }
}), Ib = { class: "smake:absolute smake:inset-y-0 smake:right-0 smake:flex smake:w-[480px] smake:max-w-full smake:flex-col smake:overflow-y-auto smake:bg-secondary-3 smake:p-10 smake:shadow-[0_0_15px_0_rgba(0,0,0,.25)]" }, Mb = { class: "smake:grid smake:grid-cols-auto-fill-14 smake:gap-4" }, Tb = ["disabled", "onClick"], zb = /* @__PURE__ */ K({
  __name: "ChangeProductColorDialogContent",
  emits: ["close"],
  setup(t, { emit: e }) {
    const n = e, s = Zt(), { data: a, fetchStatus: o, variantId: i } = D(s), { data: r } = D(Qt()), { availableVariants: l } = D(Ma()), u = I(() => {
      var f;
      return (f = a.value) == null ? void 0 : f.product_id;
    }), m = le.products.colorVariants.list.use(
      u
    ), { data: h, isPending: v } = kt({
      ...m,
      enabled: I(
        () => m.enabled.value && !!u.value
      ),
      retry: !1,
      staleTime: 1 / 0
    }), _ = I(
      () => {
        var f;
        return l.value ? (f = h.value) == null ? void 0 : f.filter(
          ({ size_variants: k }) => k.some(
            ({ id: w, external_identifier: C }) => (
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              l.value.some(
                (M) => typeof M == "number" ? M === w : M === C
              )
            )
          )
        ) : h.value;
      }
    ), y = I(() => {
      var k, w, C;
      const f = (w = (k = a.value) == null ? void 0 : k.attributes.find(
        (M) => M.name === "color"
      )) == null ? void 0 : w.handle;
      return (C = _.value) == null ? void 0 : C.find(
        ({ color_handle: M }) => M === f
      );
    });
    async function S(f) {
      var w;
      if (f === ((w = a.value) == null ? void 0 : w.base.id)) {
        n("close");
        return;
      }
      const k = r.value;
      i.value = f, await s.suspense();
      for (const C of r.value)
        for (const M of C.positioningAreas)
          M.id && M.designs.push(
            ...k.flatMap(
              (T) => T.positioningAreas.filter(({ id: E }) => E === M.id).flatMap(({ designs: E }) => E)
            )
          );
      n("close");
    }
    return (f, k) => ($(), O("div", Ib, [
      b(c(Tt), { class: "smake:mb-10 smake:text-lg smake:font-semibold smake:uppercase" }, {
        default: P(() => [
          ce(L(f.$t("product_colors")), 1)
        ]),
        _: 1
      }),
      x("div", Mb, [
        c(v) ? ($(), O(re, { key: 0 }, $e(14, (w) => x("div", {
          key: w,
          class: "smake:flex smake:animate-pulse smake:flex-col smake:items-center smake:gap-2"
        }, k[0] || (k[0] = [
          x("div", { class: "smake:rounded-full smake:border smake:border-transparent smake:p-1" }, [
            x("div", { class: "smake:size-12 smake:rounded-full smake:bg-secondary-2" })
          ], -1),
          x("div", { class: "smake:h-3 smake:w-10 smake:rounded smake:bg-secondary-2" }, null, -1)
        ]))), 64)) : X("", !0),
        ($(!0), O(re, null, $e(_.value, (w) => ($(), O("button", {
          key: w.color_handle,
          class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:grayscale-[80%]",
          disabled: c(o) === "fetching",
          onClick: (C) => S(w.size_variants[0].id)
        }, [
          x("div", {
            class: Se([
              "smake:rounded-full smake:border smake:p-1",
              w === y.value ? "smake:border-black" : "smake:border-transparent"
            ])
          }, [
            b(ln, {
              src: w.color_preview_url,
              class: "smake:size-12 smake:rounded-full smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
            }, null, 8, ["src"])
          ], 2),
          x("div", null, L(w.color_name), 1)
        ], 8, Tb))), 128))
      ])
    ]));
  }
}), Eb = { class: "smake:text-xs" }, Tu = /* @__PURE__ */ K({
  __name: "ChangeProductColor",
  setup(t) {
    const { rootElement: e } = D(Ut()), { fetchStatus: n } = D(Zt()), { isSelectingPositioningArea: s } = D(
      Gt()
    ), { isProductColorChangeDialogOpen: a } = D(
      js()
    ), { selectedProductionMethodId: o } = D(Ze());
    function i(r) {
      n.value === "fetching" && r.preventDefault();
    }
    return (r, l) => ($(), Z(c(zt), {
      open: c(a),
      "onUpdate:open": l[1] || (l[1] = (u) => _t(a) ? a.value = u : null)
    }, {
      default: P(() => [
        b(c(ad), {
          type: "button",
          "data-testid": "ChangeProductColor",
          class: "smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
          disabled: c(s) || c(o) === void 0
        }, {
          default: P(() => [
            l[2] || (l[2] = x("div", { class: "smake:size-16 smake:rounded-full smake:bg-[conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]" }, null, -1)),
            x("div", Eb, L(r.$t("product_colors")), 1)
          ]),
          _: 1,
          __: [2]
        }, 8, ["disabled"]),
        b(c(Et), { to: c(e) }, {
          default: P(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0"
            }, {
              default: P(() => [
                b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:right-[-480px]",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:right-[-480px]"
            }, {
              default: P(() => [
                b(c(Rt), {
                  "as-child": "",
                  onInteractOutside: i,
                  onEscapeKeyDown: i
                }, {
                  default: P(() => [
                    b(zb, {
                      onClose: l[0] || (l[0] = (u) => a.value = !1)
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
});
function Wo() {
  const { data: t } = D(Qt()), { data: e } = D(Zt());
  return I(() => t.value.filter(
    (s) => s.positioningAreas.some(
      (a) => a.designs.length > 0
    ) && !!s.handle
  ).map((s) => {
    var i;
    const a = (i = e.value) == null ? void 0 : i.views.find(
      (r) => r.handle === s.handle
    ), o = (a == null ? void 0 : a.scalefactor) ?? 1;
    return dk(s, o);
  }));
}
const Km = tt("saveAndContinue", () => {
  const t = Wo(), { data: e } = D(Zt()), n = I(() => !!s.value), s = I(
    () => {
      if (e.value && t.value.length !== 0)
        return {
          baseId: e.value.id,
          views: t.value
        };
    }
  ), a = N(), { isPending: o, mutate: i } = tn({
    ...le.variants.post.use(),
    onSuccess(m) {
      a.value = m;
    }
  }), r = I(
    () => o.value || a.value
  );
  function l() {
    s.value && i(s.value);
  }
  const u = N();
  return gm(
    "customVariant.customizations.completed",
    ({ id: m }) => {
      a.value === m && e.value && u.value && u.value({
        id: m,
        base: {
          id: e.value.base.id,
          external_identifier: e.value.base.external_identifier
        },
        external_identifier: e.value.external_identifier
      });
    }
  ), {
    canSaveAndContinue: n,
    isPending: r,
    onContinue: u,
    saveAndContinue: l
  };
}), Jm = sv({ prefix: "smake" }), ye = /* @__PURE__ */ K({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    type: {}
  },
  setup(t) {
    return (e, n) => ($(), O("button", wo({ ...e.$attrs, class: void 0 }, {
      type: "button",
      class: c(Jm)(
        "smake:flex smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:p-2 smake:text-[14px] smake:duration-150 smake:disabled:opacity-50",
        e.type === "outline" && "smake:border smake:border-secondary-2 smake:bg-white smake:enabled:hover:border-black",
        e.type === "primary" && "smake:bg-primary-1 smake:text-white smake:enabled:hover:bg-primary-2",
        e.type === "secondary" && "smake:bg-secondary-3 smake:enabled:hover:bg-secondary-2",
        e.type === "white" && "smake:bg-white smake:enabled:hover:bg-secondary-2",
        e.$attrs.class
      )
    }), [
      Nt(e.$slots, "default")
    ], 16));
  }
}), Ob = { key: 0 }, Rb = /* @__PURE__ */ K({
  __name: "Continue",
  setup(t) {
    const e = Km(), { saveAndContinue: n } = e, { canSaveAndContinue: s, isPending: a } = D(e);
    return (o, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), Z(ye, {
        class: "smake:px-8 smake:py-4",
        "data-testid": "Continue",
        type: c(s) && !c(a) ? "primary" : "outline",
        disabled: !c(s) || c(a),
        onClick: i[0] || (i[0] = (l) => c(n)())
      }, {
        default: P(() => [
          c(a) ? ($(), Z(r, {
            key: 1,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), O("div", Ob, L(o.$t("continue")), 1))
        ]),
        _: 1
      }, 8, ["type", "disabled"]);
    };
  }
});
function Bs() {
  const { dialogs: t } = D(sn()), e = N([]);
  function n(s, ...[a = {}]) {
    const { promise: o, resolve: i } = Promise.withResolvers(), r = qu({
      component: Fn(s),
      input: a,
      open: !0,
      resolve: i
    });
    return t.value.push(r), e.value.push(r), o;
  }
  return Bn() && Xr(() => {
    for (const s of e.value)
      s.open = !1;
  }), { open: n };
}
function Ym() {
  const { data: t } = D(Zt());
  return (e) => {
    if (t.value) {
      for (const n of t.value.views)
        for (const s of n.positioning_areas)
          if (s.id === e)
            return s;
    }
  };
}
function ss(t) {
  return t === $s.Italic || t === $s.BoldItalic || t === $s.BlackItalic || t === $s.DemiBoldItalic;
}
function eh(t, e) {
  const { appConfiguration: n } = D(it()), { selectedProductionMethodId: s } = D(
    Ze()
  ), { isLight: a } = $a(e, t);
  function o() {
    var h;
    const l = ((h = n.value) == null ? void 0 : h.colors.filter(
      ({ production_methods: v }) => v.some(
        ({ id: _ }) => _ === s.value
      )
    )) ?? [];
    let u, m = a.value ? 1 / 0 : -1 / 0;
    for (const v of l) {
      const _ = vm([
        v.red,
        v.green,
        v.blue
      ]);
      a.value ? m > _ && (m = _, u = v) : m < _ && (m = _, u = v);
    }
    if (!u) throw new Error("No color found");
    return u;
  }
  function i() {
    var u;
    const l = (u = n.value) == null ? void 0 : u.fonts.filter(
      ({ production_methods: m, style: h }) => !ss(h) && m.some(
        ({ id: v }) => v === s.value
      )
    ).sort((m, h) => m.family_name < h.family_name ? -1 : m.family_name > h.family_name ? 1 : 0)[0];
    if (!l) throw new Error("No font found");
    return l;
  }
  function r() {
    return {
      bendingRadius: 0,
      color: { id: o().id },
      fontId: i().id,
      horizontalAlignment: is.LEFT,
      offsetLeft: 0,
      paddingBottom: 2,
      size: 10,
      text: ""
    };
  }
  return r;
}
const Il = {
  dtf: ["fak", "icon-easytransfer"],
  embroidery: ["fak", "icon-direkteinstickung"]
}, Lb = {
  dtf: "production_method_summary_dtf",
  embroidery: "production_method_summary_embroidery"
};
function xt(t) {
  const e = Zu(t), { t: n } = wt(), { availableProductionMethodIds: s, selectedProductionMethodId: a } = D(Ze()), o = I(() => a.value === e.value), i = I(() => s.value === void 0 || e.value === void 0 ? !1 : s.value.has(
    e.value
  )), { appConfiguration: r, designerConfiguration: l } = D(
    it()
  ), u = I(() => {
    var f;
    return (f = r.value) == null ? void 0 : f.productionMethods.find(
      ({ id: k }) => k === e.value
    );
  }), m = I(() => {
    var f, k;
    return (k = (f = l.value) == null ? void 0 : f.settings.production_methods) == null ? void 0 : k.find(
      ({ id: w }) => w === e.value
    );
  }), h = I(() => {
    if (!u.value) return;
    const f = Lb[u.value.handle];
    if (f)
      return n(f);
  }), v = I(() => {
    if (u.value)
      return Il[u.value.handle];
  }), _ = I(
    () => {
      var f;
      return !!((f = m.value) != null && f.customer_upload);
    }
  ), y = I(
    () => {
      var f, k;
      return (k = (f = m.value) == null ? void 0 : f.customer_upload) == null ? void 0 : k.allowed_logo_file_types;
    }
  ), S = I(
    () => {
      var f, k;
      return (k = (f = m.value) == null ? void 0 : f.customer_upload) == null ? void 0 : k.max_file_size_mb;
    }
  );
  return {
    allowedExtensions: y,
    icon: v,
    isAvailableOnCurrentVariant: i,
    isCustomerLogoUploadEnabled: _,
    isSelected: o,
    maxFileSizeMb: S,
    productionMethod: u,
    shortDescription: h
  };
}
var At = /* @__PURE__ */ ((t) => (t.CUSTOMER_LOGO_UPLOAD = "featureFlagCustomerLogoUpload", t))(At || {});
const Db = ["disabled"], Nb = { class: "smake:grow smake:text-left smake:font-semibold" }, eo = /* @__PURE__ */ K({
  __name: "AddComponentButton",
  props: {
    icon: {},
    loading: { type: Boolean },
    primary: { type: Boolean },
    text: {}
  },
  setup(t) {
    return (e, n) => {
      const s = xe("FontAwesomeIcon");
      return $(), O("button", {
        class: Se(["smake:group smake:flex smake:min-h-30 smake:items-center smake:justify-between smake:gap-6 smake:rounded-2xl smake:border smake:border-secondary-2 smake:px-8 smake:py-4 smake:duration-100 smake:enabled:hover:bg-secondary-3", { "smake:animate-pulse smake:bg-secondary-3": e.loading }]),
        disabled: e.loading,
        type: "button"
      }, [
        e.loading ? X("", !0) : ($(), O(re, { key: 0 }, [
          x("div", {
            class: Se(["smake:flex smake:items-center smake:justify-center smake:rounded-full smake:p-[15px]", {
              "smake:bg-primary-1 smake:text-white": e.primary,
              "smake:bg-secondary-3 smake:text-black smake:group-hover:bg-white/70": !e.primary
            }])
          }, [
            b(s, {
              icon: e.icon,
              "fixed-width": "",
              class: "smake:size-[20px]"
            }, null, 8, ["icon"])
          ], 2),
          x("div", Nb, L(e.text), 1),
          x("div", null, [
            b(s, {
              class: "smake:h-[16px]",
              icon: ["fal", "plus"]
            })
          ])
        ], 64))
      ], 10, Db);
    };
  }
});
function Vb(t, e) {
  const { t: n } = wt(), s = jt(e), a = jt(t), o = I(() => {
    if (a.value instanceof zr)
      return a.value;
  }), i = I(() => {
    if (a.value instanceof jn)
      return a.value;
  }), r = I(() => {
    var v;
    if (((v = i.value) == null ? void 0 : v.response.status) === 422)
      return i.value;
  }), { data: l } = kt({
    enabled: I(() => !!r.value),
    queryFn: () => {
      var v;
      return (v = r.value) == null ? void 0 : v.response.json();
    },
    queryKey: [r]
  }), u = I(() => {
    var v;
    if (a.value)
      return o.value ? o.value.message : r.value ? (v = l.value) == null ? void 0 : v.message : s.value ?? n("boot_error.unexpected");
  }), m = I(() => {
    var v;
    return (v = l.value) == null ? void 0 : v.errors;
  }), h = I(() => {
    var v;
    return (v = i.value) == null ? void 0 : v.response.status;
  });
  return {
    fieldMessages: m,
    message: u,
    statusCode: h
  };
}
const Ub = /* @__PURE__ */ K({
  __name: "PositioningArea",
  props: {
    activeProductionMethodId: {},
    data: {}
  },
  setup(t) {
    const e = t, { activeProductionMethodId: n, data: s } = Ae(e), { isLight: a } = $a(s), o = I(() => [1, 1, 1, 0.5]), i = I(() => {
      if (r.value)
        return o.value;
    }), r = I(() => s.value.designs.length === 0);
    return (l, u) => ($(), Z(c(To), {
      data: c(s),
      hidden: c(s).productionMethodId !== c(n),
      "stroke-color": c(a) ? 4605510 : 14474460,
      "fill-color": i.value
    }, {
      default: P(() => [
        ($(!0), O(re, null, $e(c(s).designs, (m) => ($(), Z(c(zo), {
          key: c(He)(m),
          data: m,
          "production-method-id": c(s).productionMethodId
        }, null, 8, ["data", "production-method-id"]))), 128))
      ]),
      _: 1
    }, 8, ["data", "hidden", "stroke-color", "fill-color"]));
  }
}), Fb = { class: "smake:relative" }, jb = /* @__PURE__ */ K({
  __name: "ProductionMethodViewsPreview",
  props: /* @__PURE__ */ Ne({
    productionMethodId: {}
  }, {
    selectedViewIndex: {
      required: !0
    },
    selectedViewIndexModifiers: {}
  }),
  emits: ["update:selectedViewIndex"],
  setup(t) {
    const { data: e } = D(Qt()), n = je(t, "selectedViewIndex");
    function s() {
      n.value = (n.value + 1) % e.value.length;
    }
    function a() {
      n.value = (n.value - 1 + e.value.length) % e.value.length;
    }
    return (o, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), O("div", Fb, [
        b(c(Mo), { class: "smake:size-full" }, {
          default: P(() => [
            ($(!0), O(re, null, $e(c(e), (l, u) => ($(), Z(c(Eo), {
              key: c(He)(l),
              data: l,
              hidden: u !== n.value
            }, {
              default: P(() => [
                ($(!0), O(re, null, $e(l.positioningAreas, (m) => ($(), Z(Ub, {
                  key: c(He)(m),
                  data: m,
                  "active-production-method-id": o.productionMethodId
                }, null, 8, ["data", "active-production-method-id"]))), 128))
              ]),
              _: 2
            }, 1032, ["data", "hidden"]))), 128))
          ]),
          _: 1
        }),
        b(ye, {
          type: "secondary",
          class: "smake:absolute smake:top-1/2 smake:left-0 smake:size-12 smake:translate-x-1/2 smake:-translate-y-1/2",
          onClick: a
        }, {
          default: P(() => [
            b(r, {
              class: "smake:size-full",
              icon: ["fal", "chevron-left"]
            })
          ]),
          _: 1
        }),
        b(ye, {
          type: "secondary",
          class: "smake:absolute smake:top-1/2 smake:right-0 smake:size-12 smake:-translate-x-1/2 smake:-translate-y-1/2",
          onClick: s
        }, {
          default: P(() => [
            b(r, {
              class: "smake:size-full",
              icon: ["fal", "chevron-right"]
            })
          ]),
          _: 1
        })
      ]);
    };
  }
}), Bb = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-170 smake:max-w-full smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, qb = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, Hb = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:bg-white" }, Wb = { class: "smake:flex smake:items-center smake:gap-3 smake:rounded-xl smake:border smake:border-secondary-2 smake:p-3" }, Gb = { class: "smake:font-semibold" }, Zb = { class: "smake:leading-6" }, Qb = { class: "smake:font-semibold" }, Xb = { class: "smake:h-full" }, Kb = { class: "smake:flex smake:justify-between smake:gap-5" }, Jb = /* @__PURE__ */ K({
  __name: "ChangeProductionMethodDialouge",
  props: /* @__PURE__ */ Ne({
    targetProductionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open"), a = t, { targetProductionMethodId: o } = Ae(a), { rootElement: i } = D(Ut()), { appConfiguration: r } = D(it()), { selectedProductionMethodId: l } = D(Ze()), u = I(
      () => {
        var S;
        return (S = r.value) == null ? void 0 : S.productionMethods.find(
          (f) => f.id === l.value
        );
      }
    ), m = I(
      () => {
        var S;
        return (S = r.value) == null ? void 0 : S.productionMethods.find(
          (f) => f.id === o.value
        );
      }
    ), h = I(() => {
      if (m.value)
        return Il[m.value.handle];
    }), { selectedViewIndex: v } = D(Qt()), _ = N(v.value);
    function y() {
      v.value = _.value, n("resolve", !0);
    }
    return (S, f) => ($(), Z(c(zt), {
      open: s.value,
      "onUpdate:open": f[2] || (f[2] = (k) => s.value = k)
    }, {
      default: P(() => [
        b(c(Et), { to: c(i) }, {
          default: P(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: f[0] || (f[0] = (k) => n("closed"))
            }, {
              default: P(() => [
                b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-95 smake:opacity-0"
            }, {
              default: P(() => [
                b(c(Rt), { "as-child": "" }, {
                  default: P(() => {
                    var k, w;
                    return [
                      x("div", Bb, [
                        x("div", qb, [
                          b(c(Tt), { class: "smake:flex smake:items-center smake:gap-3 smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: P(() => {
                              var C;
                              return [
                                h.value ? ($(), Z(c(Nn), {
                                  key: 0,
                                  icon: h.value,
                                  "fixed-width": "",
                                  class: "smake:size-6"
                                }, null, 8, ["icon"])) : X("", !0),
                                ce(" " + L((C = m.value) == null ? void 0 : C.display_name) + " " + L(S.$t("icon")), 1)
                              ];
                            }),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(c(Nn), {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", Hb, [
                          x("div", Wb, [
                            b(c(Nn), {
                              icon: ["fal", "circle-exclamation"],
                              "fixed-width": "",
                              class: "smake:size-6"
                            }),
                            x("div", Gb, L(S.$t("change_production_method_info", {
                              fromProductionMethod: (k = u.value) == null ? void 0 : k.display_name
                            })), 1)
                          ]),
                          x("div", Zb, L(S.$t(
                            "to_place_motif_change_production_method",
                            {
                              toProductionMethod: (w = m.value) == null ? void 0 : w.display_name
                            }
                          )), 1),
                          x("div", Qb, L(S.$t(
                            "preview_of_possibile_positioning_areas"
                          )) + ": ", 1),
                          x("div", Xb, [
                            b(jb, {
                              "selected-view-index": _.value,
                              "onUpdate:selectedViewIndex": f[1] || (f[1] = (C) => _.value = C),
                              "production-method-id": c(o)
                            }, null, 8, ["selected-view-index", "production-method-id"])
                          ])
                        ]),
                        x("div", Kb, [
                          b(c(Bt), null, {
                            default: P(() => [
                              b(ye, {
                                class: "smake:grow smake:px-4 smake:py-3",
                                type: "outline"
                              }, {
                                default: P(() => [
                                  ce(L(S.$t("abort")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(c(Bt), null, {
                            default: P(() => [
                              b(ye, {
                                class: "smake:grow smake:px-4 smake:py-3",
                                type: "primary",
                                onClick: y
                              }, {
                                default: P(() => {
                                  var C;
                                  return [
                                    ce(L(S.$t("change_to_x", {
                                      x: (C = m.value) == null ? void 0 : C.display_name
                                    })), 1)
                                  ];
                                }),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
});
function Yb() {
  const t = mt(), e = en(
    (s) => t.fetchQuery({
      ...le.logos.get.use(s),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  async function n(s, a) {
    const o = ko(s), i = ko(a), r = i.find(
      (_) => _.type === be.LOGO
    ), l = i.find(
      (_) => _.type === be.TEXT
    );
    if (a.type === be.ANCHOR) return a;
    const u = o.find(
      (_) => _.type === be.LOGO
    ), m = o.find(
      (_) => _.type === be.TEXT
    ), h = l ?? m, v = r ?? u;
    if (v !== void 0 && h !== void 0) {
      const _ = Es(await e(v.logoId));
      return {
        children: [
          {
            anchor: _.design_settings.next_element_alignment.anchor_value,
            offset: _.design_settings.next_element_alignment.offset,
            value: h
          }
        ],
        parent: v,
        type: be.ANCHOR
      };
    }
    if (h)
      return h;
    if (v)
      return v;
    throw new Error("Design Merge Failed. Invalid data");
  }
  return {
    merge: n
  };
}
function ko(t) {
  return t.type === be.ANCHOR ? [
    ...ko(t.parent),
    ...t.children.flatMap((e) => ko(e.value))
  ] : [t];
}
function qr(t, e, n) {
  return Math.min(Math.max(t, e), n);
}
function ew() {
  const t = mt(), e = en(
    (s) => t.fetchQuery({
      ...le.logos.get.use(s),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  async function n(s, a) {
    const o = await e(s.logoId);
    if (o.width === null || o.height === null || o.min_width === null || o.max_width === null || o.min_height === null || o.max_height === null || o.min_width >= o.max_width || o.min_height >= o.max_height)
      return s;
    const i = Math.min(
      qr(
        Math.min(
          a.width / o.width,
          a.height / o.height
        ),
        Math.max(
          o.min_width / o.width,
          o.min_height / o.height
        ),
        Math.min(
          o.max_width / o.width,
          o.max_height / o.height
        )
      ),
      1
    );
    return s.size = {
      height: o.height * i,
      width: o.width * i
    }, s;
  }
  return {
    resize: n
  };
}
const Go = tt(
  "placeDesignToPositioningArea",
  () => {
    const { waitForSelectingPositioningArea: t } = Gt(), { open: e } = Bs(), {
      positioningArea: n,
      positioningAreaDesign: s
    } = D(an()), { selectedPositioningAreaDesign: a } = D(xn()), { selectedProductionMethodId: o } = D(
      Ze()
    ), { resize: i } = ew(), { merge: r } = Yb(), l = Ym();
    async function u(m, h) {
      var S;
      let v = h == null ? void 0 : h.positioningArea, _ = h == null ? void 0 : h.mergePostioningAreaDesign;
      if (v && v.productionMethodId !== m.productionMethodId && (v = void 0, _ = void 0), !v || m.productionMethodId !== o.value) {
        if (m.productionMethodId !== o.value && !await e(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          Jb,
          {
            targetProductionMethodId: m.productionMethodId
          }
        ))
          return "aborted-production-method-change";
        const f = o.value;
        if (o.value = m.productionMethodId, v = (await t()).data, !v)
          return o.value = f, "aborted-positioning-area-selection";
      }
      n.value = v, _ || (s.value = void 0);
      const y = m.design.type === be.LOGO ? await i(m.design, v) : m.design;
      return _ ? _.design = await r(
        _.design,
        y
      ) : (_ = {
        design: y,
        rotation: ((S = l(v.id)) == null ? void 0 : S.direction) ?? 0
      }, v.designs.push(_), a.value = _), s.value = _, "success";
    }
    return {
      placeDesign: u
    };
  }
), gs = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [s, a] of e)
    n[s] = a;
  return n;
}, tw = {}, nw = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.89 14.34"
};
function sw(t, e) {
  return $(), O("svg", nw, e[0] || (e[0] = [
    Hu('<g id="Ebene_1-2"><g id="Gruppe_32181"><g id="Gruppe_1731"><path fill="currentColor" d="M16.21.23c-.18-.16-.4-.24-.65-.23-.24.01-.46.12-.62.3l-5.87,6.63-2.82-2.82c-.35-.35-.92-.35-1.27,0-.35.35-.35.92,0,1.27l3.5,3.5c.17.17.4.26.64.26h.02s0,0,0,0c.25,0,.48-.12.65-.3l6.51-7.34c.33-.37.3-.94-.08-1.27Z"></path><path id="Pfad_1400" fill="currentColor" d="M18,7.65c-.49,0-.88.39-.88.88v3.15c0,.5-.42.9-.92.9H2.67c-.5,0-.9-.4-.91-.9v-3.15c0-.49-.39-.88-.88-.88s-.88.39-.88.88v3.16c.01,1.47,1.2,2.65,2.66,2.65h13.53c.71.03,1.4-.25,1.89-.77.51-.5.8-1.18.8-1.89v-3.16c0-.49-.39-.88-.88-.88"></path></g></g></g>', 1)
  ]));
}
const aw = /* @__PURE__ */ gs(tw, [["render", sw]]), ow = {}, iw = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26.06 22.13"
};
function rw(t, e) {
  return $(), O("svg", iw, e[0] || (e[0] = [
    x("g", { id: "Ebene_1-2" }, [
      x("path", {
        fill: "currentColor",
        d: "M23.85,3.99h-10.6l-3.33-3.27c-.47-.46-1.09-.72-1.75-.72H2.49C1.12,0,0,1.12,0,2.49v17.43c0,1.21.99,2.2,2.2,2.2h21.65c1.21,0,2.2-.99,2.2-2.2V6.19c0-1.21-.99-2.2-2.2-2.2ZM1.8,2.49c0-.38.31-.69.69-.69h5.69c.18,0,.36.07.49.2l2.02,1.99H1.8v-1.5ZM24.26,19.93c0,.22-.18.4-.4.4H2.2c-.22,0-.4-.18-.4-.4V5.79h22.05c.22,0,.4.18.4.4v13.73Z"
      }),
      x("path", {
        fill: "currentColor",
        d: "M9.92,18.46c-.15,0-.29-.05-.41-.13-.22-.16-.32-.42-.28-.68l.53-3.1-2.25-2.2c-.19-.19-.26-.46-.18-.72.08-.25.3-.44.56-.48l3.11-.45,1.39-2.82c.24-.48,1.02-.48,1.26,0l1.39,2.82,3.11.45c.26.04.48.22.56.48.08.25.01.53-.18.72l-2.25,2.2.53,3.1c.04.26-.06.53-.28.68-.22.16-.5.18-.74.05l-2.79-1.46-2.79,1.46c-.1.05-.21.08-.33.08ZM13.03,15.42c.11,0,.22.03.33.08l1.86.98-.35-2.07c-.04-.23.04-.46.2-.62l1.5-1.46-2.08-.3c-.23-.03-.43-.18-.53-.38l-.93-1.88-.93,1.88c-.1.21-.3.35-.53.38l-2.08.3,1.5,1.46c.17.16.24.39.2.62l-.35,2.07,1.86-.98c.1-.05.21-.08.33-.08Z"
      })
    ], -1)
  ]));
}
const lw = /* @__PURE__ */ gs(ow, [["render", rw]]), cw = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-1 smake:font-semibold" }, uw = {
  key: 0,
  class: "smake:text-xs"
}, dw = /* @__PURE__ */ K({
  __name: "SelectItem",
  props: {
    productionMethodId: {}
  },
  setup(t) {
    const e = t, { productionMethodId: n } = Ae(e), { isAvailableOnCurrentVariant: s, productionMethod: a, shortDescription: o } = xt(n);
    return (i, r) => c(a) ? ($(), Z(c(od), {
      key: 0,
      disabled: !c(s),
      value: c(a).id.toString(),
      class: Se(["smake:flex smake:items-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-1 smake:pr-3 smake:duration-150 smake:enabled:cursor-pointer smake:enabled:hover:border-black smake:data-[state=checked]:border-black smake:data-[state=checked]:bg-black smake:data-[state=checked]:text-white", {
        "smake:text-slate-400 smake:grayscale-[98%]": !c(s)
      }])
    }, {
      default: P(() => [
        b(ln, {
          src: c(a).preview_url,
          class: "smake:size-12 smake:rounded-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
        }, null, 8, ["src"]),
        x("div", cw, [
          b(c(id), null, {
            default: P(() => [
              ce(L(c(a).display_name), 1)
            ]),
            _: 1
          }),
          c(o) ? ($(), O("span", uw, L(c(o)), 1)) : X("", !0)
        ])
      ]),
      _: 1
    }, 8, ["disabled", "value", "class"])) : X("", !0);
  }
}), mw = {
  key: 0,
  class: "smake:rounded-full smake:bg-secondary-3 smake:p-1.5"
}, th = /* @__PURE__ */ K({
  __name: "ProductionMethodSelect",
  props: /* @__PURE__ */ Ne({
    disabled: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), n = t, { disabled: s } = Ae(n), a = I({
      get: () => e.value.toString(),
      set: (u) => {
        e.value = Number.parseInt(u);
      }
    }), { icon: o, productionMethod: i } = xt(e), { rootElement: r } = D(Ut()), { activatedProductionMethodIds: l } = D(
      Ze()
    );
    return (u, m) => {
      const h = xe("FontAwesomeIcon");
      return $(), Z(c(rd), {
        modelValue: a.value,
        "onUpdate:modelValue": m[0] || (m[0] = (v) => a.value = v),
        disabled: c(s)
      }, {
        default: P(() => [
          b(c(ld), { "as-child": "" }, {
            default: P(() => [
              b(ye, {
                type: "outline",
                class: "smake:grow smake:p-1 smake:pr-2 smake:@sm:grow-0"
              }, {
                default: P(() => [
                  c(o) ? ($(), O("div", mw, [
                    b(h, {
                      icon: c(o),
                      "fixed-width": "",
                      class: "smake:size-4.5"
                    }, null, 8, ["icon"])
                  ])) : X("", !0),
                  c(i) ? ($(), Z(c(cd), {
                    key: 1,
                    class: "smake:grow smake:p-1.5"
                  }, {
                    default: P(() => [
                      ce(L(c(i).display_name), 1)
                    ]),
                    _: 1
                  })) : X("", !0),
                  b(c(If), null, {
                    default: P(() => [
                      b(h, {
                        icon: ["fal", "chevron-down"],
                        class: "smake:h-4"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          b(c(ud), { to: c(r) }, {
            default: P(() => [
              b(c(dd), {
                class: "smake:rounded-3xl smake:bg-white smake:p-4 smake:shadow-[0_0_15px_0_rgba(0,0,0,0.25)]",
                position: "popper",
                "side-offset": 8,
                align: "center"
              }, {
                default: P(() => [
                  b(c(md), { class: "smake:flex smake:flex-col smake:gap-2" }, {
                    default: P(() => [
                      ($(!0), O(re, null, $e(c(l), (v) => ($(), Z(dw, {
                        key: v,
                        "production-method-id": v
                      }, null, 8, ["production-method-id"]))), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]);
    };
  }
}), ua = /* @__PURE__ */ K({
  __name: "VariantTabsTrigger",
  props: {
    value: {}
  },
  setup(t) {
    return (e, n) => ($(), Z(c(hd), {
      value: e.value,
      "as-child": ""
    }, {
      default: P(() => [
        b(ye, {
          class: "smake:p-2.5 smake:data-[state=active]:bg-black smake:data-[state=active]:text-white smake:data-[state=active]:hover:bg-black/80 smake:@max-md:grow",
          type: "outline"
        }, {
          default: P(() => [
            Nt(e.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), hw = { class: "smake:absolute smake:inset-x-5 smake:top-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:max-w-[400px] smake:-translate-y-1/2 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-4" }, pw = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, fw = { class: "smake:font-bold smake:text-primary-1" }, vw = { class: "smake:flex smake:flex-col smake:items-center smake:justify-between smake:gap-5" }, gw = {
  key: 0,
  class: "smake:w-full smake:rounded-lg smake:border smake:border-danger smake:p-2 smake:text-danger"
}, _w = { class: "smake:w-full smake:flex-col" }, kw = ["disabled"], yw = {
  key: 0,
  class: "smake:flex smake:flex-col smake:justify-start smake:gap-2 smake:p-1 smake:text-xs smake:font-bold smake:text-danger"
}, bw = { class: "smake:flex smake:w-full smake:flex-col smake:gap-4 smake:@md:flex-row" }, nh = /* @__PURE__ */ K({
  __name: "RenameDialog",
  props: /* @__PURE__ */ Ne({
    name: {},
    error: {},
    image: {},
    mutationStatus: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed", "rename", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open"), a = t, o = a.name, { dialogsRoot: i } = D(sn()), { error: r, mutationStatus: l } = Ae(a), u = I(() => l.value === "pending");
    function m(w) {
      u.value || w.preventDefault();
    }
    const h = N(), v = N(o);
    ie(() => {
      l.value === "success" && (s.value = !1);
    });
    const { t: _ } = wt();
    function y() {
      if (v.value === a.name) {
        s.value = !1;
        return;
      }
      n("rename", v.value);
    }
    const { data: S } = kt({
      enabled: I(() => !!r.value),
      queryFn: () => {
        if (r.value instanceof jn)
          return r.value.response.json();
      },
      queryKey: [r]
    }), f = I(() => {
      if (!(!r.value || r.value instanceof jn && r.value.response.status === 422))
        return _("boot_error.unexpected");
    }), k = I(() => {
      var w;
      if (!(!r.value || !(r.value instanceof jn) || r.value.response.status !== 422))
        return (w = S.value) == null ? void 0 : w.errors.name;
    });
    return (w, C) => {
      const M = xe("I18nT"), T = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: s.value,
        "onUpdate:open": C[3] || (C[3] = (E) => s.value = E)
      }, {
        default: P(() => [
          b(c(Et), { to: c(i) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: C[0] || (C[0] = (E) => n("closed"))
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), {
                    "as-child": "",
                    onInteractOutside: m,
                    onEscapeKeyDown: m
                  }, {
                    default: P(() => [
                      x("div", hw, [
                        x("div", pw, [
                          b(c(Tt), null, {
                            default: P(() => [
                              b(M, {
                                keypath: "do_you_want_to_rename",
                                tag: "span",
                                class: "smake:align-middle"
                              }, {
                                name: P(() => [
                                  x("span", fw, L(c(o)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(T, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", vw, [
                          b(ln, {
                            class: "smake:aspect-square smake:w-80 smake:rounded-3xl smake:bg-secondary-3 smake:object-contain smake:p-4 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2",
                            src: w.image
                          }, null, 8, ["src"]),
                          f.value && !k.value ? ($(), O("div", gw, L(f.value), 1)) : X("", !0),
                          x("div", _w, [
                            ot(x("input", {
                              ref_key: "newNameInput",
                              ref: h,
                              "onUpdate:modelValue": C[1] || (C[1] = (E) => v.value = E),
                              type: "text",
                              maxlength: 60,
                              class: Se([
                                "smake:w-full smake:rounded-md smake:border smake:px-4 smake:py-3 smake:outline-none smake:focus:border-black smake:disabled:cursor-not-allowed smake:disabled:text-secondary-2",
                                k.value ? "border-danger" : "border-secondary-2"
                              ]),
                              placeholder: "Text einfügen",
                              disabled: u.value,
                              onKeydown: Za(y, ["enter"])
                            }, null, 42, kw), [
                              [pn, v.value]
                            ]),
                            k.value ? ($(), O("div", yw, [
                              ($(!0), O(re, null, $e(k.value, (E) => ($(), O("div", { key: E }, L(E), 1))), 128))
                            ])) : X("", !0)
                          ]),
                          x("div", bw, [
                            b(ye, {
                              type: "outline",
                              disabled: u.value,
                              class: "smake:flex-grow",
                              onClick: C[2] || (C[2] = (E) => s.value = !1)
                            }, {
                              default: P(() => [
                                ce(L(w.$t("abort")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            b(ye, {
                              type: "primary",
                              disabled: v.value.length === 0 || u.value,
                              class: "smake:flex smake:flex-grow smake:items-center smake:gap-2",
                              onClick: y
                            }, {
                              default: P(() => [
                                b(T, {
                                  class: "smake:h-5",
                                  icon: ["fal", "save"]
                                }),
                                ce(" " + L(w.$t("save")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), zu = /* @__PURE__ */ K({
  __name: "Tooltip",
  setup(t) {
    return (e, n) => ($(), Z(c(Mf), {
      disabled: e.$slots.tooltip === void 0,
      "delay-duration": 0
    }, {
      default: P(() => [
        b(c(Tf), null, {
          default: P(() => [
            b(c(zf), {
              as: "div",
              class: "smake:cursor-default"
            }, {
              default: P(() => [
                Nt(e.$slots, "default")
              ]),
              _: 3
            }),
            b(c(Ef), null, {
              default: P(() => [
                b(c(Of), {
                  class: "smake:data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade smake:data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade smake:data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade smake:data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity] smake:rounded-[4px] smake:bg-white smake:px-[15px] smake:py-[10px] smake:text-[15px] smake:leading-none smake:select-none",
                  "side-offset": 5
                }, {
                  default: P(() => [
                    Nt(e.$slots, "tooltip"),
                    b(c(Rf), {
                      class: "smake:fill-white",
                      width: 8
                    })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
});
function Eu(t, e) {
  return t.length > e ? `${t.slice(0, e)}…` : t;
}
const ww = { class: "smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl smake:border smake:border-secondary-2" }, xw = { class: "smake:relative smake:cursor-pointer smake:bg-secondary-3 smake:p-6" }, $w = { class: "smake:flex smake:justify-center smake:pt-1 smake:pb-2" }, Sw = { class: "smake:flex smake:grow smake:flex-col smake:gap-1 smake:px-4 smake:py-3 smake:text-center" }, Aw = { class: "smake:text-xs" }, Cw = { class: "smake:flex smake:flex-wrap smake:justify-center smake:gap-1 smake:py-1" }, Pw = {
  key: 0,
  class: "smake:size-4 smake:rounded-full smake:bg-[radial-gradient(#fff_15%,transparent_60%),conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]"
}, sh = /* @__PURE__ */ K({
  __name: "SelectionCard",
  props: {
    name: {},
    colorAssignments: {},
    deletable: { type: Boolean },
    externalIdentifier: {},
    height: {},
    image: {},
    productionMethodId: {},
    width: {}
  },
  emits: ["delete", "rename", "select"],
  setup(t, { emit: e }) {
    const n = t, { colorAssignments: s, productionMethodId: a } = Ae(n), { appConfiguration: o, designerConfiguration: i } = D(
      it()
    ), r = I(() => {
      var f;
      return (f = o.value) == null ? void 0 : f.colors;
    }), l = I(
      () => {
        var f;
        return (f = i.value) == null ? void 0 : f.settings.settings.units;
      }
    ), { decimalFormat: u } = Ho(), { locale: m } = wt();
    function h(f) {
      if (f !== void 0)
        return u(f, m.value, 2);
    }
    const v = I(() => s.value.length === 0), _ = I(() => s.value.map((k) => {
      var w;
      if (k.color) {
        const C = (w = r.value) == null ? void 0 : w.find(
          (M) => k.color.id === M.id
        );
        return C ? {
          blue: C.blue,
          green: C.green,
          red: C.red
        } : void 0;
      }
      return {
        blue: k.blue,
        green: k.green,
        red: k.red
      };
    }).filter((k) => !!k).reduce((k, w) => (k.some((C) => jr(C, w)) || k.push(w), k), [])), { icon: y } = xt(a), S = e;
    return (f, k) => {
      var w;
      return $(), O("div", ww, [
        x("div", xw, [
          f.deletable ? ($(), O("button", {
            key: 0,
            class: "smake:absolute smake:top-1.5 smake:right-1.5 smake:flex smake:aspect-square smake:w-10 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-2 smake:hover:text-secondary-1",
            type: "button",
            onClick: k[0] || (k[0] = (C) => S("delete"))
          }, [
            b(c(Nn), {
              class: "smake:h-4",
              icon: ["fak", "icon-remove"],
              "fixed-width": ""
            })
          ])) : X("", !0),
          c(y) ? ($(), Z(c(Nn), {
            key: 1,
            class: "smake:absolute smake:top-2.5 smake:left-2.5 smake:h-5",
            icon: c(y),
            "fixed-width": ""
          }, null, 8, ["icon"])) : X("", !0),
          b(ln, {
            src: f.image,
            class: "w-full smake:aspect-square smake:w-full smake:rounded-2xl smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
          }, null, 8, ["src"]),
          x("div", $w, [
            f.externalIdentifier ? ($(), Z(zu, {
              key: 0,
              class: "text-sm"
            }, Gl({
              default: P(() => [
                ce(" #" + L(c(Eu)(f.externalIdentifier, 15)) + " ", 1)
              ]),
              _: 2
            }, [
              f.externalIdentifier.length > 15 ? {
                name: "tooltip",
                fn: P(() => [
                  ce(" #" + L(f.externalIdentifier), 1)
                ]),
                key: "0"
              } : void 0
            ]), 1024)) : X("", !0)
          ])
        ]),
        x("div", Sw, [
          b(zu, null, Gl({
            default: P(() => [
              ce(L(c(Eu)(f.name, 60)) + " ", 1)
            ]),
            _: 2
          }, [
            f.name.length > 60 ? {
              name: "tooltip",
              fn: P(() => [
                ce(L(f.name), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1024),
          k[3] || (k[3] = x("div", { class: "smake:flex-grow" }, null, -1)),
          x("span", Aw, L(h(f.width)) + " x " + L(h(f.height)) + " " + L((w = l.value) == null ? void 0 : w.length), 1),
          x("div", Cw, [
            v.value ? ($(), O("div", Pw)) : X("", !0),
            ($(!0), O(re, null, $e(_.value, (C) => ($(), O("div", {
              key: c(He)(C),
              class: Se([
                "smake:aspect-square smake:w-4 smake:rounded-full smake:border",
                c($l)([C.red, C.green, C.blue]) ? "smake:border-secondary-2" : "smake:border-transparent"
              ]),
              style: Wt({
                backgroundColor: `rgb(${C.red},${C.green},${C.blue})`
              })
            }, null, 6))), 128))
          ]),
          b(ye, {
            type: "secondary",
            onClick: k[1] || (k[1] = (C) => S("select"))
          }, {
            default: P(() => [
              b(c(Nn), {
                icon: ["fal", "plus"],
                class: "smake:mr-2 smake:h-5"
              }),
              ce(" " + L(f.$t("choose")), 1)
            ]),
            _: 1
          }),
          b(ye, {
            type: "outline",
            class: "smake:mt-2",
            onClick: k[2] || (k[2] = (C) => S("rename"))
          }, {
            default: P(() => [
              b(c(Nn), {
                icon: ["fak", "icon-edit"],
                class: "mr-2 smake:h-5",
                "fixed-width": ""
              }),
              ce(" " + L(f.$t("rename")), 1)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), Iw = /* @__PURE__ */ K({
  __name: "CustomerLogoCard",
  props: {
    customerLogo: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, { customerLogo: s } = Ae(n), a = e, o = N(!1), {
      error: i,
      mutate: r,
      reset: l,
      status: u
    } = tn({
      ...le.customerLogos.patch.use(),
      onSuccess: () => o.value = !1
    });
    ie(() => {
      o.value || l();
    });
    const m = I(
      () => s.value.name ?? s.value.logo.name
    ), h = I(() => s.value.logo.preview_url ?? void 0);
    return (v, _) => ($(), O(re, null, [
      b(sh, {
        name: m.value,
        "external-identifier": c(s).logo.external_identifier ?? void 0,
        image: h.value,
        width: c(s).logo.width ?? void 0,
        height: c(s).logo.height ?? void 0,
        "color-assignments": c(s).logo.color_assignments,
        "show-rainbow-icon": c(s).logo.color_assignments.length === 0,
        "production-method-id": c(s).logo.production_method.id,
        onRename: _[0] || (_[0] = (y) => o.value = !0),
        onSelect: _[1] || (_[1] = (y) => a("select"))
      }, null, 8, ["name", "external-identifier", "image", "width", "height", "color-assignments", "show-rainbow-icon", "production-method-id"]),
      b(nh, {
        open: o.value,
        "onUpdate:open": _[2] || (_[2] = (y) => o.value = y),
        name: m.value,
        image: h.value,
        error: c(i) ?? void 0,
        "mutation-status": c(u),
        onRename: _[3] || (_[3] = (y) => c(r)({ id: c(s).id, name: y }))
      }, null, 8, ["open", "name", "image", "error", "mutation-status"])
    ], 64));
  }
}), Mw = {}, Tw = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.41 17.09"
};
function zw(t, e) {
  return $(), O("svg", Tw, e[0] || (e[0] = [
    x("g", { id: "Ebene_1-2" }, [
      x("path", {
        id: "Pfad_1021",
        fill: "currentColor",
        d: "M9.76.21c-.32-.28-.79-.28-1.12,0l-3.34,2.86c-.38.29-.45.83-.16,1.2.29.38.83.45,1.2.16.03-.02.05-.04.07-.06l1.92-1.64v7.67c.02.47.41.85.89.83.45-.02.81-.38.83-.83V2.72l1.92,1.64c.35.32.9.29,1.21-.07s.29-.9-.07-1.21c0,0-.02-.02-.03-.02L9.76.21Z"
      }),
      x("path", {
        id: "Pfad_1022",
        fill: "currentColor",
        d: "M17.54,10.56c-.47,0-.86.38-.86.86h0v3.07c0,.49-.4.88-.89.88H2.6c-.48,0-.88-.39-.89-.87v-3.08c-.02-.47-.41-.85-.89-.83-.45.02-.81.38-.83.83v3.08c.01,1.43,1.17,2.58,2.6,2.59h13.18c.69.03,1.37-.25,1.85-.75.49-.48.77-1.15.78-1.84v-3.08c0-.47-.38-.86-.86-.86,0,0,0,0,0,0Z"
      })
    ], -1)
  ]));
}
const Zo = /* @__PURE__ */ gs(Mw, [["render", zw]]), Ew = { class: "smake:flex smake:items-center smake:justify-center smake:rounded-full smake:bg-primary-1 smake:p-4 smake:text-white" }, Ow = { class: "smake:text-center smake:font-semibold" }, Rw = /* @__PURE__ */ K({
  __name: "CustomerLogoUploadCard",
  props: {
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  },
  emits: ["placed"],
  setup(t, { emit: e }) {
    const n = t, { productionMethodId: s } = Ae(n), { isCustomerLogoUploadEnabled: a } = xt(s), o = e, i = N(!1);
    return (r, l) => c(a) ? ($(), O(re, { key: 0 }, [
      x("button", {
        class: "smake:flex smake:min-h-95 smake:flex-col smake:items-center smake:justify-center smake:gap-4 smake:rounded-3xl smake:border smake:border-secondary-2",
        onClick: l[0] || (l[0] = (u) => i.value = !0)
      }, [
        x("div", Ew, [
          b(Zo, { class: "smake:size-8" })
        ]),
        x("div", Ow, L(r.$t("upload_file")), 1)
      ]),
      b(Ta, {
        open: i.value,
        "onUpdate:open": l[1] || (l[1] = (u) => i.value = u),
        "production-method-id": c(s),
        "positioning-area": r.positioningArea,
        "positioning-area-design": r.positioningAreaDesign,
        onResolve: l[2] || (l[2] = (u) => o("placed"))
      }, null, 8, ["open", "production-method-id", "positioning-area", "positioning-area-design"])
    ], 64)) : X("", !0);
  }
}), Lw = { class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45" }, Dw = {
  key: 0,
  class: "smake:-mt-8 smake:flex smake:grow smake:items-center smake:justify-center smake:text-lg"
}, Nw = { class: "smake:max-w-md smake:text-center smake:text-secondary-1 smake:italic" }, Vw = /* @__PURE__ */ K({
  __name: "CustomerLogoSelection",
  props: {
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  },
  emits: ["customer-logo-selected", "upload-placed"],
  setup(t, { emit: e }) {
    const n = e, s = t, { productionMethodId: a } = Ae(s), { isCustomerLogoUploadEnabled: o, productionMethod: i } = xt(a), { t: r } = wt(), l = I(() => ({
      production_method: [a.value]
    })), { designerConfiguration: u } = D(it()), m = I(
      () => {
        var w;
        return (w = u.value) == null ? void 0 : w.settings.attributes.phone;
      }
    ), {
      data: h,
      fetchNextPage: v,
      hasNextPage: _,
      isFetching: y,
      status: S
    } = zs({
      ...le.customerLogos.list.use(l),
      select: (w) => w.pages.flatMap((C) => C.data),
      staleTime: 60 * 1e3
    });
    function f() {
      return S.value === "pending" ? !0 : _.value;
    }
    async function k() {
      S.value !== "pending" && await v();
    }
    return (w, C) => {
      var M, T, E;
      return $(), O(re, null, [
        ot(($(), O("div", Lw, [
          b(Rw, {
            "production-method-id": c(a),
            "positioning-area": w.positioningArea,
            "positioning-area-design": w.positioningAreaDesign,
            onPlaced: C[0] || (C[0] = (U) => n("upload-placed"))
          }, null, 8, ["production-method-id", "positioning-area", "positioning-area-design"]),
          c(y) || (M = c(h)) != null && M.length ? ($(!0), O(re, { key: 0 }, $e(c(h), (U) => ($(), O("div", {
            key: U.id
          }, [
            b(Iw, {
              "customer-logo": U,
              onSelect: (F) => n("customer-logo-selected", c(Es)(U))
            }, null, 8, ["customer-logo", "onSelect"])
          ]))), 128)) : X("", !0),
          ($(!0), O(re, null, $e(c(y) ? 3 : 0, (U) => ($(), O("div", {
            key: U,
            class: "smake:min-h-95 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
          }))), 128))
        ])), [
          [c(ya), [k, { distance: 350, canLoadMore: f }]]
        ]),
        !c(o) && !c(y) && (((T = c(h)) == null ? void 0 : T.length) ?? 0) === 0 ? ($(), O("div", Dw, [
          x("span", Nw, L(c(r)("no_customer_logos", {
            productionMethod: (E = c(i)) == null ? void 0 : E.display_name,
            contact: m.value
          })), 1)
        ])) : X("", !0)
      ], 64);
    };
  }
}), Uw = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-[600px] smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, Fw = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, jw = { class: "smake:flex smake:flex-col smake:justify-between smake:gap-5" }, Bw = { class: "smake:flex smake:w-full smake:flex-col smake:gap-4 smake:@md:flex-row" }, qw = /* @__PURE__ */ K({
  __name: "ConfirmReplacementDialog",
  props: {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  },
  emits: /* @__PURE__ */ Ne(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open"), { dialogsRoot: a } = D(sn());
    return (o, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: s.value,
        "onUpdate:open": i[3] || (i[3] = (l) => s.value = l)
      }, {
        default: P(() => [
          b(c(Et), { to: c(a) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: i[0] || (i[0] = (l) => n("closed"))
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), { "as-child": "" }, {
                    default: P(() => [
                      x("div", Uw, [
                        x("div", Fw, [
                          b(c(Tt), { class: "smake:flex smake:items-center smake:gap-2" }, {
                            default: P(() => [
                              b(r, {
                                class: "smake:inline-block",
                                icon: ["fak", "icon-info"]
                              }),
                              x("div", null, L(o.$t(
                                "the_selected_design_will_replace_the_current_selection"
                              )), 1)
                            ]),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(r, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", jw, [
                          x("div", Bw, [
                            b(ye, {
                              type: "outline",
                              class: "smake:flex-grow",
                              onClick: i[1] || (i[1] = (l) => s.value = !1)
                            }, {
                              default: P(() => [
                                ce(L(o.$t("abort")), 1)
                              ]),
                              _: 1
                            }),
                            b(ye, {
                              type: "primary",
                              class: "smake:flex smake:flex-grow smake:items-center smake:gap-2",
                              onClick: i[2] || (i[2] = (l) => n("resolve", !0))
                            }, {
                              default: P(() => [
                                ce(L(o.$t("replace")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), Hw = { class: "smake:absolute smake:inset-x-5 smake:top-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:max-w-[400px] smake:-translate-y-1/2 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-4" }, Ww = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, Gw = { class: "smake:font-bold smake:text-primary-1" }, Zw = { class: "smake:flex smake:flex-col smake:items-center smake:gap-4" }, Qw = ["src"], Xw = {
  key: 0,
  class: "smake:w-full smake:rounded-lg smake:border smake:border-danger smake:p-2 smake:text-danger"
}, Kw = { class: "smake:flex smake:w-full smake:flex-col smake:gap-4 smake:@md:flex-row" }, Jw = /* @__PURE__ */ K({
  __name: "DeleteDialog",
  props: /* @__PURE__ */ Ne({
    name: {},
    error: {},
    image: {},
    mutationStatus: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed", "delete", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open"), a = t, { mutationStatus: o } = Ae(a), { dialogsRoot: i } = D(sn()), r = I(() => o.value === "pending");
    function l(u) {
      r.value || u.preventDefault();
    }
    return (u, m) => {
      const h = xe("I18nT"), v = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: s.value,
        "onUpdate:open": m[3] || (m[3] = (_) => s.value = _)
      }, {
        default: P(() => [
          b(c(Et), { to: c(i) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: m[0] || (m[0] = (_) => n("closed"))
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), {
                    "as-child": "",
                    onInteractOutside: l,
                    onEscapeKeyDown: l
                  }, {
                    default: P(() => [
                      x("div", Hw, [
                        x("div", Ww, [
                          b(c(Tt), null, {
                            default: P(() => [
                              b(h, {
                                keypath: "are_you_sure_you_want_to_delete",
                                tag: "div"
                              }, {
                                deleteName: P(() => [
                                  x("span", Gw, L(u.name), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(v, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", Zw, [
                          x("img", {
                            class: "smake:aspect-square smake:w-80 smake:rounded-3xl smake:bg-secondary-3 smake:object-contain smake:p-4",
                            src: u.image
                          }, null, 8, Qw),
                          u.error ? ($(), O("div", Xw, L(u.$t("boot_error.unexpected")), 1)) : X("", !0),
                          x("div", Kw, [
                            b(ye, {
                              type: "outline",
                              class: "smake:flex-grow",
                              disabled: r.value,
                              onClick: m[1] || (m[1] = (_) => s.value = !1)
                            }, {
                              default: P(() => [
                                ce(L(u.$t("abort")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            b(ye, {
                              type: "primary",
                              class: "smake:flex smake:flex-grow smake:items-center smake:gap-2",
                              disabled: r.value,
                              onClick: m[2] || (m[2] = (_) => n("delete"))
                            }, {
                              default: P(() => [
                                b(v, {
                                  class: "smake:h-5",
                                  icon: ["fak", "icon-remove"],
                                  "fixed-width": ""
                                }),
                                ce(" " + L(u.$t("delete")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), Yw = /* @__PURE__ */ K({
  __name: "DesignFavoredCard",
  props: {
    design: {},
    isSelectConfirmationRequired: { type: Boolean }
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, { design: s } = Ae(n), a = e, o = N(!1), i = N(!1), r = N(!1), {
      error: l,
      mutate: u,
      reset: m,
      status: h
    } = tn({
      ...le.designs.favored.patch.use(),
      onSuccess: () => o.value = !1
    }), {
      error: v,
      mutate: _,
      status: y
    } = tn({
      ...le.designs.favored.delete.use(),
      onSuccess: () => i.value = !1
    });
    ie(() => {
      o.value || m();
    });
    function S() {
      if (!n.isSelectConfirmationRequired) {
        a("select");
        return;
      }
      r.value = !0;
    }
    const f = I(
      () => Pk(...Sl(s.value.elements[0]))
    ), k = I(() => s.value.name ?? ""), w = I(() => s.value.preview_url);
    function C(M) {
      M && a("select");
    }
    return (M, T) => ($(), O(re, null, [
      b(sh, {
        name: k.value,
        image: w.value,
        width: c(s).width,
        height: c(s).height,
        "color-assignments": f.value,
        deletable: !0,
        "production-method-id": c(s).production_method.id,
        onRename: T[0] || (T[0] = (E) => o.value = !0),
        onDelete: T[1] || (T[1] = (E) => i.value = !0),
        onSelect: S
      }, null, 8, ["name", "image", "width", "height", "color-assignments", "production-method-id"]),
      b(nh, {
        open: o.value,
        "onUpdate:open": T[2] || (T[2] = (E) => o.value = E),
        name: k.value,
        image: w.value,
        error: c(l) ?? void 0,
        "mutation-status": c(h),
        onRename: T[3] || (T[3] = (E) => c(u)({ id: c(s).id, name: E }))
      }, null, 8, ["open", "name", "image", "error", "mutation-status"]),
      b(Jw, {
        open: i.value,
        "onUpdate:open": T[4] || (T[4] = (E) => i.value = E),
        name: k.value,
        image: w.value,
        "mutation-status": c(y),
        error: c(v) ?? void 0,
        onDelete: T[5] || (T[5] = (E) => c(_)(c(s).id))
      }, null, 8, ["open", "name", "image", "mutation-status", "error"]),
      b(qw, {
        open: r.value,
        "onUpdate:open": T[6] || (T[6] = (E) => r.value = E),
        onResolve: C
      }, null, 8, ["open"])
    ], 64));
  }
}), e3 = {
  key: 0,
  class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45"
}, t3 = {
  key: 1,
  class: "smake:-mt-8 smake:flex smake:h-full smake:grow smake:items-center smake:justify-center smake:text-lg"
}, n3 = { class: "smake:max-w-md smake:text-center smake:text-secondary-1 smake:italic" }, s3 = /* @__PURE__ */ K({
  __name: "DesignFavoredSelection",
  props: {
    isSelectConfirmationRequired: { type: Boolean },
    productionMethodId: {}
  },
  emits: ["design-selected"],
  setup(t, { emit: e }) {
    const n = e, s = t, { productionMethodId: a } = Ae(s), { productionMethod: o } = xt(a), i = I(
      () => ({
        production_method: [a.value]
      })
    ), {
      data: r,
      fetchNextPage: l,
      hasNextPage: u,
      isFetching: m,
      status: h
    } = zs({
      ...le.designs.favored.list.use(i),
      select: (y) => y.pages.flatMap((S) => S.data),
      staleTime: 1 / 0
    });
    function v() {
      return h.value === "pending" ? !0 : u.value;
    }
    async function _() {
      h.value !== "pending" && await l();
    }
    return (y, S) => {
      var f, k;
      return c(m) || (f = c(r)) != null && f.length ? ot(($(), O("div", e3, [
        ($(!0), O(re, null, $e(c(r), (w) => ($(), O("div", {
          key: w.id
        }, [
          b(Yw, {
            design: w,
            "is-select-confirmation-required": y.isSelectConfirmationRequired,
            onSelect: (C) => n("design-selected", c(Es)(w))
          }, null, 8, ["design", "is-select-confirmation-required", "onSelect"])
        ]))), 128)),
        ($(!0), O(re, null, $e(c(m) ? 3 : 0, (w) => ($(), O("div", {
          key: w,
          class: "smake:min-h-95 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
        }))), 128))
      ])), [
        [c(ya), [_, { distance: 350, canLoadMore: v }]]
      ]) : ($(), O("div", t3, [
        x("div", n3, L(y.$t("no_designs", {
          productionMethod: (k = c(o)) == null ? void 0 : k.display_name
        })), 1)
      ]));
    };
  }
}), a3 = { class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-[1280px] smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl" }, o3 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, i3 = { class: "smake:flex smake:flex-wrap smake:gap-2" }, r3 = { class: "smake:text-nowrap smake:text-secondary-2" }, l3 = { class: "smake:text-nowrap smake:text-secondary-2" }, Ml = /* @__PURE__ */ K({
  __name: "CustomerDesignSelection",
  props: /* @__PURE__ */ Ne({
    initialProductionMethodId: {},
    intialTab: { default: "customer-logos" },
    positioningArea: { default: void 0 },
    positioningAreaDesign: { default: void 0 }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open"), a = t, {
      initialProductionMethodId: o,
      intialTab: i,
      positioningArea: r,
      positioningAreaDesign: l
    } = Ae(a), u = N(o.value);
    ht(s, (C) => {
      C && (u.value = o.value);
    });
    const m = I(() => !l.value), { dialogsRoot: h } = D(sn()), { placeDesign: v } = Go();
    function _() {
      s.value = !1, n("resolve", !0);
    }
    async function y(C) {
      const M = bl(C.logo);
      await v(
        {
          design: M,
          productionMethodId: u.value
        },
        {
          mergePostioningAreaDesign: l.value,
          positioningArea: r.value
        }
      ) === "success" && _();
    }
    async function S(C) {
      const M = yl(C.elements[0]);
      await v(
        {
          design: M,
          productionMethodId: u.value
        },
        {
          mergePostioningAreaDesign: l.value,
          positioningArea: r.value
        }
      ) === "success" && (s.value = !1, n("resolve", !0));
    }
    const f = N(i.value), { data: k } = kt({
      ...le.customerLogos.count.use(
        I(() => ({
          production_method: [u.value]
        }))
      ),
      retry: !1,
      staleTime: 1 / 0
    }), { data: w } = kt({
      ...le.designs.favored.count.use(
        I(() => ({
          production_method: [u.value]
        }))
      ),
      retry: !1,
      staleTime: 1 / 0
    });
    return (C, M) => {
      const T = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: s.value,
        "onUpdate:open": M[3] || (M[3] = (E) => s.value = E)
      }, {
        default: P(() => [
          b(c(Et), { to: c(h) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: M[0] || (M[0] = (E) => n("closed"))
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), { "as-child": "" }, {
                    default: P(() => [
                      x("div", a3, [
                        x("div", o3, [
                          b(c(Tt), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: P(() => [
                              ce(L(C.$t("logos_and_designs")), 1)
                            ]),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(T, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        b(c(Jr), {
                          modelValue: f.value,
                          "onUpdate:modelValue": M[2] || (M[2] = (E) => f.value = E),
                          class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-hidden"
                        }, {
                          default: P(() => [
                            b(c(Yr), { class: "smake:mb-4 smake:flex smake:flex-wrap smake:justify-between smake:gap-2" }, {
                              default: P(() => [
                                x("div", i3, [
                                  b(ua, { value: "customer-logos" }, {
                                    default: P(() => [
                                      b(aw, { class: "smake:size-4.5" }),
                                      ce(" " + L(C.$t("my_files")) + " ", 1),
                                      x("span", r3, L(c(k)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  b(ua, { value: "designs" }, {
                                    default: P(() => [
                                      b(lw, { class: "smake:size-4.5" }),
                                      ce(" " + L(C.$t("saved_designs")) + " ", 1),
                                      x("span", l3, L(c(w)), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                b(th, {
                                  modelValue: u.value,
                                  "onUpdate:modelValue": M[1] || (M[1] = (E) => u.value = E),
                                  disabled: !m.value
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }),
                            b(c(ca), {
                              "as-child": "",
                              value: "customer-logos",
                              unmount: !1
                            }, {
                              default: P(() => [
                                b(Vw, {
                                  "production-method-id": u.value,
                                  "positioning-area": c(r),
                                  "positioning-area-design": c(l),
                                  onCustomerLogoSelected: y,
                                  onUploadPlaced: _
                                }, null, 8, ["production-method-id", "positioning-area", "positioning-area-design"])
                              ]),
                              _: 1
                            }),
                            b(c(ca), {
                              value: "designs",
                              "as-child": "",
                              unmount: !1
                            }, {
                              default: P(() => [
                                b(s3, {
                                  "is-select-confirmation-required": c(l) !== void 0,
                                  "production-method-id": u.value,
                                  onDesignSelected: S
                                }, null, 8, ["is-select-confirmation-required", "production-method-id"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), c3 = {}, u3 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 94.03 86.98"
};
function d3(t, e) {
  return $(), O("svg", u3, e[0] || (e[0] = [
    Hu('<g id="Ebene_1-2"><g id="Icon_Image_Download"><g id="Pfad_1352"><path fill="currentColor" d="M68.6,86.98c-.61,0-1.22-.08-1.83-.25L5.05,69.81c-3.65-1-5.81-4.79-4.81-8.44l8.31-30.27c.22-.8,1.05-1.27,1.84-1.05.8.22,1.27,1.04,1.05,1.84L3.14,62.16c-.56,2.06.65,4.19,2.71,4.76l61.71,16.93c1,.27,2.04.14,2.94-.37.9-.51,1.54-1.34,1.82-2.34l3.71-13.55c.22-.8,1.04-1.27,1.84-1.05.8.22,1.27,1.04,1.05,1.84l-3.71,13.55c-.49,1.77-1.63,3.24-3.23,4.15-1.05.6-2.21.9-3.39.9Z"></path></g><g id="Pfad_1353"><path fill="currentColor" d="M34.73,27.91c-4.22,0-7.64-3.43-7.65-7.64,0-2.04.79-3.96,2.24-5.41,1.44-1.44,3.36-2.24,5.41-2.24,4.22,0,7.65,3.43,7.65,7.64h0s0,0,0,0c0,2.04-.79,3.96-2.24,5.41-1.44,1.44-3.36,2.24-5.41,2.24h0ZM34.73,15.62c-1.24,0-2.41.48-3.29,1.36-.88.88-1.36,2.04-1.36,3.28,0,2.56,2.08,4.64,4.65,4.64h0c2.56,0,4.64-2.08,4.64-4.65h0c0-2.56-2.08-4.64-4.64-4.64Z"></path></g><path fill="currentColor" d="M89.38,0H20.93c-2.56,0-4.64,2.08-4.64,4.64v53.71c0,2.56,2.08,4.64,4.64,4.64h68.46c2.56,0,4.64-2.08,4.64-4.64V4.64c0-2.56-2.08-4.64-4.64-4.64ZM20.93,3h68.46c.9,0,1.64.73,1.64,1.64v39.21l-20.35-20.35c-.56-.56-1.56-.56-2.12,0l-19.53,19.53-8.88-8.88c-.28-.28-.67-.44-1.07-.44-.4,0-.78.17-1.06.45l-18.71,19.2V4.64c0-.9.73-1.64,1.64-1.64ZM89.38,59.98H20.93c-.9,0-1.64-.73-1.64-1.64v-.68l19.8-20.32,8.87,8.87c.56.56,1.56.56,2.12,0l19.53-19.53,21.42,21.41v10.26c0,.9-.73,1.64-1.64,1.64Z"></path></g></g>', 1)
  ]));
}
const m3 = /* @__PURE__ */ gs(c3, [["render", d3]]), h3 = { class: "smake:rounded-3xl smake:border-3 smake:border-dashed smake:border-secondary-2 smake:p-2" }, p3 = {
  key: 0,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-between"
}, f3 = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-center smake:gap-4" }, v3 = { class: "smake:relative" }, g3 = { class: "smake:absolute smake:-right-2.5 smake:bottom-2 smake:flex smake:size-5 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-1 smake:@md:-right-5 smake:@md:bottom-4 smake:@md:size-10" }, _3 = { class: "smake:flex smake:items-center smake:justify-center smake:gap-2" }, k3 = { class: "smake:flex smake:flex-col smake:gap-2 smake:text-center smake:font-semibold smake:text-balance smake:text-primary-1" }, y3 = ["href"], b3 = { class: "smake:p-4 smake:text-center smake:leading-6" }, w3 = ["href"], x3 = {
  key: 1,
  class: "smake:flex smake:w-full smake:flex-col smake:items-center smake:justify-center smake:gap-5"
}, $3 = { class: "smake:rounded-full smake:bg-black smake:p-4 smake:shadow-lg" }, S3 = { class: "smake:flex smake:flex-col smake:gap-2 smake:text-center smake:text-[14px] smake:font-thin" }, A3 = {
  key: 2,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-4 smake:p-5"
}, C3 = { class: "smake:flex smake:grow smake:items-center smake:justify-center" }, P3 = { class: "smake:flex smake:w-full smake:items-center smake:gap-4 smake:@max-lg:flex-col smake:@max-lg:items-center smake:@max-lg:text-center smake:@lg:justify-between" }, I3 = { class: "smake:flex smake:flex-col smake:gap-1" }, M3 = { class: "smake:font-semibold" }, T3 = { class: "smake:[overflow-wrap:normal]" }, z3 = /* @__PURE__ */ K({
  __name: "CustomerLogoDropzone",
  props: /* @__PURE__ */ Ne({
    accept: {},
    disabled: { type: Boolean },
    errors: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["reset"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    var se;
    function n(W) {
      return "id" in W;
    }
    const s = t, { accept: a, disabled: o, errors: i } = Ae(s), r = N();
    ie(() => {
      r.value = i.value;
    });
    const { termsOfServiceLink: l, uploadHelpLink: u } = D(Ma()), m = I(() => {
      if (r.value) {
        if (r.value.fieldMessages) {
          const W = [];
          for (const [Y, me] of Object.entries(
            r.value.fieldMessages
          ))
            Y === "content_type" || Y === "path" || W.push(...me);
          return W;
        }
        if (r.value.message)
          return [r.value.message];
      }
    }), h = I(
      () => {
        var W, Y, me, he;
        return !!((Y = (W = r.value) == null ? void 0 : W.fieldMessages) != null && Y.content_type) || !!((he = (me = r.value) == null ? void 0 : me.fieldMessages) != null && he.path);
      }
    ), v = e, _ = je(t, "modelValue"), { designerConfiguration: y } = D(it()), S = I(
      () => {
        var W;
        return (W = y.value) == null ? void 0 : W.settings.settings.units.length;
      }
    ), { decimalFormat: f } = Ho(), { locale: k } = wt(), w = I(() => _.value === void 0 ? "empty" : n(_.value) ? "preview" : "processing"), C = I(() => {
      if (_.value && n(_.value))
        return {
          name: _.value.name ?? _.value.logo.name,
          height: f(
            _.value.logo.height ?? 0,
            k.value,
            2
          ),
          previewUrl: _.value.logo.preview_url ?? void 0,
          width: f(
            _.value.logo.width ?? 0,
            k.value,
            2
          )
        };
    });
    function M(W) {
      var Y;
      return (Y = a.value) != null && Y.length ? a.value.some(
        (me) => me.startsWith(".") ? W.name.endsWith(me) : W.type === me
      ) : !0;
    }
    const T = xo("dropArea"), { isOverDropZone: E } = Up(T, {
      multiple: !1,
      onDrop: (W) => {
        if (o.value) return;
        v("reset");
        let Y = W == null ? void 0 : W[0];
        Y && (M(Y) || (Y = void 0, r.value = {
          fieldMessages: {
            content_type: ["invalid"]
          }
        }), _.value = Y);
      }
    }), U = I(() => !o.value && E.value), { onChange: F, open: ee } = Fp({
      accept: (se = a.value) == null ? void 0 : se.join(","),
      multiple: !1
    });
    function Q() {
      v("reset"), ee();
    }
    return F((W) => {
      if (!W) return;
      let Y = W[0];
      Y && (M(Y) || (Y = void 0, r.value = {
        fieldMessages: {
          content_type: ["invalid"]
        }
      }), _.value = Y);
    }), (W, Y) => {
      const me = xe("FontAwesomeIcon");
      return $(), O("div", h3, [
        x("div", {
          ref_key: "dropArea",
          ref: T,
          class: Se([{
            "smake:bg-secondary-3": !U.value,
            "smake:bg-secondary-2": U.value
          }, "smake:flex smake:h-full smake:rounded-3xl smake:p-3"])
        }, [
          w.value === "empty" ? ($(), O("div", p3, [
            x("div", f3, [
              x("div", v3, [
                b(m3, { class: "smake:size-15 smake:@md:size-30" }),
                x("div", g3, [
                  b(Zo, { class: "smake:h-2.5 smake:@md:h-5" })
                ])
              ]),
              x("div", null, L(W.$t("drag_file_over_area")), 1),
              x("div", _3, [
                x("div", {
                  class: Se(["smake:w-18 smake:border-t-2", {
                    "smake:border-t-secondary-2": !U.value,
                    "smake:border-t-secondary-3": U.value
                  }])
                }, null, 2),
                ce(" " + L(W.$t("or")) + " ", 1),
                x("div", {
                  class: Se(["smake:w-18 smake:border-t-2", {
                    "smake:border-t-secondary-2": !U.value,
                    "smake:border-t-secondary-3": U.value
                  }])
                }, null, 2)
              ]),
              x("div", null, [
                b(ye, {
                  class: "smake:px-4",
                  type: "primary",
                  disabled: c(o),
                  onClick: Q
                }, {
                  default: P(() => [
                    ce(L(W.$t("select_file")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              x("div", k3, [
                ($(!0), O(re, null, $e(m.value, (he) => ($(), O("div", { key: he }, L(he), 1))), 128)),
                h.value ? ($(), Z(c(Yl), {
                  key: 0,
                  keypath: "upload_error_422_content_type",
                  tag: "span"
                }, {
                  here: P(() => [
                    x("a", {
                      class: "smake:font-bold smake:underline",
                      href: c(u),
                      target: "_blank"
                    }, L(W.$t("here")), 9, y3)
                  ]),
                  _: 1
                })) : X("", !0)
              ])
            ]),
            x("div", b3, [
              b(c(Yl), {
                keypath: "more_informations_about_upload",
                as: "div"
              }, {
                termsOfServiceLink: P(() => [
                  x("a", {
                    href: c(l),
                    target: "_blank",
                    class: "smake:underline"
                  }, L(W.$t("terms_of_service")), 9, w3)
                ]),
                _: 1
              })
            ])
          ])) : X("", !0),
          w.value === "processing" ? ($(), O("div", x3, [
            x("div", $3, [
              b(me, {
                class: "smake:size-5 smake:animate-spin smake:text-white",
                icon: ["fal", "spinner-third"]
              })
            ]),
            x("div", S3, [
              x("div", null, L(W.$t("your_file_is_beeing_uploaded")), 1),
              x("div", null, L(W.$t("please_hold_on_for_a_moment")), 1)
            ])
          ])) : X("", !0),
          C.value ? ($(), O("div", A3, [
            x("div", C3, [
              b(ln, {
                class: "smake:size-100 smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2",
                src: C.value.previewUrl
              }, null, 8, ["src"])
            ]),
            x("div", P3, [
              x("div", I3, [
                x("div", M3, L(C.value.name), 1),
                x("div", T3, L(C.value.width) + " x " + L(C.value.height) + " " + L(S.value), 1)
              ]),
              b(ye, {
                class: "smake:border smake:border-secondary-2 smake:px-4",
                type: "secondary",
                onClick: Q
              }, {
                default: P(() => [
                  ce(L(W.$t("upload_another_file")), 1)
                ]),
                _: 1
              })
            ])
          ])) : X("", !0)
        ], 2)
      ]);
    };
  }
}), E3 = { class: "smake:flex smake:size-45 smake:flex-col smake:items-center smake:justify-center smake:gap-5 smake:rounded-lg smake:bg-secondary-3 smake:p-4" }, O3 = /* @__PURE__ */ K({
  __name: "CustomerLogo",
  props: {
    data: {},
    disabled: { type: Boolean }
  },
  emits: ["selected"],
  setup(t, { emit: e }) {
    const n = e;
    return (s, a) => ($(), O("div", E3, [
      b(ln, {
        class: "smake:size-2/3 smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2",
        src: s.data.logo.preview_url ?? void 0
      }, null, 8, ["src"]),
      b(ye, {
        type: "secondary",
        class: "smake:border smake:border-secondary-2 smake:px-4 smake:text-xs smake:font-semibold",
        disabled: s.disabled,
        onClick: a[0] || (a[0] = (o) => n("selected"))
      }, {
        default: P(() => [
          ce(L(s.$t("choose")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]));
  }
}), R3 = { class: "smake:hidden smake:flex-col smake:items-center smake:gap-5 smake:@md:flex" }, L3 = {
  key: 0,
  class: "smake:flex smake:size-45 smake:items-center smake:justify-center smake:rounded-lg smake:border-2 smake:border-secondary-3 smake:text-center smake:text-xs smake:text-balance smake:text-secondary-2 smake:italic"
}, D3 = /* @__PURE__ */ K({
  __name: "RecentCustomerLogoUploads",
  props: {
    disabled: { type: Boolean },
    productionMethodId: {}
  },
  emits: ["selected"],
  setup(t, { emit: e }) {
    const n = t, { productionMethodId: s } = Ae(n), a = e, { data: o } = zs({
      ...le.customerLogos.list.use(
        I(() => ({
          production_method: [s.value]
        }))
      ),
      select: (u) => u.pages.flatMap((m) => m.data)
    }), i = I(() => {
      var u;
      return (u = o.value) == null ? void 0 : u.slice(0, 3);
    }), r = I(() => {
      var u;
      return l.value ? 2 : 3 - (((u = i.value) == null ? void 0 : u.length) ?? 0);
    }), l = I(
      () => {
        var u;
        return (((u = i.value) == null ? void 0 : u.length) ?? 0) === 0;
      }
    );
    return (u, m) => {
      var h;
      return $(), O("div", R3, [
        x("span", {
          class: Se(["smake:text-sm smake:font-semibold", {
            "smake:text-secondary-2": (((h = c(o)) == null ? void 0 : h.length) ?? 0) === 0
          }])
        }, L(u.$t("recently_uploaded")) + ": ", 3),
        ($(!0), O(re, null, $e(i.value, (v) => ($(), Z(O3, {
          key: v.id,
          data: v,
          disabled: u.disabled,
          onSelected: (_) => a("selected", v)
        }, null, 8, ["data", "disabled", "onSelected"]))), 128)),
        l.value ? ($(), O("div", L3, L(u.$t("currently_no_uploaded_files")), 1)) : X("", !0),
        ($(!0), O(re, null, $e(r.value, (v) => ($(), O("div", {
          key: v,
          class: "smake:size-45 smake:rounded-lg smake:border-2 smake:border-secondary-3"
        }))), 128))
      ]);
    };
  }
}), N3 = { class: "smake:absolute smake:inset-x-5 smake:top-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:max-w-[600px] smake:-translate-y-1/2 smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-4" }, V3 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, U3 = { class: "smake:flex smake:grow smake:gap-20 smake:text-[14px] smake:tracking-wider" }, F3 = { class: "smake:flex smake:justify-center smake:gap-5" }, j3 = /* @__PURE__ */ K({
  __name: "UploadConfirmationDialog",
  props: {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  },
  emits: /* @__PURE__ */ Ne(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = je(t, "open"), s = e, { dialogsRoot: a } = D(sn());
    return (o, i) => ($(), Z(c(zt), {
      open: n.value,
      "onUpdate:open": i[5] || (i[5] = (r) => n.value = r)
    }, {
      default: P(() => [
        b(c(Et), { to: c(a) }, {
          default: P(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: i[0] || (i[0] = (r) => s("closed"))
            }, {
              default: P(() => [
                b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-95 smake:opacity-0"
            }, {
              default: P(() => [
                b(c(Rt), {
                  "as-child": "",
                  onInteractOutside: i[3] || (i[3] = (r) => s("resolve", !1)),
                  onEscapeKeyDown: i[4] || (i[4] = (r) => s("resolve", !1))
                }, {
                  default: P(() => [
                    x("div", N3, [
                      x("div", V3, [
                        b(c(Tt), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                          default: P(() => [
                            ce(L(o.$t("confirmation")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      i[6] || (i[6] = x("hr", { class: "smake:hidden smake:border smake:border-secondary-2 smake:@sm:block" }, null, -1)),
                      x("div", U3, L(o.$t("confirmation_description")), 1),
                      x("div", F3, [
                        b(ye, {
                          class: "smake:flex smake:grow smake:gap-2 smake:px-6 smake:py-4",
                          type: "secondary",
                          onClick: i[1] || (i[1] = (r) => {
                            s("resolve", !1), n.value = !1;
                          })
                        }, {
                          default: P(() => [
                            ce(L(o.$t("abort")), 1)
                          ]),
                          _: 1
                        }),
                        b(ye, {
                          class: "smake:flex smake:grow smake:gap-2 smake:px-6 smake:py-4",
                          type: "primary",
                          onClick: i[2] || (i[2] = (r) => {
                            s("resolve", !0), n.value = !1;
                          })
                        }, {
                          default: P(() => [
                            ce(L(o.$t("confirm")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), B3 = {}, q3 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.83 21.09"
};
function H3(t, e) {
  return $(), O("svg", q3, e[0] || (e[0] = [
    x("g", { id: "Ebene_1-2" }, [
      x("path", {
        fill: "currentColor",
        d: "M22.97,0H2.86C1.28,0,0,1.28,0,2.86v15.36c0,1.58,1.28,2.86,2.86,2.86h20.11c1.58,0,2.86-1.28,2.86-2.86V2.86c0-1.58-1.28-2.86-2.86-2.86ZM2.86,1.8h20.11c.59,0,1.06.48,1.06,1.06v10.79l-5.9-5.9c-.31-.31-.82-.31-1.13,0l-6.06,6.06-2.63-2.63c-.15-.15-.35-.23-.57-.23h0c-.21,0-.42.09-.57.24l-5.37,5.51V2.86c0-.59.48-1.06,1.06-1.06ZM22.97,19.29H2.86c-.38,0-.69-.21-.88-.5l5.77-5.91,2.62,2.62c.31.31.82.31,1.13,0l6.06-6.06,6.47,6.47v2.31c0,.59-.48,1.06-1.06,1.06Z"
      }),
      x("path", {
        fill: "currentColor",
        d: "M6.35,9.3c1.53,0,2.78-1.25,2.78-2.78s-1.25-2.78-2.78-2.78-2.78,1.25-2.78,2.78,1.25,2.78,2.78,2.78ZM6.35,5.35c.65,0,1.18.53,1.18,1.18s-.53,1.18-1.18,1.18-1.18-.53-1.18-1.18.53-1.18,1.18-1.18Z"
      })
    ], -1)
  ]));
}
const W3 = /* @__PURE__ */ gs(B3, [["render", H3]]), G3 = {}, Z3 = {
  id: "Ebene_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.83 21.09"
};
function Q3(t, e) {
  return $(), O("svg", Z3, e[0] || (e[0] = [
    x("g", { id: "Ebene_1-2" }, [
      x("path", {
        fill: "currentColor",
        d: "M22.97,0H2.86C1.28,0,0,1.28,0,2.86v15.36c0,1.58,1.28,2.86,2.86,2.86h20.11c1.58,0,2.86-1.28,2.86-2.86V2.86c0-1.58-1.28-2.86-2.86-2.86ZM24.03,18.23c0,.59-.48,1.06-1.06,1.06H2.86c-.59,0-1.06-.48-1.06-1.06V2.86c0-.59.48-1.06,1.06-1.06h20.11c.59,0,1.06.48,1.06,1.06v15.36Z"
      }),
      x("path", {
        fill: "currentColor",
        d: "M17.66,5h-4.04c-.44,0-.8.36-.8.8s.36.8.8.8h2.11l-6.76,6.76v-2.11c0-.44-.36-.8-.8-.8s-.8.36-.8.8v4.04c0,.08.02.15.04.22,0,.03,0,.05.02.08.08.2.24.36.44.44.02,0,.04,0,.06.01.08.02.16.05.24.05h4.04c.44,0,.8-.36.8-.8s-.36-.8-.8-.8h-2.11l6.76-6.76v2.11c0,.44.36.8.8.8s.8-.36.8-.8v-4.04c0-.44-.36-.8-.8-.8Z"
      })
    ], -1)
  ]));
}
const X3 = /* @__PURE__ */ gs(G3, [["render", Q3]]), K3 = { class: "smake:flex smake:grow smake:flex-wrap smake:gap-4 smake:text-sm smake:font-semibold smake:@md:gap-[35px]" }, J3 = {
  key: 0,
  class: "smake:flex smake:grow smake:items-center smake:gap-2"
}, Y3 = { class: "smake:flex smake:size-12 smake:items-center smake:justify-center smake:rounded-full smake:border smake:border-secondary-2 smake:p-0.5" }, e6 = {
  key: 1,
  class: "smake:flex smake:grow smake:items-center smake:gap-2"
}, t6 = { class: "smake:flex smake:size-12 smake:items-center smake:justify-center smake:rounded-full smake:border smake:border-secondary-2 smake:p-0.5" }, n6 = /* @__PURE__ */ K({
  __name: "ValidationRules",
  props: {
    productionMethodId: {}
  },
  setup(t) {
    const e = t, { productionMethodId: n } = Ae(e), { allowedExtensions: s, maxFileSizeMb: a } = xt(n);
    return (o, i) => ($(), O("div", K3, [
      c(a) ? ($(), O("div", J3, [
        x("div", Y3, [
          b(X3, { class: "smake:size-5" })
        ]),
        x("div", null, L(o.$t("max_file_size")) + " " + L(c(a)) + " MB", 1)
      ])) : X("", !0),
      c(s) ? ($(), O("div", e6, [
        x("div", t6, [
          b(W3, { class: "smake:size-5" })
        ]),
        x("div", null, [
          x("div", null, L(o.$t("supported_file_types")) + ":", 1),
          x("div", null, L(c(s).join(", ")), 1)
        ])
      ])) : X("", !0)
    ]));
  }
}), s6 = { class: "smake:absolute smake:inset-x-0 smake:mx-auto smake:flex smake:max-h-[calc(100%-64px)] smake:max-w-[1280px] smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-6 smake:@max-md:bottom-0 smake:@max-md:rounded-b-none smake:@md:top-1/2 smake:@md:mt-[18px] smake:@md:max-h-[calc(100%-18px)] smake:@md:-translate-y-1/2" }, a6 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, o6 = { class: "smake:mt-6 smake:flex smake:gap-20" }, i6 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4" }, r6 = { class: "smake:flex smake:w-full smake:flex-wrap smake:items-center smake:justify-between smake:gap-4" }, l6 = ["href"], c6 = { class: "smake:mt-2 smake:flex smake:flex-col smake:justify-center smake:gap-5 smake:@md:flex-row" }, u6 = /* @__PURE__ */ K({
  __name: "FileUploadDialogContent",
  props: /* @__PURE__ */ Ne({
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["resolve", "update:isUploadingCustomerLogo"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = t, { positioningArea: s, positioningAreaDesign: a, productionMethodId: o } = Ae(n), i = e, { t: r } = wt(), l = je(t, "open"), { uploadHelpLink: u } = D(Ma()), { allowedExtensions: m } = xt(o), h = N(), v = I(
      () => h.value && "id" in h.value
    ), { selectedProductionMethodId: _ } = D(Ze()), y = N(!1), { placeDesign: S } = Go();
    function f() {
      i("resolve", !0);
    }
    const { open: k } = Bs();
    async function w(W) {
      const Y = bl(W.logo);
      l.value = !1, await S(
        {
          design: Y,
          productionMethodId: o.value
        },
        {
          mergePostioningAreaDesign: a.value,
          positioningArea: s.value
        }
      ) !== "success" && k(Ta, {
        positioningArea: s.value,
        positioningAreaDesign: a.value,
        productionMethodId: o.value
      }), f();
    }
    const C = _k(
      I(() => ({
        ERROR_SVG_CONTAINS_IMAGE: r("upload_error_svg_contains_image"),
        ERROR_SVG_CONTAINS_TEXT: r("upload_error_svg_contains_text"),
        ERROR_UNEXPECTED: r("upload_error_unexpected")
      }))
    ), {
      error: M,
      isPending: T,
      mutate: E,
      reset: U
    } = tn({
      ...C,
      mutationFn: (W) => Af(
        {
          name: "Customer Logo Upload",
          attributes: {
            "file.name": W.file.name,
            "file.size": W.file.size,
            "file.type": W.file.type
          },
          op: "customer-logo-upload"
        },
        async (Y) => {
          try {
            const me = await C.mutationFn(W);
            return Y.setAttribute("customer-logo.id", me.id), me;
          } catch (me) {
            throw Y.setAttribute("error", String(me)), me;
          }
        }
      ),
      onError: () => {
        h.value = void 0;
      },
      onSuccess: (W) => {
        h.value = W;
      }
    });
    ie(() => {
      i("update:isUploadingCustomerLogo", T.value);
    });
    const { fieldMessages: F, message: ee } = Vb(M), Q = N(!1);
    function se(W) {
      if (!W) {
        h.value = void 0;
        return;
      }
      h.value instanceof File && E({
        file: h.value,
        productionMethodId: o.value
      });
    }
    return ie(() => {
      h.value instanceof File && (Q.value = !0);
    }), (W, Y) => {
      var he;
      const me = xe("FontAwesomeIcon");
      return $(), O("div", s6, [
        x("div", a6, [
          b(c(Tt), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
            default: P(() => [
              ce(L(W.$t("upload_own_file")), 1)
            ]),
            _: 1
          }),
          b(c(Bt), {
            class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:enabled:hover:bg-secondary-3 smake:disabled:opacity-50",
            disabled: c(T)
          }, {
            default: P(() => [
              b(me, {
                icon: ["fak", "icon-x"],
                "fixed-width": "",
                class: "smake:size-3"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        Y[5] || (Y[5] = x("hr", { class: "smake:border smake:border-secondary-2" }, null, -1)),
        x("div", o6, [
          b(D3, {
            "production-method-id": c(o),
            disabled: c(T),
            onSelected: w
          }, null, 8, ["production-method-id", "disabled"]),
          x("div", i6, [
            x("div", r6, [
              b(n6, { "production-method-id": c(o) }, null, 8, ["production-method-id"]),
              x("a", {
                class: "smake:flex smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:border-secondary-2 smake:bg-white smake:text-[14px] smake:duration-150 smake:enabled:hover:border-black smake:disabled:opacity-50 smake:@max-md:ml-[15px] smake:@max-md:underline smake:@md:border smake:@md:px-6 smake:@md:py-4",
                type: "outline",
                href: c(u),
                target: "_blank"
              }, [
                b(me, {
                  class: "smake:h-5",
                  icon: ["fal", "circle-question"],
                  "fixed-width": ""
                }),
                ce(" " + L(W.$t("help_for_upload")), 1)
              ], 8, l6)
            ]),
            b(z3, {
              modelValue: h.value,
              "onUpdate:modelValue": Y[0] || (Y[0] = (_e) => h.value = _e),
              class: "smake:grow",
              accept: (he = c(m)) == null ? void 0 : he.map((_e) => `.${_e}`),
              errors: {
                message: c(ee),
                fieldMessages: c(F)
              },
              disabled: c(T),
              onReset: c(U)
            }, null, 8, ["modelValue", "accept", "errors", "disabled", "onReset"])
          ])
        ]),
        x("div", c6, [
          b(ye, {
            class: "smake:flex smake:gap-2 smake:px-6 smake:py-4",
            type: "secondary",
            disabled: c(T),
            onClick: Y[1] || (Y[1] = (_e) => y.value = !0)
          }, {
            default: P(() => [
              b(me, {
                class: "smake:h-5",
                icon: ["fak", "icon-ciconfig-archive"],
                "fixed-width": ""
              }),
              ce(" " + L(W.$t("show_own_files")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          b(ye, {
            class: "smake:flex smake:gap-2 smake:px-6 smake:py-4",
            type: v.value ? "primary" : "secondary",
            disabled: !v.value,
            onClick: Y[2] || (Y[2] = (_e) => w(h.value))
          }, {
            default: P(() => [
              b(me, {
                icon: ["fal", "check"],
                class: "smake:h-5"
              }),
              ce(" " + L(W.$t("place_logo")), 1)
            ]),
            _: 1
          }, 8, ["type", "disabled"])
        ]),
        c(_) !== void 0 ? ($(), Z(Ml, {
          key: 0,
          open: y.value,
          "onUpdate:open": Y[3] || (Y[3] = (_e) => y.value = _e),
          "initial-production-method-id": c(_),
          "positioning-area": c(s),
          "positioning-area-design": c(a),
          "intial-tab": "customer-logos",
          onResolve: f
        }, null, 8, ["open", "initial-production-method-id", "positioning-area", "positioning-area-design"])) : X("", !0),
        b(j3, {
          open: Q.value,
          "onUpdate:open": Y[4] || (Y[4] = (_e) => Q.value = _e),
          onResolve: se
        }, null, 8, ["open"])
      ]);
    };
  }
}), Ta = /* @__PURE__ */ K({
  __name: "FileUploadDialog",
  props: /* @__PURE__ */ Ne({
    positioningArea: {},
    positioningAreaDesign: {},
    productionMethodId: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open"), { dialogsRoot: a } = D(sn()), o = N(!1);
    function i(r) {
      o.value && r.preventDefault();
    }
    return (r, l) => ($(), Z(c(zt), {
      open: s.value,
      "onUpdate:open": l[4] || (l[4] = (u) => s.value = u)
    }, {
      default: P(() => [
        b(c(Et), { to: c(a) }, {
          default: P(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0",
              onAfterLeave: l[0] || (l[0] = (u) => n("closed"))
            }, {
              default: P(() => [
                b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
            }, {
              default: P(() => [
                b(c(Rt), {
                  "as-child": "",
                  onInteractOutside: i,
                  onEscapeKeyDown: i
                }, {
                  default: P(() => [
                    b(u6, {
                      open: s.value,
                      "onUpdate:open": l[1] || (l[1] = (u) => s.value = u),
                      "positioning-area": r.positioningArea,
                      "positioning-area-design": r.positioningAreaDesign,
                      "production-method-id": r.productionMethodId,
                      onResolve: l[2] || (l[2] = (u) => n("resolve", u)),
                      "onUpdate:isUploadingCustomerLogo": l[3] || (l[3] = (u) => o.value = u)
                    }, null, 8, ["open", "positioning-area", "positioning-area-design", "production-method-id"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), d6 = /* @__PURE__ */ K({
  __name: "FileUploadButton",
  props: {
    positioningArea: {},
    positioningAreaDesign: {}
  },
  setup(t) {
    const { selectedProductionMethodId: e } = D(Ze()), { isCustomerLogoUploadEnabled: n } = xt(
      e
    ), s = N(!1);
    return (a, o) => ($(), Z(c(Ya), {
      name: c(At).CUSTOMER_LOGO_UPLOAD
    }, {
      default: P(() => [
        c(n) ? ($(), O(re, { key: 0 }, [
          b(eo, {
            icon: ["fal", "arrow-up-from-bracket"],
            text: a.$t("upload_file"),
            primary: "",
            "data-testid": "CustomerLogoUploadButton",
            onClick: o[0] || (o[0] = (i) => s.value = !0)
          }, null, 8, ["text"]),
          c(e) ? ($(), Z(Ta, {
            key: 0,
            open: s.value,
            "onUpdate:open": o[1] || (o[1] = (i) => s.value = i),
            "production-method-id": c(e),
            "positioning-area": a.positioningArea,
            "positioning-area-design": a.positioningAreaDesign
          }, null, 8, ["open", "production-method-id", "positioning-area", "positioning-area-design"])) : X("", !0)
        ], 64)) : X("", !0)
      ]),
      _: 1
    }, 8, ["name"]));
  }
}), qs = {
  cm: 10,
  in: 25.4,
  mm: 1
}, Hr = tt("favoriteColors", () => {
  const { userExternalIdentifier: t } = D(ba()), e = jp(
    `smake-designer-favorite-colors-hex-${t.value ?? ""}`,
    []
  ), n = I(
    () => e.value.map((a) => Bo(a)).filter((a) => a !== void 0)
  );
  function s(a) {
    const o = Hm(a);
    e.value.includes(o) && (e.value = e.value.filter(
      (i) => i !== o
    )), e.value.unshift(o), !(e.value.length <= 20) && e.value.pop();
  }
  return {
    add: s,
    colors: Un(n)
  };
}), m6 = /* @__PURE__ */ K({
  __name: "ColorAreaHue",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), n = xo("hueArea"), { pressed: s } = Qu({ target: n }), { elementX: a, elementY: o } = Xu(n);
    ht(
      [o, a, s],
      () => {
        s.value && r(o.value);
      },
      { immediate: !0 }
    );
    const i = I(() => n.value ? {
      top: `${((1 - e.value.hue / 360) * n.value.clientHeight).toString()}px`
    } : void 0);
    function r(l) {
      if (!n.value) return;
      const m = (1 - wr(l / n.value.clientHeight, 0, 1)) * 360;
      e.value = { ...e.value, hue: m };
    }
    return (l, u) => ($(), O("div", {
      ref_key: "hueArea",
      ref: n,
      class: Se(["smake:relative smake:h-full smake:w-[22px] smake:touch-none smake:rounded-full smake:bg-[linear-gradient(0deg,red,yellow,lime,aqua,blue,magenta,red)]", {
        "smake:cursor-grabbing": c(s),
        "smake:cursor-pointer": !c(s)
      }])
    }, [
      x("div", {
        class: "smake:pointer-events-none smake:absolute smake:h-5 smake:w-5 smake:-translate-y-1/2 smake:rounded-full smake:border-2 smake:border-white",
        style: Wt(i.value)
      }, null, 4)
    ], 2));
  }
}), h6 = /* @__PURE__ */ K({
  __name: "ColorAreaSaturartionValue",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), n = xo("colorArea");
    function s(l, u) {
      if (!n.value) return;
      const m = wr(l / n.value.clientWidth, 0, 1), h = wr(u / n.value.clientHeight, 0, 1);
      e.value = {
        ...e.value,
        saturation: m * 100,
        value: (1 - h) * 100
      };
    }
    const { pressed: a } = Qu({ target: n }), { elementX: o, elementY: i } = Xu(n);
    ht(
      [i, o, a],
      () => {
        a.value && s(o.value, i.value);
      },
      { immediate: !0 }
    );
    const r = I(() => {
      if (!n.value) return;
      const l = e.value.saturation / 100 * n.value.clientWidth, u = (1 - e.value.value / 100) * n.value.clientHeight;
      return {
        left: `${l.toString()}px`,
        top: `${u.toString()}px`
      };
    });
    return (l, u) => ($(), O("div", {
      ref_key: "colorArea",
      ref: n,
      class: Se(["smake:relative smake:h-full smake:w-full smake:touch-none smake:rounded-md smake:bg-[linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))]", {
        "smake:cursor-grabbing": c(a),
        "smake:cursor-pointer": !c(a)
      }]),
      style: Wt({
        backgroundColor: `hsl(${e.value.hue}deg,100%, 50%)`
      })
    }, [
      x("div", {
        class: "smake:pointer-events-none smake:absolute smake:h-5 smake:w-5 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:rounded-full smake:border-2 smake:border-white",
        style: Wt(r.value),
        colorSelectorStyle: ""
      }, null, 4)
    ], 6));
  }
}), p6 = /* @__PURE__ */ K({
  __name: "ColorButton",
  props: {
    color: {}
  },
  setup(t) {
    const e = t, { color: n } = Ae(e), { colorRGB: s } = qo(n), a = I(
      () => $l([
        s.value.red,
        s.value.green,
        s.value.blue
      ])
    );
    return (o, i) => ($(), O("button", {
      class: Se(["smake:flex smake:aspect-square smake:w-10 smake:items-center smake:justify-center smake:rounded-full smake:border", {
        "smake:border-secondary-2": a.value,
        "smake:border-transparent": !a.value
      }]),
      style: Wt({
        backgroundColor: `rgb(${c(s).red}, ${c(s).green}, ${c(s).blue}) !important`
      })
    }, null, 6));
  }
}), f6 = { class: "smake:flex smake:flex-col smake:gap-2" }, v6 = { class: "smake:text-sm smake:font-semibold" }, g6 = { class: "smake:grid smake:grid-cols-6 smake:gap-2" }, _6 = /* @__PURE__ */ K({
  __name: "ColorFavorites",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const { add: e } = Hr(), { colors: n } = D(Hr()), s = je(t, "modelValue");
    function a() {
      e({ ...s.value });
    }
    return (o, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), O("div", f6, [
        x("div", v6, L(o.$t("recently_used")), 1),
        x("div", g6, [
          b(ye, {
            type: "secondary",
            class: "smake:flex smake:aspect-square smake:w-10 smake:items-center smake:justify-center smake:p-1",
            onClick: a
          }, {
            default: P(() => [
              b(r, {
                icon: ["fal", "plus"],
                class: "smake:h-3"
              })
            ]),
            _: 1
          }),
          ($(!0), O(re, null, $e(c(n), (l) => ($(), Z(p6, {
            key: c(He)(l),
            class: "smake:flex smake:aspect-square smake:w-8 smake:items-center smake:justify-center smake:rounded-full",
            color: l,
            onClick: (u) => s.value = { ...l }
          }, null, 8, ["color", "onClick"]))), 128))
        ])
      ]);
    };
  }
});
function Qo(t, e, n) {
  const s = jt(n == null ? void 0 : n.min), a = jt(n == null ? void 0 : n.max), o = jt(n == null ? void 0 : n.step), i = N(
    typeof t.value == "number" ? sa(t.value, s.value, a.value, o.value) : ""
  );
  ht(t, (l) => {
    var m;
    const u = (m = e.value) == null ? void 0 : m.getRootNode();
    !(u instanceof Document || u instanceof ShadowRoot) || u.activeElement === e.value || (i.value = typeof l == "number" ? sa(l, s.value, a.value, o.value) : "");
  }), ht(i, (l) => {
    l !== (typeof t.value == "number" ? sa(t.value, s.value, a.value, o.value) : "") && (t.value = typeof l == "number" ? sa(l, s.value, a.value, o.value) : n != null && n.optional ? void 0 : 0);
  });
  function r() {
    i.value = typeof t.value == "number" ? sa(t.value, s.value, a.value, o.value) : "";
  }
  return { inputValue: i, onBlur: r };
}
function sa(t, e, n, s) {
  return s !== void 0 && (t = Number(
    (Math.round(t / s) * s).toFixed(
      Math.ceil(-Math.log10(s))
    )
  )), e !== void 0 && (t = Math.max(t, e)), n !== void 0 && (t = Math.min(t, n)), t;
}
const k6 = ["min", "max", "step"], as = /* @__PURE__ */ K({
  __name: "NumberInput",
  props: /* @__PURE__ */ Ne({
    max: {},
    min: {},
    step: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t, { expose: e }) {
    const n = t, { max: s, min: a, step: o } = Bp(n), i = je(t, "modelValue"), r = N(), { focused: l } = Ku(r), { inputValue: u, onBlur: m } = Qo(i, r, { max: s, min: a, step: o });
    return e({
      focused: l
    }), (h, v) => ot(($(), O("input", {
      ref_key: "input",
      ref: r,
      "onUpdate:modelValue": v[0] || (v[0] = (_) => _t(u) ? u.value = _ : null),
      class: "smake:appearance-textfield smake:h-full smake:w-12 smake:rounded smake:border smake:border-secondary-2 smake:px-2 smake:focus:border-secondary-1",
      min: c(a),
      max: c(s),
      step: c(o),
      type: "number",
      onBlur: v[1] || (v[1] = //@ts-ignore
      (..._) => c(m) && c(m)(..._))
    }, null, 40, k6)), [
      [pn, c(u)]
    ]);
  }
}), y6 = { class: "smake:flex smake:w-full smake:gap-2" }, b6 = /* @__PURE__ */ K({
  __name: "ColorInputCmyk",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), { colorCMYK: n } = qo(e);
    return (s, a) => ($(), O("div", y6, [
      b(as, {
        "model-value": c(n).cyan,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": a[0] || (a[0] = (o) => n.value = { ...c(n), cyan: o })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": c(n).magenta,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": a[1] || (a[1] = (o) => n.value = { ...c(n), magenta: o })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": c(n).yellow,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": a[2] || (a[2] = (o) => n.value = { ...c(n), yellow: o })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": c(n).key,
        min: 0,
        max: 100,
        step: 1,
        "onUpdate:modelValue": a[3] || (a[3] = (o) => n.value = { ...c(n), key: o })
      }, null, 8, ["model-value"])
    ]));
  }
}), w6 = /* @__PURE__ */ K({
  __name: "ColorInputHex",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), { colorHex: n } = qo(e), s = N(n.value), a = I({
      get() {
        return i.value ? s.value : n.value.replace("#", "");
      },
      set(u) {
        n.value = "#" + u, s.value = u;
      }
    }), o = xo("input"), { focused: i } = Ku(o), r = I(() => Bo("#" + s.value) !== void 0);
    function l(u) {
      var h;
      u.preventDefault();
      const m = (h = u.clipboardData) == null ? void 0 : h.getData("text").replace("#", "");
      m && (a.value = m);
    }
    return ie(() => {
      i.value || (s.value = n.value.replace("#", ""));
    }), (u, m) => ($(), O("div", {
      class: Se(["smake:flex smake:items-center smake:gap-2 smake:overflow-clip smake:rounded smake:border smake:px-2", {
        "smake:border-danger": !r.value,
        "smake:border-secondary-2": r.value
      }])
    }, [
      m[1] || (m[1] = x("div", { class: "smake:-ml-2 smake:flex smake:h-full smake:items-center smake:bg-secondary-3 smake:px-2" }, " # ", -1)),
      ot(x("input", {
        ref_key: "input",
        ref: o,
        "onUpdate:modelValue": m[0] || (m[0] = (h) => a.value = h),
        class: "smake:w-full smake:focus:outline-hidden",
        maxlength: "6",
        onPaste: l
      }, null, 544), [
        [pn, a.value]
      ])
    ], 2));
  }
}), x6 = { class: "smake:flex smake:w-full smake:gap-2" }, $6 = /* @__PURE__ */ K({
  __name: "ColorInputRgb",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), { colorRGB: n } = qo(e);
    return (s, a) => ($(), O("div", x6, [
      b(as, {
        "model-value": c(n).red,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": a[0] || (a[0] = (o) => n.value = { ...c(n), red: o })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": c(n).green,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": a[1] || (a[1] = (o) => n.value = { ...c(n), green: o })
      }, null, 8, ["model-value"]),
      b(as, {
        "model-value": c(n).blue,
        min: 0,
        max: 255,
        step: 1,
        "onUpdate:modelValue": a[2] || (a[2] = (o) => n.value = { ...c(n), blue: o })
      }, null, 8, ["model-value"])
    ]));
  }
}), S6 = { class: "smake:flex smake:gap-2" }, A6 = /* @__PURE__ */ K({
  __name: "ColorInput",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), n = {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      cmyk: b6,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      hex: w6,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      rgb: $6
    }, s = Object.keys(
      n
    ), a = N(s[2]), { rootElement: o } = D(Ut());
    return (i, r) => {
      const l = xe("Icon");
      return $(), O("div", S6, [
        b(c(rd), {
          modelValue: a.value,
          "onUpdate:modelValue": r[0] || (r[0] = (u) => a.value = u)
        }, {
          default: P(() => [
            b(c(ld), {
              class: "smake:inline-flex smake:h-[35px] smake:w-[100px] smake:items-center smake:justify-between smake:gap-[5px] smake:rounded smake:border smake:border-secondary-2 smake:px-[5px] smake:outline-hidden",
              "aria-label": "Customise options"
            }, {
              default: P(() => [
                b(c(cd), { placeholder: "Select a mode" })
              ]),
              _: 1
            }),
            b(c(ud), { to: c(o) }, {
              default: P(() => [
                b(c(dd), { class: "smake:data-[side=top]:animate-slideDownAndFade smake:data-[side=right]:animate-slideLeftAndFade smake:data-[side=bottom]:animate-slideUpAndFade smake:data-[side=left]:animate-slideRightAndFade smake:z-100 smake:rounded smake:border smake:border-secondary-2 smake:bg-white smake:will-change-[opacity,transform]" }, {
                  default: P(() => [
                    b(c(md), null, {
                      default: P(() => [
                        ($(!0), O(re, null, $e(c(s), (u, m) => ($(), Z(c(od), {
                          key: m,
                          class: "smake:relative smake:flex smake:h-[25px] smake:items-center smake:rounded-[3px] smake:px-4 smake:py-4 smake:select-none smake:data-highlighted:bg-secondary-3 smake:data-highlighted:outline-hidden",
                          value: u
                        }, {
                          default: P(() => [
                            b(c(id), null, {
                              default: P(() => [
                                ce(L(u.toUpperCase()), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value"]))), 128))
                      ]),
                      _: 1
                    }),
                    b(c(Lf), { class: "smake:flex smake:h-[25px] smake:cursor-default smake:items-center smake:justify-center smake:bg-white" }, {
                      default: P(() => [
                        b(l, { icon: "radix-icons:chevron-down" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        a.value ? ($(), Z(Kr(n[a.value]), {
          key: 0,
          modelValue: e.value,
          "onUpdate:modelValue": r[1] || (r[1] = (u) => e.value = u),
          class: "smake:w-full"
        }, null, 8, ["modelValue"])) : X("", !0)
      ]);
    };
  }
}), C6 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAADm5AAA5uQH05n92AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAs1JREFUaIHd2r9rFEEUwPHvJNHmKg1qECxEELvkjIlCRKz8I4Q0iiCmiNgqFqKFjWBxiRiToKSMPyCFAa20FFJpo6ZQIiLGhOBFVGKexe7Gvbv9dbtvb+d88Jq7m7n3uXmzO7mcERFsDGPMAWAEOAXsBzaBReApUBGRpZoBImJVAga4CvwGJCR/AKM144ouvA7RCdyPANTnLesgLuJBEwgvz1oDSbES/qwCPV1pNqJmGGM6gWlgOOUUJeCCcT+RQkIB4cVCbhBjzG7gPDAAbAAvgAkRqbrPayEA1vLq+SFgmcZ+XgQOkX5jh++THBDHge8Rb/oFeKKIEOCNamsZY3qA10C32qTJ4naH8oQjtB6xAYxpQ44pz5ckborIW23IH+X54mIW51yGNuSl8nxR8RA4LSKbgO4RBdgBLKF7RQrKWWBbzXvncPntJfgekhsiL0iHu+wtQ6hDcP4oGm81QhVSJEIN4rbTZE6IuTiECiQBYhU4A3xLCfkEHMwVkhAx4L72cAbMO6CUC6QZhG9MFsyoOiQNwjd2OCXkkSrERdyLQRwJGZvlZjmnBsmI6MuAEOCKCqRgxFdgV2ZIzojHRF8AqsCJ2BoVECsZENPu/GWc+0X988tJELGQViB8r98JXAbmgWfANWBP4taPQBhgLKadBkPG9rp9HTZ2yo/QyP8CEQhpR0QDJCOiryhEDUQBEbWxc0XUQ+5EFLIC9NuK2IIAl9oZ4dbCXmA9op3CTrHWIDzIjRQrUbYJ4UEWAgr5GbES1iE8yFpAMZWUiMkiECJCF7Cdxlitf8AYUwae45yJgmIKOCfed7EFxHsaP9kPQLdvJfqJPmoXthL+1poIKe4jcB2o4OwZaxEe5CjOD1bCCo1KKxAi/26IM+2M8ENKwKsmEHdtQmxBfJiZmDZbBy4WXXRQNvx72hgziPNd7UlgH/DLvbLNA+Mi8hkL4y9wbQOjiqne7QAAAABJRU5ErkJggg==", P6 = /* @__PURE__ */ K({
  __name: "EyeDropper",
  emits: ["selected"],
  setup(t, { emit: e }) {
    const { isSupported: n, open: s, sRGBHex: a } = qp(), o = e;
    return ie(() => {
      a.value.length !== 0 && o("selected", a.value);
    }), (i, r) => c(n) ? ($(), Z(ye, {
      key: 0,
      type: "secondary",
      class: "smake:aspect-square smake:h-8 smake:cursor-pointer smake:rounded-full smake:bg-secondary-3 smake:p-1",
      onClick: c(s)
    }, {
      default: P(() => r[0] || (r[0] = [
        x("img", {
          src: C6,
          class: "smake:aspect-square smake:w-4",
          alt: ""
        }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 8, ["onClick"])) : X("", !0);
  }
}), I6 = { class: "smake:flex smake:w-[318px] smake:flex-col smake:justify-center smake:gap-4 smake:@sm:w-[350px]" }, M6 = { class: "smake:flex smake:h-64 smake:gap-4 smake:px-2" }, T6 = { class: "smake:flex smake:items-center smake:gap-3" }, z6 = /* @__PURE__ */ K({
  __name: "ColorPicker",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), { colorHSV: n } = hy(e);
    function s(a) {
      const o = Bo(a);
      o && (n.value = o);
    }
    return (a, o) => ($(), O("div", I6, [
      x("div", M6, [
        b(m6, {
          modelValue: c(n),
          "onUpdate:modelValue": o[0] || (o[0] = (i) => _t(n) ? n.value = i : null)
        }, null, 8, ["modelValue"]),
        b(h6, {
          modelValue: c(n),
          "onUpdate:modelValue": o[1] || (o[1] = (i) => _t(n) ? n.value = i : null)
        }, null, 8, ["modelValue"])
      ]),
      x("div", T6, [
        b(P6, { onSelected: s }),
        b(A6, {
          modelValue: c(n),
          "onUpdate:modelValue": o[2] || (o[2] = (i) => _t(n) ? n.value = i : null)
        }, null, 8, ["modelValue"])
      ]),
      b(_6, {
        modelValue: c(n),
        "onUpdate:modelValue": o[3] || (o[3] = (i) => _t(n) ? n.value = i : null)
      }, null, 8, ["modelValue"])
    ]));
  }
}), E6 = { class: "smake:flex smake:grow smake:flex-col smake:gap-2.5 smake:bg-white" }, O6 = { class: "smake:flex smake:grow smake:justify-between smake:gap-6" }, R6 = { class: "smake:flex smake:items-center smake:gap-2" }, L6 = /* @__PURE__ */ K({
  __name: "ColorPickerButton",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), { rootElement: n } = D(Ut()), { appConfiguration: s } = D(it()), { add: a } = Hr(), o = N({ blue: 0, green: 0, red: 255 });
    ie(() => {
      var l;
      if ("id" in e.value) {
        const u = (l = s.value) == null ? void 0 : l.colors.find(
          ({ id: m }) => "id" in e.value && e.value.id === m
        );
        if (!u) return;
        o.value = {
          blue: u.blue,
          green: u.green,
          red: u.red
        };
      } else
        o.value = { ...e.value };
    });
    const i = N(!1);
    function r() {
      a(Ca(o.value)), i.value = !1, e.value = o.value;
    }
    return (l, u) => {
      const m = xe("FontAwesomeIcon");
      return $(), Z(c(pd), {
        open: i.value,
        "onUpdate:open": u[2] || (u[2] = (h) => i.value = h)
      }, {
        default: P(() => [
          b(c(fd), { class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs" }, {
            default: P(() => [
              x("div", {
                class: Se([
                  "smake:rounded-full smake:border smake:p-1",
                  "id" in e.value ? "smake:border-transparent" : "smake:border-black"
                ])
              }, u[3] || (u[3] = [
                x("div", { class: "smake:relative smake:size-12 smake:rounded-full smake:bg-[conic-gradient(red,yellow,lime,aqua,blue,magenta,red)]" }, [
                  x("div", { class: "smake:absolute smake:inset-1/2 smake:size-6 smake:-translate-1/2 smake:rounded-full smake:bg-white" })
                ], -1)
              ]), 2),
              ce(" " + L(l.$t("custom")), 1)
            ]),
            _: 1
          }),
          b(c(vd), { to: c(n) }, {
            default: P(() => [
              b(c(gd), {
                class: "smake:z-50 smake:rounded-2xl smake:border smake:border-secondary-1 smake:bg-white smake:p-5",
                side: "bottom",
                align: "start",
                onInteractOutside: u[1] || (u[1] = (h) => h.preventDefault())
              }, {
                default: P(() => [
                  x("div", E6, [
                    x("div", O6, [
                      x("div", {
                        class: "smake:aspect-square smake:h-10 smake:rounded-full smake:border smake:border-secondary-2",
                        style: Wt({
                          backgroundColor: `rgb(${o.value.red},${o.value.green},${o.value.blue})`
                        })
                      }, null, 4),
                      x("div", R6, [
                        u[4] || (u[4] = x("div", { class: "grow" }, null, -1)),
                        b(ye, {
                          class: "smake:flex smake:items-center smake:gap-2 smake:text-xs",
                          type: "primary",
                          onClick: r
                        }, {
                          default: P(() => [
                            ce(L(l.$t("select_color")) + " ", 1),
                            b(m, {
                              class: "smake:h-3",
                              icon: ["fal", "check"]
                            })
                          ]),
                          _: 1
                        }),
                        b(c(_d), { "as-child": "" }, {
                          default: P(() => [
                            b(ye, {
                              type: "secondary",
                              class: "smake:flex smake:aspect-square smake:items-center smake:justify-center smake:p-3"
                            }, {
                              default: P(() => [
                                b(m, {
                                  class: "smake:h-3",
                                  icon: ["fak", "icon-x"],
                                  "fixed-width": ""
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    b(z6, {
                      modelValue: o.value,
                      "onUpdate:modelValue": u[0] || (u[0] = (h) => o.value = h)
                    }, null, 8, ["modelValue"]),
                    b(c(Df), {
                      class: "smake:size-5 smake:-translate-y-2.5 smake:rotate-45 smake:border-r smake:border-b smake:border-secondary-1 smake:bg-white",
                      as: "div"
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), D6 = { class: "smake:absolute smake:inset-0 smake:z-10 smake:flex smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4" }, N6 = { class: "smake:grid smake:grid-cols-auto-fill-15.5 smake:gap-4" }, V6 = ["onClick"], U6 = {
  key: 1,
  class: "smake:border-secondary-2"
}, F6 = { class: "smake:grid smake:grid-cols-auto-fill-15.5 smake:gap-4" }, j6 = ["onClick"], B6 = /* @__PURE__ */ K({
  __name: "ColorSelection",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), { appConfiguration: n } = D(it()), { selectedProductionMethodId: s } = D(Ze()), a = I(
      () => {
        var l, u;
        return (u = (l = n.value) == null ? void 0 : l.productionMethods.find(
          ({ id: m }) => m === s.value
        )) == null ? void 0 : u.is_using_color_picker;
      }
    ), o = I(
      () => {
        var l;
        return ((l = n.value) == null ? void 0 : l.colors.filter(
          (u) => u.production_methods.some(
            ({ id: m }) => m === s.value
          )
        )) ?? [];
      }
    ), i = I(
      () => o.value.filter((l) => l.is_customer_logo_color)
    ), r = I(
      () => o.value.filter((l) => l.is_standard)
    );
    return (l, u) => ($(), O("div", D6, [
      i.value.length > 0 ? ($(), O(re, { key: 0 }, [
        ce(L(l.$t("colors")) + ": ", 1),
        x("div", N6, [
          ($(!0), O(re, null, $e(i.value, (m) => ($(), O("button", {
            key: m.id,
            type: "button",
            class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs",
            onClick: (h) => e.value = { id: m.id }
          }, [
            x("div", {
              class: Se([
                "smake:rounded-full smake:border smake:p-1",
                "id" in e.value && e.value.id === m.id ? "smake:border-black" : "smake:border-transparent"
              ])
            }, [
              x("div", {
                class: "smake:size-12 smake:rounded-full smake:border smake:border-secondary-2",
                style: Wt({
                  backgroundColor: `rgb(${m.red}, ${m.green}, ${m.blue})`
                })
              }, null, 4)
            ], 2),
            ce(" " + L(m.display_name), 1)
          ], 8, V6))), 128))
        ])
      ], 64)) : X("", !0),
      i.value.length > 0 && r.value.length > 0 ? ($(), O("hr", U6)) : X("", !0),
      r.value.length > 0 ? ($(), O(re, { key: 2 }, [
        ce(L(l.$t("standard_colors")) + ": ", 1),
        x("div", F6, [
          a.value ? ($(), Z(L6, {
            key: 0,
            modelValue: e.value,
            "onUpdate:modelValue": u[0] || (u[0] = (m) => e.value = m)
          }, null, 8, ["modelValue"])) : X("", !0),
          ($(!0), O(re, null, $e(r.value, (m) => ($(), O("button", {
            key: m.id,
            type: "button",
            class: "smake:flex smake:flex-col smake:items-center smake:gap-2 smake:text-xs",
            onClick: (h) => e.value = { id: m.id }
          }, [
            x("div", {
              class: Se([
                "smake:rounded-full smake:border smake:p-1",
                "id" in e.value && e.value.id === m.id ? "smake:border-black" : "smake:border-transparent"
              ])
            }, [
              x("div", {
                class: "smake:size-12 smake:rounded-full smake:border smake:border-secondary-2",
                style: Wt({
                  backgroundColor: `rgb(${m.red}, ${m.green}, ${m.blue})`
                })
              }, null, 4)
            ], 2),
            ce(" " + L(m.display_name), 1)
          ], 8, j6))), 128))
        ])
      ], 64)) : X("", !0)
    ]));
  }
}), q6 = ["title"], Wr = /* @__PURE__ */ K({
  __name: "ColorInput",
  props: /* @__PURE__ */ Ne({
    disabled: { type: Boolean },
    showName: { type: Boolean }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), { appConfiguration: n } = D(it()), { t: s } = wt(), a = N(!1), o = I(() => {
      var u;
      if (!("id" in e.value)) return;
      const { id: l } = e.value;
      return (u = n.value) == null ? void 0 : u.colors.find(({ id: m }) => m === l);
    }), i = I(() => {
      var l;
      return ((l = o.value) == null ? void 0 : l.display_name) ?? s("custom");
    }), r = I(() => "id" in e.value ? o.value : e.value);
    return (l, u) => {
      const m = xe("FontAwesomeIcon");
      return $(), O(re, null, [
        b(ye, {
          type: "outline",
          disabled: l.disabled,
          class: "smake:disabled:opacity-100",
          onClick: u[0] || (u[0] = (h) => a.value = !0)
        }, {
          default: P(() => [
            x("div", {
              class: "smake:size-7 smake:shrink-0 smake:rounded-full smake:border smake:border-secondary-2 smake:duration-150",
              style: Wt({
                backgroundColor: r.value ? `rgb(${r.value.red}, ${r.value.green}, ${r.value.blue})` : void 0
              })
            }, null, 4),
            l.showName ? ($(), O("div", {
              key: 0,
              class: "smake:grow smake:overflow-hidden smake:text-start smake:text-ellipsis smake:whitespace-nowrap",
              title: i.value
            }, L(i.value), 9, q6)) : X("", !0),
            l.disabled ? X("", !0) : ($(), Z(m, {
              key: 1,
              class: "smake:mx-1 smake:size-5 smake:shrink-0",
              icon: ["fal", "chevron-right"]
            }))
          ]),
          _: 1
        }, 8, ["disabled"]),
        b(De, {
          appear: "",
          "enter-active-class": "smake:duration-300 smake:ease-out",
          "enter-from-class": "smake:opacity-0",
          "leave-active-class": "smake:duration-200 smake:ease-in",
          "leave-to-class": "smake:opacity-0"
        }, {
          default: P(() => [
            a.value ? ($(), Z(B6, {
              key: 0,
              modelValue: e.value,
              "onUpdate:modelValue": [
                u[1] || (u[1] = (h) => e.value = h),
                u[2] || (u[2] = (h) => a.value = !1)
              ]
            }, null, 8, ["modelValue"])) : X("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), H6 = {}, W6 = { class: "smake:relative smake:flex smake:shrink-0 smake:flex-col smake:gap-4 smake:overflow-hidden smake:rounded-2xl smake:border smake:border-secondary-2 smake:p-4" };
function G6(t, e) {
  return $(), O("div", W6, [
    Nt(t.$slots, "default")
  ]);
}
const Tl = /* @__PURE__ */ gs(H6, [["render", G6]]);
function As(t, e, n = []) {
  for (const s of t)
    if (e(s, n) || As(s.children, e, [...n, s]))
      return !0;
  return !1;
}
function Gr(t) {
  const e = [];
  return As(t, (n) => {
    e.push(...n.logos);
  }), new Set(e).size;
}
function ah(t, e = null) {
  const n = [];
  for (const s of t)
    s.parent_id === e && n.push({
      ...s,
      children: ah(t, s.id)
    });
  return n.sort((s, a) => s.left - a.left), n;
}
const _s = tt("logos", () => {
  const { selectedProductionMethodId: t } = D(
    Ze()
  ), e = N(), { animateHeight: n } = Gm(e), s = N(!1), a = I({
    get: () => s.value,
    set: (F) => {
      F !== s.value && n(
        () => s.value = !s.value
      );
    }
  }), o = N([]), i = N(), r = N(t.value);
  ie(() => {
    r.value === void 0 && (r.value = t.value);
  }), ht(r, () => {
    o.value = [];
  });
  const l = N();
  Hp(i, () => {
    var F;
    l.value = ((F = i.value) == null ? void 0 : F.trim()) || void 0;
  });
  const u = le.logos.categories.list.use(
    I(() => ({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      production_method: [r.value]
    }))
  ), { data: m } = kt({
    ...u,
    enabled: I(
      () => u.enabled.value && r.value !== void 0
    ),
    retry: !1,
    staleTime: 1 / 0
  }), h = I(
    () => ah(m.value ?? [])
  ), v = I(() => {
    const F = [];
    return As(h.value, (ee) => {
      o.value.includes(ee.id) && F.push(ee);
    }), F;
  }), _ = le.logos.count.use(
    I(() => ({
      name_or_tags: l.value,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      production_method: [r.value]
    }))
  ), { data: y } = kt({
    ..._,
    enabled: I(
      () => _.enabled.value && r.value !== void 0
    ),
    retry: !1,
    staleTime: 1 / 0
  }), S = I(
    () => v.value.length === 0 ? y.value ?? 0 : Gr(v.value)
  ), f = le.logos.list.use(
    I(() => ({
      "categories.id": o.value,
      name_or_tags: l.value,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      production_method: [r.value]
    }))
  ), {
    data: k,
    fetchNextPage: w,
    fetchStatus: C,
    hasNextPage: M,
    status: T
  } = zs({
    ...f,
    enabled: I(
      () => f.enabled.value && r.value !== void 0
    ),
    retry: !1,
    select: (F) => F.pages.flatMap((ee) => ee.data),
    staleTime: 1 / 0
  });
  function E() {
    o.value = [], i.value = void 0, r.value = t.value;
  }
  function U(F) {
    if (o.value.includes(F.id)) {
      o.value = o.value.filter(
        (se) => se !== F.id
      );
      return;
    }
    let ee = [];
    As(h.value, (se, W) => se.id === F.id ? (ee = W.map((Y) => Y.id), !0) : !1);
    const Q = [];
    As(F.children, (se) => {
      Q.push(se.id);
    }), o.value = o.value.filter(
      (se) => !ee.includes(se) && !Q.includes(se)
    ), o.value.push(F.id), o.value.sort();
  }
  return {
    activeCategories: v,
    activeCategoryIds: o,
    activeProductionMethodId: r,
    categoriesTree: h,
    count: S,
    fetchNextPage: w,
    fetchStatus: C,
    hasNextPage: M,
    logos: k,
    mobileSearchElement: e,
    mobileSearchOpen: a,
    normalizedSearchQuery: Un(l),
    resetFilters: E,
    searchQuery: i,
    status: T,
    toggleCategory: U
  };
}), Z6 = {
  key: 0,
  class: "smake:absolute smake:top-0 smake:right-0 smake:translate-x-1/4 smake:-translate-y-1/4 smake:rounded-full smake:border-2 smake:border-white smake:bg-black smake:px-1.5"
}, Q6 = { class: "smake:grid smake:grid-cols-2 smake:gap-x-4 smake:gap-y-2 smake:p-6" }, X6 = { class: "smake:text-secondary-1" }, oh = /* @__PURE__ */ K({
  __name: "Button",
  props: {
    data: {},
    depth: { default: 0 }
  },
  setup(t) {
    const e = t, { data: n } = Ae(e), s = _s(), { activeCategoryIds: a } = D(s), { rootElement: o } = D(Ut()), i = I(
      () => a.value.includes(n.value.id)
    ), r = I(() => {
      const m = [];
      return As(n.value.children, (h) => {
        a.value.includes(h.id) && m.push(h);
      }), m;
    }), l = I(() => {
      const m = [...r.value];
      return i.value && m.push(n.value), m;
    });
    function u() {
      l.value.length > 0 || s.toggleCategory(n.value);
    }
    return (m, h) => {
      const v = xe("FontAwesomeIcon"), _ = xe("Button", !0);
      return m.depth === 0 ? ($(), O(re, { key: 0 }, [
        c(n).children.length === 0 ? ($(), Z(ye, {
          key: 0,
          type: "outline",
          class: Se(["smake:px-6 smake:py-2.5", {
            "smake:bg-black smake:text-white smake:hover:bg-black/80": i.value
          }]),
          onClick: h[0] || (h[0] = (y) => c(s).toggleCategory(c(n)))
        }, {
          default: P(() => [
            ce(L(c(n).name), 1)
          ]),
          _: 1
        }, 8, ["class"])) : ($(), Z(c(pd), { key: 1 }, {
          default: P(() => [
            b(c(fd), { "as-child": "" }, {
              default: P(() => [
                b(ye, {
                  type: "outline",
                  class: Se(["smake:relative smake:px-6 smake:py-2.5", {
                    "smake:bg-black smake:text-white smake:hover:bg-black/80": l.value.length > 0
                  }])
                }, {
                  default: P(() => [
                    ce(L(c(n).name) + " ", 1),
                    b(v, {
                      icon: ["fal", "chevron-down"],
                      class: "smake:size-4"
                    }),
                    r.value.length > 0 ? ($(), O("div", Z6, L(r.value.length), 1)) : X("", !0)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }),
            b(c(vd), { to: c(o) }, {
              default: P(() => [
                b(c(gd), {
                  class: "smake:flex smake:flex-col smake:rounded smake:bg-white smake:text-sm smake:shadow-[0px_0px_15px_0px_rgba(0,0,0,0.25)]",
                  align: "start",
                  "side-offset": 8
                }, {
                  default: P(() => [
                    x("div", Q6, [
                      ($(!0), O(re, null, $e(c(n).children, (y) => ($(), Z(_, {
                        key: y.id,
                        data: y,
                        depth: m.depth + 1
                      }, null, 8, ["data", "depth"]))), 128))
                    ]),
                    b(c(_d), { "as-child": "" }, {
                      default: P(() => [
                        b(ye, {
                          type: "primary",
                          class: "smake:rounded-none smake:text-sm",
                          onClick: u
                        }, {
                          default: P(() => [
                            ce(L(m.$t("show_X_results", {
                              count: c(Gr)(
                                l.value.length === 0 ? [c(n)] : l.value
                              )
                            })), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }))
      ], 64)) : ($(), Z(ye, {
        key: 1,
        type: "outline",
        class: Se(["smake:px-4 smake:py-1.5 smake:text-sm", {
          "smake:bg-black smake:text-white smake:hover:bg-black/80": i.value
        }]),
        onClick: h[1] || (h[1] = (y) => c(s).toggleCategory(c(n)))
      }, {
        default: P(() => [
          ce(L(c(n).name) + " ", 1),
          x("span", X6, L(c(Gr)([c(n)])), 1)
        ]),
        _: 1
      }, 8, ["class"]));
    };
  }
}), K6 = { class: "smake:absolute smake:inset-0 smake:top-16 smake:flex smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4" }, J6 = { class: "smake:flex smake:justify-end" }, Y6 = { class: "smake:font-bold" }, ex = { class: "smake:flex smake:flex-col smake:gap-2 smake:pb-2" }, tx = { class: "smake:flex smake:shrink-0 smake:gap-2 smake:overflow-x-auto" }, nx = ["onClick"], sx = { class: "smake:rounded-full smake:bg-white smake:p-1 smake:text-black" }, ax = { class: "smake:flex smake:gap-2" }, ox = /* @__PURE__ */ K({
  __name: "Dialog",
  setup(t) {
    const { rootElement: e } = D(Ut()), n = _s(), { activeCategories: s, activeCategoryIds: a, categoriesTree: o, count: i } = D(n), r = Wp("(width >= 640px)"), l = N(!1);
    return ie(() => {
      r.value && (l.value = !1);
    }), (u, m) => {
      const h = xe("FontAwesomeIcon");
      return c(o).length > 0 ? ($(), Z(c(zt), {
        key: 0,
        open: l.value,
        "onUpdate:open": m[2] || (m[2] = (v) => l.value = v)
      }, {
        default: P(() => [
          b(c(ad), { "as-child": "" }, {
            default: P(() => [
              b(ye, { type: "outline" }, {
                default: P(() => [
                  b(h, {
                    icon: ["fal", "sliders"],
                    class: "smake:h-5.5"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          b(c(Et), { to: c(e) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0"
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40 smake:@sm:hidden" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full"
              }, {
                default: P(() => [
                  b(c(Rt), { "as-child": "" }, {
                    default: P(() => [
                      x("div", K6, [
                        x("div", J6, [
                          b(c(Nf), { "as-child": "" }, {
                            default: P(() => [
                              b(c(Tt), null, {
                                default: P(() => m[3] || (m[3] = [
                                  ce(" Filter ")
                                ])),
                                _: 1,
                                __: [3]
                              })
                            ]),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(h, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        b(c(Vf), {
                          type: "single",
                          collapsible: "",
                          class: "smake:divide-y smake:divide-secondary-2 smake:overflow-y-auto smake:border-y smake:border-secondary-2"
                        }, {
                          default: P(() => [
                            ($(!0), O(re, null, $e(c(o).filter(
                              ({ children: v }) => v.length > 0
                            ), (v) => ($(), Z(c(Uf), {
                              key: v.id,
                              value: v.id.toString()
                            }, {
                              default: P(() => [
                                b(c(Ff), { class: "smake:flex" }, {
                                  default: P(() => [
                                    b(c(jf), { class: "smake:group smake:flex smake:flex-1 smake:justify-between smake:gap-2 smake:overflow-hidden smake:py-2" }, {
                                      default: P(() => [
                                        x("span", Y6, L(v.name), 1),
                                        b(h, {
                                          icon: ["fal", "chevron-down"],
                                          class: "smake:h-4.5 smake:duration-250 smake:group-data-[state=open]:rotate-180"
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                b(c(Bf), { class: "smake:overflow-hidden smake:data-[state=closed]:animate-collapsibleClosed smake:data-[state=open]:animate-collapsibleOpen" }, {
                                  default: P(() => [
                                    x("div", ex, [
                                      ($(!0), O(re, null, $e(v.children, (_) => ($(), Z(oh, {
                                        key: _.id,
                                        data: _,
                                        depth: 1
                                      }, {
                                        default: P(() => [
                                          ce(L(_.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["data"]))), 128))
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value"]))), 128))
                          ]),
                          _: 1
                        }),
                        m[5] || (m[5] = x("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
                        c(s).length > 0 ? ($(), O(re, { key: 0 }, [
                          x("div", tx, [
                            ($(!0), O(re, null, $e(c(s), (v) => ($(), O("button", {
                              key: v.id,
                              type: "button",
                              class: "smake:flex smake:shrink-0 smake:items-center smake:gap-2 smake:rounded-full smake:bg-black smake:p-1.5 smake:pl-3 smake:text-white",
                              onClick: (_) => c(n).toggleCategory(v)
                            }, [
                              ce(L(v.name) + " ", 1),
                              x("div", sx, [
                                b(h, {
                                  icon: ["fak", "icon-x"],
                                  "fixed-width": "",
                                  class: "smake:size-3"
                                })
                              ])
                            ], 8, nx))), 128))
                          ]),
                          m[4] || (m[4] = x("hr", { class: "smake:border smake:border-secondary-2" }, null, -1))
                        ], 64)) : X("", !0),
                        x("div", ax, [
                          c(s).length > 0 ? ($(), Z(ye, {
                            key: 0,
                            type: "outline",
                            class: "smake:flex-1",
                            onClick: m[0] || (m[0] = (v) => a.value = [])
                          }, {
                            default: P(() => [
                              ce(L(u.$t("clear_filters")), 1)
                            ]),
                            _: 1
                          })) : X("", !0),
                          b(ye, {
                            type: "primary",
                            class: "smake:flex-1",
                            onClick: m[1] || (m[1] = (v) => l.value = !1)
                          }, {
                            default: P(() => [
                              ce(L(u.$t("show_X_results", { count: c(i) })), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"])) : X("", !0);
    };
  }
}), ix = { class: "smake:hidden smake:@sm:contents" }, rx = { class: "smake:contents smake:@sm:hidden" }, lx = /* @__PURE__ */ K({
  __name: "Categories",
  setup(t) {
    const { activeCategoryIds: e, categoriesTree: n } = D(_s());
    return (s, a) => {
      const o = xe("FontAwesomeIcon");
      return $(), O(re, null, [
        x("div", ix, [
          ($(!0), O(re, null, $e(c(n), (i) => ($(), Z(oh, {
            key: i.id,
            data: i
          }, null, 8, ["data"]))), 128)),
          c(e).length > 0 ? ($(), O(re, { key: 0 }, [
            a[1] || (a[1] = x("div", { class: "smake:h-11.5 smake:border smake:border-secondary-2" }, null, -1)),
            b(ye, {
              type: "outline",
              class: "smake:p-1 smake:pl-3",
              onClick: a[0] || (a[0] = (i) => e.value = [])
            }, {
              default: P(() => [
                ce(L(s.$t("clear_filters")) + " ", 1),
                b(o, {
                  icon: ["fak", "icon-x"],
                  "fixed-width": "",
                  class: "smake:size-7 smake:rounded-full smake:bg-black smake:p-1.5 smake:text-white"
                })
              ]),
              _: 1
            })
          ], 64)) : X("", !0)
        ]),
        x("div", rx, [
          b(ox)
        ])
      ], 64);
    };
  }
}), cx = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20$$$/GeneralStr/196=Adobe%20Illustrator%2027.6.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2016%2016'%20style='enable-background:new%200%200%2016%2016;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%230F922E;}%20.st1{fill:%23FFCC00;}%20.st2{fill:%231E4583;}%20.st3{fill:%23E30613;}%20%3c/style%3e%3cg%20id='Gruppe_2314'%20transform='translate(-53%20-287.998)'%3e%3cpath%20id='Differenzmenge_8'%20class='st0'%20d='M61,304L61,304v-4c2.21,0,4-1.79,4-4h4C69,300.42,65.42,304,61,304z'/%3e%3cpath%20id='Differenzmenge_7'%20class='st1'%20d='M69,296h-4c0-2.21-1.79-4-4-4v-4C65.42,288.01,68.99,291.58,69,296z'/%3e%3cpath%20id='Differenzmenge_6'%20class='st2'%20d='M57,296h-4c0.01-4.42,3.58-7.99,8-8v4C58.79,292,57,293.79,57,296z'/%3e%3cpath%20id='Differenzmenge_5'%20class='st3'%20d='M61,304L61,304c-4.42,0-8-3.58-8-8h4c0,2.21,1.79,4,4,4V304z'/%3e%3c/g%3e%3c/svg%3e", ux = { class: "smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl smake:border smake:border-secondary-2" }, dx = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-1 smake:p-3 smake:text-center" }, mx = { class: "smake:text-xs smake:font-bold" }, hx = { class: "smake:text-xs" }, px = { class: "smake:flex smake:items-center smake:gap-1 smake:text-xs" }, fx = /* @__PURE__ */ K({
  __name: "Logo",
  props: {
    data: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, { data: s } = Ae(n), a = e, { decimalFormat: o } = Ho(), { locale: i } = wt();
    function r(v) {
      if (v !== void 0)
        return o(v, i.value, 2);
    }
    const { appConfiguration: l, designerConfiguration: u } = D(
      it()
    ), m = I(
      () => {
        var v;
        return (v = u.value) == null ? void 0 : v.settings.settings.units;
      }
    ), h = I(() => {
      var _;
      const v = (_ = l.value) == null ? void 0 : _.productionMethods.find(
        ({ id: y }) => y === s.value.production_method.id
      );
      if (v)
        return Il[v.handle];
    });
    return (v, _) => {
      var S;
      const y = xe("FontAwesomeIcon");
      return $(), O("div", ux, [
        x("div", {
          class: "smake:relative smake:cursor-pointer smake:bg-secondary-3 smake:p-6",
          onClick: _[0] || (_[0] = (f) => a("select"))
        }, [
          h.value ? ($(), Z(y, {
            key: 0,
            icon: h.value,
            "fixed-width": "",
            class: "smake:absolute smake:top-3 smake:left-3 smake:h-4"
          }, null, 8, ["icon"])) : X("", !0),
          b(ln, {
            src: c(s).preview_url ?? void 0,
            class: "smake:aspect-square smake:w-full smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
          }, null, 8, ["src"])
        ]),
        x("div", dx, [
          x("span", mx, L(c(s).name), 1),
          _[3] || (_[3] = x("div", { class: "smake:-mt-1 smake:grow" }, null, -1)),
          x("span", hx, L(r(c(s).width ?? void 0)) + " x " + L(r(c(s).height ?? void 0)) + " " + L((S = m.value) == null ? void 0 : S.length), 1),
          x("div", px, [
            _[2] || (_[2] = x("img", {
              src: cx,
              class: "smake:h-4"
            }, null, -1)),
            ce(" " + L(v.$t(
              c(s).color_assignments.length === 1 ? "mono_colored" : "multi_colored"
            )), 1)
          ]),
          b(ye, {
            "data-testid": "Select",
            type: "secondary",
            class: "smake:mt-2 smake:w-full",
            onClick: _[1] || (_[1] = (f) => a("select"))
          }, {
            default: P(() => [
              b(y, {
                icon: ["fal", "plus"],
                class: "smake:h-4"
              }),
              ce(" " + L(v.$t("choose")), 1)
            ]),
            _: 1
          })
        ])
      ]);
    };
  }
}), vx = { class: "smake:mt-4 smake:flex smake:items-center smake:gap-2 smake:border-y smake:border-secondary-2 smake:pr-2 smake:duration-150 smake:focus-within:border-black" }, gx = ["placeholder"], _x = /* @__PURE__ */ K({
  __name: "MobileSearch",
  setup(t) {
    const { mobileSearchElement: e, mobileSearchOpen: n, searchQuery: s } = D(_s());
    return (a, o) => {
      const i = xe("FontAwesomeIcon");
      return $(), O("div", {
        ref_key: "mobileSearchElement",
        ref: e,
        class: Se(["smake:-mt-4 smake:shrink-0 smake:overflow-hidden smake:duration-150 smake:@sm:hidden", { "smake:h-0": !c(n) }])
      }, [
        x("div", vx, [
          ot(x("input", {
            "onUpdate:modelValue": o[0] || (o[0] = (r) => _t(s) ? s.value = r : null),
            type: "text",
            placeholder: a.$t("search_logo"),
            class: "smake:grow smake:py-2.5 smake:pl-2 smake:outline-hidden"
          }, null, 8, gx), [
            [pn, c(s)]
          ]),
          b(i, {
            icon: ["fal", "magnifying-glass"],
            class: "smake:h-4"
          })
        ])
      ], 2);
    };
  }
}), kx = { class: "smake:hidden smake:shrink-0 smake:items-center smake:gap-2 smake:overflow-hidden smake:rounded-xl smake:border smake:border-secondary-2 smake:pr-2 smake:duration-150 smake:focus-within:border-black smake:@sm:flex" }, yx = ["placeholder"], bx = /* @__PURE__ */ K({
  __name: "Search",
  setup(t) {
    const { mobileSearchOpen: e, searchQuery: n } = D(_s());
    return (s, a) => {
      const o = xe("FontAwesomeIcon");
      return $(), O(re, null, [
        x("div", kx, [
          ot(x("input", {
            "onUpdate:modelValue": a[0] || (a[0] = (i) => _t(n) ? n.value = i : null),
            type: "text",
            placeholder: s.$t("search_logo"),
            class: "smake:w-40 smake:py-2.5 smake:pl-2 smake:outline-hidden"
          }, null, 8, yx), [
            [pn, c(n)]
          ]),
          b(o, {
            icon: ["fal", "magnifying-glass"],
            class: "smake:h-4"
          })
        ]),
        b(ye, {
          type: "outline",
          class: Se(["smake:@sm:hidden", {
            "smake:border-black smake:bg-black smake:text-white smake:hover:opacity-60": c(e)
          }]),
          onClick: a[1] || (a[1] = (i) => e.value = !c(e))
        }, {
          default: P(() => [
            b(o, {
              icon: ["fal", "magnifying-glass"],
              class: "smake:h-5.5"
            })
          ]),
          _: 1
        }, 8, ["class"])
      ], 64);
    };
  }
}), wx = {
  "data-testid": "LogoSelection",
  class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-[1280px] smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl"
}, xx = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, $x = { class: "smake:flex smake:shrink-0 smake:flex-wrap smake:items-center smake:gap-2 smake:pt-1 smake:[overflow-wrap:normal]" }, Sx = { class: "smake:flex smake:grow smake:items-center smake:justify-end smake:gap-2" }, Ax = { class: "smake:hidden smake:font-bold smake:@sm:block" }, Cx = { class: "smake:grid smake:grid-cols-auto-fill-38 smake:gap-4 smake:overflow-y-auto smake:@sm:grid-cols-auto-fill-45" }, ih = /* @__PURE__ */ K({
  __name: "LogoSelection",
  props: /* @__PURE__ */ Ne({
    initialProductionMethodId: {},
    positioningArea: {},
    positioningAreaDesign: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed", "resolve"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open"), a = t, { initialProductionMethodId: o, positioningArea: i, positioningAreaDesign: r } = Ae(a), { dialogsRoot: l } = D(sn()), u = _s(), {
      activeProductionMethodId: m,
      count: h,
      fetchStatus: v,
      hasNextPage: _,
      logos: y,
      status: S
    } = D(u);
    m.value = o.value;
    const f = I(() => !r.value);
    ie(() => {
      s.value && u.resetFilters();
    });
    function k() {
      return S.value === "pending" ? !0 : _.value;
    }
    async function w() {
      S.value !== "pending" && await u.fetchNextPage();
    }
    const { placeDesign: C } = Go();
    async function M(T) {
      if (m.value === void 0) return;
      const E = bl(T);
      await C(
        {
          design: E,
          productionMethodId: m.value
        },
        {
          mergePostioningAreaDesign: r.value,
          positioningArea: i.value
        }
      ) === "success" && (s.value = !1);
    }
    return (T, E) => {
      const U = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: s.value,
        "onUpdate:open": E[2] || (E[2] = (F) => s.value = F)
      }, {
        default: P(() => [
          b(c(Et), { to: c(l) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: E[0] || (E[0] = (F) => n("closed"))
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), { "as-child": "" }, {
                    default: P(() => [
                      x("div", wx, [
                        x("div", xx, [
                          b(c(Tt), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: P(() => [
                              ce(L(T.$t("icon_database")), 1)
                            ]),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(U, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        b(c(qf), { class: "smake:hidden smake:@sm:block" }, {
                          default: P(() => [
                            ce(L(T.$t("icon_database_description")), 1)
                          ]),
                          _: 1
                        }),
                        E[3] || (E[3] = x("hr", { class: "smake:hidden smake:border smake:border-secondary-2 smake:@sm:block" }, null, -1)),
                        x("div", $x, [
                          b(lx),
                          b(bx),
                          x("div", Sx, [
                            c(m) ? ($(), Z(th, {
                              key: 0,
                              modelValue: c(m),
                              "onUpdate:modelValue": E[1] || (E[1] = (F) => _t(m) ? m.value = F : null),
                              disabled: !f.value
                            }, null, 8, ["modelValue", "disabled"])) : X("", !0),
                            x("span", Ax, L(c(h) ?? 0) + " " + L(T.$t("icon", c(h) ?? 0)), 1)
                          ])
                        ]),
                        b(_x),
                        ot(($(), O("div", Cx, [
                          ($(!0), O(re, null, $e(c(y), (F) => ($(), O("div", {
                            key: F.id
                          }, [
                            b(fx, {
                              "data-testid": `Logo-${F.id}`,
                              data: F,
                              onSelect: (ee) => M(F)
                            }, null, 8, ["data-testid", "data", "onSelect"])
                          ]))), 128)),
                          ($(!0), O(re, null, $e(c(v) === "fetching" ? 3 : 0, (F) => ($(), O("div", {
                            key: F,
                            class: "smake:h-80 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3"
                          }))), 128))
                        ])), [
                          [c(ya), [
                            w,
                            { distance: 350, canLoadMore: k }
                          ]]
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), es = {
  offset: { max: 50, min: -50 }
}, Px = { class: "smake:flex smake:flex-col smake:gap-1" }, Ix = { class: "smake:flex smake:justify-between" }, Mx = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, Tx = { class: "smake:overflow-hidden smake:rounded-full smake:border smake:border-secondary-2 smake:px-2 smake:text-xs smake:font-bold smake:duration-150 smake:focus-within:border-black" }, zx = ["min", "max"], Ex = ["min", "max"], Ox = /* @__PURE__ */ K({
  __name: "OffsetInput",
  props: {
    child: {}
  },
  setup(t) {
    const e = t, { child: n } = Ae(e), { designerConfiguration: s } = D(it()), a = I(
      () => {
        var u;
        return qs[((u = s.value) == null ? void 0 : u.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), o = I({
      get: () => {
        switch (n.value.anchor[0]) {
          case "b":
            return n.value.offset.y * a.value;
          case "l":
            return -n.value.offset.x * a.value;
          case "r":
            return n.value.offset.x * a.value;
          case "t":
            return -n.value.offset.y * a.value;
          default:
            return 0;
        }
      },
      set: (u) => {
        switch (n.value.anchor[0]) {
          case "b":
            n.value.offset.y = u / a.value;
            break;
          case "l":
            n.value.offset.x = -u / a.value;
            break;
          case "r":
            n.value.offset.x = u / a.value;
            break;
          case "t":
            n.value.offset.y = -u / a.value;
            break;
        }
      }
    }), i = N(), { inputValue: r, onBlur: l } = Qo(o, i, {
      max: es.offset.max,
      min: es.offset.min,
      step: 1
    });
    return (u, m) => ($(), O("div", Px, [
      x("div", Ix, [
        x("span", Mx, L(u.$t("distance_motif_text")), 1),
        x("div", Tx, [
          ot(x("input", {
            ref_key: "numberInput",
            ref: i,
            "onUpdate:modelValue": m[0] || (m[0] = (h) => _t(r) ? r.value = h : null),
            class: "smake:appearance-textfield smake:w-full smake:text-right smake:outline-hidden",
            type: "number",
            min: c(es).offset.min,
            max: c(es).offset.max,
            step: "1",
            onBlur: m[1] || (m[1] = //@ts-ignore
            (...h) => c(l) && c(l)(...h))
          }, null, 40, zx), [
            [pn, c(r)]
          ])
        ])
      ]),
      ot(x("input", {
        "onUpdate:modelValue": m[2] || (m[2] = (h) => o.value = h),
        class: "smake:my-1.5 smake:h-1 smake:w-full smake:appearance-none smake:rounded-full smake:bg-secondary-3 smake:[&::-webkit-slider-thumb]:h-4 smake:[&::-webkit-slider-thumb]:w-4 smake:[&::-webkit-slider-thumb]:cursor-ew-resize smake:[&::-webkit-slider-thumb]:appearance-none smake:[&::-webkit-slider-thumb]:rounded-full smake:[&::-webkit-slider-thumb]:border-2 smake:[&::-webkit-slider-thumb]:border-solid smake:[&::-webkit-slider-thumb]:border-black smake:[&::-webkit-slider-thumb]:bg-white smake:[&::-webkit-slider-thumb]:duration-150 smake:hover:[&::-webkit-slider-thumb]:bg-secondary-3",
        type: "range",
        min: c(es).offset.min,
        max: c(es).offset.max,
        step: "1"
      }, null, 8, Ex), [
        [
          pn,
          o.value,
          void 0,
          { number: !0 }
        ]
      ])
    ]));
  }
}), Rx = { class: "smake:flex smake:divide-x smake:divide-secondary-2 smake:overflow-hidden smake:rounded-full smake:border smake:border-secondary-2 smake:duration-150 smake:focus-within:border-black" }, Lx = ["disabled"], Dx = ["min", "max", "step", "disabled"], Nx = ["disabled"], da = /* @__PURE__ */ K({
  __name: "NumberInput",
  props: /* @__PURE__ */ Ne({
    disabled: { type: Boolean },
    max: {},
    min: {},
    step: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, { max: n, min: s, step: a } = Ae(e), o = je(t, "modelValue"), i = N(), { inputValue: r, onBlur: l } = Qo(o, i, { max: n, min: s, step: a });
    return (u, m) => {
      const h = xe("FontAwesomeIcon");
      return $(), O("div", Rx, [
        x("button", {
          class: "smake:p-3.5 smake:duration-150 smake:enabled:hover:opacity-60 smake:disabled:opacity-50",
          type: "button",
          disabled: c(s) !== void 0 && (c(a) !== void 0 ? o.value - c(s) < c(a) : o.value <= c(s)) || u.disabled,
          onClick: m[0] || (m[0] = (v) => o.value -= c(s) !== void 0 ? Math.min(1, o.value - c(s)) : 1)
        }, [
          b(h, {
            class: "smake:size-4",
            icon: ["fal", "minus"]
          })
        ], 8, Lx),
        ot(x("input", {
          ref_key: "input",
          ref: i,
          "onUpdate:modelValue": m[1] || (m[1] = (v) => _t(r) ? r.value = v : null),
          class: "smake:appearance-textfield smake:w-full smake:min-w-8 smake:text-center smake:text-sm smake:font-semibold smake:outline-hidden smake:disabled:opacity-50",
          type: "number",
          min: c(s),
          max: c(n),
          step: c(a),
          disabled: u.disabled,
          onBlur: m[2] || (m[2] = //@ts-ignore
          (...v) => c(l) && c(l)(...v))
        }, null, 40, Dx), [
          [pn, c(r)]
        ]),
        x("button", {
          class: "smake:p-3.5 smake:duration-150 smake:enabled:hover:opacity-60 smake:disabled:opacity-50",
          type: "button",
          disabled: c(n) !== void 0 && (c(a) !== void 0 ? c(n) - o.value < c(a) : o.value >= c(n)) || u.disabled,
          onClick: m[3] || (m[3] = (v) => o.value += c(n) !== void 0 ? Math.min(1, c(n) - o.value) : 1)
        }, [
          b(h, {
            class: "smake:size-4",
            icon: ["fal", "plus"]
          })
        ], 8, Nx)
      ]);
    };
  }
}), Vx = { class: "smake:grid smake:grid-cols-[1fr_auto_1fr] smake:items-center smake:gap-x-2 smake:gap-y-1" }, Ux = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, Fx = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, jx = /* @__PURE__ */ K({
  __name: "SizeInput",
  props: {
    bounds: {},
    disabled: { type: Boolean },
    ratio: {},
    size: {}
  },
  setup(t) {
    const e = t, { bounds: n, ratio: s, size: a } = Ae(e), o = I({
      get: () => a.value.width,
      set: (r) => {
        a.value.width = r, a.value.height = r / s.value;
      }
    }), i = I({
      get: () => a.value.height,
      set: (r) => {
        a.value.height = r, a.value.width = r * s.value;
      }
    });
    return (r, l) => {
      var m, h, v, _, y, S, f, k;
      const u = xe("FontAwesomeIcon");
      return $(), O("div", Vx, [
        x("span", Ux, L(r.$t("width_abbreviation")), 1),
        l[2] || (l[2] = x("div", null, null, -1)),
        x("span", Fx, L(r.$t("height_abbreviation")), 1),
        b(da, {
          modelValue: o.value,
          "onUpdate:modelValue": l[0] || (l[0] = (w) => o.value = w),
          min: (h = (m = c(n)) == null ? void 0 : m.min) == null ? void 0 : h.width,
          max: (_ = (v = c(n)) == null ? void 0 : v.max) == null ? void 0 : _.width,
          step: 0.1,
          disabled: r.disabled
        }, null, 8, ["modelValue", "min", "max", "disabled"]),
        b(u, {
          icon: ["fal", "link"],
          class: "smake:size-6 smake:text-secondary-1"
        }),
        b(da, {
          modelValue: i.value,
          "onUpdate:modelValue": l[1] || (l[1] = (w) => i.value = w),
          min: (S = (y = c(n)) == null ? void 0 : y.min) == null ? void 0 : S.height,
          max: (k = (f = c(n)) == null ? void 0 : f.max) == null ? void 0 : k.height,
          step: 0.1,
          disabled: r.disabled
        }, null, 8, ["modelValue", "min", "max", "disabled"])
      ]);
    };
  }
}), Bx = { class: "smake:flex smake:justify-between" }, qx = { class: "smake:text-sm smake:font-bold smake:uppercase" }, Hx = {
  class: "smake:grid smake:grid-cols-[auto_1fr_1fr_1fr_auto] smake:place-items-center smake:gap-2",
  style: {
    gridTemplateAreas: '". tl tc tr .""lt preview preview preview rt""lc preview preview preview rc""lb preview preview preview rb"". bl bc br rotate"'
  }
}, Wx = ["value"], Gx = { class: "smake:group smake:size-8 smake:cursor-pointer smake:rounded-md smake:border smake:border-secondary-2 smake:p-1.5 smake:duration-150 smake:peer-checked:border-black smake:peer-checked:bg-black smake:peer-checked:text-white smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:peer-not-checked:hover:bg-secondary-3 smake:peer-checked:hover:opacity-60" }, Zx = { class: "smake:flex smake:justify-center" }, Qx = { class: "smake:grid smake:w-full smake:grid-cols-2 smake:gap-4" }, Xx = { class: "smake:mt-4 smake:grid smake:grid-cols-2 smake:gap-4" }, Kx = { class: "smake:group-data-[state=open]:hidden" }, Jx = { class: "smake:group-data-[state=closed]:hidden" }, Yx = /* @__PURE__ */ K({
  __name: "LogoComponent",
  props: {
    data: {}
  },
  setup(t) {
    const e = t, { data: n } = Ae(e), { positioningArea: s, positioningAreaDesign: a } = D(
      an()
    ), { selectedProductionMethodId: o } = D(Ze()), { data: i } = D(Qt()), { open: r } = Bs(), { designerConfiguration: l } = D(it()), u = I(
      () => {
        var M;
        return qs[((M = l.value) == null ? void 0 : M.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), m = I(() => {
      if (s.value)
        return i.value.find(
          (M) => (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            M.positioningAreas.includes(s.value)
          )
        );
    }), { isLight: h } = $a(s, m), v = N(), _ = Oo(v, s), { data: y } = kt({
      ...le.logos.get.use(I(() => n.value.logoId)),
      retry: !1,
      staleTime: 1 / 0
    });
    async function S() {
      var M;
      if (o.value !== void 0 && s.value !== void 0) {
        if ((M = y.value) != null && M.is_customer_logo) {
          await r(Ml, {
            initialProductionMethodId: o.value,
            positioningArea: s.value,
            positioningAreaDesign: a.value
          });
          return;
        }
        await r(ih, {
          initialProductionMethodId: o.value,
          positioningArea: s.value,
          positioningAreaDesign: a.value
        });
      }
    }
    function f() {
      var M, T;
      if (s.value)
        if (((M = a.value) == null ? void 0 : M.design.type) === be.ANCHOR) {
          const E = (T = a.value.design.children[0]) == null ? void 0 : T.value;
          if ((E == null ? void 0 : E.type) !== be.TEXT)
            throw new Error(
              "Expected first child of anchor design to be text design"
            );
          a.value.design = E;
        } else
          s.value.designs = s.value.designs.filter(
            (E) => E !== a.value
          ), a.value = void 0;
    }
    function k() {
      a.value && (a.value.rotation = Io(
        a.value.rotation + 90
      ));
    }
    function w() {
      var U;
      if (((U = a.value) == null ? void 0 : U.design.type) !== be.ANCHOR) return;
      const M = a.value.design.children[0], T = Math.max(
        Math.abs(M.offset.x),
        Math.abs(M.offset.y)
      ), E = M.anchor[0];
      M.offset = {
        x: E === "l" ? -T : E === "r" ? T : 0,
        y: E === "t" ? -T : E === "b" ? T : 0
      };
    }
    const C = I(() => y.value ? y.value.is_scaleable : !0);
    return (M, T) => {
      const E = xe("FontAwesomeIcon");
      return $(), Z(Tl, { "data-testid": "LogoComponent" }, {
        default: P(() => {
          var U, F, ee, Q;
          return [
            x("div", Bx, [
              x("h3", qx, L(M.$t("icon")), 1),
              b(ye, {
                type: "secondary",
                onClick: f
              }, {
                default: P(() => [
                  b(E, {
                    class: "smake:size-5",
                    icon: ["fak", "icon-remove"],
                    "fixed-width": ""
                  })
                ]),
                _: 1
              })
            ]),
            x("div", Hx, [
              m.value && c(s) ? ($(), Z(c(Mo), {
                key: 0,
                class: "smake:aspect-square smake:w-full smake:rounded-md",
                style: { gridArea: "preview" }
              }, {
                default: P(() => [
                  b(c(Eo), {
                    data: m.value,
                    "initial-position": c(Ro)(
                      c(s),
                      10 / u.value
                    )
                  }, {
                    default: P(() => [
                      b(c(To), {
                        data: c(s),
                        "stroke-color": c(_) ? 16711680 : c(h) ? 4605510 : 14474460
                      }, {
                        default: P(() => [
                          c(a) ? ($(), Z(c(zo), {
                            key: 0,
                            data: c(a),
                            "onUpdate:boundingBox": T[0] || (T[0] = (se) => v.value = se)
                          }, null, 8, ["data"])) : X("", !0)
                        ]),
                        _: 1
                      }, 8, ["data", "stroke-color"])
                    ]),
                    _: 1
                  }, 8, ["data", "initial-position"])
                ]),
                _: 1
              })) : X("", !0),
              ((U = c(a)) == null ? void 0 : U.design.type) === c(be).ANCHOR ? ($(!0), O(re, { key: 1 }, $e(c(vs), (se) => ($(), O("label", {
                key: se,
                style: Wt({ gridArea: se })
              }, [
                ot(x("input", {
                  "onUpdate:modelValue": [
                    T[1] || (T[1] = (W) => c(a).design.children[0].anchor = W),
                    w
                  ],
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "outerAnchorPoint",
                  value: se
                }, null, 8, Wx), [
                  [
                    la,
                    c(a).design.children[0].anchor
                  ]
                ]),
                x("div", Gx, [
                  b(E, {
                    icon: ["fak", "icon-text-alignment"],
                    "fixed-width": "",
                    class: "smake:size-4.5 smake:group-peer-not-checked:hidden"
                  })
                ])
              ], 4))), 128)) : X("", !0),
              x("button", {
                type: "button",
                class: Se(["smake:z-0 smake:rounded-md smake:bg-secondary-3 smake:p-1.75 smake:duration-150 smake:hover:bg-secondary-2", {
                  "smake:-mt-8 smake:-ml-8": ((F = c(a)) == null ? void 0 : F.design.type) !== c(be).ANCHOR
                }]),
                style: { gridArea: "rotate" },
                onClick: k
              }, [
                b(E, {
                  icon: ["fal", "rotate-right"],
                  class: "smake:size-4.5"
                })
              ], 2)
            ]),
            x("div", Zx, [
              b(ye, {
                type: "secondary",
                class: "smake:px-4 smake:text-sm",
                onClick: S
              }, {
                default: P(() => {
                  var se;
                  return [
                    ce(L(M.$t(
                      (se = c(y)) != null && se.is_customer_logo ? "choose_logo" : "choose_icon"
                    )), 1)
                  ];
                }),
                _: 1
              })
            ]),
            ((ee = c(a)) == null ? void 0 : ee.design.type) === c(be).ANCHOR ? ($(), Z(Ox, {
              key: 0,
              child: c(a).design.children[0]
            }, null, 8, ["child"])) : X("", !0),
            b(c(Hf), { class: "smake:flex smake:flex-col smake:items-center smake:gap-4" }, {
              default: P(() => [
                x("div", Qx, [
                  ($(!0), O(re, null, $e(c(n).colorAssignments.slice(0, 4), (se, W) => {
                    var Y;
                    return $(), O("div", {
                      key: se.id,
                      class: "smake:flex smake:flex-col smake:gap-2"
                    }, [
                      ce(L(M.$t("color")) + " " + L(W + 1) + " ", 1),
                      b(Wr, {
                        modelValue: se.color,
                        "onUpdate:modelValue": (me) => se.color = me,
                        "show-name": "",
                        disabled: !(((Y = c(y)) == null ? void 0 : Y.is_editable) ?? !0)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]);
                  }), 128))
                ]),
                c(n).colorAssignments.length > 4 ? ($(), Z(c(Wf), {
                  key: 0,
                  class: "smake:-mt-4 smake:w-full smake:overflow-hidden smake:data-[state=closed]:animate-collapsibleClosed smake:data-[state=open]:animate-collapsibleOpen"
                }, {
                  default: P(() => [
                    x("div", Xx, [
                      ($(!0), O(re, null, $e(c(n).colorAssignments.slice(4), (se, W) => {
                        var Y;
                        return $(), O("div", {
                          key: se.id,
                          class: "smake:flex smake:flex-col smake:gap-2"
                        }, [
                          ce(L(M.$t("color")) + " " + L(W + 5) + " ", 1),
                          b(Wr, {
                            modelValue: se.color,
                            "onUpdate:modelValue": (me) => se.color = me,
                            "show-name": "",
                            disabled: !(((Y = c(y)) == null ? void 0 : Y.is_editable) ?? !0)
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]);
                      }), 128))
                    ])
                  ]),
                  _: 1
                })) : X("", !0),
                c(n).colorAssignments.length > 4 ? ($(), Z(c(Gf), {
                  key: 1,
                  "as-child": ""
                }, {
                  default: P(() => [
                    b(ye, {
                      type: "secondary",
                      class: "smake:group smake:px-4"
                    }, {
                      default: P(() => [
                        x("span", Kx, L(M.$t("more_colors")), 1),
                        x("span", Jx, L(M.$t("fewer_colors")), 1),
                        b(E, {
                          icon: ["fal", "chevron-down"],
                          class: "smake:h-4.5 smake:duration-250 smake:group-data-[state=open]:rotate-180"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })) : X("", !0)
              ]),
              _: 1
            }),
            c(n).size ? ($(), Z(jx, {
              key: 1,
              size: c(n).size,
              disabled: !C.value,
              ratio: (Q = c(y)) != null && Q.width && c(y).height ? c(y).width / c(y).height : c(n).size.width / c(n).size.height,
              bounds: c(y) ? {
                min: c(y).min_width && c(y).min_height ? {
                  width: c(y).min_width,
                  height: c(y).min_height
                } : void 0,
                max: c(y).max_width && c(y).max_height ? {
                  width: c(y).max_width,
                  height: c(y).max_height
                } : void 0
              } : void 0
            }, null, 8, ["size", "disabled", "ratio", "bounds"])) : X("", !0)
          ];
        }),
        _: 1
      });
    };
  }
}), e4 = { class: "smake:text-sm smake:font-bold smake:uppercase" }, t4 = { class: "smake:relative" }, n4 = /* @__PURE__ */ K({
  __name: "Preview",
  setup(t) {
    const { positioningArea: e, positioningAreaDesign: n } = D(
      an()
    ), { data: s } = D(Qt()), { designerConfiguration: a } = D(it()), o = I(
      () => {
        var v;
        return qs[((v = a.value) == null ? void 0 : v.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), i = pm(
      I(() => {
        var v;
        return (v = n.value) == null ? void 0 : v.design;
      }),
      o
    ), r = I(() => {
      if (e.value)
        return s.value.find(
          (v) => (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            v.positioningAreas.includes(e.value)
          )
        );
    }), { isLight: l } = $a(e, r), u = N(), m = Oo(u, e);
    function h() {
      n.value && (n.value.rotation = Io(
        n.value.rotation + 90
      ));
    }
    return (v, _) => {
      const y = xe("FontAwesomeIcon");
      return $(), Z(Tl, null, {
        default: P(() => [
          x("h3", e4, L(v.$t("preview")), 1),
          x("div", t4, [
            r.value && c(e) ? ($(), Z(c(Mo), {
              key: 0,
              class: "smake:aspect-square smake:w-full smake:rounded-md"
            }, {
              default: P(() => [
                b(c(Eo), {
                  data: r.value,
                  "initial-position": c(Ro)(
                    c(e),
                    10 / o.value
                  )
                }, {
                  default: P(() => [
                    b(c(To), {
                      data: c(e),
                      "stroke-color": c(m) ? 16711680 : c(l) ? 4605510 : 14474460
                    }, {
                      default: P(() => [
                        c(n) ? ($(), Z(c(zo), {
                          key: 0,
                          data: c(n),
                          placeholder: {
                            color: 13948116,
                            radius: 6 / o.value,
                            ...c(i)
                          },
                          "onUpdate:boundingBox": _[0] || (_[0] = (S) => u.value = S)
                        }, null, 8, ["data", "placeholder"])) : X("", !0)
                      ]),
                      _: 1
                    }, 8, ["data", "stroke-color"])
                  ]),
                  _: 1
                }, 8, ["data", "initial-position"])
              ]),
              _: 1
            })) : X("", !0),
            x("button", {
              type: "button",
              class: "smake:absolute smake:-right-2 smake:-bottom-2 smake:rounded-md smake:bg-secondary-3 smake:p-1.75 smake:duration-150 smake:hover:bg-secondary-2",
              onClick: h
            }, [
              b(y, {
                icon: ["fal", "rotate-right"],
                class: "smake:size-4.5"
              })
            ])
          ])
        ]),
        _: 1
      });
    };
  }
}), s4 = { class: "smake:font-bold" }, a4 = /* @__PURE__ */ K({
  __name: "SavedDesignSuccesfullyToast",
  props: /* @__PURE__ */ Ne({
    name: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "open");
    return (a, o) => {
      const i = xe("I18nT");
      return $(), Z(Zm, {
        open: s.value,
        "onUpdate:open": o[0] || (o[0] = (r) => s.value = r),
        type: "success",
        onClosed: o[1] || (o[1] = (r) => n("closed"))
      }, {
        default: P(() => [
          b(i, {
            keypath: "saved_design_successfully",
            tag: "span"
          }, {
            name: P(() => [
              x("span", s4, L(a.name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), o4 = { class: "smake:flex smake:justify-between" }, i4 = { class: "smake:text-lg smake:font-semibold" }, r4 = { key: 0 }, l4 = /* @__PURE__ */ K({
  __name: "SavePositioningAreaDesignButton",
  emits: ["saved"],
  setup(t, { emit: e }) {
    const n = e, { positioningArea: s, positioningAreaDesign: a } = D(
      an()
    ), o = I(
      () => a.value ? ga(a.value.design) : void 0
    ), { t: i } = wt(), r = N(!1), l = I(() => {
      var k;
      return (k = a.value) == null ? void 0 : k.design;
    });
    ht(
      l,
      () => {
        r.value = !1;
      },
      {
        deep: !0
      }
    );
    const u = I(
      () => o.value !== void 0 && s.value !== void 0
    ), m = I(
      () => u.value ? i("new_design") : i("new_customization")
    ), { open: h } = Ia();
    async function v(k) {
      return k instanceof jn && k.response.status === 422 ? (await k.response.json()).message : i("boot_error.unexpected");
    }
    const { isPending: _, mutate: y } = tn({
      ...le.designs.favored.post.use(),
      onError: async (k) => {
        h(fs, {
          input: {
            text: await v(k),
            type: "info"
          }
        });
      },
      onSuccess: (k) => {
        k.name && (h(a4, {
          input: {
            name: k.name
          }
        }), r.value = !0, n("saved"));
      }
    }), S = I(() => _.value || r.value);
    function f() {
      var w;
      if (((w = a.value) == null ? void 0 : w.design) === void 0 || s.value === void 0) return;
      const k = Ts({
        design: a.value.design,
        productionMethodId: s.value.productionMethodId
      });
      y({
        elements: [k],
        production_method: { id: s.value.productionMethodId }
      });
    }
    return (k, w) => {
      const C = xe("FontAwesomeIcon");
      return $(), O("div", o4, [
        x("h2", i4, L(m.value), 1),
        u.value ? ($(), Z(ye, {
          key: 0,
          type: "outline",
          class: "smake:px-4 smake:py-1 smake:text-sm smake:transition-colors",
          disabled: S.value,
          onClick: f
        }, {
          default: P(() => [
            x("div", null, L(k.$t("save")), 1),
            c(_) ? ($(), O("div", r4, [
              b(C, {
                icon: ["fal", "spinner"],
                class: "smake:h-4 smake:animate-spin"
              })
            ])) : X("", !0)
          ]),
          _: 1
        }, 8, ["disabled"])) : X("", !0)
      ]);
    };
  }
});
function rh(t) {
  const { appConfiguration: e } = D(it()), n = I(() => {
    var r;
    return ((r = e.value) == null ? void 0 : r.fonts) ?? [];
  }), s = jt(t), a = I(
    () => s.value.map((r) => r.fontId)
  ), o = I(
    () => Math.max(
      ...n.value.filter((r) => a.value.includes(r.id)).map((r) => r.min)
    )
  ), i = I(
    () => Math.min(
      ...n.value.filter((r) => a.value.includes(r.id)).map((r) => r.max)
    )
  );
  return I(() => ({
    offsetLeft: { max: 100, min: 0 },
    paddingBottom: { max: 100, min: 2 },
    size: {
      max: i.value,
      min: o.value
    }
  }));
}
const c4 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, u4 = { class: "smake:flex smake:w-full smake:justify-between" }, d4 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, m4 = { class: "smak:items-center smake:flex smake:gap-1 smake:overflow-hidden smake:rounded-full smake:border smake:border-secondary-2 smake:px-2 smake:text-xs smake:font-bold smake:duration-150 smake:focus-within:border-black" }, h4 = /* @__PURE__ */ K({
  __name: "BendingRadiusInput",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), n = N(), { inputValue: s, onBlur: a } = Qo(e, n, {
      max: 100,
      min: -100,
      step: 5
    });
    return (o, i) => ($(), O("div", c4, [
      x("div", u4, [
        x("span", d4, L(o.$t("bend_text_line")), 1),
        x("div", m4, [
          ot(x("input", {
            ref_key: "numberInput",
            ref: n,
            "onUpdate:modelValue": i[0] || (i[0] = (r) => _t(s) ? s.value = r : null),
            class: "smake:appearance-textfield smake:w-7 smake:text-right smake:outline-hidden",
            type: "number",
            max: "100",
            min: "-100",
            step: "5",
            onBlur: i[1] || (i[1] = //@ts-ignore
            (...r) => c(a) && c(a)(...r))
          }, null, 544), [
            [pn, c(s)]
          ]),
          i[3] || (i[3] = x("div", null, "%", -1))
        ])
      ]),
      ot(x("input", {
        "onUpdate:modelValue": i[2] || (i[2] = (r) => e.value = r),
        class: "smake:my-1.5 smake:h-1 smake:w-full smake:appearance-none smake:rounded-full smake:bg-secondary-3 smake:[&::-webkit-slider-thumb]:h-4 smake:[&::-webkit-slider-thumb]:w-4 smake:[&::-webkit-slider-thumb]:cursor-ew-resize smake:[&::-webkit-slider-thumb]:appearance-none smake:[&::-webkit-slider-thumb]:rounded-full smake:[&::-webkit-slider-thumb]:border-2 smake:[&::-webkit-slider-thumb]:border-solid smake:[&::-webkit-slider-thumb]:border-black smake:[&::-webkit-slider-thumb]:bg-white smake:[&::-webkit-slider-thumb]:duration-150 smake:hover:[&::-webkit-slider-thumb]:bg-secondary-3",
        type: "range",
        max: "100",
        min: "-100",
        step: "5"
      }, null, 512), [
        [
          pn,
          e.value,
          void 0,
          { number: !0 }
        ]
      ])
    ]));
  }
}), p4 = { class: "smake:absolute smake:inset-0 smake:z-10 smake:flex smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4" }, f4 = ["value", "disabled"], v4 = ["onClick"], g4 = {
  key: 1,
  class: "smake:text-xl smake:font-semibold"
}, _4 = {
  key: 2,
  class: "smake:mb-1 smake:text-sm smake:font-semibold"
}, k4 = {
  key: 0,
  class: "smake:text-xs smake:text-secondary-1"
}, y4 = /* @__PURE__ */ K({
  __name: "FontSelection",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: /* @__PURE__ */ Ne(["close"], ["update:modelValue"]),
  setup(t, { emit: e }) {
    const n = e, s = je(t, "modelValue"), { appConfiguration: a } = D(it()), { selectedProductionMethodId: o } = D(Ze()), i = I(() => {
      var m;
      return (m = a.value) == null ? void 0 : m.fonts;
    }), r = I(() => {
      var h;
      const m = (h = i.value) == null ? void 0 : h.find((v) => v.id === s.value);
      return m ? ss(m.style) : !1;
    }), l = I(
      () => {
        var m;
        return Object.values(
          Object.groupBy(
            ((m = i.value) == null ? void 0 : m.filter(
              (h) => h.production_methods.some(
                ({ id: v }) => v === o.value
              )
            )) ?? [],
            ({ family_name: h }) => h
          )
        ).map((h) => {
          if (r.value) {
            const v = h == null ? void 0 : h.find(
              (_) => ss(_.style)
            );
            if (v) return v;
          }
          return (h == null ? void 0 : h.find((v) => !ss(v.style))) ?? (h == null ? void 0 : h[0]);
        }).filter((h) => h !== void 0).sort((h, v) => h.family_name < v.family_name ? -1 : h.family_name > v.family_name ? 1 : 0);
      }
    ), u = I(() => l.value.some(
      (m) => m.letter_case_set === "only-uppercase"
    ));
    return (m, h) => ($(), O("div", p4, [
      ($(!0), O(re, null, $e(l.value, (v) => ($(), O("label", {
        key: v.id,
        class: "smake:relative"
      }, [
        ot(x("input", {
          "onUpdate:modelValue": h[0] || (h[0] = (_) => s.value = _),
          class: "smake:peer smake:absolute smake:appearance-none",
          type: "radio",
          name: "fontId",
          value: v.id,
          disabled: r.value !== c(ss)(v.style)
        }, null, 8, f4), [
          [la, s.value]
        ]),
        x("div", {
          class: "smake:flex smake:items-center smake:justify-center smake:gap-0.5 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:peer-checked:bg-secondary-2 smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:peer-enabled:cursor-pointer smake:peer-disabled:opacity-50 smake:hover:peer-enabled:border-black",
          onClick: () => {
            v.id === s.value && n("close");
          }
        }, [
          v.preview_url ? ($(), Z(ln, {
            key: 0,
            src: v.preview_url,
            class: "smake:h-6 smake:data-[state=pending]:w-28 smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:rounded-md smake:data-[state=pending]:bg-secondary-2"
          }, null, 8, ["src"])) : ($(), O("span", g4, L(v.display_name), 1)),
          v.letter_case_set === "only-uppercase" ? ($(), O("span", _4, " * ")) : X("", !0)
        ], 8, v4)
      ]))), 128)),
      h[1] || (h[1] = x("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
      u.value ? ($(), O("div", k4, " * " + L(m.$t("only_uppercase")), 1)) : X("", !0)
    ]));
  }
}), b4 = { class: "smake:flex smake:grow smake:flex-col smake:items-start smake:gap-1" }, w4 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, x4 = { class: "smake:grow smake:rounded-full smake:bg-secondary-3 smake:p-1 smake:text-sm smake:font-semibold" }, $4 = { class: "smake:flex smake:flex-col smake:items-start smake:gap-1" }, S4 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, A4 = { class: "smake:relative" }, C4 = ["disabled"], P4 = { class: "smake:flex smake:h-[46px] smake:items-center smake:justify-center smake:rounded smake:bg-secondary-3 smake:p-3 smake:px-4 smake:font-bold smake:italic smake:duration-150 smake:peer-checked:bg-black smake:peer-checked:text-white smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:peer-enabled:cursor-pointer smake:peer-disabled:opacity-50 smake:hover:peer-enabled:bg-secondary-2 smake:hover:peer-checked:peer-enabled:bg-black/80" }, I4 = /* @__PURE__ */ K({
  __name: "FontInput",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = je(t, "modelValue"), { appConfiguration: n } = D(it()), { selectedProductionMethodId: s } = D(Ze()), a = N(!1), o = I(() => {
      var m;
      return (m = n.value) == null ? void 0 : m.fonts;
    }), i = I(
      () => {
        var m;
        return (m = o.value) == null ? void 0 : m.find((h) => h.id === e.value);
      }
    ), r = I(
      () => {
        var m;
        return (m = o.value) == null ? void 0 : m.find(
          ({ family_name: h, production_methods: v, style: _ }) => {
            var y;
            return h === ((y = i.value) == null ? void 0 : y.family_name) && v.some(
              ({ id: S }) => S === s.value
            ) && ss(_);
          }
        );
      }
    ), l = I(
      () => {
        var m;
        return (m = o.value) == null ? void 0 : m.find(
          ({ family_name: h, production_methods: v, style: _ }) => {
            var y;
            return h === ((y = i.value) == null ? void 0 : y.family_name) && v.some(
              ({ id: S }) => S === s.value
            ) && !ss(_);
          }
        );
      }
    ), u = I({
      get: () => r.value === i.value,
      set: (m) => {
        var v, _;
        const h = m ? (v = r.value) == null ? void 0 : v.id : (_ = l.value) == null ? void 0 : _.id;
        h && (e.value = h);
      }
    });
    return (m, h) => {
      const v = xe("FontAwesomeIcon");
      return $(), O(re, null, [
        x("div", b4, [
          x("span", w4, L(m.$t("font")), 1),
          b(ye, {
            type: "outline",
            class: "smake:w-full",
            onClick: h[0] || (h[0] = (_) => a.value = !0)
          }, {
            default: P(() => {
              var _;
              return [
                x("div", x4, L((_ = i.value) == null ? void 0 : _.family_name), 1),
                b(v, {
                  class: "smake:mx-1 smake:size-5",
                  icon: ["fal", "chevron-right"]
                })
              ];
            }),
            _: 1
          })
        ]),
        x("div", $4, [
          x("span", S4, L(m.$t("italic")), 1),
          x("label", A4, [
            ot(x("input", {
              "onUpdate:modelValue": h[1] || (h[1] = (_) => u.value = _),
              class: "smake:peer smake:absolute smake:appearance-none",
              type: "checkbox",
              disabled: !r.value
            }, null, 8, C4), [
              [Op, u.value]
            ]),
            x("div", P4, L(m.$t("italic_short")), 1)
          ])
        ]),
        b(De, {
          appear: "",
          "enter-active-class": "smake:duration-300 smake:ease-out",
          "enter-from-class": "smake:opacity-0",
          "leave-active-class": "smake:duration-200 smake:ease-in",
          "leave-to-class": "smake:opacity-0"
        }, {
          default: P(() => [
            a.value ? ($(), Z(y4, {
              key: 0,
              modelValue: e.value,
              "onUpdate:modelValue": [
                h[2] || (h[2] = (_) => e.value = _),
                h[3] || (h[3] = (_) => a.value = !1)
              ],
              onClose: h[4] || (h[4] = (_) => a.value = !1)
            }, null, 8, ["modelValue"])) : X("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), M4 = { class: "smake:flex smake:gap-4" }, T4 = { class: "smake:flex smake:flex-col smake:items-start smake:gap-1" }, z4 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, E4 = { class: "smake:flex smake:gap-4" }, O4 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, R4 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, L4 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, D4 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, N4 = { class: "smake:flex smake:gap-4" }, V4 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, U4 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, F4 = { class: "smake:flex smake:gap-2" }, j4 = { class: "smake:relative" }, B4 = ["value"], q4 = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, H4 = { class: "smake:relative" }, W4 = ["value"], G4 = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, Z4 = { class: "smake:relative" }, Q4 = ["value"], X4 = { class: "smake:group smake:cursor-pointer smake:rounded smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:peer-checked:bg-black smake:peer-focus-visible:outline-2 smake:peer-focus-visible:outline-blue-700 smake:hover:bg-secondary-2 smake:hover:peer-checked:bg-black/80" }, K4 = { class: "smake:flex smake:flex-1 smake:flex-col smake:items-start smake:gap-1" }, J4 = { class: "smake:text-xs smake:font-semibold smake:uppercase" }, Y4 = /* @__PURE__ */ K({
  __name: "TextLine",
  props: {
    data: {}
  },
  setup(t) {
    const e = t, { data: n } = Ae(e), s = I(() => [n.value]), a = rh(s);
    return (o, i) => {
      const r = xe("FontAwesomeIcon");
      return $(), O(re, null, [
        x("div", M4, [
          b(I4, {
            modelValue: c(n).fontId,
            "onUpdate:modelValue": i[0] || (i[0] = (l) => c(n).fontId = l)
          }, null, 8, ["modelValue"]),
          x("div", T4, [
            x("span", z4, L(o.$t("color")), 1),
            b(Wr, {
              modelValue: c(n).color,
              "onUpdate:modelValue": i[1] || (i[1] = (l) => c(n).color = l)
            }, null, 8, ["modelValue"])
          ])
        ]),
        x("div", E4, [
          x("div", O4, [
            x("span", R4, L(o.$t("size")), 1),
            b(da, {
              modelValue: c(n).size,
              "onUpdate:modelValue": i[2] || (i[2] = (l) => c(n).size = l),
              class: "smake:w-full",
              min: c(a).size.min,
              max: c(a).size.max,
              step: 1
            }, null, 8, ["modelValue", "min", "max"])
          ]),
          x("div", L4, [
            x("span", D4, L(o.$t("line_height")), 1),
            b(da, {
              modelValue: c(n).paddingBottom,
              "onUpdate:modelValue": i[3] || (i[3] = (l) => c(n).paddingBottom = l),
              class: "smake:w-full",
              min: c(a).paddingBottom.min,
              max: c(a).paddingBottom.max,
              step: 1
            }, null, 8, ["modelValue", "min", "max"])
          ])
        ]),
        x("div", N4, [
          x("div", V4, [
            x("span", U4, L(o.$t("align")), 1),
            x("div", F4, [
              x("label", j4, [
                ot(x("input", {
                  "onUpdate:modelValue": i[4] || (i[4] = (l) => c(n).horizontalAlignment = l),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: c(is).LEFT
                }, null, 8, B4), [
                  [la, c(n).horizontalAlignment]
                ]),
                x("div", q4, [
                  b(r, {
                    class: "smake:h-[22px] smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-left"]
                  })
                ])
              ]),
              x("label", H4, [
                ot(x("input", {
                  "onUpdate:modelValue": i[5] || (i[5] = (l) => c(n).horizontalAlignment = l),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: c(is).CENTER
                }, null, 8, W4), [
                  [la, c(n).horizontalAlignment]
                ]),
                x("div", G4, [
                  b(r, {
                    class: "smake:h-[22px] smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-center"]
                  })
                ])
              ]),
              x("label", Z4, [
                ot(x("input", {
                  "onUpdate:modelValue": i[6] || (i[6] = (l) => c(n).horizontalAlignment = l),
                  class: "smake:peer smake:absolute smake:appearance-none",
                  type: "radio",
                  name: "horizontalAlignment",
                  value: c(is).RIGHT
                }, null, 8, Q4), [
                  [la, c(n).horizontalAlignment]
                ]),
                x("div", X4, [
                  b(r, {
                    class: "smake:h-[22px] smake:duration-150 smake:group-peer-checked:text-white",
                    icon: ["fal", "align-right"]
                  })
                ])
              ])
            ])
          ]),
          x("div", K4, [
            x("span", J4, L(o.$t("offset_left")), 1),
            b(da, {
              modelValue: c(n).offsetLeft,
              "onUpdate:modelValue": i[7] || (i[7] = (l) => c(n).offsetLeft = l),
              class: "smake:w-full",
              min: c(a).offsetLeft.min,
              max: c(a).offsetLeft.max,
              step: 1
            }, null, 8, ["modelValue", "min", "max"])
          ])
        ]),
        b(h4, {
          modelValue: c(n).bendingRadius,
          "onUpdate:modelValue": i[8] || (i[8] = (l) => c(n).bendingRadius = l)
        }, null, 8, ["modelValue"])
      ], 64);
    };
  }
}), e8 = { class: "smake:flex smake:justify-between" }, t8 = { class: "smake:text-sm smake:font-bold smake:uppercase" }, n8 = ["onUpdate:modelValue", "onFocus", "onKeydown"], s8 = /* @__PURE__ */ K({
  __name: "TextComponent",
  props: {
    data: {}
  },
  emits: ["remove"],
  setup(t, { emit: e }) {
    const n = t, { data: s } = Ae(n), a = e, { data: o } = D(Qt()), { positioningArea: i, positioningAreaDesign: r } = D(
      an()
    ), l = I(
      () => o.value.find(
        (C) => (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          C.positioningAreas.includes(i.value)
        )
      )
    ), u = eh(l, i), m = N({}), h = N(), v = I(
      () => s.value.lines.find(
        (C) => He(C) === h.value
      )
    );
    ie(() => {
      v.value || (s.value.lines[0] ? h.value = He(s.value.lines[0]) : a("remove"));
    });
    async function _(C) {
      var E;
      const M = s.value.lines[C], T = M ? { ...Es(M), text: "" } : u();
      s.value.lines.splice(C + 1, 0, T), await bo(), (E = m.value[He(s.value.lines[C + 1])]) == null || E.focus();
    }
    function y() {
      const C = v.value;
      if (C)
        for (const M of s.value.lines)
          M !== C && (M.bendingRadius = C.bendingRadius, M.color = { ...C.color }, M.fontId = C.fontId, M.horizontalAlignment = C.horizontalAlignment, M.paddingBottom = C.paddingBottom, M.size = C.size);
    }
    function S() {
      var M;
      if (!v.value) return;
      const C = s.value.lines[(s.value.lines.indexOf(v.value) + 1) % s.value.lines.length];
      C && ((M = m.value[He(C)]) == null || M.focus());
    }
    function f() {
      var M;
      if (!v.value) return;
      const C = s.value.lines[(s.value.lines.indexOf(v.value) - 1 + s.value.lines.length) % s.value.lines.length];
      C && ((M = m.value[He(C)]) == null || M.focus());
    }
    function k(C) {
      if (C === v.value) {
        const M = s.value.lines.indexOf(C), T = s.value.lines[M - 1] ?? s.value.lines[M + 1];
        h.value = T ? He(T) : void 0;
      }
      s.value.lines = s.value.lines.filter((M) => M !== C), s.value.lines.length === 0 && w();
    }
    function w() {
      var C;
      i.value && (((C = r.value) == null ? void 0 : C.design.type) === be.ANCHOR ? r.value.design = r.value.design.parent : (i.value.designs = i.value.designs.filter(
        (M) => M !== r.value
      ), r.value = void 0));
    }
    return (C, M) => {
      const T = xe("FontAwesomeIcon");
      return $(), Z(Tl, { "data-testid": "TextComponent" }, {
        default: P(() => [
          x("div", e8, [
            x("h3", t8, L(C.$t("texts")), 1),
            b(ye, {
              type: "secondary",
              onClick: w
            }, {
              default: P(() => [
                b(T, {
                  class: "smake:size-5",
                  icon: ["fak", "icon-remove"],
                  "fixed-width": ""
                })
              ]),
              _: 1
            })
          ]),
          b(Rp, {
            tag: "div",
            class: "smake:relative smake:flex smake:flex-col smake:gap-2",
            "enter-active-class": "smake:duration-300",
            "enter-from-class": "smake:translate-x-8 smake:opacity-0",
            "leave-active-class": "smake:duration-200",
            "leave-to-class": "smake:translate-x-8 smake:opacity-0",
            "move-class": "smake:duration-300"
          }, {
            default: P(() => [
              ($(!0), O(re, null, $e(c(s).lines, (E, U) => ($(), O("div", {
                key: c(He)(E),
                class: Se([
                  "smake:flex smake:overflow-hidden smake:rounded-md smake:border-[1px] smake:outline-[1px] smake:duration-150 smake:focus-within:outline",
                  v.value === E ? "smake:border-black" : "smake:border-secondary-2"
                ])
              }, [
                ot(x("input", {
                  ref_for: !0,
                  ref: (F) => {
                    F === null ? delete m.value[c(He)(E)] : m.value[c(He)(E)] = F;
                  },
                  "onUpdate:modelValue": (F) => E.text = F,
                  "data-testId": "TextInput",
                  class: "smake:grow smake:p-2 smake:outline-hidden",
                  type: "text",
                  onFocus: (F) => h.value = c(He)(E),
                  onKeydown: [
                    Za(os(S, ["exact", "prevent"]), ["tab"]),
                    Za(os(f, ["shift", "exact", "prevent"]), ["tab"]),
                    Za(os((F) => _(U), ["prevent"]), ["enter"])
                  ]
                }, null, 40, n8), [
                  [pn, E.text]
                ]),
                b(ye, {
                  type: "secondary",
                  class: "smake:m-2",
                  onClick: (F) => k(E)
                }, {
                  default: P(() => [
                    b(T, {
                      class: "smake:size-3",
                      icon: ["fak", "icon-x"],
                      "fixed-width": ""
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ], 2))), 128))
            ]),
            _: 1
          }),
          x("button", {
            class: "smake:flex smake:items-center smake:justify-center smake:gap-2 smake:text-xs smake:duration-150 smake:hover:opacity-60",
            onClick: M[0] || (M[0] = (E) => _(c(s).lines.length - 1))
          }, [
            b(T, {
              class: "smake:size-8 smake:rounded-full smake:bg-black smake:p-1.5 smake:text-white",
              icon: ["fal", "plus"],
              "fixed-width": ""
            }),
            ce(" " + L(C.$t("add_text_line")), 1)
          ]),
          v.value ? ($(), Z(Y4, {
            key: 0,
            data: v.value
          }, null, 8, ["data"])) : X("", !0),
          b(ye, {
            type: "secondary",
            class: "smake:text-xs smake:font-semibold",
            onClick: y
          }, {
            default: P(() => [
              ce(L(C.$t("apply_to_all_lines")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), a8 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-y-auto smake:bg-white smake:p-4 smake:@sm:rounded-lg" }, o8 = {
  key: 6,
  class: "smake:flex smake:grow smake:flex-col smake:items-center smake:justify-end smake:gap-4 smake:text-secondary-1"
}, i8 = { class: "smake:text-center smake:whitespace-pre-line" }, r8 = { class: "smake:flex smake:gap-4 smake:px-4 smake:pb-4 smake:@sm:p-0" }, l8 = { class: "smake:flex smake:grow smake:justify-center" }, c8 = /* @__PURE__ */ K({
  __name: "DesignEditDialog",
  setup(t) {
    const {
      open: e,
      positioningArea: n,
      positioningAreaDesign: s,
      positioningAreaDesignBackup: a
    } = D(an()), { selectedPositioningAreaDesign: o } = D(xn()), { selectedProductionMethodId: i } = D(Ze()), { fetchStatus: r, normalizedDesign: l, size: u, status: m } = xl(
      I(() => {
        if (i.value !== void 0 && s.value !== void 0)
          return {
            design: s.value.design,
            productionMethodId: i.value
          };
      })
    ), { data: h } = D(Qt()), v = I(
      () => h.value.find(
        (he) => (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          he.positioningAreas.includes(n.value)
        )
      )
    ), _ = Ym(), { open: y } = Bs(), S = eh(v, n), { hasAccess: f } = Pa(), { isCustomerLogoUploadEnabled: k } = xt(
      i
    ), { customerLogoUploadInfo: w } = D(Ma()), C = I(
      () => u.value && s.value ? Ms(
        u.value,
        { x: 0, y: 0 },
        s.value.rotation
      ) : void 0
    ), M = Oo(C, n), T = I(() => {
      var _e;
      if (!s.value) return;
      const he = s.value.design;
      if (he.type === be.TEXT)
        return he;
      if (he.type === be.ANCHOR && ((_e = he.children[0]) == null ? void 0 : _e.value.type) === be.TEXT)
        return he.children[0].value;
    }), E = I(() => {
      if (!s.value) return;
      const he = s.value.design;
      if (he.type === be.LOGO)
        return he;
      if (he.type === be.ANCHOR && he.parent.type === be.LOGO)
        return he.parent;
    }), U = le.logos.get.use(
      I(() => {
        var he;
        return (he = E.value) == null ? void 0 : he.logoId;
      })
    ), { data: F, status: ee } = kt({
      ...U,
      enabled: I(
        () => U.enabled.value && !!E.value
      ),
      retry: !1,
      staleTime: 1 / 0
    });
    async function Q(he) {
      i.value !== void 0 && n.value !== void 0 && await y(Ml, {
        initialProductionMethodId: i.value,
        intialTab: he,
        positioningArea: n.value,
        positioningAreaDesign: s.value
      });
    }
    async function se() {
      i.value !== void 0 && n.value !== void 0 && await y(ih, {
        initialProductionMethodId: i.value,
        positioningArea: n.value,
        positioningAreaDesign: s.value
      });
    }
    function W() {
      var _e, te;
      if (!n.value) return;
      const he = {
        lines: [S()],
        type: be.TEXT
      };
      if (((_e = s.value) == null ? void 0 : _e.design.type) === be.LOGO)
        s.value.design = {
          children: [
            F.value ? {
              anchor: F.value.design_settings.next_element_alignment.anchor_value,
              offset: {
                ...F.value.design_settings.next_element_alignment.offset
              },
              value: he
            } : {
              anchor: vs.BOTTOM_CENTER,
              offset: { x: 0, y: 5 },
              value: he
            }
          ],
          parent: s.value.design,
          type: be.ANCHOR
        };
      else {
        const J = {
          design: he,
          rotation: ((te = _(n.value.id)) == null ? void 0 : te.direction) ?? 0
        };
        n.value.designs.push(J), s.value = J, o.value = J;
      }
    }
    function Y() {
      n.value && (n.value.designs = n.value.designs.filter(
        (he) => he !== s.value
      ), a.value && n.value.designs.push(
        a.value
      )), o.value = void 0, e.value = !1;
    }
    function me() {
      s.value && l.value && (s.value.design = l.value), o.value = void 0, e.value = !1;
    }
    return (he, _e) => {
      const te = xe("FontAwesomeIcon");
      return $(), Z(De, {
        appear: "",
        "enter-active-class": "smake:duration-300 smake:ease-out",
        "enter-from-class": "smake:translate-x-full",
        "leave-active-class": "smake:duration-200 smake:ease-in smake:absolute smake:inset-y-0 smake:right-0",
        "leave-to-class": "smake:translate-x-full"
      }, {
        default: P(() => {
          var J, de;
          return [
            c(n) ? ($(), O("div", {
              key: 0,
              "data-testid": "designEditDialog",
              class: Se(["smake:pointer-events-auto smake:flex smake:w-full smake:max-w-full smake:flex-col smake:gap-4 smake:bg-secondary-3 smake:shadow-[0_0_15px_0_rgba(0,0,0,.25)] smake:@sm:w-[480px] smake:@sm:p-4", { "smake:hidden": !c(e) }])
            }, [
              x("div", a8, [
                b(l4, {
                  onSaved: _e[0] || (_e[0] = (ke) => Q("designs"))
                }),
                E.value ? ($(), Z(Yx, {
                  key: 0,
                  data: E.value
                }, null, 8, ["data"])) : c(l) ? ($(), Z(n4, { key: 1 })) : X("", !0),
                T.value ? ($(), Z(s8, {
                  key: 2,
                  data: T.value
                }, null, 8, ["data"])) : X("", !0),
                b(d6, {
                  "positioning-area": c(n),
                  "positioning-area-design": c(s)
                }, null, 8, ["positioning-area", "positioning-area-design"]),
                !E.value || c(ee) === "pending" || !((J = c(F)) != null && J.is_customer_logo) ? ($(), Z(eo, {
                  key: 3,
                  icon: ["fak", "icon-design-logo"],
                  text: he.$t("logos_and_designs"),
                  loading: E.value && c(ee) === "pending",
                  "data-testid": "AddCustomerLogoOrDesignButton",
                  onClick: _e[1] || (_e[1] = (ke) => Q("customer-logos"))
                }, null, 8, ["text", "loading"])) : X("", !0),
                !E.value || c(ee) === "pending" || (de = c(F)) != null && de.is_customer_logo ? ($(), Z(eo, {
                  key: 4,
                  icon: ["fak", "icon-design-database"],
                  text: he.$t("icon_database"),
                  loading: E.value && c(ee) === "pending",
                  "data-testid": "AddLogoComponentButton",
                  onClick: se
                }, null, 8, ["text", "loading"])) : X("", !0),
                T.value ? X("", !0) : ($(), Z(eo, {
                  key: 5,
                  icon: ["fak", "icon-design-text"],
                  text: he.$t("texts"),
                  "data-testid": "AddTextComponentButton",
                  onClick: W
                }, null, 8, ["text"])),
                c(w) && (!c(f)(c(At).CUSTOMER_LOGO_UPLOAD) || !c(k)) ? ($(), O("div", o8, [
                  b(te, {
                    icon: ["fak", "icon-info"],
                    "fixed-width": "",
                    class: "smake:size-7"
                  }),
                  x("span", i8, L(c(w)), 1)
                ])) : X("", !0)
              ]),
              x("div", r8, [
                b(ye, {
                  type: "white",
                  class: "smake:flex-1 smake:p-4 smake:text-xs smake:font-semibold",
                  onClick: Y
                }, {
                  default: P(() => [
                    b(te, {
                      icon: ["fal", "chevron-left"],
                      class: "smake:h-3"
                    }),
                    x("div", l8, L(he.$t("abort")), 1)
                  ]),
                  _: 1
                }),
                b(ye, {
                  type: "primary",
                  class: "smake:flex-1 smake:p-4 smake:text-xs",
                  "data-testid": "PlaceButton",
                  disabled: c(m) !== "success" || c(r) !== "idle" || c(l) === void 0 || c(M),
                  onClick: me
                }, {
                  default: P(() => [
                    ce(L(he.$t("place")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 2)) : X("", !0)
          ];
        }),
        _: 1
      });
    };
  }
});
function u8(t) {
  const e = jt(t), n = le.logos.get.use(
    I(() => e.value)
  ), { data: s } = kt({
    ...n,
    enabled: I(
      () => n.enabled.value && !!e.value
    ),
    retry: !1,
    staleTime: 1 / 0
  });
  return I(() => {
    var a, o, i, r;
    return {
      size: {
        max: Math.max(
          ((a = s.value) == null ? void 0 : a.max_width) ?? 1 / 0,
          ((o = s.value) == null ? void 0 : o.max_height) ?? 1 / 0
        ),
        min: Math.min(
          ((i = s.value) == null ? void 0 : i.min_width) ?? 0,
          ((r = s.value) == null ? void 0 : r.min_height) ?? 0
        )
      }
    };
  });
}
function d8(t) {
  const e = Zu(t), n = I(() => {
    if (e.value.type === be.TEXT)
      return e.value.lines;
    if (e.value.type === be.LOGO) return [];
    const i = e.value.children[0];
    return i ? i.value.type !== be.TEXT ? [] : i.value.lines : [];
  }), s = rh(n), a = I(() => {
    if (e.value.type === be.LOGO)
      return e.value.logoId;
    if (e.value.type === be.ANCHOR && e.value.parent.type === be.LOGO)
      return e.value.parent.logoId;
  }), o = u8(a);
  return I(() => ({
    anchor: es,
    logo: a.value === void 0 ? void 0 : o.value,
    text: n.value.length > 0 ? s.value : void 0
  }));
}
const m8 = Symbol("renderingFailedToast"), h8 = /* @__PURE__ */ K({
  __name: "PositioningAreaDesign",
  props: /* @__PURE__ */ Ne({
    data: {},
    productionMethodId: {}
  }, {
    invalidDesigns: {
      required: !0
    },
    invalidDesignsModifiers: {}
  }),
  emits: ["update:invalidDesigns"],
  setup(t) {
    const e = t, { data: n, productionMethodId: s } = Ae(e), a = je(t, "invalidDesigns"), { close: o, open: i } = Ia(), { t: r } = wt(), { designerConfiguration: l } = D(it()), { hidePositioningAreas: u, selectedPositioningAreaDesign: m } = D(xn()), {
      forceClose: h,
      open: v,
      positioningArea: _,
      positioningAreaDesign: y
    } = D(an()), S = wk(), { selectedProductionMethodId: f } = D(Ze()), k = I(
      () => s.value === f.value
    ), w = I(
      () => {
        var Pe;
        return qs[((Pe = l.value) == null ? void 0 : Pe.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), C = pm(
      I(() => n.value.design),
      w
    ), M = N(), T = N("idle"), E = N("pending");
    ht([T, E], ([Pe, ae]) => {
      Pe === "idle" && (ae === "success" ? M.value = Es(n.value.design) : ae === "error" && (i(fs, {
        id: m8,
        input: {
          text: r("error_pusher_rendering_failed"),
          type: "info"
        }
      }), M.value && (n.value.design = M.value)));
    });
    const U = N(), F = Oo(U), ee = Symbol("elemtOutsidePlacementAreaToast");
    ie(() => {
      if (F.value) {
        i(fs, {
          id: ee,
          input: {
            text: r("element_outside_placement_area"),
            type: "error"
          }
        });
        return;
      }
      o(ee);
    }), ie((Pe) => {
      if (!F.value) return;
      const ae = n.value;
      a.value.push(ae), Pe(() => {
        a.value = a.value.filter(
          (pe) => pe !== ae
        );
      });
    });
    const Q = N();
    yk(n, Q, {
      onMove: (Pe, ae) => {
        y.value === n.value && (_.value = ae);
      }
    });
    const se = N(!1);
    ie((Pe) => {
      Q.value && (h.value = !0, se.value = u.value, u.value = !1, Pe(() => {
        h.value = !1, u.value = se.value;
      }));
    });
    function W(Pe, ae) {
      const pe = av({
        iconName: ae,
        prefix: Pe
      }).icon;
      return {
        height: pe[1],
        path: pe[4],
        width: pe[0]
      };
    }
    const Y = W("fal", "arrow-rotate-right"), me = W("fak", "icon-remove"), he = W("fak", "resize"), { isSelectingPositioningArea: _e } = D(
      Gt()
    );
    function te() {
      m.value = n.value, h.value = !0, _.value = S.value, y.value = n.value;
    }
    const J = I(() => {
      const Pe = n.value.design;
      if (Pe.type === be.LOGO)
        return Pe;
      if (Pe.type === be.ANCHOR && Pe.parent.type === be.LOGO)
        return Pe.parent;
    }), de = le.logos.get.use(
      I(() => {
        var Pe;
        return (Pe = J.value) == null ? void 0 : Pe.logoId;
      })
    ), { data: ke } = kt({
      ...de,
      enabled: I(
        () => de.enabled.value && !!J.value
      ),
      retry: !1,
      staleTime: 1 / 0
    }), Te = I(() => E.value === "pending" ? !1 : ke.value ? ke.value.is_scaleable : !0), Ve = I(() => n.value.design), nt = d8(Ve);
    return (Pe, ae) => ($(), Z(c(pk), {
      disabled: !Q.value && c(m) !== c(n)
    }, {
      default: P(() => [
        b(c(ok), {
          disabled: !k.value || c(_e) || c(v) && c(y) !== c(n),
          "onUpdate:point": ae[3] || (ae[3] = (pe) => Q.value = pe),
          onPointerdown: te
        }, {
          default: P(() => [
            b(c(zo), {
              data: c(n),
              placeholder: {
                color: 13948116,
                radius: 6 / w.value,
                ...c(C)
              },
              "onUpdate:boundingBox": ae[0] || (ae[0] = (pe) => U.value = pe),
              "onUpdate:fetchStatus": ae[1] || (ae[1] = (pe) => T.value = pe),
              "onUpdate:status": ae[2] || (ae[2] = (pe) => E.value = pe)
            }, {
              default: P(() => [
                b(c(W_), {
                  "rotate-icon": c(Y),
                  "delete-icon": c(me),
                  "resize-icon": c(he),
                  rotateable: "",
                  deleteable: "",
                  resizeable: Te.value,
                  "rotate-step": 90,
                  hidden: c(n) !== c(m),
                  "design-bounds": c(nt),
                  padding: 3 / w.value,
                  "rotation-control-length": 15 / w.value
                }, null, 8, ["rotate-icon", "delete-icon", "resize-icon", "resizeable", "hidden", "design-bounds", "padding", "rotation-control-length"])
              ]),
              _: 1
            }, 8, ["data", "placeholder"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["disabled"]));
  }
}), p8 = /* @__PURE__ */ K({
  __name: "PositioningArea",
  props: {
    data: {},
    isNearestPositioningArea: { type: Boolean }
  },
  setup(t) {
    const e = t, { data: n, isNearestPositioningArea: s } = Ae(e), {
      hidePositioningAreas: a,
      highlightEmptyPositioningAreas: o,
      selectedPositioningAreaDesign: i
    } = D(xn()), { selectPositioningArea: r } = Gt(), { isSelectingPositioningArea: l } = D(
      Gt()
    ), { selectedProductionMethodId: u } = D(Ze()), {
      open: m,
      positioningArea: h,
      positioningAreaDesign: v
    } = D(an()), { isLight: _ } = $a(n), y = N([]), S = I(
      () => n.value.productionMethodId !== u.value || !l.value && n.value.designs.length > 1 || l.value && n.value.designs.length > 0 || m.value && h.value !== n.value
    );
    function f(T) {
      if (T.stopPropagation(), i.value = void 0, l.value) {
        r(n.value);
        return;
      }
      if (h.value = n.value, n.value.designs.length === 1) {
        v.value = n.value.designs[0], i.value = n.value.designs[0];
        return;
      }
      v.value = void 0;
    }
    const k = I(() => [1, 1, 1, 0.5]), w = I(() => {
      if (C.value)
        return k.value;
    }), C = I(() => !!(s.value || o.value && M.value)), M = I(() => n.value.designs.length === 0);
    return (T, E) => ($(), Z(c(To), {
      data: c(n),
      hidden: c(n).productionMethodId !== c(u) || c(a) || c(m) && c(h) !== c(n),
      "stroke-color": y.value.length > 0 ? 16711680 : c(_) ? 4605510 : 14474460,
      "fill-color": w.value,
      "event-mode": S.value ? "passive" : "static",
      cursor: "pointer",
      onPointerdown: f
    }, {
      default: P(() => [
        ($(!0), O(re, null, $e(c(n).designs, (U) => ($(), Z(h8, {
          key: c(He)(U),
          "invalid-designs": y.value,
          "onUpdate:invalidDesigns": E[0] || (E[0] = (F) => y.value = F),
          data: U,
          "production-method-id": c(n).productionMethodId
        }, null, 8, ["invalid-designs", "data", "production-method-id"]))), 128))
      ]),
      _: 1
    }, 8, ["data", "hidden", "stroke-color", "fill-color", "event-mode"]));
  }
}), f8 = /* @__PURE__ */ K({
  __name: "Designer",
  setup(t) {
    const { data: e, selectedViewIndex: n } = D(Qt()), { designerCore: s, readOnlyZoom: a, selectedPositioningAreaDesign: o, stage: i } = D(xn()), { designerConfiguration: r } = D(it()), l = I(
      () => {
        var v;
        return qs[((v = r.value) == null ? void 0 : v.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), u = bk();
    function m() {
      o.value = void 0;
    }
    function h(v) {
      a.value = v;
    }
    return (v, _) => ($(), Z(c(Mo), {
      ref_key: "designerCore",
      ref: s,
      "clamp-zoom": { min: 1, max: 2.5 },
      draggable: "",
      stage: c(i),
      onClick: m,
      "onUpdate:zoom": h
    }, {
      default: P(() => [
        ($(!0), O(re, null, $e(c(e), (y, S) => ($(), Z(c(Eo), {
          key: c(He)(y),
          data: y,
          hidden: S !== c(n),
          placeholder: { color: 15856113, radius: 6 / l.value }
        }, {
          default: P(() => [
            ($(!0), O(re, null, $e(y.positioningAreas, (f) => ($(), Z(p8, {
              key: c(He)(f),
              data: f,
              "is-nearest-positioning-area": c(u).some(
                ({ positioningArea: k }) => k === f
              )
            }, null, 8, ["data", "is-nearest-positioning-area"]))), 128))
          ]),
          _: 2
        }, 1032, ["data", "hidden", "placeholder"]))), 128))
      ]),
      _: 1
    }, 8, ["stage"]));
  }
}), v8 = /* @__PURE__ */ K({
  __name: "Dialogs",
  setup(t) {
    const { dialogs: e, dialogsRoot: n, hideAllDialogs: s } = D(sn()), { removeDialog: a } = sn();
    function o(i, r) {
      r || i.resolve();
    }
    return (i, r) => ot(($(), O("div", {
      ref_key: "dialogsRoot",
      ref: n
    }, [
      ($(!0), O(re, null, $e(c(e), (l) => ($(), Z(Kr(l.component), wo({
        key: c(He)(l)
      }, { ref_for: !0 }, l.input, {
        open: l.open,
        "onUpdate:open": [(u) => l.open = u, (u) => o(l, u)],
        onClosed: (u) => c(a)(l),
        onResolve: l.resolve
      }), null, 16, ["open", "onUpdate:open", "onClosed", "onResolve"]))), 128))
    ], 512)), [
      [Lp, !c(s)]
    ]);
  }
}), g8 = tt("saveAndDownloadPdf", () => {
  const t = mt(), { data: e } = D(Zt()), n = I(() => !!a.value), s = Wo(), a = I(() => {
    if (e.value && s.value.length !== 0)
      return {
        baseId: e.value.id,
        views: s.value
      };
  }), o = N(), { mutate: i } = tn({
    ...le.variants.pdf.postForDownload.use(),
    // TOdo add toast
    onError: (h) => {
      u.value = !1;
    },
    onMutate: () => u.value = !0,
    onSuccess(h) {
      o.value = h;
    }
  });
  function r() {
    a.value && i(a.value);
  }
  const l = en(
    (h) => t.fetchQuery({
      ...le.variants.pdf.getByVariantId.use(h),
      retry: !1,
      staleTime: 1 / 0
    })
  );
  gm(
    "customVariant.customizationsCompletedForPDFDownload",
    async ({ id: h, name: v, id_hash: _ }) => {
      if (o.value === h) {
        try {
          o.value = void 0, await m(h, `Design ID ${_} - ${v}.pdf`);
        } catch {
        }
        u.value = !1;
      }
    }
  );
  const u = N(!1);
  async function m(h, v) {
    const _ = await l(h), y = URL.createObjectURL(_), S = document.createElement("a");
    S.href = y, S.download = v, S.click();
  }
  return {
    canDownload: n,
    download: r,
    isPending: u
  };
}), _8 = ["disabled"], k8 = { class: "smake:flex smake:aspect-square smake:h-16 smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-2 smake:duration-150 smake:group-enabled:group-hover:border-black" }, y8 = { class: "smake:text-xs" }, b8 = /* @__PURE__ */ K({
  __name: "DownloadPdf",
  setup(t) {
    const e = g8(), { download: n } = e, { canDownload: s, isPending: a } = D(e), { selectedProductionMethodId: o } = D(Ze()), i = I(
      () => !s.value || a.value || o.value === void 0
    );
    return (r, l) => {
      const u = xe("FontAwesomeIcon");
      return $(), O("button", {
        type: "button",
        "data-testid": "DownloadPdf",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: i.value,
        onClick: l[0] || (l[0] = //@ts-ignore
        (...m) => c(n) && c(n)(...m))
      }, [
        x("div", k8, [
          c(a) ? ($(), Z(u, {
            key: 0,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), Z(u, {
            key: 1,
            icon: ["fak", "download"],
            "fixed-width": "",
            class: "smake:h-7"
          }))
        ]),
        x("div", y8, L(r.$t("pdf_download")), 1)
      ], 8, _8);
    };
  }
}), w8 = { key: 0 }, x8 = { class: "smake:rounded-full smake:bg-secondary-3 smake:p-3" }, $8 = /* @__PURE__ */ K({
  __name: "FileUploadDialogButton",
  setup(t) {
    const { selectedProductionMethodId: e } = D(Ze()), { isFileUploadDialogOpen: n } = D(js()), { isCustomerLogoUploadEnabled: s } = xt(
      e
    );
    return (a, o) => c(s) ? ($(), O("div", w8, [
      x("button", {
        "data-testid": "FileUploadDialogButton",
        type: "button",
        class: "smake:pointer-events-auto smake:flex smake:w-50 smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:p-3 smake:py-5 smake:text-sm smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50",
        onClick: o[0] || (o[0] = (i) => n.value = !0)
      }, [
        x("div", x8, [
          b(Zo, { class: "smake:size-5" })
        ]),
        ce(" " + L(a.$t("upload_file")), 1)
      ]),
      c(e) ? ($(), Z(Ta, {
        key: 0,
        open: c(n),
        "onUpdate:open": o[1] || (o[1] = (i) => _t(n) ? n.value = i : null),
        "production-method-id": c(e)
      }, null, 8, ["open", "production-method-id"])) : X("", !0)
    ])) : X("", !0);
  }
}), S8 = { key: 0 }, A8 = { class: "smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2" }, C8 = { class: "smake:text-center smake:text-xs" }, P8 = /* @__PURE__ */ K({
  __name: "FileUploadDialogButtonMobile",
  setup(t) {
    const { selectedProductionMethodId: e } = D(Ze()), { isCustomerLogoUploadEnabled: n } = xt(
      e
    ), { isFileUploadDialogOpen: s } = D(js());
    return (a, o) => c(n) ? ($(), O("div", S8, [
      x("div", A8, [
        b(ye, {
          "data-testid": "FileUploadDialogButton",
          class: "smake:size-16",
          type: "secondary",
          disabled: c(e) === void 0,
          onClick: o[0] || (o[0] = (i) => s.value = !0)
        }, {
          default: P(() => [
            b(Zo, { class: "smake:size-5" })
          ]),
          _: 1
        }, 8, ["disabled"]),
        x("div", C8, L(a.$t("upload_file")), 1)
      ]),
      c(e) ? ($(), Z(Ta, {
        key: 0,
        open: c(s),
        "onUpdate:open": o[1] || (o[1] = (i) => _t(s) ? s.value = i : null),
        "production-method-id": c(e)
      }, null, 8, ["open", "production-method-id"])) : X("", !0)
    ])) : X("", !0);
  }
}), I8 = ["disabled"], M8 = {
  key: 0,
  class: "smake:text-xs"
}, kr = /* @__PURE__ */ K({
  __name: "HidePositioningAreas",
  props: {
    hideLabel: { type: Boolean }
  },
  setup(t) {
    const { hidePositioningAreas: e } = D(xn()), { isSelectingPositioningArea: n } = D(
      Gt()
    ), { selectedProductionMethodId: s } = D(Ze());
    return (a, o) => {
      const i = xe("FontAwesomeIcon");
      return $(), O("button", {
        "data-testid": "HidePositioningAreas",
        type: "button",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: c(n) || c(s) === void 0,
        onClick: o[0] || (o[0] = (r) => e.value = !c(e))
      }, [
        x("div", {
          class: Se(["smake:size-16 smake:rounded-full smake:border smake:border-secondary-1 smake:p-4 smake:duration-150 smake:group-enabled:group-hover:border-black smake:group-enabled:group-hover:bg-white", { "smake:bg-black": !c(e) }])
        }, [
          b(i, {
            class: Se(["smake:h-full smake:duration-150 smake:group-enabled:group-hover:text-black", { "smake:text-white": !c(e) }]),
            icon: ["fak", "icon-ciconfig-areaonoff"],
            "fixed-width": ""
          }, null, 8, ["class"])
        ], 2),
        a.hideLabel ? X("", !0) : ($(), O("div", M8, L(c(e) ? a.$t("show_areas") : a.$t("hide_areas")), 1))
      ], 8, I8);
    };
  }
}), ka = tt(
  "productionMethodSelection",
  () => {
    const { availableProductionMethodIds: t, designsProductionMethodIds: e } = D(Ze()), n = N(!1), s = N(!1), a = N(!1);
    ie(() => {
      e.value !== void 0 && t.value !== void 0 && (n.value || (n.value = !0, t.value.size !== 1 && e.value.size !== 1 && (s.value = !0)));
    });
    const o = I(
      () => s.value || a.value
    );
    function i() {
      s.value = !1, a.value = !1;
    }
    return {
      closeAllProductionMethodSelections: i,
      isAProductionMethodSelectionOpen: o,
      isProductionMethodSelectionCompactOpen: a,
      isProductionMethodSelectionOpen: s
    };
  }
), T8 = ["disabled"], z8 = { class: "smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-0.5" }, E8 = { class: "smake:font-bold" }, O8 = {
  key: 0,
  class: "smake:text-sm"
}, R8 = /* @__PURE__ */ K({
  __name: "SelectButton",
  props: {
    productionMethodId: {}
  },
  setup(t) {
    const e = t, { productionMethodId: n } = Ae(e), {
      isAvailableOnCurrentVariant: s,
      isSelected: a,
      productionMethod: o,
      shortDescription: i
    } = xt(n);
    return (r, l) => c(o) ? ($(), O("button", {
      key: 0,
      class: Se(["smake:flex smake:items-center smake:justify-between smake:gap-8 smake:rounded-full smake:border smake:px-1 smake:py-1 smake:hover:border-black smake:focus:border-black smake:disabled:border-secondary-2 smake:disabled:text-secondary-2 smake:disabled:hover:bg-white", {
        "smake:border-black smake:bg-black smake:text-white": c(a),
        "smake:border-secondary-2": !c(a),
        "smake:text-slate-400 smake:grayscale-[98%]": !c(s)
      }]),
      disabled: !c(s)
    }, [
      b(ln, {
        src: c(o).preview_url,
        class: "smake:size-16 smake:rounded-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
      }, null, 8, ["src"]),
      x("div", z8, [
        x("div", E8, L(c(o).display_name), 1),
        c(i) ? ($(), O("div", O8, L(c(i)), 1)) : X("", !0)
      ]),
      l[0] || (l[0] = x("div", null, null, -1))
    ], 10, T8)) : X("", !0);
  }
}), L8 = { class: "smake:absolute smake:inset-x-0 smake:top-20 smake:mx-auto smake:flex smake:max-w-fit smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, D8 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, N8 = { class: "smake:flex smake:flex-col smake:gap-4" }, V8 = /* @__PURE__ */ K({
  __name: "CompactDialog",
  setup(t) {
    const { rootElement: e } = D(Ut()), { activatedProductionMethodIds: n, selectedProductionMethodId: s } = D(Ze()), {
      isProductionMethodSelectionCompactOpen: a,
      isProductionMethodSelectionOpen: o
    } = D(ka());
    function i(u) {
      u.preventDefault();
      const m = u.target;
      !(m instanceof HTMLElement) || m.closest("[data-radix-popper-content-wrapper]");
    }
    function r() {
      a.value = !1, o.value = !0;
    }
    function l(u) {
      s.value = u, a.value = !1;
    }
    return (u, m) => {
      const h = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: c(a),
        "onUpdate:open": m[0] || (m[0] = (v) => _t(a) ? a.value = v : null)
      }, {
        default: P(() => [
          b(c(Et), { to: c(e) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0"
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-98 smake:opacity-0 smake:-translate-y-5 "
              }, {
                default: P(() => [
                  b(c(Rt), {
                    "as-child": "",
                    onInteractOutside: i
                  }, {
                    default: P(() => [
                      x("div", L8, [
                        x("div", D8, [
                          b(c(Tt), { class: "smake:text-xl smake:font-bold smake:tracking-wider smake:uppercase" }, {
                            default: P(() => [
                              ce(L(u.$t("choose_production_method")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", N8, [
                          ($(!0), O(re, null, $e(c(n), (v) => ($(), Z(R8, {
                            key: v,
                            "production-method-id": v,
                            onClick: (_) => l(v)
                          }, null, 8, ["production-method-id", "onClick"]))), 128))
                        ]),
                        b(ye, {
                          type: "secondary",
                          class: "smake:flex smake:justify-center smake:gap-3 smake:py-3 smake:font-semibold",
                          onClick: r
                        }, {
                          default: P(() => [
                            ce(L(u.$t("go_to_production_method_overview")) + " ", 1),
                            b(h, {
                              icon: ["fal", "chevron-right"],
                              class: "smake:size-5"
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), U8 = { class: "smake:relative smake:flex smake:h-full smake:flex-col smake:overflow-clip smake:rounded-3xl" }, F8 = { class: "relative rounded-t-3xl bg-secondary-2" }, j8 = {
  key: 0,
  class: "smake:absolute smake:top-3 smake:left-3 smake:flex smake:size-10 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:p-1"
}, B8 = { class: "smake:flex smake:grow smake:flex-col smake:items-center smake:gap-5 smake:bg-secondary-3 smake:p-4 smake:px-6 smake:text-center smake:[overflow-wrap:anywhere]" }, q8 = { class: "smake:mt-4 smake:text-xl smake:font-bold" }, H8 = { class: "smake:flex smake:min-h-24 smake:w-full smake:flex-col smake:items-start smake:justify-start smake:gap-2 smake:text-left smake:text-sm" }, W8 = { class: "smake:flex smake:items-center smake:gap-3" }, G8 = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, Z8 = { class: "smake:flex smake:items-center smake:gap-3" }, Q8 = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, X8 = { class: "smake:flex smake:items-center smake:gap-3" }, K8 = { class: "smake:flex smake:size-4 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:text-xs smake:text-success" }, J8 = { class: "smake:mx-2 smake:flex smake:w-full smake:flex-col smake:divide-y smake:divide-secondary-2 smake:rounded-2xl smake:bg-white smake:px-4 smake:py-1 smake:text-sm" }, Y8 = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, e5 = { class: "smake:font-bold" }, t5 = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, n5 = { class: "smake:font-bold" }, s5 = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, a5 = { class: "smake:font-bold" }, o5 = { class: "smake:grid smake:grid-cols-2 smake:items-center smake:py-3" }, i5 = { class: "smake:font-bold" }, r5 = {
  key: 0,
  class: "smake:flex smake:w-full smake:items-center smake:justify-center smake:rounded-b-3xl smake:bg-secondary-3 smake:p-6"
}, l5 = {
  key: 1,
  class: "smake:absolute smake:inset-0 smake:flex smake:items-center smake:justify-center smake:bg-gray-800/20"
}, c5 = { class: "text-center smake:mx-10 smake:rounded-3xl smake:bg-white smake:px-6 smake:py-3 smake:text-black smake:shadow" }, u5 = /* @__PURE__ */ K({
  __name: "SelectCard",
  props: {
    productionMethodId: {}
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const { t: n } = wt(), s = e, a = t, { productionMethodId: o } = Ae(a), { icon: i, isAvailableOnCurrentVariant: r, productionMethod: l } = xt(o), { activatedProductionMethodIds: u } = D(
      Ze()
    );
    return (m, h) => {
      var _;
      const v = xe("FontAwesomeIcon");
      return c(l) ? ($(), O("div", {
        key: 0,
        class: Se({
          "smake:text-slate-400 smake:grayscale-[98%]": !c(r)
        })
      }, [
        x("div", U8, [
          x("div", F8, [
            b(ln, {
              class: "smake:h-40 smake:w-full smake:object-cover smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2",
              src: c(l).preview_url
            }, null, 8, ["src"]),
            c(i) ? ($(), O("div", j8, [
              b(v, {
                class: "smake:text-2xl",
                icon: c(i)
              }, null, 8, ["icon"])
            ])) : X("", !0)
          ]),
          x("div", B8, [
            x("div", q8, L(c(l).display_name), 1),
            x("div", H8, [
              x("div", W8, [
                x("div", G8, [
                  b(v, {
                    class: "smake:p-0.5",
                    icon: ["fal", "check"]
                  })
                ]),
                x("div", null, L(m.$t(`${c(l).handle}_selling_point_1`)), 1)
              ]),
              x("div", Z8, [
                x("div", Q8, [
                  b(v, {
                    icon: ["fal", "check"],
                    class: "smake:p-0.5"
                  })
                ]),
                x("div", null, L(m.$t(`${c(l).handle}_selling_point_2`)), 1)
              ]),
              x("div", X8, [
                x("div", K8, [
                  b(v, {
                    icon: ["fal", "check"],
                    class: "smake:p-0.5"
                  })
                ]),
                x("div", null, L(m.$t(`${c(l).handle}_selling_point_3`)), 1)
              ])
            ]),
            x("div", J8, [
              x("div", Y8, [
                x("div", e5, L(m.$t("look")), 1),
                x("div", null, L(m.$t(`${c(l).handle}_look`)), 1)
              ]),
              x("div", t5, [
                x("div", n5, L(m.$t("washablility")), 1),
                x("div", null, L(m.$t(`${c(l).handle}_washability`)), 1)
              ]),
              x("div", s5, [
                x("div", a5, L(m.$t("minimum_quantity")), 1),
                x("div", null, L(m.$t("from_one_piece")), 1)
              ]),
              x("div", o5, [
                x("div", i5, L(m.$t("textiles")), 1),
                x("div", null, L(m.$t(`${c(l).handle}_textiles`)), 1)
              ])
            ])
          ]),
          (((_ = c(u)) == null ? void 0 : _.size) ?? 0) > 1 ? ($(), O("div", r5, [
            b(ye, {
              "data-testid": `selectProductionMethod-${c(o)}`,
              type: "primary",
              class: "smake:grow smake:p-3 smake:text-xs",
              disabled: !c(r),
              onClick: h[0] || (h[0] = (y) => s("select"))
            }, {
              default: P(() => [
                ce(L(c(n)("continue_with_x", {
                  x: c(l).display_name
                })), 1)
              ]),
              _: 1
            }, 8, ["data-testid", "disabled"])
          ])) : X("", !0),
          c(r) ? X("", !0) : ($(), O("div", l5, [
            x("div", c5, L(m.$t("production_method_not_available_for_variant")), 1)
          ]))
        ])
      ], 2)) : X("", !0);
    };
  }
}), d5 = {
  "data-testid": "ProductionMethodSelectionExpandedDialog",
  class: "smake:absolute smake:inset-x-0 smake:top-20 smake:mx-auto smake:flex smake:max-h-[calc(100%-80px)] smake:w-md smake:max-w-full smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-6 smake:@max-md:rounded-b-none"
}, m5 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, h5 = /* @__PURE__ */ K({
  __name: "ExpandedDialog",
  setup(t) {
    const { rootElement: e } = D(Ut()), { activatedProductionMethodIds: n, selectedProductionMethodId: s } = D(Ze()), { isProductionMethodSelectionOpen: a } = D(
      ka()
    ), { closeAllProductionMethodSelections: o } = ka();
    function i(l) {
      l.preventDefault();
      const u = l.target;
      !(u instanceof HTMLElement) || u.closest("[data-radix-popper-content-wrapper]");
    }
    function r(l) {
      s.value = l, o();
    }
    return (l, u) => ($(), Z(c(zt), {
      open: c(a),
      "onUpdate:open": u[0] || (u[0] = (m) => _t(a) ? a.value = m : null)
    }, {
      default: P(() => [
        b(c(Et), { to: c(e) }, {
          default: P(() => [
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:opacity-0"
            }, {
              default: P(() => [
                b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
              ]),
              _: 1
            }),
            b(De, {
              appear: "",
              "enter-active-class": "smake:duration-300 smake:ease-out",
              "enter-from-class": "smake:scale-95 smake:opacity-0",
              "leave-active-class": "smake:duration-200 smake:ease-in",
              "leave-to-class": "smake:scale-98 smake:opacity-0 smake:-translate-y-5 "
            }, {
              default: P(() => [
                b(c(Rt), {
                  "as-child": "",
                  onInteractOutside: i
                }, {
                  default: P(() => {
                    var m;
                    return [
                      x("div", d5, [
                        x("div", m5, [
                          b(c(Tt), { class: "smake:text-xl smake:font-bold smake:tracking-wider smake:uppercase" }, {
                            default: P(() => [
                              ce(L(l.$t("choose_production_method")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", {
                          class: Se(["smake:flex smake:shrink-0 smake:gap-6 smake:bg-white smake:@max-md:flex-col smake:@md:overflow-x-auto", {
                            "smake:justify-center": ((m = c(n)) == null ? void 0 : m.size) === 1
                          }])
                        }, [
                          ($(!0), O(re, null, $e(c(n), (h) => ($(), Z(u5, {
                            key: h,
                            class: "smake:shrink-0 smake:@md:basis-[calc(50%-12px)]",
                            "production-method-id": h,
                            onSelect: (v) => r(h)
                          }, null, 8, ["production-method-id", "onSelect"]))), 128))
                        ], 2)
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), p5 = {
  key: 1,
  class: "smake:size-4 smake:animate-pulse smake:rounded-full smake:bg-secondary-2"
}, f5 = {
  key: 2,
  class: "smake:text-xs smake:uppercase"
}, v5 = {
  key: 3,
  class: "smake:h-4 smake:w-30 smake:animate-pulse smake:rounded-lg smake:bg-secondary-2"
}, g5 = {
  key: 5,
  class: "smake:size-4 smake:animate-pulse smake:rounded-full smake:bg-secondary-2"
}, _5 = /* @__PURE__ */ K({
  __name: "ProductionMethodSelection",
  setup(t) {
    const { activatedProductionMethodIds: e, selectedProductionMethodId: n } = D(Ze()), s = I(() => {
      var y;
      return (y = r.value) == null ? void 0 : y.productionMethods.find(
        ({ id: S }) => S === n.value
      );
    }), {
      isAProductionMethodSelectionOpen: a,
      isProductionMethodSelectionCompactOpen: o
    } = D(ka()), { closeAllProductionMethodSelections: i } = ka(), { appConfiguration: r, status: l } = D(it()), { icon: u, productionMethod: m } = xt(
      n
    ), h = I(() => {
      var y;
      return ((y = e.value) == null ? void 0 : y.size) === 1 ? ["fak", "icon-info"] : a.value ? ["fal", "chevron-up"] : ["fal", "chevron-down"];
    }), v = I(() => {
      var y;
      return (y = s.value) == null ? void 0 : y.display_name;
    });
    function _() {
      if (a.value) {
        i();
        return;
      }
      o.value = !0;
    }
    return (y, S) => {
      const f = xe("FontAwesomeIcon");
      return $(), O(re, null, [
        b(ye, {
          type: "outline",
          "data-testid": "ProductionMethodSelection",
          class: Se(["smake:pointer-events-auto smake:gap-3 smake:p-4 smake:@max-md:min-w-1/2", {
            "smake:z-10 smake:border-black": c(a)
          }]),
          onClick: _
        }, {
          default: P(() => [
            c(u) ? ($(), Z(f, {
              key: 0,
              icon: c(u),
              "fixed-width": "",
              class: "smake:h-4"
            }, null, 8, ["icon"])) : c(m) ? X("", !0) : ($(), O("div", p5)),
            v.value ? ($(), O("span", f5, L(v.value), 1)) : ($(), O("span", v5)),
            c(l) !== "pending" ? ($(), Z(f, {
              key: 4,
              class: "smake:h-4",
              icon: h.value
            }, null, 8, ["icon"])) : ($(), O("div", g5))
          ]),
          _: 1
        }, 8, ["class"]),
        b(h5),
        b(V8)
      ], 64);
    };
  }
}), Zr = tt(
  "favoriteDesignCreateStatus",
  () => {
    const t = N(/* @__PURE__ */ new Set());
    function e(s) {
      t.value.add(s);
    }
    const n = I(
      () => t.value.size > 0
    );
    return Ft("favorite.rendered", ({ resource_id: s }) => {
      t.value.delete(s);
    }), {
      hasVariantsInRendering: n,
      waitForRendering: e
    };
  }
), k5 = ["disabled"], y5 = { class: "smake:flex smake:aspect-square smake:h-16 smake:items-center smake:justify-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-2 smake:duration-150 smake:group-enabled:group-hover:border-black" }, b5 = {
  key: 0,
  class: "smake:text-xs"
}, Ou = /* @__PURE__ */ K({
  __name: "SaveVariantAsFavorite",
  props: {
    hideLabel: { type: Boolean }
  },
  setup(t) {
    const { t: e } = wt(), { selectedProductionMethodId: n } = D(Ze()), s = Wo(), { data: a } = D(Zt()), o = I(() => {
      if (a.value && s.value.length !== 0)
        return {
          resource: {
            id: a.value.id,
            views: s.value
          }
        };
    });
    function i() {
      o.value && h(o.value);
    }
    const { open: r } = Ia(), { waitForRendering: l } = Zr(), { hasVariantsInRendering: u } = D(
      Zr()
    ), { isPending: m, mutate: h } = tn({
      ...le.favorites.variants.post.use(),
      onSuccess(y) {
        r(fs, {
          input: {
            text: e("archived_variant_successfully"),
            type: "success"
          }
        }), l(y);
      }
    }), { isSelectingPositioningArea: v } = D(
      Gt()
    ), _ = I(() => m.value || !o.value || u.value || v.value || n.value === void 0);
    return (y, S) => {
      const f = xe("FontAwesomeIcon");
      return $(), O("button", {
        type: "button",
        "data-testid": "SaveVariantAsFavorite",
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: _.value,
        onClick: i
      }, [
        x("div", y5, [
          c(m) || c(u) ? ($(), Z(f, {
            key: 0,
            class: "smake:h-7 smake:animate-spin",
            icon: ["fal", "spinner"]
          })) : ($(), Z(f, {
            key: 1,
            icon: ["fak", "icon-save"],
            "fixed-width": "",
            class: "smake:h-7"
          }))
        ]),
        y.hideLabel ? X("", !0) : ($(), O("div", b5, L(y.$t("save_variant")), 1))
      ], 8, k5);
    };
  }
}), w5 = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-[600px] smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, x5 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, $5 = {
  key: 0,
  class: "smake:animate-pulse"
}, S5 = { key: 1 }, A5 = /* @__PURE__ */ K({
  __name: "SessionExpiredDialog",
  setup(t) {
    const { isSessionExpired: e } = D(ba()), { dialogsRoot: n } = D(sn()), s = N(!0), { start: a, stop: o } = Gp(3e4, {
      callback: () => s.value = !1,
      controls: !0
    });
    function i() {
      s.value = !0, a();
    }
    return ie(() => {
      e.value && i(), o();
    }), (r, l) => {
      const u = xe("FontAwesomeIcon");
      return $(), Z(c(zt), { open: c(e) }, {
        default: P(() => [
          b(c(Et), { to: c(n) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0"
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), {
                    "as-child": "",
                    onInteractOutside: l[0] || (l[0] = os(() => {
                    }, ["prevent"])),
                    onEscapeKeyDown: l[1] || (l[1] = os(() => {
                    }, ["prevent"]))
                  }, {
                    default: P(() => [
                      x("div", w5, [
                        x("div", x5, [
                          b(c(Tt), { class: "smake:flex smake:items-center smake:gap-2 smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: P(() => [
                              b(u, {
                                class: "smake:text-danger",
                                icon: [
                                  "fak",
                                  "icon-ciconfig-alert-warning"
                                ]
                              }),
                              x("div", null, L(r.$t("session_expired")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        s.value ? ($(), O("div", $5, L(r.$t("trying_to_reconnect_session")), 1)) : ($(), O("div", S5, L(r.$t("session_expired_description")), 1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), C5 = ["disabled"], P5 = { class: "smake:rounded-full smake:bg-primary-1 smake:p-3" }, I5 = /* @__PURE__ */ K({
  __name: "ShowEmptyPositioningAreas",
  setup(t) {
    const { cancelSelectingPositioningArea: e, waitForSelectingPositioningArea: n } = Gt(), { isSelectingPositioningArea: s } = D(
      Gt()
    ), { selectedProductionMethodId: a } = D(Ze()), { positioningArea: o } = D(an());
    async function i() {
      if (s.value) {
        e();
        return;
      }
      const l = await n();
      o.value = l.data;
    }
    const { hasAccess: r } = Pa();
    return (l, u) => {
      const m = xe("FontAwesomeIcon");
      return $(), O("button", {
        "data-testid": "ShowEmptyPositioningAreas",
        disabled: c(a) === void 0,
        type: "button",
        class: Se(["smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50", {
          "smake:w-50 smake:p-3 smake:py-5 smake:text-sm": c(r)(
            c(At).CUSTOMER_LOGO_UPLOAD
          ),
          "smake:size-40 smake:p-5 smake:text-xs": !c(r)(
            c(At).CUSTOMER_LOGO_UPLOAD
          )
        }]),
        onClick: u[0] || (u[0] = (h) => i())
      }, [
        x("div", P5, [
          b(m, {
            class: Se(["smake:size-5 smake:text-white smake:transition-all", { "smake:rotate-45": c(s) }]),
            icon: ["fal", "plus"]
          }, null, 8, ["class"])
        ]),
        x("div", null, L(c(s) ? l.$t("abort") : l.$t("new_customization")), 1)
      ], 10, C5);
    };
  }
}), M5 = ["disabled"], T5 = { class: "smake:rounded-full smake:bg-primary-2 smake:p-6 smake:text-white smake:enabled:group-hover:bg-primary-1" }, z5 = { class: "smake:text-xs smake:font-bold" }, E5 = /* @__PURE__ */ K({
  __name: "ShowEmptyPositioningAreasMobile",
  setup(t) {
    const { cancelSelectingPositioningArea: e, waitForSelectingPositioningArea: n } = Gt(), { isSelectingPositioningArea: s } = D(
      Gt()
    ), { selectedProductionMethodId: a } = D(Ze()), { positioningArea: o } = D(an());
    async function i() {
      if (s.value) {
        e();
        return;
      }
      const r = await n();
      o.value = r.data;
    }
    return (r, l) => {
      const u = xe("FontAwesomeIcon");
      return $(), O("button", {
        class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2 smake:disabled:opacity-50",
        disabled: c(a) === void 0,
        onClick: i
      }, [
        x("div", T5, [
          b(u, {
            class: Se(["smake:size-10 smake:transition-all", { "smake:rotate-45": c(s) }]),
            icon: ["fal", "plus"]
          }, null, 8, ["class"])
        ]),
        x("div", z5, L(c(s) ? r.$t("abort") : r.$t("new_customization")), 1)
      ], 8, M5);
    };
  }
}), O5 = /* @__PURE__ */ K({
  __name: "Stage",
  setup(t) {
    const { data: e, selectedViewIndex: n } = D(Qt()), { stage: s } = D(xn()), { showLayout: a } = D(Ut()), { open: o } = D(an()), i = N(), r = N();
    function l() {
      const h = i.value;
      if (!h) return;
      const {
        offsetLeft: v,
        offsetParent: _,
        offsetTop: y
      } = h;
      _ instanceof HTMLElement && (r.value = _);
      const { height: S, width: f } = h.getBoundingClientRect();
      s.value = { height: S, width: f, x: v, y };
    }
    Ql(i, l), Ql(r, l);
    function u() {
      n.value = (n.value + 1) % e.value.length;
    }
    function m() {
      n.value = (n.value - 1 + e.value.length) % e.value.length;
    }
    return (h, v) => {
      const _ = xe("FontAwesomeIcon");
      return $(), O("div", {
        ref_key: "stageElement",
        ref: i,
        "data-testid": "stage",
        class: Se(
          c(Jm)(
            "smake:relative smake:min-w-14",
            c(a) && "smake:mx-7",
            c(o) && "smake:absolute smake:inset-0 smake:@sm:relative"
          )
        )
      }, [
        x("button", {
          type: "button",
          class: Se(["smake:pointer-events-auto smake:absolute smake:top-1/2 smake:left-0 smake:size-14 smake:-translate-x-1/2 smake:-translate-y-1/2 smake:rounded-full smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:hover:bg-secondary-2", { "smake:hidden": !c(a) }]),
          onClick: m
        }, [
          b(_, {
            class: "smake:size-full",
            icon: ["fal", "chevron-left"]
          })
        ], 2),
        x("button", {
          type: "button",
          class: Se(["smake:pointer-events-auto smake:absolute smake:top-1/2 smake:right-0 smake:size-14 smake:translate-x-1/2 smake:-translate-y-1/2 smake:rounded-full smake:bg-secondary-3 smake:p-3 smake:duration-150 smake:hover:bg-secondary-2", { "smake:hidden": !c(a) }]),
          onClick: u
        }, [
          b(_, {
            class: "smake:size-full",
            icon: ["fal", "chevron-right"]
          })
        ], 2)
      ], 2);
    };
  }
}), R5 = /* @__PURE__ */ K({
  __name: "Toasts",
  setup(t) {
    const { toasts: e } = D(Qm());
    function n(s) {
      e.value = e.value.filter((a) => a !== s);
    }
    return (s, a) => ($(!0), O(re, null, $e(c(e), (o) => ($(), Z(Kr(o.component), wo({
      key: c(He)(o)
    }, { ref_for: !0 }, o.input, {
      open: o.open,
      "onUpdate:open": (i) => o.open = i,
      onClosed: (i) => n(o)
    }), null, 16, ["open", "onUpdate:open", "onClosed"]))), 128));
  }
});
function Qr(t) {
  const e = jt(t), { data: n, fetchNextPage: s, fetchStatus: a, hasNextPage: o, status: i } = zs({
    ...le.favorites.variants.list.use(
      I(
        () => ({
          filter: {
            collection_name: e.value
          }
        })
      )
    ),
    retry: !1,
    select: (r) => r.pages.flatMap((l) => l.data),
    staleTime: 1 / 0
  });
  return {
    data: n,
    fetchNextPage: s,
    fetchStatus: a,
    hasNextPage: o,
    status: i
  };
}
const yo = tt("cartVariantsStore", () => {
  const t = N(), e = le.variants.list.use(
    I(() => ({
      id: t.value
    }))
  ), { data: n, fetchNextPage: s, fetchStatus: a, hasNextPage: o, status: i } = zs({
    ...e,
    enabled: I(
      () => {
        var l;
        return e.enabled.value && (((l = t.value) == null ? void 0 : l.length) ?? 0) > 0;
      }
    ),
    retry: !1,
    select: (l) => l.pages.flatMap((u) => u.data),
    staleTime: 1 / 0
  }), r = I(
    () => {
      var l;
      return (((l = t.value) == null ? void 0 : l.length) ?? 0) > 0 && i.value === "pending";
    }
  );
  return {
    cartItemIds: t,
    data: n,
    fetchNextPage: s,
    fetchStatus: a,
    hasNextPage: o,
    isPending: r,
    status: i
  };
});
function lh(t, e) {
  var n;
  return (n = t.flatMap((s) => s.positioningAreas).find(
    (s) => s.designs.includes(e)
  )) == null ? void 0 : n.productionMethodId;
}
const L5 = {
  key: 1,
  class: "smake:aspect-square smake:size-full smake:animate-pulse smake:rounded-md smake:bg-secondary-2"
}, ch = /* @__PURE__ */ K({
  __name: "PositioningAreaDesignPreview",
  props: {
    positioningAreaDesign: {},
    view: {}
  },
  setup(t) {
    const e = t, { positioningAreaDesign: n, view: s } = Ae(e), { designerConfiguration: a } = D(it()), o = I(
      () => {
        var l;
        return qs[((l = a.value) == null ? void 0 : l.settings.settings.units.length) ?? "mm"] ?? 1;
      }
    ), i = I(
      () => s.value.positioningAreas.find(
        (l) => l.designs.includes(n.value)
      )
    ), r = Ak(
      i,
      n,
      I(() => 5 / o.value)
    );
    return (l, u) => ($(), O("div", null, [
      i.value && c(r) ? ($(), Z(De, {
        key: 0,
        appear: "",
        "enter-active-class": "smake:duration-300 smake:ease-out",
        "enter-from-class": "smake:opacity-0",
        "leave-active-class": "smake:hidden"
      }, {
        default: P(() => [
          b(c(gk), {
            class: "smake:aspect-square smake:w-full",
            view: {
              ...c(s),
              positioningAreas: [
                {
                  ...i.value,
                  designs: [c(n)]
                }
              ]
            },
            position: c(r)
          }, null, 8, ["view", "position"])
        ]),
        _: 1
      })) : ($(), O("div", L5))
    ]));
  }
}), D5 = { class: "smake:aspect-square smake:h-4 smake:cursor-default smake:rounded-full smake:border smake:border-black smake:bg-white smake:outline-none smake:hover:bg-slate-50 smake:focus:shadow-black" }, N5 = { class: "smake:self-end" }, V5 = {
  key: 0,
  class: "smake:absolute smake:top-1 smake:right-1 smake:m-[3px] smake:flex smake:aspect-square smake:h-8 smake:items-center smake:justify-center smake:rounded-full smake:bg-secondary-3"
}, U5 = {
  key: 1,
  class: "smake:absolute smake:inset-0 smake:bg-secondary-1/50"
}, F5 = /* @__PURE__ */ K({
  __name: "PositioningAreaDesignPreviewRadio",
  props: {
    disabled: { type: Boolean },
    positioningAreaDesign: {},
    view: {}
  },
  emits: ["showVariantDetails"],
  setup(t, { emit: e }) {
    const n = t, { positioningAreaDesign: s, view: a } = Ae(n), o = I(
      () => lh(
        [a.value],
        s.value
      )
    ), { icon: i } = xt(
      o
    ), r = e;
    function l() {
      r("showVariantDetails");
    }
    return (u, m) => {
      const h = xe("FontAwesomeIcon");
      return $(), Z(c(Zf), {
        class: Se(["smake:relative smake:flex smake:justify-between smake:gap-2 smake:rounded-md smake:border smake:border-white smake:bg-white smake:p-2 smake:@md:border-secondary-1", { "opacity-80 grayscale-[50%]": u.disabled }]),
        value: c(He)(c(s)).toString(),
        disabled: u.disabled
      }, {
        default: P(() => [
          x("div", D5, [
            b(c(Qf), { class: "smake:relative smake:flex smake:size-full smake:items-center smake:justify-center smake:after:block smake:after:aspect-square smake:after:h-2 smake:after:rounded-[50%] smake:after:bg-black smake:after:content-['']" })
          ]),
          b(ch, {
            class: "smake:aspect-square smake:w-full smake:overflow-clip smake:rounded-md",
            view: c(a),
            "positioning-area-design": c(s)
          }, null, 8, ["view", "positioning-area-design"]),
          x("div", N5, [
            x("button", {
              type: "button",
              onClick: os(l, ["stop"])
            }, [
              b(h, {
                class: "smake:h-4 smake:text-secondary-1",
                icon: ["fal", "up-right-and-down-left-from-center"]
              })
            ])
          ]),
          c(i) ? ($(), O("div", V5, [
            b(h, { icon: c(i) }, null, 8, ["icon"])
          ])) : X("", !0),
          u.disabled ? ($(), O("div", U5)) : X("", !0)
        ]),
        _: 1
      }, 8, ["class", "value", "disabled"]);
    };
  }
}), j5 = { class: "smake:absolute smake:inset-x-0 smake:mx-auto smake:flex smake:max-w-[600px] smake:flex-col smake:gap-4 smake:overflow-y-auto smake:rounded-3xl smake:bg-white smake:p-6 smake:@max-md:bottom-0 smake:@max-md:max-h-[calc(100%-64px)] smake:@max-md:rounded-b-none smake:@md:top-1/2 smake:@md:max-h-[calc(100%-80px)] smake:@md:-translate-y-1/2" }, B5 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, q5 = { class: "smake:uppercase" }, H5 = { class: "smake:font-bold" }, W5 = { class: "smake:relative smake:mt-3 smake:items-center smake:justify-between smake:bg-white" }, G5 = { class: "smake:mt-10 smake:w-full" }, Z5 = { class: "smake:relative smake:flex" }, Q5 = { class: "smake:absolute smake:top-0 smake:left-0 smake:flex smake:h-full smake:w-20 smake:items-center smake:justify-center" }, X5 = { class: "smake:absolute smake:top-0 smake:right-0 smake:flex smake:h-full smake:w-20 smake:items-center smake:justify-center" }, K5 = { key: 0 }, J5 = {
  key: 0,
  class: "smake:my-6 smake:border smake:border-t-1 smake:border-secondary-2"
}, Y5 = { class: "smake:flex smake:flex-col" }, e7 = { class: "smake:text-[14px] smake:font-bold" }, t7 = {
  key: 0,
  class: "smake:text-[12px] smake:font-bold"
}, n7 = {
  key: 1,
  class: "smake:text-[12px] smake:font-bold"
}, s7 = { class: "smake:text-[12px] smake:text-secondary-2" }, a7 = { key: 0 }, o7 = /* @__PURE__ */ K({
  __name: "VariantPreviewDialog",
  props: /* @__PURE__ */ Ne({
    initialViewIndex: {},
    variant: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const { locale: n, t: s } = wt(), a = Ho(), { rootElement: o } = D(Ut()), i = N(), { animateHeight: r } = Gm(i), l = je(t, "open"), { appConfiguration: u, designerConfiguration: m } = D(
      it()
    );
    function h(Q) {
      var se;
      return (se = u.value) == null ? void 0 : se.productionMethods.find(
        (W) => W.id === Q
      );
    }
    const v = t, { initialViewIndex: _, variant: y } = Ae(v), S = N(
      y.value.views[_.value] ? _.value : 0
    ), f = I(() => y.value.views[S.value]), k = I(
      () => {
        var Q;
        return ((Q = f.value) == null ? void 0 : Q.customizations.length) ?? 0;
      }
    ), w = N(k.value > 0);
    ht(k, async () => {
      await r(() => w.value = k.value > 0);
    });
    function C() {
      if (S.value === y.value.views.length - 1) {
        S.value = 0;
        return;
      }
      if (S.value === 0) {
        S.value = 1;
        return;
      }
      S.value = S.value + 1;
    }
    function M() {
      if (S.value === 0) {
        S.value = y.value.views.length - 1;
        return;
      }
      S.value = S.value - 1;
    }
    const T = e;
    function E(Q) {
      return a.decimalFormat(
        Q.width * Q.height,
        n.value
      );
    }
    const U = I(() => y.value.views.map((Q) => "xl" in Q.mockup_urls && Q.mockup_urls.xl ? Q.mockup_urls.xl : "md" in Q.mockup_urls && Q.mockup_urls.md ? Q.mockup_urls.md : Q.image_urls.xl));
    ie(() => {
      Sb(U.value);
    });
    const F = I(() => {
      if (f.value)
        return "xl" in f.value.mockup_urls && f.value.mockup_urls.xl ? f.value.mockup_urls.xl : "md" in f.value.mockup_urls && f.value.mockup_urls.md ? f.value.mockup_urls.md : f.value.image_urls.xl;
    }), ee = I(() => {
      var Q;
      return (Q = m.value) == null ? void 0 : Q.settings.settings.units;
    });
    return (Q, se) => {
      const W = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: l.value,
        "onUpdate:open": se[1] || (se[1] = (Y) => l.value = Y)
      }, {
        default: P(() => [
          b(c(Et), { to: c(o) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: se[0] || (se[0] = (Y) => T("closed"))
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), { "as-child": "" }, {
                    default: P(() => [
                      x("div", j5, [
                        x("div", B5, [
                          b(c(Tt), { class: "smake:text-xl" }, {
                            default: P(() => {
                              var Y;
                              return [
                                x("div", q5, L(c(s)("views_preview_headlide")), 1),
                                x("div", H5, L((Y = f.value) == null ? void 0 : Y.display_name), 1)
                              ];
                            }),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(W, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", W5, [
                          x("div", G5, [
                            x("div", Z5, [
                              F.value !== void 0 ? ($(), Z(ln, {
                                key: 0,
                                src: F.value,
                                class: "smake:aspect-square smake:w-full smake:rounded-2xl smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2"
                              }, null, 8, ["src"])) : X("", !0),
                              x("div", Q5, [
                                b(ye, {
                                  type: "secondary",
                                  class: "smake:absolute smake:size-16 smake:rounded-full smake:bg-secondary-3 smake:p-4",
                                  onClick: M
                                }, {
                                  default: P(() => [
                                    b(W, {
                                      icon: ["fal", "chevron-left"],
                                      class: "smake:aspect-square smake:h-6"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              x("div", X5, [
                                b(ye, {
                                  type: "secondary",
                                  class: "smake:absolute smake:size-16 smake:rounded-full smake:bg-secondary-3 smake:p-4",
                                  onClick: C
                                }, {
                                  default: P(() => [
                                    b(W, {
                                      icon: ["fal", "chevron-right"],
                                      class: "smake:aspect-square smake:h-6"
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            f.value ? ($(), O("div", K5, [
                              f.value.customizations.length > 0 ? ($(), O("hr", J5)) : X("", !0),
                              x("div", {
                                ref_key: "customizationPreviews",
                                ref: i
                              }, [
                                x("div", {
                                  class: Se(["smake:flex smake:flex-col smake:gap-5", {
                                    "smake:hidden": !w.value
                                  }])
                                }, [
                                  ($(!0), O(re, null, $e(f.value.customizations, (Y) => {
                                    var me, he, _e;
                                    return $(), O("div", {
                                      key: Y.id,
                                      class: "smake:flex smake:gap-4"
                                    }, [
                                      x("div", {
                                        class: "smake:flex smake:size-20 smake:items-center smake:justify-center smake:rounded-lg",
                                        style: Wt(`background-color: ${Y.background_color}`)
                                      }, [
                                        Y.design.preview_url ? ($(), Z(ln, {
                                          key: 0,
                                          src: Y.design.preview_url,
                                          class: "smake:aspect-square smake:h-4/5 smake:w-4/5 smake:object-contain smake:data-[state=pending]:animate-pulse smake:data-[state=pending]:bg-secondary-2",
                                          style: Wt({
                                            rotate: `${Y.rotation}deg`
                                          })
                                        }, null, 8, ["src", "style"])) : X("", !0)
                                      ], 4),
                                      x("div", Y5, [
                                        x("div", e7, L((me = h(
                                          Y.design.production_method.id
                                        )) == null ? void 0 : me.display_name), 1),
                                        ($(!0), O(re, null, $e(c(Sl)(
                                          Y.design.elements[0]
                                        ), (te) => ($(), O(re, {
                                          key: c(He)(
                                            te
                                          )
                                        }, [
                                          te.resource_type === "logo" ? ($(), O("div", t7, L(c(s)(
                                            te.resource.is_customer_logo ? "logos" : "icon"
                                          )) + ": " + L(te.resource.name), 1)) : X("", !0),
                                          te.resource_type === "text" ? ($(), O("div", n7, L(c(s)("texts")) + ": " + L(te.resource.lines.map(
                                            (J) => J.value
                                          ).join(" ")), 1)) : X("", !0)
                                        ], 64))), 128)),
                                        x("div", s7, [
                                          ce(L(E(
                                            Y
                                          )) + " " + L((he = ee.value) == null ? void 0 : he.length) + "² ", 1),
                                          (_e = Y.positioningArea) != null && _e.positioning_area_identifier ? ($(), O("span", a7, " | " + L(Y.positioningArea.positioning_area_identifier.name) + " (" + L(Y.positioningArea.positioning_area_identifier.handle) + ") ", 1)) : X("", !0)
                                        ])
                                      ])
                                    ]);
                                  }), 128))
                                ], 2)
                              ], 512)
                            ])) : X("", !0)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), i7 = { class: "smake:flex smake:w-full smake:flex-col smake:gap-3 smake:rounded-3xl smake:bg-secondary-3 smake:p-5" }, r7 = { class: "smake:flex smake:items-start smake:justify-between" }, l7 = { class: "smake:text-xs" }, c7 = { class: "smake:mt-1 smake:text-lg smake:font-bold" }, u7 = { class: "smake:mt-2 smake:grid smake:grid-cols-[repeat(auto-fill,minmax(150px,1fr))] smake:gap-4" }, d7 = { class: "smake:mt-4 smake:grid smake:grid-cols-1 smake:gap-4" }, uh = /* @__PURE__ */ K({
  __name: "VariantCard",
  props: {
    variant: {}
  },
  emits: ["startSelectingPositioningArea", "variantChanged"],
  setup(t, { emit: e }) {
    const n = t, s = Zt(), { variantId: a } = D(s), { availableProductionMethodIds: o } = D(
      Ze()
    ), { variant: i } = Ae(n);
    function r(T) {
      k(o7, {
        initialViewIndex: T,
        variant: i.value
      });
    }
    const l = I(
      () => i.value.views.map((T) => wl(T))
    ), u = I(
      () => new Date(i.value.created_at).toLocaleDateString("de", {
        dateStyle: "medium"
      })
    ), m = I(
      () => l.value.flatMap(
        (T) => T.positioningAreas.flatMap(
          (E) => E.designs
        )
      )
    ), h = N();
    ie(() => {
      if (o.value === void 0) return;
      const T = l.value.flatMap(
        (E) => E.positioningAreas.flatMap(
          (U) => U.designs
        )
      ).find(
        (E) => v(E)
      );
      T && (h.value = He(T).toString());
    });
    function v(T) {
      const E = lh(
        l.value,
        T
      );
      return !(E === void 0 || o.value === void 0 || !o.value.has(
        E
      ));
    }
    const { placeDesign: _ } = Go();
    async function y() {
      if (!S.value || !f.value) return;
      await _({
        design: S.value.design,
        productionMethodId: f.value
      }) === "aborted-positioning-area-selection" && k(zl);
    }
    const S = I(
      () => m.value.find(
        (T) => He(T).toString() === h.value
      )
    ), f = I(() => {
      if (S.value) {
        for (const T of l.value)
          for (const E of T.positioningAreas)
            for (const U of E.designs)
              if (He(U) === He(S.value))
                return E.productionMethodId;
      }
    }), { open: k } = Bs(), w = e;
    async function C() {
      a.value = i.value.id, await s.suspense(), w("variantChanged");
    }
    const { isSelectingPositioningArea: M } = D(
      Gt()
    );
    return ie(() => {
      M.value && w("startSelectingPositioningArea");
    }), (T, E) => ($(), O("div", i7, [
      x("div", r7, [
        x("div", null, [
          x("div", l7, L(u.value) + " | #" + L(c(i).id_hash), 1),
          x("div", c7, L(c(i).name), 1)
        ]),
        x("div", null, [
          Nt(T.$slots, "header-right")
        ])
      ]),
      b(c(Xf), {
        modelValue: h.value,
        "onUpdate:modelValue": E[0] || (E[0] = (U) => h.value = U),
        class: "smake:grow"
      }, {
        default: P(() => [
          x("div", u7, [
            ($(!0), O(re, null, $e(l.value, (U) => ($(), O(re, {
              key: c(He)(U)
            }, [
              ($(!0), O(re, null, $e(U.positioningAreas, (F) => ($(), O(re, {
                key: c(He)(F)
              }, [
                ($(!0), O(re, null, $e(F.designs, (ee, Q) => ($(), Z(F5, {
                  key: c(He)(ee),
                  view: U,
                  "positioning-area-design": ee,
                  disabled: !v(
                    ee
                  ),
                  onShowVariantDetails: (se) => r(Q)
                }, null, 8, ["view", "positioning-area-design", "disabled", "onShowVariantDetails"]))), 128))
              ], 64))), 128))
            ], 64))), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      x("div", d7, [
        b(ye, {
          type: "primary",
          onClick: y
        }, {
          default: P(() => [
            ce(L(T.$t("archive_fetch_selected_customization")), 1)
          ]),
          _: 1
        }),
        b(ye, {
          type: "outline",
          onClick: C
        }, {
          default: P(() => [
            x("div", null, L(T.$t("archive_fetch_variant_with_customizations")), 1)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), m7 = { class: "smake:grid smake:grid-cols-[repeat(auto-fill,minmax(261px,1fr))] smake:gap-4 smake:overflow-y-auto smake:@md:grid-cols-[repeat(auto-fill,minmax(355px,1fr))]" }, h7 = /* @__PURE__ */ K({
  __name: "CartVariantsTabsContent",
  emits: ["startSelectingPositioningArea", "variantChanged"],
  setup(t, { emit: e }) {
    const { fetchNextPage: n } = yo(), { data: s, fetchStatus: a, hasNextPage: o } = D(yo());
    function i() {
      return a.value === "fetching" ? !0 : o.value;
    }
    async function r() {
      a.value !== "fetching" && await n();
    }
    const l = e;
    return (u, m) => ot(($(), O("div", m7, [
      ($(!0), O(re, null, $e(c(s), (h) => ($(), Z(uh, {
        key: h.id,
        variant: h,
        "is-deletable": "",
        onVariantChanged: m[0] || (m[0] = (v) => l("variantChanged")),
        onStartSelectingPositioningArea: m[1] || (m[1] = (v) => l("startSelectingPositioningArea"))
      }, null, 8, ["variant"]))), 128)),
      c(a) === "fetching" ? ($(), O(re, { key: 0 }, [
        m[2] || (m[2] = x("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1)),
        m[3] || (m[3] = x("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1))
      ], 64)) : X("", !0)
    ])), [
      [c(ya), [r, { distance: 350, canLoadMore: i }]]
    ]);
  }
}), p7 = { class: "smake:absolute smake:top-1/2 smake:left-1/2 smake:mx-auto smake:flex smake:h-fit smake:max-h-full smake:w-auto smake:max-w-[600px] smake:-translate-x-1/2 smake:-translate-y-1/2 smake:flex-col smake:gap-6 smake:rounded-3xl smake:bg-white smake:p-4" }, f7 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, v7 = { class: "smake:font-bold smake:text-primary-1" }, g7 = { class: "smake:relative smake:mt-3 smake:items-center smake:justify-between smake:bg-white" }, _7 = { class: "smake:flex smake:justify-center smake:gap-5" }, k7 = { class: "smake:flex smake:flex-wrap smake:justify-between smake:gap-5" }, y7 = { key: 1 }, b7 = /* @__PURE__ */ K({
  __name: "VariantDeleteDialog",
  props: /* @__PURE__ */ Ne({
    apiVariant: {}
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = je(t, "open"), s = e, { rootElement: a } = D(Ut()), { t: o } = wt(), i = t, { apiVariant: r } = Ae(i), l = I(
      () => r.value.resource.views.map((v) => wl(v))
    ), { isPending: u, mutate: m } = tn(
      le.favorites.delete.use()
    );
    function h(v) {
      u.value && v.preventDefault();
    }
    return (v, _) => {
      const y = xe("I18nT"), S = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: n.value,
        "onUpdate:open": _[2] || (_[2] = (f) => n.value = f)
      }, {
        default: P(() => [
          b(c(Et), { to: c(a) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: _[0] || (_[0] = (f) => s("closed"))
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:scale-95 smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:scale-95 smake:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), {
                    "as-child": "",
                    onInteractOutside: h,
                    onEscapeKeyDown: h
                  }, {
                    default: P(() => [
                      x("div", p7, [
                        x("div", f7, [
                          b(c(Tt), null, {
                            default: P(() => [
                              b(y, {
                                keypath: "are_you_sure_you_want_to_delete",
                                tag: "div"
                              }, {
                                deleteName: P(() => [
                                  x("span", v7, L(c(r).resource.name), 1)
                                ]),
                                default: P(() => [
                                  _[3] || (_[3] = ce(" > "))
                                ]),
                                _: 1,
                                __: [3]
                              })
                            ]),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(S, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        x("div", g7, [
                          x("div", _7, [
                            ($(!0), O(re, null, $e(l.value, (f) => ($(), O(re, {
                              key: c(He)(f)
                            }, [
                              ($(!0), O(re, null, $e(f.positioningAreas, (k) => ($(), O(re, {
                                key: c(He)(k)
                              }, [
                                ($(!0), O(re, null, $e(k.designs, (w) => ($(), Z(ch, {
                                  key: c(He)(w),
                                  class: "smake:size-24 smake:overflow-clip smake:rounded-md smake:shadow-md",
                                  view: f,
                                  "positioning-area-design": w
                                }, null, 8, ["view", "positioning-area-design"]))), 128))
                              ], 64))), 128))
                            ], 64))), 128))
                          ])
                        ]),
                        x("div", k7, [
                          b(c(Bt), { "as-child": "" }, {
                            default: P(() => [
                              b(ye, {
                                class: "smake:grow",
                                type: "outline"
                              }, {
                                default: P(() => [
                                  ce(L(c(o)("abort")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          b(ye, {
                            class: "smake:grow",
                            type: "primary",
                            disabled: c(u),
                            onClick: _[1] || (_[1] = (f) => c(m)(c(r).id))
                          }, {
                            default: P(() => [
                              c(u) ? ($(), Z(S, {
                                key: 0,
                                class: "smake:h-6 smake:animate-spin",
                                icon: ["fal", "spinner"]
                              })) : ($(), O("span", y7, L(c(o)("delete")), 1))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), w7 = /* @__PURE__ */ K({
  __name: "FavoriteVariantCard",
  props: {
    favoriteVariant: {},
    isDeletable: { type: Boolean }
  },
  emits: ["startSelectingPositioningArea", "variantChanged"],
  setup(t, { emit: e }) {
    const n = t, { favoriteVariant: s } = Ae(n);
    function a() {
      o(b7, {
        apiVariant: s.value
      });
    }
    const { open: o } = Bs(), i = e;
    return (r, l) => {
      const u = xe("FontAwesomeIcon");
      return $(), Z(uh, {
        variant: c(s).resource,
        onVariantChanged: l[0] || (l[0] = (m) => i("variantChanged")),
        onStartSelectingPositioningArea: l[1] || (l[1] = (m) => i("startSelectingPositioningArea"))
      }, {
        "header-right": P(() => [
          b(ye, {
            type: "secondary",
            class: "smake:flex smake:size-10 smake:items-center smake:justify-center smake:rounded-full smake:bg-white smake:disabled:cursor-not-allowed",
            onClick: a
          }, {
            default: P(() => [
              b(u, {
                class: "smake:h-5",
                icon: ["fal", "trash-alt"]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["variant"]);
    };
  }
}), x7 = { class: "smake:grid smake:grid-cols-[repeat(auto-fill,minmax(261px,1fr))] smake:gap-4 smake:overflow-y-auto smake:@md:grid-cols-[repeat(auto-fill,minmax(355px,1fr))]" }, Ru = /* @__PURE__ */ K({
  __name: "VariantCollectionTabsContent",
  props: {
    collectionName: {}
  },
  emits: ["startSelectingPositioningArea", "variantChanged"],
  setup(t, { emit: e }) {
    const n = t, { collectionName: s } = Ae(n), { data: a, fetchNextPage: o, fetchStatus: i, hasNextPage: r } = Qr(s);
    function l() {
      return i.value === "fetching" ? !0 : r.value;
    }
    async function u() {
      i.value !== "fetching" && await o();
    }
    const m = e;
    return (h, v) => ot(($(), O("div", x7, [
      ($(!0), O(re, null, $e(c(a), (_) => ($(), Z(w7, {
        key: _.id,
        "favorite-variant": _,
        "is-deletable": "",
        onVariantChanged: v[0] || (v[0] = (y) => m("variantChanged")),
        onStartSelectingPositioningArea: v[1] || (v[1] = (y) => m("startSelectingPositioningArea"))
      }, null, 8, ["favorite-variant"]))), 128)),
      c(i) === "fetching" ? ($(), O(re, { key: 0 }, [
        v[2] || (v[2] = x("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1)),
        v[3] || (v[3] = x("div", { class: "smake:h-96 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8" }, null, -1))
      ], 64)) : X("", !0)
    ])), [
      [c(ya), [u, { distance: 350, canLoadMore: l }]]
    ]);
  }
}), $7 = { class: "smake:absolute smake:inset-0 smake:top-16 smake:mx-auto smake:flex smake:w-[1280px] smake:max-w-full smake:flex-col smake:gap-4 smake:rounded-3xl smake:rounded-b-none smake:bg-white smake:p-4 smake:@sm:inset-12 smake:@sm:max-w-[calc(100%-96px)] smake:@sm:rounded-b-3xl" }, S7 = { class: "smake:flex smake:items-start smake:justify-between smake:gap-2" }, A7 = {
  key: 0,
  class: "smake:flex smake:gap-2"
}, C7 = {
  key: 0,
  class: "smake:mb-4 smake:animate-pulse smake:rounded-3xl smake:bg-secondary-3 smake:px-5 smake:py-8 smake:@md:bg-white"
}, zl = /* @__PURE__ */ K({
  __name: "VariantsDialog",
  props: /* @__PURE__ */ Ne({
    defaultTab: { default: "customer-sketch" }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["closed"], ["update:open"]),
  setup(t, { emit: e }) {
    const n = je(t, "open"), s = t, a = e, { defaultTab: o } = Ae(s), i = N(o.value), { rootElement: r } = D(Ut()), { t: l } = wt(), { data: u, isPending: m } = D(
      yo()
    ), h = I(() => {
      var T;
      return (((T = u.value) == null ? void 0 : T.length) ?? 0) > 0;
    }), { data: v, status: _ } = Qr("merchant-sketch"), y = I(
      () => {
        var T;
        return (((T = v.value) == null ? void 0 : T.length) ?? 0) > 0;
      }
    ), { status: S } = Qr("customer-sketch"), f = I(
      () => m.value || _.value === "pending" || S.value === "pending"
    );
    function k(T) {
      T.preventDefault();
      const E = T.target;
      !(E instanceof HTMLElement) || E.closest("[data-radix-popper-content-wrapper]");
    }
    function w() {
      n.value = !1;
    }
    function C() {
      n.value = !1;
    }
    const { hasVariantsInRendering: M } = D(
      Zr()
    );
    return (T, E) => {
      const U = xe("FontAwesomeIcon");
      return $(), Z(c(zt), {
        open: n.value,
        "onUpdate:open": E[2] || (E[2] = (F) => n.value = F)
      }, {
        default: P(() => [
          b(c(Et), { to: c(r) }, {
            default: P(() => [
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:opacity-0",
                onAfterLeave: E[0] || (E[0] = (F) => a("closed"))
              }, {
                default: P(() => [
                  b(c(Ot), { class: "smake:fixed smake:inset-0 smake:bg-black/40" })
                ]),
                _: 1
              }),
              b(De, {
                appear: "",
                "enter-active-class": "smake:duration-300 smake:ease-out",
                "enter-from-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0",
                "leave-active-class": "smake:duration-200 smake:ease-in",
                "leave-to-class": "smake:translate-y-full smake:@sm:translate-y-0 smake:@sm:scale-95 smake:@sm:opacity-0"
              }, {
                default: P(() => [
                  b(c(Rt), {
                    "as-child": "",
                    onInteractOutside: k
                  }, {
                    default: P(() => [
                      x("div", $7, [
                        x("div", S7, [
                          b(c(Tt), { class: "smake:text-2xl smake:font-bold smake:uppercase" }, {
                            default: P(() => [
                              ce(L(T.$t("my_customizations")), 1)
                            ]),
                            _: 1
                          }),
                          b(c(Bt), { class: "smake:-mt-2 smake:-mr-2 smake:rounded-full smake:border smake:border-secondary-2 smake:p-2 smake:duration-150 smake:hover:bg-secondary-3" }, {
                            default: P(() => [
                              b(U, {
                                icon: ["fak", "icon-x"],
                                "fixed-width": "",
                                class: "smake:size-3"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        f.value ? ($(), O("div", A7, [
                          ($(), O(re, null, $e(2, (F) => x("div", {
                            key: F,
                            class: "smake:h-[43px] smake:w-64 smake:max-w-1/2 smake:animate-pulse smake:rounded-full smake:bg-secondary-3"
                          })), 64))
                        ])) : X("", !0),
                        b(c(Jr), {
                          modelValue: i.value,
                          "onUpdate:modelValue": E[1] || (E[1] = (F) => i.value = F),
                          class: "smake:flex smake:grow smake:flex-col smake:gap-4 smake:overflow-hidden"
                        }, {
                          default: P(() => [
                            [h.value, y.value].some(
                              (F) => F === !0
                            ) && !f.value ? ($(), Z(c(Yr), {
                              key: 0,
                              class: "smake:flex smake:flex-wrap smake:gap-2"
                            }, {
                              default: P(() => [
                                h.value ? ($(), Z(ua, {
                                  key: 0,
                                  value: "cart"
                                }, {
                                  default: P(() => [
                                    ce(L(c(l)("currently_in_cart")), 1)
                                  ]),
                                  _: 1
                                })) : X("", !0),
                                b(ua, { value: "customer-sketch" }, {
                                  default: P(() => [
                                    ce(L(c(l)("saved")), 1)
                                  ]),
                                  _: 1
                                }),
                                y.value ? ($(), Z(ua, {
                                  key: 1,
                                  value: "merchant-sketch"
                                }, {
                                  default: P(() => [
                                    ce(L(c(l)("sketches")), 1)
                                  ]),
                                  _: 1
                                })) : X("", !0)
                              ]),
                              _: 1
                            })) : X("", !0),
                            b(c(ca), {
                              "as-child": "",
                              value: "cart",
                              unmount: !1
                            }, {
                              default: P(() => [
                                b(h7, {
                                  onVariantChanged: C,
                                  onStartSelectingPositioningArea: w
                                }, null, 8, ["onStartSelectingPositioningArea"])
                              ]),
                              _: 1
                            }),
                            b(c(ca), {
                              value: "customer-sketch",
                              "as-child": "",
                              unmount: !1
                            }, {
                              default: P(() => [
                                c(M) ? ($(), O("div", C7, L(c(l)("archive_new_entry_soon_available")), 1)) : X("", !0),
                                b(Ru, {
                                  "collection-name": "customer-sketch",
                                  onVariantChanged: C,
                                  onStartSelectingPositioningArea: w
                                }, null, 8, ["onStartSelectingPositioningArea"])
                              ]),
                              _: 1
                            }),
                            b(c(ca), {
                              value: "merchant-sketch",
                              "as-child": "",
                              unmount: !1
                            }, {
                              default: P(() => [
                                b(Ru, {
                                  "collection-name": "merchant-sketch",
                                  onVariantChanged: C,
                                  onStartSelectingPositioningArea: w
                                }, null, 8, ["onStartSelectingPositioningArea"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      }, 8, ["open"]);
    };
  }
}), P7 = ["disabled"], I7 = { class: "smake:rounded-full smake:bg-secondary-3 smake:p-3" }, M7 = /* @__PURE__ */ K({
  __name: "OpenVariantsDialog",
  setup(t) {
    const { isSelectingPositioningArea: e } = D(
      Gt()
    ), { selectedProductionMethodId: n } = D(Ze()), { isVariantsDialogOpen: s } = D(
      js()
    ), a = N(!1), { hasAccess: o } = Pa();
    function i() {
      a.value = !0, s.value = !0;
    }
    return (r, l) => {
      const u = xe("FontAwesomeIcon");
      return $(), O(re, null, [
        x("button", {
          type: "button",
          "data-testid": "OpenVariantsDialog",
          class: Se(["smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:justify-center smake:gap-2 smake:rounded-2xl smake:border smake:border-secondary-2 smake:bg-white smake:font-medium smake:duration-150 smake:hover:border-black smake:disabled:opacity-50", {
            "smake:w-50 smake:p-3 smake:py-5 smake:text-sm": c(o)(
              c(At).CUSTOMER_LOGO_UPLOAD
            ),
            "smake:size-40 smake:p-3 smake:text-xs": !c(o)(
              c(At).CUSTOMER_LOGO_UPLOAD
            )
          }]),
          disabled: c(e) || c(n) === void 0,
          onClick: i
        }, [
          x("div", I7, [
            b(u, {
              class: "smake:h-5",
              icon: ["fak", "icon-ciconfig-archive"],
              "fixed-width": ""
            })
          ]),
          x("div", null, L(r.$t("my_customizations")), 1)
        ], 10, P7),
        a.value ? ($(), Z(zl, {
          key: 0,
          open: c(s),
          "onUpdate:open": l[0] || (l[0] = (m) => _t(s) ? s.value = m : null),
          "default-tab": "customer-sketch"
        }, null, 8, ["open"])) : X("", !0)
      ], 64);
    };
  }
}), T7 = { key: 0 }, z7 = /* @__PURE__ */ K({
  __name: "OpenVariantsDialogMobile",
  setup(t) {
    const e = N(!1), { selectedProductionMethodId: n } = D(Ze()), { isSelectingPositioningArea: s } = D(
      Gt()
    ), { isVariantsDialogOpen: a } = D(
      js()
    );
    function o() {
      e.value = !0, a.value = !0;
    }
    return (i, r) => {
      const l = xe("FontAwesomeIcon");
      return $(), O("div", null, [
        b(ye, {
          type: "outline",
          class: "smake:px-8 smake:py-4",
          disabled: c(s) || c(n) === void 0,
          onClick: o
        }, {
          default: P(() => [
            b(l, {
              class: "smake:h-5",
              icon: ["fak", "icon-ciconfig-archive"],
              "fixed-width": ""
            }),
            ce(" " + L(i.$t("archive")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        e.value ? ($(), O("div", T7, [
          b(zl, {
            open: c(a),
            "onUpdate:open": r[0] || (r[0] = (u) => _t(a) ? a.value = u : null),
            "default-tab": "customer-sketch"
          }, null, 8, ["open"])
        ])) : X("", !0)
      ]);
    };
  }
}), E7 = {
  key: 1,
  class: "smake:flex smake:justify-center"
}, O7 = { class: "smake:flex smake:border-t-2 smake:border-secondary-2" }, R7 = /* @__PURE__ */ K({
  __name: "ViewTabs",
  setup(t) {
    const { selectedViewIndex: e } = D(Qt()), { data: n } = D(Zt());
    return (s, a) => {
      var o;
      return (o = c(n)) != null && o.views ? ($(), Z(c(Jr), {
        key: 0,
        modelValue: c(e),
        "onUpdate:modelValue": a[0] || (a[0] = (i) => _t(e) ? e.value = i : null),
        class: "smake:flex smake:justify-center"
      }, {
        default: P(() => [
          b(c(Yr), { class: "smake:relative smake:border-t-2 smake:border-secondary-2" }, {
            default: P(() => {
              var i;
              return [
                b(c(Kf), { class: "smake:absolute smake:-top-0.5 smake:left-0 smake:h-0.5 smake:w-(--radix-tabs-indicator-size) smake:translate-x-(--radix-tabs-indicator-position) smake:bg-secondary-1 smake:transition-[width,transform] smake:duration-300" }),
                ($(!0), O(re, null, $e((i = c(n)) == null ? void 0 : i.views, (r, l) => ($(), Z(c(hd), {
                  key: c(He)(r),
                  class: "smake:pointer-events-auto smake:px-2 smake:py-1 smake:text-xs",
                  value: l
                }, {
                  default: P(() => [
                    ce(L(r.display_name), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))), 128))
              ];
            }),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])) : ($(), O("div", E7, [
        x("div", O7, [
          ($(), O(re, null, $e(4, (i) => x("div", {
            key: i,
            class: "smake:mx-2 smake:my-1 smake:h-4 smake:w-8 smake:rounded-full smake:bg-secondary-2 smake:text-xs"
          })), 64))
        ])
      ]));
    };
  }
}), L7 = { class: "smake:group smake:pointer-events-auto smake:flex smake:flex-col smake:items-center smake:gap-2" }, D7 = { class: "smake:size-16 smake:rounded-full smake:border smake:border-secondary-2 smake:bg-white smake:p-4 smake:group-focus-within:hidden smake:group-hover:hidden" }, N7 = { class: "smake:absolute smake:size-px smake:flex-col smake:items-center smake:gap-2 smake:rounded-full smake:border smake:border-secondary-3 smake:bg-secondary-3 smake:p-4 smake:[clip-path:inset(50%)] smake:[clip:rect(0_0_0_0)] smake:group-focus-within:static smake:group-focus-within:flex smake:group-focus-within:h-auto smake:group-focus-within:w-16 smake:group-focus-within:[clip-path:none] smake:group-focus-within:[clip:auto] smake:group-hover:static smake:group-hover:flex smake:group-hover:h-auto smake:group-hover:w-16 smake:group-hover:[clip-path:none] smake:group-hover:[clip:auto]" }, V7 = { class: "smake:text-xs" }, yr = 1, br = 2.5, U7 = /* @__PURE__ */ K({
  __name: "Zoom",
  setup(t) {
    const { zoom: e } = D(xn()), n = I({
      get: () => [e.value],
      set: ([s]) => {
        e.value = s;
      }
    });
    return (s, a) => {
      const o = xe("FontAwesomeIcon");
      return $(), O("div", L7, [
        x("div", D7, [
          b(o, {
            class: "smake:w-full",
            "fixed-width": "",
            icon: ["fak", "icon-zoom-in"]
          })
        ]),
        x("div", N7, [
          x("button", {
            type: "button",
            tabindex: "-1",
            onClick: a[0] || (a[0] = (i) => e.value = c(qr)(c(e) + 0.1, yr, br))
          }, [
            b(o, {
              class: "smake:w-full",
              "fixed-width": "",
              icon: ["fak", "icon-zoom-in"]
            })
          ]),
          b(c(Jf), {
            modelValue: n.value,
            "onUpdate:modelValue": a[1] || (a[1] = (i) => n.value = i),
            class: "smake:relative smake:flex smake:h-[200px] smake:w-5 smake:touch-none smake:flex-col smake:items-center smake:select-none",
            max: br,
            min: yr,
            step: 0.01,
            orientation: "vertical"
          }, {
            default: P(() => [
              b(c(Yf), { class: "smake:relative smake:w-1 smake:grow smake:rounded-full smake:bg-white" }),
              b(c(ev), {
                class: "smake:block smake:size-5 smake:rounded-full smake:bg-black smake:shadow-[0_2px_10px] smake:shadow-black smake:hover:bg-gray-800 smake:focus:shadow-[0_0_0_5px] smake:focus:shadow-slate-400 smake:focus:outline-hidden",
                "aria-label": s.$t("zoom")
              }, null, 8, ["aria-label"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          x("button", {
            type: "button",
            tabindex: "-1",
            onClick: a[2] || (a[2] = (i) => e.value = c(qr)(c(e) - 0.1, yr, br))
          }, [
            b(o, {
              class: "smake:w-full",
              "fixed-width": "",
              icon: ["fak", "icon-zoom-out"]
            })
          ])
        ]),
        x("div", V7, L(s.$t("zoom")), 1)
      ]);
    };
  }
});
function F7(t) {
  const {
    activeCategories: e,
    activeProductionMethodId: n,
    fetchStatus: s,
    logos: a,
    normalizedSearchQuery: o
  } = D(_s()), i = I(
    () => e.value.map((l) => l.name)
  ), { productionMethod: r } = xt(n);
  ie(() => {
    var u;
    if (s.value === "fetching" || !o.value && i.value.length === 0 || !r.value) return;
    const l = ((u = a.value) == null ? void 0 : u.length) ?? 0;
    t({
      categorieNames: i.value,
      productionMethodHandle: r.value.handle,
      query: o.value,
      resultCount: l
    });
  });
}
function j7(t) {
  const { data: e } = D(Zt()), n = Wo(), { isADialogOpen: s } = D(js());
  ie(() => {
    if (s.value) {
      t();
      return;
    }
    if (!e.value) {
      t();
      return;
    }
    if (n.value.length === 0) {
      t();
      return;
    }
    t({
      id: e.value.id,
      views: n.value
    });
  });
}
function B7(t) {
  const e = {};
  for (const n in t) {
    const s = jt(t, n);
    e[n] = I(() => q7(s.value));
  }
  return e;
}
function q7(t) {
  if (typeof t != "string") return t;
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}
const H7 = {
  id: "designer-strauss",
  "data-testid": "designer",
  class: "smake:@container smake:h-full smake:text-[16px] smake:[overflow-wrap:anywhere]"
}, W7 = { class: "smake:pointer-events-none smake:absolute smake:inset-0 smake:flex" }, G7 = { class: "smake:flex smake:grow smake:flex-col" }, Z7 = { class: "smake:flex smake:grow smake:justify-center" }, Q7 = { class: "smake:flex smake:w-full smake:grow smake:flex-col smake:gap-4" }, X7 = { class: "smake:flex smake:w-full smake:grow smake:gap-4" }, K7 = { class: "smake:flex smake:grow smake:flex-col smake:gap-4" }, J7 = { class: "smake:flex smake:max-w-288 smake:grow smake:items-center smake:justify-center smake:gap-5 smake:@md:justify-end smake:@md:px-10" }, Y7 = /* @__PURE__ */ K({
  __name: "App.ce",
  props: {
    apiBaseUrl: { type: String },
    apiToken: { type: String },
    availableVariants: { type: String },
    cartItemIds: { type: String },
    customerLogoUploadInfo: { type: String },
    debug: { type: String },
    featureFlagCustomerLogoUpload: { type: String },
    locale: { type: String },
    pusherAppKey: { type: String },
    pusherChannelPrefix: { type: String },
    pusherCluster: { type: String },
    termsOfServiceLink: { type: String },
    uploadHelpLink: { type: String },
    userExternalIdentifier: { type: String },
    variantId: { type: [Number, String] }
  },
  emits: ["custom-variant-created", "search-statistics", "session-expired", "variant-changed"],
  setup(t, { emit: e }) {
    const n = e, s = t, {
      apiBaseUrl: a,
      apiToken: o,
      availableVariants: i,
      cartItemIds: r,
      customerLogoUploadInfo: l,
      debug: u,
      featureFlagCustomerLogoUpload: m,
      locale: h,
      pusherAppKey: v,
      pusherChannelPrefix: _,
      pusherCluster: y,
      termsOfServiceLink: S,
      uploadHelpLink: f,
      userExternalIdentifier: k,
      variantId: w
    } = B7(s), { locale: C } = wt(), { acceptLanguage: M, baseUrl: T } = D(ul()), {
      initialToken: E,
      isSessionExpired: U,
      tokenData: F,
      userExternalIdentifier: ee
    } = D(ba()), { variantId: Q } = D(Zt()), {
      availableVariants: se,
      customerLogoUploadInfo: W,
      termsOfServiceLink: Y,
      uploadHelpLink: me
    } = D(Ma()), { rootElement: he, showLayout: _e } = D(Ut()), { cartItemIds: te } = D(yo()), { designerConfiguration: J } = D(it());
    ie(() => {
      T.value = a.value, sd("api-base-url", a.value);
    }), ie(() => {
      const we = h.value;
      M.value = we, C.value = we;
    }), ie(() => {
      ee.value = k.value;
    }), ie(() => {
      E.value = o.value;
    }), ie(() => {
      U.value && n("session-expired");
    }), ie(() => {
      var we;
      Cf({ id: (we = F.value) == null ? void 0 : we.user_id });
    }), ie(() => {
      Q.value = w.value;
    }), ie(() => {
      se.value = i.value;
    }), ie(() => {
      W.value = l.value;
    }), ie(() => {
      te.value = r.value;
    }), ie(() => {
      Y.value = S.value;
    }), ie(() => {
      me.value = f.value;
    });
    const { appKey: de, channelPrefix: ke, cluster: Te } = D(fl());
    ie(() => {
      de.value = v.value;
    }), ie(() => {
      Te.value = y.value;
    }), ie(() => {
      ke.value = _.value;
    }), A_((we) => {
      console.error(we);
    });
    const { onContinue: Ve } = D(Km());
    Ve.value = (we) => {
      n("custom-variant-created", we);
    };
    const { giveAccessToFeature: nt, hasAccess: Pe, removeAccessFromFeature: ae } = Pa();
    ie(() => {
      if (m.value === !0) {
        nt(At.CUSTOMER_LOGO_UPLOAD);
        return;
      }
      ae(At.CUSTOMER_LOGO_UPLOAD);
    }), F7((we) => {
      n("search-statistics", {
        category_names: we.categorieNames,
        production_method_handle: we.productionMethodHandle,
        query: we.query,
        result_count: we.resultCount
      });
    });
    const { selectedProductionMethodId: pe } = D(Ze()), { isCustomerLogoUploadEnabled: rt } = xt(
      pe
    );
    ie(() => {
      u.value && console.debug(
        "%c Designer-Strauss Version: 5.3.37",
        "color: #93d50a"
      );
    }), j7((we) => {
      n("variant-changed", we);
    });
    const st = I(
      () => {
        var we;
        return ((we = J.value) == null ? void 0 : we.settings.is_internal) ?? !1;
      }
    );
    return (we, Ce) => ($(), Z(c(tv), { "swipe-direction": "up" }, {
      default: P(() => [
        x("div", H7, [
          x("div", {
            ref_key: "rootElement",
            ref: he,
            class: Se(["smake:relative smake:h-full smake:overflow-hidden", {
              "smake:min-h-160": !st.value,
              "smake:@md:min-h-193": !st.value,
              "smake:min-h-150": st.value,
              "smake:@md:min-h-183": !st.value
            }])
          }, [
            b(f8, { class: "smake:absolute smake:inset-0 smake:size-full" }),
            x("div", W7, [
              x("div", G7, [
                x("div", Z7, [
                  x("div", {
                    class: Se(["smake:flex smake:w-full smake:max-w-288", { "smake:m-6": c(_e) }])
                  }, [
                    x("div", Q7, [
                      x("div", {
                        class: Se(["smake:inset-x-0 smake:flex smake:w-full smake:justify-center", { "smake:hidden": !c(_e) }])
                      }, [
                        b(_5),
                        b(c(Ya), {
                          name: c(At).CUSTOMER_LOGO_UPLOAD
                        }, {
                          default: P(() => [
                            c(rt) ? ($(), Z(kr, {
                              key: 0,
                              "hide-label": "",
                              class: Se([{
                                "smake:block smake:@md:hidden": c(_e),
                                "smake:hidden": !c(_e)
                              }, "smake:absolute smake:top-21 smake:left-4"])
                            }, null, 8, ["class"])) : X("", !0)
                          ]),
                          _: 1
                        }, 8, ["name"]),
                        b(Ou, {
                          "hide-label": "",
                          class: Se([{
                            "smake:block smake:@md:hidden": c(_e),
                            "smake:hidden": !c(_e)
                          }, "smake:absolute smake:top-21 smake:right-4"])
                        }, null, 8, ["class"])
                      ], 2),
                      x("div", X7, [
                        x("div", {
                          class: Se(["smake:hidden smake:flex-col smake:justify-end smake:gap-4 smake:@md:grow", {
                            "smake:@md:flex": c(_e),
                            "smake:max-w-50": c(Pe)(
                              c(At).CUSTOMER_LOGO_UPLOAD
                            ),
                            "smake:max-w-40": !c(Pe)(
                              c(At).CUSTOMER_LOGO_UPLOAD
                            )
                          }])
                        }, [
                          b(U7),
                          b(Tu),
                          b(kr)
                        ], 2),
                        x("div", K7, [
                          b(O5, { class: "smake:grow" }),
                          b(R7, {
                            class: Se({
                              "smake:hidden": !c(_e)
                            })
                          }, null, 8, ["class"]),
                          x("div", {
                            class: Se(["smake:mt-4 smake:flex smake:items-end smake:justify-evenly smake:gap-3 smake:@md:hidden", {
                              "smake:hidden": !c(_e)
                            }])
                          }, [
                            b(Tu),
                            b(E5),
                            b(c(Ya), {
                              name: c(At).CUSTOMER_LOGO_UPLOAD
                            }, {
                              default: P(() => [
                                b(P8)
                              ]),
                              _: 1
                            }, 8, ["name"]),
                            !c(Pe)(
                              c(At).CUSTOMER_LOGO_UPLOAD
                            ) || !c(rt) ? ($(), Z(kr, { key: 0 })) : X("", !0)
                          ], 2)
                        ]),
                        x("div", {
                          class: Se(["smake:hidden smake:flex-col smake:justify-center smake:gap-4", {
                            "smake:@md:flex": c(_e),
                            "smake:max-w-50": c(Pe)(
                              c(At).CUSTOMER_LOGO_UPLOAD
                            ),
                            "smake:max-w-40": !c(Pe)(
                              c(At).CUSTOMER_LOGO_UPLOAD
                            )
                          }])
                        }, [
                          b(I5),
                          b(c(Ya), {
                            name: c(At).CUSTOMER_LOGO_UPLOAD
                          }, {
                            default: P(() => [
                              b($8)
                            ]),
                            _: 1
                          }, 8, ["name"]),
                          b(M7),
                          Ce[0] || (Ce[0] = x("div", { class: "smake:-mt-4 smake:grow" }, null, -1)),
                          b(Ou),
                          b(b8)
                        ], 2)
                      ])
                    ])
                  ], 2)
                ]),
                x("div", {
                  class: Se(["smake:pointer-events-auto smake:flex smake:justify-center smake:rounded-t-2xl smake:bg-white smake:px-6 smake:py-3 smake:shadow-[0px_0px_15px_0px_rgba(0,0,0,0.15)]", {
                    "smake:hidden": !c(_e),
                    "smake:@md:hidden": st.value
                  }])
                }, [
                  x("div", J7, [
                    b(z7, { class: "smake:@md:hidden" }),
                    st.value ? X("", !0) : ($(), Z(Rb, { key: 0 }))
                  ])
                ], 2)
              ]),
              b(c8),
              b(A5)
            ]),
            b(v8),
            b(R5),
            b(c(nv), { class: "smake:pointer-events-none smake:absolute smake:inset-x-0 smake:top-3 smake:z-10 smake:flex smake:flex-col smake:items-center smake:gap-3" })
          ], 2)
        ])
      ]),
      _: 1
    }));
  }
}), e9 = "zrušit", t9 = "Přidat logo", n9 = "Přidat text", s9 = "Přidat řádek", a9 = "přidat do košíku", o9 = "zarovnat", i9 = "Na tomto zobrazení není žádná volná plocha pro umístění.", r9 = "použít", l9 = "Použít na všechny řádky", c9 = "Archiv", u9 = "Načíst vybrané přizpůsobení", d9 = "Načíst položku včetně personalizace", m9 = "Nový záznam do archivu bude brzy k dispozici.", h9 = "Vaše personalizace byla úspěšně uložena.", p9 = "Opravdu chcete smazat {deleteName}?", f9 = "Ohýbat text", v9 = { authentication: "Autentifikace se nezdařila.", headline: "Při spouštění konfigurátoru došlo k chybě.", unexpected: "Neočekávaná chyba", variant_not_found: "Požadovaná varianta nebyla nalezena." }, g9 = "Právě se nacházíte na ploše pro umístění pro {fromProductionMethod}.", _9 = "přepnout na {x}", k9 = "vybrat", y9 = "Vyberte prosím plochu pro umístění.", b9 = "Zvolit jiný motiv", w9 = "Zvolit jiné logo", x9 = "Vyberte způsob personalizace", $9 = "vymazat všechny filtry", S9 = "Barva", A9 = "Barvy", C9 = "potvrdit", P9 = "Potvrzení", I9 = "Nahráním požadované personalizace potvrzujete, že jste oprávněni nechat personalizaci aplikovat na textilie, zejména že personalizace neporušuje práva na jména a ochranné známky, práva k designu, autorská práva ani jiná práva třetích stran, stejně jako obecné (zejména trestní) zákony. Pokud bychom byli kvůli vámi provedené konfiguraci žalováni z důvodu porušení práv třetích stran nebo obecných zákonů, jste povinni nás zprostit veškerých nároků a škod v této souvislosti.", M9 = "pokračovat s {x}", T9 = "Upozornění: Neuložené návrhy budou při otevření návrhů ztraceny.", z9 = "Aktuálně v košíku", E9 = "Zatím nebyly nahrány žádné soubory", O9 = "Vlastní", R9 = "Typ motivu", L9 = "Personalizace", D9 = "Design|Designy", N9 = "Vzdálenost motivu/textu (v mm)", V9 = "Chcete přejmenovat {name}?", U9 = "Přetáhněte soubor přímo do pole", F9 = "barevný, různorodý", j9 = "výrazný digitální přenos", B9 = "optimální pro velké potisky", q9 = "flexibilní ve velikostech a barvách", H9 = "pro vybrané textilie a všechny základní kousky", W9 = "Praní v pračce až do 40˚C", G9 = "Prvek je mimo plochu pro umístění.", Z9 = "elegantní, jemný", Q9 = "velmi kvalitní a trvanlivá výšivka", X9 = "možné pro velké množství artiklů", K9 = "mnoho motivů a různě barevné nitě", J9 = "pro veškeré textilie, i vysoce zatěžované artikly", Y9 = "pratelné na vysoké teploty, vhodné i pro průmyslové praní", e$ = "Archivace varianty se nezdařila. Zkuste to prosím znovu.", t$ = "Uložení varianty se nezdařilo. Zkuste to prosím znovu.", n$ = "Při načítání došlo k chybě.", s$ = "Při vykreslování změn došlo k chybě. Zkuste to prosím (později) znovu.", a$ = "Při načítání varianty došlo k neočekávané chybě. Zkuste to prosím (později) znovu nebo vytvořte novou personalizaci.", o$ = "Při mazání archivované varianty došlo k chybě. Zkuste to prosím znovu.", i$ = "méně barev", r$ = "Písmo", l$ = "od 1 kusu", c$ = "Přejít na přehled personalizace", u$ = "Výška (v cm)", d$ = "Nápověda k nahrávání souborů", m$ = "zde", h$ = "skrýt oblasti", p$ = "Motiv|Motivy", f$ = "Databáze motivů", v$ = "Vyberte motiv z naší stále rostoucí databáze motivů. Poté máte možnost svůj motiv přizpůsobit.", g$ = "Vložit text", _$ = "kurzíva", k$ = "k", y$ = "Vzdálenost dolů", b$ = "nahrávání", w$ = "Logo|Loga", x$ = "Loga a designy", $$ = "Vzhled", S$ = "Velikost souboru: max.", A$ = "Byl dosažen maximální počet řádků.", C$ = 'Pod "{buttonName}" byly pro vás připraveny nové návrhy.', P$ = "Minimální množství", I$ = "jednobarevný", M$ = "více barev", T$ = "Pro používání „CI Configurator MYDESIGN“ platí následující {termsOfServiceLink}.", z$ = "vícebarevný", E$ = "Moje personalizace", O$ = "Moje soubory", R$ = "Moje loga", L$ = "Nová personalizace", D$ = "Nový design", N$ = "Nový návrh", V$ = "Ve vašem zákaznickém účtu momentálně nejsou uložena žádná loga pro {productionMethod}. Chcete-li, abychom vaše logo uložili, kontaktujte nás prosím na: {contact}. Nebo můžete změnit typ personalizace vpravo nahoře.", U$ = "Ve vašem zákaznickém účtu momentálně nejsou uloženy žádné designy pro {productionMethod}.", F$ = "Pro váš aktuální filtr nejsou momentálně uloženy žádné {productionMethod} motivy.", j$ = "Odsazení vlevo", B$ = "Pouze velká písmena", q$ = "nebo", H$ = "PDF ke stažení", W$ = "umístit", G$ = "Umístit motiv", Z$ = "Prosím, vyčkejte chvilku.", Q$ = "Náhled", X$ = "Náhled možných ploch pro umístění", K$ = "Cena", J$ = "Změnit barvu produktu", Y$ = "Metoda personalizace", eS = "Metoda personalizace na tomto produktu není bohužel možná.", tS = "výrazný digitální přenos", nS = "velmi kvalitní a trvanlivý výšivka", sS = "Množství", aS = "Nedávno nahrané", oS = "Nedávno použité", iS = "přejmenovat", rS = "nahradit", lS = "uložit", cS = "Uložit personalizaci", uS = "Uloženo", dS = "Váš design byl úspěšně uložen pod názvem {name}.", mS = "Uložené návrhy", hS = "Vyhledat motiv", pS = "Vybrat barvu", fS = "Vybrat soubor", vS = "Platnost relace vypršela", gS = "Platnost vaší relace vypršela. Znovu načtěte stránku a pokračujte v používání konfigurátoru.", _S = "zobrazit oblasti", kS = "Zobrazit mé soubory", yS = "Zobrazit návrhy nyní", bS = "{count} výsledek zobrazit|{count} výsledků zobrazit", wS = "Velikost", xS = "Velikost (v cm)", $S = "Návrhy", SS = "Standardní barvy", AS = "Podporované formáty souborů", CS = "podmínky služby", PS = "Textil", IS = "Text", MS = "Vybraný design nahradí aktuální výběr", TS = "Tuto akci nelze vrátit zpět.", zS = "Chcete-li umístit požadovaný motiv, změňte prosím metodu personalizace na {toProductionMethod}. Poté můžete vybrat vhodnou plochu pro umístění.", ES = "Pokouší se obnovit relaci.", OS = "Nahrát další soubor", RS = "Váš soubor bohužel nesplňuje technické požadavky. Nahrajte prosím jiný formát souboru. Více informací najdete {here}.", LS = "Nahrání se nezdařilo – váš SVG soubor obsahuje obrazové prvky. Odstraňte prosím vložené obrázky a nahrajte soubor znovu.", DS = "Nahrání se nezdařilo – váš SVG soubor obsahuje nepřevedená písma. Převeďte prosím všechna písma na křivky a soubor nahrajte znovu.", NS = "Nahrání se nezdařilo – došlo k neočekávané chybě. Zkuste to prosím znovu nebo použijte jiný formát souboru.", VS = "Nahrát soubor", US = "Nahrát vlastní soubor", FS = "Nahrání", jS = "Vaše personalizace od", BS = "Pratelnost", qS = "Šířka (v cm)", HS = "Váš soubor se právě nahrává...", WS = "Zoom", GS = {
  abort: e9,
  add_logo: t9,
  add_text: n9,
  add_text_line: s9,
  add_to_cart: a9,
  align: o9,
  all_positioning_areas_are_occupied: i9,
  apply: r9,
  apply_to_all_lines: l9,
  archive: c9,
  archive_fetch_selected_customization: u9,
  archive_fetch_variant_with_customizations: d9,
  archive_new_entry_soon_available: m9,
  archived_variant_successfully: h9,
  are_you_sure_you_want_to_delete: p9,
  bend_text_line: f9,
  boot_error: v9,
  change_production_method_info: g9,
  change_to_x: _9,
  choose: k9,
  choose_a_positioning_area: y9,
  choose_icon: b9,
  choose_logo: w9,
  choose_production_method: x9,
  clear_filters: $9,
  color: S9,
  colors: A9,
  confirm: C9,
  confirmation: P9,
  confirmation_description: I9,
  continue: "pokračovat",
  continue_with_x: M9,
  current_edited_customization_will_be_aborted: T9,
  currently_in_cart: z9,
  currently_no_uploaded_files: E9,
  custom: O9,
  customization_type: R9,
  customizations: L9,
  delete: "smazat",
  designs: D9,
  distance_motif_text: N9,
  do_you_want_to_rename: V9,
  drag_file_over_area: U9,
  dtf_look: F9,
  dtf_selling_point_1: j9,
  dtf_selling_point_2: B9,
  dtf_selling_point_3: q9,
  dtf_textiles: H9,
  dtf_washability: W9,
  element_outside_placement_area: G9,
  embroidery_look: Z9,
  embroidery_selling_point_1: Q9,
  embroidery_selling_point_2: X9,
  embroidery_selling_point_3: K9,
  embroidery_textiles: J9,
  embroidery_washability: Y9,
  error_failed_to_archive_variant: e$,
  error_failed_to_save_variant: t$,
  error_loading: n$,
  error_pusher_rendering_failed: s$,
  error_pusher_rendering_failed_while_loading_variant: a$,
  error_while_deleting_archive_variant: o$,
  fewer_colors: i$,
  font: r$,
  from_one_piece: l$,
  go_to_production_method_overview: c$,
  height_abbreviation: u$,
  help_for_upload: d$,
  here: m$,
  hide_areas: h$,
  icon: p$,
  icon_database: f$,
  icon_database_description: v$,
  insert_text: g$,
  italic: _$,
  italic_short: k$,
  line_height: y$,
  loading: b$,
  logos: w$,
  logos_and_designs: x$,
  look: $$,
  max_file_size: S$,
  maximum_number_of_lines: A$,
  merchant_sketch_variant_added: C$,
  minimum_quantity: P$,
  mono_colored: I$,
  more_colors: M$,
  more_informations_about_upload: T$,
  multi_colored: z$,
  my_customizations: E$,
  my_files: O$,
  my_logos: R$,
  new: "nový",
  new_customization: L$,
  new_design: D$,
  new_sketch: N$,
  no_customer_logos: V$,
  no_designs: U$,
  no_motifs: F$,
  offset_left: j$,
  only_uppercase: B$,
  or: q$,
  pdf_download: H$,
  place: W$,
  place_logo: G$,
  please_hold_on_for_a_moment: Z$,
  preview: Q$,
  preview_of_possibile_positioning_areas: X$,
  price: K$,
  product_colors: J$,
  production_method: Y$,
  production_method_not_available_for_variant: eS,
  production_method_summary_dtf: tS,
  production_method_summary_embroidery: nS,
  quantity: sS,
  recently_uploaded: aS,
  recently_used: oS,
  rename: iS,
  replace: rS,
  save: lS,
  save_variant: cS,
  saved: uS,
  saved_design_successfully: dS,
  saved_designs: mS,
  search_logo: hS,
  select_color: pS,
  select_file: fS,
  session_expired: vS,
  session_expired_description: gS,
  show_areas: _S,
  show_own_files: kS,
  show_sketches: yS,
  show_X_results: bS,
  size: wS,
  size_in_unit: xS,
  sketches: $S,
  standard_colors: SS,
  supported_file_types: AS,
  terms_of_service: CS,
  textiles: PS,
  texts: IS,
  the_selected_design_will_replace_the_current_selection: MS,
  this_action_can_not_be_undone: TS,
  to_place_motif_change_production_method: zS,
  trying_to_reconnect_session: ES,
  upload_another_file: OS,
  upload_error_422_content_type: RS,
  upload_error_svg_contains_image: LS,
  upload_error_svg_contains_text: DS,
  upload_error_unexpected: NS,
  upload_file: VS,
  upload_own_file: US,
  uploads: FS,
  views_preview_headlide: jS,
  washablility: BS,
  width_abbreviation: qS,
  your_file_is_beeing_uploaded: HS,
  zoom: WS
}, ZS = "abbrechen", QS = "Logo hinzufügen", XS = "Text hinzufügen", KS = "Zeile hinzufügen", JS = "zur Bestellung", YS = "ausrichten", eA = "Keine freie Platzierungsfläche auf dieser Ansicht.", tA = "anwenden", nA = "Für alle Zeilen übernehmen", sA = "Archiv", aA = "Ausgewähltes Motiv laden", oA = "Artikel inklusive Personalisierung laden", iA = "Ein neuer Archiv-Eintrag ist in Kürze verfügbar.", rA = "Ihre Personalisierung wurde erfolgreich gespeichert.", lA = "Möchten Sie { deleteName } wirklich löschen?", cA = "Text krümmen", uA = { authentication: "Die Authentifizierung ist fehlgeschlagen.", headline: "Beim Starten des Konfigurators ist ein Fehler aufgetreten.", unexpected: "Unerwarteter Fehler", variant_not_found: "Die gewünschte Variante wurde nicht gefunden." }, dA = "Sie befinden sich aktuell auf einer Platzierungsfläche für {fromProductionMethod}.", mA = "zu {x} wechseln", hA = "auswählen", pA = "Bitte wählen Sie eine Platzierungsfläche.", fA = "Anderes Motiv auswählen", vA = "Anderes Logo auswählen", gA = "Personalisierungsart wählen", _A = "alle Filter löschen", kA = "Farbe", yA = "Farben", bA = "bestätigen", wA = "Bestätigung", xA = "Mit dem Hochladen der gewünschten Personalisierung bestätigen Sie, dass Sie befugt sind, die Personalisierung auf Textilien anbringen zu lassen, insbesondere, dass die Personalisierung nicht gegen Namens- und Markenrechte, Designrechte, Urheberrechte oder sonstige Rechte Dritter ebenso wie gegen allgemeine (insbesondere strafrechtliche) Gesetze verstößt. Sollten wir wegen der von Ihnen vorgenommenen Konfiguration aufgrund der Verletzung von Rechten Dritter oder allgemeiner Gesetze in Anspruch genommen werden, so sind Sie verpflichtet, uns von sämtlichen Ansprüchen und Schäden in diesem Zusammenhang freizustellen.", $A = "mit {x} fortfahren", SA = "Hinweis: Ungespeicherte Designs gehen beim Aufruf der Entwürfe leider verloren.", AA = "Aktuell im Warenkorb", CA = "Bisher wurden keine Dateien hochgeladen", PA = "Individuell", IA = "Motivart", MA = "Personalisierungen", TA = "Design|Designs", zA = "Abstand Motiv/Text (in mm)", EA = "Möchten Sie {name} umbenennen?", OA = "Datei direkt ins Feld ziehen", RA = "farbbrillant, vielfältig", LA = "ausdrucksstarker Digitaltransfer", DA = "optimal für große Aufdrucke", NA = "flexibel in Größen & Farben", VA = "für ausgewählte Textilien & alle Basics", UA = "Maschinenwäsche bis 40˚C", FA = "Element ist außerhalb der Platzierungsfläche.", jA = "edel, filigran", BA = "sehr hochwertiger & langlebiger Stick", qA = "möglich für eine große Zahl an Artikeln", HA = "viele Motive & verschiedene Garnfarben", WA = "alle Textilien, auch stark beanspruchte Artikel", GA = "heiß waschbar, auch Industriewäsche", ZA = "Das Archivieren der Variante ist fehlgeschlagen. Bitte versuchen Sie es erneut.", QA = "Das Speichern der Variante ist fehlgeschlagen. Bitte versuchen Sie es erneut.", XA = "Es ist ein Fehler beim Laden aufgetreten.", KA = "Es ist ein Fehler beim Darstellen der Änderungen aufgetreten. Bitte versuchen Sie es (später) erneut.", JA = "Beim Laden der Variante kam es zu einem unerwarteten Fehler. Bitte versuchen Sie es (später) erneut oder erstellen Sie eine neue Personalisierung.", YA = "Beim Löschen der Archiv-Variante ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.", eC = "weniger Farben", tC = "Schrift", nC = "ab 1 Stück", sC = "Zur Personalisierungsübersicht", aC = "Höhe (in cm)", oC = "Hilfe zum Datei-Upload", iC = "hier", rC = "Flächen ausblenden", lC = "Motiv|Motive", cC = "Motivdatenbank", uC = "Wählen Sie ein Motiv aus unserer stetig wachsenden Motivdatenbank aus. Anschließend haben Sie die Möglichkeit Ihr Motiv zu individualisieren.", dC = "Text einfügen", mC = "kursiv", hC = "k", pC = "Abstand unten", fC = "laden", vC = "Logo|Logos", gC = "Logos & Designs", _C = "Look", kC = "Dateigröße: max.", yC = "Die maximale Zeilenanzahl ist erreicht.", bC = 'Unter "{buttonName}" wurden neue Entwürfe für Sie bereitgestellt.', wC = "Mindestmenge", xC = "einfarbig", $C = "weitere Farben", SC = "Für die Nutzung des „CI Configurator MYDESIGN“ gelten folgende {termsOfServiceLink}.", AC = "mehrfarbig", CC = "Meine Personalisierungen", PC = "Meine Dateien", IC = "Meine Logos", MC = "Neue Personalisierung", TC = "Neues Design", zC = "Neuer Entwurf", EC = "In Ihrem Kundenkonto sind aktuell noch keine Logos für {productionMethod} hinterlegt. Sie möchten Ihr Logo von uns hinterlegen lassen? Dann kontaktieren Sie uns bitte unter: {contact}. Ansonsten können Sie oben rechts die Personalisierungsart wechseln.", OC = "In Ihrem Kundenkonto sind aktuell noch keine Designs für {productionMethod} hinterlegt.", RC = "Für Ihre aktuelle Filterung sind aktuell noch keine {productionMethod}-Motive hinterlegt.", LC = "Einzug links", DC = "Nur Großbuchstaben", NC = "oder", VC = "PDF-Download", UC = "platzieren", FC = "Motiv platzieren", jC = "Bitte haben Sie einen Augenblick Geduld.", BC = "Vorschau", qC = "Vorschau der möglichen Platzierungsflächen", HC = "Preis", WC = "Artikelfarbe ändern", GC = "Personalisierungsart", ZC = "Personalisierungsart auf diesem Artikel leider nicht möglich.", QC = "ausdrucksstarker Digitaltransfer", XC = "sehr hochwertiger & langlebiger Stick", KC = "Menge", JC = "Zuletzt hochgeladen", YC = "Zuletzt verwendet", eP = "umbenennen", tP = "ersetzen", nP = "speichern", sP = "Personalisierung speichern", aP = "Gespeichert", oP = "Ihr Design wurde erfolgreich unter dem Namen {name} gespeichert.", iP = "Gespeicherte Designs", rP = "Motiv suchen", lP = "Farbe auswählen", cP = "Datei auswählen", uP = "Sitzung abgelaufen", dP = "Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite erneut, um den Konfigurator weiter nutzen zu können.", mP = "Flächen einblenden", hP = "Meine Dateien anzeigen", pP = "Entwürfe jetzt ansehen", fP = "{count} Ergebnis anzeigen|{count} Ergebnisse anzeigen", vP = "Größe", gP = "Größe (in cm)", _P = "Entwürfe", kP = "Standardfarben", yP = "Mögliche Dateiformate", bP = "Nutzungsbedingungen", wP = "Textilien", xP = "Text", $P = "Das ausgewählte Design wird Ihre aktuelle Auswahl ersetzen", SP = "Diese Aktion kann nicht rückgängig gemacht werden.", AP = "Um das gewünschte Motiv zu platzieren, wechseln Sie bitte die Personalisierungsart zu {toProductionMethod}. Im Anschluss können Sie eine passende Platzierungsfläche auswählen.", CP = "Es wird versucht, Ihre Sitzung wiederherzustellen.", PP = "weitere Datei hochladen", IP = "Ihre Datei erfüllt leider nicht die technischen Anforderungen. Bitte laden Sie ein anderes Dateiformat hoch. Weitere Informationen finden Sie {here}.", MP = "Upload nicht möglich – Ihre SVG-Datei enthält Bildelemente. Bitte entfernen Sie eingebettete Bilder und laden Sie die Datei erneut hoch.", TP = "Upload nicht möglich – Ihre SVG-Datei enthält nicht eingebettete Schriften. Bitte wandeln Sie enthaltene Schriften in Pfade um und laden Sie die Datei erneut hoch.", zP = "Upload fehlgeschlagen – ein unerwarteter Fehler ist aufgetreten. Bitte probieren Sie es erneut oder verwenden Sie ein anderes Dateiformat.", EP = "Datei hochladen", OP = "Eigene Datei Hochladen", RP = "Uploads", LP = "Ihre Personalisierung von", DP = "Waschbarkeit", NP = "Breite (in cm)", VP = "Ihre Datei wird gerade hochgeladen...", UP = "Zoom", FP = {
  abort: ZS,
  add_logo: QS,
  add_text: XS,
  add_text_line: KS,
  add_to_cart: JS,
  align: YS,
  all_positioning_areas_are_occupied: eA,
  apply: tA,
  apply_to_all_lines: nA,
  archive: sA,
  archive_fetch_selected_customization: aA,
  archive_fetch_variant_with_customizations: oA,
  archive_new_entry_soon_available: iA,
  archived_variant_successfully: rA,
  are_you_sure_you_want_to_delete: lA,
  bend_text_line: cA,
  boot_error: uA,
  change_production_method_info: dA,
  change_to_x: mA,
  choose: hA,
  choose_a_positioning_area: pA,
  choose_icon: fA,
  choose_logo: vA,
  choose_production_method: gA,
  clear_filters: _A,
  color: kA,
  colors: yA,
  confirm: bA,
  confirmation: wA,
  confirmation_description: xA,
  continue: "weiter",
  continue_with_x: $A,
  current_edited_customization_will_be_aborted: SA,
  currently_in_cart: AA,
  currently_no_uploaded_files: CA,
  custom: PA,
  customization_type: IA,
  customizations: MA,
  delete: "löschen",
  designs: TA,
  distance_motif_text: zA,
  do_you_want_to_rename: EA,
  drag_file_over_area: OA,
  dtf_look: RA,
  dtf_selling_point_1: LA,
  dtf_selling_point_2: DA,
  dtf_selling_point_3: NA,
  dtf_textiles: VA,
  dtf_washability: UA,
  element_outside_placement_area: FA,
  embroidery_look: jA,
  embroidery_selling_point_1: BA,
  embroidery_selling_point_2: qA,
  embroidery_selling_point_3: HA,
  embroidery_textiles: WA,
  embroidery_washability: GA,
  error_failed_to_archive_variant: ZA,
  error_failed_to_save_variant: QA,
  error_loading: XA,
  error_pusher_rendering_failed: KA,
  error_pusher_rendering_failed_while_loading_variant: JA,
  error_while_deleting_archive_variant: YA,
  fewer_colors: eC,
  font: tC,
  from_one_piece: nC,
  go_to_production_method_overview: sC,
  height_abbreviation: aC,
  help_for_upload: oC,
  here: iC,
  hide_areas: rC,
  icon: lC,
  icon_database: cC,
  icon_database_description: uC,
  insert_text: dC,
  italic: mC,
  italic_short: hC,
  line_height: pC,
  loading: fC,
  logos: vC,
  logos_and_designs: gC,
  look: _C,
  max_file_size: kC,
  maximum_number_of_lines: yC,
  merchant_sketch_variant_added: bC,
  minimum_quantity: wC,
  mono_colored: xC,
  more_colors: $C,
  more_informations_about_upload: SC,
  multi_colored: AC,
  my_customizations: CC,
  my_files: PC,
  my_logos: IC,
  new: "neu",
  new_customization: MC,
  new_design: TC,
  new_sketch: zC,
  no_customer_logos: EC,
  no_designs: OC,
  no_motifs: RC,
  offset_left: LC,
  only_uppercase: DC,
  or: NC,
  pdf_download: VC,
  place: UC,
  place_logo: FC,
  please_hold_on_for_a_moment: jC,
  preview: BC,
  preview_of_possibile_positioning_areas: qC,
  price: HC,
  product_colors: WC,
  production_method: GC,
  production_method_not_available_for_variant: ZC,
  production_method_summary_dtf: QC,
  production_method_summary_embroidery: XC,
  quantity: KC,
  recently_uploaded: JC,
  recently_used: YC,
  rename: eP,
  replace: tP,
  save: nP,
  save_variant: sP,
  saved: aP,
  saved_design_successfully: oP,
  saved_designs: iP,
  search_logo: rP,
  select_color: lP,
  select_file: cP,
  session_expired: uP,
  session_expired_description: dP,
  show_areas: mP,
  show_own_files: hP,
  show_sketches: pP,
  show_X_results: fP,
  size: vP,
  size_in_unit: gP,
  sketches: _P,
  standard_colors: kP,
  supported_file_types: yP,
  terms_of_service: bP,
  textiles: wP,
  texts: xP,
  the_selected_design_will_replace_the_current_selection: $P,
  this_action_can_not_be_undone: SP,
  to_place_motif_change_production_method: AP,
  trying_to_reconnect_session: CP,
  upload_another_file: PP,
  upload_error_422_content_type: IP,
  upload_error_svg_contains_image: MP,
  upload_error_svg_contains_text: TP,
  upload_error_unexpected: zP,
  upload_file: EP,
  upload_own_file: OP,
  uploads: RP,
  views_preview_headlide: LP,
  washablility: DP,
  width_abbreviation: NP,
  your_file_is_beeing_uploaded: VP,
  zoom: UP
}, jP = "Cancel", BP = "Add logo", qP = "Add text", HP = "Add row", WP = "Add to cart", GP = "Align", ZP = "No free positioning area on this screen.", QP = "Apply", XP = "Use for all rows", KP = "Archive", JP = "Load selected motif", YP = "Load item including personalisation", eI = "A new archive entry will be available shortly.", tI = "Your personalisation has been successfully saved.", nI = "Do you really want to delete {deleteName}?", sI = "Bend text", aI = { authentication: "Authentication has failed.", headline: "An error occurred when starting the Designer.", unexpected: "Unexpected error", variant_not_found: "The desired variant was not found." }, oI = "You are currently on a placement area for {fromProductionMethod}.", iI = "Switch to {x}", rI = "select", lI = "Please select a positioning area.", cI = "Select another design", uI = "Select a different logo", dI = "Choose production type", mI = "Clear all filters", hI = "Colour", pI = "Colours", fI = "confirm", vI = "Confirmation", gI = "By uploading the desired personalization, you confirm that you are authorized to have the personalization applied to textiles, in particular that the personalization does not violate name and trademark rights, design rights, copyrights, or other third-party rights, as well as general (especially criminal) laws. Should we be held liable due to the configuration you have made because of infringement of third-party rights or general laws, you are obliged to indemnify us against all claims and damages in this context.", _I = "continue with {x}", kI = "Note: Unsaved designs will unfortunately be lost when you access the drafts.", yI = "Currently in Cart", bI = "No files uploaded so far", wI = "Custom", xI = "Customization type", $I = "Personalisations", SI = "Designs|Designs", AI = "Spacing between motif/text", CI = "Do you want to rename {name}?", PI = "Drag file directly into the field", II = "bright, versatile", MI = "expressive digital transfer printing", TI = "optimal for large prints", zI = "flexible in size and colours", EI = "for selected fabrics & all basics", OI = "Machine washable up to 40 °C", RI = "Element is outside the positioning area.", LI = "elegant, delicate", DI = "very high-quality & durable embroidery", NI = "possible for a large number of articles", VI = "many motifs & different thread colours", UI = "all textiles, even heavily used ones", FI = "hot washable, even industrial laundry", jI = "Archiving of the variants failed. Please try again.", BI = "Saving of the variants failed. Please try again.", qI = "An error occurred during loading.", HI = "An error occurred when showing the changes. Please try again (later).", WI = "An unexpected error occurred when loading the variant. Please try again (later) or create a new personalisation.", GI = "An error occurred when deleting the archive variant. Please try again.", ZI = "fewer colours", QI = "Font", XI = "from 1 piece", KI = "to the personalisation overview", JI = "Height (in cm)", YI = "Help with file upload", eM = "here", tM = "Hide areas", nM = "Motif|Motifs", sM = "Motif database", aM = "Select a design from our continuously growing design database. Then you will have the opportunity to customise your design.", oM = "Insert text", iM = "Italic", rM = "i", lM = "Spacing below", cM = "Loading", uM = "Logo|Logos", dM = "Logos & designs", mM = "Look", hM = "File size: max.", pM = "The maximum number of rows has been reached.", fM = 'Under "{buttonName}" new drafts have been provided for you.', vM = "Minimum quantity", gM = "Single-colour", _M = "More colours", kM = 'The following {termsOfServiceLink} to the use of the "CI Configurator MYDESIGN."', yM = "Multi-colour", bM = "My Personalisations", wM = "My files", xM = "My logos", $M = "New personalisation", SM = "New design", AM = "New draft", CM = "There are currently no logos stored in your customer account for {productionMethod}. Would you like us to save your logo? Please contact us at: {contact}. Alternatively, you can switch the personalisation type in the top-right corner.", PM = "There are currently no designs stored in your customer account for {productionMethod}.", IM = "No motifs could be found for your current filter selection.", MM = "Indent left", TM = "Only upper case characters", zM = "or", EM = "PDF download", OM = "Place", RM = "Place design", LM = "Please hold on for a moment.", DM = "Preview", NM = "Preview of possible placement areas", VM = "Price", UM = "Change product colour", FM = "Production type", jM = "Unfortunately, this type of personalisation is not possible on this item.", BM = "expressive digital transfer printing", qM = "very high-quality & durable embroidery", HM = "Quantity", WM = "Recently uploaded", GM = "Recently used", ZM = "rename", QM = "replace", XM = "Save", KM = "Save personalisation", JM = "Saved", YM = "Your design has been successfully saved under the name {name}.", eT = "Saved designs", tT = "Search motif", nT = "select colour", sT = "Select file", aT = "Session expired", oT = "Your session has expired. Please reload the page to continue using the designer.", iT = "Show areas", rT = "Show my files", lT = "View drafts now", cT = "Show {count} result|Show {count} results", uT = "Size", dT = "Size (in cm)", mT = "Drafts", hT = "Standard colours", pT = "Supported file formats", fT = "terms of use", vT = "Textiles", gT = "Text", _T = "The selected design will replace your current selection.", kT = "This action cannot be undone.", yT = "To position the desired motif, please switch the personalisation type to {toProductionMethod}. You can then select a suitable placement area.", bT = "An attempt is made to restore your session.", wT = "Upload another file", xT = "Unfortunately, your file does not meet the technical requirements. Please upload a different file format. You can find more information {here}.", $T = "Upload failed – Your SVG file contains image elements. Please remove embedded images and upload the file again.", ST = "Upload failed – Your SVG file contains non-converted text. Please convert all fonts to outlines and upload the file again.", AT = "Upload failed – An unexpected error occurred. Please try again or use a different file format.", CT = "Upload file", PT = "Upload own file", IT = "Uploads", MT = "Your personalisation from the", TT = "Washability", zT = "Width (in cm)", ET = "Your file is being uploaded...", OT = "Zoom", RT = {
  abort: jP,
  add_logo: BP,
  add_text: qP,
  add_text_line: HP,
  add_to_cart: WP,
  align: GP,
  all_positioning_areas_are_occupied: ZP,
  apply: QP,
  apply_to_all_lines: XP,
  archive: KP,
  archive_fetch_selected_customization: JP,
  archive_fetch_variant_with_customizations: YP,
  archive_new_entry_soon_available: eI,
  archived_variant_successfully: tI,
  are_you_sure_you_want_to_delete: nI,
  bend_text_line: sI,
  boot_error: aI,
  change_production_method_info: oI,
  change_to_x: iI,
  choose: rI,
  choose_a_positioning_area: lI,
  choose_icon: cI,
  choose_logo: uI,
  choose_production_method: dI,
  clear_filters: mI,
  color: hI,
  colors: pI,
  confirm: fI,
  confirmation: vI,
  confirmation_description: gI,
  continue: "Continue",
  continue_with_x: _I,
  current_edited_customization_will_be_aborted: kI,
  currently_in_cart: yI,
  currently_no_uploaded_files: bI,
  custom: wI,
  customization_type: xI,
  customizations: $I,
  delete: "Delete",
  designs: SI,
  distance_motif_text: AI,
  do_you_want_to_rename: CI,
  drag_file_over_area: PI,
  dtf_look: II,
  dtf_selling_point_1: MI,
  dtf_selling_point_2: TI,
  dtf_selling_point_3: zI,
  dtf_textiles: EI,
  dtf_washability: OI,
  element_outside_placement_area: RI,
  embroidery_look: LI,
  embroidery_selling_point_1: DI,
  embroidery_selling_point_2: NI,
  embroidery_selling_point_3: VI,
  embroidery_textiles: UI,
  embroidery_washability: FI,
  error_failed_to_archive_variant: jI,
  error_failed_to_save_variant: BI,
  error_loading: qI,
  error_pusher_rendering_failed: HI,
  error_pusher_rendering_failed_while_loading_variant: WI,
  error_while_deleting_archive_variant: GI,
  fewer_colors: ZI,
  font: QI,
  from_one_piece: XI,
  go_to_production_method_overview: KI,
  height_abbreviation: JI,
  help_for_upload: YI,
  here: eM,
  hide_areas: tM,
  icon: nM,
  icon_database: sM,
  icon_database_description: aM,
  insert_text: oM,
  italic: iM,
  italic_short: rM,
  line_height: lM,
  loading: cM,
  logos: uM,
  logos_and_designs: dM,
  look: mM,
  max_file_size: hM,
  maximum_number_of_lines: pM,
  merchant_sketch_variant_added: fM,
  minimum_quantity: vM,
  mono_colored: gM,
  more_colors: _M,
  more_informations_about_upload: kM,
  multi_colored: yM,
  my_customizations: bM,
  my_files: wM,
  my_logos: xM,
  new: "new",
  new_customization: $M,
  new_design: SM,
  new_sketch: AM,
  no_customer_logos: CM,
  no_designs: PM,
  no_motifs: IM,
  offset_left: MM,
  only_uppercase: TM,
  or: zM,
  pdf_download: EM,
  place: OM,
  place_logo: RM,
  please_hold_on_for_a_moment: LM,
  preview: DM,
  preview_of_possibile_positioning_areas: NM,
  price: VM,
  product_colors: UM,
  production_method: FM,
  production_method_not_available_for_variant: jM,
  production_method_summary_dtf: BM,
  production_method_summary_embroidery: qM,
  quantity: HM,
  recently_uploaded: WM,
  recently_used: GM,
  rename: ZM,
  replace: QM,
  save: XM,
  save_variant: KM,
  saved: JM,
  saved_design_successfully: YM,
  saved_designs: eT,
  search_logo: tT,
  select_color: nT,
  select_file: sT,
  session_expired: aT,
  session_expired_description: oT,
  show_areas: iT,
  show_own_files: rT,
  show_sketches: lT,
  show_X_results: cT,
  size: uT,
  size_in_unit: dT,
  sketches: mT,
  standard_colors: hT,
  supported_file_types: pT,
  terms_of_service: fT,
  textiles: vT,
  texts: gT,
  the_selected_design_will_replace_the_current_selection: _T,
  this_action_can_not_be_undone: kT,
  to_place_motif_change_production_method: yT,
  trying_to_reconnect_session: bT,
  upload_another_file: wT,
  upload_error_422_content_type: xT,
  upload_error_svg_contains_image: $T,
  upload_error_svg_contains_text: ST,
  upload_error_unexpected: AT,
  upload_file: CT,
  upload_own_file: PT,
  uploads: IT,
  views_preview_headlide: MT,
  washablility: TT,
  width_abbreviation: zT,
  your_file_is_beeing_uploaded: ET,
  zoom: OT
}, LT = "Annuler", DT = "Ajouter un logo", NT = "Ajouter du texte", VT = "Ajouter une ligne", UT = "Vers la commande", FT = "Aligner", jT = "Pas de surface de placement libre sur cette affichage.", BT = "Appliquer", qT = "Reprendre pour toutes les lignes", HT = "Archive", WT = "Charger un motif sélectionné", GT = "Charger l'article avec la personnalisation", ZT = "Une nouvelle entrée d'archive sera bientôt disponible.", QT = "Votre personnalisation a été sauvegardée avec succès.", XT = "Voulez-vous vraiment supprimer {deleteName}?", KT = "Courber le texte", JT = { authentication: "L'authentification a échoué.", headline: "Une erreur est survenue lors du lancement du designer.", unexpected: "Erreur inattendue", variant_not_found: "La variante souhaitée n'a pas été trouvée." }, YT = "Vous vous trouvez actuellement sur un emplacement de {fromProductionMethod}.", ez = "Passer à {x}", tz = "Sélectionner", nz = "Veuillez sélectionner une surface de placement.", sz = "Sélectionner un autre motif", az = "Sélectionner un autre logo", oz = "Sélectionner le type de personnalisation", iz = "Supprimer tous les filtres", rz = "Couleur", lz = "Couleurs", cz = "confirmer", uz = "Confirmation", dz = "En téléchargeant la personnalisation souhaitée, vous confirmez que vous êtes autorisé à faire apposer la personnalisation sur des textiles, en particulier que cette personnalisation ne viole pas les droits de nom et de marque, les droits de design, les droits d'auteur ou autres droits de tiers, ainsi que les lois générales (notamment pénales). Si nous étions tenus responsables en raison de la configuration que vous avez effectuée pour violation des droits de tiers ou des lois générales, vous êtes tenu de nous indemniser pour toutes les réclamations et dommages y afférents.", mz = "poursuivre avec {x}", hz = "Remarque: Les designs non enregistrés seront malheureusement perdus lors de la consultation des projets.", pz = "Actuellement dans le panier", fz = "Aucun fichier n'a encore été téléchargé", vz = "Individuel", gz = "Type de motif", _z = "Personnalisations", kz = "Design|Designs", yz = "Distance motif/texte", bz = "Voulez-vous renommer {name}?", wz = "Glisser le fichier directement dans le champ", xz = "brillance des couleurs, polyvalence", $z = "impression par transfert digital expressive", Sz = "idéal pour les grandes impressions", Az = "tailles et couleurs flexibles", Cz = "pour une sélection de textiles et tous les basiques", Pz = "Lavage en machine jusqu’à 40 °C", Iz = "L'élément est en-dehors de la surface de placement.", Mz = "élégance, discrétion", Tz = "Broderie de très haute qualité et durable", zz = "possible pour un grand nombre d'articles", Ez = "de nombreux motifs et différentes couleurs de fils", Oz = "tous les textiles, même les plus usagés", Rz = "lavable très chaud, y compris avec un lavage industriel", Lz = "L'archivage de la variante a échoué. Veuillez réessayer.", Dz = "L'enregistrement de la variante a échoué. Veuillez réessayer.", Nz = "Une erreur est survenue lors du chargement.", Vz = "Une erreur est survenue lors de l'affichage des modifications. Veuillez essayer une nouvelle fois (plus tard).", Uz = "Une erreur inattendue est survenue lors du chargement de la variante. Veuillez essayer une nouvelle fois (plus tard) ou créez une nouvelle personnalisation.", Fz = "Une erreur est survenue lors de la suppression de la variante d'archive. Veuillez réessayer.", jz = "moins de couleurs", Bz = "Police", qz = "partir de 1 pièce", Hz = "Vers l'aperçu de la personnalisation", Wz = "Hauteur (en cm)", Gz = "Aide au Téléversement", Zz = "ici", Qz = "Masquer les surfaces", Xz = "Motif|Motifs", Kz = "Base de données de motifs", Jz = "Sélectionnez un motif dans notre base de données de motifs en développement constant. Vous aurez ensuite la possibilité de personnaliser votre motif.", Yz = "Insérer un texte", eE = "Italique", tE = "i", nE = "Distance en bas", sE = "Charger", aE = "Logo|Logos", oE = "Logos & designs", iE = "Style", rE = "Taille du fichier : max.", lE = "Le nombre maximum de lignes est atteint.", cE = "Dans «{buttonName}» de nouveaux projets ont été mis à disposition pour vous.", uE = "Quantité minimum", dE = "uni", mE = "Autres couleurs", hE = "Les {termsOfServiceLink} suivantes s’appliquent à l’utilisation du « CI Configurator MYDESIGN ».", pE = "multicolore", fE = "Mes personnalisations", vE = "Mes fichiers", gE = "Mes logos", _E = "Nouvelle personnalisation", kE = "Nouveau design", yE = "Nouveau projet", bE = "Votre compte client ne contient actuellement pas de logos enregistrés pour {productionMethod}. Vous souhaitez faire enregistrer votre logo par nos services ? Alors veuillez nous contacter sur : {contact}. Sinon, vous pouvez changer le type de personnalisation en haut à droite.", wE = "Votre compte client ne contient actuellement pas de designs {productionMethod}.", xE = "Aucun motif n’a malheureusement pu être trouvé pour votre filtre actuel.", $E = "Justifier à gauche", SE = "Majuscules uniquement", AE = "ou", CE = "Téléchargement PDF", PE = "Positionner", IE = "Placer le motif", ME = "Merci de patienter un instant.", TE = "Aperçu", zE = "Aperçu des emplacements possibles", EE = "Prix", OE = "Modifier la couleur de l'article", RE = "Type de personnalisation", LE = "Le type de personnalisation sur cet article n'est malheureusement pas possible.", DE = "impression par transfert digital expressive", NE = "Broderie de très haute qualité et durable", VE = "Quantité", UE = "Récemment téléchargé", FE = "Récemment utilisé", jE = "Renommer", BE = "remplacer", qE = "Enregistrer", HE = "Enregistrer la personnalisation", WE = "Enregistré", GE = "Votre design a été enregistré avec succès sous le nom {name}.", ZE = "Designs enregistrés", QE = "Rechercher un motif", XE = "Choisir la couleur", KE = "Sélectionner un fichier", JE = "Session expirée", YE = "Votre session est expirée. Veuillez recharger la page pour pouvoir continuer à utiliser l'outil de conception.", eO = "Afficher les surfaces", tO = "Afficher mes fichiers", nO = "Consulter les projets maintenant", sO = "Afficher {count} résultat|Afficher {count} résultats", aO = "Taille", oO = "TAILLE (en cm)", iO = "Projets", rO = "Couleurs standard", lO = "Formats de fichiers pris en charge", cO = "conditions d’utilisation", uO = "Textiles", dO = "Texte", mO = "Le design sélectionné remplacera votre sélection actuelle.", hO = "Cette action ne pourra pas être annulée.", pO = "Pour placer le motif souhaité, veuillez changer le type de personnalisation pour {toProductionMethod}. Vous pouvez ensuite choisir un emplacement correspondant.", fO = "Une tentative de restauration de votre session est en cours", vO = "Télécharger un autre fichier", gO = "Malheureusement, votre fichier ne répond pas aux exigences techniques. Veuillez télécharger un autre format de fichier. Vous trouverez plus d’informations {here}.", _O = "Échec du téléchargement – Votre fichier SVG contient des éléments d’image. Veuillez supprimer les images intégrées et téléverser le fichier à nouveau.", kO = "Échec du téléchargement – Votre fichier SVG contient des polices non converties. Veuillez convertir les polices en tracés avant de téléverser le fichier à nouveau.", yO = "Échec du téléchargement – Une erreur inattendue est survenue. Veuillez réessayer ou utiliser un autre format de fichier.", bO = "Télécharger un fichier", wO = "Télécharger son propre fichier", xO = "Téléchargements", $O = "Votre personnalisation à", SO = "Lavabilité", AO = "Largeur (en cm)", CO = "Votre fichier est en cours de téléchargement...", PO = "Zoom", IO = {
  abort: LT,
  add_logo: DT,
  add_text: NT,
  add_text_line: VT,
  add_to_cart: UT,
  align: FT,
  all_positioning_areas_are_occupied: jT,
  apply: BT,
  apply_to_all_lines: qT,
  archive: HT,
  archive_fetch_selected_customization: WT,
  archive_fetch_variant_with_customizations: GT,
  archive_new_entry_soon_available: ZT,
  archived_variant_successfully: QT,
  are_you_sure_you_want_to_delete: XT,
  bend_text_line: KT,
  boot_error: JT,
  change_production_method_info: YT,
  change_to_x: ez,
  choose: tz,
  choose_a_positioning_area: nz,
  choose_icon: sz,
  choose_logo: az,
  choose_production_method: oz,
  clear_filters: iz,
  color: rz,
  colors: lz,
  confirm: cz,
  confirmation: uz,
  confirmation_description: dz,
  continue: "Suite",
  continue_with_x: mz,
  current_edited_customization_will_be_aborted: hz,
  currently_in_cart: pz,
  currently_no_uploaded_files: fz,
  custom: vz,
  customization_type: gz,
  customizations: _z,
  delete: "Supprimer",
  designs: kz,
  distance_motif_text: yz,
  do_you_want_to_rename: bz,
  drag_file_over_area: wz,
  dtf_look: xz,
  dtf_selling_point_1: $z,
  dtf_selling_point_2: Sz,
  dtf_selling_point_3: Az,
  dtf_textiles: Cz,
  dtf_washability: Pz,
  element_outside_placement_area: Iz,
  embroidery_look: Mz,
  embroidery_selling_point_1: Tz,
  embroidery_selling_point_2: zz,
  embroidery_selling_point_3: Ez,
  embroidery_textiles: Oz,
  embroidery_washability: Rz,
  error_failed_to_archive_variant: Lz,
  error_failed_to_save_variant: Dz,
  error_loading: Nz,
  error_pusher_rendering_failed: Vz,
  error_pusher_rendering_failed_while_loading_variant: Uz,
  error_while_deleting_archive_variant: Fz,
  fewer_colors: jz,
  font: Bz,
  from_one_piece: qz,
  go_to_production_method_overview: Hz,
  height_abbreviation: Wz,
  help_for_upload: Gz,
  here: Zz,
  hide_areas: Qz,
  icon: Xz,
  icon_database: Kz,
  icon_database_description: Jz,
  insert_text: Yz,
  italic: eE,
  italic_short: tE,
  line_height: nE,
  loading: sE,
  logos: aE,
  logos_and_designs: oE,
  look: iE,
  max_file_size: rE,
  maximum_number_of_lines: lE,
  merchant_sketch_variant_added: cE,
  minimum_quantity: uE,
  mono_colored: dE,
  more_colors: mE,
  more_informations_about_upload: hE,
  multi_colored: pE,
  my_customizations: fE,
  my_files: vE,
  my_logos: gE,
  new: "nouveau",
  new_customization: _E,
  new_design: kE,
  new_sketch: yE,
  no_customer_logos: bE,
  no_designs: wE,
  no_motifs: xE,
  offset_left: $E,
  only_uppercase: SE,
  or: AE,
  pdf_download: CE,
  place: PE,
  place_logo: IE,
  please_hold_on_for_a_moment: ME,
  preview: TE,
  preview_of_possibile_positioning_areas: zE,
  price: EE,
  product_colors: OE,
  production_method: RE,
  production_method_not_available_for_variant: LE,
  production_method_summary_dtf: DE,
  production_method_summary_embroidery: NE,
  quantity: VE,
  recently_uploaded: UE,
  recently_used: FE,
  rename: jE,
  replace: BE,
  save: qE,
  save_variant: HE,
  saved: WE,
  saved_design_successfully: GE,
  saved_designs: ZE,
  search_logo: QE,
  select_color: XE,
  select_file: KE,
  session_expired: JE,
  session_expired_description: YE,
  show_areas: eO,
  show_own_files: tO,
  show_sketches: nO,
  show_X_results: sO,
  size: aO,
  size_in_unit: oO,
  sketches: iO,
  standard_colors: rO,
  supported_file_types: lO,
  terms_of_service: cO,
  textiles: uO,
  texts: dO,
  the_selected_design_will_replace_the_current_selection: mO,
  this_action_can_not_be_undone: hO,
  to_place_motif_change_production_method: pO,
  trying_to_reconnect_session: fO,
  upload_another_file: vO,
  upload_error_422_content_type: gO,
  upload_error_svg_contains_image: _O,
  upload_error_svg_contains_text: kO,
  upload_error_unexpected: yO,
  upload_file: bO,
  upload_own_file: wO,
  uploads: xO,
  views_preview_headlide: $O,
  washablility: SO,
  width_abbreviation: AO,
  your_file_is_beeing_uploaded: CO,
  zoom: PO
}, MO = "annuleren", TO = "Logo toevoegen", zO = "Tekst toevoegen", EO = "Regel toevoegen", OO = "aan winkelwagen toevoegen", RO = "uitlijnen", LO = "Geen vrije plaatsingsgebieden op deze weergave.", DO = "toepassen", NO = "Op alle regels toepassen", VO = "Archief", UO = "Geselecteerde aanpassing laden", FO = "Artikel inclusief personalisatie laden", jO = "Een nieuw archief-item is binnenkort beschikbaar.", BO = "Uw personalisatie is succesvol opgeslagen.", qO = "Weet u zeker dat u {deleteName} wilt verwijderen?", HO = "Tekst buigen", WO = { authentication: "De authenticatie is mislukt.", headline: "Er is een fout opgetreden bij het starten van de configurator.", unexpected: "Onverwachte fout", variant_not_found: "De gewenste variant is niet gevonden." }, GO = "U bevindt zich momenteel op een plaatsingsgebied voor {fromProductionMethod}.", ZO = "overschakelen naar {x}", QO = "kiezen", XO = "Selecteer een plaatsingsgebied.", KO = "Ander motief selecteren", JO = "Ander logo selecteren", YO = "Personalisatieoptie kiezen", eR = "alle filters wissen", tR = "Kleur", nR = "Kleuren", sR = "bevestigen", aR = "Bevestiging", oR = "Door de gewenste personalisatie te uploaden bevestigt u dat u gemachtigd bent om de personalisatie op textiel te laten aanbrengen, in het bijzonder dat de personalisatie geen inbreuk maakt op naam- en merkrechten, ontwerprechten, auteursrechten of andere rechten van derden, evenals op algemene (vooral strafrechtelijke) wetten. Mocht ons aansprakelijk worden gesteld vanwege de door u aangebrachte configuratie wegens schending van rechten van derden of algemene wetten, dan bent u verplicht ons te vrijwaren van alle aanspraken en schade in dit verband.", iR = "doorgaan met {x}", rR = "Opmerking: Niet-opgeslagen ontwerpen gaan verloren bij het openen van de ontwerpen.", lR = "Momenteel in winkelwagen", cR = "Er zijn nog geen bestanden geüpload", uR = "Aangepast", dR = "Motieftype", mR = "Personalisaties", hR = "Ontwerp|Ontwerpen", pR = "Afstand Motief/Tekst (in mm)", fR = "Wilt u {name} hernoemen?", vR = "Sleep bestand direct in het veld", gR = "kleurkrachtig, divers", _R = "expressieve digitale transfer", kR = "optimaal voor grote prints", yR = "flexibel in maten & kleuren", bR = "voor geselecteerde textiel & alle basics", wR = "Machinewas tot 40˚C", xR = "Element bevindt zich buiten het plaatsingsgebied.", $R = "elegant, filigraan", SR = "zeer hoogwaardige & duurzame borduring", AR = "mogelijk voor een groot aantal artikelen", CR = "veel motieven & verschillende kleuren garen", PR = "alle textiel, ook sterk belaste artikelen", IR = "heet wasbaar, ook industrieel wassen", MR = "Het archiveren van de variant is mislukt. Probeer het opnieuw.", TR = "Het opslaan van de variant is mislukt. Probeer het opnieuw.", zR = "Er is een fout opgetreden bij het laden.", ER = "Er is een fout opgetreden bij het weergeven van de wijzigingen. Probeer het later opnieuw.", OR = "Bij het laden van de variant is een onverwachte fout opgetreden. Probeer het later opnieuw of maak een nieuwe personalisatie.", RR = "Er is een fout opgetreden bij het verwijderen van de archiefvariant. Probeer het opnieuw.", LR = "minder kleuren", DR = "Lettertype", NR = "vanaf 1 stuk", VR = "Naar personalisatieoverzicht", UR = "Hoogte (in cm)", FR = "Hulp bij uploaden", jR = "hier", BR = "gebieden verbergen", qR = "Motief|Motieven", HR = "Motiefdatabase", WR = "Kies een motief uit onze steeds groeiende motiefdatabase. Vervolgens kunt u uw motief personaliseren.", GR = "Tekst invoegen", ZR = "cursief", QR = "c", XR = "Afstand onder", KR = "laden", JR = "Logo|Logo's", YR = "Logo's & Ontwerpen", eL = "Uiterlijk", tL = "Bestandsgrootte: max.", nL = "Het maximale aantal regels is bereikt.", sL = 'Onder "{buttonName}" zijn nieuwe ontwerpen voor u beschikbaar gesteld.', aL = "Minimale hoeveelheid", oL = "eenvoudig", iL = "meer kleuren", rL = 'De volgende {termsOfServiceLink} zijn van toepassing op het gebruik van de "CI Configurator MYDESIGN."', lL = "veelkleurig", cL = "Mijn personalisaties", uL = "Mijn bestanden", dL = "Mijn logo's", mL = "Nieuwe personalisatie", hL = "Nieuw ontwerp", pL = "Nieuw ontwerp", fL = "Er zijn momenteel geen logo's in uw klantenaccount voor {productionMethod} opgeslagen. Wilt u uw logo door ons laten opslaan? Neem dan contact met ons op via: {contact}. U kunt anders de personaliseringsoptie bovenaan rechts wijzigen.", vL = "Er zijn momenteel geen ontwerpen in uw klantenaccount voor {productionMethod} opgeslagen.", gL = "Voor uw huidige filter zijn momenteel geen {productionMethod}-motieven opgeslagen.", _L = "Inspringen links", kL = "Alleen hoofdletters", yL = "of", bL = "PDF-download", wL = "plaatsen", xL = "Motief plaatsen", $L = "Een ogenblik geduld alstublieft.", SL = "Voorbeeld", AL = "Voorbeeld van mogelijke plaatsingsgebieden", CL = "Prijs", PL = "Artikelkleur wijzigen", IL = "Productiemethode", ML = "Productiemethode op dit artikel helaas niet mogelijk.", TL = "expressieve digitale transfer", zL = "zeer hoogwaardige & duurzame borduur", EL = "Hoeveelheid", OL = "Recent geüpload", RL = "Recent gebruikt", LL = "hernoemen", DL = "vervangen", NL = "opslaan", VL = "Personalisatie opslaan", UL = "Opgeslagen", FL = "Uw ontwerp is succesvol opgeslagen onder de naam {name}.", jL = "Opgeslagen ontwerpen", BL = "Motief zoeken", qL = "Kleur selecteren", HL = "Bestand selecteren", WL = "Sessie verlopen", GL = "Uw sessie is verlopen. Herlaad de pagina om de configurator verder te kunnen gebruiken.", ZL = "gebieden tonen", QL = "Mijn bestanden weergeven", XL = "Ontwerpen nu bekijken", KL = "{count} resultaat tonen|{count} resultaten tonen", JL = "Grootte", YL = "Grootte (in cm)", eD = "Ontwerpen", tD = "Standaardkleuren", nD = "Ondersteunde bestandsformaten", sD = "gebruiksvoorwaarden", aD = "Textiel", oD = "Tekst", iD = "Het geselecteerde ontwerp vervangt uw huidige selectie", rD = "Deze actie kan niet ongedaan worden gemaakt.", lD = "Om het gewenste motief te plaatsen, moet u de personalisatieoptie wijzigen naar {toProductionMethod}. Daarna kunt u een geschikt plaatsingsgebied kiezen.", cD = "Proberen de sessie te herstellen.", uD = "Nog een bestand uploaden", dD = "Helaas voldoet uw bestand niet aan de technische vereisten. Upload alstublieft een ander bestandsformaat. Meer informatie vindt u {here}.", mD = "Upload mislukt – Uw SVG-bestand bevat afbeeldingselementen. Verwijder de ingesloten afbeeldingen en upload het bestand opnieuw.", hD = "Upload mislukt – Uw SVG-bestand bevat niet-omgezette lettertypes. Zet alle tekst om naar contouren en upload het bestand opnieuw.", pD = "Upload mislukt – Er is een onverwachte fout opgetreden. Probeer het opnieuw of gebruik een ander bestandsformaat.", fD = "Bestand uploaden", vD = "Eigen bestand uploaden", gD = "Uploads", _D = "Uw personalisatie van", kD = "Wasbaarheid", yD = "Breedte (in cm)", bD = "Uw bestand wordt momenteel geüpload...", wD = "Zoom", xD = {
  abort: MO,
  add_logo: TO,
  add_text: zO,
  add_text_line: EO,
  add_to_cart: OO,
  align: RO,
  all_positioning_areas_are_occupied: LO,
  apply: DO,
  apply_to_all_lines: NO,
  archive: VO,
  archive_fetch_selected_customization: UO,
  archive_fetch_variant_with_customizations: FO,
  archive_new_entry_soon_available: jO,
  archived_variant_successfully: BO,
  are_you_sure_you_want_to_delete: qO,
  bend_text_line: HO,
  boot_error: WO,
  change_production_method_info: GO,
  change_to_x: ZO,
  choose: QO,
  choose_a_positioning_area: XO,
  choose_icon: KO,
  choose_logo: JO,
  choose_production_method: YO,
  clear_filters: eR,
  color: tR,
  colors: nR,
  confirm: sR,
  confirmation: aR,
  confirmation_description: oR,
  continue: "doorgaan",
  continue_with_x: iR,
  current_edited_customization_will_be_aborted: rR,
  currently_in_cart: lR,
  currently_no_uploaded_files: cR,
  custom: uR,
  customization_type: dR,
  customizations: mR,
  delete: "verwijderen",
  designs: hR,
  distance_motif_text: pR,
  do_you_want_to_rename: fR,
  drag_file_over_area: vR,
  dtf_look: gR,
  dtf_selling_point_1: _R,
  dtf_selling_point_2: kR,
  dtf_selling_point_3: yR,
  dtf_textiles: bR,
  dtf_washability: wR,
  element_outside_placement_area: xR,
  embroidery_look: $R,
  embroidery_selling_point_1: SR,
  embroidery_selling_point_2: AR,
  embroidery_selling_point_3: CR,
  embroidery_textiles: PR,
  embroidery_washability: IR,
  error_failed_to_archive_variant: MR,
  error_failed_to_save_variant: TR,
  error_loading: zR,
  error_pusher_rendering_failed: ER,
  error_pusher_rendering_failed_while_loading_variant: OR,
  error_while_deleting_archive_variant: RR,
  fewer_colors: LR,
  font: DR,
  from_one_piece: NR,
  go_to_production_method_overview: VR,
  height_abbreviation: UR,
  help_for_upload: FR,
  here: jR,
  hide_areas: BR,
  icon: qR,
  icon_database: HR,
  icon_database_description: WR,
  insert_text: GR,
  italic: ZR,
  italic_short: QR,
  line_height: XR,
  loading: KR,
  logos: JR,
  logos_and_designs: YR,
  look: eL,
  max_file_size: tL,
  maximum_number_of_lines: nL,
  merchant_sketch_variant_added: sL,
  minimum_quantity: aL,
  mono_colored: oL,
  more_colors: iL,
  more_informations_about_upload: rL,
  multi_colored: lL,
  my_customizations: cL,
  my_files: uL,
  my_logos: dL,
  new: "nieuw",
  new_customization: mL,
  new_design: hL,
  new_sketch: pL,
  no_customer_logos: fL,
  no_designs: vL,
  no_motifs: gL,
  offset_left: _L,
  only_uppercase: kL,
  or: yL,
  pdf_download: bL,
  place: wL,
  place_logo: xL,
  please_hold_on_for_a_moment: $L,
  preview: SL,
  preview_of_possibile_positioning_areas: AL,
  price: CL,
  product_colors: PL,
  production_method: IL,
  production_method_not_available_for_variant: ML,
  production_method_summary_dtf: TL,
  production_method_summary_embroidery: zL,
  quantity: EL,
  recently_uploaded: OL,
  recently_used: RL,
  rename: LL,
  replace: DL,
  save: NL,
  save_variant: VL,
  saved: UL,
  saved_design_successfully: FL,
  saved_designs: jL,
  search_logo: BL,
  select_color: qL,
  select_file: HL,
  session_expired: WL,
  session_expired_description: GL,
  show_areas: ZL,
  show_own_files: QL,
  show_sketches: XL,
  show_X_results: KL,
  size: JL,
  size_in_unit: YL,
  sketches: eD,
  standard_colors: tD,
  supported_file_types: nD,
  terms_of_service: sD,
  textiles: aD,
  texts: oD,
  the_selected_design_will_replace_the_current_selection: iD,
  this_action_can_not_be_undone: rD,
  to_place_motif_change_production_method: lD,
  trying_to_reconnect_session: cD,
  upload_another_file: uD,
  upload_error_422_content_type: dD,
  upload_error_svg_contains_image: mD,
  upload_error_svg_contains_text: hD,
  upload_error_unexpected: pD,
  upload_file: fD,
  upload_own_file: vD,
  uploads: gD,
  views_preview_headlide: _D,
  washablility: kD,
  width_abbreviation: yD,
  your_file_is_beeing_uploaded: bD,
  zoom: wD
};
var $D = {
  prefix: "fal",
  iconName: "align-right",
  icon: [
    448,
    512,
    [],
    "f038",
    "M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16L176 80c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 208c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0zm16 144c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0c8.8 0 16 7.2 16 16zM432 432c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 464c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0z"
  ]
}, Lu = {
  prefix: "fal",
  iconName: "check",
  icon: [
    448,
    512,
    [10003, 10004],
    "f00c",
    "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"
  ]
}, SD = {
  prefix: "fal",
  iconName: "up-right-and-down-left-from-center",
  icon: [
    512,
    512,
    ["expand-alt"],
    "f424",
    "M321 0c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L325.4 84l-71.7 71.7c-15.6 15.6-15.6 40.9 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L428 186.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33l0-159c0-17.7-14.3-32-32-32L321 0zm-1 33c0-.5 .4-1 1-1l159 0 0 159c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-83 83c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46.1c-3.1-3.1-3.1-8.2 0-11.3l83-83c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7zM32 512l159 0c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L186.6 428l71.7-71.7c15.6-15.6 15.6-40.9 0-56.6l-46.1-46.1c-15.6-15.6-40.9-15.6-56.6 0L84 325.4 56.3 297.7C50.1 291.5 41.7 288 33 288c-18.2 0-33 14.8-33 33L0 480c0 17.7 14.3 32 32 32zm160-33c0 .5-.4 1-1 1L32 480l0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l83-83c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-83 83c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39c.2 .2 .3 .4 .3 .7z"
  ]
}, AD = {
  prefix: "fal",
  iconName: "spinner",
  icon: [
    512,
    512,
    [],
    "f110",
    "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"
  ]
}, CD = {
  prefix: "fal",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"
  ]
}, PD = {
  prefix: "fal",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"
  ]
}, ID = {
  prefix: "fal",
  iconName: "plus",
  icon: [
    448,
    512,
    [10133, 61543, "add"],
    "2b",
    "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z"
  ]
}, MD = {
  prefix: "fal",
  iconName: "chevron-down",
  icon: [
    512,
    512,
    [],
    "f078",
    "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"
  ]
}, TD = {
  prefix: "fal",
  iconName: "magnifying-glass",
  icon: [
    512,
    512,
    [128269, "search"],
    "f002",
    "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
  ]
}, zD = {
  prefix: "fal",
  iconName: "link",
  icon: [
    640,
    512,
    [128279, "chain"],
    "f0c1",
    "M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z"
  ]
}, ED = {
  prefix: "fal",
  iconName: "rotate-right",
  icon: [
    512,
    512,
    ["redo-alt", "rotate-forward"],
    "f2f9",
    "M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2c12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8C467.8 48 480 60.2 480 75.3L480 176c0 8.8-7.2 16-16 16l-100.7 0c-15.1 0-27.3-12.2-27.3-27.3c0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64C150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6L374.6 160l73.4 0 0-73.4z"
  ]
}, OD = {
  prefix: "fal",
  iconName: "align-center",
  icon: [
    448,
    512,
    [],
    "f037",
    "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L112 48zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM96 320c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z"
  ]
}, Du = {
  prefix: "fal",
  iconName: "ellipsis-vertical",
  icon: [
    128,
    512,
    ["ellipsis-v"],
    "f142",
    "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z"
  ]
}, RD = {
  prefix: "fal",
  iconName: "sliders",
  icon: [
    512,
    512,
    ["sliders-h"],
    "f1de",
    "M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z"
  ]
}, LD = {
  prefix: "fal",
  iconName: "minus",
  icon: [
    448,
    512,
    [8211, 8722, 10134, "subtract"],
    "f068",
    "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"
  ]
}, DD = {
  prefix: "fal",
  iconName: "align-left",
  icon: [
    448,
    512,
    [],
    "f036",
    "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 48zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 176zM0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 432z"
  ]
}, ND = {
  prefix: "fal",
  iconName: "spinner-third",
  icon: [
    512,
    512,
    [],
    "f3f4",
    "M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1c17.1-34.3 26.7-73 26.7-113.9C512 120 405.9 8.8 272 .5c-8.8-.5-16 6.7-16 15.5s7.2 15.9 16 16.6C388.2 40.8 480 137.7 480 256c0 35.1-8.1 68.3-22.5 97.9c-3.9 8-1.3 17.7 6.4 22.1z"
  ]
}, VD = {
  prefix: "fal",
  iconName: "arrow-rotate-right",
  icon: [
    512,
    512,
    [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"],
    "f01e",
    "M464 192c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8c6.6-10.4-1.4-23.2-13.7-23.2c-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448C150 448 64 362 64 256S150 64 256 64c71.1 0 133.1 38.6 166.3 96L336 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0z"
  ]
}, UD = {
  prefix: "fal",
  iconName: "floppy-disk",
  icon: [
    448,
    512,
    [128190, 128426, "save"],
    "f0c7",
    "M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-94.2c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6L416 416c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM96 64l192 0 0 96L96 160l0-96zM0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-245.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"
  ]
}, Nu = UD, FD = {
  prefix: "fal",
  iconName: "circle-question",
  icon: [
    512,
    512,
    [62108, "question-circle"],
    "f059",
    "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8l57.1 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
  ]
}, jD = {
  prefix: "fal",
  iconName: "image",
  icon: [
    512,
    512,
    [],
    "f03e",
    "M64 64C46.3 64 32 78.3 32 96l0 233.4 67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4 480 96c0-17.7-14.3-32-32-32L64 64zM32 374.6L32 416c0 17.7 14.3 32 32 32l41.4 0 96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448 448 448c17.7 0 32-14.3 32-32l0-105.4-90.3-90.3zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
  ]
}, Vu = {
  prefix: "fal",
  iconName: "arrow-up-from-bracket",
  icon: [
    448,
    512,
    [],
    "e09a",
    "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-281.4L340.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-96z"
  ]
}, BD = {
  prefix: "fal",
  iconName: "chevron-up",
  icon: [
    512,
    512,
    [],
    "f077",
    "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"
  ]
}, qD = {
  prefix: "fal",
  iconName: "circle-exclamation",
  icon: [
    512,
    512,
    ["exclamation-circle"],
    "f06a",
    "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
  ]
}, HD = {
  prefix: "fal",
  iconName: "trash-can",
  icon: [
    448,
    512,
    [61460, "trash-alt"],
    "f2ed",
    "M164.2 39.5L148.9 64l150.3 0L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5l-92.5 0c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64 384 64l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 336c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80L32 96 16 96C7.2 96 0 88.8 0 80s7.2-16 16-16l16 0 32 0 47.1 0L137 22.6C145.8 8.5 161.2 0 177.7 0l92.5 0c16.6 0 31.9 8.5 40.7 22.6zM64 96l0 336c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-336L64 96zm80 80l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z"
  ]
}, WD = HD, GD = {
  prefix: "fak",
  iconName: "tshirt-size",
  icon: [
    608,
    512,
    [],
    "e001",
    "M560.5 84.3L397.1 1.1s-10 11.4-15.8 17.2c-7.4 7.4-17.9 13.7-30.4 18.1-13.6 4.8-29.3 7.4-45.3 7.4-16 0-31.7-2.6-45.3-7.4-12.5-4.4-23-10.7-30.4-18.1-5.8-5.8-15.8-17.2-15.8-17.2L49.3 85c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l46.5 89.8c5.3 10.3 15.8 16.2 26.7 16.2 4.6 0 9.2-1.1 13.6-3.3l38.8-19.7v26.2l.4.4c2.1 2.1 7.2 4.6 14.6 4.6s12.5-2.5 14.6-4.6l.4-.4v-75.2l-82.4 41.9-46.5-89.8 146-72.4c21.4 21.4 57.1 34.4 96.9 34.4 39.8 0 75.6-12.9 96.9-34.4l144.6 71.7-43.4 89.9-84.3-41.2V415c0 6.3-5.1 11.4-11.4 11.4H294.2v30h113.9c22.8 0 41.4-18.6 41.4-41.4V207.8l41.1 20.1c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l43.4-89.8c7.1-14.9 1-32.7-13.7-40zM228.1 276.1l76.6 38-23 47.5-44.6-21.8v135.1c0 3.3-2.7 6-6 6H122.5c-3.3 0-6-2.7-6-6V339.8L72.8 362l-24.6-47.5 77.3-38.3c11.3 11.3 30.2 18.2 51.3 18.2 21.1-.1 40-6.9 51.3-18.3m-94.8-37.4l-98.4 48.9c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l24.6 47.5C51.5 386.1 62 392 72.9 392c4.6 0 9.2-1.1 13.6-3.3v86.2c0 19.9 16.2 36 36 36h108.6c19.9 0 36-16.2 36-36v-87l1.4.7c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l23-47.5c7.2-14.8 1.1-32.6-13.7-39.9l-97.7-48.5s-7.7 10.5-13.5 16.3c-4.3 4.3-14.8 9.4-30.1 9.4s-25.8-5.1-30.1-9.4c-5.6-6-13.3-16.5-13.3-16.5z"
  ]
}, ZD = {
  prefix: "fak",
  iconName: "icon-direkteinstickung",
  icon: [
    496,
    512,
    [],
    "e025",
    "M492.4 67.7c0-18.2-6.6-33-21.5-47.9S439.6 0 421.4 0c-33 1.7-57.8 29.7-59.5 31.4l-5 6.6c-19.8-9.9-62.8-26.4-112.3-18.2c-56.2 8.3-92.5 38-104.1 84.2c-6.6 21.5-11.6 77.6 56.2 135.4L3.6 483.9c-5 6.6-3.3 14.9 1.7 19.8c3.3 3.3 6.6 3.3 9.9 3.3s6.6-1.7 9.9-3.3l237.8-203.1c29.7 14.9 104.1 62.8 107.4 105.7c0 14.9-3.3 28.1-13.2 38c-21.5 19.8-64.4 29.7-120.6 26.4c-8.3 0-14.9 5-16.5 13.2s5 14.9 13.2 16.5c8.3 0 18.2 1.7 26.4 1.7c52.9 0 94.1-13.2 117.3-36.3c16.5-16.5 23.1-36.3 23.1-61.1c-3.3-57.8-82.6-107.4-112.3-123.9l150.3-128.8c5 16.5 3.3 36.3-3.3 54.5c-9.9 28.1-34.7 26.4-38 24.8c-8.3-1.7-14.9 5-16.5 13.2s5 14.9 13.2 16.5c1.7 0 5 0 8.3 0c18.2 0 47.9-8.3 62.8-44.6c11.6-29.7 9.9-59.5 0-85.9c3.3-6.6 26.4-31.4 28.1-62.8l0 0zM168.7 112.3C177 77.6 203.4 57.8 248 49.5c36.3-5 69.4 5 87.5 13.2L213.3 216.4c-52.9-46.2-49.5-87.5-44.6-104.1zM122.5 381.5l261-330.3s16.5-19.8 38-21.5c0 0 1.7 0 1.7 0c8.3 0 18.2 3.3 26.4 11.6s13.2 16.5 13.2 26.4c0 13.2-9.9 28.1-16.5 36.3c-5-6.6-9.9-13.2-16.5-18.2l1.7-3.3c6.6-6.6 5-14.9 0-21.5s-14.9-5-21.5 0l-28.1 28.1c-6.6 6.6-5 14.9 0 21.5c3.3 3.3 6.6 5 11.6 5s8.3-1.7 9.9-5l3.3-5c6.6 5 11.6 11.6 16.5 16.5L122.5 381.5z"
  ]
}, QD = {
  prefix: "fak",
  iconName: "icon-save",
  icon: [
    512,
    512,
    [],
    "e01e",
    "m504.3 135.9L375 6.7C370.7 2.3 364.8 0 358.7 0H74.8C33.5 0 0 33.5 0 74.8v361.5C0 477.4 33.5 511 74.8 511h361.7c41.2 0 74.5-33.5 74.8-74.5V152.1c0-6.1-2.3-12-6.7-16.4zm-142.8 329H149.2V304.4h212.2v160.5zm103.4-28.4c0 15.9-12.8 28.4-28.7 28.4h-28.7V281.3c0-12.8-10.2-23-23-23H126.2c-12.8 0-23 10.2-23 23v183.6H74.5c-15.9 0-28.7-12.8-28.7-28.7V74.8c0-15.9 12.8-28.7 28.7-28.7h28.7v106c0 12.8 10.2 23 23 23h206.6c12.8 0 23-10.2 23-23s-10.2-23-23-23H149.2V46.1h199.9l115.7 115.7v274.7z"
  ]
}, XD = {
  prefix: "fak",
  iconName: "icon-expander-small-open",
  icon: [
    1110,
    512,
    [],
    "e012",
    "M546 538a76.6 76.6 0 0 1 -48.6-17.4l-469-384A76.8 76.8 0 1 1 126 17.3L546 362 967 17.3A76.8 76.8 0 1 1 1064 136l-469 384A76.6 76.6 0 0 1 546 538z"
  ]
}, KD = {
  prefix: "fak",
  iconName: "icon-design-database",
  icon: [
    512,
    512,
    [],
    "e021",
    "M492.8 364.8c-9.6 0-19.2-9.6-19.2-19.2V86.4c0-12.8-9.6-19.2-22.4-19.2H182.4c-9.6-3.2-19.2-9.6-19.2-19.2s9.6-19.2 19.2-19.2h272c28.8 0 57.6 25.6 57.6 54.4l0 262.4c0 9.6-9.6 19.2-19.2 19.2zM377.6 102.4h-320C25.6 102.4 0 128 0 160v265.6c0 32 25.6 57.6 57.6 57.6h320c32 0 57.6-25.6 57.6-57.6V160c0-32-25.6-57.6-57.6-57.6zM35.2 160c0-12.8 9.6-22.4 22.4-22.4h320c12.8 0 22.4 9.6 22.4 22.4v25.6H35.2V160zM400 220.8v121.6l-64-80c-3.2-3.2-9.6-6.4-12.8-6.4c-6.4 0-12.8 3.2-16 6.4L217.6 368l-70.4-64c-6.4-6.4-16-6.4-22.4 0l-89.6 70.4V220.8H400zM377.6 448h-320c-12.8 0-22.4-9.6-22.4-22.4v-3.2l99.2-80 73.6 64c3.2 3.2 9.6 6.4 12.8 3.2c6.4 0 9.6-3.2 12.8-6.4L320 304l76.8 99.2v22.4c3.2 12.8-6.4 22.4-19.2 22.4zm-176-150.4c-9.6 0-19.2-6.4-19.2-19.2c0-9.6 9.6-19.2 19.2-19.2s19.2 9.6 19.2 19.2c0 12.8-9.6 19.2-19.2 19.2zm0-28.8l0 9.6s0 0 0 0l0-9.6z"
  ]
}, JD = {
  prefix: "fak",
  iconName: "icon-ciconfig-bar-check",
  icon: [
    512,
    512,
    [],
    "e009",
    "M256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256h0C512 115 397 0 256 0h0zM221 362c-5.46 0-10.6-2.05-14.3-6.14l-81.9-81.9c-7.85-7.85-7.85-20.8 0-29 7.85-7.85 20.8-7.85 29 0l66.6 66.6 138-156c7.51-8.53 20.5-9.22 29-1.71 8.53 7.51 9.22 20.5 1.71 29l-152 172c-3.75 4.1-9.22 6.83-14.7 6.83h-.683z"
  ]
}, YD = {
  prefix: "fak",
  iconName: "icon-design-logo",
  icon: [
    512,
    512,
    [],
    "e023",
    "M398.4 215.4l-10.9 3.2c-.6 0-1 .3-1.6 .6c-.3 .6-.6 1.3-.6 1.9c-.3 10.6 0 21.1 1 31.7c0 1.6 .3 2.9 .6 4.5c.6 1 1 1.6 1.6 2.6c1.3 1.6 1.9 3.5 2.2 5.8c0 5.4-4.2 9.6-9.6 9.6s-9.6-4.2-9.6-9.6l0 0c0-2.2 .6-4.2 2.2-5.8c.6-.6 1.3-1.6 1.6-2.6c.3-1.3 .6-2.9 .3-4.5c.3-8.6 1-19.5 1-25c-.3-4.8-.3-9.9 .3-14.7c.3-3.8 3.8-6.7 7.7-6.1c.6 0 1.6 .3 2.2 .6c3.8 1.6 7.4 3.5 10.9 5.8l.6 .3c1.3 .6 .3 1.3 0 1.6l0 0zM381.1 337.3s-4.2 5.1-6.1 8c0 0-.3 .3-.6 .3h-15c-.3 0-.6-.3-.6-.6v-1.6c0-.3 0-.3 .3-.6l16-8 .3 0 .3 0c.6-.3 1-1.3 1-1.9c0-.3 0-.6 0-.6s-4.5-24-6.4-33.3c0-.6 .3-1.3 1-1c3.2 1 6.7 1.6 9.9 1.6c3.5 0 6.7-.6 9.9-1.6c.6 0 1 .3 1 1c-1.9 9.6-6.4 33.3-6.4 33.3c0 .3 0 .6 0 .6c0 .6 .3 1.6 1 1.9l.3 0 .3 0 16 8c.3 0 .3 .3 .3 .3v1.3c0 .3-.3 .6-.6 .6h-15.4c-.3 0-.3 0-.6-.3c-1.9-2.2-5.8-7.4-5.8-7.4m0-56.6c-8.6 0-15.4-7-15.4-15.4c0-3.5 1.3-6.7 3.2-9.3l0-.3 1-1.3 .3-.3-.3-.6 0 0c-2.9-7.4-7.7-13.8-13.8-18.6c-16 5.8-27.2 20.5-28.2 37.4c1.9 21.1 18.2 38.1 39 41c-1-4.8-1.6-9.3-2.6-13.8v0c-.3-2.2 .3-4.5 1.9-6.1s3.8-2.2 5.8-1.9c.3 0 .6 0 1 .3c2.6 .6 5.4 1.3 8 1.3s5.4-.3 8-1.3c.3 0 .6-.3 1-.3c2.2-.3 4.5 .3 5.8 1.9c1.6 1.6 2.2 3.8 1.9 6.1v0c-1 4.5-1.6 9.3-2.6 13.8c20.8-2.9 37.1-19.8 39-41c-1-17-12.2-32-28.2-37.8c-6.4 4.8-11.2 11.2-13.8 18.6l-.3 .6 .3 .6 1 1.3 0 .3c1.9 2.6 2.9 5.8 3.2 9c0 0 0 .3 0 .6c0 8-7 15-15.4 15l0 0zM512 192V176.6c0-14.7-10.2-27.2-24.3-30.4c0-2.9-.6-5.8-1.6-8.3c-3.2-12.2-10.9-22.1-21.8-28.5l-89.6-51.8 0 0c-15.7-11.8-43.2-7.7-61.4-8.3v.3c-6.4 0-12.8 3.5-16 9.6c-10.2 20.2-30.7 33-53.8 33s-43.5-12.8-53.8-33.3c-3.2-6.1-9.3-9.6-15.7-9.6v0c-17.9 .6-44.5-3.2-60.2 7.7L23.4 108.8c-10.9 6.4-18.6 16.3-21.8 28.5c-9.9 25.9 25.3 66.9 35.5 88.6c13.1 22.7 42.2 30.1 64.3 17V416c0 25.9 21.1 46.7 46.7 46.7h191c25.6 0 46.7-21.1 46.7-46.7v-36.8h48c1.9 15.4 15 27.5 31 27.5h15.7c17.3 0 31.4-14.1 31.4-31.4v-15.7c0-16-12.2-29.1-27.5-31V223c15.4-1.9 27.5-15 27.5-31zM350.4 416c0 6.4-5.1 11.5-11.2 11.5h-191c-6.4 0-11.5-5.1-11.5-11.5V212.2c-.3-8.6-7-17-16.3-17.3c-8.3-2.2-30.1 14.4-37.1 17.3c-5.1 3.2-12.5 1.3-15.7-4.2L37.1 154.9c-3.2-5.1-1.3-12.5 4.2-15.4c0 0 90.2-52.2 90.6-52.2l0 0c5.8-4.8 25-2.2 32-2.9c34.2 56.6 125.1 56.6 159.4 0c7.4 .6 26.2-1.9 32.6 2.9l0 0c0 .3 90.6 52.2 90.6 52.5c2.9 1.6 4.8 4.8 5.4 8c-9.6 4.5-16.6 13.8-18.2 24.6H328.3c-1.9-15.4-15-27.5-31-27.5H281.6c-17.3 0-31.4 14.1-31.4 31.4V192c0 16 12.2 29.1 27.5 31v105.3c-15.4 1.9-27.5 15-27.5 31V375c0 17.3 14.1 31.4 31.4 31.4h15.7c16 0 29.1-12.2 31-27.5h22.1c0 22.1 0 37.1 0 37.1zM281.6 200c-4.5 0-8-3.5-8-8V176.6c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8V192c0 4.5-3.5 8-8 8H281.6zM305 359.7v15.7c0 4.5-3.5 8-8 8H281.6c-4.5 0-8-3.5-8-8v-15.7c0-4.5 3.5-8 8-8h15.7c4.2 0 7.7 3.5 7.7 8zm128.6-3.8H328.3c-1.9-14.1-12.8-25.3-27.2-27.2V223c14.1-1.9 25.3-12.8 27.2-27.2h105.3c1.9 14.1 12.8 25.3 27.2 27.2v105.3c-14.1 2.2-25.3 13.1-27.2 27.5zm54.7 3.8v15.7c0 4.5-3.5 8-8 8h-15.7c-4.5 0-8-3.5-8-8v-15.7c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8zm-8-159.7h-15.7c-4.5 0-8-3.5-8-8V176.6c0-4.5 3.5-8 8-8h15.7c4.5 0 8 3.5 8 8V192c0 4.5-3.5 8-8 8z"
  ]
}, eN = {
  prefix: "fak",
  iconName: "icon-zoom-out",
  icon: [
    512,
    512,
    [],
    "e01c",
    "M439.9 507.3c-16.3 0-30.3-4.7-41.9-18.6L230.4 321.2c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c7 7 18.6 7 25.6 0s7-18.6 0-25.6L286.3 265.3c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c23.3 23.3 23.3 62.8 0 86.1c-14 11.6-30.3 18.6-44.2 18.6l0 0zM172.2 360.7s0 0 0 0C74.5 356.1 0 276.9 0 181.5S81.5 0 181.5 0s181.5 81.5 181.5 181.5c0 2.3 0 4.7 0 9.3c-2.3 9.3-14 18.6-23.3 18.6c-11.6 0-20.9-9.3-20.9-20.9c0-2.3 0-4.7 0-7c0-76.8-62.8-139.6-139.6-139.6S39.6 104.7 39.6 181.5s58.2 135 132.7 137.3c11.6 0 20.9 9.3 20.9 20.9s-9.3 20.9-20.9 20.9zm65.2-165.2H121c-11.6 0-20.9-9.3-20.9-20.9s9.3-20.9 20.9-20.9h116.4c11.6 0 20.9 9.3 20.9 20.9s-9.3 20.9-20.9 20.9z"
  ]
}, tN = {
  prefix: "fak",
  iconName: "icon-ciconfig-archive",
  icon: [
    566,
    512,
    [],
    "e006",
    "M343 291h-123c-13.5 0-24.3-10.8-24.3-24.3s10.8-24.3 24.3-24.3h123c13.5 0 24.3 10.8 24.3 24.3s-10.8 24.3-24.3 24.3zM508 0H51.3C23 0 .053 22.9 .053 51.2v57.7c0 24.8 17.8 45.5 41.5 50.1V428c0 43.1 35 78.1 78.1 78.1h320c43.1 0 78.1-35 78.1-78.1V159c23.7-4.58 41.5-25.3 41.5-50.1V51.2c0-28.3-22.9-51.2-51.2-51.2zM48.6 51.2c0-1.35 1.08-2.69 2.69-2.69H508c1.35 0 2.69 1.08 2.69 2.69v57.7c0 1.35-1.08 2.69-2.69 2.69H51.3c-1.35 0-2.69-1.08-2.69-2.69V51.2zm391 407H120c-16.4 0-29.6-13.2-29.6-29.6V160h379V428c0 16.4-13.2 29.6-29.6 29.6z"
  ]
}, nN = {
  prefix: "fak",
  iconName: "download",
  icon: [
    640,
    512,
    [],
    "e020",
    "M315.8 8.1A23.8 23.8 0 0 0 296.2 31.5l0 212.3-53.1-45.6a23.8 23.8 0 0 0 -30.9 36.1l92.4 79.2a23.8 23.8 0 0 0 30.9 0l92.4-79.2a23.8 23.8 0 0 0 -30.9-36.1l-53.2 45.6 0-212.3A23.8 23.8 0 0 0 315.8 8.1zM89 323.6A23.8 23.8 0 0 0 65.3 347.3l0 85.3a72.2 72.2 0 0 0 71.9 71.6l365 0a66.3 66.3 0 0 0 51.1-20.8 71.5 71.5 0 0 0 21.5-50.9l0-85.2a23.8 23.8 0 0 0 -23.8-23.8 23.8 23.8 0 0 0 -23.8 23.8l0 85.1a24.6 24.6 0 0 1 -24.7 24.4l-365.2 0a24.5 24.5 0 0 1 -24.5-24.2l0-85.3A23.8 23.8 0 0 0 89 323.6z"
  ]
}, sN = {
  prefix: "fak",
  iconName: "icon-design-text",
  icon: [
    512,
    512,
    [],
    "e022",
    "M420.4 235.8l-33.5 0 0 92.9-13.7 0 0-92.9-33.4 0 0-11.2 80.5 0zm91.5-43.7V176.5c0-14.8-10.4-27.3-24.3-30.6c-.2-2.9-.6-5.7-1.6-8.3c-3.2-12.1-11-22.1-21.8-28.4l-89.7-51.8 0 0c-15.7-11.7-43.3-7.7-61.5-8.3v.2c-6.5 0-12.7 3.4-15.8 9.6c-10.2 20.5-30.8 33.3-53.8 33.3s-43.6-12.7-53.8-33.3c-3.1-6.2-9.3-9.6-15.8-9.6v-.2c-17.8 .6-44.4-3.2-60.3 7.6v0L23.4 108.9c-10.8 6.3-18.6 16.4-21.8 28.4c-10 25.8 25.4 67 35.4 88.5c13 22.7 42.3 30 64.3 16.9v173.2c0 25.8 21 46.8 46.8 46.8H339c25.8 0 46.7-21 46.7-46.8v-36.7h48c2 15.5 15.1 27.5 31 27.5h15.6c17.3 0 31.5-14.1 31.5-31.5v-15.6c0-16-12-29.1-27.5-31V223.2c15.5-2 27.5-15.1 27.5-31.1zM350.3 415.9c0 6.3-5.1 11.4-11.3 11.4H148.1c-6.3 0-11.4-5.1-11.4-11.4V212.2c-.4-8.9-7.1-17-16.3-17.4c-8.2-2.2-30.1 14.5-37.2 17.5c-5.2 3.2-12.5 1.2-15.5-4.2L37 155c-3.2-5.2-1.2-12.6 4.1-15.5c.1-.1 90.4-52.2 90.4-52.3l0 0c6.1-4.5 25.1-2.1 32.2-2.7c34.4 56.7 125.1 56.7 159.4 0c7.5 .6 26.3-2 32.6 2.9l0-.1c0 .4 90.5 52.3 90.7 52.5c3 1.7 4.8 4.7 5.3 8c-9.7 4.4-16.8 13.6-18.2 24.6H328.3c-2-15.5-15.1-27.5-31-27.5H281.6c-17.3 0-31.5 14.1-31.5 31.5v15.6c0 16 12 29.1 27.5 31.1v105.4c-15.5 2-27.5 15.1-27.5 31v15.6c0 17.3 14.1 31.5 31.5 31.5h15.6c16 0 29.1-12 31-27.5h22c0 21.7 0 36.7 0 36.7zM281.6 200c-4.4 0-7.9-3.5-7.9-7.9V176.5c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.5 7.9 7.9v15.6c0 4.4-3.5 7.9-7.9 7.9H281.6zm23.5 159.6v15.6c0 4.4-3.5 7.9-7.9 7.9H281.6c-4.4 0-7.9-3.5-7.9-7.9v-15.6c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.6 7.9 7.9zm128.6-4H328.3c-1.8-14.1-12.9-25.3-27.1-27.1V223.2c14.1-1.8 25.2-12.9 27.1-27.1h105.4c1.8 14.1 13 25.2 27.1 27.1v105.4c-14.1 1.8-25.2 12.9-27.1 27.1zm54.6 4v15.6c0 4.4-3.5 7.9-7.9 7.9h-15.6c-4.4 0-7.9-3.5-7.9-7.9v-15.6c0-4.4 3.5-7.9 7.9-7.9h15.6c4.3 0 7.9 3.6 7.9 7.9zM480.4 200h-15.6c-4.4 0-7.9-3.5-7.9-7.9V176.5c0-4.4 3.5-7.9 7.9-7.9h15.6c4.4 0 7.9 3.5 7.9 7.9v15.6c0 4.4-3.6 7.9-7.9 7.9z"
  ]
}, aN = {
  prefix: "fak",
  iconName: "tshirt-color",
  icon: [
    608,
    512,
    [],
    "e000",
    "M407 198.4c15.1 49.2 38.1 82 56.6 108.5 20.1 28.8 34.7 49.6 34.7 80.4 0 51.1-41 92.7-91.3 92.7s-91.3-41.6-91.3-92.7c0-30.7 14.6-51.6 34.8-80.5 18.5-26.5 41.4-59.4 56.5-108.4m0-30c-13.2 0-24.8 8.6-28.7 21.2-13.7 44.6-34.3 74.1-52.5 100.1-21.6 30.9-40.2 57.6-40.2 97.7C285.7 455 340.1 510 407 510s121.3-55 121.3-122.7c0-40.3-18.6-66.8-40.1-97.6-18.2-26-38.8-55.4-52.5-100.1-3.9-12.6-15.5-21.2-28.7-21.2zm153.5-84.1L397.1 1.1s-10 11.4-15.8 17.2c-7.4 7.4-17.9 13.7-30.4 18.1-13.6 4.8-29.3 7.4-45.3 7.4s-31.7-2.6-45.3-7.4c-12.5-4.4-23-10.7-30.4-18.1-5.8-5.8-15.8-17.2-15.8-17.2L49.3 85c-7.2 3.6-12.7 9.9-15.2 17.6-2.5 7.7-1.8 16 1.9 23.1l46.5 89.8c5.3 10.3 15.8 16.2 26.7 16.2 4.6 0 9.2-1.1 13.6-3.3l38.7-19.6V415c0 22.8 18.6 41.4 41.4 41.4h69.2c-4.8-9.5-8.6-19.5-11.4-30H203c-6.3 0-11.4-5.1-11.4-11.4V159.7l-82.4 41.9-46.5-89.8 146-72.4c21.4 21.4 57.1 34.4 96.9 34.4s75.6-12.9 96.9-34.4l144.6 71.7-43.4 89.9-38.9-19c4.9 15.7 10.8 29.4 17.3 41.7l8.6 4.2c4.1 2 8.7 3.1 13.2 3.1 3.3 0 6.6-.5 9.8-1.6 7.5-2.6 13.7-8.1 17.2-15.3l43.4-89.8c7-14.9.9-32.7-13.8-40zm-155 381.4c-8.5 0-34-2.2-53.3-26.6-21.5-27.3-18.9-52.9-18.9-52.9 0-18.1 29.8-20.3 29.8 3.8 0 0-.9 13.3 12.7 30.6 12.7 16.1 29.9 15.2 29.9 15.2 19.2-.1 19.2 29.9-.2 29.9z"
  ]
}, oN = {
  prefix: "fak",
  iconName: "icon-size-default",
  icon: [
    237,
    512,
    [],
    "e015",
    "M119 150a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 150zm0-68.5a27.2 27.2 0 1 1 -27.2 27.2A27.2 27.2 0 0 1 119 81.4zM194 205a54.4 54.4 0 0 0 -7.26-29 35.1 35.1 0 0 0 -27.9-17.1 74.1 74.1 0 0 0 -17.8 2.31 107 107 0 0 1 -22.2 2.94 101 101 0 0 1 -22.3-2.93 73.6 73.6 0 0 0 -17.7-2.32 35.1 35.1 0 0 0 -27.9 17.1A54.5 54.5 0 0 0 43.4 205c-.608 12.7-1.95 94.6-2.01 98.2a22.8 22.8 0 0 0 31.4 21.3c-.8 47.6-1.69 101-2.33 140A27.6 27.6 0 0 0 119 483a27.6 27.6 0 0 0 48.1-18.5c-.715-44.1-1.43-86.4-2.15-129l-.181-10.8a22.7 22.7 0 0 0 8.48 1.67 23 23 0 0 0 22.9-23.1C196 300 194 218 194 205zM173 312a8.77 8.77 0 0 1 -8.75-8.76c0-.164-.083-.301-.092-.463L162 215a7.09 7.09 0 0 0 -7.08-6.98l-.115 .008a7.08 7.08 0 0 0 -6.97 7.2l2.02 121c.723 42.3 1.44 84.5 2.15 129a13.4 13.4 0 0 1 -26.8 0V319a7.09 7.09 0 1 0 -14.2 0v145a13.4 13.4 0 0 1 -26.8 .115c1.35-82.3 3.91-233 4.17-248l.016-1.1a7.08 7.08 0 0 0 -6.95-7.21l-.131-.008a7.09 7.09 0 0 0 -7.08 6.96v.008l-.008 .023c0 .146-.008 .446-.016 .885L73.1 303l.004 .069-.012 .054a8.76 8.76 0 0 1 -17.5 .115c.016-.854 1.39-85.2 1.99-97.6a41.3 41.3 0 0 1 5.03-22.1 21.4 21.4 0 0 1 16.5-10.6 59.7 59.7 0 0 1 14.2 2.02 108 108 0 0 0 25.3 3.24 119 119 0 0 0 25-3.25 58.3 58.3 0 0 1 14.4-2.02 21.3 21.3 0 0 1 16.5 10.6 41.2 41.2 0 0 1 5.03 22.1c.608 12.4 1.98 96.8 1.99 97.5A8.77 8.77 0 0 1 173 312z"
  ]
}, iN = {
  prefix: "fak",
  iconName: "icon-ciconfig-bar-arrow",
  icon: [
    512,
    512,
    [],
    "e008",
    "M256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256h0C512 115 397 0 256 0h0zM223 370c-4.78 0-9.9-1.71-13.7-5.12-8.53-7.51-9.22-20.5-1.37-29l72-79.9-72-79.9c-7.51-8.53-6.83-21.5 1.37-29 8.19-7.51 21.2-6.83 29 1.37l84.3 93.5c7.17 7.85 7.17 19.5 0 27.3l-84.3 93.5c-4.1 4.44-9.56 6.83-15.4 6.83z"
  ]
}, rN = {
  prefix: "fak",
  iconName: "icon-arrow-circle-grey-right",
  icon: [
    512,
    512,
    [],
    "e005",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM228 352a10.2 10.2 0 0 1 -7.48-17.2l73.1-78.3-73.1-78.3a10.2 10.2 0 1 1 15-14l79.6 85.3a10.2 10.2 0 0 1 0 14l-79.6 85.3A10.2 10.2 0 0 1 228 352z"
  ]
}, lN = {
  prefix: "fak",
  iconName: "icon-zoom-in",
  icon: [
    512,
    512,
    [],
    "e01d",
    "M439.9 507.3c-16.3 0-30.3-7-41.9-18.6L230.4 321.2c-9.3-9.3-9.3-20.9 0-30.3s20.9-9.3 30.3 0l167.6 167.6c7 7 20.9 7 27.9 0s7-20.9 0-27.9L288.6 263c-7-9.3-7-20.9 0-30.3c9.3-7 20.9-7 27.9 0l167.6 167.6c23.3 23.3 23.3 62.8 0 86.1c-14 14-27.9 20.9-44.2 20.9M172.2 360.7l0 0C72.1 356.1-4.7 272.3 0 172.2S88.4-4.7 188.5 0c95.4 4.7 172.2 83.8 172.2 181.5c0 2.3 0 4.7 0 9.3c0 11.6-9.3 20.9-20.9 20.9s-20.9-9.3-20.9-20.9l0 0c0-2.3 0-4.7 0-7c0-76.8-62.8-139.6-139.6-139.6S39.6 107.1 39.6 183.9c0 74.5 58.2 135 132.7 137.3c11.6 0 20.9 9.3 20.9 20.9s-9.3 18.6-20.9 18.6m65.2-207.1H200.1V116.4c0-11.6-9.3-20.9-20.9-20.9s-20.9 9.3-20.9 20.9v37.2H121c-11.6 0-20.9 9.3-20.9 20.9s9.3 20.9 20.9 20.9h37.2v37.2c0 11.6 9.3 20.9 20.9 20.9s20.9-9.3 20.9-20.9l0 0V195.5h37.2c11.6 0 20.9-9.3 20.9-20.9s-9.3-20.9-20.9-20.9"
  ]
}, cN = {
  prefix: "fak",
  iconName: "icon-size-tall",
  icon: [
    237,
    512,
    [],
    "e018",
    "M118 103a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 118 103zm0-68.5a27.2 27.2 0 1 1 -27.2 27.2A27.2 27.2 0 0 1 118 34.3zM189 282c-.035-3.16-.119-12.7-.223-25.1-.285-32.8-.754-87.6-1.04-97.4a55.8 55.8 0 0 0 -5.75-28.6A35 35 0 0 0 160 114a44.8 44.8 0 0 0 -22.4 1.84c-1.02 .277-1.95 .523-2.75 .715a95.1 95.1 0 0 1 -16.6 1.94 110 110 0 0 1 -16.5-1.94c-.808-.192-1.74-.438-2.76-.715a44.7 44.7 0 0 0 -22.4-1.84 35 35 0 0 0 -21.8 17.1 55.8 55.8 0 0 0 -5.75 28.6c-.288 9.82-.758 64.7-1.04 97.4-.104 12.4-.188 21.9-.223 25.1l-.004 .223V283A21.8 21.8 0 0 0 77.1 303L74.4 466a25.6 25.6 0 0 0 44.1 17.6 25.6 25.6 0 0 0 44.1-17.8l-2.62-163a21.8 21.8 0 0 0 29.1-20.5zm-21.8 7.85a7.64 7.64 0 0 1 -7.63-7.62q0-.196-.012-.392l-1.82-113a7.09 7.09 0 0 0 -7.08-6.98l-.119 .008a7.09 7.09 0 0 0 -6.97 7.2l4.77 297a11.4 11.4 0 0 1 -22.8 0V297a7.09 7.09 0 1 0 -14.2 0V466a11.4 11.4 0 0 1 -22.8 .046l4.77-297A7.09 7.09 0 0 0 86.4 162l-.119-.008a7.09 7.09 0 0 0 -7.08 6.98l-1.82 113c-.008 .146-.012 .3-.012 .446a7.63 7.63 0 0 1 -15.3 .092c.038-3.02 .119-12.6 .231-25.3 .281-32.7 .75-87.5 1.03-97.2a42.8 42.8 0 0 1 4.12-22.3 20.8 20.8 0 0 1 13-10.1 34.9 34.9 0 0 1 15 1.85c1.18 .315 2.25 .608 3.19 .823a101 101 0 0 0 19.9 2.32 110 110 0 0 0 19.7-2.32c.927-.215 2-.508 3.18-.823a35 35 0 0 1 15-1.85 20.8 20.8 0 0 1 13 10.1 42.8 42.8 0 0 1 4.12 22.3c.281 9.68 .75 64.4 1.03 97.2 .112 12.6 .192 22.3 .231 25.3A7.64 7.64 0 0 1 167 290z"
  ]
}, uN = {
  prefix: "fak",
  iconName: "icon-edit",
  icon: [
    512,
    512,
    [],
    "e00e",
    "M480 47.1 455 21.7a78.5 78.5 0 0 0 -108 0L317 51.1 48.7 320 48.6 320l-.158 .159a18.2 18.2 0 0 0 -4.32 7.32c-.093 .273-.352 .442-.432 .721L.71 478a18.6 18.6 0 0 0 23 23L174 458c.279-.079 .448-.338 .72-.432a18.2 18.2 0 0 0 7.33-4.32l.158-.159 .011-.011L451 185 480 155a76.6 76.6 0 0 0 0-108zM45.7 456l25.1-87.8L134 431zm123-42.3L88 333 330 90.6 411 172zM454 129l-16.3 16.3L357 64.3l16.2-16.3a40.4 40.4 0 0 1 55.7 0l25.4 25.4a39.4 39.4 0 0 1 0 55.7z"
  ]
}, dN = {
  prefix: "fak",
  iconName: "icon-x",
  icon: [
    512,
    512,
    [],
    "e01a",
    "M306 260l204-204A32.9 32.9 0 0 0 463 9.64L260 213 56.2 9.64A32.9 32.9 0 0 0 9.64 56.2L213 260 9.64 463a32.9 32.9 0 1 0 46.5 46.5L260 306l204 204a32.9 32.9 0 0 0 46.5-46.5z"
  ]
}, mN = {
  prefix: "fak",
  iconName: "icon-size-stout",
  icon: [
    237,
    512,
    [],
    "e017",
    "M119 190a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 190zm0-68.5A27.2 27.2 0 1 1 91.5 148 27.2 27.2 0 0 1 119 121zM203 229a43.3 43.3 0 0 0 -31.8-28.8 85.5 85.5 0 0 0 -27.2 1.67 165 165 0 0 1 -25.3 2.66h-.185a168 168 0 0 1 -25.3-2.66 86.9 86.9 0 0 0 -27.5-1.67 43.3 43.3 0 0 0 -31.8 28.8 223 223 0 0 0 -9.93 68 237 237 0 0 0 4.85 44.6 22.3 22.3 0 0 0 37.5 10.1c-.415 21.9-.904 45.6-1.34 66.6l-.861 42.7a30.6 30.6 0 0 0 54.3 19.4A30.6 30.6 0 0 0 173 461c-.208-11.4-.538-27.2-.9-44.8-.419-20.4-.885-43.2-1.28-64.3a22.3 22.3 0 0 0 37.5-10.3 238 238 0 0 0 4.79-44.4A223 223 0 0 0 203 229zm-4.25 67.7a224 224 0 0 1 -4.41 41.4 8.08 8.08 0 0 1 -7.85 6.09 7.99 7.99 0 0 1 -7.88-7.03A76.2 76.2 0 0 0 186 305a161 161 0 0 0 -13.6-58 7.06 7.06 0 0 0 -9.54-2.82 7.13 7.13 0 0 0 -2.92 9.58A147 147 0 0 1 172 305a66.7 66.7 0 0 1 -12.5 38.1c-.731 1.12-1.33 2.03-1.74 2.74l-1 1.72 .039 1.98c.408 21.8 .9 45.6 1.34 66.9 .362 17.6 .685 33.4 .892 44.7a16.5 16.5 0 1 1 -33.1 0V350a7.09 7.09 0 1 0 -14.2 0V461a16.5 16.5 0 0 1 -33.1 .131l.862-42.5c.454-21.8 .962-46.6 1.38-69.2l.038-1.98-1-1.72c-.408-.708-1.01-1.62-1.74-2.74A66.7 66.7 0 0 1 65.4 305a147 147 0 0 1 11.9-51.3 7.09 7.09 0 0 0 -12.5-6.77A161 161 0 0 0 51.2 305a76.2 76.2 0 0 0 7.18 32.3 8.02 8.02 0 0 1 -15.7 1.12 223 223 0 0 1 -4.46-41.6 211 211 0 0 1 8.84-62.2 29.6 29.6 0 0 1 21.4-20.3 81.1 81.1 0 0 1 22.7 1.74 182 182 0 0 0 27.5 2.84h.215a178 178 0 0 0 27.5-2.84 79.5 79.5 0 0 1 22.4-1.74 29.6 29.6 0 0 1 21.4 20.3A211 211 0 0 1 199 297z"
  ]
}, hN = {
  prefix: "fak",
  iconName: "icon-size-small",
  icon: [
    237,
    512,
    [],
    "e016",
    "M119 190a41.4 41.4 0 1 0 -41.4-41.4A41.4 41.4 0 0 0 119 190zm0-68.5A27.2 27.2 0 1 1 91.5 148 27.2 27.2 0 0 1 119 121zM194 245a54.3 54.3 0 0 0 -7.26-29 35.1 35.1 0 0 0 -27.9-17.1 75.1 75.1 0 0 0 -17.8 2.31 107 107 0 0 1 -22.2 2.94 84.5 84.5 0 0 1 -22.3-2.93 74.1 74.1 0 0 0 -17.7-2.32 35.1 35.1 0 0 0 -27.9 17.1 54.2 54.2 0 0 0 -7.25 29c-.623 12.7-1.95 87.9-2.02 91.2a23 23 0 0 0 22.9 22.9 22.7 22.7 0 0 0 8.13-1.56c-.706 35.1-1.45 73.7-1.99 107a27.5 27.5 0 0 0 48.1 18.3A27.5 27.5 0 0 0 167 464c-.692-42.8-1.39-74.2-2.08-106l-.023-1.03a22.7 22.7 0 0 0 8.26 1.6 23 23 0 0 0 22.9-23.1C196 333 194 258 194 245zM173 345a8.75 8.75 0 0 1 -8.73-8.6c-.535-24.5-1.07-50.6-1.6-83.3a7.09 7.09 0 0 0 -7.08-6.98l-.115 .008a7.08 7.08 0 0 0 -6.97 7.2c.527 32.5 1.06 58.4 1.58 82.8-.002 .053-.031 .097-.031 .15 0 .145 .04 .279 .042 .424 .163 7.52 .327 14.9 .488 22.3 .7 31.4 1.39 62.8 2.08 105a13.4 13.4 0 1 1 -26.8 0V359a7.09 7.09 0 0 0 -14.2 0V464a13.4 13.4 0 0 1 -26.8 .115c.608-36.9 1.46-80.8 2.24-119a7.07 7.07 0 0 0 .377-2.18L88.8 253a7.08 7.08 0 0 0 -6.96-7.21l-.123-.008a7.09 7.09 0 0 0 -7.08 6.97L74.4 265c-.304 14.1-.881 41-1.53 72.7A8.68 8.68 0 0 1 55.5 336c.015-.777 1.38-78.2 2-90.7a41.1 41.1 0 0 1 5.03-22.1 21.3 21.3 0 0 1 16.5-10.6 59.9 59.9 0 0 1 14.2 2.02 120 120 0 0 0 25.2 3.24 119 119 0 0 0 25-3.25 63.2 63.2 0 0 1 14.4-2.02A21.3 21.3 0 0 1 174 224a41.2 41.2 0 0 1 5.04 22.1c.608 12.4 1.98 89.9 1.98 90.5A8.77 8.77 0 0 1 173 345z"
  ]
}, pN = {
  prefix: "fak",
  iconName: "icon-ciconfig-alert-warning",
  icon: [
    512,
    512,
    [],
    "e01b",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM256 398c-14.1 0-25.6-11.5-25.6-25.6s11.3-25.6 25.4-25.6h0c14.1 0 25.6 11.5 25.6 25.6s-11.5 25.6-25.6 25.6zM256 300c-11.7 0-21.3-9.6-21.3-21.3v-.427c0-5.76 0-132 0-138v-.427c0-11.7 9.6-21.3 21.3-21.3 21.3 0 21.3 16.2 21.3 42.9v95.1c0 26.9 0 42.9-21.3 42.9z"
  ]
}, fN = {
  prefix: "fak",
  iconName: "icon-ciconfig-italic",
  icon: [
    501,
    512,
    [],
    "e00a",
    "M232 296l-13.9 12.1-5.8 33.5h-29.8l28.1-162h29.8l-15.4 88.1 5.8-6.26 33.9-33.9h38.2l-49.9 49 31.7 65.1h-32.7l-20.3-45.5z"
  ]
}, vN = {
  prefix: "fak",
  iconName: "icon-expander-open",
  icon: [
    1024,
    512,
    [],
    "e010",
    "M507 502A46.1 46.1 0 0 1 476 490l-461-410A46.1 46.1 0 0 1 76.7 11.6L507 394 937 11.6A46.1 46.1 0 0 1 998 80.5l-461 410A46.1 46.1 0 0 1 507 502z"
  ]
}, gN = {
  prefix: "fak",
  iconName: "icon-close-large",
  icon: [
    512,
    512,
    [],
    "e00b",
    "M256 9.31A247 247 0 1 1 9.31 256 247 247 0 0 1 256 9.31m0-9.31A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM268 256l77.9-77.9A8.38 8.38 0 1 0 334 166l-77.9 77.9L178 166a8.38 8.38 0 1 0 -11.8 11.9l77.9 77.9L166 334a8.38 8.38 0 1 0 11.8 11.9l77.9-77.9 77.9 77.9A8.38 8.38 0 1 0 346 334z"
  ]
}, _N = {
  prefix: "fak",
  iconName: "smake",
  icon: [
    410,
    512,
    [],
    "e002",
    "M406.173 273.588c5.21 13.328 1.202 15.734-7.817 8.017-45.899-39.385-134.088-34.474-175.377 5.311-16.636 16.135-17.838 29.364-25.755 28.462-4.31-.502-4.41-6.815-3.408-14.532 12.227-94.503 183.695-100.716 212.357-27.258zM377.01 33.17c11.324 9.12 8.618 20.645 4.61 32.971-13.83 42.291-41.79 72.756-84.281 87.789-12.226 4.309-19.743.801-9.22-8.018 43.093-36.077 52.112-55.318 64.338-107.731 2.706-11.324 17.438-10.823 24.553-5.01zM268.377 18.44c-1.303-2.706-10.824-19.643 3.006-18.34 37.08 3.608 46.7 39.184 43.293 71.153-3.107 28.662-19.542 54.317-40.788 73.157-10.222 9.12-13.228 1.704-9.22-5.411 22.85-39.886 23.551-79.772 3.709-120.56zm-99.514-8.82c30.465-1.503 64.739 19.442 80.272 45.198 15.734 25.855 15.333 60.33 3.708 89.191-3.708 9.22-14.43 17.338-12.527 2.406 6.514-51.41-31.868-98.211-78.87-111.74-26.055-7.517-26.155-23.45 7.417-25.054zM12.026 381.42c44.195-3.809 87.788-24.854 115.448-45.198 11.224-8.217 15.132-4.51 9.921 7.316C122.363 377.311 75.562 420.704 33.672 419c-18.64-.802-51.51-34.975-21.646-37.58zm95.806 103.622c-25.455 3.107-69.45-15.132-28.862-34.474 37.981-18.139 60.53-56.622 72.355-97.51 4.109-14.23 16.035-20.944 17.838 9.621 2.606 43.293-8.819 115.95-61.331 122.363zm55.82-187.503c-5.813-38.182 2.004-77.466 42.49-100.816 16.637-9.621 15.033-14.03-1.703-11.525-43.994 6.514-78.87 32.77-89.091 74.86-11.325 47.002-41.59-8.918-26.657-38.382 23.55-46.3 72.455-49.807 115.047-54.417 16.535-1.804 2.806-8.919-6.414-12.927C144.41 131.382 79.67 139.5 52.112 197.524c-5.512 11.625-15.333 8.619-16.235-2.204-4.41-48.605 34.173-76.765 73.057-80.874 36.478-3.808 62.434 9.02 84.482 20.143 15.934 8.118 21.546 6.113.4-19.642-32.47-39.685-87.387-48.905-132.184-11.625-10.121 8.418-25.655 17.437-19.742-1.203 1.704-5.311 6.514-15.433 17.838-25.955 61.533-57.123 137.195-22.048 162.55 40.386 11.424 28.06 4.209 39.285 13.428 51.712 11.926 16.134 39.084 4.91 79.772 18.64 25.154 8.518 34.273 24.452 11.725 18.139-56.12-15.634-142.306 7.315-150.423 87.989-1.303 13.629-10.823 19.542-13.128 4.51zm87.287 187.002c-9.72 34.274-84.982 34.775-70.652 10.623 26.557-44.897 24.453-91.397 7.516-129.178-11.925-26.757-6.413-30.966 6.414-23.35 48.705 28.962 72.255 87.588 56.722 141.905zm158.54-128.877c-1.803 28.361-16.635 59.428-23.95 32.27-15.233-56.422-76.966-96.107-141.304-67.546-15.534 6.915-10.423 9.721 4.71 11.024 70.05 6.213 100.015 52.312 103.021 100.215 1.604 25.856-14.531 42.291-35.476 51.912-16.536 7.516-25.856 7.316-20.845-14.932 13.429-59.628-19.542-100.216-71.654-124.568-16.736-7.817-28.46-10.021 1.203-32.169 36.077-26.958 83.178-34.574 123.365-22.148 31.367 9.621 63.236 29.865 60.93 65.942z"
  ]
}, kN = {
  prefix: "fak",
  iconName: "icon-pdf",
  icon: [
    443,
    512,
    [],
    "e01f",
    "M442.6 146.6L303 7c-4.7-4.7-9.3-7-14-7H70.2C30.7 0 .4 30.3 .4 69.8v370c0 37.2 30.3 69.8 69.8 69.8h309.5c37.2 0 69.8-30.3 69.8-69.8V160.6c-2.3-4.7-4.7-9.3-7-14zM309.9 72.1l67.5 69.8h-41.9c-14 0-25.6-11.6-25.6-25.6l0-44.2zm69.8 393.3H70.2c-14 0-27.9-11.6-27.9-27.9V69.8c0-14 11.6-27.9 27.9-27.9H268V114c0 37.2 30.3 67.5 67.5 69.8h69.8v256c0 14-11.6 25.6-25.6 25.6zm-256-211.8H77.2v132.7h25.6v-46.5h18.6c11.6 0 23.3-2.3 32.6-11.6c7-9.3 11.6-18.6 11.6-30.3s-4.7-23.3-11.6-32.6c-9.3-7-18.6-11.6-30.3-11.6zm11.6 58.2c-2.3 2.3-7 4.7-11.6 4.7H105.1v-41.9h18.6c4.7 0 9.3 2.3 11.6 7s4.7 9.3 4.7 16.3c0 4.7-2.3 11.6-4.7 14zm88.4-58.2H188.9v132.7h34.9c14 0 27.9-4.7 37.2-14c9.3-11.6 14-25.6 14-41.9v-20.9c0-14-4.7-30.3-14-39.6c-9.3-11.6-23.3-16.3-37.2-16.3zm25.6 79.1c0 9.3-2.3 16.3-4.7 23.3c-4.7 4.7-11.6 7-18.6 7h-9.3v-88.4h9.3c7 0 14 2.3 18.6 7c4.7 7 7 16.3 4.7 25.6l0 25.6zm51.2 53.5h25.6v-53.5h41.9v-23.3H326.2v-34.9h46.5v-23.3h-72.1v135z"
  ]
}, yN = {
  prefix: "fak",
  iconName: "icon-close-medium",
  icon: [
    512,
    512,
    [],
    "e00c",
    "M256 11.4A245 245 0 1 1 11.4 256 245 245 0 0 1 256 11.4m0-11.4A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM270 256l78.1-78.1A10.2 10.2 0 0 0 334 163l-78.1 78.1L178 163A10.2 10.2 0 0 0 163 178l78.1 78.1L163 334a10.2 10.2 0 1 0 14.5 14.5l78.1-78.1L334 349A10.2 10.2 0 0 0 349 334z"
  ]
}, bN = {
  prefix: "fak",
  iconName: "icon-text-alignment",
  icon: [
    512,
    512,
    [],
    "e024",
    "M351.7 512H160c-4.5-9-6.4-18.9-6.1-29.1c-.3-9.9 1.6-19.5 5.8-28.5h34.6c12.8 1 24-8.3 25-21.1c0-1.3 0-2.6 0-3.8V85.1c1.6-13.4-8.3-25.9-21.8-27.2c-1.3 0-2.6-.3-3.8 0H136.3c-19.8-1.3-37.1 13.8-38.4 33.6c0 .6 0 1 0 1.6c-1.9 19.5-1.6 39 .6 58.6C88 157.4 76.5 160 64.6 160c-10.6 .6-20.8-2.2-29.4-8c-2.6-40-2.9-80.3-1-120.3c1-18.2 4.2-25 6.4-27.2C47 1 54.4-.3 61.8 .6h389.8c7.4-1 14.7 .3 21.4 3.5c1.9 1.9 5.1 7.7 6.1 26.6c1.9 40.3 1.9 80.6-.3 120.6c-9.9 5.8-21.1 8.3-32.3 8c-11.2 .3-22.1-2.2-32-7.4c1.9-19.8 2.2-39.7 1-59.2v-.6c-1-19.8-17.9-34.9-37.4-33.9h-57.3C307.2 57 295.4 66.6 293.8 80c-.3 1.9 0 3.5 0 5.4v344.3c-1 12.8 8.6 24 21.4 25c1.3 0 2.6 0 3.8 0h34.2c4.2 9 6.1 18.6 5.8 28.5c-1 9.6-2.9 19.5-7.4 28.8z"
  ]
}, wN = {
  prefix: "fak",
  iconName: "icon-easytransfer",
  icon: [
    528,
    512,
    [],
    "e026",
    "M441.6 94.4a17.6 30.4 0 1 0 0 60.8 17.6 30.4 0 1 0 0-60.8zM520 124.8c0 70.4-33.6 124.8-78.4 124.8c-20.8 0-38.4-12.8-52.8-32c-4.8 65.6-11.2 160-11.2 185.6c-3.2 41.6-12.8 72-12.8 73.6c-8 25.6-27.2 33.6-36.8 33.6s-1.6 0-3.2 0H12.8c-4.8 0-9.6-3.2-11.2-8S0 491.2 3.2 488c16-19.2 28.8-91.2 28.8-139.2V88s-3.2-25.6 11.2-52.8c16-30.4 46.4-33.6 48-33.6h337.6c4.8-1.6 8-1.6 12.8-1.6C486.4 0 520 54.4 520 124.8zM366.4 166.4c-1.6-12.8-3.2-25.6-3.2-40c0-40 11.2-75.2 28.8-97.6H89.6c1.6 0-16 1.6-25.6 19.2c-9.6 20.8-8 40-8 40v262.4c0 38.4-8 97.6-22.4 134.4h288c6.4 0 14.4-6.4 17.6-16c0 0 9.6-28.8 11.2-67.2c3.2-35.2 12.8-188.8 16-235.2zm124.8-41.6c0-56-25.6-96-49.6-96s-49.6 40-49.6 96 25.6 96 49.6 96 49.6-40 49.6-96zm-270.4-6.4v91.2c0 3.2 3.2 6.4 6.4 6.4h91.2c3.2 0 6.4-3.2 6.4-6.4V118.4c0-3.2-3.2-6.4-6.4-6.4h-91.2c-4.8 0-6.4 3.2-6.4 6.4zM131.2 348.8a52.8 52.8 0 1 0 0 105.6 52.8 52.8 0 1 0 0-105.6zm6.4-174.4c1.6-1.6 4.8-1.6 4.8 0l54.4 92.8c0 1.6-1.6 4.8-3.2 4.8H88c-3.2 0-4.8-3.2-3.2-4.8l52.8-92.8 0 0zM297.6 288l25.6 44.8c1.6 1.6 1.6 4.8 1.6 6.4L299.2 384c-1.6 1.6-4.8 3.2-6.4 3.2H240c-3.2 0-4.8-1.6-6.4-3.2L208 339.2c-1.6-1.6-1.6-4.8 0-6.4l25.6-44.8c1.6-1.6 4.8-3.2 6.4-3.2h52.8c1.6 0 3.2 1.6 4.8 3.2z"
  ]
}, xN = {
  prefix: "fak",
  iconName: "icon-arrow-circle-grey-left",
  icon: [
    512,
    512,
    [],
    "e004",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM284 352a10.2 10.2 0 0 1 -7.48-3.26l-79.6-85.3a10.2 10.2 0 0 1 0-14l79.6-85.3a10.2 10.2 0 1 1 15 14L219 256l73.1 78.3a10.2 10.2 0 0 1 -7.48 17.2z"
  ]
}, $N = {
  prefix: "fak",
  iconName: "icon-info",
  icon: [
    512,
    512,
    [],
    "e013",
    "M256 38.4A218 218 0 1 1 38.4 256 218 218 0 0 1 256 38.4M256 0A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM256 172A25.6 25.6 0 0 1 256 121h.208a25.6 25.6 0 0 1 0 51.2zM256 400a21.3 21.3 0 0 1 -21.3-21.3v-.405c.043-5.77 .043-132 0-138v-.405a21.3 21.3 0 0 1 21.3-21.3c21.3 0 21.4 16.2 21.4 43l.021 47.6-.021 47.6C277 384 277 400 256 400z"
  ]
}, SN = {
  prefix: "fak",
  iconName: "icon-expander-clos",
  icon: [
    1024,
    512,
    [],
    "e00f",
    "M968 502a46 46 0 0 1 -30.6-11.7L507 108 76.7 490A46.1 46.1 0 0 1 15.5 421l461-410a46.2 46.2 0 0 1 61.3 0l461 410a46.1 46.1 0 0 1 -30.6 80.5z"
  ]
}, AN = {
  prefix: "fak",
  iconName: "icon-close-small",
  icon: [
    512,
    512,
    [],
    "e00d",
    "M256 12.8A243 243 0 1 1 12.8 256 243 243 0 0 1 256 12.8m0-12.8A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM272 256 347 181a11.5 11.5 0 0 0 -16.3-16.3l-75.1 75.1L181 165A11.5 11.5 0 0 0 165 181l75 75-75 75.1A11.5 11.5 0 1 0 181 347l75.1-75.1L331 347A11.5 11.5 0 0 0 347 331z"
  ]
}, CN = {
  prefix: "fak",
  iconName: "icon-ciconfig-areaonoff",
  icon: [
    512,
    512,
    [],
    "e007",
    "M251 321c-31.3 0-56.6-25.3-56.6-56.6s25.3-56.6 56.6-56.6 56.6 25.3 56.6 56.6-25.3 56.6-56.6 56.6zm0-80.8c-13.5 0-24.3 10.8-24.3 24.3s10.8 24.3 24.3 24.3 24.3-10.8 24.3-24.3-10.8-24.3-24.3-24.3zM251 384c-97 0-182-74.9-182-120s85.2-120 182-120 182 74.9 182 120-85.2 120-182 120zm0-208c-86 0-150 67.1-150 87.6s63.9 87.6 150 87.6 150-67.1 150-87.6-63.9-87.6-150-87.6zM21.6 178c-11.9 0-21.6-9.7-21.6-21.6V75.5C0 34 34 0 75.5 0h71.9c11.9 0 21.6 9.7 21.6 21.6s-9.7 21.6-21.6 21.6H75.5c-17.8 0-32.3 14.6-32.3 32.3v80.8c0 11.9-9.7 21.6-21.6 21.6zM147 501H75.5c-41.5 0-75.5-34-75.5-75.5v-53.9c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6v53.9c0 17.8 14.6 32.3 32.3 32.3h71.9c11.9 0 21.6 9.7 21.6 21.6s-9.7 21.6-21.6 21.6zM426 501h-62.8c-11.9 0-21.6-9.7-21.6-21.6s9.7-21.6 21.6-21.6h62.8c17.8 0 32.3-14.6 32.3-32.3v-53.9c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6v53.9c0 41.5-34 75.5-75.5 75.5zM480 178c-11.9 0-21.6-9.7-21.6-21.6V75.5c0-17.8-14.6-32.3-32.3-32.3h-62.8c-11.9 0-21.6-9.7-21.6-21.6s9.7-21.6 21.6-21.6h62.8c41.5 0 75.5 34 75.5 75.5v80.8c0 11.9-9.7 21.6-21.6 21.6z"
  ]
}, PN = {
  prefix: "fak",
  iconName: "resize",
  icon: [
    448,
    512,
    [],
    "e003",
    "M249.2 275.5c4.7-4.7 12.3-4.7 17 0L416 425.4V364c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12H332c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h61.4L243.5 298.1c-4.7-4.7-4.7-12.3 0-17l5.7-5.6zM0 44v104c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12V86.6l149.9 149.9c4.7 4.7 12.3 4.7 17 0l5.7-5.7c4.7-4.7 4.7-12.3 0-17L54.6 64H116c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H12C5.4 32 0 37.4 0 44z"
  ]
}, IN = {
  prefix: "fak",
  iconName: "icon-remove",
  icon: [
    448,
    512,
    [],
    "e014",
    "M420 79.8H311V68.1A68.1 68.1 0 0 0 243 0H198A68.1 68.1 0 0 0 129 68.1v11.7H21.3a21.3 21.3 0 1 0 0 42.7h12.6L64 451A61 61 0 0 0 125 512h192a60.6 60.6 0 0 0 61-59.1L407 122h12.4a21.3 21.3 0 0 0 0-42.7zM172 68.1A26 26 0 0 1 198 42.7H243a25.8 25.8 0 0 1 25.8 25.8v11.7H172zm163 384a18.8 18.8 0 0 1 -18.8 18.8h-192a19.2 19.2 0 0 1 -18.8-21.3L76.2 122H365zM220 180a16.4 16.4 0 0 0 -16.4 16.4v199a16.4 16.4 0 0 0 32.9 0V196A16.2 16.2 0 0 0 220 180zM272 196v199a16.4 16.4 0 0 0 32.9 0V196a16.4 16.4 0 0 0 -32.9 0zM153 180a16.4 16.4 0 0 0 -16.4 16.4v199a16.6 16.6 0 0 0 33.1 0V196A16.4 16.4 0 0 0 153 180z"
  ]
}, MN = {
  prefix: "fak",
  iconName: "icon-expander-small-close",
  icon: [
    1110,
    512,
    [],
    "e011",
    "M1016 538a76.5 76.5 0 0 1 -48.6-17.4L546 176 126 520A76.8 76.8 0 1 1 28.5 401l469-384a76.7 76.7 0 0 1 97.3 0l469 384a76.8 76.8 0 0 1 -48.7 136z"
  ]
}, TN = {
  prefix: "fak",
  iconName: "icon-ciconfig-alert-check",
  icon: [
    512,
    512,
    [],
    "e019",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM219 367c-5.55 0-11.1-2.35-15.1-6.19l-85.3-85.3c-8.32-8.32-8.32-21.8 0-30.1s21.8-8.32 30.1 0l69.3 69.3 144-162c7.89-8.75 21.3-9.6 30.1-1.71 8.75 7.89 9.6 21.3 1.71 30.1l-159 179c-3.84 4.48-9.39 7.04-15.4 7.25h-.64z"
  ]
};
const zN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  faDownload: nN,
  faIconArrowCircleGreyLeft: xN,
  faIconArrowCircleGreyRight: rN,
  faIconCiconfigAlertCheck: TN,
  faIconCiconfigAlertWarning: pN,
  faIconCiconfigArchive: tN,
  faIconCiconfigAreaonoff: CN,
  faIconCiconfigBarArrow: iN,
  faIconCiconfigBarCheck: JD,
  faIconCiconfigItalic: fN,
  faIconCloseLarge: gN,
  faIconCloseMedium: yN,
  faIconCloseSmall: AN,
  faIconDesignDatabase: KD,
  faIconDesignLogo: YD,
  faIconDesignText: sN,
  faIconDirekteinstickung: ZD,
  faIconEasytransfer: wN,
  faIconEdit: uN,
  faIconExpanderClos: SN,
  faIconExpanderOpen: vN,
  faIconExpanderSmallClose: MN,
  faIconExpanderSmallOpen: XD,
  faIconInfo: $N,
  faIconPdf: kN,
  faIconRemove: IN,
  faIconSave: QD,
  faIconSizeDefault: oN,
  faIconSizeSmall: hN,
  faIconSizeStout: mN,
  faIconSizeTall: cN,
  faIconTextAlignment: bN,
  faIconX: dN,
  faIconZoomIn: lN,
  faIconZoomOut: eN,
  faResize: PN,
  faSmake: _N,
  faTshirtColor: aN,
  faTshirtSize: GD
}, Symbol.toStringTag, { value: "Module" }));
ov.autoAddCss = !1;
iv.add(
  zN,
  OD,
  DD,
  $D,
  VD,
  Vu,
  Lu,
  MD,
  PD,
  CD,
  BD,
  qD,
  Du,
  zD,
  TD,
  LD,
  ID,
  ED,
  Nu,
  RD,
  AD,
  ND,
  WD,
  SD,
  Lu,
  Nu,
  Du,
  Vu,
  jD,
  FD
);
const EN = Dp(Y7, {
  configureApp: (t) => {
    t.use(Qp, {
      enableDevtoolsV6Plugin: !0
    }), t.use(Zp());
    const e = $f({
      fallbackLocale: "en",
      legacy: !1,
      messages: { cs: GS, de: FP, en: RT, fr: IO, nl: xD }
    });
    t.use(e), t.provide(Sf, e), t.component("FontAwesomeIcon", Nn), t.use(Ck), t0((n) => {
      console.debug("Endpoint Validation error", n);
    });
  },
  shadowRoot: !1
});
customElements.define("designer-strauss", EN);
export {
  At as FeatureFlags
};
//# sourceMappingURL=index.js.map
